
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2yr9J", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

/* Copied from type-ahead */ 
var $zT4ZO = parcelRequire("zT4ZO");





var $ks2lK = parcelRequire("ks2lK");

function $afd69cdd98cccec1$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $afd69cdd98cccec1$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { $from: { pos: start }, $to: { pos: end } } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        const mappedStart = start;
        const nodeNormalized = (0, $zT4ZO.normaliseNestedLayout)(tr, node);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $zT4ZO.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $5SAOw.Slice).maxOpen((0, $5SAOw.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $afd69cdd98cccec1$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $ks2lK.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $afd69cdd98cccec1$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { $from: { pos: start }, $to: { pos: end } } = position;
    const fragment = maybeFragment instanceof (0, $5SAOw.Node) ? (0, $5SAOw.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $ks2lK.TextSelection).near(tr.doc.resolve(start + (fragment?.size || 0))));
};
const $afd69cdd98cccec1$export$a6d88483216c3859 = ({ tr: tr, node: node, position: position, selectNodeInserted: selectNodeInserted })=>{
    if (node instanceof (0, $5SAOw.Node) && node.isBlock) $afd69cdd98cccec1$export$faec73a52dd47a2c({
        node: node,
        tr: tr,
        position: position
    });
    else $afd69cdd98cccec1$export$a6d430434014dc1c({
        maybeFragment: node,
        tr: tr,
        position: position,
        selectInlineNode: selectNodeInserted
    });
};


const $70ee1fe528814985$export$68b1ab6a0b98c537 = ({ node: node, options: options })=>(tr)=>{
        const position = options.insertAt ?? tr.selection;
        if (!(node instanceof (0, $5SAOw.Node) || node instanceof (0, $5SAOw.Fragment))) return false;
        (0, $afd69cdd98cccec1$export$a6d88483216c3859)({
            tr: tr,
            node: node,
            position: position,
            selectNodeInserted: options.selectNodeInserted
        });
        tr.scrollIntoView();
        return true;
    };


const $82f437225d73d5b3$export$e8397698249f8f72 = (analyticsApi)=>({
        actions: {
            insert: ({ state: state, dispatch: dispatch, node: node, options: options })=>{
                if (!state || !dispatch) return false;
                const { tr: tr } = state;
                (0, $70ee1fe528814985$export$68b1ab6a0b98c537)({
                    node: node,
                    options: options
                })(tr);
                if (options.analyticsPayload) analyticsApi?.attachAnalyticsEvent(options.analyticsPayload)(tr);
                dispatch(tr);
                return true;
            }
        },
        commands: {
            insert: ({ node: node, options: options })=>({ tr: tr })=>{
                    (0, $70ee1fe528814985$export$68b1ab6a0b98c537)({
                        node: node,
                        options: options
                    })(tr);
                    if (options.analyticsPayload) analyticsApi?.attachAnalyticsEvent(options.analyticsPayload)(tr);
                    return tr;
                }
        }
    });


const $de3cfc3b9e359069$export$8469b5a27995930b = ({ api: api })=>{
    const { actions: actions, commands: commands } = (0, $82f437225d73d5b3$export$e8397698249f8f72)(api?.analytics?.actions);
    return {
        name: 'contentInsertion',
        actions: actions,
        commands: commands
    };
};
module.exports["contentInsertionPlugin"] = $de3cfc3b9e359069$export$8469b5a27995930b;

});

parcelRegister("7x0qS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $5duTD = parcelRequire("5duTD");

const $756d2e4a7a125dee$var$fullWidthLabelWrapperStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-400, 32px)",
    display: 'flex',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    boxSizing: 'border-box',
    alignItems: 'center'
});
const $756d2e4a7a125dee$var$fullWidthLabelStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $756d2e4a7a125dee$export$46c20f09a5d207e4 = ({ layout: breakoutLayout })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const message = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        switch(breakoutLayout){
            case 'max':
                return formatMessage((0, $5duTD.messages).maxWidthLabel);
            case 'full-width':
                return formatMessage((0, $5duTD.messages).fullWidthLabel);
            case 'wide':
                return formatMessage((0, $5duTD.messages).wideWidthLabel);
            default:
                return null;
        }
    }, [
        breakoutLayout,
        formatMessage
    ]);
    return message && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "resizer-breakout-mode-label",
        xcss: $756d2e4a7a125dee$var$fullWidthLabelWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $756d2e4a7a125dee$var$fullWidthLabelStyles
    }, message));
};
module.exports["ResizerBreakoutModeLabel"] = $756d2e4a7a125dee$export$46c20f09a5d207e4;

});

parcelRegister("5DsxN", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $bLhD4 = parcelRequire("bLhD4");


var $d925B = parcelRequire("d925B");


var $4HWgE = parcelRequire("4HWgE");


var $3pLGZ = parcelRequire("3pLGZ");


var $dh538 = parcelRequire("dh538");





var $zT4ZO = parcelRequire("zT4ZO");


var $1S4f7 = parcelRequire("1S4f7");


var $l03WE = parcelRequire("l03WE");


var $5SAOw = parcelRequire("5SAOw");


var $8m4tT = parcelRequire("8m4tT");





var $aIMBk = parcelRequire("aIMBk");

var $14sLv = parcelRequire("14sLv");

const $1f0d3cb22128de73$export$718ed5cb714e84ae = (state, start, end, inputMethod, editorAnalyticsAPI)=>{
    if (!state.selection.empty) return null;
    let tr = null;
    const { rule: rule } = state.schema.nodes;
    /**
	 * This is a workaround to get rid of the typeahead text when using quick insert
	 * Once we insert *nothing*, we get a new transaction, so we can use the new selection
	 * without considering the extra text after the `/` command.
	 **/ tr = state.tr.replaceWith(start, end, (0, $5SAOw.Fragment).empty);
    tr = (0, $zT4ZO.safeInsert)(rule.createChecked(), tr.selection.from)(tr);
    if (!tr) tr = state.tr.replaceRange(start, end, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(state.schema.nodes.rule.createChecked()), 0, 0));
    const resolvedInputMethod = (0, $dh538.fg)('platform_editor_element_browser_analytic') ? inputMethod : (0, $d925B.INPUT_METHOD).QUICK_INSERT;
    editorAnalyticsAPI?.attachAnalyticsEvent({
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).DIVIDER,
        attributes: {
            inputMethod: resolvedInputMethod
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })(tr);
    return tr;
};
const $1f0d3cb22128de73$var$createHorizontalRuleAutoformat = (state, start, end, editorAnalyticsAPI)=>{
    const { listItem: listItem } = state.schema.nodes;
    if ((0, $8m4tT.hasParentNodeOfType)(listItem)(state.selection)) return null;
    return $1f0d3cb22128de73$export$718ed5cb714e84ae(state, start, end, (0, $d925B.INPUT_METHOD).FORMATTING, editorAnalyticsAPI);
};
function $1f0d3cb22128de73$export$568a7ed6897c4817(schema, editorAnalyticsAPI) {
    const rules = [];
    if (schema.nodes.rule) {
        // '---' and '***' for hr
        rules.push(// eslint-disable-next-line require-unicode-regexp
        (0, $l03WE.createRule)(/^(\-\-\-|\*\*\*)$/, (state, _match, start, end)=>$1f0d3cb22128de73$var$createHorizontalRuleAutoformat(state, start, end, editorAnalyticsAPI)));
        // '---' and '***' after shift+enter for hr
        rules.push((0, $l03WE.createRule)(// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        new RegExp(`${(0, $14sLv.leafNodeReplacementCharacter)}(\\-\\-\\-|\\*\\*\\*)`), (state, _match, start, end)=>{
            const { hardBreak: hardBreak } = state.schema.nodes;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (state.doc.resolve(start).nodeAfter.type !== hardBreak) return null;
            return $1f0d3cb22128de73$var$createHorizontalRuleAutoformat(state, start, end, editorAnalyticsAPI);
        }));
    }
    if (rules.length !== 0) return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('rule', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $1f0d3cb22128de73$export$2e2bcd8739ae039 = $1f0d3cb22128de73$export$568a7ed6897c4817;


const $25833fa2bf91b712$export$439dcefd29ca03b3 = (editorAnalyticsAPI)=>(inputMethod)=>(state, dispatch)=>{
            const tr = (0, $1f0d3cb22128de73$export$718ed5cb714e84ae)(state, state.selection.from, state.selection.to, inputMethod, editorAnalyticsAPI);
            if (tr) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };







var $hgeg8 = parcelRequire("hgeg8");


var $dus6D = parcelRequire("dus6D");


function $8de4c454409556ee$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.insertRule).common, (0, $25833fa2bf91b712$export$439dcefd29ca03b3)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.escape).common, ()=>true, list);
    return (0, $dus6D.keymap)(list);
}
var $8de4c454409556ee$export$2e2bcd8739ae039 = $8de4c454409556ee$export$e832373cff8dec22;


const $be38216c2eedb78a$export$7cc71f8da095a98d = ({ api: api })=>{
    return {
        name: 'rule',
        nodes () {
            return [
                {
                    name: 'rule',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $bLhD4.ruleWithLocalId) : (0, $bLhD4.rule)
                }
            ];
        },
        actions: {
            insertHorizontalRule: (0, $25833fa2bf91b712$export$439dcefd29ca03b3)(api?.analytics?.actions)
        },
        pmPlugins () {
            return [
                {
                    name: 'ruleInputRule',
                    plugin: ({ schema: schema })=>(0, $1f0d3cb22128de73$export$2e2bcd8739ae039)(schema, api?.analytics?.actions)
                },
                {
                    name: 'ruleKeymap',
                    plugin: ()=>(0, $8de4c454409556ee$export$2e2bcd8739ae039)(api?.analytics?.actions)
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'rule',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).horizontalRule),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).horizontalRuleDescription),
                        keywords: [
                            'horizontal',
                            'rule',
                            'line',
                            'hr'
                        ],
                        priority: 1200,
                        keyshortcut: '---',
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3pLGZ.IconDivider), {}),
                        action (insert, state, source) {
                            const tr = insert(state.schema.nodes.rule.createChecked());
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).INSERTED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).DIVIDER,
                                attributes: {
                                    inputMethod: source ?? (0, $d925B.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $d925B.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};
module.exports["rulePlugin"] = $be38216c2eedb78a$export$7cc71f8da095a98d;

});

parcelRegister("eeGWn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $63Ztt = parcelRequire("63Ztt");


var $d925B = parcelRequire("d925B");

var $3824I = parcelRequire("3824I");


var $d7ZU3 = parcelRequire("d7ZU3");


var $eiA8Z = parcelRequire("eiA8Z");


var $cQMhV = parcelRequire("cQMhV");


var $hgeg8 = parcelRequire("hgeg8");


var $4HWgE = parcelRequire("4HWgE");


var $sxTNo = parcelRequire("sxTNo");


var $gmyMu = parcelRequire("gmyMu");


var $1S4f7 = parcelRequire("1S4f7");


var $8m4tT = parcelRequire("8m4tT");


var $ks2lK = parcelRequire("ks2lK");


var $dmcsV = parcelRequire("dmcsV");


var $ftzrq = parcelRequire("ftzrq");


var $7XFGZ = parcelRequire("7XFGZ");

function $8066f11773850466$export$938a078fa3e1d420(state) {
    if (!(state.selection instanceof (0, $7XFGZ.CellSelection))) return null;
    const cells = [];
    state.selection.forEachCell((node, pos)=>{
        cells.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, {
            class: 'selectedCell'
        }));
    });
    return (0, $ftzrq.DecorationSet).create(state.doc, cells);
}





const $be4cdf109bd11991$export$8dc63188bf2e0962 = new (0, $ks2lK.PluginKey)('selectingCells');
const $be4cdf109bd11991$export$9731ba46aee163cb = new (0, $ks2lK.PluginKey)('fix-tables');



var $LmqWp = parcelRequire("LmqWp");


var $jl382 = parcelRequire("jl382");


var $d1kIV = parcelRequire("d1kIV");

// Helper for iterating through the nodes in a document that changed
// compared to the given previous document. Useful for avoiding
// duplicate work on each transaction.
function $6e94456addd84fb2$var$changedDescendants(old, cur, offsetStart, f) {
    let offset = offsetStart;
    const oldSize = old.childCount;
    const curSize = cur.childCount;
    // eslint-disable-next-line no-labels
    outer: for(let i = 0, j = 0; i < curSize; i++){
        const child = cur.child(i);
        for(let scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++)if (old.child(scan) === child) {
            j = scan + 1;
            offset += child.nodeSize;
            continue outer;
        }
        f(child, offset);
        if (j < oldSize && old.child(j).sameMarkup(child)) $6e94456addd84fb2$var$changedDescendants(old.child(j), child, offset + 1, f);
        else child.nodesBetween(0, child.content.size, f, offset + 1);
        offset += child.nodeSize;
    }
}
function $6e94456addd84fb2$export$d6d48849d9121a1(state, oldState, reportFixedTable) {
    let tr;
    const check = (node, pos)=>{
        if (node.type.spec.tableRole === 'table') tr = $6e94456addd84fb2$export$26dfac117c7732d8(state, node, pos, tr, reportFixedTable);
    };
    if (!oldState) state.doc.descendants(check);
    else if (oldState.doc !== state.doc) $6e94456addd84fb2$var$changedDescendants(oldState.doc, state.doc, 0, check);
    return tr;
}
function $6e94456addd84fb2$export$26dfac117c7732d8(state, table, tablePos, transaction, reportFixedTable) {
    let tr = transaction;
    const map = (0, $LmqWp.TableMap).get(table);
    if (!map.problems) return tr;
    if (!tr) tr = state.tr;
    // Track which rows we must add cells to, so that we can adjust that
    // when fixing collisions.
    const mustAdd = [];
    for(let i = 0; i < map.height; i++)mustAdd.push(0);
    for(let i = 0; i < map.problems.length; i++){
        const prob = map.problems[i];
        if (reportFixedTable) reportFixedTable({
            state: state,
            tr: tr,
            reason: prob.type || 'unknown'
        });
        if (prob.type === (0, $LmqWp.TableProblemTypes).COLLISION) {
            const collision = prob;
            const cell = table.nodeAt(prob.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            for(let j = 0; j < cell.attrs.rowspan; j++)mustAdd[collision.row + j] += collision.n;
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), undefined, (0, $jl382.removeColSpan)(cell.attrs, cell.attrs.colspan - collision.n, collision.n));
        } else if (prob.type === (0, $LmqWp.TableProblemTypes).MISSING) {
            const missing = prob;
            mustAdd[missing.row] += missing.n;
        } else if (prob.type === (0, $LmqWp.TableProblemTypes).OVERLONG_ROWSPAN) {
            const overlong = prob;
            const cell = table.nodeAt(overlong.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + overlong.pos), undefined, {
                ...cell.attrs,
                rowspan: cell.attrs.rowspan - overlong.n
            });
        } else if (prob.type === (0, $LmqWp.TableProblemTypes).COLWIDTH_MISMATCH) {
            const cell = table.nodeAt(prob.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), undefined, {
                ...cell.attrs,
                colwidth: prob.colwidth
            });
        }
    }
    let first;
    let last;
    for(let i = 0; i < mustAdd.length; i++)if (mustAdd[i]) {
        if (first == null) first = i;
        last = i;
    }
    // Add the necessary cells, using a heuristic for whether to add the
    // cells at the start or end of the rows (if it looks like a 'bite'
    // was taken out of the table, add cells at the start of the row
    // after the bite. Otherwise add them at the end).
    for(let i = 0, pos = tablePos + 1; i < map.height; i++){
        const row = table.child(i);
        const end = pos + row.nodeSize;
        const add = mustAdd[i];
        if (add > 0) {
            let tableNodeType = 'cell';
            if (row.firstChild) tableNodeType = row.firstChild.type.spec.tableRole;
            const nodes = [];
            for(let j = 0; j < add; j++)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            nodes.push((0, $d1kIV.tableNodeTypes)(state.schema)[tableNodeType].createAndFill());
            const side = (i === 0 || first === i - 1) && last === i ? pos + 1 : end - 1;
            tr.insert(tr.mapping.map(side), nodes);
        }
        pos = end;
    }
    return tr.setMeta((0, $be4cdf109bd11991$export$9731ba46aee163cb), {
        fixTables: true
    });
}






var $iu6m9 = parcelRequire("iu6m9");







function $fc3f1737d6e568d3$export$64b8795b15903d8d(state, transaction, allowTableNodeSelection) {
    let tr = transaction;
    const sel = (tr || state).selection;
    const { doc: doc } = tr || state;
    let normalize;
    let role;
    if (sel instanceof (0, $ks2lK.NodeSelection)) role = sel.node.type.spec.tableRole;
    const isMultiSelect = (0, $iu6m9.editorExperiment)('platform_editor_element_drag_and_drop_multiselect', true);
    if (sel instanceof (0, $ks2lK.NodeSelection) && role) {
        if (role === 'cell' || role === 'header_cell') normalize = (0, $7XFGZ.CellSelection).create(doc, sel.from);
        else if (role === 'row') {
            const $cell = doc.resolve(sel.from + 1);
            normalize = (0, $7XFGZ.CellSelection).rowSelection($cell, $cell);
        } else if (!allowTableNodeSelection) {
            const map = (0, $LmqWp.TableMap).get(sel.node);
            const start = sel.from + 1;
            const lastCell = start + map.map[map.width * map.height - 1];
            normalize = (0, $7XFGZ.CellSelection).create(doc, start + 1, lastCell);
        }
    } else if (sel instanceof (0, $ks2lK.TextSelection) && $fc3f1737d6e568d3$var$isCellBoundarySelection(sel)) normalize = (0, $ks2lK.TextSelection).create(doc, sel.from);
    else if (sel instanceof (0, $ks2lK.TextSelection) && (isMultiSelect ? $fc3f1737d6e568d3$var$isTextSelectionAcrossSameTableCells(sel) : $fc3f1737d6e568d3$var$isTextSelectionAcrossCells(sel))) normalize = (0, $ks2lK.TextSelection).create(doc, sel.$from.start(), sel.$from.end());
    if (normalize) (tr || (tr = state.tr)).setSelection(normalize);
    return tr;
}
function $fc3f1737d6e568d3$var$isCellBoundarySelection({ $from: $from, $to: $to }) {
    if ($from.pos === $to.pos || $from.pos < $from.pos - 6) return false;
     // Cheap elimination
    let afterFrom = $from.pos;
    let beforeTo = $to.pos;
    let { depth: depth } = $from;
    for(; depth >= 0; depth--, afterFrom++){
        if ($from.after(depth + 1) < $from.end(depth)) break;
    }
    for(let d = $to.depth; d >= 0; d--, beforeTo--){
        if ($to.before(d + 1) > $to.start(d)) break;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return afterFrom === beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole);
}
function $fc3f1737d6e568d3$var$isTextSelectionAcrossCells({ $from: $from, $to: $to }) {
    let fromCellBoundaryNode;
    let toCellBoundaryNode;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') {
            fromCellBoundaryNode = node;
            break;
        }
    }
    for(let i = $to.depth; i > 0; i--){
        const node = $to.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') {
            toCellBoundaryNode = node;
            break;
        }
    }
    return fromCellBoundaryNode !== toCellBoundaryNode && $to.parentOffset === 0;
}
function $fc3f1737d6e568d3$var$isTextSelectionAcrossSameTableCells({ $from: $from, $to: $to }) {
    let fromCellBoundaryNode;
    let toCellBoundaryNode;
    let fromCellTableNode;
    let toCellTableNode;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') fromCellBoundaryNode = node;
        if (node.type.name === 'table') {
            fromCellTableNode = node;
            break;
        }
    }
    for(let i = $to.depth; i > 0; i--){
        const node = $to.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') toCellBoundaryNode = node;
        if (node.type.name === 'table') {
            toCellTableNode = node;
            break;
        }
    }
    return fromCellBoundaryNode !== undefined && toCellBoundaryNode !== undefined && fromCellBoundaryNode !== toCellBoundaryNode && toCellTableNode === fromCellTableNode && $to.parentOffset === 0;
}


// This file defines a number of helpers for wiring up user input to
// table-related functionality.

var $dus6D = parcelRequire("dus6D");


var $5SAOw = parcelRequire("5SAOw");








var $id9O1 = parcelRequire("id9O1");




var $3gZJH = parcelRequire("3gZJH");


var $bMyNT = parcelRequire("bMyNT");


const $ae1fd67c68cac0cd$export$bab59f27a7347e45 = (0, $dus6D.keydownHandler)({
    ArrowLeft: $ae1fd67c68cac0cd$var$arrow('horiz', -1),
    ArrowRight: $ae1fd67c68cac0cd$var$arrow('horiz', 1),
    ArrowUp: $ae1fd67c68cac0cd$var$arrow('vert', -1),
    ArrowDown: $ae1fd67c68cac0cd$var$arrow('vert', 1),
    'Shift-ArrowLeft': $ae1fd67c68cac0cd$var$shiftArrow('horiz', -1),
    'Shift-ArrowRight': $ae1fd67c68cac0cd$var$shiftArrow('horiz', 1),
    'Shift-ArrowUp': $ae1fd67c68cac0cd$var$shiftArrow('vert', -1),
    'Shift-ArrowDown': $ae1fd67c68cac0cd$var$shiftArrow('vert', 1),
    Backspace: $ae1fd67c68cac0cd$var$deleteCellSelection,
    'Mod-Backspace': $ae1fd67c68cac0cd$var$deleteCellSelection,
    Delete: $ae1fd67c68cac0cd$var$deleteCellSelection,
    'Mod-Delete': $ae1fd67c68cac0cd$var$deleteCellSelection
});
function $ae1fd67c68cac0cd$var$maybeSetSelection(state, dispatch, selection) {
    if (selection.eq(state.selection)) return false;
    if (dispatch) dispatch(state.tr.setSelection(selection).scrollIntoView());
    return true;
}
function $ae1fd67c68cac0cd$var$arrow(axis, dir) {
    return (state, dispatch, view)=>{
        if (dispatch) {
            const sel = state.selection;
            if (sel instanceof (0, $7XFGZ.CellSelection)) return $ae1fd67c68cac0cd$var$maybeSetSelection(state, dispatch, (0, $ks2lK.Selection).near(sel.$headCell, dir));
            if (axis !== 'horiz' && !sel.empty) return false;
            const end = view ? $ae1fd67c68cac0cd$var$atEndOfCell(view, axis, dir) : null;
            if (end === null) return false;
            if (axis === 'horiz') return $ae1fd67c68cac0cd$var$maybeSetSelection(state, dispatch, (0, $ks2lK.Selection).near(state.doc.resolve(sel.head + dir), dir));
            const $cell = state.doc.resolve(end);
            const $next = (0, $3gZJH.nextCell)($cell, axis, dir);
            let newSel;
            if ($next) newSel = (0, $ks2lK.Selection).near($next, 1);
            else if (dir < 0) newSel = (0, $ks2lK.Selection).near(state.doc.resolve($cell.before(-1)), -1);
            else newSel = (0, $ks2lK.Selection).near(state.doc.resolve($cell.after(-1)), 1);
            return $ae1fd67c68cac0cd$var$maybeSetSelection(state, dispatch, newSel);
        }
        return true;
    };
}
function $ae1fd67c68cac0cd$var$shiftArrow(axis, dir) {
    return (state, dispatch, view)=>{
        let sel = state.selection;
        if (!(sel instanceof (0, $7XFGZ.CellSelection))) {
            const end = view ? $ae1fd67c68cac0cd$var$atEndOfCell(view, axis, dir) : null;
            if (end === null) return false;
            const { selection: { $head: $head, $anchor: $anchor } } = state;
            const maybeTableCell = $head.blockRange($anchor);
            // Make sure the selection is coming from the same cell
            const sameCell = [
                'tableCell',
                'tableHeader'
            ].includes(maybeTableCell?.parent?.type.name || '');
            if (!sameCell) return false;
            sel = new (0, $7XFGZ.CellSelection)(state.doc.resolve(end));
        }
        const $head = (0, $3gZJH.nextCell)(sel.$headCell, axis, dir);
        if (!$head) return false;
        if (dispatch) return $ae1fd67c68cac0cd$var$maybeSetSelection(state, dispatch, new (0, $7XFGZ.CellSelection)(sel.$anchorCell, $head));
        return true;
    };
}
function $ae1fd67c68cac0cd$var$deleteCellSelection(state, dispatch) {
    const sel = state.selection;
    if (!(sel instanceof (0, $7XFGZ.CellSelection))) return false;
    if (dispatch) {
        const { tr: tr } = state;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const baseContent = (0, $d1kIV.tableNodeTypes)(state.schema).cell.createAndFill().content;
        sel.forEachCell((cell, pos)=>{
            if (!cell.content.eq(baseContent)) tr.replace(tr.mapping.map(pos + 1), tr.mapping.map(pos + cell.nodeSize - 1), new (0, $5SAOw.Slice)(baseContent, 0, 0));
        });
        if (tr.docChanged) dispatch(tr);
    }
    return true;
}
function $ae1fd67c68cac0cd$export$f17e34274dd6fcf5(view, pos) {
    const { doc: doc } = view.state;
    const $cell = (0, $3gZJH.cellAround)(doc.resolve(pos));
    if (!$cell) return false;
    view.dispatch(view.state.tr.setSelection(new (0, $7XFGZ.CellSelection)($cell)));
    return true;
}
function $ae1fd67c68cac0cd$export$b4a93e0b711d8f7(view, event) {
    const startEvent = event;
    // Prevent right clicks from making a cell selection https://product-fabric.atlassian.net/browse/ED-12527
    if (startEvent.ctrlKey || startEvent.metaKey || startEvent.button === 2 // right mouse click
    ) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const startDOMCell = $ae1fd67c68cac0cd$var$domInCell(view, startEvent.target);
    const $anchor = (0, $3gZJH.cellAround)(view.state.selection.$anchor);
    if (startEvent.shiftKey && view.state.selection instanceof (0, $7XFGZ.CellSelection)) {
        const targetElement = event.target instanceof HTMLElement || event.target instanceof SVGElement ? event.target : null;
        const isDragHandleElement = !!targetElement && !!targetElement.closest('button.pm-table-drag-handle-button-container, button.pm-table-drag-handle-button-clickable-zone');
        if (isDragHandleElement) return false;
        setCellSelection(view.state.selection.$anchorCell, startEvent);
        startEvent.preventDefault();
    } else if (startEvent.shiftKey && startDOMCell && $anchor !== null && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $ae1fd67c68cac0cd$var$cellUnderMouse(view, startEvent).pos !== $anchor.pos) {
        // Adding to a selection that starts in another cell (causing a
        // cell selection to be created).
        setCellSelection($anchor, startEvent);
        startEvent.preventDefault();
    } else if (!startDOMCell) // Not in a cell, let the default behavior happen.
    return false;
    // Create and dispatch a cell selection between the given anchor and
    // the position under the mouse.
    function setCellSelection($selectionAnchor, event) {
        let $head = $ae1fd67c68cac0cd$var$cellUnderMouse(view, event);
        const starting = (0, $be4cdf109bd11991$export$8dc63188bf2e0962).getState(view.state) == null;
        if (!$head || !(0, $bMyNT.inSameTable)($selectionAnchor, $head)) {
            if (starting) $head = $selectionAnchor;
            else return false;
        }
        const selection = new (0, $7XFGZ.CellSelection)($selectionAnchor, $head);
        if (starting || !view.state.selection.eq(selection)) {
            const tr = view.state.tr.setSelection(selection);
            if (starting) tr.setMeta((0, $be4cdf109bd11991$export$8dc63188bf2e0962), $selectionAnchor.pos);
            view.dispatch(tr);
        }
    }
    // Stop listening to mouse motion events.
    function stop() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('mouseup', stop);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('dragstart', stop);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('mousemove', move);
        if ((0, $be4cdf109bd11991$export$8dc63188bf2e0962).getState(view.state) != null) view.dispatch(view.state.tr.setMeta((0, $be4cdf109bd11991$export$8dc63188bf2e0962), -1));
    }
    function move(event) {
        const anchor = (0, $be4cdf109bd11991$export$8dc63188bf2e0962).getState(view.state);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const currDOMCell = $ae1fd67c68cac0cd$var$domInCell(view, event.target);
        const isCurrCellInsideNestedTable = $ae1fd67c68cac0cd$var$isInsideNestedTable(view, event);
        const isStartCellInsideNestedTable = $ae1fd67c68cac0cd$var$isInsideNestedTable(view, startEvent);
        const isBothCellsInSameTable = isCurrCellInsideNestedTable === isStartCellInsideNestedTable;
        let $moveAnchor;
        if (anchor != null) // Continuing an existing cross-cell selection
        $moveAnchor = view.state.doc.resolve(anchor);
        else if (currDOMCell !== startDOMCell && isBothCellsInSameTable) {
            // Moving out of the initial cell -- start a new cell selection
            $moveAnchor = $ae1fd67c68cac0cd$var$cellUnderMouse(view, startEvent);
            if (!$moveAnchor) {
                stop();
                return;
            }
        }
        if ($moveAnchor) setCellSelection($moveAnchor, event);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('mouseup', stop);
    // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('dragstart', stop);
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('mousemove', move);
    return false;
}
// Check whether the cursor is at the end of a cell (so that further
// motion would move out of the cell)
function $ae1fd67c68cac0cd$var$atEndOfCell(view, axis, dir) {
    if (!(view.state.selection instanceof (0, $ks2lK.TextSelection))) return null;
    const { $head: $head } = view.state.selection;
    for(let d = $head.depth - 1; d >= 0; d--){
        const parent = $head.node(d);
        const index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
        if (index !== (dir < 0 ? 0 : parent.childCount)) return null;
        if (parent.type.spec.tableRole === 'cell' || parent.type.spec.tableRole === 'header_cell') {
            const cellPos = $head.before(d);
            const dirStr = // eslint-disable-next-line no-nested-ternary
            axis === 'vert' ? dir > 0 ? 'down' : 'up' : dir > 0 ? 'right' : 'left';
            return view.endOfTextblock(dirStr) ? cellPos : null;
        }
    }
    return null;
}
function $ae1fd67c68cac0cd$var$domInCell(view, inputDom) {
    let dom = inputDom;
    for(; dom && dom !== view.dom; dom = dom.parentNode){
        if (dom.nodeName === 'TD' || dom.nodeName === 'TH') return dom;
    }
    return null;
}
function $ae1fd67c68cac0cd$var$cellUnderMouse(view, event) {
    const mousePos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!mousePos) return null;
    return (0, $3gZJH.cellAround)(view.state.doc.resolve(mousePos.pos));
}
function $ae1fd67c68cac0cd$var$isInsideNestedTable(view, event) {
    const mousePos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!mousePos) return false;
    const pos = view.state.doc.resolve(mousePos.pos);
    const table = (0, $id9O1.findTableClosestToPos)(pos);
    if (!table) return false;
    const parent = view.state.doc.resolve(table.pos).parent;
    const nodeTypes = view.state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
}



function $4bda0cf32d3d9590$export$e382fe3f780a6548({ allowTableNodeSelection: allowTableNodeSelection = false, reportFixedTable: reportFixedTable } = {}) {
    return new (0, $ks2lK.Plugin)({
        key: (0, $be4cdf109bd11991$export$8dc63188bf2e0962),
        // This piece of state is used to remember when a mouse-drag
        // cell-selection is happening, so that it can continue even as
        // transactions (which might move its anchor cell) come in.
        state: {
            init () {
                return null;
            },
            apply (unsafeTr, cur) {
                const tr = unsafeTr;
                const set = tr.getMeta((0, $be4cdf109bd11991$export$8dc63188bf2e0962));
                if (set != null) return set === -1 ? null : set;
                if (cur == null || !tr.docChanged) return cur;
                const { deleted: deleted, pos: pos } = tr.mapping.mapResult(cur);
                return deleted ? null : pos;
            }
        },
        props: {
            decorations: (0, $8066f11773850466$export$938a078fa3e1d420),
            handleDOMEvents: {
                mousedown: (view, event)=>{
                    (0, $ae1fd67c68cac0cd$export$b4a93e0b711d8f7)(view, event);
                }
            },
            createSelectionBetween (view) {
                if ((0, $be4cdf109bd11991$export$8dc63188bf2e0962).getState(view.state) != null) return view.state.selection;
                return null;
            },
            handleTripleClick: $ae1fd67c68cac0cd$export$f17e34274dd6fcf5,
            handleKeyDown: $ae1fd67c68cac0cd$export$bab59f27a7347e45,
            handlePaste: $dmcsV.handlePaste
        },
        appendTransaction (_, oldState, state) {
            return (0, $fc3f1737d6e568d3$export$64b8795b15903d8d)(state, (0, $6e94456addd84fb2$export$d6d48849d9121a1)(state, oldState, reportFixedTable), allowTableNodeSelection);
        }
    });
}



var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");





var $2daQU = parcelRequire("2daQU");


var $kB2tR = parcelRequire("kB2tR");





var $24P9d = parcelRequire("24P9d");


var $ixUmr = parcelRequire("ixUmr");





var $1zav4 = parcelRequire("1zav4");


var $caYZ2 = parcelRequire("caYZ2");

var $3Ter7 = parcelRequire("3Ter7");





var $aFUXX = parcelRequire("aFUXX");




const $8588522c22c049a0$export$dd66abdcfb4bb2cf = 48;
const $8588522c22c049a0$export$bffd6819c009a916 = 1800;
const $8588522c22c049a0$export$8a91b25da594a758 = 4000;
const $8588522c22c049a0$export$b5e6eff3efdc4860 = 1800;
const $8588522c22c049a0$export$e8dbf55270553cd3 = 0.3;
const $8588522c22c049a0$export$2e7c88a39ad490e6 = 0.4;
const $8588522c22c049a0$export$7c8bcfa1d3f9af23 = 76;
const $8588522c22c049a0$var$COMMENT_AK_EDITOR_CONTENT_AREA_PADDING = 20;
const $8588522c22c049a0$var$COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN = 12;
const $8588522c22c049a0$export$c332ba2dd5aa2199 = 2 * ($8588522c22c049a0$var$COMMENT_AK_EDITOR_CONTENT_AREA_PADDING + $8588522c22c049a0$var$COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN);
const $8588522c22c049a0$export$a823f6a7493b3d06 = 12;



var $6fQl1 = parcelRequire("6fQl1");


















function $b61fc0745b235461$export$7bde9ac1d5d663fc(tableLayout, containerWidth = 0, options) {
    const { isFullWidthModeEnabled: isFullWidthModeEnabled } = options;
    if (isFullWidthModeEnabled) {
        let padding = (0, $aFUXX.akEditorGutterPaddingDynamic)();
        if (containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        })) padding = (0, $aFUXX.akEditorGutterPaddingReduced);
        return containerWidth ? Math.min(containerWidth - padding * 2, (0, $aFUXX.akEditorFullWidthLayoutWidth)) : (0, $aFUXX.akEditorFullWidthLayoutWidth);
    }
    const calculatedTableWidth = (0, $1zav4.calcTableWidth)(tableLayout, containerWidth, true);
    if (calculatedTableWidth !== 'inherit') return calculatedTableWidth;
    return (0, $6fQl1.layoutToWidth)[tableLayout] || containerWidth;
}
function $b61fc0745b235461$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $b61fc0745b235461$export$8f862fd911e06936(view, cellPos, { colspan: colspan, colwidth: colwidth }) {
    const width = colwidth && colwidth[colwidth.length - 1];
    if (width) return width;
    // Not fixed, read current width from DOM
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    let domWidth = view.domAtPos(cellPos + 1).node.offsetWidth;
    let parts = colspan || 0;
    if (colwidth) {
        for(let i = 0; i < (colspan || 0); i++)if (colwidth[i]) {
            domWidth -= colwidth[i];
            parts--;
        }
    }
    return domWidth / parts;
}
const $b61fc0745b235461$export$8bfbafe1083a527d = ({ table: table, tableStart: tableStart, state: state, layout: layout, getEditorContainerWidth: getEditorContainerWidth })=>{
    const containerWidth = getEditorContainerWidth();
    const parentWidth = (0, $6fQl1.getParentNodeWidth)(tableStart, state, containerWidth);
    let maxWidth = parentWidth || table.attrs.width || $b61fc0745b235461$export$7bde9ac1d5d663fc(layout, containerWidth.width, {});
    if (table.attrs.isNumberColumnEnabled) maxWidth -= (0, $aFUXX.akEditorTableNumberColumnWidth);
    return maxWidth;
};
const $b61fc0745b235461$export$44361276769f7eff = (table)=>{
    if ((0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(table)) // TODO: ED-26961 - is there a scenario where ADF columns are SMALLER than container width?
    return (0, $caYZ2.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
    return $b61fc0745b235461$export$a34136fcfaec1907(table);
};
const $b61fc0745b235461$export$a34136fcfaec1907 = (table)=>{
    return (0, $6fQl1.getTableContainerWidth)(table);
};
const $b61fc0745b235461$export$817f7cd897b65634 = (isCommentEditor, isChromelessEditor, isTableScalingEnabled)=>{
    const maxResizerWidthForNonCommentEditor = isTableScalingEnabled ? `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2)), ${(0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916)}px)` : `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2) - var(--ak-editor--resizer-handle-spacing)), ${(0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916)}px)`;
    return isCommentEditor || isChromelessEditor ? '100%' : maxResizerWidthForNonCommentEditor;
};
const $b61fc0745b235461$export$708cde710ed0df70 = (node, isCommentEditor, isChromelessEditor)=>{
    const tableWidthAttribute = (0, $6fQl1.getTableContainerWidth)(node);
    if (!node.attrs.width && (isCommentEditor || isChromelessEditor)) // width undefined would make .resizer-item width to be `auto`
    return undefined;
    return tableWidthAttribute;
};
const $b61fc0745b235461$export$7d968ec824de6aa6 = (node, isCommentEditor, isChromelessEditor)=>{
    const tableWidthAttribute = $b61fc0745b235461$export$708cde710ed0df70(node, isCommentEditor, isChromelessEditor);
    return tableWidthAttribute ? `${tableWidthAttribute}px` : 'auto';
};
const $b61fc0745b235461$export$30421da09613cb3d = (node, isTableScalingEnabled)=>{
    const tableWidth = $b61fc0745b235461$export$a34136fcfaec1907(node);
    // for full page appearance
    if (isTableScalingEnabled) return `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2)), ${tableWidth}px)`;
    return `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2) - var(--ak-editor--resizer-handle-spacing)), ${tableWidth}px)`;
};
const $b61fc0745b235461$export$b2c142721a99201b = (table, tableRef, shouldUseIncreasedScalingPercent)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $8588522c22c049a0$export$2e7c88a39ad490e6) : (0, $8588522c22c049a0$export$e8dbf55270553cd3);
    const tableWidth = $b61fc0745b235461$export$a34136fcfaec1907(table);
    const renderWidth = tableRef?.parentElement?.clientWidth || tableWidth;
    // minus 1 here to avoid any 1px scroll in Firefox
    let scalePercent = (renderWidth - 1) / tableWidth;
    scalePercent = Math.max(scalePercent, 1 - maxScalingPercent);
    return Math.min(scalePercent, 1);
};
const $b61fc0745b235461$export$4e884677f8e54bba = (table, tableRef)=>{
    // are table columns resized
    if ((0, $d7e0ca7a06057b05$export$b44a013e4f554514)(table)) {
        const tableWidth = (0, $caYZ2.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
        const renderWidth = tableRef?.parentElement?.clientWidth || tableWidth;
        // minus 1 here to avoid any 1px scroll in Firefox
        return (renderWidth - 1) / tableWidth;
    }
    // When table cols are not resized and table width is not set,
    // tableWidth is equal to renderWidth
    return 1;
};
const $b61fc0745b235461$export$f9c5ace2959c7a33 = (table, tableRenderWidth, shouldUseIncreasedScalingPercent)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $8588522c22c049a0$export$2e7c88a39ad490e6) : (0, $8588522c22c049a0$export$e8dbf55270553cd3);
    const tableWidth = $b61fc0745b235461$export$a34136fcfaec1907(table);
    // minus 1 here to avoid any 1px scroll in Firefox
    let scalePercent = (tableRenderWidth - 1) / tableWidth;
    scalePercent = Math.max(scalePercent, 1 - maxScalingPercent);
    return Math.min(scalePercent, 1);
};


const $d7e0ca7a06057b05$export$66302252070a658d = (colwidth, tableColumnCount)=>colwidth - 1 / tableColumnCount;
const $d7e0ca7a06057b05$var$generateColStyle = (fixedColWidth, tableWidth, isCommentEditor, isChromelessEditor, isNested, shouldUseIncreasedScalingPercent, isNumberColumnEnabled, isTableHasWidth, hasTableBeenResized)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $8588522c22c049a0$export$2e7c88a39ad490e6) : (0, $8588522c22c049a0$export$e8dbf55270553cd3);
    const maxScaledRatio = 1 - maxScalingPercent;
    const isFullPageEditor = !isChromelessEditor && !isCommentEditor;
    // for nested tables, or chromeless editor, which used non resizable table container
    if (isNested || isChromelessEditor) {
        if (hasTableBeenResized) return `width: max(${fixedColWidth}px, ${0, $1zav4.tableCellMinWidth}px)`;
        return `width: ${0, $1zav4.tableCellMinWidth}px)`;
    }
    if (isFullPageEditor || !isFullPageEditor && isTableHasWidth) {
        const scaledPercent = isNumberColumnEnabled ? `calc(calc(var(--ak-editor-table-width) - ${0, $aFUXX.akEditorTableNumberColumnWidth}px - 1px)/${tableWidth})` : `calc(calc(var(--ak-editor-table-width) - 1px)/${tableWidth})`;
        return `width: max(calc(${fixedColWidth}px * ${maxScaledRatio}), calc(${fixedColWidth} * ${scaledPercent}), ${0, $1zav4.tableCellMinWidth}px)`;
    }
    // table resized to full-width in comment editor
    // it doesn't have a width attribute, and cols has been resized
    if (hasTableBeenResized) {
        const scaledPercent = isNumberColumnEnabled ? `calc(calc(var(--ak-editor-table-width) - ${0, $aFUXX.akEditorTableNumberColumnWidth}px - 1px)/${tableWidth})` : `calc(calc(var(--ak-editor-table-width) - 1px)/${tableWidth})`;
        return `width: max(calc(${fixedColWidth} * ${scaledPercent}), ${0, $1zav4.tableCellMinWidth}px)`;
    }
    return `width: ${0, $1zav4.tableCellMinWidth}px`;
};
const $d7e0ca7a06057b05$export$465034143db788da = (table, isCommentEditor, isChromelessEditor, isNested, isTableScalingEnabled, shouldUseIncreasedScalingPercent)=>{
    const cols = [];
    const map = (0, $LmqWp.TableMap).get(table);
    const isTableHasWidth = !!table.attrs.width;
    const isNumberColumnEnabled = table.attrs.isNumberColumnEnabled || false;
    const isFullPageEditor = !isChromelessEditor && !isCommentEditor;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    table.content.firstChild.content.forEach((cell)=>{
        const colspan = cell.attrs.colspan || 1;
        // if the table has been resized
        if (Array.isArray(cell.attrs.colwidth)) cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
            // existing logic for calculating the width of the column
            const fixedColWidth = $d7e0ca7a06057b05$export$66302252070a658d(width, map.width);
            const tableWidth = isFullPageEditor || !isFullPageEditor && isTableHasWidth ? (0, $b61fc0745b235461$export$a34136fcfaec1907)(table) : (0, $caYZ2.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
            if (isTableScalingEnabled) cols.push([
                'col',
                {
                    style: $d7e0ca7a06057b05$var$generateColStyle(fixedColWidth, tableWidth, isCommentEditor, isChromelessEditor, isNested, shouldUseIncreasedScalingPercent, isNumberColumnEnabled, isTableHasWidth, true)
                }
            ]);
            else cols.push([
                'col',
                {
                    style: `width: max(${fixedColWidth}px, ${(0, $1zav4.tableCellMinWidth)}px)`
                }
            ]);
        });
        else if (!isTableScalingEnabled) cols.push(...Array.from({
            length: colspan
        }, (_)=>[
                'col',
                {
                    style: `width: ${(0, $1zav4.tableCellMinWidth)}px;`
                }
            ]));
        else // columns has not been resized, so distribute the width evenly
        cols.push(...Array.from({
            length: colspan
        }, (_)=>{
            const tableWidth = (0, $b61fc0745b235461$export$a34136fcfaec1907)(table);
            const columnWidth = tableWidth / map.width || 0;
            const fixedColWidth = $d7e0ca7a06057b05$export$66302252070a658d(columnWidth, map.width || 0);
            return [
                'col',
                {
                    style: $d7e0ca7a06057b05$var$generateColStyle(fixedColWidth, tableWidth, isCommentEditor, isChromelessEditor, isNested, shouldUseIncreasedScalingPercent, isNumberColumnEnabled, isTableHasWidth)
                }
            ];
        }));
    });
    return cols;
};
const $d7e0ca7a06057b05$export$6628e11a2af8bd40 = (table, tableRef, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor)=>{
    const cols = [];
    const map = (0, $LmqWp.TableMap).get(table);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    table.content.firstChild.content.forEach((cell)=>{
        const colspan = cell.attrs.colspan || 1;
        if (Array.isArray(cell.attrs.colwidth)) {
            // We slice here to guard against our colwidth array having more entries
            // Than the we actually span. We'll patch the document at a later point.
            if (tableRef) {
                // if we have tableRef here, isTableScalingEnabled is true
                let scalePercent = 1;
                if (isCommentOrChromelessEditor && !table.attrs?.width) scalePercent = (0, $b61fc0745b235461$export$4e884677f8e54bba)(table, tableRef);
                else scalePercent = (0, $b61fc0745b235461$export$b2c142721a99201b)(table, tableRef, shouldUseIncreasedScalingPercent);
                cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
                    // existing logic for calculating the width of the column
                    const fixedColWidth = $d7e0ca7a06057b05$export$66302252070a658d(width, map.width);
                    const scaledWidth = fixedColWidth * scalePercent;
                    const finalWidth = Math.max(scaledWidth, (0, $1zav4.tableCellMinWidth));
                    cols.push([
                        'col',
                        {
                            style: `width: ${finalWidth}px;`
                        }
                    ]);
                });
            } else cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
                cols.push([
                    'col',
                    {
                        style: `width: ${$d7e0ca7a06057b05$export$66302252070a658d(width ? Math.max(width, (0, $1zav4.tableCellMinWidth)) : (0, $1zav4.tableCellMinWidth), map.width)}px;`
                    }
                ]);
            });
        } else // When we have merged cells on the first row (firstChild),
        // We want to ensure we're creating the appropriate amount of
        // cols the table still has.
        cols.push(...Array.from({
            length: colspan
        }, (_)=>[
                'col',
                {
                    style: `width: ${(0, $1zav4.tableCellMinWidth)}px;`
                }
            ]));
    });
    return cols;
};
const $d7e0ca7a06057b05$export$ae5d9647f2a0891c = (tableRef, table, isTableScalingEnabled = false, shouldRemove = true, shouldUseIncreasedScalingPercent = false, isCommentOrChromelessEditor = false)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    let colgroup = tableRef?.querySelector('colgroup');
    if (colgroup && shouldRemove) tableRef?.removeChild(colgroup);
    colgroup = $d7e0ca7a06057b05$var$renderColgroupFromNode(table, isTableScalingEnabled ? tableRef ?? undefined : undefined, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor);
    if (shouldRemove) tableRef?.insertBefore(colgroup, tableRef?.firstChild);
    return colgroup.children;
};
const $d7e0ca7a06057b05$export$8c07f44cea64e3c7 = (table)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return !!(0, $3Ter7.getFragmentBackingArray)(table.content.firstChild.content).find((cell)=>cell.attrs.colwidth);
};
const $d7e0ca7a06057b05$export$b44a013e4f554514 = $d7e0ca7a06057b05$export$8c07f44cea64e3c7;
const $d7e0ca7a06057b05$export$2878318085bf6dbf = (table)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const cellArray = (0, $3Ter7.getFragmentBackingArray)(table.content.firstChild.content);
    const isTableMinCellWidth = cellArray.every((cell)=>{
        return cell.attrs.colwidth && cell.attrs.colwidth[0] === (0, $1zav4.tableCellMinWidth) || cell.attrs.colwidth === null;
    });
    return isTableMinCellWidth;
};
function $d7e0ca7a06057b05$var$renderColgroupFromNode(table, maybeTableRef, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor) {
    const rendered = (0, $5SAOw.DOMSerializer).renderSpec(document, [
        'colgroup',
        {},
        ...$d7e0ca7a06057b05$export$6628e11a2af8bd40(table, maybeTableRef, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor)
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return rendered.dom;
}
const $d7e0ca7a06057b05$export$dc24345db4290451 = (table)=>{
    const map = (0, $LmqWp.TableMap).get(table);
    return map.width;
};
const $d7e0ca7a06057b05$export$e7ee55be67771d90 = (node)=>{
    const currentColumnCount = $d7e0ca7a06057b05$export$dc24345db4290451(node);
    const minColumnWidth = Math.min(3, currentColumnCount) * (0, $8588522c22c049a0$export$dd66abdcfb4bb2cf);
    // add an extra pixel as the scale table logic will scale columns to be tableContainerWidth - 1
    // the table can't scale past its min-width, so instead restrict table container min width to avoid that situation
    return minColumnWidth + 1;
};



























const $710fa7224ef1174e$export$ce28ec4a9ddaeb6d = (tr, table, tablePos, modifyCell)=>{
    const rows = [];
    let modifiedCells = 0;
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const row = table.child(rowIndex);
        const cells = [];
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            // TODO: ED-26961 - The rowIndex and colIndex are not accurate in a merged cell scenario
            // e.g. table with 5 columns might have only one cell in a row, colIndex will be 1, where it should be 4
            const node = modifyCell(cell, rowIndex, colIndex);
            if (node.sameMarkup(cell) === false) modifiedCells++;
            cells.push(node);
        }
        if (cells.length) rows.push(row.type.createChecked(row.attrs, cells, row.marks));
    }
    // Check if the table has changed before replacing.
    // If no cells are modified our counter will be zero.
    if (rows.length && modifiedCells !== 0) {
        const newTable = table.type.createChecked(table.attrs, rows, table.marks);
        return tr.replaceWith(tablePos, tablePos + table.nodeSize, newTable);
    }
    return tr;
};
const $710fa7224ef1174e$export$97482f1a2b86c59e = (tr, table, tablePos, modifyCell)=>{
    let rowOffset = tablePos + 1;
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const row = table.child(rowIndex);
        let cellOffset = rowOffset + 1;
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            const modified = modifyCell(cell, rowIndex, colIndex);
            if (!modified.sameMarkup(cell)) tr.setNodeMarkup(cellOffset, modified.type, modified.attrs, modified.marks);
            cellOffset += cell.nodeSize;
        }
        rowOffset += row.nodeSize;
    }
    return tr;
};


const $63436dab70cd92ce$var$tableWidth = (contentWidth)=>{
    const maxEditorWidth = (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $aFUXX.akEditorMaxLayoutWidth) : (0, $aFUXX.akEditorFullWidthLayoutWidth);
    return Math.min(maxEditorWidth, contentWidth);
};
const $63436dab70cd92ce$export$d87d6ab7a18b29eb = (tableRef)=>{
    const colWidths = $63436dab70cd92ce$var$getRenderedColgroupColumnWidths(tableRef);
    const totalContentWidth = colWidths.reduce((acc, current)=>acc + current, 0);
    return {
        colWidths: colWidths,
        tableWidth: $63436dab70cd92ce$var$tableWidth(totalContentWidth)
    };
};
const $63436dab70cd92ce$export$e55d81380f623ba1 = (tr, tableNode, { colWidths: colWidths, tableWidth: tableWidth }, tablePos)=>{
    tr = (0, $710fa7224ef1174e$export$97482f1a2b86c59e)(tr, tableNode, tablePos, (cell, _rowIndex, colIndex)=>{
        const newColWidths = colWidths.slice(colIndex, colIndex + cell.attrs.colspan);
        return cell.type.createChecked({
            ...cell.attrs,
            colwidth: newColWidths.length ? newColWidths : null
        }, cell.content, cell.marks);
    });
    return tr.setNodeMarkup(tablePos, undefined, {
        ...tableNode.attrs,
        width: tableWidth
    });
};
function $63436dab70cd92ce$var$getRenderedColgroupColumnWidths(tableRef) {
    const cols = Array.from(tableRef.querySelectorAll(':scope > colgroup > col'));
    return cols.map((col)=>{
        const width = col.getBoundingClientRect().width;
        return Math.max(Math.round(width), (0, $1zav4.tableCellMinWidth));
    });
}


const $3a3941a6aa273892$export$e217d2a535d6ae45 = ({ allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, isFullPageEditor: isFullPageEditor })=>{
    return allowColumnResizing && allowTableResizing && isFullPageEditor;
};
const $3a3941a6aa273892$export$a6fbfadef1c3fa2e = (view, pluginInjectionApi)=>{
    const { state: { doc: doc, schema: schema } } = view;
    let tr = view.state.tr;
    const { table: table } = schema.nodes;
    let modified = false;
    const measuredTables = [];
    // modify only top-level tables
    doc.forEach((node, offset)=>{
        if (node.type !== table || (0, $ixUmr.hasTableBeenResized)(node) && node.attrs.layout !== 'align-start') return;
        const domNode = view.domAtPos(offset + 1).node;
        const tableWrapper = domNode instanceof HTMLElement ? domNode.closest(`.${(0, $1zav4.TableSharedCssClassName).TABLE_VIEW_CONTENT_WRAP}`) : null;
        const tableRef = tableWrapper?.querySelector('table');
        if (!tableRef) return;
        measuredTables.push({
            node: node,
            offset: offset,
            measurement: (0, $63436dab70cd92ce$export$d87d6ab7a18b29eb)(tableRef)
        });
    });
    measuredTables.forEach(({ node: node, offset: offset, measurement: measurement })=>{
        tr = (0, $63436dab70cd92ce$export$e55d81380f623ba1)(tr, node, measurement, offset);
        modified = true;
    });
    if (modified) {
        pluginInjectionApi?.analytics?.actions?.attachAnalyticsEvent({
            action: (0, $3824I.TABLE_ACTION).FIT_TO_CONTENT_AUTO_CONVERTED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                editorContainerWidth: pluginInjectionApi?.width?.sharedState.currentState()?.width ?? 0,
                totalTablesResized: measuredTables.length,
                measurements: measuredTables.map(({ measurement: measurement })=>({
                        tableWidth: measurement.tableWidth,
                        totalColumnCount: measurement.colWidths.length
                    }))
            }
        })(tr);
        view.dispatch(tr.setMeta('addToHistory', false));
    }
};
const $3a3941a6aa273892$export$b4d02699ba1d276b = (tableRef)=>{
    const cols = Array.from(tableRef.querySelectorAll(':scope > colgroup > col'));
    const contentWrap = tableRef.closest(`.${(0, $1zav4.TableSharedCssClassName).TABLE_VIEW_CONTENT_WRAP}`);
    const resizerContainer = contentWrap?.querySelector(`.${(0, $1zav4.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`);
    const resizerItem = resizerContainer?.querySelector('.resizer-item.display-handle');
    // Capture current inline styles so we can restore them after measurement
    const prevTableWidth = tableRef.style.width;
    const prevTableLayout = tableRef.style.tableLayout;
    const prevColWidths = cols.map((col)=>col.style.width);
    const prevResizerItemWidth = resizerItem?.style.width;
    // Apply temporary styles for content-based measurement
    tableRef.style.width = '';
    tableRef.style.tableLayout = 'auto';
    cols.forEach((col)=>col.style.width = '');
    if (resizerContainer) {
        // favour CSS var to align with the table first render state, which gets reset
        // once resized by user. By doing this we avoid the need to any 'reset' work after
        // measurement and ensures it works if the table has been resized or not in the session.
        resizerContainer.style.width = 'var(--ak-editor-table-width)';
        resizerContainer.style.setProperty('--ak-editor-table-width', 'max-content');
    }
    if (resizerItem) resizerItem.style.width = 'max-content';
    const measurement = (0, $63436dab70cd92ce$export$d87d6ab7a18b29eb)(tableRef);
    // Reset all inline styles back to their previous values
    tableRef.style.width = prevTableWidth;
    tableRef.style.tableLayout = prevTableLayout;
    cols.forEach((col, i)=>col.style.width = prevColWidths[i]);
    if (resizerItem) resizerItem.style.width = prevResizerItemWidth ?? '';
    return measurement;
};
const $3a3941a6aa273892$export$b4b4c38f004e5aad = (view, api)=>{
    const tableObject = (0, $id9O1.findTable)(view.state.selection);
    if (!tableObject) return;
    const { node: node, pos: pos } = tableObject;
    const tableState = api?.table.sharedState.currentState();
    if (!tableState?.tableRef) return;
    // Instead of dispatching a transaction to "strip widths" and then waiting
    // for a rAF to measure natural column widths, directly update the DOM elements,
    // take a measurement, and reset styles so no temporary overrides persist.
    const measurement = $3a3941a6aa273892$export$b4d02699ba1d276b(tableState.tableRef);
    const tr = (0, $63436dab70cd92ce$export$e55d81380f623ba1)(view.state.tr, node, measurement, pos);
    api?.analytics?.actions?.attachAnalyticsEvent({
        action: (0, $3824I.TABLE_ACTION).FIT_TO_CONTENT_ON_DEMAND,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        actionSubjectId: null,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            editorContainerWidth: api?.width?.sharedState.currentState()?.width ?? 0,
            tableWidth: measurement.tableWidth,
            totalColumnCount: measurement.colWidths.length
        }
    })(tr);
    view.dispatch(tr);
};



const $8b84c930bc26bcf8$export$2cbc54593c64b1f2 = 'align-start';
const $8b84c930bc26bcf8$export$3ea9e188ab01c845 = 'center';
const $8b84c930bc26bcf8$export$2e10df95acfe6933 = (layout)=>layout === $8b84c930bc26bcf8$export$3ea9e188ab01c845 || layout === $8b84c930bc26bcf8$export$2cbc54593c64b1f2 ? layout : $8b84c930bc26bcf8$export$3ea9e188ab01c845;
const $8b84c930bc26bcf8$export$8dcb9bda5f25db3a = (isTableAlignmentEnabled, tableNode, lineLength, updatedTableWidth)=>Boolean(isTableAlignmentEnabled && tableNode && tableNode.attrs.layout === $8b84c930bc26bcf8$export$2cbc54593c64b1f2 && lineLength && updatedTableWidth > lineLength && lineLength < (0, $8588522c22c049a0$export$b5e6eff3efdc4860));


const $b5ee4b1040c29bb8$var$centerAlignStyle = {
    display: 'flex',
    justifyContent: 'center'
};
const $b5ee4b1040c29bb8$var$leftAlignStyle = {
    display: 'flex',
    justifyContent: 'flex-start'
};
const $b5ee4b1040c29bb8$export$b4e2cb644a5e9e7e = (alignment)=>alignment === (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2) ? $b5ee4b1040c29bb8$var$leftAlignStyle : $b5ee4b1040c29bb8$var$centerAlignStyle;


const $da7b34fe5d676606$export$477bb32cbededd65 = (config)=>{
    const tableNode = config.isNestingSupported ? (0, $63Ztt.tableWithNestedTable) : (0, $63Ztt.table);
    return {
        ...tableNode,
        toDOM: (node)=>{
            const isFullPageEditor = !config.isChromelessEditor && !config.isCommentEditor;
            const isInContentMode = (0, $ixUmr.isTableInContentMode)({
                tableNode: node,
                isSupported: (0, $3a3941a6aa273892$export$e217d2a535d6ae45)({
                    allowColumnResizing: config.allowColumnResizing,
                    allowTableResizing: config.tableResizingEnabled,
                    isFullPageEditor: isFullPageEditor
                }),
                isTableNested: config.isNested
            }) && (0, $1oCLl.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true);
            const alignmentStyle = Object.entries((0, $b5ee4b1040c29bb8$export$b4e2cb644a5e9e7e)(node.attrs.layout)).map(([k, v])=>`${(0, (/*@__PURE__*/$parcel$interopDefault($kB2tR)))(k)}: ${(0, (/*@__PURE__*/$parcel$interopDefault($kB2tR)))(v)}`).join(';');
            const tableMinWidth = (0, $d7e0ca7a06057b05$export$e7ee55be67771d90)(node);
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width,
                'data-ssr-placeholder': `table-${node.attrs.localId}`,
                'data-ssr-placeholder-replace': `table-${node.attrs.localId}`
            };
            if (isInContentMode) attrs['data-initial-width-mode'] = 'content';
            if ((0, $1oCLl.expValEquals)('platform_editor_table_display_mode_in_to_dom', 'isEnabled', true)) attrs['data-table-display-mode'] = node.attrs.displayMode;
            // This would be used for table scaling in colgroup CSS
            // cqw, or px is well supported
            const resizableTableWidth = isFullPageEditor ? (0, $b61fc0745b235461$export$30421da09613cb3d)(node, config.isTableScalingEnabled) : `calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2))`;
            let colgroup = '';
            if (config.allowColumnResizing) colgroup = [
                'colgroup',
                {},
                ...(0, $d7e0ca7a06057b05$export$465034143db788da)(node, config.isCommentEditor, config.isChromelessEditor, config.isNested, config.isTableScalingEnabled, config.shouldUseIncreasedScalingPercent)
            ];
            const tableContainerDiv = [
                'div',
                {
                    class: 'pm-table-container',
                    'data-number-column': node.attrs.isNumberColumnEnabled,
                    'data-layout': node.attrs.layout,
                    'data-testid': 'table-container'
                },
                [
                    'div',
                    {
                        class: 'pm-table-sticky-sentinel-top',
                        'data-testid': 'sticky-sentinel-top'
                    }
                ],
                [
                    'div',
                    {
                        class: 'pm-table-row-controls-wrapper'
                    },
                    [
                        'div'
                    ]
                ],
                [
                    'div',
                    {
                        class: 'pm-table-wrapper'
                    },
                    [
                        'table',
                        attrs,
                        colgroup,
                        [
                            'tbody',
                            0
                        ]
                    ]
                ],
                [
                    'div',
                    {
                        class: 'pm-table-sticky-sentinel-bottom',
                        'data-testid': 'sticky-sentinel-bottom'
                    }
                ],
                ...(0, $1oCLl.expValEquals)('platform_editor_vc90_transition_table_border', 'isEnabled', true) ? [
                    [
                        'div',
                        {
                            contenteditable: 'false',
                            class: 'pm-table-left-border',
                            'data-with-numbered-table': node.attrs.isNumberColumnEnabled,
                            'data-testid': 'table-left-border'
                        }
                    ],
                    [
                        'div',
                        {
                            contenteditable: 'false',
                            class: 'pm-table-right-border',
                            'data-testid': 'table-right-border'
                        }
                    ]
                ] : []
            ];
            if (!config.tableResizingEnabled || config.isNested) return [
                'div',
                {
                    class: 'tableView-content-wrap',
                    'data-prosemirror-initial-toDOM-render': 'true',
                    style: (0, $24P9d.convertToInlineCss)({
                        '--ak-editor-table-width': resizableTableWidth
                    })
                },
                tableContainerDiv
            ];
            const tableResizingDiv = [
                'div',
                {
                    'data-testid': 'table-alignment-container',
                    style: alignmentStyle
                },
                [
                    'div',
                    {
                        class: 'pm-table-resizer-container',
                        style: (0, $24P9d.convertToInlineCss)({
                            '--ak-editor-table-gutter-padding': config.isTableScalingEnabled ? 'calc(var(--ak-editor--large-gutter-padding) * 2)' : 'calc(var(--ak-editor--large-gutter-padding) * 2 - var(--ak-editor-resizer-handle-spacing))',
                            '--ak-editor-table-width': isInContentMode ? 'max-content' : resizableTableWidth,
                            width: `var(--ak-editor-table-width)`
                        })
                    },
                    [
                        'div',
                        {
                            class: (0, $1oCLl.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true) ? 'resizer-item display-handle' : (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))('resizer-item', {
                                'display-handle': !isInContentMode
                            }),
                            style: (0, $24P9d.convertToInlineCss)({
                                position: 'relative',
                                userSelect: 'auto',
                                boxSizing: 'border-box',
                                '--ak-editor-table-max-width': `${(0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916)}px`,
                                '--ak-editor-table-min-width': `${tableMinWidth}px`,
                                minWidth: 'var(--ak-editor-table-min-width)',
                                maxWidth: (0, $b61fc0745b235461$export$817f7cd897b65634)(config.isCommentEditor, config.isChromelessEditor, config.isTableScalingEnabled),
                                width: isInContentMode ? 'auto' : (0, $b61fc0745b235461$export$7d968ec824de6aa6)(node, config.isCommentEditor, config.isChromelessEditor)
                            })
                        },
                        [
                            'span',
                            {
                                class: 'resizer-hover-zone'
                            },
                            tableContainerDiv
                        ]
                    ]
                ]
            ];
            return [
                'div',
                {
                    class: 'tableView-content-wrap',
                    'data-prosemirror-initial-toDOM-render': 'true'
                },
                tableResizingDiv
            ];
        }
    };
};











var $a4TK8 = parcelRequire("a4TK8");





var $4vlwG = parcelRequire("4vlwG");

var $7iE7T = parcelRequire("7iE7T");

var $kTbzR = parcelRequire("kTbzR");




















const $40458289442cabaf$export$c14b77638b178c5d = (columnIndexes)=>(selection)=>{
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return;
        const map = (0, $LmqWp.TableMap).get(table.node);
        const indexes = Array.isArray(columnIndexes) ? columnIndexes : [
            columnIndexes
        ];
        return indexes.filter((index)=>index >= 0 && index <= map.width - 1).reduce((acc, index)=>{
            const cells = map.cellsInRect({
                left: index,
                right: index + 1,
                top: 0,
                bottom: map.height
            });
            return acc.concat(cells.map((nodePos)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const node = table.node.nodeAt(nodePos);
                const pos = nodePos + table.start;
                return {
                    pos: pos,
                    start: pos + 1,
                    node: node,
                    depth: table.depth + 2
                };
            }));
        }, []);
    };







const $88d5b76f5df04f99$export$a804b6b4ce22aa92 = (rowIndex)=>(selection)=>{
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return;
        const map = (0, $LmqWp.TableMap).get(table.node);
        const indexes = Array.isArray(rowIndex) ? rowIndex : [
            rowIndex
        ];
        return indexes.filter((index)=>index >= 0 && index <= map.height - 1).reduce((acc, index)=>{
            const cells = map.cellsInRect({
                left: 0,
                right: map.width,
                top: index,
                bottom: index + 1
            });
            return acc.concat(cells.map((nodePos)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const node = table.node.nodeAt(nodePos);
                const pos = nodePos + table.start;
                return {
                    pos: pos,
                    start: pos + 1,
                    node: node,
                    depth: table.depth + 2
                };
            }));
        }, []);
    };


var $iP1et = parcelRequire("iP1et");

var $BW42l = parcelRequire("BW42l");

var $iYC9s = parcelRequire("iYC9s");

var $8usfh = parcelRequire("8usfh");

const $008a20f9f9e43ec0$export$5b4a0d6329b35552 = (tr)=>{
    const { $from: $from } = tr.selection;
    for(let depth = $from.depth; depth > 0; depth--){
        const node = $from.node(depth);
        if (node.type.spec.tableRole === 'table') return (0, $8usfh.cloneTr)(tr.delete($from.before(depth), $from.after(depth)));
    }
    return tr;
};


var $kEbNW = parcelRequire("kEbNW");

var $bzgWU = parcelRequire("bzgWU");



const $e4d9ceb64529799d$export$aa21d3b96c1c378c = (cell, attrs)=>(tr)=>{
        if (cell) {
            tr.setNodeMarkup(cell.pos, undefined, Object.assign({}, cell.node.attrs, attrs));
            return (0, $8usfh.cloneTr)(tr);
        }
        return tr;
    };


/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json






const $8b6ac7577f3a66b8$export$1a38c7157d718094 = 30;
var $8b6ac7577f3a66b8$export$fe8f2ca19399400e = /*#__PURE__*/ function(TableDecorations) {
    /** Classic controls */ TableDecorations["ALL_CONTROLS_HOVER"] = "CONTROLS_HOVER";
    TableDecorations["ROW_CONTROLS_HOVER"] = "ROW_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_HOVER"] = "COLUMN_CONTROLS_HOVER";
    TableDecorations["TABLE_CONTROLS_HOVER"] = "TABLE_CONTROLS_HOVER";
    TableDecorations["CELL_CONTROLS_HOVER"] = "CELL_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_DECORATIONS"] = "COLUMN_CONTROLS_DECORATIONS";
    TableDecorations["COLUMN_DROP_TARGET_DECORATIONS"] = "COLUMN_DROP_TARGET_DECORATIONS";
    TableDecorations["COLUMN_SELECTED"] = "COLUMN_SELECTED";
    TableDecorations["COLUMN_RESIZING_HANDLE"] = "COLUMN_RESIZING_HANDLE";
    TableDecorations["COLUMN_RESIZING_HANDLE_WIDGET"] = "COLUMN_RESIZING_HANDLE_WIDGET";
    TableDecorations["COLUMN_RESIZING_HANDLE_LINE"] = "COLUMN_RESIZING_HANDLE_LINE";
    TableDecorations["COLUMN_INSERT_LINE"] = "COLUMN_INSERT_LINE";
    TableDecorations["ROW_INSERT_LINE"] = "ROW_INSERT_LINE";
    return TableDecorations;
}({});
const $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f = {
    ...(0, $1zav4.TableSharedCssClassName),
    /** Classic controls */ COLUMN_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-column-controls`,
    COLUMN_CONTROLS_DECORATIONS: `${(0, $63Ztt.tablePrefixSelector)}-column-controls-decoration`,
    COLUMN_SELECTED: `${(0, $63Ztt.tablePrefixSelector)}-column__selected`,
    ROW_CONTROLS_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-row-controls-wrapper`,
    ROW_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-row-controls`,
    ROW_CONTROLS_INNER: `${(0, $63Ztt.tablePrefixSelector)}-row-controls__inner`,
    ROW_CONTROLS_BUTTON_WRAP: `${(0, $63Ztt.tablePrefixSelector)}-row-controls__button-wrap`,
    ROW_CONTROLS_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-row-controls__button`,
    CONTROLS_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-controls__button`,
    CONTROLS_BUTTON_ICON: `${(0, $63Ztt.tablePrefixSelector)}-controls__button-icon`,
    CONTROLS_INSERT_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-button`,
    CONTROLS_INSERT_BUTTON_INNER: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-button-inner`,
    CONTROLS_INSERT_BUTTON_WRAP: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-button-wrap`,
    CONTROLS_INSERT_LINE: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-line`,
    CONTROLS_BUTTON_OVERLAY: `${(0, $63Ztt.tablePrefixSelector)}-controls__button-overlay`,
    DRAG_CONTROLS_INSERT_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-controls__drag-insert-button`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER: `${(0, $63Ztt.tablePrefixSelector)}-controls__drag-insert-button-inner`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-controls__drag-insert-button-inner-column`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW: `${(0, $63Ztt.tablePrefixSelector)}-controls__drag-insert-button-inner-row`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS: `${(0, $63Ztt.tablePrefixSelector)}-controls__drag-insert-button-inner-row-chromeless`,
    DRAG_CONTROLS_INSERT_BUTTON_WRAP: `${(0, $63Ztt.tablePrefixSelector)}-controls__drag-insert-button-wrap`,
    CONTROLS_INSERT_MARKER: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-marker`,
    CONTROLS_INSERT_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-column`,
    CONTROLS_INSERT_ROW: `${(0, $63Ztt.tablePrefixSelector)}-controls__insert-row`,
    CONTROLS_DELETE_BUTTON_WRAP: `${(0, $63Ztt.tablePrefixSelector)}-controls__delete-button-wrap`,
    CONTROLS_DELETE_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-controls__delete-button`,
    CONTROLS_FLOATING_BUTTON_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-controls-floating__button-column`,
    CONTROLS_FLOATING_BUTTON_ROW: `${(0, $63Ztt.tablePrefixSelector)}-controls-floating__button-row`,
    CORNER_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-corner-controls`,
    CORNER_CONTROLS_INSERT_ROW_MARKER: `${(0, $63Ztt.tablePrefixSelector)}-corner-controls__insert-row-marker`,
    CORNER_CONTROLS_INSERT_COLUMN_MARKER: `${(0, $63Ztt.tablePrefixSelector)}-corner-controls__insert-column-marker`,
    CONTROLS_CORNER_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-corner-button`,
    /** drag and drop controls */ DRAG_ROW_CONTROLS_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-drag-row-controls-wrapper`,
    DRAG_ROW_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-drag-row-controls`,
    DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-drag-row-floating-insert-dot-wrapper`,
    DRAG_ROW_FLOATING_INSERT_DOT: `${(0, $63Ztt.tablePrefixSelector)}-drag-row-floating-insert-dot`,
    DRAG_ROW_FLOATING_DRAG_HANDLE: `${(0, $63Ztt.tablePrefixSelector)}-drag-row-floating-drag-handle`,
    DRAG_COLUMN_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-drag-column-controls`,
    DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-drag-columns-floating-insert-dot-wrapper`,
    DRAG_COLUMN_FLOATING_INSERT_DOT: `${(0, $63Ztt.tablePrefixSelector)}-drag-columns-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS_WRAPPER: `${(0, $63Ztt.tablePrefixSelector)}-col-controls-wrapper`,
    DRAG_COLUMN_DROP_TARGET_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-col-drop-target-controls`,
    DRAG_COLUMN_CONTROLS_INNER: `${(0, $63Ztt.tablePrefixSelector)}-col-controls__inner`,
    DRAG_HANDLE_BUTTON_CONTAINER: `${(0, $63Ztt.tablePrefixSelector)}-drag-handle-button-container`,
    DRAG_HANDLE_BUTTON_CLICKABLE_ZONE: `${(0, $63Ztt.tablePrefixSelector)}-drag-handle-button-clickable-zone`,
    DRAG_CORNER_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-drag-corner-button`,
    DRAG_CORNER_BUTTON_INNER: `${(0, $63Ztt.tablePrefixSelector)}-drag-corner-button-inner`,
    /** nested tables classes */ NESTED_TABLE_WITH_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-nested-table-with-controls`,
    /** disabled classes */ DRAG_HANDLE_DISABLED: `${(0, $63Ztt.tablePrefixSelector)}-drag-handle-disabled`,
    /** minimised handle class */ DRAG_HANDLE_MINIMISED: `${(0, $63Ztt.tablePrefixSelector)}-drag-handle-minimised`,
    DRAG_SUBMENU: `${(0, $63Ztt.tablePrefixSelector)}-drag-submenu`,
    DRAG_SUBMENU_ICON: `${(0, $63Ztt.tablePrefixSelector)}-drag-submenu-icon`,
    /** Other classes */ NUMBERED_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-numbered-column`,
    NUMBERED_COLUMN_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-numbered-column__button`,
    NUMBERED_COLUMN_BUTTON_DISABLED: `${(0, $63Ztt.tablePrefixSelector)}-numbered-column__button-disabled`,
    HOVERED_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-hovered-column`,
    HOVERED_ROW: `${(0, $63Ztt.tablePrefixSelector)}-hovered-row`,
    HOVERED_TABLE: `${(0, $63Ztt.tablePrefixSelector)}-hovered-table`,
    HOVERED_NO_HIGHLIGHT: `${(0, $63Ztt.tablePrefixSelector)}-hovered-no-highlight`,
    HOVERED_CELL: `${(0, $63Ztt.tablePrefixSelector)}-hovered-cell`,
    HOVERED_CELL_IN_DANGER: 'danger',
    HOVERED_CELL_ACTIVE: 'active',
    HOVERED_CELL_WARNING: `${(0, $63Ztt.tablePrefixSelector)}-hovered-cell__warning`,
    HOVERED_DELETE_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-hovered-delete-button`,
    WITH_CONTROLS: `${(0, $63Ztt.tablePrefixSelector)}-with-controls`,
    RESIZING_PLUGIN: `${(0, $63Ztt.tablePrefixSelector)}-resizing-plugin`,
    RESIZE_CURSOR: `${(0, $63Ztt.tablePrefixSelector)}-resize-cursor`,
    IS_RESIZING: `${(0, $63Ztt.tablePrefixSelector)}-is-resizing`,
    RESIZE_HANDLE_DECORATION: `${(0, $63Ztt.tablePrefixSelector)}-resize-decoration`,
    CONTEXTUAL_SUBMENU: `${(0, $63Ztt.tablePrefixSelector)}-contextual-submenu`,
    CONTEXTUAL_MENU_BUTTON_WRAP: `${(0, $63Ztt.tablePrefixSelector)}-contextual-menu-button-wrap`,
    CONTEXTUAL_MENU_BUTTON: `${(0, $63Ztt.tablePrefixSelector)}-contextual-menu-button`,
    CONTEXTUAL_MENU_BUTTON_FIXED: `${(0, $63Ztt.tablePrefixSelector)}-contextual-menu-button-fixed`,
    CONTEXTUAL_MENU_ICON: `${(0, $63Ztt.tablePrefixSelector)}-contextual-submenu-icon`,
    CONTEXTUAL_MENU_ICON_SMALL: `${(0, $63Ztt.tablePrefixSelector)}-contextual-submenu-icon-small`,
    // come from prosemirror-table
    SELECTED_CELL: 'selectedCell',
    // defined in ReactNodeView based on PM node name
    NODEVIEW_WRAPPER: 'tableView-content-wrap',
    TABLE_SELECTED: `${(0, $63Ztt.tablePrefixSelector)}-table__selected`,
    TABLE_CELL: (0, $63Ztt.tableCellSelector),
    TABLE_HEADER_CELL: (0, $63Ztt.tableHeaderSelector),
    TABLE_STICKY: `${(0, $63Ztt.tablePrefixSelector)}-sticky`,
    TABLE_CHROMELESS: `${(0, $63Ztt.tablePrefixSelector)}-chromeless`,
    TOP_LEFT_CELL: 'table > tbody > tr:nth-child(2) > td:nth-child(1)',
    WITH_COLUMN_INSERT_LINE: `${(0, $63Ztt.tablePrefixSelector)}-column-insert-line`,
    WITH_COLUMN_INSERT_LINE_INACTIVE: `${(0, $63Ztt.tablePrefixSelector)}-column-insert-line__inactive`,
    WITH_FIRST_COLUMN_INSERT_LINE: `${(0, $63Ztt.tablePrefixSelector)}-first-column-insert-line`,
    WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $63Ztt.tablePrefixSelector)}-first-column-insert-line__inactive`,
    WITH_LAST_COLUMN_INSERT_LINE: `${(0, $63Ztt.tablePrefixSelector)}-last-column-insert-line`,
    WITH_LAST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $63Ztt.tablePrefixSelector)}-last-column-insert-line__inactive`,
    WITH_RESIZE_LINE: `${(0, $63Ztt.tablePrefixSelector)}-column-resize-line`,
    WITH_RESIZE_LINE_LAST_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-column-resize-line-last-column`,
    WITH_DRAG_RESIZE_LINE: `${(0, $63Ztt.tablePrefixSelector)}-drag-column-resize-line`,
    WITH_DRAG_RESIZE_LINE_LAST_COLUMN: `${(0, $63Ztt.tablePrefixSelector)}-drag-column-resize-line-last-column`,
    WITH_ROW_INSERT_LINE: `${(0, $63Ztt.tablePrefixSelector)}-row-insert-line`,
    WITH_ROW_INSERT_LINE_INACTIVE: `${(0, $63Ztt.tablePrefixSelector)}-row-insert-line__inactive`,
    WITH_LAST_ROW_INSERT_LINE: `${(0, $63Ztt.tablePrefixSelector)}-last-row-insert-line`,
    WITH_LAST_ROW_INSERT_LINE_INACTIVE: `${(0, $63Ztt.tablePrefixSelector)}-last-row-insert-line__inactive`,
    NATIVE_STICKY: `${(0, $63Ztt.tablePrefixSelector)}-row-native-sticky`,
    NATIVE_STICKY_ACTIVE: `${(0, $63Ztt.tablePrefixSelector)}-row-native-sticky-active`,
    NO_OVERFLOW: `${(0, $63Ztt.tablePrefixSelector)}-no-overflow`
};
var $8b6ac7577f3a66b8$export$ce63d9b315ac58c9 = /*#__PURE__*/ function(ShadowEvent) {
    ShadowEvent["SHOW_BEFORE_SHADOW"] = "showBeforeShadow";
    ShadowEvent["SHOW_AFTER_SHADOW"] = "showAfterShadow";
    return ShadowEvent;
}({});



var $4KOFJ = parcelRequire("4KOFJ");
















/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json



const $fedf15e5199146e8$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tablePlugin');


/**
 * A plugin for handle table custom widths
 * Has login to scan the document, add width value to table's width attribute when necessary
 * Also holds resizing state to hide / show table controls
 */ 
var $9YoeD = parcelRequire("9YoeD");








var $2pjJ5 = parcelRequire("2pjJ5");













const $e9b9e23609860f66$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableWidthPlugin');
const $e9b9e23609860f66$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, fullWidthEnabled, maxWidthEnabled, isTableScalingEnabled, isTableAlignmentEnabled, isCommentEditor)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $e9b9e23609860f66$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    resizing: false,
                    tableLocalId: '',
                    tableRef: null
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($e9b9e23609860f66$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($e9b9e23609860f66$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            // When document first load in Confluence, initially it is an empty document
            // and Collab service triggers a transaction to replace the empty document with the real document that should be rendered.
            // what we need to do is to add width attr to all tables in the real document
            // isReplaceDocumentOperation is checking if the transaction is the one that replace the empty document with the real document
            const isReplaceDocumentOperation = (0, $2pjJ5.isReplaceDocOperation)(transactions, oldState);
            const referentialityTr = transactions.find((tr)=>tr.getMeta('referentialityTableInserted'));
            const shouldPatchTableWidth = fullWidthEnabled && isTableScalingEnabled;
            const shouldPatchTableAlignment = fullWidthEnabled && isTableAlignmentEnabled;
            if (!isReplaceDocumentOperation && (!shouldPatchTableWidth && !shouldPatchTableAlignment || !referentialityTr)) return null;
            const { table: table } = newState.schema.nodes;
            const tr = newState.tr;
            if (isReplaceDocumentOperation && !isCommentEditor) newState.doc.forEach((node, offset)=>{
                if ((0, $ixUmr.isTableInContentMode)({
                    tableNode: node,
                    isSupported: (0, $3a3941a6aa273892$export$e217d2a535d6ae45)({
                        allowColumnResizing: true,
                        allowTableResizing: true,
                        isFullPageEditor: true
                    }),
                    isTableNested: false
                })) return;
                if (node.type === table) {
                    const width = node.attrs.width;
                    const layout = node.attrs.layout;
                    if (!width && layout) {
                        let tableWidthCal;
                        if (maxWidthEnabled) tableWidthCal = (0, $aFUXX.akEditorMaxWidthLayoutWidth);
                        else if (fullWidthEnabled) tableWidthCal = (0, $aFUXX.akEditorFullWidthLayoutWidth);
                        else switch(layout){
                            case 'wide':
                                tableWidthCal = (0, $aFUXX.akEditorWideLayoutWidth);
                                break;
                            case 'full-width':
                                tableWidthCal = (0, $aFUXX.akEditorFullWidthLayoutWidth);
                                break;
                            // when in fix-width appearance, no need to assign value to table width attr
                            // as when table is created, width attr is null by default, table rendered using layout attr
                            default:
                                tableWidthCal = (0, $aFUXX.akEditorDefaultLayoutWidth);
                                break;
                        }
                        const { width: _width, ...rest } = node.attrs;
                        if (tableWidthCal) tr.step(new (0, $9YoeD.SetAttrsStep)(offset, {
                            width: tableWidthCal,
                            ...rest
                        }));
                    }
                }
            });
            if (referentialityTr) referentialityTr.steps.forEach((step)=>{
                step.getMap().forEach((_, __, newStart, newEnd)=>{
                    newState.doc.nodesBetween(newStart, newEnd, (node, pos)=>{
                        if (node.type === table) {
                            if (shouldPatchTableWidth && node.attrs.width !== ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916))) tr.setNodeAttribute(pos, 'width', (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916));
                            if (shouldPatchTableAlignment) tr.setNodeAttribute(pos, 'layout', (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2));
                        }
                    });
                });
            });
            return tr;
        }
    });
};


// @ts-ignore -- ReadonlyTransaction is a local declaration and will cause a TS2305 error in CCFE typecheck








var $aXWIB = parcelRequire("aXWIB");


var $cUcZ5 = parcelRequire("cUcZ5");
















/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $9K4OG = parcelRequire("9K4OG");








var $2CQVV = parcelRequire("2CQVV");


var $3gadb = parcelRequire("3gadb");


const $95b600cf03e08426$export$e84bed3a1e3da852 = ({ startIndex: startIndex, endIndex: endIndex, includeTooltip: includeTooltip })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    if (!includeTooltip) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION,
        "data-start-index": startIndex,
        "data-end-index": endIndex
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hgeg8.ToolTipContent), {
            description: formatMessage((0, $2CQVV.messages).adjustColumns),
            keymap: (0, $hgeg8.startColumnResizing)
        }),
        hideTooltipOnClick: true,
        hideTooltipOnMouseDown: true,
        position: "mouse",
        mousePosition: "auto-start"
    }, (tooltipProps)=>/*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION,
            "data-start-index": startIndex,
            "data-end-index": endIndex,
            ...tooltipProps
        }));
};


const $9283ce7d62ffd391$var$filterDecorationByKey = (key, decorationSet)=>decorationSet.find(undefined, undefined, (spec)=>spec.key.indexOf(key) > -1);
const $9283ce7d62ffd391$export$8042b574593bd713 = (decorationSet)=>$9283ce7d62ffd391$var$filterDecorationByKey((0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_SELECTED, decorationSet);
const $9283ce7d62ffd391$export$6577d2f7fe84e45c = (decorationSet)=>$9283ce7d62ffd391$var$filterDecorationByKey((0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).ALL_CONTROLS_HOVER, decorationSet);
const $9283ce7d62ffd391$export$e1f7dd2d4ed6c778 = (cells)=>cells.map((cell)=>(0, $ftzrq.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_WARNING
        }, {
            key: (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).CELL_CONTROLS_HOVER
        }));
const $9283ce7d62ffd391$export$ecf836094c108a0 = (cells, type, tr, hoveredIndexes, danger, selected)=>{
    const table = (0, $id9O1.findTable)(tr.selection);
    if (!table) return [];
    const map = (0, $LmqWp.TableMap).get(table.node);
    const [min, max] = cells.reduce(([min, max], cell)=>{
        if (min === null || cell.pos < min) min = cell.pos;
        if (max === null || cell.pos > max) max = cell.pos;
        return [
            min,
            max
        ];
    }, [
        null,
        null
    ]);
    if (min === null || max === null) return [];
    let updatedCells = cells.map((x)=>x.pos);
    // ED-15246 fixed trello card table overflow issue
    // If columns / rows have been merged the hovered selection is different to the actual selection
    // So If the table cells are in danger we want to create a "rectangle" selection
    // to match the "clicked" selection
    if (danger && type !== 'table') {
        const { selection: selection } = tr;
        const table = (0, $id9O1.findTable)(selection);
        const rect = (0, $iP1et.getSelectionRect)(selection);
        if (table && rect) updatedCells = map.cellsInRect(rect).map((x)=>x + table.start);
    }
    return updatedCells.map((pos)=>{
        const cell = tr.doc.nodeAt(pos);
        const classes = [
            (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL
        ];
        if (danger) classes.push((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER);
        if (selected) classes.push((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL);
        if (type === 'column' || type === 'row') {
            classes.pop();
            classes.push((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT);
        }
        let key;
        switch(type){
            case 'row':
                key = (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).ROW_CONTROLS_HOVER;
                break;
            case 'column':
                key = (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_CONTROLS_HOVER;
                break;
            default:
                key = (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).TABLE_CONTROLS_HOVER;
                break;
        }
        return (0, $ftzrq.Decoration).node(pos, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pos + cell.nodeSize, {
            class: classes.join(' ')
        }, {
            key: key
        });
    });
};
const $9283ce7d62ffd391$export$9bd7e7efc13bb839 = (tr)=>{
    const { selection: selection, doc: doc } = tr;
    const table = (0, $id9O1.findTable)(selection);
    const rect = (0, $iP1et.getSelectionRect)(selection);
    if (!table || !rect) return [];
    const map = (0, $LmqWp.TableMap).get(table.node);
    const cellPositions = map.cellsInRect(rect);
    return cellPositions.map((pos, index)=>{
        const cell = doc.nodeAt(pos + table.start);
        return (0, $ftzrq.Decoration).node(pos + table.start, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pos + table.start + cell.nodeSize, {
            class: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED
        }, {
            key: `${(0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_SELECTED}_${index}`
        });
    });
};
const $9283ce7d62ffd391$export$fbcaf99fd4d31ced = (selection)=>{
    const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(0)(selection) || [];
    let index = 0;
    return cells.map((cell)=>{
        const colspan = cell.node.attrs.colspan || 1;
        // It's important these values are scoped locally as the widget callback could be executed anytime in the future
        // and we want to avoid value leak
        const startIndex = index;
        const endIndex = startIndex + colspan;
        // The next cell start index will commence from the current cell end index.
        index = endIndex;
        return (0, $ftzrq.Decoration).widget(cell.pos + 1, ()=>{
            const element = document.createElement('div');
            element.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS);
            element.dataset.startIndex = `${startIndex}`;
            element.dataset.endIndex = `${endIndex}`;
            return element;
        }, {
            key: `${(0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_CONTROLS_DECORATIONS}_${endIndex}`,
            // this decoration should be the first one, even before gap cursor.
            side: -100
        });
    });
};
const $9283ce7d62ffd391$export$77a59c867f92cbc7 = (node, decorationSet, decorations, key)=>{
    const filteredDecorations = $9283ce7d62ffd391$var$filterDecorationByKey(key, decorationSet);
    const decorationSetFiltered = decorationSet.remove(filteredDecorations);
    return decorationSetFiltered.add(node, decorations);
};
const $9283ce7d62ffd391$var$makeArray = (n)=>Array.from(Array(n).keys());
const $9283ce7d62ffd391$export$dab489ad285db87 = (tr, rowIndexTarget, columnEndIndexTarget, includeTooltip = false, getIntl, nodeViewPortalProviderAPI)=>{
    const table = (0, $id9O1.findTable)(tr.selection);
    if (!table || !table.node) return [];
    const map = (0, $LmqWp.TableMap).get(table.node);
    if (!map.width) return [];
    const createResizerHandleDecoration = (cellColumnPositioning, columnIndex, rowIndex, cellPos, cellNode)=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const decorationRenderKey = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
        const position = cellPos + cellNode.nodeSize - 1;
        return (0, $ftzrq.Decoration).widget(position, ()=>{
            const element = document.createElement('div');
            nodeViewPortalProviderAPI.render(()=>(0, $42omo.createElement)((0, $aXWIB.RawIntlProvider), {
                    value: getIntl()
                }, (0, $42omo.createElement)((0, $95b600cf03e08426$export$e84bed3a1e3da852), {
                    startIndex: cellColumnPositioning.left,
                    endIndex: cellColumnPositioning.right,
                    includeTooltip: includeTooltip
                })), element, decorationRenderKey);
            return element;
        }, {
            key: `${(0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_WIDGET}_${rowIndex}_${columnIndex}_${includeTooltip ? 'with' : 'no'}-tooltip`,
            destroy: (_node)=>{
                nodeViewPortalProviderAPI.remove(decorationRenderKey);
            }
        });
    };
    const resizeHandleCellDecorations = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const seen = {};
        if (rowIndex !== rowIndexTarget) continue;
        for(let columnIndex = 0; columnIndex < map.width; columnIndex++){
            const cellPosition = map.map[map.width * rowIndex + columnIndex];
            if (seen[cellPosition]) continue;
            seen[cellPosition] = true;
            const cellPos = table.start + cellPosition;
            const cell = tr.doc.nodeAt(cellPos);
            if (!cell) continue;
            const colspan = cell.attrs.colspan || 1;
            const startIndex = columnIndex;
            const endIndex = colspan + startIndex;
            if (endIndex !== columnEndIndexTarget.right) continue;
            const resizerHandleDec = createResizerHandleDecoration({
                left: startIndex,
                right: endIndex
            }, columnIndex, rowIndex, cellPos, cell);
            resizeHandleCellDecorations.push(resizerHandleDec);
        }
    }
    return resizeHandleCellDecorations;
};
const $9283ce7d62ffd391$export$c1faae7fcf0653ce = (selection, cellColumnPositioning)=>{
    const table = (0, $id9O1.findTable)(selection);
    if (!table || cellColumnPositioning.right === null) return [];
    let columnIndex = cellColumnPositioning.right;
    const map = (0, $LmqWp.TableMap).get(table.node);
    const isLastColumn = columnIndex === map.width;
    if (isLastColumn) columnIndex -= 1;
    const decorationClassName = isLastColumn ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE_LAST_COLUMN : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE;
    const cellPositions = $9283ce7d62ffd391$var$makeArray(map.height).map((rowIndex)=>map.map[map.width * rowIndex + columnIndex]).filter((cellPosition, rowIndex)=>{
        if (isLastColumn) return true; // If is the last column no filter applied
        const nextPosition = map.map[map.width * rowIndex + columnIndex - 1];
        return cellPosition !== nextPosition; // Removed it if next position is merged
    });
    const cells = cellPositions.map((pos)=>({
            pos: pos + table.start,
            node: table.node.nodeAt(pos)
        }));
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $ftzrq.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE}_${cellColumnPositioning.right}_${index}`
        });
    }).filter((0, $kTbzR.nonNullable));
};
const $9283ce7d62ffd391$export$6012cbb334f87faa = (columnIndex, selection, hasMergedCells)=>{
    const table = (0, $id9O1.findTable)(selection);
    if (!table) return [];
    const map = (0, $LmqWp.TableMap).get(table.node);
    const isFirstColumn = columnIndex === 0;
    const isLastColumn = columnIndex === map.width;
    if (isLastColumn) columnIndex -= 1;
    let decorationClassName;
    if (hasMergedCells) decorationClassName = isFirstColumn ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE : isLastColumn ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE_INACTIVE;
    else decorationClassName = isFirstColumn ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE : isLastColumn ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE;
    const cellPositions = $9283ce7d62ffd391$var$makeArray(map.height).map((rowIndex)=>map.map[map.width * rowIndex + columnIndex]).filter((cellPosition, rowIndex)=>{
        if (isLastColumn) return true; // If is the last column no filter applied
        const nextPosition = map.map[map.width * rowIndex + columnIndex - 1];
        return cellPosition !== nextPosition; // Removed it if next position is merged
    });
    const cells = cellPositions.map((pos)=>({
            pos: pos + table.start,
            node: table.node.nodeAt(pos)
        }));
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $ftzrq.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_INSERT_LINE}_${index}`
        });
    }).filter((0, $kTbzR.nonNullable));
};
const $9283ce7d62ffd391$export$c47f6da2c2a0ebc8 = (rowIndex, selection, hasMergedCells)=>{
    const table = (0, $id9O1.findTable)(selection);
    if (!table) return [];
    const map = (0, $LmqWp.TableMap).get(table.node);
    const isLastRow = rowIndex === map.height;
    if (isLastRow) rowIndex -= 1;
    const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(rowIndex)(selection);
    if (!cells) return [];
    let decorationClassName;
    if (hasMergedCells) decorationClassName = isLastRow ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE_INACTIVE : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE_INACTIVE;
    else decorationClassName = isLastRow ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE;
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $ftzrq.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).ROW_INSERT_LINE}_${index}`
        });
    }).filter((0, $kTbzR.nonNullable));
};


const $f134087c7f5a0a6e$export$c3909dd6d9555879 = (transformers)=>({ decorationSet: decorationSet, tr: tr })=>transformers.reduce((decorationSet, transform)=>transform({
                decorationSet: decorationSet,
                tr: tr
            }), decorationSet);


const $54e3fa1bb68d93c9$var$isColumnSelected = (tr)=>tr.selection instanceof (0, $7XFGZ.CellSelection) && tr.selection.isColSelection();
// @see: https://product-fabric.atlassian.net/browse/ED-3796
const $54e3fa1bb68d93c9$var$removeControlsHoverDecoration = ({ decorationSet: decorationSet })=>decorationSet.remove((0, $9283ce7d62ffd391$export$6577d2f7fe84e45c)(decorationSet));
const $54e3fa1bb68d93c9$var$maybeUpdateColumnSelectedDecoration = ({ decorationSet: decorationSet, tr: tr })=>{
    if (!$54e3fa1bb68d93c9$var$isColumnSelected(tr)) return decorationSet;
    return (0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(tr.doc, decorationSet, (0, $9283ce7d62ffd391$export$9bd7e7efc13bb839)(tr), (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_SELECTED);
};
// @see: https://product-fabric.atlassian.net/browse/ED-7304
const $54e3fa1bb68d93c9$var$removeColumnControlsSelectedDecoration = ({ decorationSet: decorationSet })=>decorationSet.remove((0, $9283ce7d62ffd391$export$8042b574593bd713)(decorationSet));
const $54e3fa1bb68d93c9$var$hasColumnSelectedDecorations = (decorationSet)=>!!(0, $9283ce7d62ffd391$export$8042b574593bd713)(decorationSet).length;
const $54e3fa1bb68d93c9$export$cbb3730335eda2fb = ({ decorationSet: decorationSet, tr: tr })=>{
    if (!$54e3fa1bb68d93c9$var$hasColumnSelectedDecorations(decorationSet)) return decorationSet;
    return $54e3fa1bb68d93c9$var$removeColumnControlsSelectedDecoration({
        decorationSet: decorationSet,
        tr: tr
    });
};
const $54e3fa1bb68d93c9$export$967c329e5e466f2 = ({ decorationSet: decorationSet, tr: tr })=>{
    return (0, $f134087c7f5a0a6e$export$c3909dd6d9555879)([
        $54e3fa1bb68d93c9$var$removeColumnControlsSelectedDecoration,
        $54e3fa1bb68d93c9$var$removeControlsHoverDecoration,
        $54e3fa1bb68d93c9$var$maybeUpdateColumnSelectedDecoration
    ])({
        decorationSet: decorationSet,
        tr: tr
    });
};


const $de8398c45f744acc$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableDecorationsPlugin');
const $de8398c45f744acc$export$968abecb43309c32 = (state)=>$de8398c45f744acc$export$18d4026d1ea86bb1.getState(state);
const $de8398c45f744acc$export$a9962e3214ca2ff7 = (tr, decorationSet, oldState, newState)=>{
    const isResizing = (0, $e9b9e23609860f66$export$18d4026d1ea86bb1).getState(newState)?.resizing;
    const wasResizing = (0, $e9b9e23609860f66$export$18d4026d1ea86bb1).getState(oldState)?.resizing;
    const { isInDanger: isInDanger, isTableHovered: isTableHovered } = (0, $fedf15e5199146e8$export$18d4026d1ea86bb1).getState(newState) || {};
    const changedResizing = isResizing !== wasResizing;
    // Remove column controls when resizing and don't add column decoration controls when DnD enabled
    if (isResizing) return (0, $ftzrq.DecorationSet).empty;
    else if (tr.docChanged || tr.selection instanceof (0, $7XFGZ.CellSelection) || changedResizing) return (0, $54e3fa1bb68d93c9$export$967c329e5e466f2)({
        decorationSet: decorationSet,
        tr: tr
    });
    else if (tr.selectionSet) {
        const isTransactionFromMouseClick = !tr.docChanged && tr.selectionSet && tr.getMeta('pointer');
        if (isTransactionFromMouseClick || oldState.selection instanceof (0, $7XFGZ.CellSelection)) return (0, $54e3fa1bb68d93c9$export$cbb3730335eda2fb)({
            decorationSet: decorationSet,
            tr: tr
        });
        // We're exiting a table with an existing decorations so we should clean it up
        if ((isInDanger || isTableHovered) && (!(0, $4KOFJ.insideTable)(newState) || (0, $id9O1.findTable)(newState.selection)?.node !== (0, $id9O1.findTable)(oldState.selection)?.node)) return (0, $54e3fa1bb68d93c9$export$967c329e5e466f2)({
            decorationSet: decorationSet,
            tr: tr
        });
    }
    return decorationSet;
};
const $de8398c45f744acc$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init: ()=>(0, $ftzrq.DecorationSet).empty,
            apply: (tr, decorationSet, oldState, newState)=>{
                let pluginState = decorationSet;
                // main table plugin --->
                const meta = tr.getMeta((0, $fedf15e5199146e8$export$18d4026d1ea86bb1));
                if (meta && meta.data && meta.data.decorationSet) pluginState = meta.data.decorationSet;
                if (tr.docChanged || tr.selectionSet || tr.getMeta((0, $e9b9e23609860f66$export$18d4026d1ea86bb1))) {
                    pluginState = pluginState.map(tr.mapping, tr.doc);
                    return $de8398c45f744acc$export$a9962e3214ca2ff7(tr, pluginState, oldState, newState);
                }
                return pluginState;
            }
        },
        key: $de8398c45f744acc$export$18d4026d1ea86bb1,
        props: {
            decorations: (state)=>$de8398c45f744acc$export$968abecb43309c32(state)
        }
    });
};





const $8d12b05d544e83c2$var$updateColumnResizeHandle = (columnResizesDecorations)=>({ decorationSet: decorationSet, tr: tr })=>(0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(tr.doc, decorationSet, columnResizesDecorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_WIDGET);
const $8d12b05d544e83c2$export$aa1fe977609f5606 = (rowEndIndex, columnEndIndex, includeTooltip, getIntl, nodeViewPortalProviderAPI)=>({ tr: tr, decorationSet: decorationSet })=>{
        const columnResizesDecorations = columnEndIndex < 0 ? [] : (0, $9283ce7d62ffd391$export$dab489ad285db87)(tr, rowEndIndex, {
            right: columnEndIndex
        }, includeTooltip, getIntl, nodeViewPortalProviderAPI);
        return (0, $f134087c7f5a0a6e$export$c3909dd6d9555879)([
            $8d12b05d544e83c2$var$updateColumnResizeHandle(columnResizesDecorations)
        ])({
            decorationSet: decorationSet,
            tr: tr
        });
    };
const $8d12b05d544e83c2$export$a590d16867e1babd = ()=>({ tr: tr, decorationSet: decorationSet })=>{
        return (0, $f134087c7f5a0a6e$export$c3909dd6d9555879)([
            $8d12b05d544e83c2$var$updateColumnResizeHandle([])
        ])({
            decorationSet: decorationSet,
            tr: tr
        });
    };



var $lkJUe = parcelRequire("lkJUe");

// #region Imports

var $cCTpf = parcelRequire("cCTpf");


var $5mxQU = parcelRequire("5mxQU");







const $780923e152cc8f13$export$af473ce758096273 = {
    hoveredColumns: [],
    hoveredRows: []
};
const $780923e152cc8f13$export$4c0699e9a8272521 = {
    hoveredCell: {
        rowIndex: undefined,
        colIndex: undefined
    }
};





const $452bdd9463f93418$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableFlexiColumnResizing');






var $aXG5V = parcelRequire("aXG5V");




const $8c756dab441d0bf4$var$bail = ()=>({
        tableIsCollapsible: false
    });
const $8c756dab441d0bf4$export$34840b5e3787a37c = (tr)=>{
    const selection = tr.selection;
    const schema = tr.doc.type.schema;
    const nodePos = (0, $id9O1.findTable)(selection);
    if (!nodePos) return $8c756dab441d0bf4$var$bail();
    const expand = schema.nodes.expand;
    const { node: node, pos: pos } = nodePos;
    const $pos = tr.doc.resolve(pos);
    const range = new (0, $5SAOw.NodeRange)($pos, tr.doc.resolve(pos + node.nodeSize), $pos.depth);
    if (!range) return $8c756dab441d0bf4$var$bail();
    const canWrap = (0, $aXG5V.findWrapping)(range, expand);
    if (canWrap === null) return $8c756dab441d0bf4$var$bail();
    return {
        tableIsCollapsible: true,
        range: range,
        /**
		 * Do we ever want to deal with the result of `findWrapping`? Probably not,
		 * but we have it anyway.
		 */ findWrappingRes: canWrap
    };
};
const $8c756dab441d0bf4$export$436c9f28d887a0c3 = (tr)=>{
    const canCollapse = $8c756dab441d0bf4$export$34840b5e3787a37c(tr);
    const expand = tr.doc.type.schema.nodes.expand;
    if (!canCollapse.range || !canCollapse.tableIsCollapsible) return undefined;
    /**
	 * TODO: add attrs: { __expanded: false } when
	 * - it is working with new collab (CEMS-1204)
	 * - synchrony is no longer used
	 *
	 *   (via confluence-frontend, "this feature" referencing allowInteractiveExpand)
	 *   `we can NEVER allow this feature to be enabled for the synchrony-powered editor
	 */ tr.wrap(canCollapse.range, [
        {
            type: expand
        }
    ]).setMeta('scrollIntoView', true);
    return tr;
};











const $bdb0299b531c40df$export$b75dc620676872cc = (node)=>{
    return !!node.type.spec.isolating;
};
const $bdb0299b531c40df$export$a21ded6c12f16fdf = (table)=>{
    const map = (0, $LmqWp.TableMap).get(table);
    // Get cell positions for first column.
    const cellPositions = map.cellsInRect({
        left: 0,
        top: 0,
        right: 1,
        bottom: map.height
    });
    for(let i = 0; i < cellPositions.length; i++)try {
        const cell = table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== table.type.schema.nodes.tableHeader) return false;
    } catch (e) {
        return false;
    }
    return true;
};
const $bdb0299b531c40df$export$86a810659e2d575 = (table)=>{
    const map = (0, $LmqWp.TableMap).get(table);
    for(let i = 0; i < map.width; i++){
        const cell = table.nodeAt(map.map[i]);
        if (cell && cell.type !== table.type.schema.nodes.tableHeader) return false;
    }
    return true;
};
const $bdb0299b531c40df$export$653b4f383b39a1d0 = (selection)=>$bdb0299b531c40df$var$filterNearSelection(selection, (0, $id9O1.findTable), $bdb0299b531c40df$export$a21ded6c12f16fdf, false);
const $bdb0299b531c40df$export$b8efdc0183f04d59 = (selection)=>$bdb0299b531c40df$var$filterNearSelection(selection, (0, $id9O1.findTable), $bdb0299b531c40df$export$86a810659e2d575, false);
const $bdb0299b531c40df$export$101f2696d8127fe0 = (selection)=>$bdb0299b531c40df$var$filterNearSelection(selection, (0, $id9O1.findTable), (table)=>!!table.attrs.isNumberColumnEnabled, false);
const $bdb0299b531c40df$export$4910020ffe58186f = (node)=>{
    return $bdb0299b531c40df$var$getTableWidths(node).reduce((acc, current)=>acc + current, 0);
};
const $bdb0299b531c40df$export$8f2a10e9b102ac33 = (currentTable, previousTable)=>{
    const currentTableWidths = $bdb0299b531c40df$var$getTableWidths(currentTable);
    const previousTableWidths = $bdb0299b531c40df$var$getTableWidths(previousTable);
    if (currentTableWidths.length !== previousTableWidths.length) return true;
    const sameWidths = currentTableWidths.every((value, index)=>{
        return value === previousTableWidths[index];
    });
    return sameWidths === false;
};
const $bdb0299b531c40df$export$bc84d95d2dfa63bf = (currentTable, previousTable)=>{
    const prevMap = (0, $LmqWp.TableMap).get(previousTable);
    const currentMap = (0, $LmqWp.TableMap).get(currentTable);
    return prevMap.width !== currentMap.width;
};
const $bdb0299b531c40df$export$8fe872ff9fc9b477 = (currentTable, previousTable)=>{
    const prevMap = (0, $LmqWp.TableMap).get(previousTable);
    const currentMap = (0, $LmqWp.TableMap).get(currentTable);
    return prevMap.height !== currentMap.height;
};
function $bdb0299b531c40df$var$filterNearSelection(selection, findNode, predicate, defaultValue) {
    const found = findNode(selection);
    if (!found) return defaultValue;
    return predicate(found.node, found.pos);
}
function $bdb0299b531c40df$var$getTableWidths(node) {
    if (!node.content.firstChild) return [];
    const tableWidths = [];
    node.content.firstChild.content.forEach((cell)=>{
        if (Array.isArray(cell.attrs.colwidth)) {
            const colspan = cell.attrs.colspan || 1;
            tableWidths.push(...cell.attrs.colwidth.slice(0, colspan));
        }
    });
    return tableWidths;
}
const $bdb0299b531c40df$export$d4302a800316ebd6 = (state, tablePos = 0)=>{
    const $tablePos = state.doc.resolve(tablePos);
    return $tablePos.depth > 0;
};
const $bdb0299b531c40df$export$e31912a493829c23 = (state, tablePos = 0)=>{
    return state.doc.resolve(tablePos).depth > 2;
};
const $bdb0299b531c40df$export$ffa7c963c6f2f204 = (state, tablePos)=>{
    const bodiedSyncBlock = state.schema.nodes.bodiedSyncBlock;
    if (!bodiedSyncBlock) return false;
    const $pos = state.doc.resolve(tablePos);
    for(let d = $pos.depth; d > 0; d--){
        if ($pos.node(d).type === bodiedSyncBlock) return true;
    }
    return false;
};
const $bdb0299b531c40df$var$anyChildCellMergedAcrossRow = (node)=>(0, $3Ter7.mapChildren)(node, (child)=>child.attrs.rowspan || 0).some((rowspan)=>rowspan > 1);
const $bdb0299b531c40df$export$4af45fdaadf67b18 = (node)=>{
    const allHeaders = (0, $3Ter7.mapChildren)(node, (child)=>child.type.name === 'tableHeader').every(Boolean);
    const someMerged = $bdb0299b531c40df$var$anyChildCellMergedAcrossRow(node);
    return allHeaders && !someMerged;
};


const $50cdb605d97c868c$var$nextTableSorting = (tr, table)=>{
    const tableSortStep = tr.steps.find((step)=>step instanceof (0, $cCTpf.TableSortStep));
    return tableSortStep && table && table.pos === tableSortStep.pos ? tableSortStep.next : undefined;
};
const $50cdb605d97c868c$var$nextResizeHandleColumnIndex = (tr, resizeHandleColumnIndex)=>{
    if (tr.getMeta((0, $452bdd9463f93418$export$18d4026d1ea86bb1))) return undefined;
    return resizeHandleColumnIndex;
};
const $50cdb605d97c868c$var$updateTargetCellPosition = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        if (!tableNode) return {
            ...pluginState,
            targetCellPosition: undefined
        };
        const { tableCell: tableCell, tableHeader: tableHeader } = tr.doc.type.schema.nodes;
        const cell = (0, $8m4tT.findParentNodeOfType)([
            tableCell,
            tableHeader
        ])(tr.selection);
        const targetCellPosition = cell ? cell.pos : undefined;
        if (pluginState.targetCellPosition === targetCellPosition) return pluginState;
        return {
            ...pluginState,
            targetCellPosition: targetCellPosition
        };
    };
const $50cdb605d97c868c$var$updateTableNodePluginState = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        if (!tableNode || (0, $5mxQU.isTextInput)(tr)) return pluginState;
        return {
            ...pluginState,
            ...(0, $780923e152cc8f13$export$af473ce758096273),
            tableNode: tableNode,
            ordering: $50cdb605d97c868c$var$nextTableSorting(tr, table),
            resizeHandleColumnIndex: $50cdb605d97c868c$var$nextResizeHandleColumnIndex(tr, pluginState.resizeHandleColumnIndex),
            isNumberColumnEnabled: (0, $bdb0299b531c40df$export$101f2696d8127fe0)(tr.selection),
            isHeaderColumnEnabled: (0, $bdb0299b531c40df$export$653b4f383b39a1d0)(tr.selection),
            isHeaderRowEnabled: (0, $bdb0299b531c40df$export$b8efdc0183f04d59)(tr.selection)
        };
    };
const $50cdb605d97c868c$var$updateCollapseHandler = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        const schema = tr.doc.type.schema;
        const allowCollapse = pluginState.pluginConfig.allowCollapse;
        const isExpandInSchema = schema.nodes.expand !== undefined;
        const isCollapseEnabled = allowCollapse && isExpandInSchema;
        /**
		 * If we don't have focus, or collapse isn't allowed, or a table node doesn't
		 * exist, we don't need to waste extra checks below
		 */ if (!pluginState.editorHasFocus || !isCollapseEnabled || !tableNode) return pluginState;
        const expandNodeType = schema.nodes.expand;
        const isTableCollapsed = expandNodeType && !!(0, $8m4tT.findParentNodeOfType)(expandNodeType)(tr.selection);
        const trCanBeCollapsed = (0, $8c756dab441d0bf4$export$34840b5e3787a37c)(tr).tableIsCollapsible;
        // We're focused on a table + we're not inside an expand
        const canCollapseTable = !!pluginState.tableNode && // is it already collapsed?
        !isTableCollapsed && !!trCanBeCollapsed;
        if (pluginState.isTableCollapsed !== isTableCollapsed || pluginState.canCollapseTable !== canCollapseTable) return {
            ...pluginState,
            isTableCollapsed: isTableCollapsed,
            canCollapseTable: canCollapseTable
        };
        return pluginState;
    };
const $50cdb605d97c868c$var$buildPluginState = (builders)=>(props)=>(pluginState)=>{
            if (!props.table) return pluginState.targetCellPosition ? {
                ...pluginState,
                targetCellPosition: undefined
            } : pluginState;
            return builders.reduce((_pluginState, transform)=>transform(props)(_pluginState), pluginState);
        };
const $50cdb605d97c868c$export$a9962e3214ca2ff7 = (tr, pluginState)=>$50cdb605d97c868c$var$buildPluginState([
        $50cdb605d97c868c$var$updateTargetCellPosition,
        $50cdb605d97c868c$var$updateTableNodePluginState,
        $50cdb605d97c868c$var$updateCollapseHandler
    ])({
        tr: tr,
        table: (0, $id9O1.findTable)(tr.selection)
    })(pluginState);




var $d19295ed9bb2f523$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'TOGGLE_HEADER_COLUMN':
            return {
                ...pluginState,
                isHeaderColumnEnabled: !pluginState.isHeaderColumnEnabled
            };
        case 'TOGGLE_HEADER_ROW':
            return {
                ...pluginState,
                isHeaderRowEnabled: !pluginState.isHeaderRowEnabled
            };
        case 'CLEAR_HOVER_SELECTION':
            return {
                ...pluginState,
                ...action.data,
                ...(0, $780923e152cc8f13$export$af473ce758096273)
            };
        case 'SELECT_COLUMN':
            return {
                ...pluginState,
                ...action.data,
                isContextualMenuOpen: false
            };
        case 'SET_TARGET_CELL_POSITION':
            return {
                ...pluginState,
                ...action.data,
                isContextualMenuOpen: false
            };
        case 'TOGGLE_CONTEXTUAL_MENU':
            return {
                ...pluginState,
                isContextualMenuOpen: !pluginState.isContextualMenuOpen
            };
        case 'SHOW_INSERT_ROW_BUTTON':
            if (action.data.insertRowButtonIndex === pluginState.insertRowButtonIndex) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                insertColumnButtonIndex: undefined
            };
        case 'SHOW_INSERT_COLUMN_BUTTON':
            if (action.data.insertColumnButtonIndex === pluginState.insertColumnButtonIndex) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                insertRowButtonIndex: undefined
            };
        case 'HIDE_INSERT_COLUMN_OR_ROW_BUTTON':
            if (pluginState.insertRowButtonIndex !== undefined || pluginState.insertColumnButtonIndex !== undefined) return {
                ...pluginState,
                insertRowButtonIndex: undefined,
                insertColumnButtonIndex: undefined
            };
            return pluginState;
        case 'HIDE_RESIZE_HANDLE_LINE':
            return {
                ...pluginState,
                ...action.data,
                resizeHandleColumnIndex: undefined,
                resizeHandleRowIndex: undefined
            };
        case 'START_KEYBOARD_COLUMN_RESIZE':
        case 'ADD_RESIZE_HANDLE_DECORATIONS':
            if (action.data.resizeHandleColumnIndex === pluginState.resizeHandleColumnIndex && action.data.resizeHandleRowIndex === pluginState.resizeHandleRowIndex && action.data.resizeHandleIncludeTooltip === pluginState.resizeHandleIncludeTooltip && action.data.isKeyboardResize === pluginState.isKeyboardResize) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                isResizeHandleWidgetAdded: true
            };
        case 'UPDATE_RESIZE_HANDLE_DECORATIONS':
            const { resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleRowIndex: resizeHandleRowIndex, resizeHandleIncludeTooltip: resizeHandleIncludeTooltip } = action.data;
            if ((resizeHandleColumnIndex === pluginState.resizeHandleColumnIndex || !Number.isFinite(resizeHandleColumnIndex)) && (resizeHandleRowIndex === pluginState.resizeHandleRowIndex || !Number.isFinite(resizeHandleRowIndex)) && (resizeHandleIncludeTooltip === pluginState.resizeHandleIncludeTooltip || resizeHandleIncludeTooltip === undefined)) return pluginState;
            return {
                ...pluginState,
                resizeHandleColumnIndex: resizeHandleColumnIndex ?? pluginState.resizeHandleColumnIndex,
                resizeHandleRowIndex: resizeHandleRowIndex ?? pluginState.resizeHandleRowIndex,
                resizeHandleIncludeTooltip: resizeHandleIncludeTooltip ?? pluginState.resizeHandleIncludeTooltip
            };
        case 'STOP_KEYBOARD_COLUMN_RESIZE':
        case 'REMOVE_RESIZE_HANDLE_DECORATIONS':
            if (!pluginState.isResizeHandleWidgetAdded) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                resizeHandleColumnIndex: undefined,
                resizeHandleRowIndex: undefined,
                isResizeHandleWidgetAdded: false,
                isKeyboardResize: undefined
            };
        case 'UPDATE_TABLE_WIDTH_TO_WIDEST':
        case 'SET_TABLE_REF':
        case 'HOVER_ROWS':
        case 'HOVER_COLUMNS':
        case 'HOVER_TABLE':
        case 'TABLE_HOVERED':
        case 'HOVER_MERGED_CELLS':
        case 'HOVER_CELL':
        case 'SHOW_RESIZE_HANDLE_LINE':
        case 'SET_EDITOR_FOCUS':
        case 'SET_CELL_MENU_OPEN':
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
};


const $69d6e2a2c784f306$var$dest = (0, $lkJUe.pluginFactory)((0, $fedf15e5199146e8$export$18d4026d1ea86bb1), (0, $d19295ed9bb2f523$export$2e2bcd8739ae039), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let updatedTargetCell = {};
            if (pluginState.targetCellPosition) {
                const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.targetCellPosition);
                updatedTargetCell = {
                    targetCellPosition: deleted ? undefined : pos
                };
            }
            let updatedTablePos = {};
            if (pluginState.tablePos) {
                const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.tablePos, -1);
                updatedTablePos = {
                    tablePos: deleted ? undefined : pos
                };
            }
            return {
                ...pluginState,
                ...updatedTargetCell,
                ...updatedTablePos
            };
        }
        return pluginState;
    },
    onDocChanged: (0, $50cdb605d97c868c$export$a9962e3214ca2ff7),
    onSelectionChanged: (0, $50cdb605d97c868c$export$a9962e3214ca2ff7)
});
const $69d6e2a2c784f306$export$656c7661095efe2e = $69d6e2a2c784f306$var$dest.createPluginState;
const $69d6e2a2c784f306$export$8d4021544bdece00 = $69d6e2a2c784f306$var$dest.createCommand;
const $69d6e2a2c784f306$export$f05434c51e3762e = $69d6e2a2c784f306$var$dest.getPluginState;

















const $04bc37fa10be064a$export$d486eb5767febcd9 = (unit)=>unit ? parseInt(unit, 10) : 0;


function $d5d08c4fa562e06d$export$698d25a635a3873a(elem, container, colWidths = [], canvas = document.createElement('canvas')) {
    return $d5d08c4fa562e06d$var$calcContentWidth(elem, container || elem, canvas, colWidths);
}
function $d5d08c4fa562e06d$var$calcContentWidth(elem, container, canvas, colWidths) {
    const flowWidths = [];
    let curWidth = 0;
    for(let i = 0; i < elem.childNodes.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const child = elem.childNodes[i];
        if (child.nodeType === Node.COMMENT_NODE) continue;
        if (child.nodeType === Node.TEXT_NODE) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const parent = child.parentNode;
            const parentStyle = getComputedStyle(parent);
            let contentLength = 0;
            if (parent.nodeName === 'CODE' || parent.nodeName === 'PRE') contentLength = $d5d08c4fa562e06d$var$handlePreText(canvas, parent, child.textContent, parentStyle.font);
            else contentLength = $d5d08c4fa562e06d$var$measureText(canvas, child.textContent, parentStyle.font);
            const left = parent.offsetLeft - container.offsetLeft;
            flowWidths.push(curWidth);
            curWidth += contentLength + left;
            // If the text isn't meant to wrap, we should set that as a hard limit.
            if (parentStyle.whiteSpace === 'nowrap') // + 3 is for date offset plus cursor
            // TODO: ED-26961 - There should be a programmatic way to get this.
            colWidths.push(parent.offsetWidth + 3);
        } else {
            // TODO: ED-26961 - doesn't quite work right with spacing
            const style = getComputedStyle(child);
            if (style.minWidth && style.minWidth.endsWith('px') && style.minWidth !== '0px') colWidths.push((0, $04bc37fa10be064a$export$d486eb5767febcd9)(style.minWidth));
            const { width: width } = $d5d08c4fa562e06d$export$698d25a635a3873a(child, container, colWidths, canvas);
            if (style.display && style.display.indexOf('inline') > -1) // is inline element, add to curWidth
            curWidth += width;
            else {
                // block element, reset curWidth
                flowWidths.push(curWidth);
                curWidth = width;
            }
        }
    }
    flowWidths.push(curWidth);
    return {
        minWidth: colWidths.reduce((oldMax, width)=>Math.max(width, oldMax), 0),
        width: flowWidths.reduce((oldMax, width)=>Math.max(width, oldMax), 0)
    };
}
function $d5d08c4fa562e06d$var$measureText(canvas, text, font) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return 0;
    if (font) ctx.font = font;
    return Math.round(ctx.measureText(text || '').width);
}
function $d5d08c4fa562e06d$var$handlePreText(canvas, node, textContent, font) {
    let parent = node;
    if (node.nodeName === 'CODE') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @atlaskit/editor/no-as-casting
    parent = node.parentNode;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const computedStyle = getComputedStyle(parent);
    if (textContent && computedStyle.whiteSpace === 'pre') // If white space is pre grab the longest line in the block.
    return textContent.split('\n').reduce((acc, current)=>Math.max($d5d08c4fa562e06d$var$measureText(canvas, current, font), acc), 0);
    return $d5d08c4fa562e06d$var$measureText(canvas, textContent, font);
}



const $52c8652e4f6c617c$export$5c09bfb77c404ce = (cells, index, minWidth)=>{
    const width = $52c8652e4f6c617c$export$8c54458430be6d1d(cells, $52c8652e4f6c617c$var$calculateColumnWidthCallback);
    const minColumnWidth = width < minWidth ? (0, $1zav4.tableNewColumnMinWidth) : $52c8652e4f6c617c$export$8c54458430be6d1d(cells, $52c8652e4f6c617c$var$calculateColumnMinWidthCallback(minWidth));
    return {
        index: index,
        width: width < minWidth ? (0, $1zav4.tableNewColumnMinWidth) : width,
        minWidth: minColumnWidth
    };
};
const $52c8652e4f6c617c$export$529a1befd331574 = (state)=>{
    return Math.max(state.width - state.minWidth, 0);
};
const $52c8652e4f6c617c$export$43e8ce817a8e5c42 = (columnIndex, table, tableStart, domAtPos)=>{
    const map = (0, $LmqWp.TableMap).get(table);
    const cellsPositions = map.cellsInRect({
        left: columnIndex,
        right: columnIndex + 1,
        top: 0,
        bottom: map.height
    });
    const cells = [];
    cellsPositions.forEach((pos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const col = (0, $8m4tT.findDomRefAtPos)(pos + tableStart, domAtPos);
        if (col) cells.push(col);
    });
    return cells;
};
const $52c8652e4f6c617c$export$8c54458430be6d1d = (cells, calculateColumnWidthCb)=>{
    let maxColWidth = 0;
    let colSpanWidth = 0;
    cells.forEach((cellRef)=>{
        const css = getComputedStyle(cellRef);
        const colspan = Number(cellRef.getAttribute('colspan') || 1);
        if (colspan > 1) {
            colSpanWidth = calculateColumnWidthCb(css, cellRef, colspan);
            return;
        }
        if (css) {
            const colWidth = calculateColumnWidthCb(css, cellRef, colspan);
            maxColWidth = Math.max(colWidth, maxColWidth);
        }
    });
    return maxColWidth || colSpanWidth;
};
const $52c8652e4f6c617c$export$8a19622c99267fdf = (amount, css)=>amount + (0, $04bc37fa10be064a$export$d486eb5767febcd9)(css.paddingLeft) + (0, $04bc37fa10be064a$export$d486eb5767febcd9)(css.paddingRight);
function $52c8652e4f6c617c$var$calculateColumnWidthCallback(css) {
    return (0, $04bc37fa10be064a$export$d486eb5767febcd9)(css.width);
}
function $52c8652e4f6c617c$var$calculateColumnMinWidthCallback(minColumnWidth) {
    return (css, cellRef, colSpan)=>{
        if (colSpan && colSpan > 1) return (0, $04bc37fa10be064a$export$d486eb5767febcd9)(css.width);
        const { minWidth: minContentWidth } = (0, $d5d08c4fa562e06d$export$698d25a635a3873a)(cellRef, cellRef);
        // Override the min width, if there is content that can't collapse
        // Past a certain width.
        return Math.max($52c8652e4f6c617c$export$8a19622c99267fdf(minContentWidth, css), minContentWidth, minColumnWidth);
    };
}





const $994471c61aed7ad3$var$validateTableCellNodeAttrs = ({ colspan: colspan, rowspan: rowspan, tableLocalId: tableLocalId }, reportInvalidTableCellSpanAttrs)=>{
    if (colspan && colspan < 0) reportInvalidTableCellSpanAttrs({
        nodeType: 'tableCell',
        attribute: 'colspan',
        reason: 'negative value',
        tableLocalId: tableLocalId,
        spanValue: colspan
    });
    if (rowspan && rowspan < 0) reportInvalidTableCellSpanAttrs({
        nodeType: 'tableCell',
        attribute: 'rowspan',
        reason: 'negative value',
        tableLocalId: tableLocalId,
        spanValue: rowspan
    });
    return;
};
const $994471c61aed7ad3$export$2867dc958552ea31 = (node, basePos, tr, reportInvalidTableCellSpanAttrs)=>{
    let hasProblems = false;
    tr = (0, $710fa7224ef1174e$export$ce28ec4a9ddaeb6d)(tr, node, basePos, (cell)=>{
        const { colwidth: colwidth, colspan: colspan, rowspan: rowspan } = cell.attrs;
        if (reportInvalidTableCellSpanAttrs) $994471c61aed7ad3$var$validateTableCellNodeAttrs({
            colspan: colspan,
            rowspan: rowspan,
            tableLocalId: node.attrs.localId
        }, reportInvalidTableCellSpanAttrs);
        if (colwidth && colwidth.length > colspan) {
            hasProblems = true;
            return cell.type.createChecked({
                ...cell.attrs,
                colwidth: colwidth.slice(0, colspan)
            }, cell.content, cell.marks);
        }
        return cell;
    });
    if (hasProblems) return true;
    return false;
};
const $994471c61aed7ad3$export$d6d48849d9121a1 = (tr, reportInvalidTableCellSpanAttrs)=>{
    let hasProblems = false;
    tr.doc.descendants((node, pos)=>{
        if (node.type.name === 'table') // in the unlikely event of having to fix multiple tables at the same time
        hasProblems = $994471c61aed7ad3$export$2867dc958552ea31(node, tr.mapping.map(pos), tr, reportInvalidTableCellSpanAttrs);
    });
    if (hasProblems) return tr;
};
const $994471c61aed7ad3$export$8d491ebb055c561d = (view, tableNode, tableRef, tablePos, opts)=>{
    let { tr: tr } = view.state;
    const domAtPos = view.domAtPos.bind(view);
    const tableStart = tablePos + 1;
    const colWidths = $994471c61aed7ad3$var$parseDOMColumnWidths(domAtPos, tableNode, tableStart, tableRef);
    const totalContentWidth = colWidths.reduce((acc, current)=>acc + current, 0);
    const tableLayout = $994471c61aed7ad3$var$getLayoutBasedOnWidth(totalContentWidth);
    const maxLayoutSize = (0, $b61fc0745b235461$export$7bde9ac1d5d663fc)(tableLayout, opts.containerWidth, {});
    // Content width will generally not meet the constraints of the layout
    // whether it be below or above, so we scale our columns widths
    // to meet these requirements
    let scale = 1;
    if (totalContentWidth !== maxLayoutSize) scale = maxLayoutSize / totalContentWidth;
    const scaledColumnWidths = colWidths.map((width)=>Math.floor(width * scale));
    tr = (0, $710fa7224ef1174e$export$ce28ec4a9ddaeb6d)(tr, tableNode, tablePos, (cell, _rowIndex, colIndex)=>{
        const newColWidths = scaledColumnWidths.slice(colIndex, colIndex + cell.attrs.colspan);
        return cell.type.createChecked({
            ...cell.attrs,
            colwidth: newColWidths.length ? newColWidths : null
        }, cell.content, cell.marks);
    });
    // clear autosizing on the table node
    return tr.setNodeMarkup(tablePos, undefined, {
        ...tableNode.attrs,
        layout: tableLayout,
        __autoSize: false
    }).setMeta('addToHistory', false);
};
const $994471c61aed7ad3$var$getLayoutBasedOnWidth = (totalWidth)=>{
    if (totalWidth > (0, $aFUXX.akEditorWideLayoutWidth)) return 'full-width';
    else if (totalWidth > (0, $aFUXX.akEditorDefaultLayoutWidth) && totalWidth < (0, $aFUXX.akEditorWideLayoutWidth)) return 'wide';
    else return 'default';
};
function $994471c61aed7ad3$var$parseDOMColumnWidths(domAtPos, tableNode, tableStart, tableRef) {
    const row = tableRef.querySelector('tr');
    if (!row) return [];
    const cols = [];
    for(let col = 0; col < row.childElementCount; col++){
        const currentCol = row.children[col];
        const colspan = Number(currentCol.getAttribute('colspan') || 1);
        for(let span = 0; span < colspan; span++){
            const colIdx = col + span;
            const cells = (0, $52c8652e4f6c617c$export$43e8ce817a8e5c42)(colIdx, tableNode, tableStart, domAtPos);
            const colWidth = (0, $52c8652e4f6c617c$export$8c54458430be6d1d)(cells, (_, col)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                return (0, $d5d08c4fa562e06d$export$698d25a635a3873a)(col, tableRef).width;
            });
            cols[colIdx] = Math.max(colWidth, (0, $1zav4.tableCellMinWidth));
        }
    }
    return cols;
}






const $8f7786e61047e565$export$884c674a282996e7 = (state, decorations, key)=>(0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(state.doc, (0, $de8398c45f744acc$export$968abecb43309c32)(state), decorations, key);


const $4ca83755c936c9c8$var$DARK_MODE_CELL_COLOR = '#1f1f21';
const $4ca83755c936c9c8$var$DARK_MODE_HEADER_COLOR = '#303134';
const $4ca83755c936c9c8$export$f516ed9c5f43abfc = (editorHasFocus)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)({
        type: 'SET_EDITOR_FOCUS',
        data: {
            editorHasFocus: editorHasFocus
        }
    });
const $4ca83755c936c9c8$export$79b661cbf50c3490 = (ref)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const tableRef = ref;
        const foundTable = (0, $id9O1.findTable)(state.selection);
        const tableNode = ref && foundTable ? foundTable.node : undefined;
        const tablePos = ref && foundTable ? foundTable.pos : undefined;
        const tableWrapperTarget = (0, $4vlwG.closestElement)(tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`) || undefined;
        return {
            type: 'SET_TABLE_REF',
            data: {
                tableRef: tableRef,
                tableNode: tableNode,
                tablePos: tablePos,
                tableWrapperTarget: tableWrapperTarget,
                isNumberColumnEnabled: (0, $bdb0299b531c40df$export$101f2696d8127fe0)(state.selection),
                isHeaderRowEnabled: (0, $bdb0299b531c40df$export$b8efdc0183f04d59)(state.selection),
                isHeaderColumnEnabled: (0, $bdb0299b531c40df$export$653b4f383b39a1d0)(state.selection),
                resizeHandleRowIndex: undefined,
                resizeHandleColumnIndex: undefined
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$c8d277469ceb354b = (name, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
value)=>(state, dispatch)=>{
        const { tr: tr, selection: selection } = state;
        if (selection instanceof (0, $7XFGZ.CellSelection)) {
            let updated = false;
            selection.forEachCell((cell, pos)=>{
                if (cell.attrs[name] !== value) {
                    tr.setNodeMarkup(pos, cell.type, {
                        ...cell.attrs,
                        [name]: value
                    });
                    updated = true;
                }
            });
            if (updated) {
                if (dispatch) dispatch(tr);
                return true;
            }
        } else {
            const cell = (0, $bzgWU.selectionCell)(state.selection);
            if (cell) {
                if (dispatch) dispatch(tr.setNodeMarkup(cell.pos, cell.nodeAfter?.type, {
                    ...cell.nodeAfter?.attrs,
                    [name]: value
                }));
                return true;
            }
        }
        return false;
    };
const $4ca83755c936c9c8$export$7f2d94cd70b8a5ce = (command)=>(state, dispatch, view)=>{
        const { selection: selection, schema: { nodes: { tableHeader: tableHeader } } } = state;
        if (selection instanceof (0, $ks2lK.TextSelection)) {
            const cell = (0, $id9O1.findCellClosestToPos)(selection.$from);
            if (cell && cell.node.type !== tableHeader) return command(state, dispatch, view);
        }
        if (selection instanceof (0, $7XFGZ.CellSelection)) {
            const rect = (0, $iP1et.getSelectionRect)(selection);
            if (!(0, $bdb0299b531c40df$export$b8efdc0183f04d59)(selection) || rect && rect.top > 0) return command(state, dispatch, view);
        }
        return false;
    };
const $4ca83755c936c9c8$export$f4e57bcfd514085d = (slice, schema)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $3Ter7.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            const cellAttrs = {
                ...maybeCell.attrs
            };
            cellAttrs.background = undefined;
            return maybeCell.type.createChecked(cellAttrs, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $4ca83755c936c9c8$export$80a571fa7de8754d = (slice, schema)=>{
    // the background attr in adf should always store the light mode value of the background color
    // and tables which have been created without a background color set will have background as undefined
    // in the undefined case, when pasting from renderer, we get a background color which is the dark mode color
    // we need to convert it back to undefined, otherwise it will be interpreted as a light mode value and be inverted
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $3Ter7.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            const cellAttrs = {
                ...maybeCell.attrs
            };
            if (maybeCell.type === tableCell && cellAttrs.background === $4ca83755c936c9c8$var$DARK_MODE_CELL_COLOR || maybeCell.type === tableHeader && cellAttrs.background === $4ca83755c936c9c8$var$DARK_MODE_HEADER_COLOR) cellAttrs.background = undefined;
            return maybeCell.type.createChecked(cellAttrs, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $4ca83755c936c9c8$export$bb3294affcb5059f = (slice, schema)=>{
    const { table: table, tableHeader: tableHeader, tableRow: tableRow } = schema.nodes;
    return (0, $3Ter7.mapSlice)(slice, (maybeTable)=>{
        if (maybeTable.type === table) {
            const firstRow = maybeTable.firstChild;
            if (firstRow) {
                const headerCols = [];
                firstRow.forEach((oldCol)=>{
                    headerCols.push(tableHeader.createChecked(oldCol.attrs, oldCol.content, oldCol.marks));
                });
                const headerRow = tableRow.createChecked(firstRow.attrs, headerCols, firstRow.marks);
                return maybeTable.copy(maybeTable.content.replaceChild(0, headerRow));
            }
        }
        return maybeTable;
    });
};
const $4ca83755c936c9c8$export$8fcd87e05a98248e = (slice, schema)=>{
    const { tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    return (0, $3Ter7.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            if (!maybeCell.attrs.colwidth) return maybeCell;
            return maybeCell.type.createChecked({
                ...maybeCell.attrs,
                colwidth: undefined
            }, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $4ca83755c936c9c8$export$6dfa233a4abfaf9 = (slice, schema, type)=>{
    const { tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    let count = 0;
    if (!type) return count;
    slice.content.descendants((maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            count += type === 'row' ? maybeCell.attrs.colspan : maybeCell.attrs.rowspan;
            return false;
        }
    });
    return count;
};
const $4ca83755c936c9c8$export$e5b37491e59cd9d = (selection)=>{
    if (selection instanceof (0, $7XFGZ.CellSelection)) return selection.isRowSelection() ? 'row' : selection.isColSelection() ? 'column' : undefined;
};
const $4ca83755c936c9c8$export$1798097ddb0b05de = (slice, state)=>{
    const { schema: { nodes: { tableRow: tableRow, table: table } } } = state;
    const currentTable = (0, $id9O1.findTable)(state.tr.selection);
    // check if copied slice is a table or table row
    if (!slice.content.firstChild || slice.content.firstChild.type !== table && slice.content.firstChild.type !== tableRow || !currentTable) return undefined;
    // if the slice only contains one table row, assume it's a row
    if (slice.content.childCount === 1 && slice.content.firstChild.type === tableRow) return 'row';
    // `TableMap.get` can throw if the content is invalid - in which case we should just
    // return undefined
    try {
        const map = (0, $LmqWp.TableMap).get(currentTable.node);
        const slicedMap = (0, $LmqWp.TableMap).get(slice.content.firstChild);
        return map.width === slicedMap.width ? 'row' : map.height === slicedMap.height ? 'column' : undefined;
    } catch  {
        return undefined;
    }
};
const $4ca83755c936c9c8$export$950c7c2913136ae5 = (selection, type)=>{
    const table = (0, $id9O1.findTable)(selection);
    if (!table || !type) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const map = (0, $LmqWp.TableMap).get(table.node);
    const cell = (0, $id9O1.findCellClosestToPos)(selection.$anchor);
    if (!cell) return false;
    const pos = cell.pos - table.pos - 1;
    // cell positions in table map always start at 1, as they're offsets not positions
    const index = map.map.findIndex((value)=>value === pos);
    return type === 'row' ? index % map.width === 0 : index < map.width;
};
const $4ca83755c936c9c8$export$4882f04e79ed0a80 = (state, dispatch)=>{
    if (dispatch) dispatch((0, $008a20f9f9e43ec0$export$5b4a0d6329b35552)(state.tr));
    return true;
};
const $4ca83755c936c9c8$export$a853c8f1dbe33b1f = (state, dispatch)=>{
    if ((0, $iYC9s.isTableSelected)(state.selection)) return $4ca83755c936c9c8$export$4882f04e79ed0a80(state, dispatch);
    return false;
};
const $4ca83755c936c9c8$export$a2b81d7877a7a370 = (schema)=>(tr)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const table = (0, $id9O1.findTable)(tr.selection);
        const map = (0, $LmqWp.TableMap).get(table.node);
        for(let i = 0; i < map.width; i++){
            const cell = table.node.child(0).child(i);
            tr.setNodeMarkup(table.start + map.map[i], schema.nodes.tableHeader, cell.attrs);
        }
        return tr;
    };
const $4ca83755c936c9c8$export$f49961c90342f4db = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    // if cursor is in the middle of a text node, do nothing
    if (!$cursor || $cursor.parentOffset > 0) return false;
    // find the node before the cursor
    let before;
    let cut;
    if (!(0, $bdb0299b531c40df$export$b75dc620676872cc)($cursor.parent)) for(let i = $cursor.depth - 1; !before && i >= 0; i--){
        if ($cursor.index(i) > 0) {
            cut = $cursor.before(i + 1);
            before = $cursor.node(i).child($cursor.index(i) - 1);
        }
        if ((0, $bdb0299b531c40df$export$b75dc620676872cc)($cursor.node(i))) break;
    }
    // if the node before is not a table node - do nothing
    if (!before || before.type !== state.schema.nodes.table) return false;
    /*
    ensure we're just at a top level paragraph
    otherwise, perform regular backspace behaviour
   */ const grandparent = $cursor.node($cursor.depth - 1);
    if ($cursor.parent.type !== state.schema.nodes.paragraph || grandparent && grandparent.type !== state.schema.nodes.doc) return false;
    const { tr: tr } = state;
    const lastCellPos = (cut || 0) - 4;
    // need to move cursor inside the table to be able to calculate table's offset
    tr.setSelection(new (0, $ks2lK.TextSelection)(state.doc.resolve(lastCellPos)));
    const { $from: $from } = tr.selection;
    const start = $from.start(-1);
    const pos = start + $from.parent.nodeSize - 1;
    // move cursor to the last cell
    // it doesn't join node before (last cell) with node after (content after the cursor)
    // due to ridiculous amount of PM code that would have been required to overwrite
    tr.setSelection(new (0, $ks2lK.TextSelection)(state.doc.resolve(pos)));
    // if we are inside an empty paragraph not at the end of the doc we delete it
    const cursorNode = $cursor.node();
    const docEnd = state.doc.content.size;
    const paragraphWrapStart = $cursor.pos - 1;
    const paragraphWrapEnd = $cursor.pos + 1;
    if (cursorNode.content.size === 0 && $cursor.pos + 1 !== docEnd) tr.delete(paragraphWrapStart, paragraphWrapEnd);
    if (dispatch) dispatch(tr);
    return true;
};
const $4ca83755c936c9c8$export$91116982335533cf = (attrs, editorView)=>(state, dispatch)=>{
        let cursorPos;
        let { tr: tr } = state;
        const { targetCellPosition: targetCellPosition } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if ((0, $BW42l.isSelectionType)(tr.selection, 'cell')) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selection = tr.selection;
            selection.forEachCell((_cell, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                tr = (0, $e4d9ceb64529799d$export$aa21d3b96c1c378c)((0, $id9O1.findCellClosestToPos)($pos), attrs)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (targetCellPosition) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $id9O1.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            tr = (0, $e4d9ceb64529799d$export$aa21d3b96c1c378c)(cell, attrs)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos !== undefined) {
            if (dispatch) {
                editorView?.focus();
                dispatch(tr);
            }
            return true;
        }
        return false;
    };
const $4ca83755c936c9c8$export$c2e8772deb1607ea = (column, expand, triggeredByKeyboard = false)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const cells = (0, $40458289442cabaf$export$c14b77638b178c5d)(column)(state.tr.selection);
        if (!cells || !cells.length || typeof cells[0].pos !== 'number') return false;
        const decorations = (0, $9283ce7d62ffd391$export$9bd7e7efc13bb839)((0, $kEbNW.selectColumn)(column, expand)(state.tr));
        const decorationSet = (0, $8f7786e61047e565$export$884c674a282996e7)(state, decorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_SELECTED);
        const targetCellPosition = cells[0].pos;
        return {
            type: 'SELECT_COLUMN',
            data: {
                targetCellPosition: targetCellPosition,
                decorationSet: decorationSet
            }
        };
    }, (tr)=>(0, $kEbNW.selectColumn)(column, expand)(tr).setMeta('addToHistory', false).setMeta('selectedColumnViaKeyboard', triggeredByKeyboard));
const $4ca83755c936c9c8$export$41a42e79fbe56d35 = (columnIndexes)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        if (!columnIndexes) return false;
        const cells = columnIndexes.map((column)=>(0, $40458289442cabaf$export$c14b77638b178c5d)(column)(state.tr.selection)).flat();
        if (!cells || !cells.length || cells.some((cell)=>cell && typeof cell.pos !== 'number')) return false;
        const decorations = (0, $9283ce7d62ffd391$export$9bd7e7efc13bb839)((0, $kEbNW.selectColumns)(columnIndexes)(state.tr));
        const decorationSet = (0, $8f7786e61047e565$export$884c674a282996e7)(state, decorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_SELECTED);
        const cellsInFirstColumn = (0, $40458289442cabaf$export$c14b77638b178c5d)(Math.min(...columnIndexes))(state.tr.selection);
        if (!cellsInFirstColumn || cellsInFirstColumn.length === 0) return false;
        const targetCellPosition = cellsInFirstColumn[0].pos;
        return {
            type: 'SELECT_COLUMN',
            data: {
                targetCellPosition: targetCellPosition,
                decorationSet: decorationSet
            }
        };
    }, (tr)=>{
        return (0, $kEbNW.selectColumns)(columnIndexes)(tr).setMeta('addToHistory', false);
    });
const $4ca83755c936c9c8$export$e247ed8cec4832f4 = (row, expand, triggeredByKeyboard = false)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        let targetCellPosition;
        const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(row)(state.tr.selection);
        if (cells && cells.length) targetCellPosition = cells[0].pos;
        return {
            type: 'SET_TARGET_CELL_POSITION',
            data: {
                targetCellPosition: targetCellPosition
            }
        };
    }, (tr)=>(0, $kEbNW.selectRow)(row, expand)(tr).setMeta('addToHistory', false).setMeta('selectedRowViaKeyboard', triggeredByKeyboard));
const $4ca83755c936c9c8$export$b5ba3b60192c7a8d = (rowIndexes)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        if (rowIndexes.length === 0) return false;
        const cells = rowIndexes.map((row)=>(0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(row)(state.tr.selection)).flat();
        if (!cells || !cells.length || cells.some((cell)=>cell && typeof cell.pos !== 'number')) return false;
        const cellsInFirstRow = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(Math.min(...rowIndexes))(state.tr.selection);
        if (!cellsInFirstRow || cellsInFirstRow.length === 0) return false;
        const targetCellPosition = cellsInFirstRow[0].pos;
        return {
            type: 'SET_TARGET_CELL_POSITION',
            data: {
                targetCellPosition: targetCellPosition
            }
        };
    }, (tr)=>(0, $kEbNW.selectRows)(rowIndexes)(tr).setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$72433e6f15f8aeaa = (columnIndex)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((_)=>columnIndex > -1 ? {
            type: 'SHOW_INSERT_COLUMN_BUTTON',
            data: {
                insertColumnButtonIndex: columnIndex
            }
        } : false, (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$6ed6a4eb343cf21 = (rowIndex)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((_)=>rowIndex > -1 ? {
            type: 'SHOW_INSERT_ROW_BUTTON',
            data: {
                insertRowButtonIndex: rowIndex
            }
        } : false, (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$27d9631a056c3f39 = ()=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)({
        type: 'HIDE_INSERT_COLUMN_OR_ROW_BUTTON'
    }, (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$cc6f44d67305c400 = (rowIndex, columnIndex, includeTooltip, nodeViewPortalProviderAPI, isKeyboardResize)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const tableNode = (0, $id9O1.findTable)(state.selection);
        const { pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if (!tableNode || !allowColumnResizing) return false;
        return {
            type: 'ADD_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $8d12b05d544e83c2$export$aa1fe977609f5606)(rowIndex, columnIndex, includeTooltip, getIntl, nodeViewPortalProviderAPI)({
                    tr: state.tr,
                    decorationSet: (0, $de8398c45f744acc$export$968abecb43309c32)(state)
                }),
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: includeTooltip,
                isKeyboardResize: isKeyboardResize || false
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$31eed8673ceee613 = (nodeViewPortalProviderAPI, rowIndex, columnIndex, includeTooltip)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const tableNode = (0, $id9O1.findTable)(state.selection);
        const { resizeHandleRowIndex: resizeHandleRowIndex, resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleIncludeTooltip: resizeHandleIncludeTooltip, pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if (!tableNode || !allowColumnResizing) return false;
        const resolvedRowIndex = rowIndex ?? resizeHandleRowIndex;
        const resolvedColumnIndex = columnIndex ?? resizeHandleColumnIndex;
        const resolvedIncludeTooltip = includeTooltip ?? resizeHandleIncludeTooltip;
        if (resolvedRowIndex === undefined || resolvedColumnIndex === undefined || resolvedIncludeTooltip === undefined) return false;
        return {
            type: 'UPDATE_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $8d12b05d544e83c2$export$aa1fe977609f5606)(resolvedRowIndex, resolvedColumnIndex, resolvedIncludeTooltip, getIntl, nodeViewPortalProviderAPI)({
                    tr: state.tr,
                    decorationSet: (0, $de8398c45f744acc$export$968abecb43309c32)(state)
                }),
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: includeTooltip
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$99c5230572e6696d = ()=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>({
            type: 'REMOVE_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $8d12b05d544e83c2$export$a590d16867e1babd)()({
                    tr: state.tr,
                    decorationSet: (0, $de8398c45f744acc$export$968abecb43309c32)(state)
                })
            }
        }), (tr)=>tr.setMeta('addToHistory', false));
const $4ca83755c936c9c8$export$d6e5d8afaa172954 = (view, node, table, basePos, opts)=>{
    if (typeof basePos !== 'number') return false;
    view.dispatch((0, $994471c61aed7ad3$export$8d491ebb055c561d)(view, node, table, basePos, opts));
    return true;
};
const $4ca83755c936c9c8$export$bf5ab08a5036bda8 = (tableCellHeader)=>(state, dispatch)=>{
        const { tr: tr } = state;
        if (// Avoid infinite loop when the current selection is not a TextSelection
        (0, $kTbzR.isTextSelection)(tr.selection) && tr.selection.$cursor && // When storedMark is null that means this is the initial state
        // if the user press to remove the mark storedMark will be an empty array
        // and we shouldn't apply the strong mark
        tr.storedMarks == null && // Check if the current node is a direct child from paragraph
        tr.selection.$from.depth === tableCellHeader.depth + 1 && // this logic is applied only for empty paragraph
        tableCellHeader.node.nodeSize === 4 && (0, $7iE7T.isParagraph)(tableCellHeader.node.firstChild, state.schema)) {
            const { strong: strong } = state.schema.marks;
            tr.setStoredMarks([
                strong?.create()
            ]).setMeta('addToHistory', false);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $4ca83755c936c9c8$export$833849b68219cbcc = (widthToWidest)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const { widthToWidest: prevWidthToWidest } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(widthToWidest, prevWidthToWidest)) return false;
        return {
            type: 'UPDATE_TABLE_WIDTH_TO_WIDEST',
            data: {
                widthToWidest: {
                    ...prevWidthToWidest,
                    ...widthToWidest
                }
            }
        };
    });
const $4ca83755c936c9c8$export$e0cd4746386d78b5 = (newAlignment, isCommentEditor)=>({ tr: tr })=>{
        const tableObject = (0, $id9O1.findTable)(tr.selection);
        if (!tableObject) return null;
        const nextTableAttrs = {
            ...tableObject.node.attrs,
            layout: newAlignment
        };
        // table uses old breakout values in layout attribute to determine width
        // but that information is lost when alignment changes, so we need to ensure we retain that info
        // If table width is not set in the Comment editor, it means that the table width is inherited from the editor and is "full width".
        // In that case when switching between alignment options in the Comment editor we should keep the table width unset.
        if (!tableObject.node.attrs.width && !isCommentEditor) {
            const tableWidth = (0, $6fQl1.getTableContainerWidth)(tableObject.node);
            nextTableAttrs.width = tableWidth;
        }
        tr.setNodeMarkup(tableObject.pos, undefined, nextTableAttrs).setMeta('scrollIntoView', false);
        return tr;
    };
const $4ca83755c936c9c8$export$2880e63de92f5116 = (newAlignment, tableNodeWithPos)=>({ tr: tr })=>{
        const table = tableNodeWithPos.node;
        const nextTableAttrs = {
            ...table.attrs,
            layout: newAlignment
        };
        // table uses old breakout values in layout attribute to determine width
        // but that information is lost when alignment changes, so we need to ensure we retain that info
        if (!table.attrs.width) {
            const tableWidth = (0, $6fQl1.getTableContainerWidth)(table);
            nextTableAttrs.width = tableWidth;
        }
        tr.setNodeMarkup(tableNodeWithPos.pos, undefined, nextTableAttrs).setMeta('scrollIntoView', false);
        return tr;
    };
const $4ca83755c936c9c8$export$a6e5155a1ac72366 = (isCellMenuOpenByKeyboard = true, originalTr)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)(()=>{
        return {
            type: 'SET_CELL_MENU_OPEN',
            data: {
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard
            }
        };
    }, (tr)=>(originalTr || tr).setMeta('addToHistory', false));


var $80e2e1780dfad522$export$4e6e4e454d4dbb37 = /*#__PURE__*/ function(AnalyticPluginTypes) {
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateOverflowTriggerNameAction"] = 0] = "UpdateOverflowTriggerNameAction";
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateRowOrColumnMovedAction"] = 1] = "UpdateRowOrColumnMovedAction";
    AnalyticPluginTypes[AnalyticPluginTypes["RemoveRowOrColumnMovedAction"] = 2] = "RemoveRowOrColumnMovedAction";
    AnalyticPluginTypes[AnalyticPluginTypes["RemoveOverFlowTriggerNameAction"] = 3] = "RemoveOverFlowTriggerNameAction";
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateRowOrColumnMovedAndOverflowTrigger"] = 4] = "UpdateRowOrColumnMovedAndOverflowTrigger";
    return AnalyticPluginTypes;
}({});








const $5aef720a18b9fb47$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableAnalyticPlugin');



const $352fa929b617731a$export$49d5fc8cba920a0 = {
    rowOrColumnMoved: {
        type: undefined,
        numberOfCells: undefined,
        currentActions: []
    }
};


const $569fa7ec33daa007$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $80e2e1780dfad522$export$4e6e4e454d4dbb37).UpdateRowOrColumnMovedAction:
            return {
                ...state,
                rowOrColumnMoved: {
                    ...state.rowOrColumnMoved,
                    ...action.data
                }
            };
        case (0, $80e2e1780dfad522$export$4e6e4e454d4dbb37).RemoveRowOrColumnMovedAction:
            return {
                ...state,
                rowOrColumnMoved: (0, $352fa929b617731a$export$49d5fc8cba920a0).rowOrColumnMoved
            };
        default:
            return state;
    }
};


const $feb9fc552ec5b9d2$var$dest = (0, $lkJUe.pluginFactory)((0, $5aef720a18b9fb47$export$18d4026d1ea86bb1), (0, $569fa7ec33daa007$export$1650419e431d3ba3));
const $feb9fc552ec5b9d2$export$656c7661095efe2e = $feb9fc552ec5b9d2$var$dest.createPluginState;
const $feb9fc552ec5b9d2$export$8d4021544bdece00 = $feb9fc552ec5b9d2$var$dest.createCommand;
const $feb9fc552ec5b9d2$export$f05434c51e3762e = $feb9fc552ec5b9d2$var$dest.getPluginState;




const $e0bf7ec1b6ce132f$var$getNextActionType = (nextState, nextAction, prevState)=>{
    if (nextAction === 'pasted') {
        if (prevState && prevState.currentActions.includes('copyOrCut') && prevState.currentActions.includes('addRowOrColumn') && prevState.numberOfCells === nextState.numberOfCells && prevState.type === nextState.type) return 'pasted';
        return 'none';
    }
    return nextAction;
};
const $e0bf7ec1b6ce132f$export$245979e0371ee049 = (nextState, nextAction, prevState)=>{
    const nextActionType = $e0bf7ec1b6ce132f$var$getNextActionType(nextState, nextAction, prevState);
    if (nextActionType === 'none') return (0, $352fa929b617731a$export$49d5fc8cba920a0).rowOrColumnMoved;
    // a new workflow has started in the opposite axis (e.g. inserted a row, but copied a column) remove old state
    if (prevState.type !== nextState.type) return {
        currentActions: [
            nextActionType
        ],
        numberOfCells: nextState?.numberOfCells,
        type: nextState.type
    };
    return {
        currentActions: prevState.currentActions.includes(nextActionType) ? prevState.currentActions : [
            ...prevState.currentActions,
            nextActionType
        ],
        numberOfCells: nextState?.numberOfCells || prevState.numberOfCells,
        type: nextState?.type
    };
};


const $b6ae840bbb0dbfb0$export$7edd58207362eb7c = (nextState, nextAction)=>(0, $feb9fc552ec5b9d2$export$8d4021544bdece00)((state)=>{
        const { rowOrColumnMoved: rowOrColumnMoved } = (0, $feb9fc552ec5b9d2$export$f05434c51e3762e)(state);
        const data = (0, $e0bf7ec1b6ce132f$export$245979e0371ee049)(nextState, nextAction, rowOrColumnMoved);
        return {
            type: (0, $80e2e1780dfad522$export$4e6e4e454d4dbb37).UpdateRowOrColumnMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $b6ae840bbb0dbfb0$export$39ebe85f9f5fbe7e = ()=>(tr)=>{
        const payload = {
            type: (0, $80e2e1780dfad522$export$4e6e4e454d4dbb37).RemoveRowOrColumnMovedAction
        };
        return tr.setMeta((0, $5aef720a18b9fb47$export$18d4026d1ea86bb1), payload);
    };
const $b6ae840bbb0dbfb0$export$800a77929fdae774 = (nextState, nextAction)=>(state, tr)=>{
        const { rowOrColumnMoved: rowOrColumnMoved } = (0, $feb9fc552ec5b9d2$export$f05434c51e3762e)(state);
        const data = (0, $e0bf7ec1b6ce132f$export$245979e0371ee049)(nextState, nextAction, rowOrColumnMoved);
        const payload = {
            type: (0, $80e2e1780dfad522$export$4e6e4e454d4dbb37).UpdateRowOrColumnMovedAction,
            data: data
        };
        return tr.setMeta((0, $5aef720a18b9fb47$export$18d4026d1ea86bb1), payload);
    };





const $5ee9558e2724a8ab$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent)=>new (0, $1S4f7.SafePlugin)({
        key: (0, $5aef720a18b9fb47$export$18d4026d1ea86bb1),
        state: (0, $feb9fc552ec5b9d2$export$656c7661095efe2e)(dispatch, (0, $352fa929b617731a$export$49d5fc8cba920a0)),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta((0, $5aef720a18b9fb47$export$18d4026d1ea86bb1))?.data?.currentActions?.includes('pasted'));
            if (tr) {
                const newTr = newState.tr;
                dispatchAnalyticsEvent({
                    action: (0, $3824I.TABLE_ACTION).ROW_OR_COLUMN_MOVED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        type: tr.getMeta((0, $5aef720a18b9fb47$export$18d4026d1ea86bb1))?.data?.type
                    }
                });
                return (0, $b6ae840bbb0dbfb0$export$39ebe85f9f5fbe7e)()(newTr);
            }
            return undefined;
        },
        props: {
            handlePaste: ({ state: state, dispatch: dispatch }, event, slice)=>{
                const { schema: schema } = state;
                const type = (0, $4ca83755c936c9c8$export$1798097ddb0b05de)(slice, state);
                // if the selection wasn't in the first cell of a row or column, don't count it
                if (!type || !(0, $4ca83755c936c9c8$export$950c7c2913136ae5)(state.selection, type)) return;
                const count = (0, $4ca83755c936c9c8$export$6dfa233a4abfaf9)(slice, schema, type);
                (0, $b6ae840bbb0dbfb0$export$7edd58207362eb7c)({
                    numberOfCells: count,
                    type: type
                }, 'pasted')(state, dispatch);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                const { schema: schema } = state;
                const type = (0, $4ca83755c936c9c8$export$e5b37491e59cd9d)(state.selection);
                const count = (0, $4ca83755c936c9c8$export$6dfa233a4abfaf9)(slice, schema, type);
                (0, $b6ae840bbb0dbfb0$export$7edd58207362eb7c)({
                    numberOfCells: count,
                    type: type
                }, 'copyOrCut')(state, dispatch);
                return slice;
            }
        }
    });


// #region Imports

var $1rJN9 = parcelRequire("1rJN9");






















var $9b9Mr = parcelRequire("9b9Mr");







const $8fbf19abc35dbd28$export$93d48be6ee61745 = (columnIndex)=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (table) {
            const map = (0, $LmqWp.TableMap).get(table.node);
            if (columnIndex >= 0 && columnIndex <= map.width) return (0, $8usfh.cloneTr)((0, $9b9Mr.addColumn)(tr, {
                map: map,
                tableStart: table.start,
                table: table.node
            }, columnIndex));
        }
        return tr;
    };








var $9MzzS = parcelRequire("9MzzS");












const $da196c89e6ffa52b$var$filterCellsInRow = (rowIndex, predicate)=>(tr)=>{
        const foundCells = [];
        const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(rowIndex)(tr.selection);
        if (cells) {
            for(let j = cells.length - 1; j >= 0; j--)if (predicate(cells[j], tr)) foundCells.push(cells[j]);
        }
        return foundCells;
    };
const $da196c89e6ffa52b$export$46bec710cf196d80 = (rowIndex)=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (table) {
            const map = (0, $LmqWp.TableMap).get(table.node);
            if (rowIndex >= 0 && rowIndex <= map.height) {
                const tableNode = table.node;
                const tableNodes = (0, $d1kIV.tableNodeTypes)(tableNode.type.schema);
                let rowPos = table.start;
                for(let i = 0; i < rowIndex + 1; i++)rowPos += tableNode.child(i).nodeSize;
                const cloneRow = tableNode.child(rowIndex);
                // Re-create the same nodes with same attrs, dropping the node content.
                const cells = [];
                let rowWidth = 0;
                cloneRow.forEach((cell)=>{
                    // If we're copying a row with rowspan somewhere, we dont want to copy that cell
                    // We'll increment its span below.
                    if (cell.attrs.rowspan === 1) {
                        rowWidth += cell.attrs.colspan;
                        const node = tableNodes[cell.type.spec.tableRole].createAndFill(cell.attrs, [], cell.marks);
                        if (node) cells.push(node);
                    }
                });
                // If a higher row spans past our clone row, bump the higher row to cover this new row too.
                if (rowWidth < map.width) {
                    const rowSpanCells = [];
                    for(let i = rowIndex; i >= 0; i--){
                        const foundCells = $da196c89e6ffa52b$var$filterCellsInRow(i, (cell, _tr)=>{
                            const rowspan = cell.node.attrs.rowspan;
                            const spanRange = i + rowspan;
                            return rowspan > 1 && spanRange > rowIndex;
                        })(tr);
                        rowSpanCells.push(...foundCells);
                    }
                    if (rowSpanCells.length) rowSpanCells.forEach((cell)=>{
                        tr = (0, $e4d9ceb64529799d$export$aa21d3b96c1c378c)(cell, {
                            rowspan: cell.node.attrs.rowspan + 1
                        })(tr);
                    });
                }
                return (0, $8m4tT.safeInsert)(tableNodes.row.create(cloneRow.attrs, cells), rowPos)(tr);
            }
        }
        return tr;
    };
const $da196c89e6ffa52b$export$643f25d380b0167d = (rowIndex, clonePreviousRow)=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (table) {
            const map = (0, $LmqWp.TableMap).get(table.node);
            const cloneRowIndex = rowIndex - 1;
            if (clonePreviousRow && cloneRowIndex >= 0) return (0, $8usfh.cloneTr)($da196c89e6ffa52b$export$46bec710cf196d80(cloneRowIndex)(tr));
            if (rowIndex >= 0 && rowIndex <= map.height) return (0, $8usfh.cloneTr)((0, $9MzzS.addRow)(tr, {
                map: map,
                tableStart: table.start,
                table: table.node
            }, rowIndex));
        }
        return tr;
    };




var $2QyFu = parcelRequire("2QyFu");


/**
 * A plugin is created for collecting payload data for tableOverflowChanged analytics event
 */ 










const $92e1eed7d2f10a77$var$pluginKey = new (0, $ks2lK.PluginKey)('tableOverflowAnalyticsPlugin');
const $92e1eed7d2f10a77$export$210bf30466b5bcc8 = {
    OVERFLOW_TRIGGER: 'tableOverflowTrigger',
    OVERFLOW_STATE_CHANGED: 'tableOverflowStateChanged'
};
const $92e1eed7d2f10a77$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, tableResizingEnabled)=>new (0, $1S4f7.SafePlugin)({
        key: $92e1eed7d2f10a77$var$pluginKey,
        state: {
            init () {
                return {
                    lastTrigger: undefined
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($92e1eed7d2f10a77$export$210bf30466b5bcc8.OVERFLOW_TRIGGER);
                const newState = {
                    ...pluginState
                };
                if (meta) {
                    newState.lastTrigger = {
                        ...meta
                    };
                    dispatch($92e1eed7d2f10a77$var$pluginKey, newState);
                    return newState;
                }
                return pluginState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            const newPluginState = $92e1eed7d2f10a77$var$pluginKey.getState(newState);
            let hasAnalyticsBeenDispatched = false;
            const lastTriggerName = newPluginState?.lastTrigger?.name || // NOTE: We assume that we know and can correctly differentiate
            // between all triggers of table overflow state change.
            // The only trigger we can't identify is viewport width change.
            // However, since there is still a chance that there are other triggers we didn't think of,
            // all these unknown triggers and viwport width change trigger are captured as EXTERNAL.
            (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).EXTERNAL;
            transactions.forEach((tr)=>{
                const payload = tr.getMeta($92e1eed7d2f10a77$export$210bf30466b5bcc8.OVERFLOW_STATE_CHANGED);
                if (payload) {
                    dispatchAnalyticsEvent({
                        action: (0, $3824I.TABLE_ACTION).OVERFLOW_CHANGED,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        eventType: (0, $d925B.EVENT_TYPE).TRACK,
                        attributes: {
                            editorWidth: payload.editorWidth,
                            parentWidth: payload.parentWidth,
                            isOverflowing: payload.isOverflowing,
                            wasOverflowing: payload.wasOverflowing,
                            width: payload.width,
                            tableResizingEnabled: tableResizingEnabled,
                            trigger: lastTriggerName
                        }
                    });
                    hasAnalyticsBeenDispatched = true;
                }
            });
            if (hasAnalyticsBeenDispatched) {
                const tr = newState.tr;
                return tr.setMeta($92e1eed7d2f10a77$export$210bf30466b5bcc8.OVERFLOW_TRIGGER, {});
            }
            return undefined;
        }
    });































var $lWghV = parcelRequire("lWghV");











function $d406f1b0c5d56902$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $id9O1.findTable)(selection);
    if (table) {
        map = (0, $LmqWp.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}
function $d406f1b0c5d56902$export$277d5394a2608229(selection) {
    let horizontalCells = 1;
    let verticalCells = 1;
    let totalCells = 1;
    const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = $d406f1b0c5d56902$export$d2cf64960b17e12e(selection);
    if (table && map) {
        const rect = (0, $iP1et.getSelectionRect)(selection);
        if (rect) {
            totalCells = map.cellsInRect(rect).length;
            horizontalCells = rect.right - rect.left;
            verticalCells = rect.bottom - rect.top;
        }
    }
    return {
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount,
        horizontalCells: horizontalCells,
        verticalCells: verticalCells,
        totalCells: totalCells
    };
}
const $d406f1b0c5d56902$export$c27221be174b6703 = (payload)=>(editorAnalyticsAPI)=>{
        return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                    const dynamicPayload = payload instanceof Function ? payload(state) : payload;
                    if (dynamicPayload) editorAnalyticsAPI?.attachAnalyticsEvent(dynamicPayload)(tr);
                    if (dispatch) dispatch(tr);
                    return true;
                }, view);
    };
const $d406f1b0c5d56902$export$a12b1eaff522a2d1 = (props)=>{
    const tableMap = (0, $LmqWp.TableMap).get(props.resizedNode);
    return {
        action: (0, $3824I.TABLE_ACTION).RESIZED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            newWidth: props.resizedNode.attrs.width,
            prevWidth: props.originalNode.attrs.width ?? null,
            nodeSize: props.resizedNode.nodeSize,
            totalTableWidth: (0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(props.resizedNode) ? (0, $bdb0299b531c40df$export$4910020ffe58186f)(props.resizedNode) : null,
            totalRowCount: tableMap.height,
            totalColumnCount: tableMap.width
        }
    };
};
const $d406f1b0c5d56902$export$52625746d6329c8a = (frameRateSamples)=>{
    if (frameRateSamples.length > 1) {
        const frameRateSum = frameRateSamples.reduce((sum, frameRate, index)=>{
            if (index === 0) return sum;
            else return sum + frameRate;
        }, 0);
        const averageFrameRate = Math.round(frameRateSum / (frameRateSamples.length - 1));
        return [
            frameRateSamples[0],
            averageFrameRate
        ];
    } else return frameRateSamples;
};
const $d406f1b0c5d56902$export$29574a7e6ffc8eb4 = (props)=>{
    const reducedResizeFrameRateSamples = $d406f1b0c5d56902$export$52625746d6329c8a(props.frameRateSamples);
    return reducedResizeFrameRateSamples.map((frameRateSample, index)=>({
            action: (0, $3824I.TABLE_ACTION).RESIZE_PERF_SAMPLING,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                frameRate: frameRateSample,
                nodeSize: props.originalNode.nodeSize,
                docSize: props.docSize,
                isInitialSample: index === 0
            }
        }));
};
const $d406f1b0c5d56902$export$9642a56c1e8805cc = (config = {})=>{
    const { maxSamples: maxSamples = 10, minFrames: minFrames = 5, minTimeMs: minTimeMs = 500, sampleRateMs: sampleRateMs = 1000, timeoutMs: timeoutMs = 200 } = config;
    const frameCount = (0, $42omo.useRef)(0);
    const lastTime = (0, $42omo.useRef)(0);
    const timeoutId = (0, $42omo.useRef)();
    const frameRateSamples = (0, $42omo.useRef)([]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (timeoutId.current) clearTimeout(timeoutId.current);
        };
    }, []);
    const startMeasure = ()=>{
        frameCount.current = 0;
        lastTime.current = performance.now();
    };
    /**
	 * Returns an array of frame rate samples as integers.
	 */ const endMeasure = ()=>{
        const samples = frameRateSamples.current;
        frameRateSamples.current = [];
        return samples;
    };
    const sampleFrameRate = (delay = 0)=>{
        const currentTime = performance.now();
        const deltaTime = currentTime - lastTime.current - delay;
        const isValidSample = deltaTime > minTimeMs && frameCount.current >= minFrames;
        if (isValidSample) {
            const frameRate = Math.round(frameCount.current / (deltaTime / 1000));
            frameRateSamples.current.push(frameRate);
        }
        frameCount.current = 0;
        lastTime.current = 0;
    };
    /**
	 * Counts the number of frames that occur within a given time period. Intended to be called
	 * inside a `requestAnimationFrame` callback.
	 */ const countFrames = ()=>{
        if (frameRateSamples.current.length >= maxSamples && timeoutId.current) {
            clearTimeout(timeoutId.current);
            return;
        }
        /**
		 * Allows us to keep counting frames even if `startMeasure` is not called
		 */ if (lastTime.current === 0) lastTime.current = performance.now();
        frameCount.current++;
        if (timeoutId.current) clearTimeout(timeoutId.current);
        if (performance.now() - lastTime.current > sampleRateMs) sampleFrameRate();
        else timeoutId.current = setTimeout(()=>sampleFrameRate(timeoutMs), timeoutMs);
    };
    return {
        startMeasure: startMeasure,
        endMeasure: endMeasure,
        countFrames: countFrames
    };
};
const $d406f1b0c5d56902$var$tableContainerNodes = new Set([
    'layoutSection',
    'layoutColumn',
    'expand',
    'nestedExpand',
    'extension',
    'bodiedExtension',
    'multiBodiedExtension',
    'extensionFrame',
    'table',
    'tableCell',
    'tableHeader',
    'tableRow'
]);
const $d406f1b0c5d56902$export$208d2421b73f3f86 = (editorView, editorWidth)=>{
    const tablesInfo = [];
    editorView.state.doc.nodesBetween(0, editorView.state.doc.content.size, (node, pos, parent)=>{
        if (!$d406f1b0c5d56902$var$tableContainerNodes.has(node.type.name)) return false;
        if (node.type.name === 'table') {
            const domAtPos = editorView.domAtPos(pos + 1);
            const table = domAtPos.node?.parentElement;
            const isNestedTable = parent?.type.name === 'tableCell' || parent?.type.name === 'tableHeader';
            if (table instanceof HTMLTableElement) tablesInfo.push({
                tableWidth: table.scrollWidth,
                isNestedTable: isNestedTable,
                hasScrollbar: table.parentElement ? table?.parentElement.clientWidth < table.scrollWidth : false
            });
        }
    });
    // only send the event if there are tables on the page
    if (tablesInfo.length === 0) return undefined;
    const maxTableWidth = Math.max(...tablesInfo.map((table)=>table.tableWidth));
    return {
        action: (0, $3824I.TABLE_ACTION).TABLE_WIDTH_INFO,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $lWghV.getBreakpointKey)(editorWidth),
            hasTableWithScrollbar: tablesInfo.some((table)=>table.hasScrollbar),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            maxTableWidthBreakpoint: (0, $lWghV.getBreakpointKey)(maxTableWidth),
            tableWidthInfo: tablesInfo,
            mode: 'editor'
        },
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    };
};
const $d406f1b0c5d56902$export$34e5b28c67455a81 = (editorView)=>{
    const tablesInfo = [];
    const editorPopupScrollParent = editorView.dom.closest('.fabric-editor-popup-scroll-parent');
    // don't send the event if the editor scroll parent is not available
    if (!editorPopupScrollParent) return undefined;
    const editorScrollParentClientHeight = editorPopupScrollParent.clientHeight;
    const isEditorScrollable = editorPopupScrollParent.scrollHeight > editorScrollParentClientHeight;
    editorView.state.doc.nodesBetween(0, editorView.state.doc.content.size, (node, pos, parent)=>{
        if (!$d406f1b0c5d56902$var$tableContainerNodes.has(node.type.name)) return false;
        if (node.type.name === 'table') {
            const domAtPos = editorView.domAtPos(pos + 1);
            const table = domAtPos.node?.parentElement;
            const isNestedTable = parent?.type.name === 'tableCell' || parent?.type.name === 'tableHeader';
            if (table instanceof HTMLTableElement) tablesInfo.push({
                isNestedTable: isNestedTable,
                tableHeight: table.scrollHeight
            });
        }
    });
    // only send the event if there are tables on the page
    if (tablesInfo.length === 0) return undefined;
    const maxTableHeight = Math.max(...tablesInfo.map((table)=>table.tableHeight));
    return {
        action: (0, $3824I.TABLE_ACTION).TABLE_EDITOR_HEIGHT_INFO,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        attributes: {
            editorScrollParentClientHeight: editorScrollParentClientHeight,
            isEditorScrollable: isEditorScrollable,
            maxTableToEditorHeightRatio: maxTableHeight / editorScrollParentClientHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    };
};


























/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json







const $fbbb9ee8877c285e$export$3efa753685336605 = "var(--ds-surface, #FFFFFF)";
const $fbbb9ee8877c285e$export$95883e661e73a1d1 = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $fbbb9ee8877c285e$export$1b578d7ab4fc0385 = "var(--ds-background-neutral-subtle, #00000000)";
const $fbbb9ee8877c285e$export$14da8da34a807702 = "var(--ds-text-subtlest, #6B6E76)";
const $fbbb9ee8877c285e$export$60473ec4f7c2b794 = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $fbbb9ee8877c285e$export$5aac4cb73ae3f2da = "var(--ds-background-neutral, #0515240F)";
const $fbbb9ee8877c285e$export$f26d047169b4195d = "var(--ds-blanket-selected, #388BFF14)";
const $fbbb9ee8877c285e$export$7c0a2e8110d12a28 = "var(--ds-background-selected-pressed, #8FB8F6)";
const $fbbb9ee8877c285e$export$8c5dd0fc35774ae1 = "var(--ds-background-selected-pressed, #8FB8F6)";
const $fbbb9ee8877c285e$export$9bf0891aaaf2fecb = "var(--ds-border-focused, #4688EC)";
const $fbbb9ee8877c285e$export$a699493d7d7580c3 = "var(--ds-icon-subtle, #505258)";
const $fbbb9ee8877c285e$export$cd5e5900c9fa42dc = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $fbbb9ee8877c285e$export$3c2a828febe9d506 = "var(--ds-blanket-danger, #EF5C4814)";
const $fbbb9ee8877c285e$export$870d72a5700e711d = "var(--ds-border-danger, #E2483D)";
const $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50 = "var(--ds-background-danger-pressed, #FFB8B2)";
const $fbbb9ee8877c285e$export$6cc2aa96833a5989 = "var(--ds-icon-inverse, #FFFFFF)";
const $fbbb9ee8877c285e$export$9907ca2ad437ddcc = "var(--ds-background-danger-bold, #C9372C)";
const $fbbb9ee8877c285e$export$371da7842ff35a5b = 3;
const $fbbb9ee8877c285e$export$e5ff276883773ffd = 8;
const $fbbb9ee8877c285e$export$92421f8864c287b1 = 15;
const $fbbb9ee8877c285e$export$cbcfa4314b903419 = 2;
const $fbbb9ee8877c285e$export$6d23b13c5fcb846c = 20;
const $fbbb9ee8877c285e$export$cb376ed67c7ae37e = 16;
const $fbbb9ee8877c285e$export$52b432855099b8bd = 6;
const $fbbb9ee8877c285e$export$a4d60e31f4f6188b = (0, $aFUXX.akEditorTableToolbarSize);
const $fbbb9ee8877c285e$export$880976487022eb5 = (0, $1zav4.tableMarginTop) + $fbbb9ee8877c285e$export$e5ff276883773ffd - (0, $1zav4.tableCellBorderWidth);
const $fbbb9ee8877c285e$export$73b1242ebdcc73be = 3;
const $fbbb9ee8877c285e$export$86dfc955b6099b88 = 32;
const $fbbb9ee8877c285e$export$893fc0cfd2a0c40e = 13;
const $fbbb9ee8877c285e$export$a3e71c692f2c2213 = 4;
const $fbbb9ee8877c285e$export$62374dd2f63076b0 = 25;
const $fbbb9ee8877c285e$export$da0ccd381b1a80f = (0, $aFUXX.akEditorUnitZIndex) * 10;
const $fbbb9ee8877c285e$export$83da30a15600a83e = $fbbb9ee8877c285e$export$da0ccd381b1a80f + 1;
const $fbbb9ee8877c285e$export$45aeeddcedd441ab = (0, $aFUXX.akEditorUnitZIndex) * 10;
const $fbbb9ee8877c285e$export$5b53cc051bf05434 = $fbbb9ee8877c285e$export$83da30a15600a83e + 1;
const $fbbb9ee8877c285e$export$cc7ed656b7dcf729 = 3;
const $fbbb9ee8877c285e$export$72409f838e9c33c7 = (0, $8b6ac7577f3a66b8$export$1a38c7157d718094) / 3;
const $fbbb9ee8877c285e$export$45d9825f76985b4e = 2;
const $fbbb9ee8877c285e$export$887c1388be90c08e = $fbbb9ee8877c285e$export$da0ccd381b1a80f + (0, $aFUXX.akRichMediaResizeZIndex);
const $fbbb9ee8877c285e$export$3969371f057ce1e5 = 16;
const $fbbb9ee8877c285e$export$a6ed027d1a83416d = 180;
const $fbbb9ee8877c285e$export$42d9040c5091b076 = 250;
const $fbbb9ee8877c285e$export$1279af870a198fea = $fbbb9ee8877c285e$export$887c1388be90c08e + 2;
const $fbbb9ee8877c285e$export$83c60dd0aac17107 = 8;
const $fbbb9ee8877c285e$export$13b0e72269a9a3aa = 1;
const $fbbb9ee8877c285e$export$40311377f05dbfc4 = 8;
const $fbbb9ee8877c285e$export$1680d391e1ce7b96 = 32;
const $fbbb9ee8877c285e$export$3cdde837cf189e96 = 188;
const $fbbb9ee8877c285e$export$9c3151841258b6f0 = 24;
const $fbbb9ee8877c285e$export$a13fb25a398e2fab = (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex) - 5;
const $fbbb9ee8877c285e$export$471fb2a0b2f2f936 = $fbbb9ee8877c285e$export$a13fb25a398e2fab + 1;
const $fbbb9ee8877c285e$export$7b64f35449327c05 = $fbbb9ee8877c285e$export$a13fb25a398e2fab - 1;
const $fbbb9ee8877c285e$export$b2015400488f9243 = 14;
const $fbbb9ee8877c285e$export$8f6133b6e2b4291 = 9;
const $fbbb9ee8877c285e$export$edb1b9caf8ff5b32 = 10;
const $fbbb9ee8877c285e$export$7af5c65e392a647 = 2;
const $fbbb9ee8877c285e$export$11cf30061861ec4a = 5;
const $fbbb9ee8877c285e$export$858d012f03ae70a5 = -68;
const $fbbb9ee8877c285e$export$a13bd817a2eda041 = 92;
const $fbbb9ee8877c285e$export$e0140c2b978caac5 = 4;
const $fbbb9ee8877c285e$export$c6a9e7014cf7aedc = 6;
const $fbbb9ee8877c285e$export$963fb187132ee7cf = 250;
const $fbbb9ee8877c285e$export$d18320cc8ee69115 = 16;
const $fbbb9ee8877c285e$export$6bec1f8a2aa82be8 = 150;
const $fbbb9ee8877c285e$export$c2ef52861254b274 = 14;
const $fbbb9ee8877c285e$export$2c18704a8d793cdb = 7;
const $fbbb9ee8877c285e$export$150cd2564fec30b7 = 8;


const $7eacb027e2e3fea2$export$79aef9e007571c = (view)=>{
    const { selection: selection } = view.state;
    let widths = [];
    const table = (0, $id9O1.findTable)(selection);
    if (table) {
        const map = (0, $LmqWp.TableMap).get(table.node);
        const domAtPos = view.domAtPos.bind(view);
        // When there is no cell we need to fill it with undefined
        widths = Array.from({
            length: map.width
        });
        for(let i = 0; i < map.width; i++)if (!map.isCellMergedTopLeft(0, i)) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(map.map[i]);
            const pos = map.map[i] + table.start;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const cellRef = (0, $8m4tT.findDomRefAtPos)(pos, domAtPos);
            const rect = cellRef.getBoundingClientRect();
            widths[i] = (rect ? rect.width : cellRef.offsetWidth) + 1;
            i += node.attrs.colspan - 1;
        }
    }
    return widths;
};
const $7eacb027e2e3fea2$export$bedfed4734d37a07 = (columnsWidths, selection)=>{
    const rect = (0, $iP1et.getSelectionRect)(selection);
    if (!rect) return null;
    let width = 0;
    let offset = 0;
    // find the columns before the selection
    for(let i = 0; i < rect.left; i++){
        const colWidth = columnsWidths[i];
        if (colWidth) offset += colWidth - 1;
    }
    // these are the selected columns widths
    const indexes = [];
    for(let i = rect.left; i < rect.right; i++){
        const colWidth = columnsWidths[i];
        if (colWidth) {
            width += colWidth;
            indexes.push(i);
        }
    }
    const left = offset + width / 2 - (0, $fbbb9ee8877c285e$export$cb376ed67c7ae37e) / 2;
    return {
        left: left,
        indexes: indexes
    };
};
// give a row colspan and a colwidths
// and map to a row's colwidths
const $7eacb027e2e3fea2$var$mapTableColwidthsToRow = (rowColSpans, tableColWidths)=>{
    let curColIdx = 0;
    const colWidths = [];
    rowColSpans.forEach((cellColSpan)=>{
        const colWidth = tableColWidths.slice(curColIdx, curColIdx + cellColSpan).reduce((acc, val)=>acc + val, 0);
        curColIdx += cellColSpan;
        colWidths.push(colWidth);
    });
    return colWidths;
};
const $7eacb027e2e3fea2$var$getRelativeDomCellWidths = ({ width: width, colspan: colspan, colwidth: colwidth })=>{
    // For cells with colSpan 1
    // or
    // for cells in a table with unchanged column widths,
    // these are identified by the lack of colwidth data attribute,
    // return equally partitioned total cell width in DOM for each cell.
    if (colspan === 1 || !colwidth) return new Array(colspan).fill(width / colspan);
    // For cells that have colSpan > 1 and
    // are part of a table with resized columns
    // return the current total DOM width of the cell multiplied
    // by the percentage of the each individual cell's size.
    // The cell size percentage is calculated using individual colwidth of the cell,
    // from data-colwidth attribute on the cell,
    // divided by the total width of the cells from colwidths for merged cells.
    // Ex:
    // colwidth = ‘201,102’
    // Total colWidth = 303
    // returned cellWidths = [303 * (201/303), 303 * (102/303)]
    // For merged cells we get back colwidth as `201,102`
    const cellColWidths = colwidth.split(',').map((colwidth)=>Number(colwidth));
    const totalCalculatedCellWidth = cellColWidths.reduce((acc, cellColWidth)=>acc + cellColWidth, 0);
    return cellColWidths.map((cellColWidth)=>width * (cellColWidth / totalCalculatedCellWidth));
};
const $7eacb027e2e3fea2$export$d231dfb66a75f6c1 = (tr)=>{
    // get the colspans
    const rowColSpans = (0, $4vlwG.maphElem)(tr, (cell)=>Number(cell.getAttribute('colspan') || 1 /* default to span of 1 */ ));
    // Chrome has trouble aligning borders with auto tables
    // and the rest of the page grid. tables with defined
    // column widths align fine.
    //
    // eg a 4x25% table might end up as 189px 190px 190px 190px
    //
    // prefer copying the widths via the DOM
    // or inferring from the next row if one exists
    const copyTarget = tr.nextElementSibling || tr;
    if (copyTarget) {
        // either from the first row while it's still in the table
        const cellInfos = (0, $4vlwG.maphElem)(copyTarget, (cell)=>({
                width: cell.getBoundingClientRect().width,
                colspan: Number(cell.getAttribute('colspan') || 1),
                colwidth: cell.dataset.colwidth
            }));
        // reverse engineer cell widths from table widths
        const domBasedCellWidths = [];
        cellInfos.map((cell)=>{
            domBasedCellWidths.push(...$7eacb027e2e3fea2$var$getRelativeDomCellWidths(cell));
        });
        if (cellInfos.reduce((acc, cell)=>acc + cell.width, 0) !== 0) {
            const newWidths = $7eacb027e2e3fea2$var$mapTableColwidthsToRow(rowColSpans, domBasedCellWidths);
            return newWidths.map((px)=>`${px}px`).join(' ');
        }
    }
    // as a fallback, just calculate a %, and hope that
    // it aligns perfectly in the user's browser
    const visualColCount = rowColSpans.reduce((acc, val)=>acc + val, 0);
    const pctWidths = rowColSpans.map((cellColSpan)=>cellColSpan / visualColCount * 100);
    return pctWidths.map((pct)=>`${pct}%`).join(' ');
};
const $7eacb027e2e3fea2$export$b53a50910add7502 = (htmlColIndex, htmlRowIndex, tableMap)=>{
    // Same numbers (positions) in tableMap.map array mean that there are merged cells.
    // Cells can be merged across columns. So we need to check if the cell on the left and current cell have the same value.
    // Cells can be merged acroll rows. So we need to check if the cell above has the same value as current cell.
    // When cell has the same value as the cell above it or the cell to the left of it, html cellIndex won't count it a separete column.
    const width = tableMap.width;
    const map = tableMap.map;
    let htmlColCount = 0;
    if (htmlRowIndex === 0) for(let colIndex = 0; colIndex < width; colIndex++){
        if (colIndex === 0 || map[colIndex] !== map[colIndex - 1]) htmlColCount++;
        if (htmlColCount - 1 === htmlColIndex) return colIndex;
    }
    else for(let colIndex = 0; colIndex < width; colIndex++){
        const currentCellMapIndex = htmlRowIndex * width + colIndex;
        const cellAboveMapIndex = (htmlRowIndex - 1) * width + colIndex;
        if (colIndex > 0) {
            if (map[currentCellMapIndex] !== map[currentCellMapIndex - 1] && map[currentCellMapIndex] !== map[cellAboveMapIndex]) htmlColCount++;
        } else if (map[currentCellMapIndex] !== map[cellAboveMapIndex]) htmlColCount++;
        if (htmlColCount - 1 === htmlColIndex) return colIndex;
    }
    return 0;
};
const $7eacb027e2e3fea2$export$ffa56ed053ef832e = (convertedColIndex, htmlRowIndex, tableMap)=>{
    const width = tableMap.width;
    const map = tableMap.map;
    const mapColIndexToFistRowColIndex = [];
    let htmlColCounFirstRow = 0;
    let colSpan = 0;
    if (htmlRowIndex === 0) return convertedColIndex;
    for(let colIndex = 0; colIndex < width; colIndex++){
        if (colIndex === 0 || map[colIndex] !== map[colIndex - 1]) {
            if (colSpan > 0) {
                htmlColCounFirstRow += colSpan;
                colSpan = 0;
            }
            htmlColCounFirstRow++;
        } else if (map[colIndex] === map[colIndex - 1]) colSpan++;
        mapColIndexToFistRowColIndex[colIndex] = htmlColCounFirstRow - 1;
    }
    return mapColIndexToFistRowColIndex[convertedColIndex];
};




















const $885c1a71dd6e181b$export$3e5149a60ac7416b = (tableRef)=>{
    const heights = [];
    const tableBody = tableRef.querySelector('tbody');
    if (tableBody) {
        const rows = tableBody.childNodes;
        for(let i = 0, count = rows.length; i < count; i++){
            const row = rows[i];
            heights[i] = row.getBoundingClientRect().height + 1;
            // padding only gets applied when the container has sticky
            if (row.classList.contains('sticky') && i === 0) {
                const styles = window.getComputedStyle(row);
                const paddingTop = (0, $4vlwG.parsePx)(styles.paddingTop || '');
                heights[i] -= paddingTop ? paddingTop + 1 : 1;
            }
        }
    }
    return heights;
};
const $885c1a71dd6e181b$export$b0ece9f607a8bda1 = (rowsHeights, selection, offsetTop = 0)=>{
    const rect = (0, $iP1et.getSelectionRect)(selection);
    if (!rect) return null;
    let height = 0;
    let offset = offsetTop;
    // find the rows before the selection
    for(let i = 0; i < rect.top; i++){
        const rowHeight = rowsHeights[i];
        if (rowHeight) offset += rowHeight - 1;
    }
    // these are the selected rows widths
    const indexes = [];
    for(let i = rect.top; i < rect.bottom; i++){
        const rowHeight = rowsHeights[i];
        if (rowHeight) {
            height += rowHeight - 1;
            indexes.push(i);
        }
    }
    const top = offset + height / 2 - (0, $fbbb9ee8877c285e$export$cb376ed67c7ae37e) / 2;
    return {
        top: top,
        indexes: indexes
    };
};
const $885c1a71dd6e181b$export$b8127ab1acaa6d46 = (rowsHeights)=>{
    const rows = [];
    for(let i = 0, count = rowsHeights.length; i < count; i++){
        const height = rowsHeights[i];
        if (!height) continue;
        let endIndex = rowsHeights.length;
        for(let k = i + 1, count = rowsHeights.length; k < count; k++)if (rowsHeights[k]) {
            endIndex = k;
            break;
        }
        rows.push({
            startIndex: i,
            endIndex: endIndex,
            height: height
        });
    }
    return rows;
};
const $885c1a71dd6e181b$export$8969ab96fc5961ae = (index, selection, hoveredRows = [], isInDanger, isResizing)=>{
    const classNames = [];
    if ((0, $iYC9s.isRowSelected)(index)(selection) || hoveredRows.indexOf(index) > -1 && !isResizing) {
        classNames.push((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_ACTIVE);
        if (isInDanger) classNames.push((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER);
    }
    return classNames.join(' ');
};
const $885c1a71dd6e181b$export$173c92a3a1ff68a7 = (schema)=>(insertNewRowIndex)=>(tr)=>{
            const table = (0, $id9O1.findTable)(tr.selection);
            if (!table) return tr;
            const map = (0, $LmqWp.TableMap).get(table.node);
            const copyPreviousRowIndex = insertNewRowIndex - 1;
            if (insertNewRowIndex <= 0) throw Error(`Row Index less or equal 0 isn't not allowed since there is not a previous to copy`);
            if (insertNewRowIndex > map.height) return tr;
            const tableNode = table.node;
            const { nodes: { tableRow: tableRow } } = schema;
            const cellsInRow = map.cellsInRect({
                left: 0,
                right: map.width,
                top: copyPreviousRowIndex,
                bottom: copyPreviousRowIndex + 1
            });
            const offsetIndexPosition = copyPreviousRowIndex * map.width;
            const offsetNextLineIndexPosition = insertNewRowIndex * map.width;
            const cellsPositionsInOriginalRow = map.map.slice(offsetIndexPosition, offsetIndexPosition + map.width);
            const cellsPositionsInNextRow = map.map.slice(offsetNextLineIndexPosition, offsetNextLineIndexPosition + map.width);
            const cells = [];
            const fixRowspans = [];
            for(let i = 0; i < cellsPositionsInOriginalRow.length;){
                const pos = cellsPositionsInOriginalRow[i];
                const documentCellPos = pos + table.start;
                const node = tr.doc.nodeAt(documentCellPos);
                if (!node) continue;
                const attributes = {
                    ...node.attrs,
                    colspan: 1,
                    rowspan: 1
                };
                const newCell = node.type.createAndFill(attributes);
                if (!newCell) return tr;
                if (cellsPositionsInNextRow.indexOf(pos) > -1) fixRowspans.push({
                    pos: documentCellPos,
                    node: node
                });
                else if (cellsInRow.indexOf(pos) > -1) {
                    if (node.attrs.colspan > 1) {
                        const newCellWithColspanFixed = node.type.createAndFill({
                            ...attributes,
                            colspan: node.attrs.colspan
                        });
                        if (!newCellWithColspanFixed) return tr;
                        cells.push(newCellWithColspanFixed);
                        i = i + node.attrs.colspan;
                        continue;
                    }
                    cells.push(newCell);
                } else cells.push(newCell);
                i++;
            }
            fixRowspans.forEach((cell)=>{
                tr.setNodeMarkup(cell.pos, undefined, {
                    ...cell.node.attrs,
                    rowspan: cell.node.attrs.rowspan + 1
                });
            });
            const cloneRow = tableNode.child(copyPreviousRowIndex);
            let rowPos = table.start;
            for(let i = 0; i < insertNewRowIndex; i++)rowPos += tableNode.child(i).nodeSize;
            return (0, $8m4tT.safeInsert)(tableRow.createChecked(cloneRow.attrs, cells, cloneRow.marks), rowPos)(tr);
        };


const $b432f0a26e9b5b59$export$13c259c17cfd51f5 = ()=>(state)=>{
        const { tableRef: tableRef } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if (!tableRef) return;
        const tr = tableRef.querySelector('tr');
        if (!tr) return;
        const wrapper = tableRef.parentElement;
        if (!(wrapper && wrapper.parentElement)) return;
        const rowControls = wrapper.parentElement.querySelectorAll(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP}`);
        const numberedRows = wrapper.parentElement.querySelectorAll((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON);
        $b432f0a26e9b5b59$export$43080b9794565cc4(tableRef);
        const rowHeights = (0, $885c1a71dd6e181b$export$3e5149a60ac7416b)(tableRef);
        // update rows controls height on resize
        for(let i = 0, count = rowControls.length; i < count; i++){
            const height = rowHeights[i];
            if (height) {
                rowControls[i].style.height = `${height}px`;
                if (numberedRows.length) numberedRows[i].style.height = `${height}px`;
            }
        }
    };
const $b432f0a26e9b5b59$export$f76d638a91295d45 = (event, click)=>{
    const dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
};
const $b432f0a26e9b5b59$export$3658aa65e79e3104 = (view, event)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    if (!(0, $4vlwG.containsClassName)(target, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION)) return null;
    const tableCell = (0, $4vlwG.closestElement)(target, 'td, th');
    if (!tableCell) return null;
    const cellStartPosition = view.posAtDOM(tableCell, 0);
    return cellStartPosition - 1;
};
const $b432f0a26e9b5b59$export$ec6da316e37a54bf = (table)=>{
    const row = table.querySelector('tr.sticky');
    if (!row) {
        table.style.marginTop = '';
        return;
    }
    const paddingTop = (0, $4vlwG.parsePx)(window.getComputedStyle(row).paddingTop || '') || 0;
    const firstRowHeight = row.getBoundingClientRect().height - paddingTop - (0, $1zav4.tableCellBorderWidth);
    table.style.marginTop = `${(0, $1zav4.tableMarginTop) + firstRowHeight}px`;
};
const $b432f0a26e9b5b59$var$applyColWidthsToStickyRow = (colGroup, headerRow)=>{
    // sync column widths for the sticky row
    const newCols = (0, $7eacb027e2e3fea2$export$d231dfb66a75f6c1)(headerRow);
    if (newCols) headerRow.style.gridTemplateColumns = newCols;
};
const $b432f0a26e9b5b59$export$43080b9794565cc4 = (tableRef)=>{
    if (!tableRef) return;
    const headerRow = tableRef.querySelector('tr[data-header-row]');
    if (!headerRow) return;
    $b432f0a26e9b5b59$var$applyColWidthsToStickyRow(tableRef.querySelector('colgroup'), headerRow);
    $b432f0a26e9b5b59$var$applyTableWidthToStickyRow(tableRef, headerRow);
};
const $b432f0a26e9b5b59$var$applyTableWidthToStickyRow = (tableRef, headerRow)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const tbody = tableRef.querySelector('tbody');
    const wrapper = tableRef.parentElement;
    if (tbody && wrapper) {
        // when resizing in Chrome, clientWidth will give us 759px
        // but toggling the sticky class will reset it to 760px.
        //
        // both elements in the dom + inspector will
        // be the same width but at layout will be different..
        const newWidth = Math.min(tbody.offsetWidth + 1, wrapper.offsetWidth);
        headerRow.style.width = `${newWidth}px`;
        headerRow.scrollLeft = wrapper.scrollLeft;
    }
};



const $77650a1f6e0f1ab2$export$38f73cf370cfaafc = ({ minWidth: minWidth, maxSize: maxSize, table: table, tableRef: tableRef, start: start, domAtPos: domAtPos, isTableScalingEnabled: isTableScalingEnabled = false, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent = false, isCommentEditor: isCommentEditor = false })=>{
    if (isTableScalingEnabled && !isCommentEditor || isTableScalingEnabled && isCommentEditor && table.attrs?.width) {
        const scalePercent = (0, $b61fc0745b235461$export$b2c142721a99201b)(table, tableRef, shouldUseIncreasedScalingPercent);
        minWidth = Math.ceil(minWidth / scalePercent);
    }
    if ((0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(table)) {
        // If the table has been resized, we can use the column widths from the table node
        const cols = (0, $caYZ2.calcTableColumnWidths)(table).map((width, index)=>({
                width: width === 0 ? (0, $1zav4.tableNewColumnMinWidth) : width,
                minWidth: width === 0 ? (0, $1zav4.tableNewColumnMinWidth) : minWidth,
                index: index
            }));
        const widths = cols.map((col)=>col.width);
        const tableWidth = widths.reduce((sum, width)=>sum + width, 0);
        const overflow = tableWidth > maxSize;
        return {
            cols: cols,
            widths: widths,
            maxSize: maxSize,
            tableWidth: tableWidth,
            overflow: overflow,
            isScaled: isTableScalingEnabled
        };
    }
    const shouldReinsertColgroup = !isTableScalingEnabled;
    // Getting the resize state from DOM
    const colgroupChildren = (0, $d7e0ca7a06057b05$export$ae5d9647f2a0891c)(tableRef, table, isTableScalingEnabled, shouldReinsertColgroup, shouldUseIncreasedScalingPercent, isCommentEditor);
    const cols = Array.from(colgroupChildren).map((_, index)=>{
        // If the table hasn't been resized and we have a table width attribute, we can use it
        // to calculate the widths of the columns
        if (isTableScalingEnabled) {
            // isCommentEditor when table cols were not resized,
            // we want to use tableRef.parentElement.clientWidth, which is the same as maxSize
            const tableNodeWidth = isCommentEditor && !table.attrs?.width ? maxSize : (0, $6fQl1.getTableContainerWidth)(table);
            return {
                index: index,
                width: tableNodeWidth / colgroupChildren.length,
                minWidth: minWidth
            };
        }
        const cellsRefs = (0, $52c8652e4f6c617c$export$43e8ce817a8e5c42)(index, table, start, domAtPos);
        return (0, $52c8652e4f6c617c$export$5c09bfb77c404ce)(cellsRefs, index, minWidth);
    });
    const widths = cols.map((col)=>col.width);
    const tableWidth = widths.reduce((sum, width)=>sum + width, 0);
    const overflow = tableWidth > maxSize;
    return {
        cols: cols,
        widths: widths,
        maxSize: maxSize,
        tableWidth: tableWidth,
        overflow: overflow,
        isScaled: isTableScalingEnabled
    };
};
const $77650a1f6e0f1ab2$export$23e0010f5fd8981 = (state, tableRef, tableNode, isTableScalingEnabled, scalePercent)=>{
    const cols = tableRef?.querySelectorAll(':scope > colgroup > col');
    const columnsCount = cols?.length;
    /**
     updateColgroup will update whole table scale when click the column resize handle, this behavior will affect when table overflowed, when now resize handle been dragged and extend to make table overflowed, table will show overflow. This need to be confirmed because it conflict with how isTableScalingEnabled work.
     We don't want to scale the table when resizing columns, only when viewpoint shrinks the table.
     We need to remove !isColumnResizing if we handled auto scale table when mouseUp event.
     * */ if (isTableScalingEnabled && tableNode) state.cols.filter((column)=>column && !!column.width) // if width is 0, we dont want to apply that.
    .forEach((column, i)=>{
        const fixedColWidth = (0, $d7e0ca7a06057b05$export$66302252070a658d)(column.width, columnsCount ?? 0);
        const scaledWidth = fixedColWidth * (scalePercent || 1);
        const finalWidth = Math.max(scaledWidth, (0, $1zav4.tableCellMinWidth));
        // we aren't handling the remaining pixels here when the 48px min width is reached
        if (cols?.[i]) cols[i].style.width = `${finalWidth}px`;
    });
    else state.cols.filter((column)=>column && !!column.width) // if width is 0, we dont want to apply that.
    .forEach((column, i)=>{
        if (cols?.[i]) cols[i].style.width = `${(0, $d7e0ca7a06057b05$export$66302252070a658d)(column.width, columnsCount ?? 0)}px`;
    });
    // colgroup has updated, reflect new widths in sticky header
    (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(tableRef);
};
const $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8 = ({ cols: cols })=>{
    return cols.reduce((totalWidth, col)=>totalWidth + col.width, 0);
};
const $77650a1f6e0f1ab2$export$b07f5f5f9c98720a = (resizeState, maxSize)=>{
    const totalWidth = $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8(resizeState);
    const diff = maxSize - totalWidth;
    if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $1zav4.tableCellMinWidth)) {
        let updated = false;
        return {
            ...resizeState,
            cols: resizeState.cols.map((col)=>{
                if (!updated && col.width + diff > col.minWidth) {
                    updated = true;
                    return {
                        ...col,
                        width: col.width + diff
                    };
                }
                return col;
            })
        };
    }
    return resizeState;
};
const $77650a1f6e0f1ab2$export$aa593d179f012fe1 = (resizeState)=>{
    const maxSize = $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8(resizeState);
    const evenWidth = Math.floor(maxSize / resizeState.cols.length);
    const cols = resizeState.cols.map((col)=>({
            ...col,
            width: evenWidth
        }));
    return $77650a1f6e0f1ab2$export$b07f5f5f9c98720a({
        ...resizeState,
        cols: cols
    }, maxSize);
};
const $77650a1f6e0f1ab2$var$getSpace = (columns, start, end)=>columns.slice(start, end).map((col)=>col.width).reduce((sum, width)=>sum + width, 0);
const $77650a1f6e0f1ab2$var$evenSelectedColumnsWidths = (resizeState, rect)=>{
    const cols = resizeState.cols;
    const selectedSpace = $77650a1f6e0f1ab2$var$getSpace(cols, rect.left, rect.right);
    const allSpace = $77650a1f6e0f1ab2$var$getSpace(cols, 0, cols.length);
    const allWidth = allSpace / cols.length;
    const width = selectedSpace / (rect.right - rect.left);
    // Result equals even distribution of all columns -
    // unset widths of all columns
    if (allWidth === width) return {
        ...resizeState,
        widths: cols.map(()=>width),
        cols: resizeState.cols.map((col)=>({
                ...col,
                width: 0
            }))
    };
    return {
        ...resizeState,
        widths: cols.map((col, i)=>i >= rect.left && i < rect.right ? width : col.width),
        cols: cols.map((col, i)=>({
                ...col,
                width: i >= rect.left && i < rect.right ? width : col.width
            }))
    };
};
const $77650a1f6e0f1ab2$export$7d703099c5579705 = (resizeState, columnsIndexes, sourceColumnIndex)=>{
    const currentTableWidth = $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8(resizeState);
    const colIndex = columnsIndexes.indexOf(sourceColumnIndex) > -1 ? sourceColumnIndex : sourceColumnIndex + 1;
    const sourceCol = resizeState.cols[colIndex];
    const seenColumns = {};
    const widthsDiffs = [];
    const cols = resizeState.cols.map((col)=>{
        if (columnsIndexes.indexOf(col.index) > -1) {
            const diff = col.width - sourceCol.width;
            if (diff !== 0) widthsDiffs.push(diff);
            return {
                ...col,
                width: sourceCol.width
            };
        }
        return col;
    });
    let newState = {
        ...resizeState,
        cols: cols.map((col)=>{
            if (columnsIndexes.indexOf(col.index) > -1 || // take from prev columns only if dragging the first handle to the left
            columnsIndexes.indexOf(sourceColumnIndex) > -1 && col.index < colIndex) return col;
            while(widthsDiffs.length){
                const diff = widthsDiffs.shift() || 0;
                const column = seenColumns[col.index] || col;
                const maybeWidth = column.width + diff;
                if (maybeWidth > column.minWidth) seenColumns[column.index] = {
                    ...column,
                    width: maybeWidth
                };
                else {
                    widthsDiffs.push(maybeWidth - column.minWidth);
                    seenColumns[column.index] = {
                        ...column,
                        width: column.minWidth
                    };
                    break;
                }
            }
            return seenColumns[col.index] || col;
        })
    };
    // minimum possible table widths at the current layout
    const minTableWidth = resizeState.maxSize;
    // new table widths after bulk resize
    const newTotalWidth = $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8(newState);
    // when all columns are selected, what do we do when sum of columns widths is lower than min possible table widths?
    if (columnsIndexes.length === resizeState.cols.length && newTotalWidth < minTableWidth) {
        // table is not in overflow -> normal resize of a single column
        if (currentTableWidth === minTableWidth) return resizeState;
        else {
            const columnWidth = Math.floor((minTableWidth - sourceCol.width) / (newState.cols.length - 1));
            newState = {
                ...resizeState,
                cols: newState.cols.map((col)=>{
                    if (col.index === sourceCol.index) return col;
                    return {
                        ...col,
                        width: columnWidth
                    };
                })
            };
        }
    }
    // fixes total table widths by adding missing pixels to columns widths here and there
    return $77650a1f6e0f1ab2$export$b07f5f5f9c98720a(newState, resizeState.maxSize);
};
// Get the layout
const $77650a1f6e0f1ab2$var$normaliseTableLayout = (input)=>{
    switch(input){
        case 'wide':
            return input;
        case 'full-width':
            return input;
        default:
            return 'default';
    }
};
const $77650a1f6e0f1ab2$export$8490eb29eba3007d = (rect, state, domAtPos, getEditorContainerWidth, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>{
    // Fail early so that we don't do complex calculations for no reason
    const numColumnsSelected = rect.right - rect.left;
    if (numColumnsSelected <= 1) return;
    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount, table: table } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
    if (!table) return;
    // Fail early so that we don't do complex calculations for no reason
    if (!(0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(table.node)) return;
    const maybeTable = domAtPos(table.start).node;
    const maybeTableElement = maybeTable instanceof HTMLElement ? maybeTable : null;
    const tableRef = maybeTableElement?.closest('table');
    if (!tableRef) return;
    const layout = $77650a1f6e0f1ab2$var$normaliseTableLayout(tableRef?.dataset.layout);
    const maxSize = (0, $b61fc0745b235461$export$8bfbafe1083a527d)({
        table: table.node,
        tableStart: table.start,
        state: state,
        layout: layout,
        getEditorContainerWidth: getEditorContainerWidth
    });
    let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = table.node.attrs.displayMode !== 'fixed';
    let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingEnabled && isCommentEditor) {
        isTableScalingEnabledOnCurrentTable = true;
        shouldUseIncreasedScalingPercent = true;
    }
    const resizeState = $77650a1f6e0f1ab2$export$38f73cf370cfaafc({
        minWidth: (0, $1zav4.tableCellMinWidth),
        maxSize: maxSize,
        table: table.node,
        tableRef: tableRef,
        start: table.start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    const newResizeState = $77650a1f6e0f1ab2$var$evenSelectedColumnsWidths(resizeState, rect);
    const widthsBefore = resizeState.widths;
    const widthsAfter = newResizeState.widths;
    const changed = resizeState.widths.some((widthBefore, index)=>widthBefore !== widthsAfter[index]);
    return {
        resizeState: newResizeState,
        table: table,
        changed: changed,
        attributes: {
            position: rect.left,
            count: rect.right - rect.left,
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount,
            widthsBefore: widthsBefore,
            widthsAfter: widthsAfter
        }
    };
};









var $e6n00 = parcelRequire("e6n00");












const $9ca3c6b800e4b699$export$276e2d0f37ca319a = (state, colIndex, amount, selectedColumns)=>{
    // can't grow if columns don't exist or it's the last column
    if (!state.cols[colIndex] || !state.cols[colIndex + 1]) return state;
    const res = $9ca3c6b800e4b699$var$moveSpaceFrom(state, colIndex + 1, colIndex, amount);
    const remaining = amount - res.amount;
    let newState = res.state;
    if (remaining > 0) newState = $9ca3c6b800e4b699$var$stackSpace(newState, colIndex, remaining).state;
    if (selectedColumns && selectedColumns.length > 1) return (0, $77650a1f6e0f1ab2$export$7d703099c5579705)(newState, selectedColumns, colIndex);
    return newState;
};
const $9ca3c6b800e4b699$export$99e30963fc7d1a1e = (state, colIndex, amount, selectedColumns)=>{
    // can't shrink if columns don't exist
    if (!state.cols[colIndex]) return state;
    // try to shrink dragging column by giving from the column to the right first
    const res = $9ca3c6b800e4b699$var$moveSpaceFrom(state, colIndex, colIndex + 1, -amount);
    let newState = res.state;
    const isOverflownTable = (0, $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8)(newState) > newState.maxSize;
    const isLastColumn = !newState.cols[colIndex + 1];
    // stop resizing the last column once table is not overflown
    if (isLastColumn && !isOverflownTable) return newState;
    const remaining = amount + res.amount;
    if (remaining < 0) newState = $9ca3c6b800e4b699$var$stackSpace(newState, colIndex + 1, remaining).state;
    if (selectedColumns && selectedColumns.length > 1) return (0, $77650a1f6e0f1ab2$export$7d703099c5579705)(newState, selectedColumns, colIndex);
    return newState;
};
function $9ca3c6b800e4b699$export$827dd2d6fa38543e(state, amount, ignoreCols = []) {
    let remaining = amount;
    // keep trying to resolve resize request until we run out of free space,
    // or nothing to resize
    while(remaining > 0){
        // filter candidates only with free space
        const candidates = state.cols.filter((column)=>{
            return (0, $52c8652e4f6c617c$export$529a1befd331574)(column) && ignoreCols.indexOf(column.index) === -1;
        });
        if (candidates.length === 0) break;
        const requestedResize = Math.floor(remaining / candidates.length);
        if (requestedResize === 0) break;
        candidates.forEach((candidate)=>{
            let newWidth = candidate.width - requestedResize;
            if (newWidth < candidate.minWidth) {
                // If the new requested width is less than our min
                // Calc what width we didn't use, we'll try extract that
                // from other cols.
                const remainder = candidate.minWidth - newWidth;
                newWidth = candidate.minWidth;
                remaining = remaining - requestedResize + remainder;
            } else remaining -= requestedResize;
            state = {
                ...state,
                cols: [
                    ...state.cols.slice(0, candidate.index),
                    {
                        ...candidate,
                        width: newWidth
                    },
                    ...state.cols.slice(candidate.index + 1)
                ]
            };
        });
    }
    return state;
}
var $9ca3c6b800e4b699$var$ColType = /*#__PURE__*/ function(ColType) {
    ColType["SOURCE"] = "src";
    ColType["DEST"] = "dest";
    return ColType;
}($9ca3c6b800e4b699$var$ColType || {});
// TODO: ED-26961 - should handle when destIdx:
// - is beyond the range, and then not give it back
function $9ca3c6b800e4b699$var$moveSpaceFrom(state, srcIdx, destIdx, amount, useFreeSpace = true) {
    const srcCol = state.cols[srcIdx];
    const destCol = state.cols[destIdx];
    if (useFreeSpace) {
        const freeSpace = (0, $52c8652e4f6c617c$export$529a1befd331574)(srcCol);
        // if taking more than source column's free space, only take that much
        if ($9ca3c6b800e4b699$var$amountFor("dest")(amount) > freeSpace) amount = amount > 0 ? freeSpace : -freeSpace;
    }
    // if the source column shrinks past its min size, don't give the space away
    if ($9ca3c6b800e4b699$var$amountFor("src")(amount) < 0 && $9ca3c6b800e4b699$var$widthFor("src")(amount, srcCol, destCol) < srcCol.minWidth) amount = srcCol.width - srcCol.minWidth;
    const newDest = destCol ? {
        ...destCol,
        width: $9ca3c6b800e4b699$var$widthFor("dest")(amount, srcCol, destCol)
    } : undefined;
    if (!newDest && $9ca3c6b800e4b699$var$amountFor("src")(amount) < 0) {
        // non-zero-sum game, ensure that we're not removing more than the total table width either
        const totalWidth = (0, $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8)(state);
        if (totalWidth - srcCol.width + $9ca3c6b800e4b699$var$widthFor("src")(amount, srcCol, destCol) < state.maxSize) // would shrink table below max width, stop it
        amount = state.maxSize - (totalWidth - srcCol.width) - srcCol.width - 1;
    }
    const newSrc = {
        ...srcCol,
        width: $9ca3c6b800e4b699$var$widthFor("src")(amount, srcCol, destCol)
    };
    const newCols = state.cols.map((existingCol, idx)=>idx === srcIdx ? newSrc : idx === destIdx ? newDest : existingCol).filter(Boolean);
    return {
        state: {
            ...state,
            cols: newCols
        },
        amount: amount
    };
}
function $9ca3c6b800e4b699$var$stackSpace(state, destIdx, amount) {
    let candidates = $9ca3c6b800e4b699$var$getCandidates(state, destIdx, amount);
    while(candidates.length && amount){
        // search for most (or least) free space in candidates
        const candidateIdx = $9ca3c6b800e4b699$var$findNextFreeColumn(candidates, amount);
        if (candidateIdx === -1) {
            // stack to the right -> growing the dragging column and go overflow
            if (amount > 0) return {
                state: {
                    ...state,
                    cols: [
                        ...state.cols.slice(0, destIdx),
                        {
                            ...state.cols[destIdx],
                            width: state.cols[destIdx].width + amount
                        },
                        ...state.cols.slice(destIdx + 1)
                    ]
                },
                remaining: amount
            };
            break;
        }
        const column = candidates.find((col)=>col.index === candidateIdx);
        if (!column || (0, $52c8652e4f6c617c$export$529a1befd331574)(column) <= 0) break;
        const res = $9ca3c6b800e4b699$var$moveSpaceFrom(state, column.index, destIdx, amount);
        state = res.state;
        amount -= res.amount;
        candidates = candidates.filter((col)=>col.index !== candidateIdx);
    }
    return {
        state: state,
        remaining: amount
    };
}
function $9ca3c6b800e4b699$var$findNextFreeColumn(columns, amount) {
    if (columns.length === 0) return -1;
    const direction = amount < 0 ? 'left' : 'right';
    if (direction === 'left') columns = columns.slice().reverse();
    let freeIndex = -1;
    columns.forEach((column)=>{
        if ((0, $52c8652e4f6c617c$export$529a1befd331574)(column) && freeIndex === -1) freeIndex = column.index;
    });
    if (freeIndex === -1) return -1;
    return freeIndex;
}
function $9ca3c6b800e4b699$var$amountFor(colType) {
    return (amount)=>colType === "src" ? amount > 0 ? -amount : amount : amount < 0 ? -amount : amount;
}
function $9ca3c6b800e4b699$var$widthFor(colType) {
    return (amount, srcCol, destCol)=>(colType === "src" ? srcCol : destCol).width + $9ca3c6b800e4b699$var$amountFor(colType)(amount);
}
function $9ca3c6b800e4b699$var$getCandidates(state, destIdx, amount) {
    const candidates = state.cols;
    // only consider rows after the selected column in the direction of resize
    return amount < 0 ? candidates.slice(0, destIdx) : candidates.slice(destIdx + 1);
}
function $9ca3c6b800e4b699$export$a2e757ac5c4f573f(resizeState, colIndex, resizeAmount) {
    const updatedCols = resizeState.cols.map((col, index)=>{
        if (index === colIndex) {
            const newWidth = Math.max(col.width + resizeAmount, col.minWidth);
            return {
                ...col,
                width: newWidth
            };
        }
        return col;
    });
    return {
        ...resizeState,
        tableWidth: updatedCols.reduce((acc, col)=>acc + col.width, 0),
        cols: updatedCols
    };
}





// Base function to trigger the actual scale on a table node.
// Will only resize/scale if a table has been previously resized.
const $0e5c6cf05dff4e80$var$scale = (tableRef, options, domAtPos, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const { node: node, containerWidth: containerWidth, previousContainerWidth: previousContainerWidth, prevNode: prevNode, start: start, layoutChanged: layoutChanged, isTableResizingEnabled: isTableResizingEnabled } = options;
    const maxSize = isTableResizingEnabled ? (0, $6fQl1.getTableContainerWidth)(node) : (0, $b61fc0745b235461$export$7bde9ac1d5d663fc)(node.attrs.layout, containerWidth, {});
    const prevTableWidth = (0, $bdb0299b531c40df$export$4910020ffe58186f)(prevNode);
    const previousMaxSize = isTableResizingEnabled ? (0, $6fQl1.getTableContainerWidth)(node) : (0, $b61fc0745b235461$export$7bde9ac1d5d663fc)(prevNode.attrs.layout, previousContainerWidth, {});
    let newWidth = maxSize;
    // adjust table width if layout is updated
    const hasOverflow = prevTableWidth > previousMaxSize;
    if (layoutChanged && hasOverflow) {
        // No keep overflow if the old content can be in the new size
        const canFitInNewSize = prevTableWidth < maxSize;
        if (canFitInNewSize) newWidth = maxSize;
        else {
            // Keep the same scale.
            const overflowScale = prevTableWidth / previousMaxSize;
            newWidth = Math.floor(newWidth * overflowScale);
        }
    }
    if (node.attrs.isNumberColumnEnabled) newWidth -= (0, $aFUXX.akEditorTableNumberColumnWidth);
    const resizeState = (0, $77650a1f6e0f1ab2$export$38f73cf370cfaafc)({
        minWidth: (0, $1zav4.tableCellMinWidth),
        maxSize: maxSize,
        table: node,
        tableRef: tableRef,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    return $0e5c6cf05dff4e80$export$5de2ae9923ce5a0(resizeState, newWidth);
};
const $0e5c6cf05dff4e80$var$scaleWithParent = (tableRef, parentWidth, table, start, domAtPos, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const resizeState = (0, $77650a1f6e0f1ab2$export$38f73cf370cfaafc)({
        minWidth: (0, $1zav4.tableCellMinWidth),
        maxSize: parentWidth,
        table: table,
        tableRef: tableRef,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    if (table.attrs.isNumberColumnEnabled) parentWidth -= (0, $aFUXX.akEditorTableNumberColumnWidth);
    return $0e5c6cf05dff4e80$export$5de2ae9923ce5a0(resizeState, Math.floor(parentWidth));
};
function $0e5c6cf05dff4e80$export$5de2ae9923ce5a0(state, maxSize) {
    const scaleFactor = maxSize / (0, $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8)(state);
    let newState = {
        ...state,
        maxSize: maxSize,
        cols: state.cols.map((col)=>{
            const { minWidth: minWidth, width: width } = col;
            let newColWidth = Math.floor(width * scaleFactor);
            if (newColWidth < minWidth) newColWidth = minWidth;
            return {
                ...col,
                width: newColWidth
            };
        })
    };
    const newTotalWidth = (0, $77650a1f6e0f1ab2$export$fbc5c7e5991c30a8)(newState);
    if (newTotalWidth > maxSize) newState = (0, $9ca3c6b800e4b699$export$827dd2d6fa38543e)(newState, newTotalWidth - maxSize);
    return (0, $77650a1f6e0f1ab2$export$b07f5f5f9c98720a)(newState, maxSize);
}
const $0e5c6cf05dff4e80$export$2d57109fc9066ba2 = (tableRef, options, domAtPos, isTableScalingEnabled = false, allowFixedColumnWidthOption = false, isCommentOrChromelessEditor = false)=>{
    const { node: node, start: start, parentWidth: parentWidth } = options;
    if (!tableRef) return;
    if (parentWidth) {
        const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
        const width = isNumberColumnEnabled ? parentWidth - (0, $aFUXX.akEditorTableNumberColumnWidth) : parentWidth;
        tableRef.style.width = `${width}px`;
    }
    let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && allowFixedColumnWidthOption;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = isTableScalingEnabled && node.attrs.displayMode !== 'fixed';
    // If the table hasn't been resize, the colgroup 48px width values will gracefully scale down.
    // If we are scaling the table down with isTableScalingEnabled, the colgroup widths may be scaled to a value that is not 48px.
    if (!(0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(node) && !isTableScalingEnabledOnCurrentTable) {
        (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(tableRef);
        return;
    }
    const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentOrChromelessEditor;
    const resizeState = parentWidth ? $0e5c6cf05dff4e80$var$scaleWithParent(tableRef, parentWidth, node, start, domAtPos, false, shouldUseIncreasedScalingPercent) : $0e5c6cf05dff4e80$var$scale(tableRef, options, domAtPos, false, shouldUseIncreasedScalingPercent);
    if (resizeState) (0, $77650a1f6e0f1ab2$export$23e0010f5fd8981)(resizeState, tableRef, node, false, 1);
};
const $0e5c6cf05dff4e80$export$edcf1a404e75ce35 = (tableRef, options, domAtPos, api, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentOrChromelessEditor = false)=>(tr)=>{
        if (!tableRef) return tr;
        const { node: node, start: start, parentWidth: parentWidth, layoutChanged: layoutChanged } = options;
        // If a table has not been resized yet, columns should be auto.
        if ((0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(node) === false) {
            // If its not a re-sized table, we still want to re-create cols
            // To force reflow of columns upon delete.
            if (!isTableScalingEnabledOnCurrentTable) {
                const isTableScalingEnabled = false;
                (0, $d7e0ca7a06057b05$export$ae5d9647f2a0891c)(tableRef, node, isTableScalingEnabled, undefined, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor);
            }
            tr.setMeta('scrollIntoView', false);
            return tr;
        }
        let resizeState;
        if (parentWidth) {
            // When the table is nested inside a bodiedSyncBlock, the table's outer transparent
            // left/right borders (1px total under `border-collapse: collapse`) cause the
            // table's outer width to exceed the colgroup width by 1px. Subtract 1px from the
            // parentWidth here so that the scaled colgroup fits within the sync-block
            // container without overflowing.
            const isNestedInBodiedSyncBlock = !!tableRef.closest?.(`.${(0, $e6n00.BodiedSyncBlockSharedCssClassName).content}`) && (0, $dh538.fg)('platform_synced_block_patch_9');
            const BORDER_COLLAPSE_WIDTH_PX = 1;
            const adjustedParentWidth = isNestedInBodiedSyncBlock ? parentWidth - BORDER_COLLAPSE_WIDTH_PX : parentWidth;
            resizeState = $0e5c6cf05dff4e80$var$scaleWithParent(tableRef, adjustedParentWidth, node, start, domAtPos, isTableScalingEnabledOnCurrentTable, shouldUseIncreasedScalingPercent);
        } else resizeState = $0e5c6cf05dff4e80$var$scale(tableRef, options, domAtPos, isTableScalingEnabledOnCurrentTable, shouldUseIncreasedScalingPercent);
        if (resizeState) {
            tr = (0, $b2a65d666c2c28a8$export$6688b13ec132acdf)(resizeState, node, start, api)(tr);
            if (tr.docChanged) {
                tr.setMeta('scrollIntoView', false);
                // TODO: ED-8995 - We need to do this check to reduce the number of race conditions when working with tables.
                // This metadata is been used in the sendTransaction function in the Collab plugin
                /* Added !layoutChanged check here to solve unnecessary scroll bar after publish when click on breakout button multiple times and publish
           scaleTable is only called once every time a breakout button is clicked, so it is safe not to add the meta 'scaleTable' to the tr.
           Leaving the tr.setMeta('scaleTable', true) here for race conditions that we aren't aware of.
         */ !layoutChanged && tr.setMeta('scaleTable', true);
                return tr;
            }
        }
        return tr;
    };


const $b2a65d666c2c28a8$export$6688b13ec132acdf = (resizeState, table, start, api)=>(tr)=>{
        const map = (0, $LmqWp.TableMap).get(table);
        const updatedCellsAttrs = {};
        const steps = [];
        // calculating new attributes for each cell
        for(let columnIndex = 0; columnIndex < map.width; columnIndex++)for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            let { width: width } = resizeState.cols[columnIndex];
            if (resizeState.isScaled) // Ensure that the width is an integer if the table has been scaled
            width = Math.floor(width);
            const mapIndex = rowIndex * map.width + columnIndex;
            const cellPos = map.map[mapIndex];
            const attrs = updatedCellsAttrs[cellPos] || {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                ...table.nodeAt(cellPos).attrs
            };
            const colspan = attrs.colspan || 1;
            if (attrs.colwidth && attrs.colwidth.length > colspan) attrs.colwidth = attrs.colwidth.slice(0, colspan);
            // Rowspanning cell that has already been handled
            if (rowIndex && map.map[mapIndex] === map.map[mapIndex - map.width]) continue;
            const colspanIndex = colspan === 1 ? 0 : columnIndex - map.colCount(cellPos);
            if (attrs.colwidth && attrs.colwidth[colspanIndex] === width) continue;
            let colwidths = attrs.colwidth ? attrs.colwidth.slice() : Array.from({
                length: colspan
            }, (_)=>0);
            colwidths[colspanIndex] = width;
            if (colwidths.length > colspan) colwidths = colwidths.slice(0, colspan);
            updatedCellsAttrs[cellPos] = {
                ...attrs,
                colwidth: colwidths.includes(0) ? undefined : colwidths
            };
        }
        // updating all cells with new attributes
        const seen = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++)for(let columnIndex = 0; columnIndex < map.width; columnIndex++){
            const mapIndex = rowIndex * map.width + columnIndex;
            const pos = map.map[mapIndex];
            const cell = table.nodeAt(pos);
            if (!seen[pos] && cell) {
                if (updatedCellsAttrs[pos]) steps.push(new (0, $aXG5V.AttrStep)(pos + start, 'colwidth', updatedCellsAttrs[pos].colwidth === undefined ? null : updatedCellsAttrs[pos].colwidth));
                seen[pos] = true;
            }
        }
        if (api?.batchAttributeUpdates) {
            const batchStep = api.batchAttributeUpdates.actions.batchSteps({
                steps: steps,
                doc: tr.doc
            });
            tr.step(batchStep);
        } else steps.forEach((s)=>{
            tr.step(s);
        });
        return tr;
    };
const $b2a65d666c2c28a8$export$81edad89dedd3529 = (isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, api, isCommentEditor = false)=>(table, view)=>(tr)=>{
            if (!view) return tr;
            const newTable = tr.doc.nodeAt(table.pos);
            const domAtPos = view.domAtPos.bind(view);
            const maybeTable = domAtPos(table.start).node;
            const maybeTableElement = maybeTable instanceof HTMLElement ? maybeTable : null;
            const tableRef = maybeTableElement?.closest('table');
            if (!tableRef || !newTable) return tr;
            const isResized = (0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(table.node);
            let previousTableInfo = {
                width: 0,
                possibleMaxWidth: 0,
                isResized: isResized
            };
            const tableDepth = view.state.doc.resolve(table.pos).depth;
            let shouldScale = isTableScalingEnabled && tableDepth === 0;
            if (shouldScale && isTableFixedColumnWidthsOptionEnabled) shouldScale = newTable.attrs.displayMode !== 'fixed';
            if (shouldScale) previousTableInfo = {
                width: (0, $b61fc0745b235461$export$44361276769f7eff)(table.node),
                possibleMaxWidth: (0, $b61fc0745b235461$export$a34136fcfaec1907)(table.node),
                isResized: isResized
            };
            else previousTableInfo = {
                // when table is resized the tableRef client width will be 1px larger than colGroup, which is used in calculations
                width: isResized ? tableRef.clientWidth - 1 : tableRef.clientWidth,
                /** the is the width the table can reach before overflowing */ possibleMaxWidth: tableRef?.parentElement?.clientWidth || 0,
                isResized: isResized
            };
            // determine the new table, based on new width
            const newTableInfo = {
                noOfColumns: (0, $LmqWp.TableMap).get(newTable).width
            };
            if (!newTableInfo.noOfColumns || newTableInfo.noOfColumns <= 0) return tr;
            const averageColumnWidth = previousTableInfo.width / newTableInfo.noOfColumns;
            // If the table has not been resized (i.e. all columns will have the same width) and every column width is bigger than the minimum column width
            // we skip updating the size of columns here.
            if (!previousTableInfo.isResized && averageColumnWidth > (0, $1zav4.tableCellMinWidth)) return tr;
            const wasTableInOverflow = previousTableInfo.width > previousTableInfo.possibleMaxWidth;
            // If the table has not been resized, and each column width is smaller than the minimum column width
            // Or if the table has been resized, but each column width is either 48px or null
            // we update the table to have 48px for each column
            if (!previousTableInfo.isResized && averageColumnWidth <= (0, $1zav4.tableCellMinWidth) || previousTableInfo.isResized && (0, $d7e0ca7a06057b05$export$2878318085bf6dbf)(table.node)) {
                const widths = new Array(newTableInfo.noOfColumns).fill((0, $1zav4.tableCellMinWidth));
                const cols = widths.map((_, index)=>({
                        width: (0, $1zav4.tableCellMinWidth),
                        minWidth: (0, $1zav4.tableCellMinWidth),
                        index: index
                    }));
                const minWidthResizeState = {
                    cols: cols,
                    widths: widths,
                    maxSize: previousTableInfo.possibleMaxWidth,
                    tableWidth: previousTableInfo.width,
                    overflow: wasTableInOverflow
                };
                return $b2a65d666c2c28a8$export$6688b13ec132acdf(minWidthResizeState, table.node, table.start, api)(tr);
            }
            let resizeState = (0, $77650a1f6e0f1ab2$export$38f73cf370cfaafc)({
                minWidth: (0, $1zav4.tableCellMinWidth),
                table: table.node,
                start: table.start,
                tableRef: tableRef,
                domAtPos: domAtPos,
                maxSize: previousTableInfo.possibleMaxWidth,
                isTableScalingEnabled: shouldScale,
                shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                isCommentEditor: isCommentEditor
            });
            // Two scenarios that require scaling:
            //   1. If the new table width will result in the table going into overflow
            //      we resize the cells to avoid it (e.g. adding a column)
            //   2. If the new table width will be shorter than the parent width, scale columns to fit parent
            if (!wasTableInOverflow && resizeState.overflow || resizeState.tableWidth < resizeState.maxSize) resizeState = (0, $0e5c6cf05dff4e80$export$5de2ae9923ce5a0)(resizeState, previousTableInfo.possibleMaxWidth);
            return $b2a65d666c2c28a8$export$6688b13ec132acdf(resizeState, table.node, table.start, api)(tr);
        };





/**
 * Direct copy from adf-schema to kill circular dependency without pulling into
 * a new package
 */ /* eslint-disable no-bitwise */ const $be162319d9eff55e$export$1c3aefb711c3a4cc = ()=>// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $be162319d9eff55e$var$staticValue = false;
const $be162319d9eff55e$export$31b40729666a4ae0 = {
    setStatic (value) {
        $be162319d9eff55e$var$staticValue = value;
    },
    generate () {
        return $be162319d9eff55e$var$staticValue || $be162319d9eff55e$export$1c3aefb711c3a4cc();
    }
};


const $4efd607b0fe3314c$var$createCell = (cellType, cellContent)=>{
    if (cellContent) return cellType.createChecked(null, cellContent);
    return cellType.createAndFill();
};
const $4efd607b0fe3314c$export$33bbb3ec7652e187 = ({ schema: schema, rowsCount: rowsCount = 3, colsCount: colsCount = 3, withHeaderRow: withHeaderRow = true, cellContent: cellContent, tableWidth: tableWidth, layout: // default to undefined so PM will use default value defined in schema
layout })=>{
    const { cell: tableCell, header_cell: tableHeader, row: tableRow, table: table } = (0, $d1kIV.tableNodeTypes)(schema);
    const cells = [];
    const headerCells = [];
    for(let i = 0; i < colsCount; i++){
        const cell = $4efd607b0fe3314c$var$createCell(tableCell, cellContent);
        if (cell) cells.push(cell);
        if (withHeaderRow) {
            const headerCell = $4efd607b0fe3314c$var$createCell(tableHeader, cellContent);
            if (headerCell) headerCells.push(headerCell);
        }
    }
    const rows = [];
    for(let i = 0; i < rowsCount; i++)rows.push(tableRow.createChecked(null, withHeaderRow && i === 0 ? headerCells : cells));
    const width = tableWidth === 'inherit' ? undefined : tableWidth === undefined ? 760 : tableWidth;
    return table.createChecked({
        localId: (0, $be162319d9eff55e$export$31b40729666a4ae0).generate(),
        width: width,
        layout: layout
    }, rows);
};






const $93be038868ed0558$var$NESTED_TABLE_DEFAULT_ROWS = 2;
const $93be038868ed0558$var$NESTED_TABLE_DEFAULT_COLS = 2;
const $93be038868ed0558$export$5003ecb973fc11c2 = ({ isTableScalingEnabled: isTableScalingEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled, isFullWidthModeEnabled: isFullWidthModeEnabled, isMaxWidthModeEnabled: isMaxWidthModeEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor, isTableResizingEnabled: isTableResizingEnabled, isNestedTable: isNestedTable, createTableProps: createTableProps })=>(schema)=>{
        const attrsOverrides = {};
        if (isNestedTable) {
            attrsOverrides.rowsCount = createTableProps?.rowsCount ? createTableProps?.rowsCount : $93be038868ed0558$var$NESTED_TABLE_DEFAULT_ROWS;
            attrsOverrides.colsCount = createTableProps?.colsCount ? createTableProps?.colsCount : $93be038868ed0558$var$NESTED_TABLE_DEFAULT_COLS;
        }
        if (isTableScalingEnabled && !isCommentEditor) {
            if (((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && isMaxWidthModeEnabled) attrsOverrides.tableWidth = (0, $8588522c22c049a0$export$8a91b25da594a758);
            else if (isFullWidthModeEnabled) attrsOverrides.tableWidth = (0, $8588522c22c049a0$export$bffd6819c009a916);
        }
        if (isTableAlignmentEnabled && (isFullWidthModeEnabled || ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) && isMaxWidthModeEnabled || isCommentEditor)) attrsOverrides.layout = 'align-start';
        if (isCommentEditor && isTableResizingEnabled || isChromelessEditor) attrsOverrides.tableWidth = 'inherit';
        return (0, $4efd607b0fe3314c$export$33bbb3ec7652e187)({
            schema: schema,
            ...createTableProps,
            ...attrsOverrides
        });
    };



function $b53892aeb6ce63cd$export$f8ddfdc64e14a808(state) {
    const tablePluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    return Boolean(tablePluginState) && Boolean(tablePluginState.pluginConfig.allowAddColumnWithCustomStep);
}




function $6921de1f1a31eb9c$var$addColumnAtCustomStep(column) {
    return (tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (table) return tr.step((0, $1rJN9.AddColumnStep).create(tr.doc, table.pos, column));
        return tr;
    };
}
function $6921de1f1a31eb9c$export$93d48be6ee61745(api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor) {
    return (column, allowAddColumnCustomStep = false, view)=>{
        return (tr)=>{
            let updatedTr = tr;
            if (allowAddColumnCustomStep) updatedTr = $6921de1f1a31eb9c$var$addColumnAtCustomStep(column)(updatedTr);
            else updatedTr = (0, $8fbf19abc35dbd28$export$93d48be6ee61745)(column)(updatedTr);
            const table = (0, $id9O1.findTable)(updatedTr.selection);
            if (table) // [ED-8288] Update colwidths manually to avoid multiple dispatch in TableComponent
            updatedTr = (0, $b2a65d666c2c28a8$export$81edad89dedd3529)(isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, api, isCommentEditor)(table, view)(updatedTr);
            if (view) updatedTr = (0, $b6ae840bbb0dbfb0$export$800a77929fdae774)({
                type: 'column'
            }, 'addRowOrColumn')(view.state, updatedTr);
            updatedTr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
                name: (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).ADDED_COLUMN
            });
            return updatedTr;
        };
    };
}
const $6921de1f1a31eb9c$export$717d5ccb817cdecc = (api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(state, dispatch, view)=>{
        const table = (0, $id9O1.findTable)(state.selection);
        if (!table) return false;
        if (dispatch) {
            const rect = (0, $2QyFu.selectedRect)(state);
            dispatch($6921de1f1a31eb9c$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(rect.left, (0, $b53892aeb6ce63cd$export$f8ddfdc64e14a808)(state), view)(state.tr));
        }
        return true;
    };
const $6921de1f1a31eb9c$export$bf95f7b7d259c19f = (api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)=>(state, dispatch, view)=>{
        const table = (0, $id9O1.findTable)(state.selection);
        if (!table) return false;
        if (dispatch) {
            const rect = (0, $2QyFu.selectedRect)(state);
            dispatch($6921de1f1a31eb9c$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(rect.right, (0, $b53892aeb6ce63cd$export$f8ddfdc64e14a808)(state), view)(state.tr));
        }
        return true;
    };
const $6921de1f1a31eb9c$export$35ae1d3df4b27cf0 = (api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)=>(column)=>(state, dispatch, view)=>{
            const tr = $6921de1f1a31eb9c$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(column, (0, $b53892aeb6ce63cd$export$f8ddfdc64e14a808)(state), view)(state.tr);
            const table = (0, $id9O1.findTable)(tr.selection);
            if (!table) return false;
            // move the cursor to the newly created column
            const pos = (0, $LmqWp.TableMap).get(table.node).positionAt(0, column, table.node);
            if (dispatch) dispatch(tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(table.start + pos))));
            return true;
        };
const $6921de1f1a31eb9c$export$5a4e94bbc04b5f2 = (row, moveCursorToTheNewRow)=>(state, dispatch)=>{
        // Don't clone the header row
        const headerRowEnabled = (0, $bdb0299b531c40df$export$b8efdc0183f04d59)(state.selection);
        const clonePreviousRow = headerRowEnabled && row > 1 || !headerRowEnabled && row > 0;
        // When the table have header row
        // we should not add row on the position zero
        if (row === 0 && headerRowEnabled) return false;
        const tr = clonePreviousRow ? (0, $885c1a71dd6e181b$export$173c92a3a1ff68a7)(state.schema)(row)(state.tr) : (0, $da196c89e6ffa52b$export$643f25d380b0167d)(row, undefined)(state.tr);
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return false;
        if (dispatch) {
            const { selection: selection } = state;
            if (moveCursorToTheNewRow) {
                // move the cursor to the newly created row
                const pos = (0, $LmqWp.TableMap).get(table.node).positionAt(row, 0, table.node);
                tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(table.start + pos)));
            } else tr.setSelection(selection.map(tr.doc, tr.mapping));
            (0, $b6ae840bbb0dbfb0$export$800a77929fdae774)({
                type: 'row'
            }, 'addRowOrColumn')(state, tr);
            dispatch(tr);
        }
        return true;
    };
const $6921de1f1a31eb9c$export$33bbb3ec7652e187 = (isTableScalingEnabled, isTableAlignmentEnabled, isFullWidthModeEnabled, isMaxWidthModeEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor, isTableResizingEnabled)=>(state, dispatch)=>{
        const table = (0, $93be038868ed0558$export$5003ecb973fc11c2)({
            isTableScalingEnabled: isTableScalingEnabled,
            isTableAlignmentEnabled: isTableAlignmentEnabled,
            isFullWidthModeEnabled: isFullWidthModeEnabled,
            isMaxWidthModeEnabled: isMaxWidthModeEnabled,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            isTableResizingEnabled: isTableResizingEnabled
        })(state.schema);
        if (dispatch) {
            const tr = (0, $8m4tT.safeInsert)(table)(state.tr).scrollIntoView();
            if (editorAnalyticsAPI) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TABLE,
                attributes: {
                    inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            })(tr);
            dispatch(tr);
        }
        return true;
    };
const $6921de1f1a31eb9c$export$505b7f2cb88dd074 = (isFullWidthModeEnabled, isMaxWidthModeEnabled, isTableScalingEnabled, isTableAlignmentEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor)=>(rowsCount, colsCount, inputMethod)=>{
        return ({ tr: tr })=>{
            const tableNode = (0, $93be038868ed0558$export$5003ecb973fc11c2)({
                isTableScalingEnabled: isTableScalingEnabled,
                isFullWidthModeEnabled: isFullWidthModeEnabled,
                isMaxWidthModeEnabled: isMaxWidthModeEnabled,
                isTableAlignmentEnabled: isTableAlignmentEnabled,
                isCommentEditor: isCommentEditor,
                isChromelessEditor: isChromelessEditor,
                createTableProps: {
                    rowsCount: rowsCount,
                    colsCount: colsCount
                }
            })(tr.doc.type.schema);
            const newTr = (0, $8m4tT.safeInsert)(tableNode)(tr).scrollIntoView();
            if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $d925B.ACTION).INSERTED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TABLE,
                attributes: {
                    inputMethod: inputMethod,
                    totalRowCount: rowsCount,
                    totalColumnCount: colsCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            })(newTr);
            return newTr;
        };
    };
const $6921de1f1a31eb9c$export$b57b177fe1ab7f1f = ({ isTableScalingEnabled: isTableScalingEnabled = false, isTableAlignmentEnabled: isTableAlignmentEnabled = false, isFullWidthModeEnabled: isFullWidthModeEnabled = false, isMaxWidthModeEnabled: isMaxWidthModeEnabled = false, isCommentEditor: isCommentEditor = false, isChromelessEditor: isChromelessEditor = false, isTableResizingEnabled: isTableResizingEnabled = false, createTableProps: createTableProps = {} }, api, analyticsPayload)=>({ tr: tr })=>{
        const { schema: schema } = tr.doc.type;
        // If the cursor is inside a table
        let insertAt;
        let isNestedTable = false;
        if ((0, $8m4tT.hasParentNodeOfType)(schema.nodes.table)(tr.selection) && (0, $sxTNo.isNestedTablesSupported)(schema)) {
            // If trying to nest deeper than one level, we insert the table after the top table
            if ((0, $sxTNo.getParentOfTypeCount)(schema.nodes.table)(tr.selection.$from) > 1) {
                const positionAfterTopTable = (0, $sxTNo.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(tr.selection.$from);
                if (!positionAfterTopTable) return tr;
                insertAt = (0, $ks2lK.TextSelection).create(tr.doc, positionAfterTopTable);
            } else // Table can be nested in parent table
            isNestedTable = true;
        }
        const node = (0, $93be038868ed0558$export$5003ecb973fc11c2)({
            isTableScalingEnabled: isTableScalingEnabled,
            isTableAlignmentEnabled: isTableAlignmentEnabled,
            isFullWidthModeEnabled: isFullWidthModeEnabled,
            isMaxWidthModeEnabled: isMaxWidthModeEnabled,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            isTableResizingEnabled: isTableResizingEnabled,
            isNestedTable: isNestedTable,
            createTableProps: createTableProps
        })(schema);
        api?.contentInsertion?.commands?.insert({
            node: node,
            options: {
                selectNodeInserted: false,
                analyticsPayload: analyticsPayload ? {
                    ...analyticsPayload,
                    attributes: {
                        ...analyticsPayload.attributes,
                        localId: node.attrs.localId
                    }
                } : undefined,
                insertAt: insertAt
            }
        })({
            tr: tr
        });
        return tr;
    };


const $46b4a5487442d4d4$export$c23fbabe48bd9130 = (config = {})=>{
    return config.advanced ? {
        allowBackgroundColor: true,
        allowColumnResizing: true,
        allowHeaderColumn: true,
        allowHeaderRow: true,
        allowMergeCells: true,
        allowNumberColumn: true,
        permittedLayouts: 'all',
        allowControls: true,
        ...config
    } : config;
};


















var $9KolL = parcelRequire("9KolL");


var $2v1PW = parcelRequire("2v1PW");


var $51lK8 = parcelRequire("51lK8");


var $bSjaC = parcelRequire("bSjaC");


var $4T4vf = parcelRequire("4T4vf");











const $c2cd42e9bb213cdd$export$835df158d20ae2f0 = (node)=>{
    return Boolean(node && ([
        'TH',
        'TD'
    ].indexOf(node.tagName) > -1 || !!(0, $4vlwG.closestElement)(node, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL}`) || !!(0, $4vlwG.closestElement)(node, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL}`)));
};
const $c2cd42e9bb213cdd$export$94cf9243187b20f0 = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON);
const $c2cd42e9bb213cdd$export$7a8d111d40fb198c = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_ROW) || (0, $4vlwG.closestElement)(node, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_ROW}`) || (0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_OVERLAY) && (0, $4vlwG.closestElement)(node, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS}`);
const $c2cd42e9bb213cdd$export$e5e82c478fd9ea3 = (target)=>[
        parseInt(target.getAttribute('data-start-index') || '-1', 10),
        parseInt(target.getAttribute('data-end-index') || '-1', 10)
    ];
const $c2cd42e9bb213cdd$export$14eb53395cc0cf57 = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS);
const $c2cd42e9bb213cdd$export$edad492f0c70264f = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON) || (0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON);
const $c2cd42e9bb213cdd$export$4cf9002f70d2d324 = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION);
const $c2cd42e9bb213cdd$export$b4f0758743701ac9 = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON) || (0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP);
const $c2cd42e9bb213cdd$export$2b59104f44ee317b = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER) || (0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER);
const $c2cd42e9bb213cdd$export$b2ae534578c0ae33 = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER);
const $c2cd42e9bb213cdd$export$666ae3fd07127e7f = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER);
const $c2cd42e9bb213cdd$export$571c943db7bc729c = (node)=>(0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON) || (0, $4vlwG.containsClassName)(node, (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER);
const $c2cd42e9bb213cdd$export$3dde6150a2e2df0a = (mouseEvent, offsetX, gapInPixels)=>{
    const element = mouseEvent.target;
    if (element instanceof HTMLElement) {
        const width = element.clientWidth; // reflow
        const x = !Number.isNaN(offsetX) ? offsetX : mouseEvent.offsetX; // reflow
        if (width <= 0) return null;
        if (!gapInPixels) return x / width > 0.5 ? 'right' : 'left';
        else {
            if (x <= gapInPixels) return 'left';
            else if (x >= width - gapInPixels) return 'right';
        }
    }
    return null;
};
const $c2cd42e9bb213cdd$export$3bf5911758d564a4 = (mouseEvent)=>{
    const element = mouseEvent.target;
    if (element instanceof HTMLElement) {
        const elementRect = element.getBoundingClientRect();
        if (elementRect.height <= 0) return null;
        const y = mouseEvent.clientY - elementRect.top;
        return y / elementRect.height > 0.5 ? 'bottom' : 'top';
    }
    return null;
};
const $c2cd42e9bb213cdd$export$80e4fcc9d7220616 = ({ columnEndIndexTarget: columnEndIndexTarget, target: target })=>{
    const tableElement = (0, $4vlwG.closestElement)(target, 'table');
    if (!tableElement) return false;
    const query = [
        `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION}`,
        `[data-end-index="${columnEndIndexTarget}"]`
    ];
    const decorationElement = tableElement.querySelectorAll(query.join(''));
    if (!decorationElement || decorationElement.length === 0) return false;
    return true;
};
const $c2cd42e9bb213cdd$export$b76263aac816aadb = (tr)=>{
    // pm renders into tbody, owned by react
    const tbody = tr.parentElement;
    if (!tbody) return null;
    // rendered by react
    const table = tbody.parentElement;
    if (!table) return null;
    // rendered by react
    const wrapper = table.parentElement;
    if (!wrapper) return null;
    return {
        wrapper: wrapper,
        table: table
    };
};
const $c2cd42e9bb213cdd$export$449115d164fc37c3 = (element)=>{
    if (!element || element instanceof Window) return 0;
    return element?.getBoundingClientRect?.()?.top ?? 0;
};
const $c2cd42e9bb213cdd$export$fe489db90f7f492a = (x, y)=>{
    const elements = document.elementsFromPoint(x, y);
    const cell = elements.find((el)=>el.nodeName.toUpperCase() === 'TD' || el.nodeName.toUpperCase() === 'TH');
    const row = cell?.parentElement ?? undefined;
    if (!Number.isFinite(row?.rowIndex) || !Number.isFinite(cell?.cellIndex)) return undefined;
    return {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        row: row.rowIndex,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        col: cell.cellIndex
    };
};
const $c2cd42e9bb213cdd$export$732358707dcc2511 = (entry)=>{
    const rects = [
        entry.boundingClientRect,
        entry.rootBounds,
        entry.intersectionRect
    ];
    return rects.every((rect)=>rect && rect.width === 0 && rect.height === 0 && rect.top === 0 && rect.left === 0 && rect.bottom === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0);
};







const $0e87c5ebb1bfe871$var$getRect = (index, type, map)=>{
    if (type === 'column') {
        const x = Math.max(Math.min(index, map.width - 1), 0); // clamped index
        return {
            left: x,
            right: x === index ? x + 1 : x,
            top: 0,
            bottom: map.height
        };
    } else {
        const y = Math.max(Math.min(index, map.height - 1), 0); // clamped index
        return {
            left: 0,
            right: map.width,
            top: y,
            bottom: y === index ? y + 1 : y
        };
    }
};
const $0e87c5ebb1bfe871$export$6e6c0cf88a287d8 = (indexes, type)=>(selection)=>{
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return false;
        const map = (0, $LmqWp.TableMap).get(table.node);
        const cellPositions = new Set();
        const mergedCells = new Set();
        map.map.forEach((value)=>{
            if (cellPositions.has(value)) mergedCells.add(value);
            else cellPositions.add(value);
        });
        if (!mergedCells.size) return false;
        const getMergedCellsInRect = (index, type)=>{
            const rect = $0e87c5ebb1bfe871$var$getRect(index, type, map);
            const isValidRectangle = rect.left < rect.right && rect.top < rect.bottom;
            if (!isValidRectangle) return [];
            const cells = map.cellsInRect(rect);
            let allCellsInRect = [];
            if (type === 'column') allCellsInRect = map.map.filter((_, key)=>key % map.width === index);
            else allCellsInRect = map.map.filter((_, key)=>Math.floor(key / map.width) === index);
            const mergedCell = allCellsInRect.filter((nodePos)=>{
                return !cells.includes(nodePos) // cell exists in Rect but not show in the map.cellsInRect list => merged cell
                 ? true : mergedCells.has(nodePos); // cell includes in mergedCells => merged cell
            });
            return [
                ...new Set(mergedCell)
            ];
        };
        const mergedCellsInRectArr = indexes.map((index)=>getMergedCellsInRect(index, type));
        // Currently only support 2 indexes, but we can extend this to support more indexes in the future.
        return mergedCellsInRectArr[0].some((cell)=>mergedCellsInRectArr[1].includes(cell));
    };
const $0e87c5ebb1bfe871$export$834c4ba4fe64e8f2 = (colIndex, selection)=>{
    const table = (0, $id9O1.findTable)(selection);
    if (!table) return false;
    const tableMap = (0, $LmqWp.TableMap).get(table.node);
    const { width: width } = tableMap;
    if (width <= 1) return false;
    if (colIndex < 0 || colIndex > width - 1) return false;
    const { map: map } = tableMap;
    // j is an index in the tableMap.map array. tableMap.map is a flat array.
    // Each item of this array contains a number.
    // The number represents the position of the corresponding cell in the tableMap. It exists for each cell.
    // If there are merged cells, their positions will be represented by the same number.
    const isFirstColumn = colIndex === 0;
    const isLastColumn = colIndex === width - 1;
    for(let j = colIndex; j < map.length; j += width){
        if (!isFirstColumn && map[j] === map[j - 1] || // compare with a cell in the column on the left
        !isLastColumn && map[j] === map[j + 1] // compare with a cell in the column on the right
        ) return true;
    }
    return false;
};
const $0e87c5ebb1bfe871$export$7ef37f297601e698 = (rowIndex, selection)=>{
    const table = (0, $id9O1.findTable)(selection);
    if (!table) return false;
    const tableMap = (0, $LmqWp.TableMap).get(table.node);
    const { height: height } = tableMap;
    if (height <= 1) return false;
    if (rowIndex < 0 || rowIndex > height - 1) return false;
    const { map: map, width: width } = tableMap; // map is a flat array representing position of each cell in the table.
    const indexOfFirstCellInTheRow = rowIndex * width;
    const indexOfLastCellInTheRow = indexOfFirstCellInTheRow + width - 1;
    const isFirstRow = rowIndex === 0;
    const isLastRow = rowIndex === height - 1;
    // j is an index of a cell in a row
    for(let j = indexOfFirstCellInTheRow; j <= indexOfLastCellInTheRow; j++){
        if (!isFirstRow && map[j] === map[j - width] || // compare with a cell in the row above
        !isLastRow && map[j] === map[j + width] // compare with a cell in the row below
        ) return true;
    }
    return false;
};
const $0e87c5ebb1bfe871$export$e4c313e419348ae7 = (indexes, type)=>(selection)=>{
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return false;
        const map = (0, $LmqWp.TableMap).get(table.node);
        if (!map.hasMergedCells()) return false;
        return $0e87c5ebb1bfe871$export$9af117e01db30223(indexes, map, type);
    };
const $0e87c5ebb1bfe871$export$9af117e01db30223 = (indexes, tableMap, direction)=>{
    const { mapByRow: mapByRow, mapByColumn: mapByColumn } = tableMap;
    const map = 'row' === direction ? mapByRow : mapByColumn;
    const lengthLimiter = direction === 'row' ? tableMap.width : tableMap.height;
    const minIndex = Math.min(...indexes);
    const maxIndex = Math.max(...indexes);
    let isTopSideHaveMergedCells = false;
    let isBottomSideHaveMergedCells = false;
    /**
   * this is to check if the cell position from last focused table is overflow. since if you selection from a cell in 6th row and 7th column cell in a 7x8 table to 3x3 table, the cell position will be overflow because new table dont have this cell at all.
   TODO: ED-22335 this should better called only when hover over the drag handle.
  */ const isOldMinIndex = !map[minIndex - 1] || !map[minIndex];
    const isOldMaxIndex = !map[maxIndex + 1] || !map[maxIndex];
    if (minIndex > 0 && !isOldMinIndex) {
        const prevSelectionSet = map[minIndex - 1];
        const minSelectionSet = map[minIndex];
        for(let i = 0; i < lengthLimiter; i++)if (prevSelectionSet[i] === minSelectionSet[i]) {
            isTopSideHaveMergedCells = true;
            break;
        }
    }
    if (maxIndex < map.length - 1 && !isOldMaxIndex) {
        const afterSelectionSet = map[maxIndex + 1];
        const maxSelectionSet = map[maxIndex];
        for(let i = 0; i < lengthLimiter; i++)if (afterSelectionSet[i] === maxSelectionSet[i]) {
            isBottomSideHaveMergedCells = true;
            break;
        }
    }
    return isTopSideHaveMergedCells || isBottomSideHaveMergedCells;
};
const $0e87c5ebb1bfe871$export$1d4a5608e72f1096 = (array)=>{
    if (!array) return [];
    return array.filter((item, index)=>array.indexOf(item) !== index);
};


const $769dcbe1acb4060b$export$b6bb967ba58ec81c = {
    SET_DROP_TARGET: 'SET_DROP_TARGET',
    CLEAR_DROP_TARGET: 'CLEAR_DROP_TARGET',
    TOGGLE_DRAG_MENU: 'TOGGLE_DRAG_MENU'
};














function $53e8172627dd7927$export$9206f249edb43d1b(table, tableMap, types) {
    // We only really need to check the nth (last) cell in the row/col if it's a header, since we only support a single full row/col header on the top & left
    // of a table. We can assume that if the nth (last) cell is also a header then the entire row/col is a header.
    // Be careful though! when checking the 1st cell as it shares its header state with both row/cols.
    // This means we won't be able to reliably identify header state on tables smaller than 2x2, however we can make a best guess.
    // This is a 3 bit mask;
    // bit: 0 = Identifies if the cell at (0, 0) (row, col - 0-based) is a header cell or not
    // bit: 1 = Identifies if the cell at (0, n) is a header cell or not
    // bit: 2 = Identifies if the cell at (n, 0) is a header cell or not
    let mask = 0;
    const isExperimentEnabled = (0, $1oCLl.expValEquals)('platform_editor_analyse_table_with_merged_cells', 'isEnabled', true);
    // At minimum we should have 1 cell in the table.
    const topLeftCell = table.nodeAt(tableMap.map[0]);
    // If this cell is a header that could indicate
    mask |= topLeftCell && topLeftCell.type === types.header_cell ? 1 : 0;
    if (tableMap.width > 1) {
        const cell = isExperimentEnabled ? table.nodeAt(tableMap.map[tableMap.width - 1]) : table.nodeAt(tableMap.map[1]);
        // If the cell at (0, n) is a header then we set the bit flag to indicate row headers are enabled, otherwise if it's
        // not then we will set the col headers enabled flag (and vice versa in the branch below) only if the cell at (0,0)
        // was a header cell.
        mask |= cell && cell.type === types.header_cell ? 2 : 4 * (mask & 1);
    }
    if (tableMap.height > 1) {
        const cell = isExperimentEnabled ? table.nodeAt(tableMap.map[tableMap.width * (tableMap.height - 1)]) : table.nodeAt(tableMap.map[tableMap.width]);
        mask |= cell && cell.type === types.header_cell ? 4 : 2 * (mask & 1);
    }
    return {
        rowHeaderEnabled: mask === 7 || mask === 3,
        columnHeaderEnabled: mask === 7 || mask === 5
    };
}










const $c544c9e42ea52662$export$7032a6f0de5ecc29 = (startColIndex, endColIndex = startColIndex)=>(tr)=>{
        let startIndex = startColIndex;
        let endIndex = endColIndex;
        // looking for selection start column (startIndex)
        for(let i = startColIndex; i >= 0; i--){
            const cells = (0, $40458289442cabaf$export$c14b77638b178c5d)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.colspan + i - 1;
                if (maybeEndIndex >= startIndex) startIndex = i;
                if (maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // looking for selection end column (endIndex)
        for(let i = startColIndex; i <= endIndex; i++){
            const cells = (0, $40458289442cabaf$export$c14b77638b178c5d)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.colspan + i - 1;
                if (cell.node.attrs.colspan > 1 && maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // filter out columns without cells (where all rows have colspan > 1 in the same column)
        const indexes = [];
        for(let i = startIndex; i <= endIndex; i++){
            const maybeCells = (0, $40458289442cabaf$export$c14b77638b178c5d)(i)(tr.selection);
            if (maybeCells && maybeCells.length) indexes.push(i);
        }
        startIndex = indexes[0];
        endIndex = indexes[indexes.length - 1];
        const firstSelectedColumnCells = (0, $40458289442cabaf$export$c14b77638b178c5d)(startIndex)(tr.selection);
        const firstRowCells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(0)(tr.selection);
        if (!firstSelectedColumnCells || !firstRowCells) return;
        const $anchor = tr.doc.resolve(firstSelectedColumnCells[firstSelectedColumnCells.length - 1].pos);
        let headCell;
        for(let i = endIndex; i >= startIndex; i--){
            const columnCells = (0, $40458289442cabaf$export$c14b77638b178c5d)(i)(tr.selection);
            if (columnCells && columnCells.length) {
                for(let j = firstRowCells.length - 1; j >= 0; j--)if (firstRowCells[j].pos === columnCells[0].pos) {
                    headCell = columnCells[0];
                    break;
                }
                if (headCell) break;
            }
        }
        if (!headCell) return;
        const $head = tr.doc.resolve(headCell.pos);
        return {
            $anchor: $anchor,
            $head: $head,
            indexes: indexes
        };
    };





const $6c611051a8223ad8$export$9cb09a71b7d66923 = (array)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return array[0].map((_, i)=>{
        return array.map((column)=>column[i]);
    });
};
const $6c611051a8223ad8$export$5c8f3870f9ad667 = (tableNode, arrayOfNodes)=>{
    const rowsPM = [];
    const map = (0, $LmqWp.TableMap).get(tableNode);
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const row = tableNode.child(rowIndex);
        const rowCells = [];
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            if (!arrayOfNodes[rowIndex][colIndex]) continue;
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = arrayOfNodes[rowIndex][colIndex];
            const oldCell = tableNode.nodeAt(cellPos);
            if (!cell || !oldCell) continue;
            const newCell = oldCell.type.createChecked(Object.assign({}, cell.attrs), cell.content, cell.marks);
            rowCells.push(newCell);
        }
        rowsPM.push(row.type.createChecked(row.attrs, rowCells, row.marks));
    }
    const newTable = tableNode.type.createChecked(tableNode.attrs, rowsPM, tableNode.marks);
    return newTable;
};
const $6c611051a8223ad8$var$moveRowInArrayOfRows = (arrayOfNodes, indexesOrigin, indexesTarget, directionOverride)=>{
    const direction = indexesOrigin[0] > indexesTarget[0] ? -1 : 1;
    const rowsExtracted = arrayOfNodes.splice(indexesOrigin[0], indexesOrigin.length);
    const positionOffset = rowsExtracted.length % 2 === 0 ? 1 : 0;
    let target;
    if (directionOverride === -1 && direction === 1) target = indexesTarget[0] - 1;
    else if (directionOverride === 1 && direction === -1) target = indexesTarget[indexesTarget.length - 1] - positionOffset + 1;
    else target = direction === -1 ? indexesTarget[0] : indexesTarget[indexesTarget.length - 1] - positionOffset;
    // @ts-ignore no idea what this line does
    arrayOfNodes.splice.apply(arrayOfNodes, [
        target,
        0
    ].concat(rowsExtracted));
    return arrayOfNodes;
};
const $6c611051a8223ad8$export$63019a088e9d8f5f = (tableNode)=>{
    const map = (0, $LmqWp.TableMap).get(tableNode);
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const rowCells = [];
        const seen = {};
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = tableNode.nodeAt(cellPos);
            const rect = map.findCell(cellPos);
            if (!cell || seen[cellPos] || rect.top !== rowIndex) {
                rowCells.push(null);
                continue;
            }
            seen[cellPos] = true;
            rowCells.push(cell);
        }
        rows.push(rowCells);
    }
    return rows;
};
const $6c611051a8223ad8$export$8eeacd95914015c2 = (table, indexesOrigin, indexesTarget, direction)=>{
    let rows = $6c611051a8223ad8$export$63019a088e9d8f5f(table.node);
    rows = $6c611051a8223ad8$var$moveRowInArrayOfRows(rows, indexesOrigin, indexesTarget, direction);
    return $6c611051a8223ad8$export$5c8f3870f9ad667(table.node, rows);
};
const $6c611051a8223ad8$export$18d467ff157d6daa = (table, indexesOrigin, indexesTarget, direction)=>{
    let rows = $6c611051a8223ad8$export$9cb09a71b7d66923($6c611051a8223ad8$export$63019a088e9d8f5f(table.node));
    rows = $6c611051a8223ad8$var$moveRowInArrayOfRows(rows, indexesOrigin, indexesTarget, direction);
    rows = $6c611051a8223ad8$export$9cb09a71b7d66923(rows);
    return $6c611051a8223ad8$export$5c8f3870f9ad667(table.node, rows);
};
const $6c611051a8223ad8$export$fd791265d075eb03 = (originIndex, targetIndex, targets, type)=>{
    const direction = originIndex > targetIndex ? -1 : 1;
    const errorMessage = `Target position is invalid, you can't move the ${type} ${originIndex} to ${targetIndex}, the target can't be split. You could use tryToFit option.`;
    if (direction === 1) {
        if (targets.slice(0, targets.length - 1).indexOf(targetIndex) !== -1) throw new Error(errorMessage);
    } else {
        if (targets.slice(1).indexOf(targetIndex) !== -1) throw new Error(errorMessage);
    }
    return true;
};





function $c6bfdfd835c0e3db$var$normalizeDirection(targetDirection, options) {
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : targetDirection;
}
const $c6bfdfd835c0e3db$export$799175205f855ccd = (state, originColumnIndex, targetColumnIndex, targetDirection, options = {
    tryToFit: false,
    direction: 0,
    selectAfterClone: false
})=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since this supports moving both a single & multiple cols in a single action.
        if (!Array.isArray(originColumnIndex)) originColumnIndex = [
            originColumnIndex
        ];
        const tableMap = (0, $LmqWp.TableMap).get(table.node);
        const originalColumnRanges = (0, $c544c9e42ea52662$export$7032a6f0de5ecc29)(Math.min(...originColumnIndex), Math.max(...originColumnIndex))(tr);
        const targetColumnRanges = (0, $c544c9e42ea52662$export$7032a6f0de5ecc29)(targetColumnIndex)(tr);
        const indexesOriginColumn = originalColumnRanges?.indexes ?? [];
        const indexesTargetColumn = targetColumnRanges?.indexes ?? [];
        const min = indexesOriginColumn[0];
        const max = indexesOriginColumn[indexesOriginColumn.length - 1];
        if (!options.tryToFit && indexesTargetColumn.length > 1) (0, $6c611051a8223ad8$export$fd791265d075eb03)(originColumnIndex[0], targetColumnIndex, indexesTargetColumn, 'column');
        const types = (0, $d1kIV.tableNodeTypes)(state.schema);
        const direction = $c6bfdfd835c0e3db$var$normalizeDirection(targetDirection, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetColumn);
        const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $53e8172627dd7927$export$9206f249edb43d1b)(table.node, tableMap, types);
        const createContentNode = $c6bfdfd835c0e3db$var$createContentNodeFactory(table);
        const newTr = (0, $8usfh.cloneTr)(tr);
        const origins = [];
        for(let y = 0; y < tableMap.height; y++){
            origins.push([]);
            for(let x = min; x <= max; x++){
                if (tableMap.isCellMergedTopLeft(y, x)) continue;
                const nodePos = tableMap.map[y * tableMap.width + x];
                origins[y].push(createContentNode(nodePos));
            }
            if (columnHeaderEnabled && actualTargetIndex === 0 && direction === 'start') {
                // This block is handling the situation where a col is moved in/out of the header position. If the header col option
                // is enabled then;
                // When a col is moved out, the col will be converted to a normal col and the col to the right will become the header.
                // When a col is moved in, the old col header needs to be made normal, and the incoming col needs to be made a header.
                // This section only manages what happens to the other col, not the one being moved.
                const nearHeaderCol = min === 0 ? max + 1 : actualTargetIndex;
                const nodePos = tableMap.map[y * tableMap.width + nearHeaderCol];
                const { pos: pos, node: node } = createContentNode(nodePos);
                newTr.setNodeMarkup(pos, actualTargetIndex !== 0 || rowHeaderEnabled && y === 0 ? types.header_cell : types.cell, node.attrs);
            }
        }
        origins.forEach((row, y)=>{
            if (!row.length) // If the origin has no cells to be moved then we can skip moving for this row. This can occur when a cell above rowspans
            // into the current row.
            return;
            // The actual target index needs to be translated per row, this is because row/col spans can affect the amount of
            // cells each row contains.
            const rowTargetPosition = $c6bfdfd835c0e3db$var$translateTargetPosition(y, actualTargetIndex, tableMap);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(rowTargetPosition);
            const pos = table.start + rowTargetPosition;
            const insertPos = direction === 'end' ? newTr.mapping.map(pos + node.nodeSize, 1) : newTr.mapping.map(pos, -1);
            return newTr.insert(insertPos, row.map(({ node: node }, x)=>$c6bfdfd835c0e3db$var$normalizeCellNode(node, rowHeaderEnabled && y === 0, columnHeaderEnabled && actualTargetIndex === 0 && x === 0 && direction === 'start', types)));
        });
        if (options.selectAfterClone) {
            const offset = direction === 'end' ? 1 : 0;
            const selectionRange = (0, $c544c9e42ea52662$export$7032a6f0de5ecc29)(actualTargetIndex + offset, actualTargetIndex + offset + indexesOriginColumn.length - 1)(newTr);
            if (selectionRange) newTr.setSelection(new (0, $7XFGZ.CellSelection)(selectionRange.$anchor, selectionRange.$head));
        }
        return newTr;
    };
function $c6bfdfd835c0e3db$var$normalizeCellNode(cellNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const newTargetType = rowHeaderEnabled || columnHeaderEnabled ? types.header_cell : types.cell;
    return cellNode.type !== newTargetType ? newTargetType.create(cellNode.attrs, cellNode.content, cellNode.marks) : cellNode;
}
function $c6bfdfd835c0e3db$var$createContentNodeFactory(table) {
    return (nodePos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const node = table.node.nodeAt(nodePos);
        const pos = nodePos + table.start;
        return {
            pos: pos,
            start: pos + 1,
            node: node,
            depth: table.depth + 2
        };
    };
}
function $c6bfdfd835c0e3db$var$translateTargetPosition(row, startIndex, tableMap) {
    if (tableMap.isCellMergedTopLeft(row, startIndex)) {
        // find the closet unmerged position to the left of the target. We scan left first because merged cells will actually
        // reduce the amount of cells in a row.
        for(let x = startIndex - 1; x >= 0; x--){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
        // If no index found then we need to look to the right, this can occur when the first cell in the row is merged.
        for(let x = startIndex + 1; x < tableMap.width; x++){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
    }
    return tableMap.map[row * tableMap.width + startIndex];
}
















const $3ed7b5445cd344b0$export$550d44f4e6042645 = (startRowIndex, endRowIndex = startRowIndex)=>(tr)=>{
        let startIndex = startRowIndex;
        let endIndex = endRowIndex;
        // looking for selection start row (startIndex)
        for(let i = startRowIndex; i >= 0; i--){
            const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.rowspan + i - 1;
                if (maybeEndIndex >= startIndex) startIndex = i;
                if (maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // looking for selection end row (endIndex)
        for(let i = startRowIndex; i <= endIndex; i++){
            const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.rowspan + i - 1;
                if (cell.node.attrs.rowspan > 1 && maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // filter out rows without cells (where all columns have rowspan > 1 in the same row)
        const indexes = [];
        for(let i = startIndex; i <= endIndex; i++){
            const maybeCells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(i)(tr.selection);
            if (maybeCells && maybeCells.length) indexes.push(i);
        }
        startIndex = indexes[0];
        endIndex = indexes[indexes.length - 1];
        const firstSelectedRowCells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(startIndex)(tr.selection);
        const firstColumnCells = (0, $40458289442cabaf$export$c14b77638b178c5d)(0)(tr.selection);
        if (!firstSelectedRowCells || !firstColumnCells) return;
        const $anchor = tr.doc.resolve(firstSelectedRowCells[firstSelectedRowCells.length - 1].pos);
        let headCell;
        for(let i = endIndex; i >= startIndex; i--){
            const rowCells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(i)(tr.selection);
            if (rowCells && rowCells.length) {
                for(let j = firstColumnCells.length - 1; j >= 0; j--)if (firstColumnCells[j].pos === rowCells[0].pos) {
                    headCell = rowCells[0];
                    break;
                }
                if (headCell) break;
            }
        }
        if (!headCell) return;
        const $head = tr.doc.resolve(headCell.pos);
        return {
            $anchor: $anchor,
            $head: $head,
            indexes: indexes
        };
    };






function $a69dc46ce4b17569$var$normalizeDirection(targetDirection, options) {
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : targetDirection;
}
const $a69dc46ce4b17569$export$94fc9bbbd60f961f = (state, originRowIndex, targetRowIndex, targetDirection, options = {
    tryToFit: false,
    direction: 0,
    selectAfterClone: false
})=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since move row support moving both a single & multiple rows in a single action.
        if (!Array.isArray(originRowIndex)) originRowIndex = [
            originRowIndex
        ];
        const tableMap = (0, $LmqWp.TableMap).get(table.node);
        const [originMin, originMax] = originRowIndex.reduce(([min, max], cur)=>[
                Math.min(min, cur),
                Math.max(max, cur)
            ], [
            Number.MAX_SAFE_INTEGER,
            Number.MIN_SAFE_INTEGER
        ]);
        const originalRowRanges = (0, $3ed7b5445cd344b0$export$550d44f4e6042645)(originMin, originMax)(tr);
        const targetRowRanges = (0, $3ed7b5445cd344b0$export$550d44f4e6042645)(targetRowIndex)(tr);
        const indexesOriginRow = originalRowRanges?.indexes || [];
        const indexesTargetRow = targetRowRanges?.indexes || [];
        if (originMin < 0 || originMin === Number.MAX_SAFE_INTEGER || originMax >= tableMap.height || originMax === Number.MIN_SAFE_INTEGER) return tr;
        if (!options.tryToFit && indexesTargetRow.length > 1) (0, $6c611051a8223ad8$export$fd791265d075eb03)(originMin, targetRowIndex, indexesTargetRow, 'row');
        const types = (0, $d1kIV.tableNodeTypes)(state.schema);
        const direction = $a69dc46ce4b17569$var$normalizeDirection(targetDirection, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetRow);
        const originPositions = indexesOriginRow.map((index)=>tableMap.positionAt(index, 0, table.node) + table.pos);
        const originNodes = originPositions.reduce((acc, pos)=>{
            const node = tr.doc.nodeAt(tr.mapping.map(pos));
            if (node) return [
                ...acc,
                {
                    pos: pos,
                    node: node
                }
            ];
            return acc;
        }, []);
        const targetPos = tableMap.positionAt(actualTargetIndex, 0, table.node) + table.pos;
        const targetNode = tr.doc.nodeAt(tr.mapping.map(targetPos));
        if (originNodes?.length && targetNode) {
            const newTr = (0, $8usfh.cloneTr)(tr);
            const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $53e8172627dd7927$export$9206f249edb43d1b)(table.node, tableMap, types);
            if (rowHeaderEnabled && actualTargetIndex === 0 && direction === 'start') {
                // This block is handling the situation where a row is moved in/out of the header position. If the header row option
                // is enabled then;
                // When a row is moved out, the row will be converted to a normal row and the row below it will become the header.
                // When a row is moved in, the old row header needs to be made normal, and the incoming row needs to be made a header.
                // This section only manages what happens to the other row, no the one being moved.
                const nearHeaderPos = tableMap.positionAt(originMin === 0 ? originMax + 1 : actualTargetIndex, 0, table.node) + table.pos;
                const nearHeaderNode = newTr.doc.nodeAt(newTr.mapping.map(nearHeaderPos));
                if (nearHeaderNode) nearHeaderNode.forEach((node, offset, index)=>{
                    const start = newTr.mapping.map(nearHeaderPos + 1 + offset);
                    newTr.setNodeMarkup(start, actualTargetIndex !== 0 || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell, node.attrs);
                });
            }
            const insertPos = direction === 'end' ? newTr.mapping.map(targetPos + targetNode.nodeSize, 1) : newTr.mapping.map(targetPos, -1);
            newTr.insert(insertPos, originNodes.map(({ node: node }, index)=>$a69dc46ce4b17569$var$normalizeRowNode(node, rowHeaderEnabled && actualTargetIndex === 0 && index === 0 && direction === 'start', columnHeaderEnabled, types)));
            if (options.selectAfterClone) {
                const offset = direction === 'end' ? 1 : 0;
                const selectionRange = (0, $3ed7b5445cd344b0$export$550d44f4e6042645)(actualTargetIndex + offset, actualTargetIndex + offset + originNodes.length - 1)(newTr);
                if (selectionRange) newTr.setSelection(new (0, $7XFGZ.CellSelection)(selectionRange.$anchor, selectionRange.$head));
            }
            return newTr;
        }
        return tr;
    };
/**
 * This ensures the row node cell type correctly reflect what they should be.
 * @returns A copy of the rowNode
 */ function $a69dc46ce4b17569$var$normalizeRowNode(rowNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const content = [];
    rowNode.forEach((node, _offset, index)=>{
        const newTargetType = rowHeaderEnabled || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell;
        content.push(node.type !== newTargetType ? newTargetType.create(node.attrs, node.content, node.marks) : node);
    });
    return rowNode.type.create(rowNode.attrs, content, rowNode.marks);
}















function $bc08f7cff1f95a7c$export$3d9c15b8c24b72f5(origin, target, options) {
    const dir = origin < target ? 'end' : 'start';
    const override = (options?.direction ?? 0) < 0 ? 'start' : 'end';
    return options?.tryToFit && !!options?.direction ? override : dir;
}






const $0b010a9a091e74d7$export$d1fbe0eb3fc9219 = (state, originColumnIndex, targetColumnIndex, options = {
    tryToFit: false,
    direction: 0,
    selectAfterMove: false
})=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since this supports moving both a single & multiple cols in a single action.
        if (!Array.isArray(originColumnIndex)) originColumnIndex = [
            originColumnIndex
        ];
        const tableMap = (0, $LmqWp.TableMap).get(table.node);
        const originalColumnRanges = (0, $c544c9e42ea52662$export$7032a6f0de5ecc29)(Math.min(...originColumnIndex), Math.max(...originColumnIndex))(tr);
        const targetColumnRanges = (0, $c544c9e42ea52662$export$7032a6f0de5ecc29)(targetColumnIndex)(tr);
        const indexesOriginColumn = originalColumnRanges?.indexes ?? [];
        const indexesTargetColumn = targetColumnRanges?.indexes ?? [];
        const min = indexesOriginColumn[0];
        const max = indexesOriginColumn[indexesOriginColumn.length - 1];
        if (indexesOriginColumn.includes(targetColumnIndex)) return tr;
        if (!options.tryToFit && indexesTargetColumn.length > 1) (0, $6c611051a8223ad8$export$fd791265d075eb03)(originColumnIndex[0], targetColumnIndex, indexesTargetColumn, 'column');
        const types = (0, $d1kIV.tableNodeTypes)(state.schema);
        const direction = (0, $bc08f7cff1f95a7c$export$3d9c15b8c24b72f5)(min, targetColumnIndex, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetColumn);
        const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $53e8172627dd7927$export$9206f249edb43d1b)(table.node, tableMap, types);
        const createContentNode = $0b010a9a091e74d7$var$createContentNodeFactory(table);
        const newTr = (0, $8usfh.cloneTr)(tr);
        const origins = [];
        for(let y = 0; y < tableMap.height; y++){
            origins.push([]);
            for(let x = min; x <= max; x++){
                if (tableMap.isCellMergedTopLeft(y, x)) continue;
                const nodePos = tableMap.map[y * tableMap.width + x];
                origins[y].push(createContentNode(nodePos));
            }
            if (columnHeaderEnabled && (min === 0 || actualTargetIndex === 0)) {
                // This block is handling the situation where a col is moved in/out of the header position. If the header col option
                // is enabled then;
                // When a col is moved out, the col will be converted to a normal col and the col to the right will become the header.
                // When a col is moved in, the old col header needs to be made normal, and the incoming col needs to be made a header.
                // This section only manages what happens to the other col, not the one being moved.
                const nearHeaderCol = min === 0 ? max + 1 : actualTargetIndex;
                const nodePos = tableMap.map[y * tableMap.width + nearHeaderCol];
                const { pos: pos, node: node } = createContentNode(nodePos);
                newTr.setNodeMarkup(pos, actualTargetIndex !== 0 || rowHeaderEnabled && y === 0 ? types.header_cell : types.cell, node.attrs);
            }
        }
        origins.forEach((row, y)=>{
            if (!row.length) // If the origin has no cells to be moved then we can skip moving for this row. This can occur when a cell above rowspans
            // into the current row.
            return;
            // The actual target index needs to be translated per row, this is because row/col spans can affect the amount of
            // cells each row contains.
            const rowTargetPosition = $0b010a9a091e74d7$var$translateTargetPosition(y, actualTargetIndex, tableMap);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(rowTargetPosition);
            const pos = table.start + rowTargetPosition;
            const insertPos = direction === 'end' || tableMap.isCellMergedTopLeft(y, actualTargetIndex) ? newTr.mapping.map(pos + node.nodeSize, 1) : newTr.mapping.map(pos, -1);
            newTr.insert(insertPos, row.map(({ node: node }, x)=>$0b010a9a091e74d7$var$normalizeCellNode(node, rowHeaderEnabled && y === 0, columnHeaderEnabled && actualTargetIndex === 0 && x === 0, types)));
            // NOTE: only consecutive cells can be moved, this means we can simplify the delete op into a single step which
            // deletes the range of cells.
            const first = row[0];
            const last = row[row.length - 1];
            return newTr.delete(newTr.mapping.map(first.pos, 1), newTr.mapping.map(last.pos + last.node.nodeSize, -1));
        });
        if (options.selectAfterMove) {
            const n = indexesOriginColumn.length - 1;
            const selectionRange = (0, $c544c9e42ea52662$export$7032a6f0de5ecc29)(actualTargetIndex - (direction === 'end' ? n : 0), actualTargetIndex + (direction === 'start' ? n : 0))(newTr);
            if (selectionRange) newTr.setSelection(new (0, $7XFGZ.CellSelection)(selectionRange.$anchor, selectionRange.$head));
        }
        return newTr;
    };
function $0b010a9a091e74d7$var$normalizeCellNode(cellNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const newTargetType = rowHeaderEnabled || columnHeaderEnabled ? types.header_cell : types.cell;
    return cellNode.type !== newTargetType ? newTargetType.create(cellNode.attrs, cellNode.content, cellNode.marks) : cellNode;
}
function $0b010a9a091e74d7$var$createContentNodeFactory(table) {
    return (nodePos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const node = table.node.nodeAt(nodePos);
        const pos = nodePos + table.start;
        return {
            pos: pos,
            start: pos + 1,
            node: node,
            depth: table.depth + 2
        };
    };
}
function $0b010a9a091e74d7$var$translateTargetPosition(row, startIndex, tableMap) {
    if (tableMap.isCellMergedTopLeft(row, startIndex)) {
        // find the closet unmerged position to the left of the target. We scan left first because merged cells will actually
        // reduce the amount of cells in a row.
        for(let x = startIndex - 1; x >= 0; x--){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
        // If no index found then we need to look to the right, this can occur when the first cell in the row is merged.
        for(let x = startIndex + 1; x < tableMap.width; x++){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
    }
    return tableMap.map[row * tableMap.width + startIndex];
}




















const $9cafb746affc3203$export$fbe24096ca2da576 = (state, originRowIndex, targetRowIndex, options = {
    tryToFit: false,
    direction: 0,
    selectAfterMove: false
})=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since move row support moving both a single & multiple rows in a single action.
        if (!Array.isArray(originRowIndex)) originRowIndex = [
            originRowIndex
        ];
        if (originRowIndex.includes(targetRowIndex)) return tr;
        const tableMap = (0, $LmqWp.TableMap).get(table.node);
        const [originMin, originMax] = originRowIndex.reduce(([min, max], cur)=>[
                Math.min(min, cur),
                Math.max(max, cur)
            ], [
            Number.MAX_SAFE_INTEGER,
            Number.MIN_SAFE_INTEGER
        ]);
        const originalRowRanges = (0, $3ed7b5445cd344b0$export$550d44f4e6042645)(originMin, originMax)(tr);
        const targetRowRanges = (0, $3ed7b5445cd344b0$export$550d44f4e6042645)(targetRowIndex)(tr);
        const indexesOriginRow = originalRowRanges?.indexes || [];
        const indexesTargetRow = targetRowRanges?.indexes || [];
        if (originMin < 0 || originMin === Number.MAX_SAFE_INTEGER || originMax >= tableMap.height || originMax === Number.MIN_SAFE_INTEGER || // The target index cannot be within the origin bounds
        targetRowIndex >= originMin && targetRowIndex <= originMax) return tr;
        if (!options.tryToFit && indexesTargetRow.length > 1) (0, $6c611051a8223ad8$export$fd791265d075eb03)(originMin, targetRowIndex, indexesTargetRow, 'row');
        const types = (0, $d1kIV.tableNodeTypes)(state.schema);
        const direction = (0, $bc08f7cff1f95a7c$export$3d9c15b8c24b72f5)(originMin, targetRowIndex, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetRow);
        const originPositions = indexesOriginRow.map((index)=>tableMap.positionAt(index, 0, table.node) + table.pos);
        const originNodes = originPositions.reduce((acc, pos)=>{
            const node = tr.doc.nodeAt(tr.mapping.map(pos));
            if (node) return [
                ...acc,
                {
                    pos: pos,
                    node: node
                }
            ];
            return acc;
        }, []);
        const targetPos = tableMap.positionAt(actualTargetIndex, 0, table.node) + table.pos;
        const targetNode = tr.doc.nodeAt(tr.mapping.map(targetPos));
        if (originNodes?.length && targetNode) {
            const newTr = (0, $8usfh.cloneTr)(tr);
            const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $53e8172627dd7927$export$9206f249edb43d1b)(table.node, tableMap, types);
            if (rowHeaderEnabled && (originMin === 0 || actualTargetIndex === 0)) {
                // This block is handling the situation where a row is moved in/out of the header position. If the header row option
                // is enabled then;
                // When a row is moved out, the row will be converted to a normal row and the row below it will become the header.
                // When a row is moved in, the old row header needs to be made normal, and the incoming row needs to be made a header.
                // This section only manages what happens to the other row, no the one being moved.
                const nearHeaderPos = tableMap.positionAt(originMin === 0 ? originMax + 1 : actualTargetIndex, 0, table.node) + table.pos;
                const nearHeaderNode = newTr.doc.nodeAt(newTr.mapping.map(nearHeaderPos));
                if (nearHeaderNode) nearHeaderNode.forEach((node, offset, index)=>{
                    const start = newTr.mapping.map(nearHeaderPos + 1 + offset);
                    newTr.setNodeMarkup(start, actualTargetIndex !== 0 || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell, node.attrs);
                });
            }
            const insertPos = direction === 'end' ? newTr.mapping.map(targetPos + targetNode.nodeSize, 1) : newTr.mapping.map(targetPos, -1);
            newTr.insert(insertPos, originNodes.map(({ node: node }, index)=>$9cafb746affc3203$var$normalizeRowNode(node, rowHeaderEnabled && actualTargetIndex === 0 && index === 0, columnHeaderEnabled, types)));
            // IMPORTANT: We need to perform the selection between the insert/delete. This is because the delete could cause
            // the current selection to be pushed out of the table resulting in an invalid selection range outside of the table
            if (options.selectAfterMove) {
                const offset = direction === 'end' ? 1 : 0;
                const selectionRange = (0, $3ed7b5445cd344b0$export$550d44f4e6042645)(actualTargetIndex + offset, actualTargetIndex + offset + originNodes.length - 1)(newTr);
                if (selectionRange) newTr.setSelection(new (0, $7XFGZ.CellSelection)(selectionRange.$anchor, selectionRange.$head));
            }
            originNodes.forEach(({ pos: pos, node: node })=>{
                newTr.delete(newTr.mapping.map(pos, 1), newTr.mapping.map(pos + node.nodeSize, -1));
            });
            return newTr;
        }
        return tr;
    };
/**
 * This ensures the row node cell type correctly reflect what they should be.
 * @returns A copy of the rowNode
 */ function $9cafb746affc3203$var$normalizeRowNode(rowNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const content = [];
    rowNode.forEach((node, _offset, index)=>{
        const newTargetType = rowHeaderEnabled || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell;
        content.push(node.type !== newTargetType ? newTargetType.create(node.attrs, node.content, node.marks) : node);
    });
    return rowNode.type.create(rowNode.attrs, content, rowNode.marks);
}





const $23a3656b396423d5$export$9377432e002bc2da = {
    NONE: 'none',
    ROW: 'row',
    COLUMN: 'column'
};









const $c8432cced568eda6$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('dragAndDropPlugin');




var $0295690b8f66cf4b$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).SET_DROP_TARGET:
            return {
                ...pluginState,
                decorationSet: action.data.decorationSet,
                dropTargetType: action.data.type,
                dropTargetIndex: action.data.index,
                isDragging: true
            };
        case (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).CLEAR_DROP_TARGET:
            return {
                ...pluginState,
                decorationSet: action.data.decorationSet,
                dropTargetType: (0, $23a3656b396423d5$export$9377432e002bc2da).NONE,
                dropTargetIndex: 0,
                isDragging: false
            };
        case (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).TOGGLE_DRAG_MENU:
            return {
                ...pluginState,
                isDragMenuOpen: action.data.isDragMenuOpen,
                dragMenuDirection: action.data.direction,
                dragMenuIndex: action.data.index,
                isKeyboardModeActive: action.data.isKeyboardModeActive
            };
        default:
            return pluginState;
    }
};


const $abc6204662f4f035$var$dest = (0, $lkJUe.pluginFactory)((0, $c8432cced568eda6$export$18d4026d1ea86bb1), (0, $0295690b8f66cf4b$export$2e2bcd8739ae039), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let decorationSet = pluginState.decorationSet;
            const meta = tr.getMeta((0, $fedf15e5199146e8$export$18d4026d1ea86bb1));
            if (meta && meta.data && meta.data.decorationSet) decorationSet = meta.data.decorationSet;
            if (decorationSet) decorationSet = decorationSet.map(tr.mapping, tr.doc);
            return {
                ...pluginState,
                decorationSet: decorationSet
            };
        }
        return pluginState;
    }
});
const $abc6204662f4f035$export$656c7661095efe2e = $abc6204662f4f035$var$dest.createPluginState;
const $abc6204662f4f035$export$8d4021544bdece00 = $abc6204662f4f035$var$dest.createCommand;
const $abc6204662f4f035$export$f05434c51e3762e = $abc6204662f4f035$var$dest.getPluginState;



// TODO: ED-26961 - This command is a placeholder example. Please replace this if required.
const $68bb38467b052d2c$var$getDecorations = (state)=>{
    return (0, $c8432cced568eda6$export$18d4026d1ea86bb1).getState(state)?.decorationSet || (0, $ftzrq.DecorationSet).empty;
};
const $68bb38467b052d2c$var$updatePluginStateDecorations = (state, decorations, key)=>(0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(state.doc, $68bb38467b052d2c$var$getDecorations(state), decorations, key);
const $68bb38467b052d2c$export$a54c991ec4a21b4a = (type, index, hasMergedCells, tr)=>(0, $abc6204662f4f035$export$8d4021544bdece00)((state)=>{
        const { dropTargetType: dropTargetType, dropTargetIndex: dropTargetIndex } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
        if (dropTargetType === type && dropTargetIndex === index) return false;
        let decorationSet = (0, $ftzrq.DecorationSet).empty;
        if (type === 'column') decorationSet = $68bb38467b052d2c$var$updatePluginStateDecorations(state, (0, $9283ce7d62ffd391$export$6012cbb334f87faa)(index, state.selection, hasMergedCells), (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_INSERT_LINE);
        else if (type === 'row') decorationSet = $68bb38467b052d2c$var$updatePluginStateDecorations(state, (0, $9283ce7d62ffd391$export$c47f6da2c2a0ebc8)(index, state.selection, hasMergedCells), (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).ROW_INSERT_LINE);
        return {
            type: (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).SET_DROP_TARGET,
            data: {
                decorationSet: decorationSet,
                type: type,
                index: index
            }
        };
    }, (originalTr)=>(tr || originalTr).setMeta('addToHistory', false));
const $68bb38467b052d2c$export$e74dec9e818a8c0b = (tr)=>(0, $abc6204662f4f035$export$8d4021544bdece00)((state)=>{
        const { dropTargetType: dropTargetType, dropTargetIndex: dropTargetIndex } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
        if (dropTargetType === (0, $23a3656b396423d5$export$9377432e002bc2da).NONE && dropTargetIndex === 0) return false;
        return {
            type: (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $ftzrq.DecorationSet).empty
            }
        };
    }, (originalTr)=>(tr || originalTr).setMeta('addToHistory', false));
const $68bb38467b052d2c$export$1326c72b3102f66d = (sourceType, sourceIndexes, targetIndex, tr)=>(0, $abc6204662f4f035$export$8d4021544bdece00)((state)=>{
        return {
            type: (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $ftzrq.DecorationSet).empty
            }
        };
    }, (originalTr, state)=>{
        const nextTr = tr || originalTr;
        if (sourceIndexes.includes(targetIndex)) return nextTr.setMeta('addToHistory', false);
        const move = sourceType === 'table-row' ? (0, $9cafb746affc3203$export$fbe24096ca2da576) : (0, $0b010a9a091e74d7$export$d1fbe0eb3fc9219);
        return move(state, sourceIndexes, targetIndex, {
            selectAfterMove: true
        })(nextTr);
    });
const $68bb38467b052d2c$export$8a902a12acc69924 = (isDragMenuOpen, direction, index, trigger = 'mouse')=>(0, $abc6204662f4f035$export$8d4021544bdece00)((state)=>{
        const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
        if (previousOpenState === isDragMenuOpen && previousDragMenuDirection === direction && previousDragMenuIndex === index) return false;
        let updatedMenuOpenState;
        if (isDragMenuOpen !== undefined) updatedMenuOpenState = isDragMenuOpen;
        else // menu open but menu direction changed, means user clicked on drag handle of different row/column
        // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
        // 2 scenarios above , menu should remain open.
        if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) updatedMenuOpenState = true;
        else updatedMenuOpenState = !previousOpenState;
        return {
            type: (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).TOGGLE_DRAG_MENU,
            data: {
                isDragMenuOpen: updatedMenuOpenState,
                direction: direction ?? previousDragMenuDirection,
                index: index ?? previousDragMenuIndex,
                isKeyboardModeActive: updatedMenuOpenState && trigger === 'keyboard'
            }
        };
    }, (tr)=>{
        return tr.setMeta('addToHistory', false);
    });
const $68bb38467b052d2c$export$88277f1015e99c8a = (sourceType, sourceIndexes, targetIndex, targetDirection, tr)=>(0, $abc6204662f4f035$export$8d4021544bdece00)((state)=>{
        return {
            type: (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $ftzrq.DecorationSet).empty
            }
        };
    }, (originalTr, state)=>{
        const nextTr = tr || originalTr;
        const clone = sourceType === 'table-row' ? (0, $a69dc46ce4b17569$export$94fc9bbbd60f961f) : (0, $c6bfdfd835c0e3db$export$799175205f855ccd);
        return clone(state, sourceIndexes, targetIndex, targetDirection, {
            selectAfterClone: true
        })(nextTr);
    });






















parcelRequire("42omo");


var $5rHEx = parcelRequire("5rHEx");








var $4c0se = parcelRequire("4c0se");


var $dmsGX = parcelRequire("dmsGX");


var $iV7dk = parcelRequire("iV7dk");


var $luItc = parcelRequire("luItc");


var $6p8nb = parcelRequire("6p8nb");


var $4Ilrk = parcelRequire("4Ilrk");


var $lvYQd = parcelRequire("lvYQd");


var $batr4 = parcelRequire("batr4");


var $iBNSQ = parcelRequire("iBNSQ");


var $kDG2N = parcelRequire("kDG2N");


var $4s9K9 = parcelRequire("4s9K9");


var $HbwpQ = parcelRequire("HbwpQ");


var $krMwx = parcelRequire("krMwx");


var $gzmk4 = parcelRequire("gzmk4");







/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766







var $2XqLN = parcelRequire("2XqLN");










var $aaI8u = parcelRequire("aaI8u");





var $61p3e = parcelRequire("61p3e");










var $iHzeA = parcelRequire("iHzeA");





var $hMewq = parcelRequire("hMewq");


var $fWSjz = parcelRequire("fWSjz");

const $81b7b6f3cf3366fc$var$cellBackgroundColorPalette = [];
(0, $63Ztt.tableBackgroundColorPalette).forEach((label, color)=>{
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $hMewq.default)((0, $fWSjz.default), key);
    $81b7b6f3cf3366fc$var$cellBackgroundColorPalette.push({
        value: color,
        label: label,
        border: (0, $63Ztt.tableBackgroundBorderColor),
        message: message
    });
});
var $81b7b6f3cf3366fc$export$2e2bcd8739ae039 = $81b7b6f3cf3366fc$var$cellBackgroundColorPalette;


var $lhtyR = parcelRequire("lhtyR");




var $5GR8v = parcelRequire("5GR8v");








var $6f5RK = parcelRequire("6f5RK");






















function $92cfb9d684c33d6a$export$603245c099db0b11($pos) {
    for(let d = $pos.depth; d > 0; d--){
        // Sometimes the cell can be in the same depth.
        const role = $pos.node(d).type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.node(d);
    }
    return null;
}
function $92cfb9d684c33d6a$export$8c441a625fd4d770(getCellType) {
    return (state, dispatch)=>{
        const sel = state.selection;
        let cellNode, cellPos;
        if (!(sel instanceof (0, $7XFGZ.CellSelection))) {
            cellNode = $92cfb9d684c33d6a$export$603245c099db0b11(sel.$from);
            if (!cellNode) return false;
            const cellNodeAround = (0, $3gZJH.cellAround)(sel.$from);
            cellPos = cellNodeAround && cellNodeAround.pos;
        } else {
            if (sel.$anchorCell.pos !== sel.$headCell.pos) return false;
            cellNode = sel.$anchorCell.nodeAfter;
            cellPos = sel.$anchorCell.pos;
        }
        if (cellNode && cellNode.attrs.colspan === 1 && cellNode.attrs.rowspan === 1) return false;
        if (cellNode && dispatch) {
            let cellAttrs = cellNode.attrs;
            const attrs = [];
            const colwidth = cellAttrs.colwidth;
            if (cellAttrs.rowspan && cellAttrs.rowspan > 1) cellAttrs = {
                ...cellAttrs,
                rowspan: 1
            };
            if (cellAttrs.colspan && cellAttrs.colspan > 1) cellAttrs = {
                ...cellAttrs,
                colspan: 1
            };
            const rect = (0, $2QyFu.selectedRect)(state);
            const tr = state.tr;
            for(let i = 0; i < rect.right - rect.left; i++)attrs.push(colwidth ? {
                ...cellAttrs,
                colwidth: colwidth && colwidth[i] ? [
                    colwidth[i]
                ] : null
            } : cellAttrs);
            let lastCell = null;
            for(let row = rect.top; row < rect.bottom; row++){
                let pos = rect.map.positionAt(row, rect.left, rect.table);
                if (row === rect.top) pos += cellNode.nodeSize;
                for(let col = rect.left, i = 0; col < rect.right; col++, i++){
                    if (col === rect.left && row === rect.top) continue;
                    const cellType = getCellType({
                        node: cellNode,
                        row: row,
                        col: col
                    }).createAndFill(attrs[i]);
                    if (cellType) tr.insert(lastCell = tr.mapping.map(pos + rect.tableStart, 1), cellType);
                }
            }
            if (typeof cellPos === 'number') tr.setNodeMarkup(cellPos, getCellType({
                node: cellNode,
                row: rect.top,
                col: rect.left
            }), attrs[0]);
            const $lastCellPosition = lastCell && tr.doc.resolve(lastCell);
            if (sel instanceof (0, $7XFGZ.CellSelection) && $lastCellPosition instanceof (0, $5SAOw.ResolvedPos)) {
                const cellSelection = new (0, $7XFGZ.CellSelection)(tr.doc.resolve(sel.$anchorCell.pos), $lastCellPosition);
                tr.setSelection(cellSelection);
            }
            dispatch(tr);
        }
        return true;
    };
}





const $2d87994eabccd17d$export$74933b5979945879 = (state, dispatch)=>{
    const nodeTypes = (0, $d1kIV.tableNodeTypes)(state.schema);
    return (0, $92cfb9d684c33d6a$export$8c441a625fd4d770)(({ node: node })=>{
        return nodeTypes[node.type.spec.tableRole];
    })(state, dispatch);
};



var $dxgIg = parcelRequire("dxgIg");


var $1dusJ = parcelRequire("1dusJ");


var $2MuFw = parcelRequire("2MuFw");


var $isYda = parcelRequire("isYda");


var $gKvd9 = parcelRequire("gKvd9");


var $64M9v = parcelRequire("64M9v");










// #region Imports


















const $1731f25dceb7d4d1$export$ffded79ba5549697 = (tr)=>{
    const table = (0, $id9O1.findTable)(tr.selection);
    if (!table) return [];
    const map = (0, $LmqWp.TableMap).get(table.node);
    const cellPositions = new Set();
    const mergedCells = [];
    map.map.forEach((value)=>{
        if (cellPositions.has(value)) mergedCells.push(value);
        else cellPositions.add(value);
    });
    return mergedCells;
};
const $1731f25dceb7d4d1$export$cea95ea93d5f9224 = (prevTableNode, currentTableNode, intl)=>{
    const { formatMessage: formatMessage } = intl;
    const prevTableMap = (0, $LmqWp.TableMap).get(prevTableNode);
    const currentTableMap = (0, $LmqWp.TableMap).get(currentTableNode);
    if (currentTableMap.width !== prevTableMap.width) {
        const diff = Math.abs(currentTableMap.width - prevTableMap.width);
        if (currentTableMap.width > prevTableMap.width) return formatMessage((0, $2CQVV.messages).columnsAreInserted, {
            count: diff
        });
        if (currentTableMap.width < prevTableMap.width) return formatMessage((0, $2CQVV.messages).columnsAreRemoved, {
            count: diff
        });
    }
    if (currentTableMap.height !== prevTableMap.height) {
        const diff = Math.abs(currentTableMap.height - prevTableMap.height);
        if (currentTableMap.height > prevTableMap.height) return formatMessage((0, $2CQVV.messages).rowsAreInserted, {
            count: diff
        });
        if (currentTableMap.height < prevTableMap.height) return formatMessage((0, $2CQVV.messages).rowsAreRemoved, {
            count: diff
        });
    }
    return '';
};



const $7132c436572167eb$var$makeArray = (n)=>Array.from(Array(n).keys());
const $7132c436572167eb$export$59dcdc44819c7e7c = ()=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const mergedCellsPositions = (0, $1731f25dceb7d4d1$export$ffded79ba5549697)(state.tr);
        if (!mergedCellsPositions.length) return false;
        const table = (0, $id9O1.findTable)(state.tr.selection);
        if (!table) return false;
        const mergedCells = mergedCellsPositions.map((pos)=>({
                pos: pos + table.start,
                start: pos + table.start + 1,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                node: table.node.nodeAt(pos)
            }));
        const decorations = (0, $9283ce7d62ffd391$export$e1f7dd2d4ed6c778)(mergedCells);
        return {
            type: 'HOVER_MERGED_CELLS',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, decorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).CELL_CONTROLS_HOVER)
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7132c436572167eb$export$4cf548f2efac0afe = (hoveredColumns, isInDanger)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const cells = (0, $40458289442cabaf$export$c14b77638b178c5d)(hoveredColumns)(state.tr.selection);
        if (!cells) return false;
        const decorations = (0, $9283ce7d62ffd391$export$ecf836094c108a0)(cells, 'column', state.tr, hoveredColumns, isInDanger);
        return {
            type: 'HOVER_COLUMNS',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, decorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_CONTROLS_HOVER),
                hoveredColumns: hoveredColumns,
                isInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7132c436572167eb$export$ab63d99b591b89 = (hoveredRows, isInDanger)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(hoveredRows)(state.selection);
        if (!cells) return false;
        const decorations = (0, $9283ce7d62ffd391$export$ecf836094c108a0)(cells, 'row', state.tr, hoveredRows, isInDanger);
        return {
            type: 'HOVER_ROWS',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, decorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).ROW_CONTROLS_HOVER),
                hoveredRows: hoveredRows,
                isInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7132c436572167eb$export$41c571b711ba06e = (isInDanger, isSelected)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const table = (0, $id9O1.findTable)(state.selection);
        if (!table) return false;
        const map = (0, $LmqWp.TableMap).get(table.node);
        const hoveredColumns = $7132c436572167eb$var$makeArray(map.width);
        const hoveredRows = $7132c436572167eb$var$makeArray(map.height);
        const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(hoveredRows)(state.selection);
        if (!cells) return false;
        const decorations = (0, $9283ce7d62ffd391$export$ecf836094c108a0)(cells, 'table', state.tr, [], isInDanger, isSelected);
        return {
            type: 'HOVER_TABLE',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, decorations, (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).TABLE_CONTROLS_HOVER),
                hoveredColumns: hoveredColumns,
                hoveredRows: hoveredRows,
                isInDanger: isInDanger,
                isWholeTableInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7132c436572167eb$export$d4bebf197f3770e4 = ()=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>({
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, [], (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).ALL_CONTROLS_HOVER),
                isInDanger: false,
                isWholeTableInDanger: false
            }
        }));
const $7132c436572167eb$export$9b72d13d82d16e72 = (cellColumnPositioning)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        return {
            type: 'SHOW_RESIZE_HANDLE_LINE',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, (0, $9283ce7d62ffd391$export$c1faae7fcf0653ce)(state.selection, cellColumnPositioning), (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE)
            }
        };
    });
const $7132c436572167eb$export$5ad4eed96dbaffaf = ()=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>({
            type: 'HIDE_RESIZE_HANDLE_LINE',
            data: {
                decorationSet: (0, $8f7786e61047e565$export$884c674a282996e7)(state, [], (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE)
            }
        }));
const $7132c436572167eb$export$f217071b524cec4f = (hovered)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)(()=>{
        return {
            type: 'TABLE_HOVERED',
            data: {
                isTableHovered: hovered
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7132c436572167eb$export$1d614a0f0fe37c44 = (rowIndex, colIndex)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)((state)=>{
        const { hoveredCell: prevHoveredCell } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        // If no arguments have been passed then the intention it to reset the hover cell data
        const clear = rowIndex === undefined && colIndex === undefined;
        const nextRowIndex = clear ? undefined : rowIndex ?? prevHoveredCell.rowIndex;
        const nextColIndex = clear ? undefined : colIndex ?? prevHoveredCell.colIndex;
        if (nextRowIndex === prevHoveredCell.rowIndex && nextColIndex === prevHoveredCell.colIndex) return false;
        return {
            type: 'HOVER_CELL',
            data: {
                hoveredCell: {
                    rowIndex: nextRowIndex,
                    colIndex: nextColIndex
                }
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));





const $54880c895472da5f$export$fa79c3ccfdddfece = (sourceNode)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        return sourceNode ? (0, $5GR8v.removeConnectedNodes)(state, sourceNode) : tr;
    });

































// @ts-ignore -- ReadonlyTransaction is a local declaration and will cause a TS2305 error in CCFE typecheck




var $de12874950226c67$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'STOP_RESIZING':
            return {
                ...pluginState,
                resizeHandlePos: null,
                dragging: null
            };
        case 'SET_RESIZE_HANDLE_POSITION':
            return {
                ...pluginState,
                resizeHandlePos: action.data.resizeHandlePos
            };
        case 'SET_DRAGGING':
            return {
                ...pluginState,
                dragging: action.data.dragging
            };
        case 'SET_LAST_CLICK':
            const { lastClick: lastClick } = action.data;
            return {
                ...pluginState,
                lastClick: lastClick,
                resizeHandlePos: lastClick ? pluginState.resizeHandlePos : null
            };
        default:
            return pluginState;
    }
};


function $bd73f3b7ba9edc98$var$mapping(tr, pluginState) {
    if (pluginState && pluginState.resizeHandlePos !== null) return {
        ...pluginState,
        resizeHandlePos: tr.mapping.map(pluginState.resizeHandlePos)
    };
    return pluginState;
}
const $bd73f3b7ba9edc98$var$factory = (0, $lkJUe.pluginFactory)((0, $452bdd9463f93418$export$18d4026d1ea86bb1), (0, $de12874950226c67$export$2e2bcd8739ae039), {
    mapping: $bd73f3b7ba9edc98$var$mapping
});
const $bd73f3b7ba9edc98$export$8d4021544bdece00 = $bd73f3b7ba9edc98$var$factory.createCommand;
const $bd73f3b7ba9edc98$export$656c7661095efe2e = $bd73f3b7ba9edc98$var$factory.createPluginState;
const $bd73f3b7ba9edc98$export$f05434c51e3762e = $bd73f3b7ba9edc98$var$factory.getPluginState;




const $fab8fdccc1cad2fc$export$c955b9a736441250 = ({ resizeState: resizeState, table: table, start: start, event: event, api: api })=>(state, dispatch)=>{
        if (!(0, $iYC9s.isTableSelected)(state.selection)) return false;
        // double click detection logic
        // Note: ProseMirror's handleDoubleClick doesn't quite work with DOM mousedown event handler
        const { lastClick: lastClick } = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state);
        const now = Date.now();
        if (lastClick && now - lastClick.time < 500 && (0, $b432f0a26e9b5b59$export$f76d638a91295d45)(event, lastClick)) {
            const newState = (0, $77650a1f6e0f1ab2$export$aa593d179f012fe1)(resizeState);
            $fab8fdccc1cad2fc$var$setLastClick(null, (tr)=>(0, $b2a65d666c2c28a8$export$6688b13ec132acdf)(newState, table, start, api)(tr))(state, dispatch);
            return true;
        }
        $fab8fdccc1cad2fc$var$setLastClick({
            x: event.clientX,
            y: event.clientY,
            time: now
        })(state, dispatch);
        return false;
    };
const $fab8fdccc1cad2fc$export$e8f15c4883bd4cb9 = (newResizeState, table, api)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $b2a65d666c2c28a8$export$6688b13ec132acdf)(newResizeState, table.node, table.start, api)(state.tr);
            tr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
                name: (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).DISTRIBUTED_COLUMNS
            });
            $fab8fdccc1cad2fc$export$d1301521f1f26547(tr)(state, dispatch);
        }
        return true;
    };
const $fab8fdccc1cad2fc$export$4d14ce8b526952e5 = (resizeHandlePos)=>(0, $bd73f3b7ba9edc98$export$8d4021544bdece00)({
        type: 'SET_RESIZE_HANDLE_POSITION',
        data: {
            resizeHandlePos: resizeHandlePos
        }
    });
const $fab8fdccc1cad2fc$export$d1301521f1f26547 = (tr)=>(0, $bd73f3b7ba9edc98$export$8d4021544bdece00)({
        type: 'STOP_RESIZING'
    }, (originalTr)=>(tr || originalTr).setMeta('scrollIntoView', false).setMeta('is-resizer-resizing', false));
const $fab8fdccc1cad2fc$export$e747fb9908ce65b7 = (dragging, tr)=>(0, $bd73f3b7ba9edc98$export$8d4021544bdece00)({
        type: 'SET_DRAGGING',
        data: {
            dragging: dragging
        }
    }, (originalTr)=>(tr || originalTr).setMeta('is-resizer-resizing', true));
const $fab8fdccc1cad2fc$var$setLastClick = (lastClick, transform)=>(0, $bd73f3b7ba9edc98$export$8d4021544bdece00)({
        type: 'SET_LAST_CLICK',
        data: {
            lastClick: lastClick
        }
    }, transform);





























function $c13226e4e2217284$export$124b0cee26577176(tr) {
    const { selection: selection } = tr;
    if (!(selection instanceof (0, $7XFGZ.CellSelection)) || !$c13226e4e2217284$export$9df87bad3fce982f(tr)) return tr;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const rect = (0, $iP1et.getSelectionRect)(selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const table = (0, $id9O1.findTable)(selection);
    const map = (0, $LmqWp.TableMap).get(table.node);
    const seen = [];
    const selectedCells = map.cellsInRect(rect);
    let mergedCellPos;
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const rowCells = [];
        const row = table.node.child(rowIndex);
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = table.node.nodeAt(cellPos);
            if (!cell || seen.indexOf(cellPos) > -1) continue;
            seen.push(cellPos);
            // merged cell
            if (colIndex === rect.left && rowIndex === rect.top) {
                mergedCellPos = cellPos;
                // merge content of the selected cells, dropping empty cells
                let content = $c13226e4e2217284$var$isEmptyCell(cell) ? (0, $5SAOw.Fragment).empty : cell.content;
                const seenContent = [
                    mergedCellPos
                ];
                for(let i = rect.top; i < rect.bottom; i++)for(let j = rect.left; j < rect.right; j++){
                    const pos = map.map[i * map.width + j];
                    if (seenContent.indexOf(pos) === -1) {
                        seenContent.push(pos);
                        const copyCell = table.node.nodeAt(pos);
                        if (copyCell && !$c13226e4e2217284$var$isEmptyCell(copyCell)) content = content.append(copyCell.content);
                    }
                }
                const rowspan = rect.bottom - rect.top;
                if (rowspan < 1) return tr;
                // update colspan and rowspan of the merged cell to span the selection
                const attrs = $c13226e4e2217284$var$addColSpan({
                    ...cell.attrs,
                    rowspan: rowspan
                }, cell.attrs.colspan, rect.right - rect.left - cell.attrs.colspan);
                const newCell = content === (0, $5SAOw.Fragment).empty ? cell.type.createAndFill(attrs, content, cell.marks) : cell.type.createChecked(attrs, content, cell.marks);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                rowCells.push(newCell);
            } else if (selectedCells.indexOf(cellPos) === -1) // if its one of the selected cells, but not the merged cell, we get rid of it
            // otherwise we keep the cell
            rowCells.push(cell);
        }
        if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        else // empty row, we need to fix rowspans for rows above the current one
        for(let i = rows.length - 1; i >= 0; i--){
            const prevRow = rows[i];
            const cells = [];
            let rowChanged = false;
            for(let j = 0; j < prevRow.childCount; j++){
                const cell = prevRow.child(j);
                const { rowspan: rowspan } = cell.attrs;
                if (rowspan && rowspan + i - 1 >= rows.length) {
                    rowChanged = true;
                    if (rowspan < 2) return tr;
                    cells.push(cell.type.createChecked({
                        ...cell.attrs,
                        rowspan: rowspan - 1
                    }, cell.content, cell.marks));
                } else cells.push(cell);
            }
            if (rowChanged) rows[i] = row.type.createChecked(prevRow.attrs, cells, prevRow.marks);
        }
    }
    // empty tables? cancel merging like nothing happened
    if (!rows.length) return tr;
    const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
    const fixedTable = $c13226e4e2217284$export$84575ef2cffee22a(newTable);
    if (fixedTable === null) return tr;
    return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable).setSelection((0, $ks2lK.Selection).near(tr.doc.resolve((mergedCellPos || 0) + table.start)));
}
function $c13226e4e2217284$export$9df87bad3fce982f(tr) {
    const { selection: selection } = tr;
    if (!(selection instanceof (0, $7XFGZ.CellSelection)) || selection.$anchorCell.pos === selection.$headCell.pos) return false;
    const rect = (0, $iP1et.getSelectionRect)(selection);
    if (!rect) return false;
    const table = selection.$anchorCell.node(-1);
    const map = (0, $LmqWp.TableMap).get(table);
    if ($c13226e4e2217284$var$cellsOverlapRectangle(map, rect)) return false;
    return true;
}
function $c13226e4e2217284$var$isEmptyCell(cell) {
    const { content: content } = cell;
    return content.childCount === 1 && content.firstChild && content.firstChild.isTextblock && content.firstChild.childCount === 0;
}
function $c13226e4e2217284$var$addColSpan(attrs, pos, span = 1) {
    const newAttrs = {
        ...attrs,
        colspan: (attrs.colspan || 1) + span
    };
    if (newAttrs.colwidth) {
        newAttrs.colwidth = newAttrs.colwidth.slice();
        for(let i = 0; i < span; i++)newAttrs.colwidth.splice(pos, 0, 0);
    }
    return newAttrs;
}
function $c13226e4e2217284$var$cellsOverlapRectangle({ width: width, height: height, map: map }, rect) {
    let indexTop = rect.top * width + rect.left;
    let indexLeft = indexTop;
    let indexBottom = (rect.bottom - 1) * width + rect.left;
    let indexRight = indexTop + (rect.right - rect.left - 1);
    for(let i = rect.top; i < rect.bottom; i++){
        if (rect.left > 0 && map[indexLeft] === map[indexLeft - 1] || rect.right < width && map[indexRight] === map[indexRight + 1]) return true;
        indexLeft += width;
        indexRight += width;
    }
    for(let i = rect.left; i < rect.right; i++){
        if (rect.top > 0 && map[indexTop] === map[indexTop - width] || rect.bottom < height && map[indexBottom] === map[indexBottom + width]) return true;
        indexTop++;
        indexBottom++;
    }
    return false;
}
// returns an array of numbers, each number indicates the minimum colSpan in each column
function $c13226e4e2217284$var$getEmptyColumnIndexes(table) {
    const map = (0, $LmqWp.TableMap).get(table);
    const emptyColumnIndexes = new Set();
    // Loop throuh each column
    for(let colIndex = 0; colIndex < map.width; colIndex++){
        // Get the cells in each row for this column
        const cellPositions = map.cellsInRect({
            left: colIndex,
            right: colIndex + 1,
            top: 0,
            bottom: map.height
        });
        // If no cells exist in that column it is empty
        if (!cellPositions.length) emptyColumnIndexes.add(colIndex);
    }
    return emptyColumnIndexes;
}
function $c13226e4e2217284$export$84575ef2cffee22a(table) {
    const rows = [];
    const map = (0, $LmqWp.TableMap).get(table);
    const emptyColumnIndexes = $c13226e4e2217284$var$getEmptyColumnIndexes(table);
    // We don't need to remove any so return early.
    if (emptyColumnIndexes.size === 0) return table;
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const cellsByCols = {};
        // Work backwards so that calculating colwidths is easier with Array.slice
        for(let colIndex = map.width - 1; colIndex >= 0; colIndex--){
            const cellPos = map.map[colIndex + rowIndex * map.width];
            const rect = map.findCell(cellPos);
            let cell = cellsByCols[rect.left] || table.nodeAt(cellPos);
            if (rect.top !== rowIndex) continue;
            // If this column is empty, we want to decrement the colspan of its corresponding
            // cell as this column is being "merged"
            if (emptyColumnIndexes.has(colIndex)) {
                const { colspan: colspan, colwidth: colwidth } = cell.attrs;
                if (colspan > 1) cell = cell.type.createChecked({
                    ...cell.attrs,
                    colspan: colspan - 1,
                    colwidth: colwidth ? colwidth.slice(0, colspan) : null
                }, cell.content, cell.marks);
            }
            cellsByCols[rect.left] = cell;
        }
        const rowCells = Object.values(cellsByCols);
        const row = table.child(rowIndex);
        if (row) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
    }
    if (!rows.length) return null;
    return table.type.createChecked(table.attrs, rows, table.marks);
}


const $afc8bdade8a657ed$export$88b7a0bb8d808bf6 = (rect, isHeaderRowRequired = false)=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        const rowsToDelete = [];
        const map = (0, $LmqWp.TableMap).get(table.node);
        for(let i = rect.top; i < rect.bottom; i++)// skip header row if its required
        if (isHeaderRowRequired) {
            const cell = table.node.nodeAt(map.map[i * map.width]);
            if (cell && cell.type !== cell.type.schema.nodes.tableHeader) rowsToDelete.push(i);
        } else rowsToDelete.push(i);
        if (!rowsToDelete.length) return tr;
        const rows = [];
        const seen = {};
        const deletedCells = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            const rowCells = [];
            const row = table.node.child(rowIndex);
            for(let colIndex = 0; colIndex < map.width; colIndex++){
                const cellPos = map.map[rowIndex * map.width + colIndex];
                const cell = table.node.nodeAt(cellPos);
                if (!cell) continue;
                const cellsInRow = map.cellsInRect({
                    left: 0,
                    top: rowIndex,
                    right: map.width,
                    bottom: rowIndex + 1
                });
                if (rowsToDelete.indexOf(rowIndex) === -1 && !seen[cellPos]) {
                    // decrement rowspans for row-spanning cells that overlap deleted rows
                    if (cellsInRow.indexOf(cellPos) > -1) {
                        let overlappingRows = 0;
                        rowsToDelete.forEach((rowIndexToDelete)=>{
                            if (rowIndex < rowIndexToDelete && cell.attrs.rowspan + rowIndex - 1 >= rowIndexToDelete) overlappingRows += 1;
                        });
                        if (overlappingRows > 0) {
                            const newCell = cell.type.createChecked({
                                ...cell.attrs,
                                rowspan: cell.attrs.rowspan - overlappingRows
                            }, cell.content, cell.marks);
                            rowCells.push(newCell);
                            seen[cellPos] = true;
                            continue;
                        }
                    } else if (deletedCells[cellPos]) {
                        // if we're removing a row-spanning cell, we need to add missing cells to rows below
                        const attrs = {
                            ...cell.attrs,
                            colspan: 1,
                            rowspan: 1
                        };
                        if (cell.attrs.colwidth) {
                            const pos = colIndex > 0 ? colIndex - map.colCount(cellPos) : 0;
                            attrs.colwidth = cell.attrs.colwidth.slice().splice(pos, 1);
                        }
                        const newCell = cell.type.createChecked(attrs, cell.type.schema.nodes.paragraph.createChecked(), cell.marks);
                        rowCells.push(newCell);
                        continue;
                    }
                    // normal cells that we want to keep
                    if (!seen[cellPos]) {
                        seen[cellPos] = true;
                        rowCells.push(cell);
                    }
                } else if (cellsInRow.indexOf(cellPos) > -1) deletedCells[cellPos] = true;
            }
            if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
        if (!rows.length) return tr;
        const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
        const fixedTable = (0, $c13226e4e2217284$export$84575ef2cffee22a)(newTable);
        if (fixedTable === null) return tr;
        const cursorPos = $afc8bdade8a657ed$var$getNextCursorPos(newTable, rowsToDelete);
        // If we delete a row we should also clean up the hover selection
        tr.setMeta((0, $fedf15e5199146e8$export$18d4026d1ea86bb1), {
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                isInDanger: false,
                isWholeTableInDanger: false
            }
        });
        return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable)// move cursor before the deleted rows if possible, otherwise - to the first row
        .setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
    };
function $afc8bdade8a657ed$var$getNextCursorPos(table, deletedRows) {
    const minRow = Math.min(...deletedRows);
    const nextRowWithCursor = minRow > 0 ? minRow - 1 : 0;
    const map = (0, $LmqWp.TableMap).get(table);
    return map.map[nextRowWithCursor * map.width];
}














const $4964dcabee9819e6$export$1a1df84fec87e1b5 = (cell, schema)=>(tr)=>{
        if (cell) {
            const node = (0, $d1kIV.tableNodeTypes)(schema).cell.createAndFill();
            if (node && !cell.node.content.eq(node.content)) {
                tr.replaceWith(cell.pos + 1, cell.pos + cell.node.nodeSize, node.content);
                return (0, $8usfh.cloneTr)(tr);
            }
        }
        return tr;
    };






const $f49a30b111b3e46f$export$5d68db27bfdddb78 = (targetCellPosition)=>(state, dispatch)=>{
        let cursorPos;
        let { tr: tr } = state;
        if ((0, $BW42l.isSelectionType)(tr.selection, 'cell')) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selection = tr.selection;
            selection.forEachCell((_node, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                tr = (0, $4964dcabee9819e6$export$1a1df84fec87e1b5)((0, $id9O1.findCellClosestToPos)($pos), state.schema)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (targetCellPosition) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $id9O1.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            tr = (0, $4964dcabee9819e6$export$1a1df84fec87e1b5)(cell, state.schema)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos) {
            const $pos = tr.doc.resolve(tr.mapping.map(cursorPos));
            const textSelection = (0, $ks2lK.Selection).findFrom($pos, 1, true);
            if (textSelection) tr.setSelection(textSelection);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };



const $39aa9905e2194032$export$8afb7fb379a7ebd1 = (state, dispatch)=>{
    const collapseTr = (0, $8c756dab441d0bf4$export$436c9f28d887a0c3)(state.tr);
    if (!collapseTr) return false;
    if (dispatch) dispatch(collapseTr);
    return true;
};




























// Resize a given column by an amount from the current state


const $b475a539e4faa154$export$7f7e69ee7fe25ed6 = (resizeState, colIndex, amount, tableRef, tableNode, selectedColumns, isTableScalingEnabled = false, scalePercent = 1)=>{
    let resizeAmount = amount;
    if (isTableScalingEnabled) resizeAmount = amount / scalePercent;
    const newState = resizeAmount > 0 ? (0, $9ca3c6b800e4b699$export$276e2d0f37ca319a)(resizeState, colIndex, resizeAmount, selectedColumns) : resizeAmount < 0 ? (0, $9ca3c6b800e4b699$export$99e30963fc7d1a1e)(resizeState, colIndex, resizeAmount, selectedColumns) : resizeState;
    (0, $77650a1f6e0f1ab2$export$23e0010f5fd8981)(newState, tableRef, tableNode, isTableScalingEnabled, scalePercent);
    return newState;
};





const $cee807f94f070ba4$export$915a77877be361e9 = (selectionRect)=>{
    const columnIndexes = [];
    for(let i = selectionRect.left; i < selectionRect.right; i++)columnIndexes.push(i);
    return columnIndexes;
};
const $cee807f94f070ba4$export$d023456f91fdf995 = (selectionRect)=>{
    const rowIndexes = [];
    for(let i = selectionRect.top; i < selectionRect.bottom; i++)rowIndexes.push(i);
    return rowIndexes;
};


const $9f1d04378e27f5e1$var$getTablePluginCommand = (actionPayload, originalTr)=>{
    return (0, $69d6e2a2c784f306$export$8d4021544bdece00)(()=>actionPayload, (tr)=>(originalTr || tr).setMeta('addToHistory', false));
};
const $9f1d04378e27f5e1$var$updateResizeHandleAndStatePosition = (rowIndex, columnIndex, nextResizeHandlePos, nodeViewPortalProviderAPI)=>(state, dispatch)=>{
        let customTr = state.tr;
        const { pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        if (!allowColumnResizing) return false;
        const decorationsWithWidget = (0, $8d12b05d544e83c2$export$aa1fe977609f5606)(rowIndex, columnIndex, true, getIntl, nodeViewPortalProviderAPI)({
            tr: customTr,
            decorationSet: (0, $de8398c45f744acc$export$968abecb43309c32)(state)
        });
        const decorationsWithWidgetAndHandle = (0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(customTr.doc, decorationsWithWidget, (0, $9283ce7d62ffd391$export$c1faae7fcf0653ce)(state.selection, {
            right: columnIndex
        }), (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE);
        $9f1d04378e27f5e1$var$getTablePluginCommand({
            type: 'START_KEYBOARD_COLUMN_RESIZE',
            data: {
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: true,
                isKeyboardResize: true,
                decorationSet: decorationsWithWidgetAndHandle
            }
        }, customTr)(state, fakeDispatch);
        customTr.setMeta((0, $452bdd9463f93418$export$18d4026d1ea86bb1), {
            type: 'SET_RESIZE_HANDLE_POSITION',
            data: {
                resizeHandlePos: nextResizeHandlePos
            }
        });
        if (dispatch) {
            dispatch(customTr);
            return true;
        }
        return false;
    };
const $9f1d04378e27f5e1$export$833f46f974daec36 = ({ ariaNotify: ariaNotify, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(state, dispatch, view)=>{
        const { selection: selection } = state;
        const selectionRect = (0, $BW42l.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $iP1et.getSelectionRect)(selection) : (0, $id9O1.findCellRectClosestToPos)(selection.$from);
        const cell = (0, $id9O1.findCellClosestToPos)(selection.$from);
        if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).startedColumnResize), {
            priority: 'important'
        });
        if (selectionRect && cell && view) return $9f1d04378e27f5e1$var$updateResizeHandleAndStatePosition(selectionRect.top, selectionRect.right, cell.pos, nodeViewPortalProviderAPI)(state, dispatch);
        return false;
    };
const $9f1d04378e27f5e1$export$44cde2b92e1bbc4a = ({ direction: direction, ariaNotify: ariaNotify, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(state, dispatch, view)=>{
        const { resizeHandlePos: resizeHandlePos } = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state) || {};
        // If No resizing has initiated, skip to regular handler
        if (!resizeHandlePos) return false;
        const { selection: selection } = state;
        const cell = (0, $id9O1.findCellClosestToPos)(selection.$from);
        if (!cell) // cursor position may be changed by mouse to be outside of table;
        return false;
        const $currentCell = state.doc.resolve(resizeHandlePos);
        if (!$currentCell) return false;
        const tableNode = $currentCell.node(-1);
        const closestTable = (0, $id9O1.findTableClosestToPos)($currentCell);
        const tableMap = (0, $LmqWp.TableMap).get(tableNode);
        if (!tableNode || !closestTable || !tableMap) return false;
        const currentCellRect = tableMap.findCell($currentCell.pos - $currentCell.start(-1));
        const $nextCell = (0, $3gZJH.nextCell)($currentCell, 'horiz', direction);
        if (ariaNotify && getIntl) {
            if (direction === 1) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).focusedOtherResize, {
                direction: 'right'
            }), {
                priority: 'important'
            });
            if (direction === -1) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).focusedOtherResize, {
                direction: 'left'
            }), {
                priority: 'important'
            });
        }
        if ($nextCell) {
            // we are somewhere in between the side columns of the table
            const offset = $nextCell.pos - $nextCell.start(-1);
            const rectForNextCell = tableMap.findCell(offset);
            return $9f1d04378e27f5e1$var$updateResizeHandleAndStatePosition(rectForNextCell.top, rectForNextCell.right, $nextCell.pos, nodeViewPortalProviderAPI)(state, dispatch, view);
        } else {
            // current position is in the one of the side columns of the table(left or right)
            if (currentCellRect.left === 0) {
                const lastCellInCurrentRow = tableMap.positionAt(currentCellRect.top, tableMap.width - 1, tableNode) + closestTable.start;
                const $lastCell = state.doc.resolve(lastCellInCurrentRow);
                return $9f1d04378e27f5e1$var$updateResizeHandleAndStatePosition(currentCellRect.top, tableMap.width, $lastCell.pos, nodeViewPortalProviderAPI)(state, dispatch, view);
            } else if (tableMap.width === currentCellRect.right) {
                const firsCellInCurrentRow = tableMap.positionAt(currentCellRect.top, 0, tableNode) + closestTable.start;
                const $nextCell = state.doc.resolve(firsCellInCurrentRow);
                return $9f1d04378e27f5e1$var$updateResizeHandleAndStatePosition(currentCellRect.top, 1, $nextCell.pos, nodeViewPortalProviderAPI)(state, dispatch);
            }
        }
        return false;
    };
const $9f1d04378e27f5e1$export$4627714f08bcfd8 = ({ stepSize: stepSize, getEditorContainerWidth: getEditorContainerWidth, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isCommentEditor: isCommentEditor, ariaNotify: ariaNotify, api: api, getIntl: getIntl })=>(state, dispatch, view)=>{
        let customTr = state.tr;
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        const { resizeHandlePos: resizeHandlePos } = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state);
        const cell = (0, $id9O1.findCellClosestToPos)(state.selection.$from);
        if (!view || !resizeHandlePos || !cell) return false;
        const $cell = state.doc.resolve(resizeHandlePos);
        const tableStartPosition = $cell.start(-1);
        const originalTable = $cell.node(-1);
        const map = (0, $LmqWp.TableMap).get(originalTable);
        const domAtPos = view.domAtPos.bind(view);
        const colIndex = map.colCount($cell.pos - tableStartPosition) + ($cell.nodeAfter ? $cell.nodeAfter.attrs.colspan : 1) - 1;
        let dom = null;
        const domAtPosition = domAtPos(tableStartPosition);
        dom = domAtPosition.node instanceof HTMLTableElement ? domAtPosition.node : null;
        if (dom && dom.nodeName !== 'TABLE') dom = dom.closest('table');
        const cellAttrs = cell?.node.attrs;
        const width = (0, $b61fc0745b235461$export$8f862fd911e06936)(view, cell?.pos, cellAttrs);
        (0, $bd73f3b7ba9edc98$export$8d4021544bdece00)({
            type: 'SET_DRAGGING',
            data: {
                dragging: {
                    startX: 0,
                    startWidth: width
                }
            }
        })(state, fakeDispatch);
        const maxSize = (0, $b61fc0745b235461$export$8bfbafe1083a527d)({
            table: originalTable,
            tableStart: tableStartPosition,
            state: state,
            layout: originalTable.attrs.layout,
            getEditorContainerWidth: getEditorContainerWidth
        });
        let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = originalTable.attrs.displayMode !== 'fixed';
        let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
        if (isTableScalingEnabled && isCommentEditor) {
            isTableScalingEnabledOnCurrentTable = true;
            shouldUseIncreasedScalingPercent = true;
        }
        const initialResizeState = (0, $77650a1f6e0f1ab2$export$38f73cf370cfaafc)({
            minWidth: (0, $1zav4.tableCellMinWidth),
            maxSize: maxSize,
            table: originalTable,
            tableRef: dom,
            start: tableStartPosition,
            domAtPos: domAtPos,
            isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isCommentEditor: isCommentEditor
        });
        (0, $b432f0a26e9b5b59$export$13c259c17cfd51f5)()(state);
        const selectionRect = (0, $iP1et.getSelectionRect)(state.selection);
        const selectedColumns = selectionRect ? (0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect) : [];
        // only selected (or selected - 1) columns should be distributed
        const resizingSelectedColumns = selectedColumns.indexOf(colIndex) > -1 || selectedColumns.indexOf(colIndex + 1) > -1;
        const scalePercent = isTableScalingEnabled && isCommentEditor && !originalTable.attrs?.width ? (0, $b61fc0745b235461$export$4e884677f8e54bba)(originalTable, dom) : (0, $b61fc0745b235461$export$b2c142721a99201b)(originalTable, dom, shouldUseIncreasedScalingPercent);
        const newResizeState = (0, $b475a539e4faa154$export$7f7e69ee7fe25ed6)(initialResizeState, colIndex, stepSize, dom, originalTable, resizingSelectedColumns ? selectedColumns : undefined, isTableScalingEnabled, scalePercent);
        customTr = (0, $b2a65d666c2c28a8$export$6688b13ec132acdf)(newResizeState, originalTable, tableStartPosition, api)(customTr);
        if (dispatch) dispatch(customTr);
        if (ariaNotify && getIntl) {
            ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).changedColumnWidth, {
                width: Math.floor(newResizeState.cols[colIndex].width)
            }));
            if (newResizeState.cols.length === colIndex + 1) {
                if (newResizeState.overflow === true) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).columnResizeLast), {
                    priority: 'important'
                });
                if (newResizeState.overflow === false) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).columnResizeOverflow), {
                    priority: 'important'
                });
            }
        }
        return true;
    };
const $9f1d04378e27f5e1$export$b77825ff607efdbb = ({ ariaNotify: ariaNotify, getIntl: getIntl, originalTr: originalTr })=>(state, dispatch)=>{
        let customTr = originalTr || state.tr;
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        const decorationWithoutWidget = (0, $8d12b05d544e83c2$export$a590d16867e1babd)()({
            tr: customTr,
            decorationSet: (0, $de8398c45f744acc$export$968abecb43309c32)(state)
        });
        const decorationWithoutWidgetAndHandle = (0, $9283ce7d62ffd391$export$77a59c867f92cbc7)(customTr.doc, decorationWithoutWidget, [], (0, $8b6ac7577f3a66b8$export$fe8f2ca19399400e).COLUMN_RESIZING_HANDLE_LINE);
        $9f1d04378e27f5e1$var$getTablePluginCommand({
            type: 'STOP_KEYBOARD_COLUMN_RESIZE',
            data: {
                decorationSet: decorationWithoutWidgetAndHandle
            }
        }, customTr)(state, fakeDispatch);
        (0, $bd73f3b7ba9edc98$export$8d4021544bdece00)({
            type: 'STOP_RESIZING'
        }, ()=>customTr.setMeta('scrollIntoView', false))(state, fakeDispatch);
        if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).columnResizeStop), {
            priority: 'important'
        });
        if (dispatch) {
            dispatch(customTr);
            return true;
        }
        return false;
    };























function $eb6b76c935ecabc6$export$e526e68a5eecfb66(tr, tablePos, columnStart, columnEnd) {
    const mapStart = tr.mapping.maps.length;
    const table = tr.doc.nodeAt(tablePos);
    if (!table) return tr;
    const tableStart = tr.doc.resolve(tablePos).start(1);
    const map = (0, $LmqWp.TableMap).get(table);
    for(let column = columnStart; column < columnEnd; column++)for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const cellIndex = rowIndex * map.width + column;
        const cellPos = map.map[cellIndex];
        // Check if the cell is contained by another by another row/column
        const hasMergedCellsBefore = column > 0 && map.map[cellIndex - 1] === cellPos || rowIndex > 0 && map.map[(rowIndex - 1) * map.width + column] === cellPos;
        // Check if the cell contains another row/column
        const hasMergedCellsAfter = column < map.width - 1 && map.map[cellIndex + 1] === cellPos || rowIndex < map.height - 1 && map.map[(rowIndex + 1) * map.width + column] === cellPos;
        if (!hasMergedCellsBefore && hasMergedCellsAfter) {
            // Is a merged cell that start in this row/column
            const cellNode = table.nodeAt(cellPos);
            if (!cellNode) continue;
            const { colwidth: colwidth, colspan: colspan = 1, rowspan: rowspan = 1 } = cellNode.attrs;
            let mapping = tr.mapping.slice(mapStart);
            // Update current node with the simple colspan
            const baseAttrs = {
                ...cellNode.attrs,
                colspan: 1,
                rowspan: 1
            };
            // Add the new cells
            for(let cellRowIndex = rowIndex; cellRowIndex < rowIndex + rowspan; cellRowIndex++)for(let i = 0; i < colspan; i++){
                const mapping = tr.mapping.slice(mapStart);
                const cellPos = map.positionAt(cellRowIndex, column + i, table);
                tr.insert(mapping.map(cellPos + tableStart), // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                cellNode.type.createAndFill({
                    ...baseAttrs,
                    colwidth: colwidth ? [
                        colwidth[i]
                    ] : undefined
                }));
            }
            // Delete the original cell
            mapping = tr.mapping.slice(mapStart);
            tr.delete(mapping.map(cellPos + tableStart), mapping.map(cellPos + tableStart + cellNode.nodeSize));
            // Skip rows based on rowspan
            if (rowspan && rowspan > 1) rowIndex += rowspan - 1;
        }
    }
    return tr;
}


const $2519da145d38150e$var$deleteColumnsCustomStep = (rect)=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        // Need to split all the merge in the ranges (this is the current behaviour)
        // Maybe is better to split only the last column?
        // TODO: ED-26961 - After talking with Roto about this behaviour, he likes when we dont split the columns, I am keeping this for consistency of the current implementation.
        (0, $eb6b76c935ecabc6$export$e526e68a5eecfb66)(tr, table.pos, rect.left, rect.right);
        // Delete the columns
        const mapStart = tr.mapping.maps.length;
        const originalDoc = tr.doc;
        const deletedColumns = [];
        for(let i = rect.left; i < rect.right; i++){
            const step = (0, $1rJN9.AddColumnStep).create(originalDoc, table.pos, i, true);
            deletedColumns.push(i);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tr.step(step.map(tr.mapping.slice(mapStart)));
        }
        const tablePosResult = tr.mapping.mapResult(table.pos);
        if (tablePosResult.deleted) {
            const pos = Math.min(tablePosResult.pos, tr.doc.nodeSize - 1);
            tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(pos)));
        } else {
            const newTable = tr.doc.nodeAt(tablePosResult.pos);
            if (newTable) {
                const cursorPos = $2519da145d38150e$var$getNextCursorPos(newTable, deletedColumns);
                tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
            }
        }
        return tr;
    };
const $2519da145d38150e$var$deleteColumnsLegacy = (rect)=>(tr)=>{
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table) return tr;
        const columnsToDelete = [];
        for(let i = rect.left; i < rect.right; i++)columnsToDelete.push(i);
        if (!columnsToDelete.length) return tr;
        const map = (0, $LmqWp.TableMap).get(table.node);
        const rows = [];
        const seen = {};
        const deletedCells = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            const rowCells = [];
            const row = table.node.child(rowIndex);
            for(let colIndex = 0; colIndex < map.width; colIndex++){
                const cellPos = map.map[rowIndex * map.width + colIndex];
                const cell = table.node.nodeAt(cellPos);
                if (!cell) continue;
                const cellsInColumn = map.cellsInRect({
                    left: colIndex,
                    top: 0,
                    right: colIndex + 1,
                    bottom: map.height
                });
                if (columnsToDelete.indexOf(colIndex) === -1) {
                    // decrement colspans for col-spanning cells that overlap deleted columns
                    if (cellsInColumn.indexOf(cellPos) > -1 && !seen[cellPos]) {
                        let overlappingCols = 0;
                        columnsToDelete.forEach((colIndexToDelete)=>{
                            if (colIndex < colIndexToDelete && cell.attrs.colspan + colIndex - 1 >= colIndexToDelete) overlappingCols += 1;
                        });
                        if (overlappingCols > 0) {
                            const attrs = {
                                ...cell.attrs,
                                colspan: cell.attrs.colspan - overlappingCols
                            };
                            if (cell.attrs.colwidth) {
                                const minColIndex = Math.min(...columnsToDelete);
                                const pos = minColIndex > 0 ? minColIndex - map.colCount(cellPos) : 0;
                                const colwidth = cell.attrs.colwidth.slice() || [];
                                colwidth.splice(pos, overlappingCols);
                                attrs.colwidth = colwidth;
                            }
                            const newCell = cell.type.createChecked(attrs, cell.content, cell.marks);
                            rowCells.push(newCell);
                            seen[cellPos] = true;
                            continue;
                        }
                    } else if (deletedCells[cellPos]) {
                        // if we're removing a col-spanning cell, we need to add missing cells to columns to the right
                        const attrs = {
                            ...cell.attrs,
                            colspan: 1,
                            rowspan: 1
                        };
                        if (cell.attrs.colwidth) {
                            const pos = colIndex > 0 ? colIndex - map.colCount(cellPos) : 0;
                            attrs.colwidth = cell.attrs.colwidth.slice().splice(pos, 1);
                        }
                        const newCell = cell.type.createChecked(attrs, cell.type.schema.nodes.paragraph.createChecked(), cell.marks);
                        rowCells.push(newCell);
                        continue;
                    }
                    // normal cells that we want to keep
                    if (!seen[cellPos]) {
                        seen[cellPos] = true;
                        rowCells.push(cell);
                    }
                } else if (cellsInColumn.indexOf(cellPos) > -1) deletedCells[cellPos] = true;
            }
            if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
        if (!rows.length) return tr;
        const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
        const fixedTable = $2519da145d38150e$var$fixRowSpans(newTable);
        if (fixedTable === null) return tr;
        const cursorPos = $2519da145d38150e$var$getNextCursorPos(newTable, columnsToDelete);
        return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable)// move cursor to the left of the deleted columns if possible, otherwise - to the first column
        .setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
    };
function $2519da145d38150e$var$getNextCursorPos(table, deletedColumns) {
    const minColumn = Math.min(...deletedColumns);
    const nextColumnWithCursor = minColumn > 0 ? minColumn - 1 : 0;
    const map = (0, $LmqWp.TableMap).get(table);
    return map.map[nextColumnWithCursor];
}
// returns an array of numbers, each number indicates the minimum rowSpan in each row
function $2519da145d38150e$var$getMinRowSpans(table) {
    const minRowSpans = [];
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const rowSpans = [];
        const row = table.child(rowIndex);
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            rowSpans.push(cell.attrs.rowspan);
        }
        minRowSpans[rowIndex] = Math.min(...rowSpans);
    }
    return minRowSpans;
}
function $2519da145d38150e$var$fixRowSpans(table) {
    const map = (0, $LmqWp.TableMap).get(table);
    const minRowSpans = $2519da145d38150e$var$getMinRowSpans(table);
    if (!minRowSpans.some((rowspan)=>rowspan > 1)) return table;
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const row = table.child(rowIndex);
        if (minRowSpans[rowIndex] === 1) rows.push(row);
        else {
            const rowCells = [];
            for(let colIndex = 0; colIndex < row.childCount; colIndex++){
                const cell = row.child(colIndex);
                const rowspan = cell.attrs.rowspan - minRowSpans[rowIndex] + 1;
                if (rowspan < 1) return null;
                const newCell = cell.type.createChecked({
                    ...cell.attrs,
                    rowspan: rowspan
                }, cell.content, cell.marks);
                rowCells.push(newCell);
            }
            rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
    }
    if (!rows.length) return null;
    return table.type.createChecked(table.attrs, rows, table.marks);
}
const $2519da145d38150e$export$9dbd3595d5638a0b = (rect, allowCustomStep, api, view, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(tr)=>{
        let updatedTr = tr;
        updatedTr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
            name: (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).DELETED_COLUMN
        });
        if (allowCustomStep) updatedTr = $2519da145d38150e$var$deleteColumnsCustomStep(rect)(updatedTr);
        else updatedTr = $2519da145d38150e$var$deleteColumnsLegacy(rect)(updatedTr);
        const table = (0, $id9O1.findTable)(updatedTr.selection);
        if (table) updatedTr = (0, $b2a65d666c2c28a8$export$81edad89dedd3529)(isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, api, isCommentEditor)(table, view)(updatedTr);
        return updatedTr;
    };



const $e4429e273b8a2818$export$136e266e21963ad8 = (rect, api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(state, dispatch, view)=>{
        const tr = (0, $2519da145d38150e$export$9dbd3595d5638a0b)(rect, (0, $b53892aeb6ce63cd$export$f8ddfdc64e14a808)(state), api, view, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(state.tr);
        // If we delete a column we should also clean up the hover selection
        tr.setMeta((0, $fedf15e5199146e8$export$18d4026d1ea86bb1), {
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                isInDanger: false,
                isWholeTableInDanger: false
            }
        });
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };





const $4f0e4300b954578f$export$6ed6a850e47b73cc = ({ tr: tr })=>{
    const table = (0, $id9O1.findTable)(tr.selection);
    if (!table) return null;
    const { displayMode: displayMode } = table.node.attrs;
    tr.setNodeMarkup(table.pos, tr.doc.type.schema.nodes.table, {
        ...table.node.attrs,
        displayMode: !displayMode || displayMode === 'default' ? 'fixed' : 'default'
    });
    return tr.setMeta('scrollIntoView', false);
};










var $d4WtM = parcelRequire("d4WtM");















const $463dc03ee3a8d9cd$var$createGetInlineCardTextFromStore = (attrs)=>{
    const { data: data } = attrs;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (data && (data.name || data.title)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return data.name || data.title;
    const { url: cardUrl } = attrs;
    return cardUrl;
};
const $463dc03ee3a8d9cd$export$53e8d4c581cfe158 = (columnIndex, order = (0, $5rHEx.SortOrder).DESC)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)(()=>({
            type: 'SORT_TABLE',
            data: {
                ordering: {
                    columnIndex: columnIndex,
                    order: order
                }
            }
        }), (tr, state)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const table = (0, $id9O1.findTable)(tr.selection);
        if (!table || !table.node) return tr;
        const selectionRect = (0, $BW42l.isSelectionType)(tr.selection, 'cell') ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $iP1et.getSelectionRect)(tr.selection) : (0, $id9O1.findCellRectClosestToPos)(tr.selection.$from);
        if (!selectionRect) return tr;
        const tablePluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        const tableArray = (0, $6c611051a8223ad8$export$63019a088e9d8f5f)(table.node);
        let headerRow;
        if (tablePluginState.isHeaderRowEnabled) headerRow = tableArray.shift();
        const compareNodesInOrder = (0, $d4WtM.createCompareNodes)({
            getInlineCardTextFromStore: $463dc03ee3a8d9cd$var$createGetInlineCardTextFromStore
        }, order);
        const sortedTable = tableArray.sort((rowA, rowB)=>compareNodesInOrder(rowA[columnIndex], rowB[columnIndex]));
        if (headerRow) sortedTable.unshift(headerRow);
        const newTableNode = (0, $6c611051a8223ad8$export$5c8f3870f9ad667)(table.node, sortedTable);
        tr.replaceWith(table.pos, table.pos + table.node.nodeSize, newTableNode);
        const pos = (0, $LmqWp.TableMap).get(table.node).positionAt(selectionRect.top, columnIndex, table.node);
        const prev = tablePluginState.ordering;
        const next = {
            columnIndex: columnIndex,
            order: order
        };
        tr.step(new (0, $cCTpf.TableSortStep)(table.pos, prev, next));
        return tr.setSelection((0, $ks2lK.Selection).near(tr.doc.resolve(table.start + pos)));
    });




const $6a2616981e4f9350$export$74933b5979945879 = (state, dispatch)=>{
    const tableState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    const { tableHeader: tableHeader, tableCell: tableCell } = state.schema.nodes;
    if (dispatch) return (0, $92cfb9d684c33d6a$export$8c441a625fd4d770)(({ row: row, col: col })=>{
        if (row === 0 && tableState.isHeaderRowEnabled || col === 0 && tableState.isHeaderColumnEnabled) return tableHeader;
        return tableCell;
    })(state, dispatch);
    return true;
};


//#region Imports






var $2vynv = parcelRequire("2vynv");



const $4d39a5caa29eeec8$export$5ba3b70e6a8fb9d8 = (currentLayout)=>{
    switch(currentLayout){
        case 'default':
            return 'wide';
        case 'wide':
            return 'full-width';
        case 'full-width':
            return 'default';
        default:
            return 'default';
    }
};
const $4d39a5caa29eeec8$export$2155c86bec6ad614 = (state, dispatch)=>(0, $2vynv.toggleHeader)('row')(state, (tr)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)({
            type: 'TOGGLE_HEADER_ROW'
        }, ()=>tr.setMeta('scrollIntoView', false))(state, dispatch));
const $4d39a5caa29eeec8$export$cb41f2462444ad87 = (state, dispatch)=>(0, $2vynv.toggleHeader)('column')(state, (tr)=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)({
            type: 'TOGGLE_HEADER_COLUMN'
        }, ()=>tr.setMeta('scrollIntoView', false))(state, dispatch));
const $4d39a5caa29eeec8$export$67d4f89bd3067fa2 = (state, dispatch)=>{
    const { tr: tr } = state;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { node: node, pos: pos } = (0, $id9O1.findTable)(state.selection);
    const isNumberedColumnEnabled = node.attrs.isNumberColumnEnabled;
    tr.setNodeMarkup(pos, state.schema.nodes.table, {
        ...node.attrs,
        isNumberColumnEnabled: !isNumberedColumnEnabled
    });
    tr.setMeta('scrollIntoView', false);
    const tableOverflowChangeTriggerName = isNumberedColumnEnabled ? (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).DISABLED_NUMBERED_COLUMN : (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).ENABLED_NUMBERED_COLUMN;
    tr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
        name: tableOverflowChangeTriggerName
    });
    if (dispatch) dispatch(tr);
    return true;
};
const $4d39a5caa29eeec8$export$2e89b565e66d3fda = (state, dispatch)=>{
    const table = (0, $id9O1.findTable)(state.selection);
    if (!table) return false;
    const layout = $4d39a5caa29eeec8$export$5ba3b70e6a8fb9d8(table.node.attrs.layout);
    return (0, $69d6e2a2c784f306$export$8d4021544bdece00)({
        type: 'SET_TABLE_LAYOUT',
        data: {
            layout: layout
        }
    }, (tr)=>{
        tr.setNodeMarkup(table.pos, state.schema.nodes.table, {
            ...table.node.attrs,
            layout: layout
        });
        tr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
            name: (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED
        });
        return tr.setMeta('scrollIntoView', false);
    })(state, dispatch);
};
const $4d39a5caa29eeec8$export$458dbe7d48b81d0a = ()=>(0, $69d6e2a2c784f306$export$8d4021544bdece00)({
        type: 'TOGGLE_CONTEXTUAL_MENU'
    }, (tr)=>tr.setMeta('addToHistory', false)); // #endregion


const $d9aad08b0e0e65bb$export$67e5a2aa802b5be1 = (editorAnalyticsAPI)=>(inputMethod, targetCellPosition)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$277d5394a2608229)(selection);
            return {
                action: (0, $3824I.TABLE_ACTION).CLEARED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $f49a30b111b3e46f$export$5d68db27bfdddb78)(targetCellPosition));
const $d9aad08b0e0e65bb$export$96680f9d22153cab = (editorAnalyticsAPI)=>(inputMethod)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$277d5394a2608229)(selection);
            return {
                action: (0, $3824I.TABLE_ACTION).MERGED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalCells: totalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) dispatch((0, $c13226e4e2217284$export$124b0cee26577176)(state.tr));
            return true;
        });
const $d9aad08b0e0e65bb$export$e30671f873d3125c = (editorAnalyticsAPI)=>(inputMethod)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$277d5394a2608229)(selection);
            const cell = (0, $id9O1.findCellClosestToPos)(selection.$anchor);
            if (cell) {
                const { rowspan: verticalCells, colspan: horizontalCells } = cell.node.attrs;
                return {
                    action: (0, $3824I.TABLE_ACTION).SPLIT,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        inputMethod: inputMethod,
                        horizontalCells: horizontalCells,
                        verticalCells: verticalCells,
                        totalCells: horizontalCells * verticalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                };
            }
            return;
        })(editorAnalyticsAPI)((0, $6a2616981e4f9350$export$74933b5979945879));
const $d9aad08b0e0e65bb$export$d0cc02883d6bbba = (editorAnalyticsAPI)=>(inputMethod, cellColor, editorView)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$277d5394a2608229)(selection);
            return {
                action: (0, $3824I.TABLE_ACTION).COLORED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    cellColor: ((0, $63Ztt.tableBackgroundColorPalette).get(cellColor.toLowerCase()) || cellColor).toLowerCase(),
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalCells: totalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $4ca83755c936c9c8$export$91116982335533cf)({
            background: cellColor
        }, editorView));
const $d9aad08b0e0e65bb$export$4df69ad9d7ac565d = (editorAnalyticsAPI)=>(side)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const isCellSelection = selection instanceof (0, $7XFGZ.CellSelection);
            const rect = isCellSelection ? (0, $iP1et.getSelectionRect)(selection) : (0, $id9O1.findCellRectClosestToPos)(selection.$from);
            if (!rect) return false;
            const position = isCellSelection && side === 'TOP' ? rect.top : rect.bottom - 1;
            const offset = side === 'BOTTOM' ? 1 : 0;
            return $d9aad08b0e0e65bb$export$e45f3a1f9c021052(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT, {
                index: position + offset,
                moveCursorToInsertedRow: false
            })(state, dispatch);
        };
const $d9aad08b0e0e65bb$export$e45f3a1f9c021052 = (editorAnalyticsAPI)=>(inputMethod, options)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
            return {
                action: (0, $3824I.TABLE_ACTION).ADDED_ROW,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: options.index,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $6921de1f1a31eb9c$export$5a4e94bbc04b5f2)(options.index, options.moveCursorToInsertedRow));
const $d9aad08b0e0e65bb$export$e75fc938db126e1a = (editorAnalyticsAPI, api)=>(stepSize, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, inputMethod, ariaNotify, getIntl)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
            const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
            const { hoveredCell: { colIndex: colIndex } } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            return {
                action: (0, $3824I.TABLE_ACTION).COLUMN_RESIZED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    colIndex: colIndex,
                    resizedDelta: stepSize,
                    isLastColumn: colIndex === totalColumnCount - 1,
                    tableWidth: table?.node.attrs.width,
                    inputMethod: inputMethod,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                }
            };
        })(editorAnalyticsAPI)((0, $9f1d04378e27f5e1$export$4627714f08bcfd8)({
            stepSize: stepSize,
            getEditorContainerWidth: getEditorContainerWidth,
            isTableScalingEnabled: isTableScalingEnabled,
            isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled,
            isCommentEditor: isCommentEditor,
            ariaNotify: ariaNotify,
            getIntl: getIntl,
            api: api
        }));
const $d9aad08b0e0e65bb$export$fc693eab55df8b35 = (api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(inputMethod, position)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
            return {
                action: (0, $3824I.TABLE_ACTION).ADDED_COLUMN,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: position,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $6921de1f1a31eb9c$export$35ae1d3df4b27cf0)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(position));
const $d9aad08b0e0e65bb$export$ad9854279980efbe = (editorAnalyticsAPI)=>(inputMethod, rect, isHeaderRowRequired)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
            return {
                action: (0, $3824I.TABLE_ACTION).DELETED_ROW,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: rect.top,
                    count: rect.bottom - rect.top,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) dispatch((0, $afc8bdade8a657ed$export$88b7a0bb8d808bf6)(rect, isHeaderRowRequired)(state.tr));
            return true;
        });
const $d9aad08b0e0e65bb$export$4c11b948fab97510 = (editorAnalyticsAPI, api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(inputMethod, rect)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
            return {
                action: (0, $3824I.TABLE_ACTION).DELETED_COLUMN,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: rect.left,
                    count: rect.right - rect.left,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $e4429e273b8a2818$export$136e266e21963ad8)(rect, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor));
const $d9aad08b0e0e65bb$export$a5b48d8f68e0fbd = (editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)=>(state, dispatch)=>{
        const { selection: selection } = state;
        const isCellSelection = selection instanceof (0, $7XFGZ.CellSelection);
        if (!isCellSelection) return false;
        const rect = (0, $iP1et.getSelectionRect)(selection);
        if (!rect) return false;
        const selectionType = (0, $4ca83755c936c9c8$export$e5b37491e59cd9d)(selection);
        if (selectionType === 'row') {
            const { pluginConfig: pluginConfig } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            const isHeaderRowRequired = pluginConfig.isHeaderRowRequired || false;
            return $d9aad08b0e0e65bb$export$ad9854279980efbe(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).SHORTCUT, rect, isHeaderRowRequired)(state, dispatch);
        } else if (selectionType === 'column') return $d9aad08b0e0e65bb$export$4c11b948fab97510(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $d925B.INPUT_METHOD).SHORTCUT, rect)(state, dispatch);
        else return false;
    };
const $d9aad08b0e0e65bb$var$getTableDeletedAnalytics = (selection, inputMethod)=>{
    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
    return {
        action: (0, $3824I.TABLE_ACTION).DELETED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
        attributes: {
            inputMethod: inputMethod,
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    };
};
const $d9aad08b0e0e65bb$export$3e2fb93914330b82 = (editorAnalyticsAPI)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>$d9aad08b0e0e65bb$var$getTableDeletedAnalytics(selection, (0, $d925B.INPUT_METHOD).FLOATING_TB))(editorAnalyticsAPI)((0, $4ca83755c936c9c8$export$4882f04e79ed0a80));
const $d9aad08b0e0e65bb$export$253ebd9c41cefd54 = (editorAnalyticsAPI)=>(inputMethod)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>$d9aad08b0e0e65bb$var$getTableDeletedAnalytics(selection, inputMethod))(editorAnalyticsAPI)((0, $4ca83755c936c9c8$export$a853c8f1dbe33b1f));
const $d9aad08b0e0e65bb$export$2e66edaa488e7a1d = (editorAnalyticsAPI)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
        const { isHeaderRowEnabled: isHeaderRowEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        return {
            action: (0, $3824I.TABLE_ACTION).TOGGLED_HEADER_ROW,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !isHeaderRowEnabled,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $4d39a5caa29eeec8$export$2155c86bec6ad614));
const $d9aad08b0e0e65bb$export$9fd5a66fcada8ad2 = (editorAnalyticsAPI)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
        const { isHeaderColumnEnabled: isHeaderColumnEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        return {
            action: (0, $3824I.TABLE_ACTION).TOGGLED_HEADER_COLUMN,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !isHeaderColumnEnabled,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $4d39a5caa29eeec8$export$cb41f2462444ad87));
const $d9aad08b0e0e65bb$export$9e4b8d27ecc9c55 = (editorAnalyticsAPI)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
        return {
            action: (0, $3824I.TABLE_ACTION).TOGGLED_NUMBER_COLUMN,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !(0, $bdb0299b531c40df$export$101f2696d8127fe0)(state.selection),
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $4d39a5caa29eeec8$export$67d4f89bd3067fa2));
const $d9aad08b0e0e65bb$export$1be9cb7a554871e3 = (editorAnalyticsAPI)=>(inputMethod, columnIndex, sortOrder)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
            return {
                action: (0, $3824I.TABLE_ACTION).SORTED_COLUMN,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                attributes: {
                    inputMethod: inputMethod,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount,
                    position: columnIndex,
                    sortOrder: sortOrder,
                    mode: 'editor'
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $463dc03ee3a8d9cd$export$53e8d4c581cfe158)(columnIndex, sortOrder));
const $d9aad08b0e0e65bb$export$9bca7816a0c95373 = (editorAnalyticsAPI, api)=>(inputMethod, { resizeState: resizeState, table: table, attributes: attributes })=>{
        return (0, $d406f1b0c5d56902$export$c27221be174b6703)(()=>{
            return {
                action: (0, $3824I.TABLE_ACTION).DISTRIBUTED_COLUMNS_WIDTHS,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    ...attributes
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $fab8fdccc1cad2fc$export$e8f15c4883bd4cb9)(resizeState, table, api)(state, dispatch);
            return true;
        });
    };
const $d9aad08b0e0e65bb$export$70cd1c3ffea1a5d0 = (editorAnalyticsAPI)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
        return {
            action: (0, $3824I.TABLE_ACTION).COLLAPSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $39aa9905e2194032$export$8afb7fb379a7ebd1));
const $d9aad08b0e0e65bb$export$ebf85a007abbf908 = (editorAnalyticsAPI, inputMethod)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
        const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
        let previousDisplayMode;
        let newDisplayMode;
        switch(table?.node.attrs.displayMode){
            case 'fixed':
                previousDisplayMode = (0, $3824I.TABLE_DISPLAY_MODE).FIXED;
                newDisplayMode = (0, $3824I.TABLE_DISPLAY_MODE).DEFAULT;
                break;
            case 'default':
                previousDisplayMode = (0, $3824I.TABLE_DISPLAY_MODE).DEFAULT;
                newDisplayMode = (0, $3824I.TABLE_DISPLAY_MODE).FIXED;
                break;
            case null:
            default:
                previousDisplayMode = (0, $3824I.TABLE_DISPLAY_MODE).INITIAL;
                newDisplayMode = (0, $3824I.TABLE_DISPLAY_MODE).FIXED;
        }
        return {
            action: (0, $3824I.TABLE_ACTION).CHANGED_DISPLAY_MODE,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
            attributes: {
                inputMethod: inputMethod,
                previousDisplayMode: previousDisplayMode,
                newDisplayMode: newDisplayMode,
                tableWidth: table?.node.attrs.width,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $gmyMu.editorCommandToPMCommand)((0, $4f0e4300b954578f$export$6ed6a850e47b73cc)));
const $d9aad08b0e0e65bb$export$5d8dfbdf832abbae = (editorAnalyticsAPI, isCommentEditor)=>(newAlignment, previousAlignment, inputMethod, reason)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
            const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
            return {
                action: (0, $3824I.TABLE_ACTION).CHANGED_ALIGNMENT,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    tableWidth: table?.node.attrs.width,
                    newAlignment: newAlignment,
                    previousAlignment: previousAlignment === 'center' || previousAlignment === 'align-start' ? previousAlignment : null,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount,
                    inputMethod: inputMethod,
                    reason: reason
                }
            };
        })(editorAnalyticsAPI)((0, $gmyMu.editorCommandToPMCommand)((0, $4ca83755c936c9c8$export$e0cd4746386d78b5)(newAlignment, isCommentEditor)));
const $d9aad08b0e0e65bb$export$58691b745e97f79d = (editorAnalyticsAPI)=>(newAlignment, previousAlignment, tableNodeWithPos, inputMethod, reason)=>(0, $d406f1b0c5d56902$export$c27221be174b6703)(()=>{
            const map = (0, $LmqWp.TableMap).get(tableNodeWithPos.node);
            const totalRowCount = map.height;
            const totalColumnCount = map.width;
            const attributes = {
                tableWidth: tableNodeWithPos.node.attrs.width,
                newAlignment: newAlignment,
                previousAlignment: previousAlignment,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount,
                inputMethod: inputMethod,
                reason: reason
            };
            return {
                action: (0, $3824I.TABLE_ACTION).CHANGED_ALIGNMENT,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: attributes
            };
        })(editorAnalyticsAPI)((0, $gmyMu.editorCommandToPMCommand)((0, $4ca83755c936c9c8$export$2880e63de92f5116)(newAlignment, tableNodeWithPos)));















/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 



var $hArLp = parcelRequire("hArLp");


var $3P0Cg = parcelRequire("3P0Cg");

var $faH35 = parcelRequire("faH35");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $d179d7a7f1f90c15$var$containerStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.100'
});
const $d179d7a7f1f90c15$export$a6e8f537af71668f = ({ alignmentButtons: alignmentButtons, dispatchCommand: dispatchCommand, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
        xcss: $d179d7a7f1f90c15$var$containerStyles
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hArLp.default), null, alignmentButtons.map((item, idx)=>{
        switch(item.type){
            case 'separator':
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $faH35.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'button':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = item.icon;
                return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $3P0Cg.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    icon: item.icon ? /*#__PURE__*/ (0, $9K4OG.jsx)(ButtonIcon, {
                        label: item.title
                    }) : undefined,
                    title: item.title,
                    selected: item.selected,
                    disabled: item.disabled,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onClick: ()=>{
                        dispatchCommand(item.onClick);
                    },
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
        }
    })));
};


const $b9cb78eca8ad2cf1$export$aea1bbb5471be38f = (config, state, { formatMessage: formatMessage }, editorAnalyticsAPI, isTableScalingWithFixedColumnWidthsOptionShown = false, areTableColumnWidthsFixed = false)=>{
    const optionItem = 'item-checkbox';
    const options = [
        {
            id: 'editor.table.lockColumnWidths',
            title: formatMessage((0, $2CQVV.messages).lockColumnWidths),
            onClick: (0, $d9aad08b0e0e65bb$export$ebf85a007abbf908)(editorAnalyticsAPI, (0, $d925B.INPUT_METHOD).FLOATING_TB),
            selected: areTableColumnWidthsFixed,
            hidden: !isTableScalingWithFixedColumnWidthsOptionShown,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.headerRow',
            title: formatMessage((0, $2CQVV.messages).headerRow),
            onClick: (0, $d9aad08b0e0e65bb$export$2e66edaa488e7a1d)(editorAnalyticsAPI),
            selected: state.isHeaderRowEnabled,
            hidden: !config.allowHeaderRow,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.headerColumn',
            title: formatMessage((0, $2CQVV.messages).headerColumn),
            onClick: (0, $d9aad08b0e0e65bb$export$9fd5a66fcada8ad2)(editorAnalyticsAPI),
            selected: state.isHeaderColumnEnabled,
            hidden: !config.allowHeaderColumn,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.numberedColumn',
            title: formatMessage((0, $2CQVV.messages).numberedRows),
            onClick: (0, $d9aad08b0e0e65bb$export$9e4b8d27ecc9c55)(editorAnalyticsAPI),
            selected: state.isNumberColumnEnabled,
            hidden: !config.allowNumberColumn,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.collapseTable',
            title: formatMessage((0, $2CQVV.messages).collapseTable),
            onClick: (0, $d9aad08b0e0e65bb$export$70cd1c3ffea1a5d0)(editorAnalyticsAPI),
            selected: !!state.isTableCollapsed,
            disabled: !state.canCollapseTable,
            hidden: !config.allowCollapse,
            domItemOptions: {
                type: optionItem
            }
        }
    ];
    const tableOptionsDropdownWidth = isTableScalingWithFixedColumnWidthsOptionShown ? 192 : undefined;
    if (state.isDragAndDropEnabled) return {
        id: 'editor.table.tableOptions',
        type: 'dropdown',
        testId: 'table_options',
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($isYda))),
        title: formatMessage((0, $2CQVV.messages).tableOptions),
        hidden: options.every((option)=>option.hidden),
        options: options,
        dropdownWidth: tableOptionsDropdownWidth
    };
    else return {
        id: 'editor.table.tableOptions',
        type: 'dropdown',
        testId: 'table_options',
        title: formatMessage((0, $2CQVV.messages).tableOptions),
        hidden: options.every((option)=>option.hidden),
        options: options,
        dropdownWidth: tableOptionsDropdownWidth
    };
};
const $b9cb78eca8ad2cf1$export$99943093c6d7192b = (editorState, editorView, initialSelectionRect, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false, isLimitedModeEnabled = false)=>{
    const { top: top, bottom: bottom, right: right, left: left } = initialSelectionRect;
    const numberOfColumns = right - left;
    const numberOfRows = bottom - top;
    const pluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorState);
    const options = [
        {
            id: 'editor.table.insertColumn',
            title: formatMessage((0, $2CQVV.messages).insertColumn),
            onClick: (state, dispatch, view)=>{
                const selectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
                const index = selectionRect?.right;
                if (index) (0, $d9aad08b0e0e65bb$export$fc693eab55df8b35)(api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $d925B.INPUT_METHOD).FLOATING_TB, index)(state, dispatch, view);
                return true;
            },
            selected: false,
            disabled: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $6f5RK.shortcutStyle)
            }, (0, $hgeg8.tooltip)((0, $hgeg8.addColumnAfter)))
        },
        {
            id: 'editor.table.insertRow',
            title: formatMessage((0, $2CQVV.messages).insertRow),
            onClick: (state, dispatch)=>{
                const selectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
                const index = selectionRect?.bottom;
                if (index) (0, $d9aad08b0e0e65bb$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB, {
                    index: index,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            },
            selected: false,
            disabled: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $6f5RK.shortcutStyle)
            }, (0, $hgeg8.tooltip)((0, $hgeg8.addRowAfter)))
        },
        {
            id: 'editor.table.removeColumns',
            title: formatMessage((0, $2CQVV.messages).removeColumns, {
                0: numberOfColumns
            }),
            onClick: (state, dispatch, view)=>{
                const selectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
                if (selectionRect) (0, $d9aad08b0e0e65bb$export$4c11b948fab97510)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $d925B.INPUT_METHOD).FLOATING_TB, selectionRect)(state, dispatch, view);
                return true;
            },
            onFocus: $b9cb78eca8ad2cf1$var$highlightColumnsHandler,
            onBlur: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
            onMouseOver: $b9cb78eca8ad2cf1$var$highlightColumnsHandler,
            onMouseLeave: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
            selected: false,
            disabled: false
        },
        {
            id: 'editor.table.removeRows',
            title: formatMessage((0, $2CQVV.messages).removeRows, {
                0: numberOfRows
            }),
            onClick: (state, dispatch)=>{
                const selectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
                if (selectionRect) (0, $d9aad08b0e0e65bb$export$ad9854279980efbe)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB, selectionRect, false)(state, dispatch);
                return true;
            },
            onFocus: $b9cb78eca8ad2cf1$var$highlightRowsHandler,
            onBlur: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
            onMouseOver: $b9cb78eca8ad2cf1$var$highlightRowsHandler,
            onMouseLeave: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
            selected: false,
            disabled: false
        }
    ];
    if (pluginState.pluginConfig.allowMergeCells) options.push({
        id: 'editor.table.mergeCells',
        title: formatMessage((0, $2CQVV.messages).mergeCells),
        onClick: (0, $d9aad08b0e0e65bb$export$96680f9d22153cab)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB),
        selected: false,
        disabled: !(0, $c13226e4e2217284$export$9df87bad3fce982f)(editorState.tr)
    }, {
        id: 'editor.table.splitCell',
        title: formatMessage((0, $2CQVV.messages).splitCell),
        onClick: (0, $d9aad08b0e0e65bb$export$e30671f873d3125c)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB),
        selected: false,
        disabled: !(0, $2d87994eabccd17d$export$74933b5979945879)(editorState)
    });
    if (pluginState?.pluginConfig?.allowDistributeColumns) {
        let wouldChange = true; // Default to enabled - show the button.
        let newResizeStateWithAnalytics;
        // Performance optimization: Skip expensive getTableScalingPercent() DOM query when limited mode is enabled.
        // This avoids layout reflows on every transaction. Instead, button stays enabled and calculates on-demand when clicked.
        if (!isLimitedModeEnabled && !(0, $1oCLl.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true)) {
            newResizeStateWithAnalytics = editorView ? (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(initialSelectionRect, editorState, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor) : undefined;
            wouldChange = newResizeStateWithAnalytics?.changed ?? false;
        }
        const distributeColumnWidths = (state, dispatch, view)=>{
            // When optimization is enabled, calculate on-demand when clicked
            if (isLimitedModeEnabled || (0, $1oCLl.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true)) {
                if (view) {
                    const resizeState = (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(initialSelectionRect, state, view.domAtPos.bind(view), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
                    if (resizeState) {
                        (0, $d9aad08b0e0e65bb$export$9bca7816a0c95373)(editorAnalyticsAPI, api)((0, $d925B.INPUT_METHOD).FLOATING_TB, resizeState)(state, dispatch);
                        return true;
                    }
                }
                return false;
            } else {
                // Original behavior: use pre-calculated state
                if (newResizeStateWithAnalytics) {
                    (0, $d9aad08b0e0e65bb$export$9bca7816a0c95373)(editorAnalyticsAPI, api)((0, $d925B.INPUT_METHOD).FLOATING_TB, newResizeStateWithAnalytics)(state, dispatch);
                    return true;
                }
                return false;
            }
        };
        options.push({
            id: 'editor.table.distributeColumns',
            title: formatMessage((0, $2CQVV.messages).distributeColumns),
            onClick: distributeColumnWidths,
            selected: false,
            disabled: !wouldChange
        });
    }
    if (pluginState?.pluginConfig?.allowColumnSorting) {
        const hasMergedCellsInTable = (0, $1731f25dceb7d4d1$export$ffded79ba5549697)(editorState.tr).length > 0;
        const warning = hasMergedCellsInTable ? formatMessage((0, $2CQVV.messages).canNotSortTable) : undefined;
        options.push({
            id: 'editor.table.sortColumnAsc',
            title: formatMessage((0, $2CQVV.messages).sortColumnASC),
            onMouseOver: (state, dispatch)=>{
                if ((0, $1731f25dceb7d4d1$export$ffded79ba5549697)(state.tr).length !== 0) {
                    (0, $7132c436572167eb$export$59dcdc44819c7e7c)()(state, dispatch);
                    return true;
                }
                return false;
            },
            onMouseOut: (state, dispatch)=>{
                (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
                return true;
            },
            onClick: (state, dispatch)=>{
                (0, $d9aad08b0e0e65bb$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB, initialSelectionRect.left, (0, $5rHEx.SortOrder).ASC)(state, dispatch);
                return true;
            },
            selected: false,
            disabled: hasMergedCellsInTable,
            tooltip: warning
        });
        options.push({
            id: 'editor.table.sortColumnDesc',
            title: formatMessage((0, $2CQVV.messages).sortColumnDESC),
            onMouseOver: (state, dispatch)=>{
                if ((0, $1731f25dceb7d4d1$export$ffded79ba5549697)(state.tr).length !== 0) {
                    (0, $7132c436572167eb$export$59dcdc44819c7e7c)()(state, dispatch);
                    return true;
                }
                return false;
            },
            onMouseOut: (state, dispatch)=>{
                (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
                return true;
            },
            onClick: (state, dispatch)=>{
                (0, $d9aad08b0e0e65bb$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB, initialSelectionRect.left, (0, $5rHEx.SortOrder).DESC)(state, dispatch);
                return true;
            },
            selected: false,
            disabled: hasMergedCellsInTable,
            tooltip: warning
        });
    }
    options.push({
        id: 'editor.table.clearCells',
        title: formatMessage((0, $2CQVV.messages).clearCells, {
            0: Math.max(numberOfColumns, numberOfRows)
        }),
        onClick: (state, dispatch)=>{
            const { targetCellPosition: targetCellPosition } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            (0, $d9aad08b0e0e65bb$export$67e5a2aa802b5be1)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB, targetCellPosition)(state, dispatch);
            return true;
        },
        selected: false,
        disabled: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $6f5RK.shortcutStyle)
        }, (0, $hgeg8.tooltip)((0, $hgeg8.backspace)))
    });
    return {
        id: 'editor.table.cellOptions',
        testId: 'cell_options',
        type: 'dropdown',
        title: formatMessage((0, $2CQVV.messages).cellOptions),
        options: options,
        // Increased dropdown item width to prevent labels from being truncated
        dropdownWidth: 230,
        showSelected: false
    };
};
const $b9cb78eca8ad2cf1$export$e3ff63a8559e7571 = (state)=>{
    const selection = state.selection;
    return (0, $BW42l.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $iP1et.getSelectionRect)(selection) : (0, $id9O1.findCellRectClosestToPos)(selection.$from);
};
const $b9cb78eca8ad2cf1$var$getClosestSelectionOrTableRect = (state)=>{
    const selection = state.selection;
    const tableObject = (0, $id9O1.findTable)(state.selection);
    if (!tableObject) return;
    const map = (0, $LmqWp.TableMap).get(tableObject.node);
    const tableRect = new (0, $LmqWp.Rect)(0, 0, map.width, map.height);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, $BW42l.isSelectionType)(selection, 'cell') ? (0, $iP1et.getSelectionRect)(selection) : tableRect;
};
// Memoize the expensive DOM queries (querySelector, closestElement) separately
// Cache key is the parent DOM node reference - stays same when typing in same cell
const $b9cb78eca8ad2cf1$var$getTableWrapperFromParentImpl = (parent)=>{
    if (!parent) return undefined;
    // These are the expensive DOM operations
    const tableRef = // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    parent.querySelector('table') || undefined;
    if (!tableRef) return undefined;
    return (0, $4vlwG.closestElement)(tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`) || undefined;
};
// Create memoized version ONCE - reused across all calls
const $b9cb78eca8ad2cf1$var$getMemoizedTableWrapperFromParent = (0, $2XqLN.default)($b9cb78eca8ad2cf1$var$getTableWrapperFromParentImpl);
const $b9cb78eca8ad2cf1$export$86ce8f8241c20a3 = (getEditorContainerWidth, api, editorAnalyticsAPI, getEditorView, options, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false)=>(config)=>(state, intl)=>{
            const tableObject = (0, $id9O1.findTable)(state.selection);
            const pluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            const resizeState = (0, $452bdd9463f93418$export$18d4026d1ea86bb1).getState(state);
            const tableWidthState = (0, $e9b9e23609860f66$export$18d4026d1ea86bb1).getState(state);
            const isTableScalingEnabled = options?.isTableScalingEnabled || false;
            const nodeType = state.schema.nodes.table;
            const toolbarTitle = 'Table floating controls';
            const areAnyNewToolbarFlagsEnabled = (0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar));
            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) {
                const { isDragMenuOpen: isDragHandleMenuOpened = false, isDragging: isTableRowOrColumnDragged = false } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
                const isTableOrColumnResizing = !!(resizeState?.dragging || tableWidthState?.resizing);
                const isTableMenuOpened = pluginState.isContextualMenuOpen || isDragHandleMenuOpened;
                const isTableState = isTableRowOrColumnDragged || isTableOrColumnResizing || isTableMenuOpened;
                const isViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                // Note: when focus is in codeblocks, pluginState.editorHasFocus is false, so the codeblocks toolbar
                // won't be suppressed.
                const shouldSuppressAllToolbars = isTableState && pluginState.editorHasFocus && !isViewMode;
                if (shouldSuppressAllToolbars) return {
                    title: toolbarTitle,
                    items: [],
                    nodeType: nodeType
                };
            }
            // We don't want to show floating toolbar while resizing the table
            const isWidthResizing = tableWidthState?.resizing;
            if (tableObject && pluginState.editorHasFocus && !isWidthResizing) {
                const isNested = pluginState.tablePos && (0, $bdb0299b531c40df$export$d4302a800316ebd6)(state, pluginState.tablePos);
                const isTableScalingWithFixedColumnWidthsOptionShown = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled && !isNested;
                const areTableColumWidthsFixed = tableObject.node.attrs.displayMode === 'fixed';
                const editorView = getEditorView();
                const getDomRef = (0, $1oCLl.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true) ? (editorView)=>{
                    const domAtPos = editorView.domAtPos.bind(editorView);
                    const parent = (0, $8m4tT.findParentDomRefOfType)(nodeType, domAtPos)(state.selection);
                    return $b9cb78eca8ad2cf1$var$getMemoizedTableWrapperFromParent(parent);
                } : (editorView)=>{
                    let element;
                    const domAtPos = editorView.domAtPos.bind(editorView);
                    const parent = (0, $8m4tT.findParentDomRefOfType)(nodeType, domAtPos)(state.selection);
                    if (parent) {
                        const tableRef = // Ignored via go/ees005
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        parent.querySelector('table') || undefined;
                        if (tableRef) element = (0, $4vlwG.closestElement)(tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`) || undefined;
                    }
                    return element;
                };
                const menu = $b9cb78eca8ad2cf1$export$aea1bbb5471be38f(config, pluginState, intl, editorAnalyticsAPI, isTableScalingWithFixedColumnWidthsOptionShown, areTableColumWidthsFixed);
                const alignmentMenu = config.allowTableAlignment && !isNested ? $b9cb78eca8ad2cf1$var$getAlignmentOptionsConfig(state, intl, editorAnalyticsAPI, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, areAnyNewToolbarFlagsEnabled, options?.fullWidthEnabled, options?.isCommentEditor) : [];
                const isLimitedModeEnabled = api?.limitedMode?.sharedState.currentState()?.enabled ?? false;
                const cellItems = pluginState.isDragAndDropEnabled ? [] : $b9cb78eca8ad2cf1$var$getCellItems(state, editorView, intl, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, options?.isCommentEditor, isLimitedModeEnabled);
                const columnSettingsItems = pluginState.isDragAndDropEnabled ? $b9cb78eca8ad2cf1$var$getColumnSettingItems(state, editorView, intl, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, options?.isCommentEditor, isLimitedModeEnabled) : [];
                const colorPicker = !areAnyNewToolbarFlagsEnabled ? $b9cb78eca8ad2cf1$var$getColorPicker(state, menu, intl, editorAnalyticsAPI, getEditorView) : [];
                const fitToContentButton = (0, $3a3941a6aa273892$export$e217d2a535d6ae45)({
                    allowColumnResizing: !!pluginState.pluginConfig.allowColumnResizing,
                    allowTableResizing: !!pluginState.pluginConfig.allowTableResizing,
                    isFullPageEditor: !pluginState.isChromelessEditor && !pluginState.isCommentEditor
                }) && !isNested && api?.editorViewMode?.sharedState.currentState()?.mode !== 'view' && (0, $1oCLl.expValEquals)('platform_editor_table_fit_to_content_on_demand', 'isEnabled', true) ? [
                    {
                        id: 'editor.table.fitToContent',
                        type: 'button',
                        title: intl.formatMessage((0, $2CQVV.messages).fitToContent),
                        icon: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64M9v))), {
                                spacing: 'spacious',
                                label: ''
                            }),
                        onClick: (_state, _dispatch, view)=>{
                            if (view) (0, $3a3941a6aa273892$export$b4b4c38f004e5aad)(view, api ?? undefined);
                            return true;
                        }
                    }
                ] : [];
                // Check if we need to show confirm dialog for delete button
                let confirmDialog;
                if ((0, $5GR8v.isReferencedSource)(state, tableObject.node)) {
                    const localSourceName = intl.formatMessage((0, $2CQVV.messages).unnamedSource);
                    confirmDialog = ()=>({
                            title: intl.formatMessage((0, $2CQVV.messages).deleteElementTitle),
                            okButtonLabel: intl.formatMessage((0, $2CQVV.messages).confirmDeleteLinkedModalOKButton),
                            message: intl.formatMessage((0, $2CQVV.messages).confirmDeleteLinkedModalMessage, {
                                nodeName: (0, $5GR8v.getNodeName)(state, tableObject.node) || localSourceName
                            }),
                            messagePrefix: intl.formatMessage((0, $2CQVV.messages).confirmDeleteLinkedModalMessagePrefix),
                            isReferentialityDialog: true,
                            getChildrenInfo: ()=>(0, $5GR8v.getChildrenInfo)(state, tableObject.node),
                            checkboxLabel: intl.formatMessage((0, $2CQVV.messages).confirmModalCheckboxLabel),
                            onConfirm: (isChecked = false)=>$b9cb78eca8ad2cf1$var$clickWithCheckboxHandler(isChecked, tableObject.node)
                        });
                }
                const deleteButton = {
                    id: 'editor.table.delete',
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))),
                    onClick: (0, $d9aad08b0e0e65bb$export$3e2fb93914330b82)(editorAnalyticsAPI),
                    disabled: !!resizeState && !!resizeState.dragging,
                    onMouseEnter: (0, $7132c436572167eb$export$41c571b711ba06e)(true),
                    onFocus: (0, $7132c436572167eb$export$41c571b711ba06e)(true),
                    onBlur: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
                    onMouseLeave: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
                    title: intl.formatMessage((0, $61p3e.default).remove),
                    focusEditoronEnter: true,
                    confirmDialog: confirmDialog
                };
                const copyButton = {
                    type: 'copy-button',
                    supportsViewMode: true,
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: nodeType,
                            onMouseEnter: (0, $7132c436572167eb$export$41c571b711ba06e)(false, true),
                            onMouseLeave: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
                            onFocus: (0, $7132c436572167eb$export$41c571b711ba06e)(false, true),
                            onBlur: (0, $7132c436572167eb$export$d4bebf197f3770e4)()
                        }
                    ]
                };
                const isNestedTable = (0, $sxTNo.isNestedTablesSupported)(state.schema) && (0, $sxTNo.isSelectionTableNestedInTable)(state);
                const hoverTableProps = (isInDanger, isSelected)=>({
                        onMouseEnter: (0, $7132c436572167eb$export$41c571b711ba06e)(isInDanger, isSelected),
                        onMouseLeave: (0, $7132c436572167eb$export$d4bebf197f3770e4)(),
                        onFocus: (0, $7132c436572167eb$export$41c571b711ba06e)(isInDanger, isSelected),
                        onBlur: (0, $7132c436572167eb$export$d4bebf197f3770e4)()
                    });
                // testId is required to show focus on trigger button on ESC key press
                // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
                const overflowDropdownTestId = 'table-overflow-dropdown-trigger';
                const extensionState = api?.extension?.sharedState?.currentState();
                const extensionApi = api?.extension?.actions.api();
                return {
                    title: toolbarTitle,
                    getDomRef: getDomRef,
                    nodeType: nodeType,
                    offset: [
                        0,
                        18
                    ],
                    absoluteOffset: {
                        top: -6
                    },
                    zIndex: (0, $aFUXX.akEditorFloatingPanelZIndex) + 1,
                    // Place the context menu slightly above the others
                    items: [
                        menu,
                        ...!areAnyNewToolbarFlagsEnabled ? [
                            $b9cb78eca8ad2cf1$var$separator(menu.hidden)
                        ] : [],
                        ...alignmentMenu,
                        ...!areAnyNewToolbarFlagsEnabled ? [
                            $b9cb78eca8ad2cf1$var$separator(alignmentMenu.length === 0)
                        ] : [],
                        ...cellItems,
                        ...columnSettingsItems,
                        ...fitToContentButton,
                        ...colorPicker,
                        ...!areAnyNewToolbarFlagsEnabled ? [
                            {
                                type: 'extensions-placeholder',
                                separator: 'end'
                            },
                            copyButton,
                            {
                                type: 'separator'
                            },
                            deleteButton
                        ] : [
                            areAnyNewToolbarFlagsEnabled && {
                                type: 'separator',
                                fullHeight: true
                            },
                            {
                                type: 'overflow-dropdown',
                                testId: overflowDropdownTestId,
                                dropdownWidth: 220,
                                options: [
                                    {
                                        type: 'custom',
                                        fallback: [],
                                        render: (editorView, dropdownOptions)=>{
                                            if (!editorView) return null;
                                            if (!extensionApi || !extensionState?.extensionProvider) return null;
                                            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $aaI8u.DropdownMenuExtensionItems), {
                                                node: tableObject.node,
                                                editorView: editorView,
                                                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                                extension: {
                                                    extensionProvider: extensionState?.extensionProvider ? Promise.resolve(extensionState.extensionProvider) : undefined,
                                                    extensionApi: extensionApi
                                                },
                                                dropdownOptions: dropdownOptions,
                                                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                                disabled: (key)=>{
                                                    return isNestedTable && [
                                                        'referentiality:connections',
                                                        'chart:insert-chart'
                                                    ].includes(key);
                                                },
                                                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                                            });
                                        }
                                    },
                                    ...extensionApi && extensionState?.extensionProvider && !areAnyNewToolbarFlagsEnabled ? [
                                        {
                                            type: 'separator'
                                        }
                                    ] : [],
                                    {
                                        title: intl.formatMessage((0, $61p3e.default).copyToClipboard),
                                        onClick: ()=>{
                                            api?.core?.actions.execute(// @ts-ignore
                                            api?.floatingToolbar?.commands.copyNode(nodeType, (0, $d925B.INPUT_METHOD).FLOATING_TB));
                                            return true;
                                        },
                                        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))), {
                                            label: intl.formatMessage((0, $61p3e.default).copyToClipboard)
                                        }),
                                        ...hoverTableProps(false, true)
                                    },
                                    {
                                        title: intl.formatMessage((0, $61p3e.default).delete),
                                        onClick: (0, $d9aad08b0e0e65bb$export$3e2fb93914330b82)(editorAnalyticsAPI),
                                        icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
                                            label: intl.formatMessage((0, $61p3e.default).delete)
                                        }),
                                        ...hoverTableProps(true),
                                        confirmDialog: confirmDialog
                                    }
                                ]
                            }
                        ]
                    ],
                    scrollable: true
                };
            }
            return;
        };
const $b9cb78eca8ad2cf1$var$separator = (hidden)=>{
    return {
        type: 'separator',
        hidden: hidden
    };
};
const $b9cb78eca8ad2cf1$var$getCellItems = (state, view, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false, isLimitedModeEnabled = false)=>{
    const initialSelectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
    if (initialSelectionRect) {
        const cellOptions = $b9cb78eca8ad2cf1$export$99943093c6d7192b(state, view, initialSelectionRect, {
            formatMessage: formatMessage
        }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isLimitedModeEnabled);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return [
            cellOptions,
            $b9cb78eca8ad2cf1$var$separator(cellOptions.hidden)
        ];
    }
    return [];
};
const $b9cb78eca8ad2cf1$var$getDistributeConfig = (getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>(state, dispatch, editorView)=>{
        const selectionOrTableRect = $b9cb78eca8ad2cf1$var$getClosestSelectionOrTableRect(state);
        if (!editorView || !selectionOrTableRect) return false;
        const newResizeStateWithAnalytics = (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(selectionOrTableRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
        if (newResizeStateWithAnalytics) {
            (0, $d9aad08b0e0e65bb$export$9bca7816a0c95373)(editorAnalyticsAPI, api)((0, $d925B.INPUT_METHOD).FLOATING_TB, newResizeStateWithAnalytics)(state, dispatch);
            return true;
        }
        return false;
    };
// this create the button group for distribute column and also fixed column width
// fixed column button should be in this function call in the future
const $b9cb78eca8ad2cf1$var$getColumnSettingItems = (editorState, editorView, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false, isLimitedModeEnabled = false)=>{
    const pluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorState);
    const items = [];
    let wouldChange = true; // Default to enabled - show the button.
    let newResizeStateWithAnalytics;
    if ((0, $1oCLl.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true)) {
        if (!editorView) return [];
    } else {
        const selectionOrTableRect = $b9cb78eca8ad2cf1$var$getClosestSelectionOrTableRect(editorState);
        if (!selectionOrTableRect || !editorView) return [];
        // Performance optimization: Skip expensive getTableScalingPercent() DOM query when limited mode is enabled.
        // This avoids layout reflows on every transaction. Instead, button stays enabled and calculates on-demand when clicked.
        if (!isLimitedModeEnabled) {
            newResizeStateWithAnalytics = (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(selectionOrTableRect, editorState, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
            wouldChange = newResizeStateWithAnalytics?.changed ?? false;
        }
    }
    if (pluginState?.pluginConfig?.allowDistributeColumns && pluginState.isDragAndDropEnabled) items.push({
        id: 'editor.table.distributeColumns',
        type: 'button',
        title: formatMessage((0, $2CQVV.messages).distributeColumns),
        icon: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iBNSQ))), {
                spacing: 'spacious',
                label: ''
            }),
        onClick: (state, dispatch, view)=>$b9cb78eca8ad2cf1$var$getDistributeConfig(getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor)(state, dispatch, view),
        disabled: !wouldChange
    });
    if (items.length !== 0 && !(0, $iHzeA.areToolbarFlagsEnabled)(Boolean(api?.toolbar))) items.push({
        type: 'separator'
    });
    return items;
};
const $b9cb78eca8ad2cf1$var$getColorPicker = (state, menu, { formatMessage: formatMessage }, editorAnalyticsAPI, getEditorView)=>{
    const { targetCellPosition: targetCellPosition, pluginConfig: pluginConfig } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    if (!pluginConfig.allowBackgroundColor) return [];
    const node = targetCellPosition ? state.doc.nodeAt(targetCellPosition) : undefined;
    const currentBackground = node?.attrs?.background || '#ffffff';
    const defaultPalette = (0, $81b7b6f3cf3366fc$export$2e2bcd8739ae039).find((item)=>item.value === currentBackground) || {
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        label: 'Custom',
        value: currentBackground,
        border: (0, $lhtyR.DEFAULT_BORDER_COLOR)
    };
    return [
        {
            id: 'editor.table.colorPicker',
            title: formatMessage((0, $2CQVV.messages).cellBackground),
            type: 'select',
            isAriaExpanded: true,
            selectType: 'color',
            defaultValue: defaultPalette,
            options: (0, $81b7b6f3cf3366fc$export$2e2bcd8739ae039),
            returnEscToButton: true,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange: (option)=>(0, $d9aad08b0e0e65bb$export$d0cc02883d6bbba)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).FLOATING_TB, option.value, getEditorView())
        },
        $b9cb78eca8ad2cf1$var$separator(menu.hidden)
    ];
};
const $b9cb78eca8ad2cf1$var$clickWithCheckboxHandler = (isChecked, node, editorAnalyticsAPI)=>(state, dispatch)=>{
        if (!node) return false;
        if (!isChecked) return (0, $d9aad08b0e0e65bb$export$3e2fb93914330b82)(editorAnalyticsAPI)(state, dispatch);
        else (0, $54880c895472da5f$export$fa79c3ccfdddfece)(node)(state, dispatch);
        return true;
    };
const $b9cb78eca8ad2cf1$var$highlightRowsHandler = (state, dispatch)=>{
    const selectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
    if (selectionRect) {
        (0, $7132c436572167eb$export$ab63d99b591b89)((0, $cee807f94f070ba4$export$d023456f91fdf995)(selectionRect), true)(state, dispatch);
        return true;
    }
    return false;
};
const $b9cb78eca8ad2cf1$var$highlightColumnsHandler = (state, dispatch)=>{
    const selectionRect = $b9cb78eca8ad2cf1$export$e3ff63a8559e7571(state);
    if (selectionRect) {
        (0, $7132c436572167eb$export$4cf548f2efac0afe)((0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect), true)(state, dispatch);
        return true;
    }
    return false;
};
const $b9cb78eca8ad2cf1$var$getAlignmentOptionsConfig = (editorState, { formatMessage: formatMessage }, editorAnalyticsAPI, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, areAnyNewToolbarFlagsEnabled, isFullWidthEditor, isCommentEditor)=>{
    const tableObject = (0, $id9O1.findTable)(editorState.selection);
    if (!tableObject) return [];
    const alignmentIcons = [
        {
            id: 'editor.table.alignLeft',
            value: 'align-start',
            icon: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1dusJ))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "table-align-start-icon"
                })
        },
        {
            id: 'editor.table.alignCenter',
            value: 'center',
            icon: ()=>/*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dxgIg))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "table-align-center-icon"
                })
        }
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const layoutToMessages = {
        center: (0, $2CQVV.messages).alignTableCenter,
        'align-start': (0, $2CQVV.messages).alignTableLeft
    };
    const alignmentButtons = alignmentIcons.map((alignmentIcon)=>{
        const { id: id, value: value, icon: icon } = alignmentIcon;
        const currentLayout = tableObject.node.attrs.layout;
        const shouldDisableLayoutOption = (0, $1oCLl.expValEquals)('platform_editor_table_toolbar_perf_fix', 'isEnabled', true) ? $b9cb78eca8ad2cf1$var$getMemoizedIsLayoutOptionDisabled(tableObject.node, getEditorContainerWidth, editorView !== null, shouldUseIncreasedScalingPercent, isFullWidthEditor) : $b9cb78eca8ad2cf1$var$isLayoutOptionDisabled(tableObject.node, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, isFullWidthEditor);
        return {
            id: id,
            type: 'button',
            icon: icon,
            title: formatMessage(layoutToMessages[value]),
            selected: (0, $8b84c930bc26bcf8$export$2e10df95acfe6933)(currentLayout) === value,
            onClick: (0, $d9aad08b0e0e65bb$export$5d8dfbdf832abbae)(editorAnalyticsAPI, isCommentEditor || false)(value, currentLayout, (0, $d925B.INPUT_METHOD).FLOATING_TB, (0, $3824I.CHANGE_ALIGNMENT_REASON).TOOLBAR_OPTION_CHANGED),
            ...shouldDisableLayoutOption && {
                disabled: value !== 'center'
            }
        };
    });
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $d179d7a7f1f90c15$export$a6e8f537af71668f), {
                alignmentButtons: alignmentButtons,
                ...props,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        },
        width: 74,
        height: 32
    };
    const selectedAlignmentIcon = $b9cb78eca8ad2cf1$var$getSelectedAlignmentIcon(alignmentIcons, tableObject.node);
    const alignmentToolbarItem = [
        {
            id: 'table-layout',
            testId: 'table-layout-dropdown',
            type: 'dropdown',
            options: alignmentItemOptions,
            title: formatMessage((0, $2CQVV.messages).tableAlignmentOptions),
            icon: selectedAlignmentIcon?.icon
        }
    ];
    return alignmentToolbarItem;
};
const $b9cb78eca8ad2cf1$var$getSelectedAlignmentIcon = (alignmentIcons, selectedNode)=>{
    const selectedAlignment = selectedNode.attrs.layout;
    return alignmentIcons.find((icon)=>icon.value === (0, $8b84c930bc26bcf8$export$2e10df95acfe6933)(selectedAlignment));
};
const $b9cb78eca8ad2cf1$var$isLayoutOptionDisabledImpl = (selectedNode, getEditorContainerWidth, hasEditorView, shouldUseIncreasedScalingPercent, isFullWidthEditor)=>{
    const { lineLength: lineLength } = getEditorContainerWidth();
    let tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(selectedNode);
    // table may be scaled, use the scale percent to calculate the table width
    if (hasEditorView) {
        const tableWrapperWidth = tableContainerWidth;
        const scalePercent = (0, $b61fc0745b235461$export$f9c5ace2959c7a33)(selectedNode, tableWrapperWidth, shouldUseIncreasedScalingPercent);
        tableContainerWidth = tableContainerWidth * scalePercent;
    }
    // If fixed-width editor, we disable 'left-alignment' when table width is 760px.
    // tableContainerWidth +1 here because tableContainerWidth is 759 in fixed-width editor
    if (selectedNode && !isFullWidthEditor && lineLength && tableContainerWidth + 1 >= lineLength) return true;
    return false;
};
const $b9cb78eca8ad2cf1$var$getMemoizedIsLayoutOptionDisabled = (0, $2XqLN.default)($b9cb78eca8ad2cf1$var$isLayoutOptionDisabledImpl, ([prevNode, ...prevRest], [nextNode, ...nextRest])=>{
    // Only node needs special comparison (attrs only), rest use reference equality
    const nodeEqual = (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(prevNode.attrs, nextNode.attrs);
    const restEqual = prevRest.every((val, idx)=>val === nextRest[idx]);
    return nodeEqual && restEqual;
});
const $b9cb78eca8ad2cf1$var$isLayoutOptionDisabled = (selectedNode, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, isFullWidthEditor)=>{
    const { lineLength: lineLength } = getEditorContainerWidth();
    let tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(selectedNode);
    // table may be scaled, use the scale percent to calculate the table width
    if (editorView) {
        const tableWrapperWidth = tableContainerWidth;
        const scalePercent = (0, $b61fc0745b235461$export$f9c5ace2959c7a33)(selectedNode, tableWrapperWidth, shouldUseIncreasedScalingPercent);
        tableContainerWidth = tableContainerWidth * scalePercent;
    }
    // If fixed-width editor, we disable 'left-alignment' when table width is 760px.
    // tableContainerWidth +1 here because tableContainerWidth is 759 in fixed-width editor
    if (selectedNode && !isFullWidthEditor && lineLength && tableContainerWidth + 1 >= lineLength) return true;
    return false;
};








const $95cc14ff7c35ef77$export$79db8995cf046b43 = (selectedIndexes, direction)=>Math[direction < 0 ? 'min' : 'max'](...selectedIndexes) + direction;
const $95cc14ff7c35ef77$export$a4ef2b0c3fa55ad2 = (sourceType, direction, totalItemsOfSourceTypeCount, selection, selectionRect)=>{
    if (!selectionRect) return false;
    const isRow = sourceType === 'table-row';
    const selectedIndexes = isRow ? (0, $cee807f94f070ba4$export$d023456f91fdf995)(selectionRect) : (0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect);
    const targetIndex = $95cc14ff7c35ef77$export$79db8995cf046b43(selectedIndexes, direction);
    const isValidTargetIndex = targetIndex >= 0 && targetIndex < totalItemsOfSourceTypeCount;
    if (!isValidTargetIndex) return false;
    // We can't move column when target has merged cells with other columns
    // We can't move row when target has merged cells with other rows
    const hasMergedCellsInTarget = isRow ? (0, $0e87c5ebb1bfe871$export$7ef37f297601e698)(targetIndex, selection) : (0, $0e87c5ebb1bfe871$export$834c4ba4fe64e8f2)(targetIndex, selection);
    if (hasMergedCellsInTarget) return false;
    // We can't move if selection in the source is not a rectangle
    if ((0, $0e87c5ebb1bfe871$export$e4c313e419348ae7)(selectedIndexes, isRow ? 'row' : 'column')(selection)) return false;
    return true;
};
const $95cc14ff7c35ef77$var$isDistributeColumnsEnabled = (state)=>{
    const rect = (0, $b9cb78eca8ad2cf1$export$e3ff63a8559e7571)(state);
    if (rect) {
        const selectedColIndexes = (0, $cee807f94f070ba4$export$915a77877be361e9)(rect);
        return selectedColIndexes.length > 1;
    }
    return false;
};
const $95cc14ff7c35ef77$var$defaultSelectionRect = {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
};
const $95cc14ff7c35ef77$export$25f919d23e41e94d = (direction, getEditorContainerWidth, hasMergedCellsInTable, editorView, api, tableMap, index, targetCellPosition, selectionRect, editorAnalyticsAPI, isHeaderRowRequired, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, ariaNotifyPlugin, isCommentEditor = false, isColumnSortingEnabled = true)=>{
    const { selection: selection } = editorView.state;
    const { getIntl: getIntl } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
    const addOptions = direction === 'row' ? [
        {
            label: 'above',
            offset: 0,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kDG2N))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $hgeg8.addRowBefore)
        },
        {
            label: 'below',
            offset: 1,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4s9K9))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $hgeg8.addRowAfter)
        }
    ] : [
        {
            label: 'left',
            offset: 0,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($luItc))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $hgeg8.addColumnBefore)
        },
        {
            label: 'right',
            offset: 1,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6p8nb))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $hgeg8.addColumnAfter)
        }
    ];
    const isNewKeymapExperiment = (0, $1oCLl.expValEquals)('editor-a11y-fy26-keyboard-move-row-column', 'isEnabled', true);
    const moveOptions = direction === 'row' ? [
        {
            label: 'up',
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gzmk4))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $hgeg8.moveRowUp) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $hgeg8.moveRowUpOld),
            canMove: $95cc14ff7c35ef77$export$a4ef2b0c3fa55ad2('table-row', -1, tableMap?.height ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $cee807f94f070ba4$export$d023456f91fdf995),
            getTargetIndex: (selectionRect)=>selectionRect.top - 1
        },
        {
            label: 'down',
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($krMwx))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $hgeg8.moveRowDown) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $hgeg8.moveRowDownOld),
            canMove: $95cc14ff7c35ef77$export$a4ef2b0c3fa55ad2('table-row', 1, tableMap?.height ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $cee807f94f070ba4$export$d023456f91fdf995),
            getTargetIndex: (selectionRect)=>selectionRect.bottom
        }
    ] : [
        {
            label: 'left',
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lvYQd))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $hgeg8.moveColumnLeft) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $hgeg8.moveColumnLeftOld),
            canMove: $95cc14ff7c35ef77$export$a4ef2b0c3fa55ad2('table-column', -1, tableMap?.width ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $cee807f94f070ba4$export$915a77877be361e9),
            getTargetIndex: (selectionRect)=>selectionRect.left - 1
        },
        {
            label: 'right',
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($batr4))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $hgeg8.moveColumnRight) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $hgeg8.moveColumnRightOld),
            canMove: $95cc14ff7c35ef77$export$a4ef2b0c3fa55ad2('table-column', 1, tableMap?.width ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $cee807f94f070ba4$export$915a77877be361e9),
            getTargetIndex: (selectionRect)=>selectionRect.right
        }
    ];
    const sortOptions = direction === 'column' ? [
        {
            label: 'increasing',
            order: (0, $5rHEx.SortOrder).ASC,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4c0se))), {
                    spacing: 'spacious',
                    label: ''
                })
        },
        {
            label: 'decreasing',
            order: (0, $5rHEx.SortOrder).DESC,
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dmsGX))), {
                    spacing: 'spacious',
                    label: ''
                })
        }
    ] : [];
    const sortConfigs = sortOptions.map(({ label: label, order: order, icon: icon })=>({
            id: `sort_column_${order}`,
            title: `Sort ${label}`,
            disabled: hasMergedCellsInTable,
            icon: icon,
            onClick: (state, dispatch)=>{
                (0, $d9aad08b0e0e65bb$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, index ?? 0, order)(state, dispatch);
                return true;
            }
        }));
    const restConfigs = [
        ...addOptions.map(({ label: label, offset: offset, icon: icon, keymap: keymap })=>({
                id: `add_${direction}_${label}`,
                title: `Add ${direction} ${label}`,
                icon: icon,
                onClick: (state, dispatch)=>{
                    if (direction === 'row') (0, $d9aad08b0e0e65bb$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, {
                        index: (index ?? 0) + offset,
                        moveCursorToInsertedRow: true
                    })(state, dispatch);
                    else (0, $d9aad08b0e0e65bb$export$fc693eab55df8b35)(api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, (index ?? 0) + offset)(state, dispatch, editorView);
                    return true;
                },
                keymap: keymap && (0, $hgeg8.tooltip)(keymap)
            })),
        direction === 'column' ? {
            id: 'distribute_columns',
            title: 'Distribute columns',
            disabled: !$95cc14ff7c35ef77$var$isDistributeColumnsEnabled(editorView.state),
            onClick: (state, dispatch)=>{
                const selectionRect = (0, $b9cb78eca8ad2cf1$export$e3ff63a8559e7571)(state);
                if (selectionRect) {
                    const newResizeState = (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(selectionRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
                    if (newResizeState) {
                        (0, $d9aad08b0e0e65bb$export$9bca7816a0c95373)(editorAnalyticsAPI, api)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, newResizeState)(state, dispatch);
                        return true;
                    }
                    return false;
                }
                return false;
            },
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iBNSQ))), {
                    spacing: 'spacious',
                    label: ''
                })
        } : undefined,
        {
            id: 'clear_cells',
            title: 'Clear cells',
            onClick: (state, dispatch)=>{
                (0, $d9aad08b0e0e65bb$export$67e5a2aa802b5be1)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, targetCellPosition)(state, dispatch);
                return true;
            },
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iV7dk))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $hgeg8.tooltip)((0, $hgeg8.backspace))
        },
        {
            id: `delete_${direction}`,
            title: `Delete ${direction}`,
            onClick: (state, dispatch)=>{
                if (direction === 'row') (0, $d9aad08b0e0e65bb$export$ad9854279980efbe)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect ?? $95cc14ff7c35ef77$var$defaultSelectionRect, !!isHeaderRowRequired)(state, dispatch);
                else (0, $d9aad08b0e0e65bb$export$4c11b948fab97510)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect ?? $95cc14ff7c35ef77$var$defaultSelectionRect)(state, dispatch, editorView);
                return true;
            },
            icon: direction === 'row' ? ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($HbwpQ))), {
                    spacing: 'spacious',
                    label: ''
                }) : ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4Ilrk))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: direction === 'row' ? (0, $hgeg8.tooltip)((0, $hgeg8.deleteRow)) : (0, $hgeg8.tooltip)((0, $hgeg8.deleteColumn))
        },
        ...moveOptions.map(({ label: label, canMove: canMove, icon: icon, keymap: keymap, getOriginIndexes: getOriginIndexes, getTargetIndex: getTargetIndex })=>({
                id: `move_${direction}_${label}`,
                title: `Move ${direction} ${label}`,
                disabled: !canMove,
                icon: icon,
                onClick: (_state, _dispatch)=>{
                    if (canMove) {
                        requestAnimationFrame(()=>{
                            (0, $66674519b4a32446$export$137f4de350aca2d8)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)((0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU, `table-${direction}`, // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            getOriginIndexes(selectionRect), // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            getTargetIndex(selectionRect))(editorView.state, editorView.dispatch);
                        });
                        return true;
                    }
                    return false;
                },
                keymap: keymap && (0, $hgeg8.tooltip)(keymap)
            }))
    ];
    const allConfigs = [
        ...restConfigs
    ];
    if (isColumnSortingEnabled && (0, $dh538.fg)('platform_editor_enable_table_dnd') || !(0, $dh538.fg)('platform_editor_enable_table_dnd')) allConfigs.unshift(...sortConfigs);
    return allConfigs.filter(Boolean);
};





const $66674519b4a32446$export$fbaa62c9a250295d = (editorAnalyticsAPI)=>(inputMethod, sourceType, sourceIndexes, status, tr)=>{
        return (0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $3824I.TABLE_ACTION).MOVED_ROW : (0, $3824I.TABLE_ACTION).MOVED_COLUMN,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes?.length ?? 0,
                    distance: 0,
                    status: status,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $68bb38467b052d2c$export$e74dec9e818a8c0b)(tr)(state, dispatch);
            return true;
        });
    };
const $66674519b4a32446$export$137f4de350aca2d8 = (editorAnalyticsAPI, ariaNotify, getIntl)=>(inputMethod, sourceType, sourceIndexes, targetIndex, tr)=>{
        return (0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const direction = sourceIndexes[0] > targetIndex ? -1 : 1;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $3824I.TABLE_ACTION).MOVED_ROW : (0, $3824I.TABLE_ACTION).MOVED_COLUMN,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes.length,
                    // This identifies the total amount of row/cols the move operation covered. The distance covered should be a representaion
                    // of the minimum distance. This will account for large selection being moved causing a large distance travelled value.
                    distance: Math.min(...sourceIndexes.map((v)=>Math.abs(targetIndex - v))) * direction,
                    // If a drop doesn't actually change anything then we're going to mark the event as cancelled.
                    status: sourceIndexes.includes(targetIndex) ? (0, $3824I.TABLE_STATUS).CANCELLED : (0, $3824I.TABLE_STATUS).SUCCESS,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) {
                (0, $68bb38467b052d2c$export$1326c72b3102f66d)(sourceType, sourceIndexes, targetIndex, tr)(state, dispatch);
                // Only considering single row/column movement for screen reader as only single row/column selection is supported via keyboard atm.
                if ((inputMethod === (0, $d925B.INPUT_METHOD).TABLE_CONTEXT_MENU || (0, $d925B.INPUT_METHOD).SHORTCUT) && sourceIndexes.length === 1 && ariaNotify && getIntl) {
                    const direction = sourceIndexes[0] > targetIndex ? -1 : 1; // -1 for left/up , 1 for right/down
                    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
                    ariaNotify(getIntl().formatMessage(sourceType === 'table-row' ? direction > 0 ? (0, $2CQVV.messages).rowMovedDown : (0, $2CQVV.messages).rowMovedUp : direction > 0 ? (0, $2CQVV.messages).columnMovedRight : (0, $2CQVV.messages).columnMovedLeft, {
                        index: targetIndex + 1,
                        total: sourceType === 'table-row' ? totalRowCount : totalColumnCount
                    }), {
                        priority: 'important'
                    });
                }
            }
            return true;
        });
    };
const $66674519b4a32446$export$a01080da268c1d9d = (editorAnalyticsAPI, ariaNotify, getIntl)=>(sourceType, direction)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const isCellSelection = selection instanceof (0, $7XFGZ.CellSelection);
            const selectionRect = isCellSelection ? (0, $iP1et.getSelectionRect)(selection) : (0, $id9O1.findCellRectClosestToPos)(selection.$from);
            if (!selectionRect) return false;
            const isRow = sourceType === 'table-row';
            const selectedIndexes = isRow ? (0, $cee807f94f070ba4$export$d023456f91fdf995)(selectionRect) : (0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect);
            if (selectedIndexes.length === 0) return false;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
            if (!(0, $95cc14ff7c35ef77$export$a4ef2b0c3fa55ad2)(sourceType, direction, isRow ? totalRowCount : totalColumnCount, selection, selectionRect)) return false;
            const targetIndex = (0, $95cc14ff7c35ef77$export$79db8995cf046b43)(selectedIndexes, direction);
            return $66674519b4a32446$export$137f4de350aca2d8(editorAnalyticsAPI, ariaNotify, getIntl)((0, $d925B.INPUT_METHOD).SHORTCUT, sourceType, selectedIndexes, targetIndex)(state, dispatch);
        };
const $66674519b4a32446$export$e432b518ff8f345a = (editorAnalyticsAPI)=>(inputMethod, sourceType, sourceIndexes, targetIndex, targetDirection, tr)=>{
        return (0, $d406f1b0c5d56902$export$c27221be174b6703)(({ selection: selection })=>{
            const direction = sourceIndexes[0] > targetIndex ? -1 : 1;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $3824I.TABLE_ACTION).CLONED_ROW : (0, $3824I.TABLE_ACTION).CLONED_COLUMN,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes.length,
                    // This identifies the total amount of row/cols the move operation covered. The distance covered should be a representaion
                    // of the minimum distance. This will account for large selection being moved causing a large distance travelled value.
                    distance: Math.min(...sourceIndexes.map((v)=>Math.abs(targetIndex - v))) * direction,
                    // If a drop doesn't actually change anything then we're going to mark the event as cancelled.
                    status: sourceIndexes.includes(targetIndex) ? (0, $3824I.TABLE_STATUS).CANCELLED : (0, $3824I.TABLE_STATUS).SUCCESS,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $68bb38467b052d2c$export$88277f1015e99c8a)(sourceType, sourceIndexes, targetIndex, targetDirection, tr)(state, dispatch);
            return true;
        });
    };
const $66674519b4a32446$export$ade80ff7f1fbb779 = (editorAnalyticsAPI)=>(isDragMenuOpen, direction, index, trigger = 'mouse')=>{
        return (0, $d406f1b0c5d56902$export$c27221be174b6703)((state)=>{
            const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
            if (previousOpenState === isDragMenuOpen && previousDragMenuDirection === direction && previousDragMenuIndex === index) return undefined;
            let updatedMenuOpenState;
            if (isDragMenuOpen !== undefined) updatedMenuOpenState = isDragMenuOpen;
            else // menu open but menu direction changed, means user clicked on drag handle of different row/column
            // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
            // 2 scenarios above , menu should remain open.
            if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) updatedMenuOpenState = true;
            else updatedMenuOpenState = !previousOpenState;
            if (updatedMenuOpenState) // We only want to fire analytics when the menu is opened
            return {
                action: (0, $3824I.TABLE_ACTION).DRAG_MENU_OPENED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: trigger === 'keyboard' ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE,
                    direction: direction ?? previousDragMenuDirection ?? 'column'
                }
            };
            return undefined;
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $68bb38467b052d2c$export$8a902a12acc69924)(isDragMenuOpen, direction, index, trigger)(state, dispatch);
            return true;
        });
    };






var $2WHHL = parcelRequire("2WHHL");




const $af1654059f589843$export$b95259a1f587c41 = ({ altKey: altKey, ctrlKey: ctrlKey })=>{
    const browser = (0, $d7ZU3.getBrowserInfo)();
    const isCloneModifierKeyPressed = browser.mac ? altKey : ctrlKey;
    return isCloneModifierKeyPressed ? 'clone' : 'move';
};


const $5d9f70a2f60147a3$export$6d440138302b6316 = ({ location: location, source: source })=>{
    const destination = location.current.dropTargets.at(0);
    // If no target exists at the current location, then the current draggable is not over a target or the target doesn't support
    // the current draggable.
    if (!destination) return undefined;
    // This is the draggable elements data
    const { indexes: sourceIndexes, type: sourceType, localId: sourceLocalId } = source.data;
    // This is the drop target's data
    const { targetIndex: targetIndex, type: targetType, localId: targetLocalId } = destination.data;
    // Some basic check to abort early with...
    if (!sourceIndexes || targetIndex < 0 || // abort if the type of the draggable is different to the target, for eg. rows cannot be dropped onto column targets.
    sourceType !== targetType || // abort if the draggable is coming from a different table that the target is on.
    sourceLocalId !== targetLocalId) return undefined;
    const targetClosestEdge = (0, $2WHHL.extractClosestEdge)(destination.data) ?? (targetType === 'table-row' ? 'top' : 'left');
    // NOTE: By default we always insert row/cols at the target index to the top/left (retrospectively of row/cols).
    // This introduces an offset in the event the drop occured closer to the bottom/right of the target. We want
    // the new target index to be 1 index higher.
    const targetOffset = targetClosestEdge === 'right' || targetClosestEdge === 'bottom' ? 1 : 0;
    // if the min index is greater then the target index, the then the direction of the DnD is decreasing
    // if the target is within the min/max index then we can assume that no direction exists so it will be 0.
    const srcMin = Math.min(...sourceIndexes);
    const srcMax = Math.max(...sourceIndexes);
    const direction = targetIndex >= srcMin && targetIndex <= srcMax ? 0 : srcMin >= targetIndex ? -1 : 1;
    return {
        sourceType: sourceType,
        sourceLocalId: sourceLocalId,
        sourceIndexes: sourceIndexes,
        targetType: targetType,
        targetLocalId: targetLocalId,
        targetIndex: targetIndex,
        targetAdjustedIndex: targetIndex + targetOffset,
        targetClosestEdge: targetClosestEdge,
        targetDirection: targetClosestEdge === 'top' || targetClosestEdge === 'left' ? 'start' : 'end',
        direction: direction,
        behaviour: (0, $af1654059f589843$export$b95259a1f587c41)(location.current.input)
    };
};


const $58c44b411bfbf733$var$destroyFn = (editorView, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, api)=>{
    const editorPageScrollContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    const rowAutoScrollers = editorPageScrollContainer ? [
        (0, $4T4vf.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type } = source.data;
                return type === 'table-row';
            },
            onDragStart () {
                if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.startFeature('tableDragAndDrop');
                // auto scroller doesn't work when scroll-behavior: smooth is set, this monitor temporarily removes it via inline styles
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorPageScrollContainer.style.setProperty('scroll-behavior', 'unset');
            },
            onDrop () {
                if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableDragAndDrop');
                // 'null' will remove the inline style
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorPageScrollContainer.style.setProperty('scroll-behavior', null);
            }
        }),
        (0, $51lK8.autoScrollForElements)({
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            element: editorPageScrollContainer,
            canScroll: ({ source: source })=>{
                const { type: type } = source.data;
                return type === 'table-row';
            }
        })
    ] : [];
    return (0, $bSjaC.combine)(...rowAutoScrollers, (0, $4T4vf.monitorForElements)({
        canMonitor ({ source: source }) {
            const { type: type, localId: localId, indexes: indexes } = source.data;
            // First; Perform any quick checks so we can abort early.
            if (!indexes || !localId || !(type === 'table-row' || type === 'table-column')) return false;
            const { tableNode: tableNode } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            // If the draggable localId is the same as the current selected table localId then we will allow the monitor
            // watch for changes
            return localId === tableNode?.attrs.localId;
        },
        onDragStart: ()=>{
            if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.startFeature('tableDragAndDrop');
            (0, $68bb38467b052d2c$export$8a902a12acc69924)(false)(editorView.state, editorView.dispatch);
            api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('dragging'));
        },
        onDrag (event) {
            const data = (0, $5d9f70a2f60147a3$export$6d440138302b6316)(event);
            // If no data can be found then it's most like we do not want to perform any drag actions
            if (!data) {
                (0, $68bb38467b052d2c$export$e74dec9e818a8c0b)()(editorView.state, editorView.dispatch);
                return;
            }
            // TODO: ED-26961 - as we drag an element around we are going to want to update the state to acurately reflect the current
            // insert location as to where the draggable will most likely be go. For example;
            const { sourceType: sourceType, targetAdjustedIndex: targetAdjustedIndex } = data;
            const dropTargetType = sourceType === 'table-row' ? (0, $23a3656b396423d5$export$9377432e002bc2da).ROW : (0, $23a3656b396423d5$export$9377432e002bc2da).COLUMN;
            const hasMergedCells = (0, $0e87c5ebb1bfe871$export$6e6c0cf88a287d8)([
                targetAdjustedIndex - 1,
                targetAdjustedIndex
            ], dropTargetType)(editorView.state.selection);
            (0, $68bb38467b052d2c$export$a54c991ec4a21b4a)(dropTargetType, targetAdjustedIndex, hasMergedCells)(editorView.state, editorView.dispatch);
            api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('dragging'));
        },
        onDrop (event) {
            const data = (0, $5d9f70a2f60147a3$export$6d440138302b6316)(event);
            // On Drop we need to update the table main plugin hoveredCell value with the current row/col that the mouse is
            // over. This is so the drag handles update their positions to correctly align with the users mouse. Unfortunately
            // at this point in time and during the drag opertation, the drop targets are eating all the mouse events so
            // it's not possible to know what row/col the mouse is over (via mouse events). This attempts to locate the nearest cell and
            // then tries to update the main table hoveredCell value by piggy-backing the transaction onto the command
            // triggered by this on drop event.
            const { hoveredCell: hoveredCell } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const cell = (0, $c2cd42e9bb213cdd$export$fe489db90f7f492a)(event.location.current.input.clientX, event.location.current.input.clientY);
            const tr = editorView.state.tr;
            const action = {
                type: 'HOVER_CELL',
                data: {
                    hoveredCell: {
                        rowIndex: cell?.row ?? hoveredCell.rowIndex,
                        colIndex: cell?.col ?? hoveredCell.colIndex
                    }
                }
            };
            tr.setMeta((0, $fedf15e5199146e8$export$18d4026d1ea86bb1), action);
            if (api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'dragging') api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('default'));
            // If no data can be found then it's most like we do not want to perform any drop action
            if (!data) {
                // If we're able to determine the source type of the dropped element then we should report to analytics that
                // the drop event was cancelled. Otherwise we will cancel silently.
                if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableDragAndDrop');
                if (event?.source?.data?.type === 'table-row' || event?.source?.data?.type === 'table-column') return (0, $66674519b4a32446$export$fbaa62c9a250295d)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).DRAG_AND_DROP, event.source.data.type, event.source.data?.indexes, (0, $3824I.TABLE_STATUS).CANCELLED, tr)(editorView.state, editorView.dispatch);
                return (0, $68bb38467b052d2c$export$e74dec9e818a8c0b)(tr)(editorView.state, editorView.dispatch);
            }
            const { sourceType: sourceType, sourceIndexes: sourceIndexes, targetIndex: targetIndex, targetAdjustedIndex: targetAdjustedIndex, targetDirection: targetDirection, direction: direction, behaviour: behaviour } = data;
            // When we drop on a target we will know the targets row/col index for certain,
            if (sourceType === 'table-row') action.data.hoveredCell.rowIndex = targetIndex;
            else action.data.hoveredCell.colIndex = targetIndex;
            // If the drop target index contains merged cells then we should not allow the drop to occur.
            if ((0, $0e87c5ebb1bfe871$export$6e6c0cf88a287d8)([
                targetAdjustedIndex - 1,
                targetAdjustedIndex
            ], sourceType === 'table-row' ? (0, $23a3656b396423d5$export$9377432e002bc2da).ROW : (0, $23a3656b396423d5$export$9377432e002bc2da).COLUMN)(editorView.state.selection)) {
                (0, $66674519b4a32446$export$fbaa62c9a250295d)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, // This event is mrked as invalid because the user is attempting to drop an element in an area which has merged cells.
                (0, $3824I.TABLE_STATUS).INVALID, tr)(editorView.state, editorView.dispatch);
                if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableDragAndDrop');
                return;
            }
            requestAnimationFrame(()=>{
                if (behaviour === 'clone') (0, $66674519b4a32446$export$e432b518ff8f345a)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, targetIndex, targetDirection, tr)(editorView.state, editorView.dispatch);
                else (0, $66674519b4a32446$export$137f4de350aca2d8)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, targetAdjustedIndex + (direction === 1 ? -1 : 0), tr)(editorView.state, editorView.dispatch);
                // force a colgroup update here, otherwise dropped columns don't have
                // the correct width immediately after the drop
                if (sourceType === 'table-column') {
                    const { tableRef: tableRef, tableNode: tableNode } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
                    if (tableRef && tableNode) {
                        let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
                        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
                        if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = tableNode.attrs.displayMode !== 'fixed';
                        if (isTableScalingEnabled && isCommentEditor) isTableScalingEnabledOnCurrentTable = true;
                        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
                        (0, $d7e0ca7a06057b05$export$ae5d9647f2a0891c)(tableRef, tableNode, isTableScalingEnabledOnCurrentTable, undefined, shouldUseIncreasedScalingPercent, isCommentEditor);
                    }
                }
                editorView.focus();
                if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableDragAndDrop');
            });
        }
    }));
};
const $58c44b411bfbf733$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false, api)=>{
    return new (0, $1S4f7.SafePlugin)({
        state: (0, $abc6204662f4f035$export$656c7661095efe2e)(dispatch, ()=>({
                decorationSet: (0, $ftzrq.DecorationSet).empty,
                dropTargetType: (0, $23a3656b396423d5$export$9377432e002bc2da).NONE,
                dropTargetIndex: 0,
                isDragMenuOpen: false,
                dragMenuIndex: 0,
                isDragging: false,
                isKeyboardModeActive: false
            })),
        key: (0, $c8432cced568eda6$export$18d4026d1ea86bb1),
        appendTransaction: (transactions, oldState, newState)=>{
            const { targetCellPosition: oldTargetCellPosition } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(oldState);
            const { targetCellPosition: newTargetCellPosition } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(newState);
            const { isDragMenuOpen: isDragMenuOpen = false, dragMenuIndex: dragMenuIndex } = (0, $abc6204662f4f035$export$f05434c51e3762e)(newState);
            transactions.forEach((transaction)=>{
                if (transaction.getMeta('selectedRowViaKeyboard')) {
                    const button = document.querySelector('#drag-handle-button-row');
                    if (button) button.focus();
                }
                if (transaction.getMeta('selectedColumnViaKeyboard')) {
                    const button = document.querySelector('#drag-handle-button-column');
                    if (button) button.focus();
                }
            });
            // What's happening here? you asked... In a nutshell;
            // If the target cell position changes while the drag menu is open then we want to close the drag menu if it has been opened.
            // This will stop the drag menu from moving around the screen to different row/cols. Too achieve this we need
            // to check if the new target cell position is pointed at a different cell than what the drag menu was opened on.
            if (oldTargetCellPosition !== newTargetCellPosition) {
                if (isDragMenuOpen) {
                    const tr = newState.tr;
                    const action = {
                        type: (0, $769dcbe1acb4060b$export$b6bb967ba58ec81c).TOGGLE_DRAG_MENU,
                        data: {
                            isDragMenuOpen: false,
                            direction: undefined
                        }
                    };
                    if (newTargetCellPosition !== undefined) {
                        const cells = (0, $88d5b76f5df04f99$export$a804b6b4ce22aa92)(dragMenuIndex)(tr.selection);
                        // TODO: ED-20673 - check if it is a cell selection,
                        // when true, a drag handle is clicked and isDragMenuOpen is true here
                        // should not close the drag menu.
                        const isCellSelection = tr.selection instanceof (0, $7XFGZ.CellSelection);
                        if (cells && cells.length && cells[0].node !== tr.doc.nodeAt(newTargetCellPosition) && !isCellSelection) return tr.setMeta((0, $c8432cced568eda6$export$18d4026d1ea86bb1), action);
                         // else NOP
                    } else return tr.setMeta((0, $c8432cced568eda6$export$18d4026d1ea86bb1), action);
                }
            }
        },
        view: (editorView)=>{
            return {
                destroy: $58c44b411bfbf733$var$destroyFn(editorView, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, api)
            };
        },
        props: {
            decorations: (state)=>{
                const { decorationSet: decorationSet } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
                return decorationSet;
            },
            handleKeyDown: (view, event)=>{
                const { state: { tr: tr } } = view;
                const keysToTrapWhen = [
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft',
                    'ArrowRight'
                ];
                /** fix for NCS spam update where the user is holding down the move column / row keyboard shortcut
				 * if the user is holding down shortcut (ctrl + shift + alt + arrowKey), we want to move the selection only once
				 * See ticket ED-22154 https://product-fabric.atlassian.net/browse/ED-22154
				 */ // Do early check for the keys we want to trap here so we can abort early
                if (event.ctrlKey && event.shiftKey && event.altKey) {
                    const { verticalCells: verticalCells, horizontalCells: horizontalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $9KolL.getSelectedCellInfo)(tr.selection);
                    const isRowOrColumnSelected = horizontalCells === totalColumnCount || verticalCells === totalRowCount;
                    if (isRowOrColumnSelected && keysToTrapWhen.includes(event.key) && event.repeat) return true;
                }
                const isDragHandleFocused = [
                    'drag-handle-button-row',
                    'drag-handle-button-column'
                ].includes((event.target || null)?.id);
                const keysToTrap = [
                    'Enter',
                    ' '
                ];
                const { isDragMenuOpen: isDragMenuOpen = false } = (0, $abc6204662f4f035$export$f05434c51e3762e)(view.state);
                // drag handle is focused, and user presses any key return them back to editing
                if (isDragHandleFocused && !isDragMenuOpen && !keysToTrap.includes(event.key)) {
                    view.dom.focus();
                    return true;
                }
                if (isDragHandleFocused && keysToTrap.includes(event.key) || isDragMenuOpen && keysToTrapWhen.includes(event.key)) return true;
            }
        }
    });
};









const $c80e8922e1b59353$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('editorContentAreaHeightPlugin');
const $c80e8922e1b59353$export$4d09e1a8cc78d53 = 1200;
const $c80e8922e1b59353$export$e591924e2463f32f = '.ak-editor-content-area-region';
const $c80e8922e1b59353$export$ae829ec7b2625219 = ()=>new (0, $1S4f7.SafePlugin)({
        key: $c80e8922e1b59353$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    height: $c80e8922e1b59353$export$4d09e1a8cc78d53
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($c80e8922e1b59353$export$18d4026d1ea86bb1);
                if (meta) return {
                    ...pluginState,
                    ...meta
                };
                return pluginState;
            }
        },
        view: (view)=>{
            const editorContentAreaEl = view.dom.closest($c80e8922e1b59353$export$e591924e2463f32f);
            let resizeObserver;
            if (editorContentAreaEl) {
                resizeObserver = new ResizeObserver((entries)=>{
                    for (const entry of entries){
                        const height = entry.contentRect.height;
                        const tr = view.state.tr.setMeta($c80e8922e1b59353$export$18d4026d1ea86bb1, {
                            height: height,
                            isObserved: true
                        });
                        view.dispatch(tr);
                    }
                });
                resizeObserver.observe(editorContentAreaEl);
            }
            return {
                destroy () {
                    resizeObserver?.disconnect();
                }
            };
        }
    });












var $astHL = parcelRequire("astHL");


































function $8948cb1031c9ee31$var$moveCellForward($pos) {
    const nextNodeSize = $pos.nodeAfter ? $pos.nodeAfter.nodeSize : 0;
    return $pos.node(0).resolve($pos.pos + nextNodeSize);
}
function $8948cb1031c9ee31$export$78a7cb7971e0752d(direction) {
    return function(state, dispatch) {
        if (!(0, $bMyNT.isInTable)(state)) return false;
        const cellSelection = (0, $bzgWU.selectionCell)(state.selection);
        if (!cellSelection) return false;
        const cell = $8948cb1031c9ee31$var$findNextCell(cellSelection, direction);
        if (cell === undefined) return false;
        if (dispatch) {
            const $cell = state.doc.resolve(cell);
            dispatch(state.tr.setSelection((0, $ks2lK.TextSelection).between($cell, $8948cb1031c9ee31$var$moveCellForward($cell))).scrollIntoView());
        }
        return true;
    };
}
function $8948cb1031c9ee31$var$findNextCell($cell, direction) {
    if (direction === -1) {
        const before = $cell.nodeBefore;
        if (before) return $cell.pos - before.nodeSize;
        for(let row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--){
            const rowNode = $cell.node(-1).child(row);
            if (rowNode.childCount && rowNode.lastChild) return rowEnd - 1 - rowNode.lastChild.nodeSize;
            rowEnd -= rowNode.nodeSize;
        }
    } else {
        if ($cell.index() < $cell.parent.childCount - 1 && $cell.nodeAfter) return $cell.pos + $cell.nodeAfter.nodeSize;
        let table = $cell.node(-1);
        // table is the parent table, not the nested table
        if ($cell.node(-4) && $cell.node(-4).type.name === 'table') table = $cell.node(-4);
        for(let row = $cell.indexAfter(-1), rowStart = $cell.after(); row < table.childCount; row++){
            const rowNode = table.child(row);
            if (rowNode.childCount) return rowStart + 1;
            rowStart += rowNode.nodeSize;
        }
    }
}







const $2408f65fb4ff5ac9$var$TAB_FORWARD_DIRECTION = 1;
const $2408f65fb4ff5ac9$var$TAB_BACKWARD_DIRECTION = -1;
const $2408f65fb4ff5ac9$export$78a7cb7971e0752d = (editorAnalyticsAPI, ariaNotify, getIntl)=>(direction)=>(state, dispatch, view)=>{
            const table = (0, $id9O1.findTable)(state.selection);
            if (!table) return false;
            const isColumnResizing = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state)?.isKeyboardResize;
            if (isColumnResizing) {
                (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({
                    ariaNotify: ariaNotify,
                    getIntl: getIntl
                })(state, dispatch, view);
                return true;
            }
            const map = (0, $LmqWp.TableMap).get(table.node);
            const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $8m4tT.findParentNodeOfType)([
                tableCell,
                tableHeader
            ])(state.selection);
            const firstCellPos = map.positionAt(0, 0, table.node) + table.start;
            const lastCellPos = map.positionAt(map.height - 1, map.width - 1, table.node) + table.start;
            // When tabbing backwards at first cell (top left), insert row at the start of table
            if (firstCellPos === cell.pos && direction === $2408f65fb4ff5ac9$var$TAB_BACKWARD_DIRECTION) {
                (0, $d9aad08b0e0e65bb$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD, {
                    index: 0,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            }
            // When tabbing forwards at last cell (bottom right), insert row at the end of table
            if (lastCellPos === cell.pos && direction === $2408f65fb4ff5ac9$var$TAB_FORWARD_DIRECTION) {
                (0, $d9aad08b0e0e65bb$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD, {
                    index: map.height,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            }
            if (dispatch) return (0, $8948cb1031c9ee31$export$78a7cb7971e0752d)(direction)(state, dispatch);
            return true;
        };
const $2408f65fb4ff5ac9$export$24bf4ae22c7b6454 = (direction)=>(state, dispatch)=>{
        const { selection: selection } = state;
        const nestedTableSelection = (0, $sxTNo.isSelectionTableNestedInTable)(state);
        if (!(selection instanceof (0, $ks2lK.NodeSelection)) && !nestedTableSelection) return false; // Let ProseMirror handle other selection types
        let table = (0, $id9O1.findTable)(selection);
        let cell = (0, $id9O1.findCellClosestToPos)(state.doc.resolve(selection.from));
        let selectionPos = selection.from;
        // Handle when we have nested table fully selected
        if (table && nestedTableSelection && (0, $iYC9s.isTableSelected)(selection)) {
            const parentTablePos = table.pos;
            table = (0, $id9O1.findTableClosestToPos)(state.doc.resolve(parentTablePos));
            cell = (0, $id9O1.findCellClosestToPos)(state.doc.resolve(parentTablePos));
            selectionPos = parentTablePos;
        }
        if (!table || !cell || !cell.pos) return false;
        const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
        // Let ProseMirror handle movement within the cell if content exists above/below
        if ($2408f65fb4ff5ac9$var$cellHasContentInDirection(cell.node, cell.pos, selectionPos, direction)) return false;
        // Move to the next cell vertically
        const map = (0, $LmqWp.TableMap).get(table.node);
        const nextCellPos = map.nextCell(cell.pos - table.start, 'vert', direction);
        if (dispatch && nextCellPos) {
            const nextCellStart = table.start + nextCellPos;
            const $nextCell = state.doc.resolve(nextCellStart);
            if ($nextCell.nodeAfter?.type && [
                tableCell,
                tableHeader
            ].includes($nextCell.nodeAfter?.type)) {
                const contentPos = $2408f65fb4ff5ac9$var$getTargetPositionInNextCell($nextCell.nodeAfter, nextCellStart, direction);
                dispatch(state.tr.setSelection((0, $ks2lK.TextSelection).create(state.doc, contentPos)));
                return true;
            }
            return false;
        }
        return false; // No next cell found
    };
function $2408f65fb4ff5ac9$var$cellHasContentInDirection(cellNode, cellPos, selectionPos, direction) {
    let hasContent = false;
    cellNode.content.forEach((node, offset)=>{
        const nodeStart = cellPos + 1 + offset;
        const nodeEnd = nodeStart + node.nodeSize;
        if (direction === 1 && nodeStart > selectionPos && node.isBlock) hasContent = true; // Content below
        else if (direction === -1 && nodeEnd <= selectionPos && node.isBlock) hasContent = true; // Content above
    });
    return hasContent;
}
function $2408f65fb4ff5ac9$var$getTargetPositionInNextCell(cellNode, nextCellStart, direction) {
    let contentPos = nextCellStart + 1; // Default: just inside the cell
    if (cellNode.content.size > 0) {
        if (direction === 1) {
            const firstChild = cellNode.firstChild;
            if (firstChild && firstChild.isBlock) contentPos = nextCellStart + 1 + (firstChild.isLeaf ? 0 : 1); // Down: Start of first block
        } else if (direction === -1) {
            let lastBlock;
            let lastOffset = 0;
            cellNode.content.forEach((node, offset)=>{
                if (node.isBlock) {
                    lastBlock = node;
                    lastOffset = offset;
                }
            });
            if (lastBlock) contentPos = nextCellStart + 1 + lastOffset + (lastBlock.isLeaf ? 0 : lastBlock.nodeSize - 1);
        }
    }
    return contentPos;
}






function $7b84646b01762248$export$e832373cff8dec22(getEditorContainerWidth, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled = false, isTableAlignmentEnabled = false, isFullWidthEnabled, pluginInjectionApi, getIntl, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, isTableResizingEnabled) {
    const list = {};
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.nextCell).common, (0, $2408f65fb4ff5ac9$export$78a7cb7971e0752d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)(1), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.previousCell).common, (0, $2408f65fb4ff5ac9$export$78a7cb7971e0752d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)(-1), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleTable).common, (0, $gmyMu.editorCommandToPMCommand)((0, $6921de1f1a31eb9c$export$b57b177fe1ab7f1f)({
        isTableScalingEnabled: isTableScalingEnabled,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        isFullWidthModeEnabled: !!isFullWidthEnabled,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor,
        isTableResizingEnabled: isTableResizingEnabled
    }, api, {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TABLE,
        attributes: {
            inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT
        },
        eventType: (0, $d925B.EVENT_TYPE).TRACK
    })), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.backspace).common, (0, $astHL.chainCommands)((0, $d9aad08b0e0e65bb$export$253ebd9c41cefd54)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD), (0, $d9aad08b0e0e65bb$export$67e5a2aa802b5be1)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).KEYBOARD)), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.backspace).common, (0, $4ca83755c936c9c8$export$f49961c90342f4db), list);
    // Add row/column shortcuts
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addRowBefore).common, (0, $d9aad08b0e0e65bb$export$4df69ad9d7ac565d)(editorAnalyticsAPI)('TOP'), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addRowAfter).common, (0, $d9aad08b0e0e65bb$export$4df69ad9d7ac565d)(editorAnalyticsAPI)('BOTTOM'), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addColumnBefore).common, (0, $6921de1f1a31eb9c$export$717d5ccb817cdecc)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addColumnAfter).common, (0, $6921de1f1a31eb9c$export$bf95f7b7d259c19f)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addRowBeforeVO).common, (0, $d9aad08b0e0e65bb$export$4df69ad9d7ac565d)(editorAnalyticsAPI)('TOP'), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addRowAfterVO).common, (0, $d9aad08b0e0e65bb$export$4df69ad9d7ac565d)(editorAnalyticsAPI)('BOTTOM'), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addColumnBeforeVO).common, (0, $6921de1f1a31eb9c$export$717d5ccb817cdecc)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.addColumnAfterVO).common, (0, $6921de1f1a31eb9c$export$bf95f7b7d259c19f)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    if ((0, $hgeg8.moveRowDown).common && (0, $hgeg8.moveRowUp).common && (0, $hgeg8.moveColumnLeft).common && (0, $hgeg8.moveColumnRight).common) {
        const isNewKeyMapExperiment = (0, $1oCLl.expValEquals)('editor-a11y-fy26-keyboard-move-row-column', 'isEnabled', true);
        // Move row/column shortcuts
        /**
     * NOTE: If the keyboard shortcut for moving rows or columns is changed, we need to update the handleKeyDown function
     * in packages/editor/editor-plugin-table/src/pm-plugins/drag-and-drop/plugin.ts
     * to make sure the logic for holding the shortcut keys is valid
     * See ticket ED-22154 https://product-fabric.atlassian.net/browse/ED-22154
     */ (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $hgeg8.moveRowDown).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.moveRowDownOld).common, (0, $66674519b4a32446$export$a01080da268c1d9d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-row', 1), list);
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $hgeg8.moveRowUp).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.moveRowUpOld).common, (0, $66674519b4a32446$export$a01080da268c1d9d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-row', -1), list);
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $hgeg8.moveColumnLeft).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.moveColumnLeftOld).common, (0, $66674519b4a32446$export$a01080da268c1d9d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-column', -1), list);
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $hgeg8.moveColumnRight).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.moveColumnRightOld).common, (0, $66674519b4a32446$export$a01080da268c1d9d)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-column', 1), list);
        // Delete row/column shortcuts
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.deleteColumn).common, (0, $d9aad08b0e0e65bb$export$a5b48d8f68e0fbd)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
        (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $hgeg8.deleteRow).common, (0, $d9aad08b0e0e65bb$export$a5b48d8f68e0fbd)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    }
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.startColumnResizing).common, (0, $9f1d04378e27f5e1$export$833f46f974daec36)({
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveRight).common, (0, $9f1d04378e27f5e1$export$44cde2b92e1bbc4a)({
        direction: 1,
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveLeft).common, (0, $9f1d04378e27f5e1$export$44cde2b92e1bbc4a)({
        direction: -1,
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveDown).common, (0, $2408f65fb4ff5ac9$export$24bf4ae22c7b6454)(1), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.moveUp).common, (0, $2408f65fb4ff5ac9$export$24bf4ae22c7b6454)(-1), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.decreaseMediaSize).common, (0, $d9aad08b0e0e65bb$export$e75fc938db126e1a)(editorAnalyticsAPI, api)(-10, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, !!isCommentEditor, (0, $d925B.INPUT_METHOD).SHORTCUT, ariaNotifyPlugin, getIntl), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.increaseMediaSize).common, (0, $d9aad08b0e0e65bb$export$e75fc938db126e1a)(editorAnalyticsAPI, api)(10, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, !!isCommentEditor, (0, $d925B.INPUT_METHOD).SHORTCUT, ariaNotifyPlugin, getIntl), list);
    (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.escape).common, (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl
    }), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.focusToContextMenuTrigger).common, (0, $4ca83755c936c9c8$export$a6e5155a1ac72366)(), list);
    return (0, $dus6D.keymap)(list);
}
var $7b84646b01762248$export$2e2bcd8739ae039 = $7b84646b01762248$export$e832373cff8dec22;



var $fFa3V = parcelRequire("fFa3V");

















var $igNsz = parcelRequire("igNsz");

var $hcbpx = parcelRequire("hcbpx");

var $edTnG = parcelRequire("edTnG");




























const $425e1bfad150b07f$export$2073a24f9367a16f = (0, $2XqLN.default)(()=>{
    if (window.CSS && window.CSS.supports) return window.CSS.supports('anchor-name: --anchor');
    return false;
});
const $425e1bfad150b07f$export$2ee7329d46115d8f = ()=>{
    const safariVersion = (0, $d7ZU3.getBrowserInfo)().safari_version;
    const isBrowserSafari = !Number.isNaN(safariVersion);
    return(// Safari has a bug with position: sticky and content editable, so we don't support it
    !isBrowserSafari && $425e1bfad150b07f$export$2073a24f9367a16f());
};





parcelRequire("42omo");





var $2gkmX = parcelRequire("2gkmX");






























parcelRequire("42omo");

















var $2P8Ax = parcelRequire("2P8Ax");








var $h3X17 = parcelRequire("h3X17");





var $92LVN = parcelRequire("92LVN");

































var $jtbk8 = parcelRequire("jtbk8");


var $h9dtK = parcelRequire("h9dtK");


var $hhm38 = parcelRequire("hhm38");


var $ajYex = parcelRequire("ajYex");


var $1PEak = parcelRequire("1PEak");


var $wfJXn = parcelRequire("wfJXn");


var $eIOs5 = parcelRequire("eIOs5");


var $6UNNA = parcelRequire("6UNNA");


var $8e8VQ = parcelRequire("8e8VQ");


var $lFBSq = parcelRequire("lFBSq");

function $1c290c738b99c876$var$makeGetHitbox({ axis: axis, side: side }) {
    return function hitbox({ clientRect: clientRect, overflow: overflow, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $8e8VQ.axisLookup)[axis];
        const edge = mainAxis[side];
        const spacingForEdge = overflow[edge];
        const overElementHitbox = (0, $lFBSq.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        // Same as the over element hitbox,
        // but we are stretching out on the cross axis (if needed)
        const insideOfEdge = DOMRect.fromRect({
            [mainAxis.point]: overElementHitbox[mainAxis.point],
            [mainAxis.size]: overElementHitbox[mainAxis.size],
            // pull the cross axis backwards
            [crossAxis.point]: overElementHitbox[crossAxis.point] - spacingForEdge[crossAxis.start],
            // grow the cross axis
            [crossAxis.size]: overElementHitbox[crossAxis.size] + spacingForEdge[crossAxis.start] + spacingForEdge[crossAxis.end]
        });
        // Note: this will be "cut out" by the "overElementHitbox"
        const outsideOfEdge = DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] - spacingForEdge[mainAxis.start] : clientRect[mainAxis.end],
            [crossAxis.point]: clientRect[crossAxis.point] - spacingForEdge[crossAxis.start],
            [mainAxis.size]: side === 'start' ? spacingForEdge[mainAxis.start] : spacingForEdge[mainAxis.end],
            [crossAxis.size]: spacingForEdge[crossAxis.start] + clientRect[crossAxis.size] + spacingForEdge[crossAxis.end]
        });
        return {
            insideOfEdge: insideOfEdge,
            outsideOfEdge: outsideOfEdge
        };
    };
}
const $1c290c738b99c876$export$b220adcde0a1c5fd = {
    top: $1c290c738b99c876$var$makeGetHitbox({
        axis: 'vertical',
        side: 'start'
    }),
    right: $1c290c738b99c876$var$makeGetHitbox({
        axis: 'horizontal',
        side: 'end'
    }),
    bottom: $1c290c738b99c876$var$makeGetHitbox({
        axis: 'vertical',
        side: 'end'
    }),
    left: $1c290c738b99c876$var$makeGetHitbox({
        axis: 'horizontal',
        side: 'start'
    })
};


// Distance dampening is enabled when we are inside the edge
// In order to match "over element" scrolling
function $4a66a924dc2ff4b9$var$getIsDistanceDampeningEnabled(value) {
    return value.type === 'inside-of-edge';
}
function $4a66a924dc2ff4b9$var$getSpacingFromProvided(value) {
    return {
        top: value?.top ?? 0,
        right: value?.right ?? 0,
        bottom: value?.bottom ?? 0,
        left: value?.left ?? 0
    };
}
function $4a66a924dc2ff4b9$var$getHitboxSpacing(provided) {
    return {
        top: $4a66a924dc2ff4b9$var$getSpacingFromProvided(provided.forTopEdge),
        right: $4a66a924dc2ff4b9$var$getSpacingFromProvided(provided.forRightEdge),
        bottom: $4a66a924dc2ff4b9$var$getSpacingFromProvided(provided.forBottomEdge),
        left: $4a66a924dc2ff4b9$var$getSpacingFromProvided(provided.forLeftEdge)
    };
}
function $4a66a924dc2ff4b9$export$6cfa6dfe6898b98f({ entry: entry, timeSinceLastFrame: timeSinceLastFrame, input: input, config: config, allowedAxis: allowedAxis }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // 🔥
    // For each registered item we need to do `getBoundingClientRect()` which is not great
    // Why?
    // 1. The hitbox can extend outside of an elements bounds
    // 2. We want overflow scrolling to start before the user has entered the bounds of the element
    //     Otherwise we could search upwards in the DOM from the `elementFromPoint`
    const clientRect = entry.element.getBoundingClientRect();
    const overflow = $4a66a924dc2ff4b9$var$getHitboxSpacing(entry.getOverflow());
    const inHitboxForEdge = (0, $ajYex.edges).map((edge)=>{
        const { insideOfEdge: insideOfEdge, outsideOfEdge: outsideOfEdge } = (0, $1c290c738b99c876$export$b220adcde0a1c5fd)[edge]({
            clientRect: clientRect,
            overflow: overflow,
            config: config
        });
        /** Note:
			 * Intentionally _not_ doing an explicit check to
			 * see if `client` is with within the `overElementHitbox`.
			 *
			 * **Why?**
			 *
			 * 1. 🥱 Redundant
			 * This check is already achieved by `element.contains(underUsersPointer)`
			 *
			 * 2. 📐 Overlap on boundaries
			 * Two elements can share the same `{x,y}` points on shared edges.
			 * It's not clear which of the two will be picked by
			 * `const underUsersPointer = document.elementFromPoint(x,y)`
			 * The edge of an "outside" element, can have shared `{x,y}`
			 * values along the edge of an "inside element".
			 * So when `underUsersPointer` is the "outer" element, the `client`
			 * point might actually be also within the "inner" element.
			 * We are exclusively relying on `underUsersPointer` make the decision
			 * on what we are "over" so we should not be doing "over element" hitbox
			 * testing here.
			 * https://twitter.com/alexandereardon/status/1721758766507638996
			 *
			 *
			 * 3. 🐞 Chrome bug
			 * `document.elementFromPoint(x, y)` can return an element that does not contain `{x,y}`,
			 * In these cases, `isWithin({client, clientRect: overElementHitbox})` can return `false`.
			 * https://bugs.chromium.org/p/chromium/issues/detail?id=1500073
			 */ if ((0, $6UNNA.isWithin)({
            client: client,
            clientRect: outsideOfEdge
        })) return {
            edge: edge,
            hitbox: outsideOfEdge,
            type: 'outside-of-edge'
        };
        if ((0, $6UNNA.isWithin)({
            client: client,
            clientRect: insideOfEdge
        })) return {
            edge: edge,
            hitbox: insideOfEdge,
            type: 'inside-of-edge'
        };
        return false;
    }).filter((value)=>Boolean(value));
    if (!inHitboxForEdge.length) return null;
    // Even if no edges are scrollable, we are marking the element
    // as being engaged with to start applying time dampening
    const engagement = (0, $1PEak.markAndGetEngagement)(entry.element);
    // Note: changing the allowed axis during a drag will not
    // reset time dampening. It was decided it would be too
    // complex to implement initially, and we can add it
    // later if needed.
    const scrollableEdges = inHitboxForEdge.filter((value)=>(0, $eIOs5.isAxisAllowed)((0, $ajYex.edgeAxisLookup)[value.edge], allowedAxis) && (0, $hhm38.canScrollOnEdge)[value.edge](entry.element));
    // Nothing can be scrolled
    if (!scrollableEdges.length) return null;
    const lookup = new Map(scrollableEdges.map((value)=>[
            value.edge,
            value
        ]));
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = lookup.get('left');
        if (leftEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $4a66a924dc2ff4b9$var$getIsDistanceDampeningEnabled(leftEdge),
            hitbox: leftEdge.hitbox,
            edge: 'left',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        const rightEdge = lookup.get('right');
        if (rightEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $4a66a924dc2ff4b9$var$getIsDistanceDampeningEnabled(rightEdge),
            hitbox: rightEdge.hitbox,
            edge: 'right',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = lookup.get('bottom');
        if (bottomEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $4a66a924dc2ff4b9$var$getIsDistanceDampeningEnabled(bottomEdge),
            hitbox: bottomEdge.hitbox,
            edge: 'bottom',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        const topEdge = lookup.get('top');
        if (topEdge) return (0, $wfJXn.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $4a66a924dc2ff4b9$var$getIsDistanceDampeningEnabled(topEdge),
            hitbox: topEdge.hitbox,
            edge: 'top',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}


function $4e0224677ef5d1d3$export$10dd8807a40dbd8b({ input: input, source: source, entries: entries, timeSinceLastFrame: timeSinceLastFrame, underUsersPointer: underUsersPointer }) {
    // For now we are auto scrolling any element that wants to.
    // Otherwise it's hard to know what should scroll first as we might
    // be scrolling elements that have no hierarchical relationship
    for (const entry of entries){
        // "overflow" scrolling not relevant when directly over the element
        // "over element" scrolling is responsible for scrolling when over an element
        // 1. If we are over the element, then we want to exit and let the "overflow" scroller take over
        // 2. The overflow hitbox area for an edge actually stretches over the element
        //    This check is used to "mask" or "cut out" the element hitbox from the overflow hitbox
        if (entry.element.contains(underUsersPointer)) continue;
        const feedback = {
            input: input,
            source: source,
            element: entry.element
        };
        // Scrolling not allowed for this entity
        // Note: not marking engagement if an entity is opting out of scrolling
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        const config = (0, $h9dtK.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $4a66a924dc2ff4b9$export$6cfa6dfe6898b98f)({
            entry: entry,
            input: input,
            timeSinceLastFrame: timeSinceLastFrame,
            allowedAxis: allowedAxis,
            config: config
        });
        if (scrollBy) entry.element.scrollBy(scrollBy);
    }
}


function $896fd387f906313a$export$b8fa21320a811083({ monitor: monitor }) {
    const ledger = new Map();
    function unsafeOverflowAutoScroll(args) {
        ledger.set(args.element, args);
        return ()=>ledger.delete(args.element);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $4e0224677ef5d1d3$export$10dd8807a40dbd8b)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            entries: Array.from(ledger).map(([_, args])=>args),
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame
        });
    }
    // scheduler is never cleaned up
    (0, $jtbk8.getScheduler)(monitor).onFrame(onFrame);
    return {
        unsafeOverflowAutoScroll: unsafeOverflowAutoScroll
    };
}


const $c48213aba266fe77$var$api = (0, $896fd387f906313a$export$b8fa21320a811083)({
    monitor: (0, $4T4vf.monitorForElements)
});
const $c48213aba266fe77$export$b6fc2123c6c7faac = $c48213aba266fe77$var$api.unsafeOverflowAutoScroll;



const $f69a5020d7054d5c$export$aed4bc7b473fc217 = ({ tableWrapper: tableWrapper, getNode: getNode })=>{
    return [
        (0, $51lK8.autoScrollForElements)({
            element: tableWrapper,
            canScroll: ({ source: source })=>{
                const { localId: localId, type: type } = source.data;
                const node = getNode();
                return localId === node?.attrs.localId && type === 'table-column';
            }
        }),
        (0, $c48213aba266fe77$export$b6fc2123c6c7faac)({
            element: tableWrapper,
            canScroll: ({ source: source })=>{
                const { localId: localId, type: type } = source.data;
                const node = getNode();
                return localId === node?.attrs.localId && type === 'table-column';
            },
            getOverflow: ()=>({
                    forTopEdge: {
                        top: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                        right: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                        left: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8)
                    },
                    forRightEdge: {
                        right: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                        top: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                        bottom: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8)
                    },
                    forLeftEdge: {
                        top: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                        left: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                        bottom: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8)
                    }
                })
        })
    ];
};





const $1562ea854f0ae047$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('stickyHeadersPlugin');


const $894c3bb16e3b70ec$export$91d61a242b14c7fb = (state, tablePos)=>{
    if (!state || tablePos === undefined) return undefined;
    const rowInfo = state.find((rowInfo)=>rowInfo.pos === tablePos + 1);
    if (!rowInfo) return undefined;
    return rowInfo.sticky ? rowInfo : undefined;
};





























































const $f10f08824d624bfc$var$isFocusingCalendar = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.getAttribute('aria-label') === 'calendar';
const $f10f08824d624bfc$var$isFocusingModal = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[role="dialog"]');
const $f10f08824d624bfc$var$isFocusingFloatingToolbar = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[role="toolbar"]');
const $f10f08824d624bfc$var$isFocusingDragHandles = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('button') && event.relatedTarget.getAttribute('draggable') === 'true';
const $f10f08824d624bfc$var$isFocusingDragHandlesClickableZone = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('button') && event.relatedTarget.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE);
const $f10f08824d624bfc$export$27d5d91e7417534c = (view, event)=>{
    const { state: state, dispatch: dispatch } = view;
    // IE version check for ED-4665
    // Calendar focus check for ED-10466
    if ((0, $d7ZU3.getBrowserInfo)().ie_version !== 11 && !$f10f08824d624bfc$var$isFocusingCalendar(event) && !$f10f08824d624bfc$var$isFocusingModal(event) && !$f10f08824d624bfc$var$isFocusingFloatingToolbar(event) && !$f10f08824d624bfc$var$isFocusingDragHandles(event) && !$f10f08824d624bfc$var$isFocusingDragHandlesClickableZone(event)) (0, $4ca83755c936c9c8$export$f516ed9c5f43abfc)(false)(state, dispatch);
    event.preventDefault();
    return false;
};
const $f10f08824d624bfc$export$185584c64f36588 = (view, event)=>{
    const { state: state, dispatch: dispatch } = view;
    (0, $4ca83755c936c9c8$export$f516ed9c5f43abfc)(true)(state, dispatch);
    event.preventDefault();
    return false;
};
const $f10f08824d624bfc$export$b981489921ee18cd = (view, event)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    const element = event.target;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const table = (0, $id9O1.findTable)(view.state.selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    if (event instanceof MouseEvent && (0, $c2cd42e9bb213cdd$export$14eb53395cc0cf57)(element)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const [startIndex] = (0, $c2cd42e9bb213cdd$export$e5e82c478fd9ea3)(element);
        const { state: state, dispatch: dispatch } = view;
        return (0, $4ca83755c936c9c8$export$c2e8772deb1607ea)(startIndex, event.shiftKey)(state, dispatch);
    }
    const matchfn = element.matches ? element.matches : element.msMatchesSelector;
    // check if the table cell with an image is clicked and its not the image itself
    if (!table || // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    !(0, $kTbzR.isElementInTableCell)(element) || !matchfn || matchfn.call(element, 'table .image, table p, table .image div')) return false;
    const map = (0, $LmqWp.TableMap).get(table.node);
    /** Getting the offset of current item clicked */ // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const colElement = (0, $4vlwG.closestElement)(element, 'td') || // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $4vlwG.closestElement)(element, 'th');
    const colIndex = colElement && colElement.cellIndex;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rowElement = (0, $4vlwG.closestElement)(element, 'tr');
    const rowIndex = rowElement && rowElement.rowIndex;
    const cellIndex = map.width * rowIndex + colIndex;
    const { dispatch: dispatch, state: { tr: tr, schema: { nodes: { paragraph: paragraph } } } } = view;
    const cellPos = map.map[cellIndex];
    if (isNaN(cellPos) || cellPos === undefined || typeof cellPos !== 'number') return false;
    const editorElement = table.node.nodeAt(cellPos);
    /** Only if the last item is media group, insert a paragraph */ if ((0, $kTbzR.isLastItemMediaGroup)(editorElement)) {
        const posInTable = map.map[cellIndex] + editorElement.nodeSize;
        tr.insert(posInTable + table.pos, paragraph.create());
        dispatch(tr);
        (0, $kTbzR.setNodeSelection)(view, posInTable + table.pos);
    }
    return true;
};
const $f10f08824d624bfc$export$321c2da35903b013 = (view, mouseEvent)=>{
    if (!(mouseEvent.target instanceof HTMLElement)) return false;
    const { state: state, dispatch: dispatch } = view;
    const target = mouseEvent.target;
    const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isTableHovered: isTableHovered } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    if ((0, $c2cd42e9bb213cdd$export$7a8d111d40fb198c)(target)) {
        const [startIndex, endIndex] = (0, $c2cd42e9bb213cdd$export$e5e82c478fd9ea3)(target);
        const positionRow = (0, $c2cd42e9bb213cdd$export$3bf5911758d564a4)(mouseEvent) === 'bottom' ? endIndex : startIndex;
        return (0, $4ca83755c936c9c8$export$6ed6a4eb343cf21)(positionRow)(state, dispatch);
    }
    if ((0, $c2cd42e9bb213cdd$export$14eb53395cc0cf57)(target)) {
        const [startIndex] = (0, $c2cd42e9bb213cdd$export$e5e82c478fd9ea3)(target);
        const { state: state, dispatch: dispatch } = view;
        return (0, $7132c436572167eb$export$4cf548f2efac0afe)([
            startIndex
        ], false)(state, dispatch);
    }
    const isNestedTable = (0, $sxTNo.getParentOfTypeCount)(state.schema.nodes.table)(state.selection.$from) > 1;
    if (isNestedTable) {
        // if the table is nested inside a table, we only call hideInsertColumnOrRowButton if the table nearest to the mouse target is NOT the parent table
        const nearestTable = (0, $4vlwG.closestElement)(target, 'table');
        const nestedTable = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(state.doc.resolve(state.selection.from), [
            state.schema.nodes.table
        ]);
        const parentTable = (0, $8m4tT.findParentNodeOfTypeClosestToPos)(state.doc.resolve(nestedTable?.pos || 0), [
            state.schema.nodes.table
        ]);
        if (nearestTable?.dataset.tableLocalId !== parentTable?.node.attrs.localId && ((0, $c2cd42e9bb213cdd$export$835df158d20ae2f0)(target) || (0, $c2cd42e9bb213cdd$export$94cf9243187b20f0)(target)) && (typeof insertColumnButtonIndex === 'number' || typeof insertRowButtonIndex === 'number')) return (0, $4ca83755c936c9c8$export$27d9631a056c3f39)()(state, dispatch);
    } else if (((0, $c2cd42e9bb213cdd$export$835df158d20ae2f0)(target) || (0, $c2cd42e9bb213cdd$export$94cf9243187b20f0)(target)) && (typeof insertColumnButtonIndex === 'number' || typeof insertRowButtonIndex === 'number')) return (0, $4ca83755c936c9c8$export$27d9631a056c3f39)()(state, dispatch);
    if ((0, $c2cd42e9bb213cdd$export$4cf9002f70d2d324)(target)) {
        const [startIndex, endIndex] = (0, $c2cd42e9bb213cdd$export$e5e82c478fd9ea3)(target);
        return (0, $7132c436572167eb$export$9b72d13d82d16e72)({
            left: startIndex,
            right: endIndex
        })(state, dispatch);
    }
    if (!isTableHovered) return (0, $7132c436572167eb$export$f217071b524cec4f)(true)(state, dispatch);
    return false;
};
const $f10f08824d624bfc$export$88f4dbb0cd0ffc84 = (view, mouseEvent)=>{
    if (!(mouseEvent instanceof MouseEvent)) return false;
    const { state: state, dispatch: dispatch } = view;
    const { insertColumnButtonIndex: insertColumnButtonIndex, tableNode: tableNode, tableRef: tableRef } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    if (insertColumnButtonIndex !== undefined && tableRef && tableRef.parentElement && tableNode) {
        const { width: width } = (0, $LmqWp.TableMap).get(tableNode);
        const newInsertColumnButtonIndex = insertColumnButtonIndex + 1;
        if (width === newInsertColumnButtonIndex) {
            const tableWidth = tableRef.clientWidth;
            tableRef.parentElement.scrollTo(tableWidth, 0);
            return (0, $4ca83755c936c9c8$export$72433e6f15f8aeaa)(newInsertColumnButtonIndex)(state, dispatch);
        }
    }
    return false;
};
const $f10f08824d624bfc$export$b4a93e0b711d8f7 = (_, event)=>{
    const isControl = !!(event.target && event.target instanceof HTMLElement && ((0, $c2cd42e9bb213cdd$export$2b59104f44ee317b)(event.target) || (0, $c2cd42e9bb213cdd$export$14eb53395cc0cf57)(event.target) || (0, $c2cd42e9bb213cdd$export$edad492f0c70264f)(event.target) || (0, $c2cd42e9bb213cdd$export$571c943db7bc729c)(event.target)));
    if (isControl) event.preventDefault();
    return isControl;
};
const $f10f08824d624bfc$export$72517da01e0ce829 = (view, mouseEvent)=>{
    if (!(mouseEvent instanceof MouseEvent) || !(mouseEvent.target instanceof HTMLElement)) return false;
    const target = mouseEvent.target;
    if ((0, $c2cd42e9bb213cdd$export$14eb53395cc0cf57)(target)) {
        const { state: state, dispatch: dispatch } = view;
        return (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
    }
    const relatedTarget = mouseEvent.relatedTarget;
    // In case the user is moving between cell at the same column
    // we don't need to hide the resize handle decoration
    if ((0, $c2cd42e9bb213cdd$export$4cf9002f70d2d324)(target) && !(0, $c2cd42e9bb213cdd$export$4cf9002f70d2d324)(relatedTarget)) {
        const { state: state, dispatch: dispatch } = view;
        const { isKeyboardResize: isKeyboardResize } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if (isKeyboardResize) // no need to hide decoration if column resizing started by keyboard
        return false;
        return (0, $7132c436572167eb$export$5ad4eed96dbaffaf)()(state, dispatch);
    }
    return false;
};
const $f10f08824d624bfc$export$2560ef85393729a7 = (view, mouseEvent)=>{
    const { state: state, dispatch: dispatch } = view;
    const { isTableHovered: isTableHovered } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    if (!isTableHovered) return (0, $7132c436572167eb$export$f217071b524cec4f)(true)(state, dispatch);
    return false;
};
const $f10f08824d624bfc$export$fcff8e67f71577c3 = (view, event)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    const { state: state, dispatch: dispatch } = view;
    const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isDragAndDropEnabled: isDragAndDropEnabled, isTableHovered: isTableHovered } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    if (isTableHovered) {
        if (isDragAndDropEnabled) {
            const { isDragMenuOpen: isDragMenuOpen = false } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
            !isDragMenuOpen && (0, $7132c436572167eb$export$f217071b524cec4f)(false)(state, dispatch);
        } else (0, $7132c436572167eb$export$f217071b524cec4f)(false)(state, dispatch);
        return true;
    }
    // If this table doesn't have focus then we want to skip everything after this.
    if (!$f10f08824d624bfc$export$42d5d9cc7457d81e(view)) return false;
    const target = event.target;
    if ((0, $c2cd42e9bb213cdd$export$b4f0758743701ac9)(target)) return true;
    if ((typeof insertColumnButtonIndex !== 'undefined' || typeof insertRowButtonIndex !== 'undefined') && (0, $4ca83755c936c9c8$export$27d9631a056c3f39)()(state, dispatch)) return true;
    return false;
};
// IMPORTANT: The mouse move handler has been setup with RAF schedule to avoid Reflows which will occur as some methods
// need to access the mouse event offset position and also the target clientWidth vallue.
const $f10f08824d624bfc$var$handleMouseMoveDebounce = (nodeViewPortalProviderAPI)=>(0, $2P8Ax.default)((view, event, offsetX)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        const element = event.target;
        if ((0, $c2cd42e9bb213cdd$export$14eb53395cc0cf57)(element) || (0, $c2cd42e9bb213cdd$export$666ae3fd07127e7f)(element)) {
            const { state: state, dispatch: dispatch } = view;
            const { insertColumnButtonIndex: insertColumnButtonIndex } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            const [startIndex, endIndex] = (0, $c2cd42e9bb213cdd$export$e5e82c478fd9ea3)(element);
            const positionColumn = (0, $c2cd42e9bb213cdd$export$3dde6150a2e2df0a)(event, offsetX, undefined) === 'right' ? endIndex : startIndex;
            if (positionColumn !== insertColumnButtonIndex) return (0, $4ca83755c936c9c8$export$72433e6f15f8aeaa)(positionColumn)(state, dispatch);
        }
        if ((0, $c2cd42e9bb213cdd$export$edad492f0c70264f)(element) || (0, $c2cd42e9bb213cdd$export$b2ae534578c0ae33)(element)) {
            const { state: state, dispatch: dispatch } = view;
            const { insertRowButtonIndex: insertRowButtonIndex } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            const [startIndex, endIndex] = (0, $c2cd42e9bb213cdd$export$e5e82c478fd9ea3)(element);
            const positionRow = (0, $c2cd42e9bb213cdd$export$3bf5911758d564a4)(event) === 'bottom' ? endIndex : startIndex;
            if (positionRow !== insertRowButtonIndex) return (0, $4ca83755c936c9c8$export$6ed6a4eb343cf21)(positionRow)(state, dispatch);
        }
        if (!(0, $c2cd42e9bb213cdd$export$4cf9002f70d2d324)(element) && (0, $c2cd42e9bb213cdd$export$835df158d20ae2f0)(element)) {
            const positionColumn = (0, $c2cd42e9bb213cdd$export$3dde6150a2e2df0a)(event, offsetX, (0, $8b6ac7577f3a66b8$export$1a38c7157d718094));
            if (positionColumn !== null) {
                const { state: state, dispatch: dispatch } = view;
                const { resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleRowIndex: resizeHandleRowIndex } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
                const isKeyboardResize = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state).isKeyboardResize;
                const tableCell = (0, $4vlwG.closestElement)(element, 'td, th');
                const cellStartPosition = view.posAtDOM(tableCell, 0);
                const rect = (0, $id9O1.findCellRectClosestToPos)(state.doc.resolve(cellStartPosition));
                if (rect) {
                    const columnEndIndexTarget = positionColumn === 'left' ? rect.left : rect.right;
                    const rowIndexTarget = rect.top;
                    if ((columnEndIndexTarget !== resizeHandleColumnIndex || rowIndexTarget !== resizeHandleRowIndex || !(0, $c2cd42e9bb213cdd$export$80e4fcc9d7220616)({
                        target: element,
                        columnEndIndexTarget: columnEndIndexTarget
                    })) && !isKeyboardResize // if initiated by keyboard don't need to react on hover for other resize sliders
                    ) return (0, $4ca83755c936c9c8$export$cc6f44d67305c400)(rowIndexTarget, columnEndIndexTarget, true, nodeViewPortalProviderAPI)(state, dispatch);
                }
            }
        }
        return false;
    });
const $f10f08824d624bfc$export$3248c033e90a4ba0 = (nodeViewPortalProviderAPI)=>(view, event)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        // NOTE: When accessing offsetX in gecko from a deferred callback, it will return 0. However it will be non-zero if accessed
        // within the scope of it's initial mouse move handler. Also Chrome does return the correct value, however it could trigger
        // a reflow. So for now this will just grab the offsetX value immediately for gecko and chrome will calculate later
        // in the deferred callback handler.
        // Bug Tracking: https://bugzilla.mozilla.org/show_bug.cgi?id=1882903
        $f10f08824d624bfc$var$handleMouseMoveDebounce(nodeViewPortalProviderAPI)(view, event, (0, $d7ZU3.getBrowserInfo)().gecko ? event.offsetX : NaN);
        return false;
    };
function $f10f08824d624bfc$export$f17e34274dd6fcf5(view, pos) {
    const { state: state, dispatch: dispatch } = view;
    const $cellPos = (0, $3gZJH.cellAround)(state.doc.resolve(pos));
    if (!$cellPos) return false;
    const cell = state.doc.nodeAt($cellPos.pos);
    if (cell) {
        const selFrom = (0, $ks2lK.Selection).findFrom($cellPos, 1, true);
        const selTo = (0, $ks2lK.Selection).findFrom(state.doc.resolve($cellPos.pos + cell.nodeSize), -1, true);
        if (selFrom && selTo) {
            dispatch(state.tr.setSelection(new (0, $ks2lK.TextSelection)(selFrom.$from, selTo.$to)));
            return true;
        }
    }
    return false;
}
const $f10f08824d624bfc$export$1c3f791fb2a5168 = (oldTr, oldState, newState, api, editorAnalyticsAPI, editorView, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false)=>{
    const oldSelection = oldState.tr.selection;
    let { tr: tr } = newState;
    if (oldSelection instanceof (0, $7XFGZ.CellSelection)) {
        const $anchorCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$anchorCell.pos));
        const $headCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$headCell.pos));
        const cellSelection = new (0, $7XFGZ.CellSelection)($anchorCell, $headCell);
        tr.setSelection(cellSelection);
        if (tr.selection instanceof (0, $7XFGZ.CellSelection)) {
            const rect = (0, $iP1et.getSelectionRect)(cellSelection);
            if (rect) {
                const { verticalCells: verticalCells, horizontalCells: horizontalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$277d5394a2608229)(tr.selection);
                // Reassigning to make it more obvious and consistent
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $3824I.TABLE_ACTION).CUT,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        verticalCells: verticalCells,
                        horizontalCells: horizontalCells,
                        totalCells: totalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(tr);
                // Need this check again since we are overriding the tr in previous statement
                if (tr.selection instanceof (0, $7XFGZ.CellSelection)) {
                    const isTableSelected = tr.selection.isRowSelection() && tr.selection.isColSelection();
                    if (isTableSelected) tr = (0, $008a20f9f9e43ec0$export$5b4a0d6329b35552)(tr);
                    else if (tr.selection.isRowSelection()) {
                        const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(newState);
                        tr = (0, $afc8bdade8a657ed$export$88b7a0bb8d808bf6)(rect, isHeaderRowRequired)(tr);
                    } else if (tr.selection.isColSelection()) tr = (0, $2519da145d38150e$export$9dbd3595d5638a0b)(rect, (0, $b53892aeb6ce63cd$export$f8ddfdc64e14a808)(oldState), api, editorView, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)(tr);
                }
            }
        }
    }
    return tr;
};
const $f10f08824d624bfc$export$42d5d9cc7457d81e = (view)=>{
    return !!(0, $69d6e2a2c784f306$export$f05434c51e3762e)(view.state)?.tableNode && !(0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(view.state)?.dragging;
};
const $f10f08824d624bfc$export$82a75cb550f27e28 = (eventHandler, pluginInjectionApi)=>(view, mouseEvent)=>{
        if (!$f10f08824d624bfc$export$42d5d9cc7457d81e(view)) return false;
        const isViewMode = pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        /**
   * Table cannot be in focus if we are in view mode.
   * This will prevent an infinite flow of adding and removing
   * resize handle decorations in view mode that causes unpredictable
   * selections.
   */ if (isViewMode) return false;
        return eventHandler(view, mouseEvent);
    };
const $f10f08824d624bfc$var$trackCellLocation = (view, mouseEvent)=>{
    const target = mouseEvent.target;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const maybeTableCell = (0, $kTbzR.isElementInTableCell)(target);
    const { tableNode: tableNode, tableRef: tableRef } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(view.state);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const tableElement = (0, $4vlwG.closestElement)(target, 'table');
    // hover will only trigger if target localId is the same with selected localId
    if (tableElement?.dataset?.tableLocalId && tableElement.dataset.tableLocalId !== tableNode?.attrs.localId) return;
    if (!maybeTableCell || !tableRef) return;
    const htmlColIndex = maybeTableCell.cellIndex;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rowElement = (0, $4vlwG.closestElement)(target, 'tr');
    const htmlRowIndex = rowElement && rowElement.rowIndex;
    const tableMap = tableNode && (0, $LmqWp.TableMap).get(tableNode);
    let colIndex = htmlColIndex;
    if (tableMap) {
        const convertedColIndex = (0, $7eacb027e2e3fea2$export$b53a50910add7502)(htmlColIndex, htmlRowIndex, tableMap);
        colIndex = (0, $7eacb027e2e3fea2$export$ffa56ed053ef832e)(convertedColIndex, htmlRowIndex, tableMap);
    }
    (0, $7132c436572167eb$export$1d614a0f0fe37c44)(htmlRowIndex, colIndex)(view.state, view.dispatch);
};
const $f10f08824d624bfc$export$87e6a6bf8341824f = (eventHandler)=>(view, mouseEvent)=>{
        if ((0, $69d6e2a2c784f306$export$f05434c51e3762e)(view.state).isDragAndDropEnabled && (0, $abc6204662f4f035$export$f05434c51e3762e)(view.state) && !(0, $abc6204662f4f035$export$f05434c51e3762e)(view.state).isDragging) $f10f08824d624bfc$var$trackCellLocation(view, mouseEvent);
        return eventHandler(view, mouseEvent);
    };



















/* eslint-disable @atlaskit/design-system/prefer-primitives */ 




























/* eslint-disable @atlaskit/design-system/no-html-button */ 









var $jTxSS = parcelRequire("jTxSS");






















var $afUmf = parcelRequire("afUmf");











parcelRequire("42omo");









parcelRequire("42omo");

const $a906c61be8f1260e$export$227151c7eab30def = ({ style: style })=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "28",
        height: "20",
        viewBox: "0 0 28 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "1",
                y: "1",
                width: "26",
                height: "18",
                rx: "5",
                fill: "var(--ds-background-accent-blue-subtle, #669DF1)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "9",
                y: "6",
                width: "2",
                height: "8",
                rx: "1",
                fill: "var(--ds-border-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "13",
                y: "6",
                width: "2",
                height: "8",
                rx: "1",
                fill: "var(--ds-border-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "17",
                y: "6",
                width: "2",
                height: "8",
                rx: "1",
                fill: "var(--ds-border-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                x: "1",
                y: "1",
                width: "26",
                height: "18",
                rx: "5",
                stroke: "var(--ds-border-inverse, #FFFFFF)",
                strokeWidth: "2"
            })
        ]
    });


const $0478538aa7e68e3c$var$boxStyles = (0, $ecnYn.xcss)({
    borderColor: 'color.border.focused',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width.focused',
    backgroundColor: 'color.blanket.selected'
});
const $0478538aa7e68e3c$export$905ab40ac2179daa = ({ direction: direction, width: width, height: height })=>{
    const marginLeft = direction === 'row' ? -14 : width / 2 - 14;
    const marginTop = direction === 'row' ? height / 2 - 14 : -10;
    const transform = direction === 'row' ? 'rotate(90deg)' : 'none';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $0478538aa7e68e3c$var$boxStyles,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        style: {
            width: `${width}px`,
            height: `${height}px`
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a906c61be8f1260e$export$227151c7eab30def), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginLeft: `${marginLeft}px`,
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: `${marginTop}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                transform: transform
            }
        })
    });
};





parcelRequire("42omo");




parcelRequire("42omo");

const $2c3f7bd5b3179fae$export$b005cb3a0f2a5647 = ({ style: style })=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": "drag-icon-disabled",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "16",
                rx: "4"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        x: "7",
                        y: "4",
                        width: "2",
                        height: "8",
                        rx: "1"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        x: "11",
                        y: "4",
                        width: "2",
                        height: "8",
                        rx: "1"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        x: "15",
                        y: "4",
                        width: "2",
                        height: "8",
                        rx: "1"
                    })
                ]
            })
        ]
    });





parcelRequire("42omo");

const $ff4957c8f89fc920$export$7d3bc85820ac4455 = ()=>/*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        fill: "none",
        "data-testid": "drag-icon-enabled",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                width: "24",
                height: "16",
                rx: "4"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M9 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM9 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
                })
            })
        ]
    });





parcelRequire("42omo");


const $5f4c29316e84f6e9$export$e32dc8bb64018ca1 = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "5",
        fill: "none",
        children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_MINIMISED,
            width: "24",
            height: "5",
            rx: "3"
        })
    });


const $8b9780e38922bcca$export$8749e1cb5c52435f = (props)=>{
    const { forceDefaultHandle: forceDefaultHandle, isHandleHovered: isHandleHovered, hasMergedCells: hasMergedCells } = props;
    if (isHandleHovered || forceDefaultHandle) return hasMergedCells ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2c3f7bd5b3179fae$export$b005cb3a0f2a5647), {}) : /*#__PURE__*/ (0, $l998X.jsx)((0, $ff4957c8f89fc920$export$7d3bc85820ac4455), {});
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5f4c29316e84f6e9$export$e32dc8bb64018ca1), {});
};


const $7c8b405b164adf54$var$DragHandleComponent = ({ isDragMenuTarget: isDragMenuTarget, tableLocalId: tableLocalId, direction: direction = 'row', appearance: appearance = 'default', indexes: indexes, forceDefaultHandle: forceDefaultHandle = false, previewWidth: previewWidth, previewHeight: previewHeight, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, toggleDragMenu: toggleDragMenu, hoveredCell: hoveredCell, onClick: onClick, editorView: editorView, intl: { formatMessage: formatMessage } })=>{
    const dragHandleDivRef = (0, $42omo.useRef)(null);
    const [previewContainer, setPreviewContainer] = (0, $42omo.useState)(null);
    const { state: state, state: { selection: selection } } = editorView;
    const { isDragMenuOpen: isDragMenuOpen = false } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const isRow = direction === 'row';
    const isColumn = direction === 'column';
    const hasMergedCells = (0, $42omo.useMemo)(()=>{
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return false;
        const map = (0, $LmqWp.TableMap).get(table?.node);
        if (!map.hasMergedCells() || indexes.length < 1) return false;
        const { mapByColumn: mapByColumn, mapByRow: mapByRow } = map;
        // this handle when hover to first column or row which has merged cells.
        if (hoveredCell && hoveredCell.rowIndex !== undefined && hoveredCell.colIndex !== undefined && selection instanceof (0, $ks2lK.TextSelection)) {
            const { rowIndex: rowIndex, colIndex: colIndex } = hoveredCell;
            const mergedPositionInRow = (0, $0e87c5ebb1bfe871$export$1d4a5608e72f1096)(mapByRow[rowIndex]);
            const mergedPositionInCol = (0, $0e87c5ebb1bfe871$export$1d4a5608e72f1096)(mapByColumn[colIndex]);
            const hasMergedCellsInFirstRowOrColumn = direction === 'column' ? mergedPositionInRow.includes(mapByRow[0][colIndex]) : mergedPositionInCol.includes(mapByColumn[0][rowIndex]);
            const isHoveredOnFirstRowOrColumn = direction === 'column' ? hoveredCell.rowIndex === 0 && hasMergedCellsInFirstRowOrColumn : hoveredCell.colIndex === 0 && hasMergedCellsInFirstRowOrColumn;
            if (isHoveredOnFirstRowOrColumn) {
                const mergedSizes = direction === 'column' ? mapByRow[0].filter((el)=>el === mapByRow[0][colIndex]).length : mapByColumn[0].filter((el)=>el === mapByColumn[0][rowIndex]).length;
                const mergedSelection = (0, $0e87c5ebb1bfe871$export$e4c313e419348ae7)(direction === 'column' ? [
                    colIndex,
                    colIndex + mergedSizes - 1
                ] : [
                    rowIndex,
                    rowIndex + mergedSizes - 1
                ], direction)(selection);
                return mergedSelection;
            }
        }
        return (0, $0e87c5ebb1bfe871$export$e4c313e419348ae7)(indexes, direction)(selection);
    }, [
        indexes,
        selection,
        direction,
        hoveredCell
    ]);
    const handleIconProps = {
        forceDefaultHandle: forceDefaultHandle,
        isHandleHovered: isHovered,
        hasMergedCells: hasMergedCells
    };
    (0, $42omo.useEffect)(()=>{
        const dragHandleDivRefCurrent = dragHandleDivRef.current;
        const browser = (0, $d7ZU3.getBrowserInfo)();
        if (dragHandleDivRefCurrent) return (0, $4T4vf.draggable)({
            element: dragHandleDivRefCurrent,
            canDrag: ()=>{
                return !hasMergedCells;
            },
            getInitialData () {
                return {
                    localId: tableLocalId,
                    type: `table-${direction}`,
                    indexes: indexes
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $afUmf.setCustomNativeDragPreview)({
                    getOffset: ({ container: container })=>{
                        const rect = container.getBoundingClientRect();
                        if (browser.safari) // See: https://product-fabric.atlassian.net/browse/ED-21442
                        // We need to ensure that the preview is not overlaying screen content when the snapshot is taken, otherwise
                        // safari will composite the screen text elements into the bitmap snapshot. The container is a wrapper which is already
                        // positioned fixed at top/left 0.
                        // IMPORTANT: we must not exceed more then the width of the container off-screen otherwise not preview will
                        // be generated.
                        container.style.left = `-${rect.width - 0.0001}px`;
                        if (isRow) return {
                            x: 12,
                            y: rect.height / 2
                        };
                        else return {
                            x: rect.width / 2 + 4,
                            y: 12
                        };
                    },
                    render: function render({ container: container }) {
                        setPreviewContainer(container);
                        return ()=>setPreviewContainer(null);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        });
    }, [
        tableLocalId,
        direction,
        indexes,
        isRow,
        editorView.state.selection,
        hasMergedCells
    ]);
    const showDragMenuAnchorId = isRow ? 'drag-handle-button-row' : 'drag-handle-button-column';
    const browser = (0, $d7ZU3.getBrowserInfo)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("button", {
                type: "button",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE,
                "data-testid": "table-drag-handle-clickable-zone-button",
                style: {
                    height: isRow ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    `calc(100% - ${0, $fbbb9ee8877c285e$export$d18320cc8ee69115}px)` : `${"var(--ds-space-200, 16px)"}`,
                    // 16px here because it's the size of drag handle button's large side
                    width: isRow ? `${"var(--ds-space-200, 16px)"}` // 16px here because it's the size of drag handle button's large side
                     : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    `calc(100% - ${0, $fbbb9ee8877c285e$export$d18320cc8ee69115}px)`,
                    left: isRow ? `${"var(--ds-space-050, 4px)"}` : undefined,
                    bottom: isColumn ? `${"var(--ds-space-0, 0px)"}` : undefined,
                    alignSelf: isColumn ? 'none' : 'center',
                    zIndex: isColumn ? '-1' : 'auto',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    pointerEvents: 'auto'
                },
                onMouseUp: (e)=>{
                    // should toggle menu if current drag menu open.
                    // return focus to editor so copying table selections whilst still works, i cannot call e.preventDefault in a mousemove event as this stops dragstart events from firing
                    // -> this is bad for a11y but is the current standard new copy/paste keyboard shortcuts should be introduced instead
                    editorView.focus();
                    if (isDragMenuOpen) toggleDragMenu && toggleDragMenu('mouse', e);
                },
                onClick: onClick,
                "aria-label": formatMessage((0, $2CQVV.messages).dragHandleZone)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("button", {
                type: "button",
                id: isDragMenuTarget ? showDragMenuAnchorId : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CONTAINER, appearance, {
                    [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_DISABLED]: hasMergedCells
                }),
                ref: dragHandleDivRef,
                style: {
                    transform: isColumn ? 'none' : 'rotate(90deg)',
                    alignSelf: isColumn ? 'none' : 'center'
                },
                "data-testid": "table-drag-handle-button",
                "aria-label": formatMessage(isRow ? (0, $2CQVV.messages).rowDragHandle : (0, $2CQVV.messages).columnDragHandle),
                "aria-expanded": isDragMenuOpen && isDragMenuTarget ? 'true' : 'false',
                "aria-haspopup": "menu",
                onMouseOver: (e)=>{
                    setIsHovered(true);
                    onMouseOver && onMouseOver(e);
                },
                onMouseOut: (e)=>{
                    setIsHovered(false);
                    onMouseOut && onMouseOut(e);
                },
                onFocus: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? (e)=>{
                    onFocus && onFocus(e);
                } : undefined,
                onBlur: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? (e)=>{
                    onBlur && onBlur(e);
                } : undefined,
                onMouseUp: (e)=>{
                    // return focus to editor so copying table selections whilst still works, i cannot call e.preventDefault in a mousemove event as this stops dragstart events from firing
                    // -> this is bad for a11y but is the current standard new copy/paste keyboard shortcuts should be introduced instead
                    editorView.focus();
                    toggleDragMenu && toggleDragMenu('mouse', e);
                },
                onClick: onClick,
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' || e.key === ' ') toggleDragMenu && toggleDragMenu('keyboard');
                },
                children: appearance !== 'placeholder' ? //  cannot block pointer events in Firefox as it breaks Dragging functionality
                browser.gecko ? // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $l998X.jsx)((0, $8b9780e38922bcca$export$8749e1cb5c52435f), {
                    ...handleIconProps
                }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    style: {
                        pointerEvents: 'none'
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8b9780e38922bcca$export$8749e1cb5c52435f), {
                        ...handleIconProps
                    })
                }) : null
            }),
            previewContainer && previewWidth !== undefined && previewHeight !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).createPortal(/*#__PURE__*/ (0, $l998X.jsx)((0, $0478538aa7e68e3c$export$905ab40ac2179daa), {
                direction: direction,
                width: previewWidth,
                height: previewHeight
            }), previewContainer)
        ]
    });
};
const $7c8b405b164adf54$export$a0c24614540b0efb = (0, $aXWIB.injectIntl)($7c8b405b164adf54$var$DragHandleComponent);


const $e85fd443bde152fa$var$getSelectedColumns = (selection)=>{
    if (selection instanceof (0, $7XFGZ.CellSelection) && selection.isColSelection()) {
        const rect = (0, $iP1et.getSelectionRect)(selection);
        if (!rect) return [];
        return (0, $cee807f94f070ba4$export$915a77877be361e9)(rect);
    }
    return [];
};
const $e85fd443bde152fa$export$a71b12ee0b179860 = ({ editorView: editorView, tableActive: tableActive, tableRef: tableRef, hoveredCell: hoveredCell, stickyTop: stickyTop, localId: localId, isInDanger: isInDanger, rowHeights: rowHeights, colWidths: colWidths, isTableHovered: isTableHovered, tableContainerWidth: tableContainerWidth, isNumberColumnEnabled: isNumberColumnEnabled, isDragging: isDragging, getScrollOffset: getScrollOffset, api: api })=>{
    const columnControlsRef = (0, $42omo.useRef)(null);
    const { selection: selection } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>({
            selection: states.selectionState?.selection
        }));
    const widths = colWidths?.map((width)=>// when there is sticky header, a `margin-right: -1px` applied to `tr.sticky th` so it causes colWidths to be 1px wider
        // we need to reduce the width by 1px to avoid misalignment of column controls.
        width ? stickyTop ? `${width - 2}px` : `${width - 1}px` : '0px').join(' ') ?? '0px';
    // TODO: ED-26961 - reusing getRowsParams here because it's generic enough to work for columns -> rename
    const columnParams = (0, $885c1a71dd6e181b$export$b8127ab1acaa6d46)(colWidths ?? []);
    const colIndex = hoveredCell?.colIndex;
    const selectedColIndexes = $e85fd443bde152fa$var$getSelectedColumns(selection || editorView.state.selection);
    const firstRow = tableRef.querySelector('tr');
    const hasHeaderRow = firstRow ? firstRow.getAttribute('data-header-row') : false;
    const rowControlStickyTop = 45;
    const marginTop = hasHeaderRow && stickyTop !== undefined ? rowControlStickyTop ?? 0 : 0;
    const handleClick = (0, $42omo.useCallback)((event)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const isClickOutsideSelectedCols = // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedColIndexes.length >= 1 && !selectedColIndexes.includes(colIndex);
        if (!selectedColIndexes || selectedColIndexes.length === 0 || isClickOutsideSelectedCols) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $4ca83755c936c9c8$export$c2e8772deb1607ea)(colIndex, event.shiftKey)(state, dispatch);
        if (selectedColIndexes.length > 1 && // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedColIndexes.includes(colIndex) && !event.shiftKey) (0, $4ca83755c936c9c8$export$41a42e79fbe56d35)(selectedColIndexes)(state, dispatch);
    }, [
        colIndex,
        selectedColIndexes,
        editorView
    ]);
    const handleMouseOver = (0, $42omo.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = editorView;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $7132c436572167eb$export$4cf548f2efac0afe)([
            colIndex
        ])(state, dispatch);
    }, [
        colIndex,
        editorView
    ]);
    const handleMouseMove = (0, $42omo.useCallback)((e)=>{
        const isParentDragControls = e.nativeEvent.target.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS}`);
        const colIndex = e.nativeEvent.target.getAttribute('data-start-index');
        // avoid updating if event target is not related
        if (!isParentDragControls || !colIndex) return;
        // update hovered cell location
        const { state: state, dispatch: dispatch } = editorView;
        if (tableActive) // For context:  Whenever we mouse over a column or row drag handle, we will ALWAYS be hovering over the 0 index
        // of the opposite dimension. For example; here when we mouse over the column drag handle then we're technically
        // also hovering over row 0 index. And vice-versa with rows. This means we don't need to worry about knowing the
        // current row index. We can just force it to 0.
        (0, $7132c436572167eb$export$1d614a0f0fe37c44)(0, Number(colIndex))(state, dispatch);
    }, [
        editorView,
        tableActive
    ]);
    const handleMouseOut = (0, $42omo.useCallback)(()=>{
        if (tableActive) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        }
    }, [
        editorView,
        tableActive
    ]);
    const toggleDragMenuHandler = (0, $42omo.useCallback)((trigger, event)=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (event?.shiftKey) return;
        (0, $66674519b4a32446$export$ade80ff7f1fbb779)(api?.analytics?.actions)(undefined, 'column', colIndex, trigger)(state, dispatch);
    }, [
        editorView,
        colIndex,
        api?.analytics?.actions
    ]);
    const colIndexes = (0, $42omo.useMemo)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return [
            colIndex
        ];
    }, [
        colIndex
    ]);
    if (stickyTop && columnControlsRef.current) columnControlsRef.current.scrollLeft = getScrollOffset?.() ?? 0;
    const generateHandleByType = (type, appearance, gridColumn, indexes)=>{
        const isHover = type === 'hover';
        const isPlaceholder = appearance === 'placeholder';
        const previewHeight = rowHeights?.reduce((sum, cur)=>sum + cur, 0) ?? 0;
        const previewWidth = colWidths?.reduce((sum, v, i)=>sum + (v ?? (0, $1zav4.tableCellMinWidth)) * (indexes.includes(i) ? 1 : 0), 0) ?? (0, $1zav4.tableCellMinWidth);
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            contentEditable: false,
            style: {
                gridColumn: gridColumn,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridRow: '1',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                justifyContent: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                alignItems: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: 'fit-content',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                placeSelf: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                zIndex: 99,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative'
            },
            "data-testid": `table-floating-column-${isHover ? colIndex : isPlaceholder ? appearance : selectedColIndexes[0]}-drag-handle`,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7c8b405b164adf54$export$a0c24614540b0efb), {
                isDragMenuTarget: !isHover,
                direction: "column",
                tableLocalId: localId || '',
                indexes: indexes,
                hoveredCell: hoveredCell,
                previewWidth: previewWidth,
                forceDefaultHandle: !isHover,
                previewHeight: previewHeight,
                appearance: appearance,
                onClick: handleClick,
                onMouseOver: handleMouseOver,
                onMouseOut: handleMouseOut,
                onBlur: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? handleMouseOut : undefined,
                onFocus: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? handleMouseOver : undefined,
                toggleDragMenu: toggleDragMenuHandler,
                editorView: editorView
            })
        }, type);
    };
    const columnHandles = ()=>{
        const handles = [];
        const isColumnSelected = selectedColIndexes.length > 0;
        const isEntireTableSelected = (colWidths || []).length > selectedColIndexes.length;
        if (!tableActive) return null;
        const selectedAppearance = isColumnSelected && isEntireTableSelected ? isInDanger ? 'danger' : 'selected' : 'placeholder';
        // placeholder / selected need to always render at least one handle
        // so it can be focused via keyboard shortcuts
        handles.push(generateHandleByType('selected', selectedAppearance, // always position placeholder in first column to avoid overflow issues
        selectedAppearance === 'placeholder' ? '1 / span 1' : `${selectedColIndexes[0] + 1} / span ${selectedColIndexes.length}`, selectedColIndexes));
        if (hoveredCell && isTableHovered && colIndex !== undefined && !selectedColIndexes.includes(colIndex)) handles.push(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        generateHandleByType('hover', 'default', `${colIndex + 1} / span 1`, colIndexes));
        return handles;
    };
    const containerWidth = isNumberColumnEnabled && tableContainerWidth ? tableContainerWidth - (0, $aFUXX.akEditorTableNumberColumnWidth) : tableContainerWidth;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS,
        onMouseMove: handleMouseMove,
        children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            ref: columnControlsRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER,
            "data-testid": "table-floating-column-controls",
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridTemplateColumns: widths,
                marginTop: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                marginTop,
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                width: stickyTop ? containerWidth : undefined,
                overflowX: stickyTop ? 'hidden' : 'visible',
                pointerEvents: isDragging ? 'none' : undefined
            },
            children: [
                columnParams.map(({ startIndex: startIndex, endIndex: endIndex }, index)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            gridColumn: `${startIndex + 1} / span 1`
                        },
                        "data-start-index": startIndex,
                        "data-end-index": endIndex,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER,
                        contentEditable: false,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: columnParams.length - 1 === index ? {
                                right: '0'
                            } : {}
                        })
                    }, index)),
                columnHandles()
            ]
        })
    });
};






















const $d471513cc0a7aea8$export$e8a325e09c5453d5 = ({ index: index, localId: localId, width: width, height: height, marginTop: marginTop })=>{
    const dropTargetRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!dropTargetRef.current) return;
        return (0, $4T4vf.dropTargetForElements)({
            element: dropTargetRef.current,
            canDrop ({ source: source, input: input }) {
                const data = source.data;
                const behaviour = (0, $af1654059f589843$export$b95259a1f587c41)(input);
                // A move drop is limited too where it can go, however a clone can drop can go anywhere.
                const isDropValid = behaviour === 'move' ? data.indexes?.indexOf(index) === -1 : behaviour === 'clone';
                return(// Only draggables of row type can be dropped on this target
                data.type === 'table-column' && // Only draggables which came from the same table can be dropped on this target
                data.localId === localId && // Only draggables which DO NOT include this drop targets index can be dropped
                !!data.indexes?.length && isDropValid);
            },
            getDropEffect: ({ input: input })=>(0, $af1654059f589843$export$b95259a1f587c41)(input) === 'clone' ? 'copy' : 'move',
            getIsSticky: ()=>true,
            getData ({ source: source, input: input, element: element }) {
                const data = {
                    localId: localId,
                    type: 'table-column',
                    targetIndex: index
                };
                const srcData = source.data;
                const behaviour = (0, $af1654059f589843$export$b95259a1f587c41)(input);
                // During a move op there's no point in allowing edges to be dropped on which result in no change/move to occur.
                const allowedEdges = behaviour === 'move' ? srcData.indexes?.reduce((acc, v)=>{
                    if (v - index === -1) acc.shift();
                    if (v - index === 1) acc.pop();
                    return acc;
                }, [
                    'left',
                    'right'
                ]) : [
                    'left',
                    'right'
                ];
                return (0, $2WHHL.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            }
        });
    }, [
        index,
        localId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: dropTargetRef,
        style: {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            width: width && `${width - 1}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            height: height && `${height}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginTop: marginTop && `${marginTop}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexShrink: 0
        },
        "data-drop-target-index": index,
        "data-drop-target-localid": localId,
        "data-testid": "table-floating-column-controls-drop-target"
    });
};


const $f70703bd6e177feb$export$9878f6beafc50edd = ({ tableRef: tableRef, tableHeight: tableHeight, localId: localId, colWidths: colWidths, isHeaderSticky: isHeaderSticky, getScrollOffset: getScrollOffset })=>{
    const dropTargetRef = (0, $42omo.useRef)(null);
    if (!tableRef) return null;
    if (isHeaderSticky && dropTargetRef.current) dropTargetRef.current.style.marginLeft = `-${getScrollOffset?.() ?? 0}px`;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: dropTargetRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_DROP_TARGET_CONTROLS,
        contentEditable: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER,
            "data-testid": "table-floating-column-controls-drop-targets",
            children: colWidths?.map((width, index)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $d471513cc0a7aea8$export$e8a325e09c5453d5), {
                    index: index,
                    localId: localId,
                    width: width,
                    height: tableHeight,
                    marginTop: 0
                }, index);
            })
        })
    });
};


const $fc03cc481fa1e1aa$var$TableFloatingColumnControls = ({ editorView: editorView, tableRef: tableRef, getNode: getNode, tableActive: tableActive, hasHeaderRow: hasHeaderRow, hoveredCell: hoveredCell, isResizing: isResizing, stickyHeader: stickyHeader, selection: selection, isInDanger: isInDanger, isTableHovered: isTableHovered, tableContainerWidth: tableContainerWidth, isNumberColumnEnabled: isNumberColumnEnabled, getScrollOffset: getScrollOffset, tableWrapperHeight: tableWrapperHeight, api: api, isChromelessEditor: isChromelessEditor, isDragAndDropEnabled: isDragAndDropEnabled })=>{
    const [isDragging, setIsDragging] = (0, $42omo.useState)(false);
    const containerRef = (0, $42omo.useRef)(null);
    const node = getNode();
    const currentNodeLocalId = node?.attrs.localId;
    const hasHeaderColumn = (0, $bdb0299b531c40df$export$a21ded6c12f16fdf)(node);
    const stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
    (0, $42omo.useEffect)(()=>{
        return (0, $4T4vf.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, localId: localId, indexes: indexes } = source.data;
                return type === 'table-column' && !!indexes?.length && localId === currentNodeLocalId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        editorView,
        currentNodeLocalId
    ]);
    const rowHeights = (0, $42omo.useMemo)(()=>{
        // NOTE: we don't care so much as to what tableHeight is, we only care that it changed and is a sane value.
        if (tableRef && !!tableWrapperHeight) return (0, $885c1a71dd6e181b$export$3e5149a60ac7416b)(tableRef);
        return [
            0
        ];
    }, [
        tableRef,
        tableWrapperHeight
    ]);
    if (!tableRef || !tableActive || isResizing) return null;
    const colWidths = (0, $7eacb027e2e3fea2$export$79aef9e007571c)(editorView);
    if (stickyTop) {
        const columnControlTopOffsetFromParent = '-12px';
        containerRef?.current?.style.setProperty('top', columnControlTopOffsetFromParent);
    } else containerRef?.current?.style.removeProperty('top');
    let anchorStyles = {};
    if ((0, $425e1bfad150b07f$export$2ee7329d46115d8f)() && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) {
        const rowAnchorName = tableRef.querySelector('tr')?.style.getPropertyValue('anchor-name');
        // cast here is due to CSSProperties missing valid positionAnchor property
        anchorStyles = {
            /* We need to default to checking the anchor style because there may be a conflict with the block controls
       plugin not using the data attribute value and setting the `anchor-name` style property independently of the data attribute.
       */ positionAnchor: rowAnchorName === '' ? tableRef.querySelector('tr')?.dataset.nodeAnchor : rowAnchorName
        };
    }
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        ref: containerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER + (isChromelessEditor ? ' ' + (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS : ''),
        "data-testid": "table-floating-column-controls-wrapper",
        // anchor name is determined dynamically so can't use static styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: anchorStyles,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $e85fd443bde152fa$export$a71b12ee0b179860), {
                editorView: editorView,
                hoveredCell: hoveredCell,
                tableRef: tableRef,
                tableActive: tableActive,
                isTableHovered: isTableHovered,
                stickyTop: tableActive ? stickyTop : undefined,
                localId: currentNodeLocalId,
                isInDanger: isInDanger,
                rowHeights: rowHeights,
                colWidths: colWidths,
                hasHeaderColumn: hasHeaderColumn,
                tableContainerWidth: tableContainerWidth,
                isNumberColumnEnabled: isNumberColumnEnabled,
                isDragging: isDragging,
                getScrollOffset: getScrollOffset,
                api: api
            }),
            isDragging && /*#__PURE__*/ (0, $l998X.jsx)((0, $f70703bd6e177feb$export$9878f6beafc50edd), {
                tableRef: tableRef,
                isHeaderSticky: stickyHeader?.sticky && hasHeaderRow,
                tableHeight: tableWrapperHeight,
                localId: currentNodeLocalId,
                colWidths: colWidths,
                getScrollOffset: getScrollOffset
            })
        ]
    });
};
var $fc03cc481fa1e1aa$export$2e2bcd8739ae039 = $fc03cc481fa1e1aa$var$TableFloatingColumnControls;


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 


















































const $c3edf387a25033c9$var$DragCornerControlsComponent = ({ editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage } })=>{
    const handleOnClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        dispatch((0, $kEbNW.selectTable)(state.tr).setMeta('addToHistory', false));
    };
    const handleMouseOut = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
    };
    const isActive = (0, $42omo.useMemo)(()=>{
        const { selection: selection } = editorView.state;
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return false;
        return (0, $iYC9s.isTableSelected)(selection);
    }, [
        editorView.state
    ]);
    if (isResizing) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON, {
            active: isActive,
            danger: isActive && isInDanger
        }),
        "aria-label": formatMessage((0, $2CQVV.messages).cornerControl),
        type: "button",
        onClick: handleOnClick,
        onMouseOut: handleMouseOut,
        onBlur: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? handleMouseOut : undefined,
        contentEditable: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER
        })
    });
};
const $c3edf387a25033c9$var$DragCornerControlsComponentWithSelection = ({ editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage }, api: api })=>{
    const { selection: selection } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>({
            selection: states.selectionState?.selection
        }));
    const handleOnClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        dispatch((0, $kEbNW.selectTable)(state.tr).setMeta('addToHistory', false));
    };
    const handleMouseOut = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
    };
    const isActive = (0, $42omo.useMemo)(()=>{
        if (!selection) return;
        const table = (0, $id9O1.findTable)(selection);
        if (!table) return false;
        return (0, $iYC9s.isTableSelected)(selection);
    }, [
        selection
    ]);
    if (isResizing) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON, {
            active: isActive,
            danger: isActive && isInDanger
        }),
        "aria-label": formatMessage((0, $2CQVV.messages).cornerControl),
        type: "button",
        onClick: handleOnClick,
        onMouseOut: handleMouseOut,
        onBlur: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? handleMouseOut : undefined,
        contentEditable: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER
        })
    });
};
const $c3edf387a25033c9$export$2e06061cfdb64df2 = (0, $aXWIB.injectIntl)($c3edf387a25033c9$var$DragCornerControlsComponentWithSelection);
const $c3edf387a25033c9$export$2beb96b6455e9966 = (0, $aXWIB.injectIntl)($c3edf387a25033c9$var$DragCornerControlsComponent);





parcelRequire("42omo");


































// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components, @typescript-eslint/no-explicit-any
class $8c2dcccfe6a575f9$var$CornerControlComponent extends (0, $42omo.Component) {
    render() {
        const { isInDanger: isInDanger, tableRef: tableRef, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, intl: { formatMessage: formatMessage } } = this.props;
        if (!tableRef) return null;
        const isActive = this.isActive();
        return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, {
                active: isActive,
                sticky: this.props.stickyTop !== undefined
            }),
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                top: this.props.stickyTop !== undefined ? `0px` : undefined
            },
            contentEditable: false,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("button", {
                    "aria-label": formatMessage((0, $2CQVV.messages).cornerControl),
                    type: "button",
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, {
                        danger: isActive && isInDanger
                    }),
                    onClick: this.selectTable,
                    onMouseOver: this.hoverTable,
                    onMouseOut: this.clearHoverSelection,
                    onFocus: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? this.hoverTable : undefined,
                    onBlur: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? this.clearHoverSelection : undefined
                }),
                !isHeaderRowEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS_INSERT_ROW_MARKER,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_MARKER
                    })
                }),
                !isHeaderColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS_INSERT_COLUMN_MARKER,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_MARKER
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.isActive = ()=>{
            const { editorView: editorView, hoveredRows: hoveredRows, isResizing: isResizing } = this.props;
            const { selection: selection } = editorView.state;
            const table = (0, $id9O1.findTable)(selection);
            if (!table) return false;
            return (0, $iYC9s.isTableSelected)(selection) || hoveredRows && hoveredRows.length === (0, $LmqWp.TableMap).get(table.node).height && !isResizing;
        };
        this.clearHoverSelection = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        };
        this.selectTable = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            dispatch((0, $kEbNW.selectTable)(state.tr).setMeta('addToHistory', false));
        };
        this.hoverTable = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            (0, $7132c436572167eb$export$41c571b711ba06e)()(state, dispatch);
        };
    }
}
const $8c2dcccfe6a575f9$export$c4e380678531b264 = (0, $aXWIB.injectIntl)($8c2dcccfe6a575f9$var$CornerControlComponent);





















// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $2720990bf6054318$var$RowControlsComponent extends (0, $42omo.Component) {
    render() {
        const { editorView: editorView, tableRef: tableRef, hoveredRows: hoveredRows, isInDanger: isInDanger, isResizing: isResizing, intl: { formatMessage: formatMessage }, selection: selectionState } = this.props;
        if (!tableRef) return null;
        const { selection: selection } = editorView.state;
        const rowHeights = (0, $885c1a71dd6e181b$export$3e5149a60ac7416b)(tableRef);
        const rowsParams = (0, $885c1a71dd6e181b$export$b8127ab1acaa6d46)(rowHeights);
        const firstRow = tableRef.querySelector('tr');
        const hasHeaderRow = firstRow ? firstRow.getAttribute('data-header-row') : false;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS,
            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_INNER,
                children: rowsParams.map(({ startIndex: startIndex, endIndex: endIndex, height: height }, index)=>{
                    // if previous row was header row, add its height to our margin
                    let marginTop = -1;
                    if (index === 1 && hasHeaderRow && this.props.stickyTop !== undefined) marginTop += rowHeights[index - 1] + (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b);
                    const thisRowSticky = this.props.stickyTop !== undefined && index === 0 && hasHeaderRow;
                    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: `${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP} ${(0, $885c1a71dd6e181b$export$8969ab96fc5961ae)(startIndex, selectionState || selection, hoveredRows, isInDanger, isResizing)} ${thisRowSticky ? 'sticky' : ''}`,
                        style: {
                            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                            height: height,
                            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                            marginTop: `${marginTop}px`,
                            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                            top: thisRowSticky ? `3px` : undefined,
                            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            paddingTop: thisRowSticky ? // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                            `${(0, $fbbb9ee8877c285e$export$880976487022eb5) - 2}px` : undefined
                        },
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)("button", {
                                "aria-label": formatMessage((0, $2CQVV.messages).rowControl),
                                type: "button",
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: `${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON} ${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON}`,
                                onClick: (event)=>this.props.selectRow(startIndex, event.shiftKey),
                                onMouseOver: ()=>this.props.hoverRows([
                                        startIndex
                                    ]),
                                onFocus: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? ()=>this.props.hoverRows([
                                        startIndex
                                    ]) : undefined,
                                onMouseOut: this.clearHoverSelection,
                                onBlur: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? this.clearHoverSelection : undefined,
                                "data-start-index": startIndex,
                                "data-end-index": endIndex
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_MARKER
                            })
                        ]
                    }, startIndex);
                })
            })
        }));
    }
    constructor(...args){
        super(...args);
        this.clearHoverSelection = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        };
    }
}
const $2720990bf6054318$export$bd67b796ee9987b2 = (0, $aXWIB.injectIntl)($2720990bf6054318$var$RowControlsComponent);


const $a72f571dbc5509cd$export$4017f69d73e46bd1 = ({ editorView: editorView, tableRef: tableRef, isInDanger: isInDanger, isResizing: isResizing, isHeaderRowEnabled: isHeaderRowEnabled, isHeaderColumnEnabled: isHeaderColumnEnabled, hoveredRows: hoveredRows, stickyTop: stickyTop, hoverRows: hoverRows, selectRow: selectRow, tableActive: tableActive, api: api })=>{
    const { selection: selection } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>({
            selection: states.selectionState?.selection
        }));
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $8c2dcccfe6a575f9$export$c4e380678531b264), {
                editorView: editorView,
                tableRef: tableRef,
                isInDanger: isInDanger,
                isResizing: isResizing,
                isHeaderRowEnabled: isHeaderRowEnabled,
                isHeaderColumnEnabled: isHeaderColumnEnabled,
                hoveredRows: hoveredRows,
                stickyTop: tableActive ? stickyTop : undefined
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $2720990bf6054318$export$bd67b796ee9987b2), {
                selection: selection,
                editorView: editorView,
                tableRef: tableRef,
                hoverRows: hoverRows,
                hoveredRows: hoveredRows,
                isInDanger: isInDanger,
                isResizing: isResizing,
                selectRow: selectRow,
                stickyTop: tableActive ? stickyTop : undefined
            })
        ]
    });
};












var $eTj7Y = parcelRequire("eTj7Y");














class $b09bdd4510c4ed50$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { tableRef: tableRef, hasHeaderRow: hasHeaderRow, isDragAndDropEnabled: isDragAndDropEnabled, tableActive: tableActive, updateCellHoverLocation: updateCellHoverLocation } = this.props;
        const rowHeights = (0, $885c1a71dd6e181b$export$3e5149a60ac7416b)(tableRef);
        if ((0, $eTj7Y.isSSR)()) return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN,
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: hasHeaderRow && this.props.stickyTop !== undefined ? rowHeights[0] : undefined,
                borderLeft: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                isDragAndDropEnabled && tableActive ? `1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794}` : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                visibility: 'hidden' // Ensure the column is not visible during SSR
            },
            contentEditable: false
        });
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN,
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: hasHeaderRow && this.props.stickyTop !== undefined ? rowHeights[0] : undefined,
                borderLeft: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                isDragAndDropEnabled && tableActive ? `1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794}` : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                visibility: 'visible'
            },
            contentEditable: false,
            children: rowHeights.map((rowHeight, index)=>isDragAndDropEnabled ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: this.getClassNames(index, true),
                    "data-index": index,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: this.getCellStyles(index, rowHeight),
                    onFocus: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? ()=>updateCellHoverLocation(index) : undefined,
                    onMouseOver: ()=>updateCellHoverLocation(index),
                    children: hasHeaderRow ? index > 0 ? index : null : index + 1
                }, `wrapper-${index}`) : /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // Ignored via go/ees005
                    role: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? 'button' : undefined,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: this.getClassNames(index),
                    "data-index": index,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: this.getCellStyles(index, rowHeight),
                    onClick: (event)=>this.selectRow(index, event),
                    onFocus: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? ()=>this.hoverRows(index) : undefined,
                    onMouseOver: ()=>this.hoverRows(index),
                    tabIndex: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? 0 : undefined,
                    onKeyDown: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? (event)=>{
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            this.selectRow(index, event);
                        }
                    } : undefined,
                    onMouseOut: this.clearHoverSelection,
                    onBlur: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? this.clearHoverSelection : undefined,
                    children: hasHeaderRow ? index > 0 ? index : null : index + 1
                }, `wrapper-${index}`))
        });
    }
    constructor(...args){
        super(...args);
        this.hoverRows = (index)=>{
            return this.props.tableActive ? this.props.hoverRows([
                index
            ]) : null;
        };
        this.selectRow = (index, event)=>{
            const { tableActive: tableActive, editorView: editorView, selectRow: selectRow } = this.props;
            // If selection is outside the table then first reset the selection inside table
            if (!tableActive && event.target && event.target instanceof Node) {
                const { doc: doc, selection: selection, tr: tr } = editorView.state;
                const pos = editorView.posAtDOM(event.target, 1);
                const $pos = doc.resolve(pos);
                const newPos = selection.head > pos ? // Selection is after table
                // nodeSize - 3 will move the position inside last table cell
                (0, $ks2lK.Selection).near(doc.resolve(pos + ($pos.parent.nodeSize - 3)), -1) : // Selection is before table
                (0, $ks2lK.Selection).near($pos);
                editorView.dispatch(tr.setSelection(newPos));
            }
            selectRow(index, event.shiftKey);
        };
        this.clearHoverSelection = ()=>{
            const { tableActive: tableActive, editorView: editorView } = this.props;
            if (tableActive) {
                const { state: state, dispatch: dispatch } = editorView;
                (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
            }
        };
        this.getCellStyles = (index, rowHeight)=>{
            const { stickyTop: stickyTop, hasHeaderRow: hasHeaderRow } = this.props;
            if (stickyTop && hasHeaderRow && index === 0) {
                const topOffset = 0;
                return {
                    height: rowHeight,
                    top: `${topOffset}px`
                };
            }
            return {
                height: rowHeight
            };
        };
        this.getClassNames = (index, isButtonDisabled = false)=>{
            const { hoveredRows: hoveredRows, editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, tableActive: tableActive } = this.props;
            const isActive = (0, $iYC9s.isRowSelected)(index)(editorView.state.selection) || (hoveredRows || []).indexOf(index) !== -1 && !isResizing;
            return (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, {
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON_DISABLED]: isButtonDisabled,
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER]: tableActive && isActive && isInDanger,
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_ACTIVE]: tableActive && isActive
            });
        };
    }
}


/* eslint-disable @atlaskit/design-system/prefer-primitives */ 









































const $1ec0dafc4a18e7bb$var$RowDropTarget = ({ index: index, localId: localId, style: style })=>{
    const dropTargetRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!dropTargetRef.current) return;
        return (0, $4T4vf.dropTargetForElements)({
            element: dropTargetRef.current,
            canDrop ({ source: source, input: input }) {
                const data = source.data;
                const behaviour = (0, $af1654059f589843$export$b95259a1f587c41)(input);
                // A move drop is limited too where it can go, however a clone can drop can go anywhere.
                const isDropValid = behaviour === 'move' ? data.indexes?.indexOf(index) === -1 : behaviour === 'clone';
                return(// Only draggables of row type can be dropped on this target
                data.type === 'table-row' && // Only draggables which came from the same table can be dropped on this target
                data.localId === localId && // Only draggables which DO NOT include this drop targets index can be dropped
                !!data.indexes?.length && isDropValid);
            },
            getDropEffect: ({ input: input })=>(0, $af1654059f589843$export$b95259a1f587c41)(input) === 'clone' ? 'copy' : 'move',
            getIsSticky: ()=>true,
            getData ({ source: source, input: input, element: element }) {
                const data = {
                    localId: localId,
                    type: 'table-row',
                    targetIndex: index
                };
                const srcData = source.data;
                const behaviour = (0, $af1654059f589843$export$b95259a1f587c41)(input);
                // During a move op there's no point in allowing edges to be dropped on which result in no change/move to occur.
                const allowedEdges = behaviour === 'move' ? srcData.indexes?.reduce((acc, v)=>{
                    if (v - index === -1) acc.shift();
                    if (v - index === 1) acc.pop();
                    return acc;
                }, [
                    'top',
                    'bottom'
                ]) : [
                    'top',
                    'bottom'
                ];
                return (0, $2WHHL.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            }
        });
    }, [
        index,
        localId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: dropTargetRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-drop-target-index": index,
        "data-drop-target-localid": localId,
        "data-testid": "table-floating-row-controls-drop-target"
    });
};
var $1ec0dafc4a18e7bb$export$2e2bcd8739ae039 = $1ec0dafc4a18e7bb$var$RowDropTarget;


const $cfea739a66bdcdd3$var$getSelectedRows = (selection)=>{
    if (selection instanceof (0, $7XFGZ.CellSelection) && selection.isRowSelection()) {
        const rect = (0, $iP1et.getSelectionRect)(selection);
        if (!rect) return [];
        return (0, $cee807f94f070ba4$export$d023456f91fdf995)(rect);
    }
    return [];
};
const $cfea739a66bdcdd3$export$350d0cf1f91b53f4 = ({ tableRef: tableRef, tableNode: tableNode, tableWidth: tableWidth, hoveredCell: hoveredCell, tableActive: tableActive, editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, isTableHovered: isTableHovered, hoverRows: hoverRows, selectRow: selectRow, selectRows: selectRows, updateCellHoverLocation: updateCellHoverLocation, api: api, selection: selection })=>{
    const [isDragging, setIsDragging] = (0, $42omo.useState)(false);
    const rowHeights = (0, $885c1a71dd6e181b$export$3e5149a60ac7416b)(tableRef);
    const rowsParams = (0, $885c1a71dd6e181b$export$b8127ab1acaa6d46)(rowHeights);
    const heights = rowHeights.map((height)=>`${height - 1}px`).join(' ');
    const selectedRowIndexes = $cfea739a66bdcdd3$var$getSelectedRows(selection ?? editorView.state.selection);
    const currentNodeLocalId = tableNode?.attrs?.localId ?? '';
    (0, $42omo.useEffect)(()=>{
        return (0, $4T4vf.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, localId: localId, indexes: indexes } = source.data;
                if (!indexes || !localId || type !== 'table-row') return false;
                const { tableNode: tableNode } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
                // If the draggable localId is the same as the current selected table localId then we will allow the monitor
                // watch for changes
                return localId === tableNode?.attrs.localId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        editorView
    ]);
    const toggleDragMenuHandler = (0, $42omo.useCallback)((trigger, event)=>{
        if (event?.shiftKey) return;
        (0, $66674519b4a32446$export$ade80ff7f1fbb779)(api?.analytics?.actions)(undefined, 'row', hoveredCell?.rowIndex, trigger)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        hoveredCell?.rowIndex,
        api?.analytics?.actions
    ]);
    const rowIndex = hoveredCell?.rowIndex;
    const handleMouseOut = (0, $42omo.useCallback)(()=>{
        if (tableActive) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        }
    }, [
        editorView,
        tableActive
    ]);
    const handleMouseMove = (0, $42omo.useCallback)((e)=>{
        const target = e.nativeEvent.target instanceof Element ? e.nativeEvent.target : null;
        const isParentDragControls = target?.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS}`);
        const rowIndex = target?.getAttribute('data-start-index');
        // avoid updating if event target is not related
        if (!isParentDragControls || !rowIndex) return;
        updateCellHoverLocation(Number(rowIndex));
    }, [
        updateCellHoverLocation
    ]);
    const rowIndexes = (0, $42omo.useMemo)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return [
            rowIndex
        ];
    }, [
        rowIndex
    ]);
    const handleMouseOver = (0, $42omo.useCallback)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        hoverRows([
            rowIndex
        ]);
    }, [
        hoverRows,
        rowIndex
    ]);
    const handleClick = (0, $42omo.useCallback)((e)=>{
        const isClickOutsideSelectedRows = // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedRowIndexes.length >= 1 && !selectedRowIndexes.includes(rowIndex);
        if (!selectedRowIndexes || selectedRowIndexes.length === 0 || isClickOutsideSelectedRows) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectRow(rowIndex, e.shiftKey);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (selectedRowIndexes.length > 1 && selectedRowIndexes.includes(rowIndex) && !e.shiftKey) selectRows(selectedRowIndexes);
    }, [
        rowIndex,
        selectRow,
        selectRows,
        selectedRowIndexes
    ]);
    const generateHandleByType = (type, appearance, gridRow, indexes)=>{
        const isHover = type === 'hover';
        const previewHeight = rowHeights.reduce((sum, v, i)=>sum + v * (indexes.includes(i) ? 1 : 0), 0);
        return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                gridRow: gridRow,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridColumn: '2',
                // DragHandle uses `transform: rotate(90)`, which doesn't affect its parent (this div) causing the width of this element to be the true height of the drag handle
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '9px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                right: '-0.5px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                pointerEvents: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_DRAG_HANDLE : undefined,
            "data-testid": `table-floating-row-${isHover ? rowIndex : selectedRowIndexes[0]}-drag-handle`,
            "data-row-index": rowIndex,
            "data-selected-row-index": selectedRowIndexes[0],
            "data-handle-appearance": appearance,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7c8b405b164adf54$export$a0c24614540b0efb), {
                isDragMenuTarget: !isHover,
                direction: "row",
                tableLocalId: currentNodeLocalId,
                indexes: indexes,
                forceDefaultHandle: !isHover,
                previewWidth: tableWidth,
                previewHeight: previewHeight,
                appearance: appearance,
                hoveredCell: hoveredCell,
                onClick: handleClick,
                onMouseOver: handleMouseOver,
                onMouseOut: handleMouseOut,
                onBlur: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? handleMouseOut : undefined,
                onFocus: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? handleMouseOver : undefined,
                toggleDragMenu: toggleDragMenuHandler,
                editorView: editorView
            })
        }, type);
    };
    const rowHandles = ()=>{
        const handles = [];
        const isRowSelected = selectedRowIndexes.length > 0;
        const isEntireTableSelected = rowHeights.length > selectedRowIndexes.length;
        if (!tableActive) return null;
        // placeholder / selected need to always render at least one handle
        // so it can be focused via keyboard shortcuts
        handles.push(generateHandleByType('selected', isRowSelected && isEntireTableSelected ? isInDanger ? 'danger' : 'selected' : 'placeholder', `${selectedRowIndexes[0] + 1} / span ${selectedRowIndexes.length}`, selectedRowIndexes));
        if (hoveredCell && isTableHovered && rowIndex !== undefined && !selectedRowIndexes.includes(rowIndex) && rowIndex < rowHeights.length) handles.push(generateHandleByType('hover', 'default', `${rowIndex + 1} / span 1`, rowIndexes));
        return handles;
    };
    if (isResizing) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS,
        style: {
            gridTemplateRows: heights,
            gridTemplateColumns: isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8}px ${0, $fbbb9ee8877c285e$export$c2ef52861254b274}px ${tableWidth}px` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `0px ${0, $fbbb9ee8877c285e$export$c2ef52861254b274}px 0px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            left: isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `-${(0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8) + 2}px` : "var(--ds-space-negative-025, -2px)"
        },
        onMouseMove: handleMouseMove,
        contentEditable: false,
        children: [
            rowsParams.map(({ startIndex: startIndex, endIndex: endIndex }, index)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)("div", {
                            style: {
                                gridRow: `${index + 1} / span 1`,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                gridColumn: '2'
                            },
                            "data-start-index": startIndex,
                            "data-end-index": endIndex,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER,
                            contentEditable: false,
                            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT
                            })
                        }, `insert-dot-${index}`),
                        isDragging && /*#__PURE__*/ (0, $l998X.jsx)((0, $1ec0dafc4a18e7bb$export$2e2bcd8739ae039), {
                            index: index,
                            localId: currentNodeLocalId,
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                gridColumn: '1 / span 3',
                                gridRow: `${index + 1} / span 1`,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                pointerEvents: 'auto',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                position: 'relative',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                left: "var(--ds-space-negative-100, -8px)"
                            }
                        }, `drop-target-${index}`)
                    ]
                }, index)),
            rowHandles()
        ]
    });
};
const $cfea739a66bdcdd3$export$8bade456cc132de4 = ({ editorView: editorView, tableRef: tableRef, tableNode: tableNode, tableWidth: tableWidth, tableActive: tableActive, hoveredCell: hoveredCell, isInDanger: isInDanger, isTableHovered: isTableHovered, isResizing: isResizing, hoverRows: hoverRows, selectRow: selectRow, selectRows: selectRows, updateCellHoverLocation: updateCellHoverLocation, api: api })=>{
    const { selection: selection } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>({
            selection: states.selectionState?.selection
        }));
    return /*#__PURE__*/ (0, $l998X.jsx)($cfea739a66bdcdd3$export$350d0cf1f91b53f4, {
        editorView: editorView,
        tableRef: tableRef,
        tableNode: tableNode,
        tableWidth: tableWidth,
        tableActive: tableActive,
        hoveredCell: hoveredCell,
        isInDanger: isInDanger,
        isTableHovered: isTableHovered,
        isResizing: isResizing,
        hoverRows: hoverRows,
        selectRow: selectRow,
        selectRows: selectRows,
        updateCellHoverLocation: updateCellHoverLocation,
        api: api,
        selection: selection
    });
};


function $534ff361a414cc4b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $534ff361a414cc4b$var$styles = {
    name: "lr2r3w",
    styles: "&:has(~ .pm-table-wrapper-no-overflow){margin-top:0;}"
};
const $534ff361a414cc4b$export$1e425115e5c75aac = ({ editorView: editorView, tableRef: tableRef, tableNode: tableNode, isInDanger: isInDanger, isResizing: isResizing, isNumberColumnEnabled: isNumberColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, isHeaderColumnEnabled: isHeaderColumnEnabled, tableActive: tableActive, hasHeaderRow: hasHeaderRow, hoveredRows: hoveredRows, stickyHeader: stickyHeader, isDragAndDropEnabled: isDragAndDropEnabled, hoveredCell: hoveredCell, isTableHovered: isTableHovered, tableWrapperWidth: tableWrapperWidth, api: api, isChromelessEditor: isChromelessEditor })=>{
    const _selectRow = (0, $42omo.useCallback)((row, expand)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const browser = (0, $d7ZU3.getBrowserInfo)();
        if (browser.ie_version === 11) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorView.dom.blur();
        (0, $4ca83755c936c9c8$export$e247ed8cec4832f4)(row, expand)(state, dispatch);
    }, [
        editorView
    ]);
    const _selectRows = (0, $42omo.useCallback)((rowIndexes)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const browser = (0, $d7ZU3.getBrowserInfo)();
        if (browser.ie_version === 11) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorView.dom.blur();
        (0, $4ca83755c936c9c8$export$b5ba3b60192c7a8d)(rowIndexes)(state, dispatch);
    }, [
        editorView
    ]);
    const _hoverRows = (0, $42omo.useCallback)((rows, danger)=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $7132c436572167eb$export$ab63d99b591b89)(rows, danger)(state, dispatch);
    }, [
        editorView
    ]);
    // re-use across numbered columns and row controls
    const updateCellHoverLocation = (0, $42omo.useCallback)((rowIndex)=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (tableActive) // For context:  Whenever we mouse over a column or row drag handle, we will ALWAYS be hovering over the 0 index
        // of the opposite dimension. For example; here when we mouse over the row drag handle then we're technically
        // also hovering over column 0 index. And vice-versa with columns. This means we don't need to worry about knowing the
        // current column index. We can just force it to 0.
        (0, $7132c436572167eb$export$1d614a0f0fe37c44)(rowIndex, 0)(state, dispatch);
    }, [
        editorView,
        tableActive
    ]);
    if (!tableRef) return null;
    const stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
    const wrapperClassName = isDragAndDropEnabled ? isChromelessEditor ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER + ' ' + (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER;
    const tablePos = (0, $id9O1.findTable)(editorView.state.selection)?.pos;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const isNested = tablePos !== undefined && (0, $bdb0299b531c40df$export$d4302a800316ebd6)(editorView.state, tablePos);
    const shouldShowCornerControls = isNested && !(0, $dh538.fg)('platform_editor_nested_dnd_styles_changes');
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: wrapperClassName,
        css: [
            (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && !(0, $dh538.fg)('platform_editor_table_sticky_header_patch_7') && $534ff361a414cc4b$var$styles
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        role: "none",
        onMouseDown: (e)=>!isDragAndDropEnabled && e.preventDefault()
    }, isNumberColumnEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $b09bdd4510c4ed50$export$2e2bcd8739ae039), {
        editorView: editorView,
        hoverRows: _hoverRows,
        tableRef: tableRef,
        tableActive: tableActive,
        hoveredRows: hoveredRows,
        hasHeaderRow: hasHeaderRow,
        isInDanger: isInDanger,
        isResizing: isResizing,
        selectRow: _selectRow,
        updateCellHoverLocation: updateCellHoverLocation,
        stickyTop: stickyTop,
        isDragAndDropEnabled: isDragAndDropEnabled
    }) : null, tableActive && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), null, shouldShowCornerControls && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c3edf387a25033c9$export$2e06061cfdb64df2), {
        editorView: editorView,
        tableRef: tableRef,
        isInDanger: isInDanger,
        isResizing: isResizing,
        api: api
    }), /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cfea739a66bdcdd3$export$8bade456cc132de4), {
        tableRef: tableRef,
        tableNode: tableNode,
        hoveredCell: hoveredCell,
        isTableHovered: isTableHovered,
        editorView: editorView,
        tableActive: tableActive,
        isInDanger: isInDanger,
        isResizing: isResizing,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tableWidth: tableWrapperWidth,
        hoverRows: _hoverRows,
        selectRow: _selectRow,
        selectRows: _selectRows,
        updateCellHoverLocation: updateCellHoverLocation,
        api: api
    })) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a72f571dbc5509cd$export$4017f69d73e46bd1), {
        editorView: editorView,
        tableRef: tableRef,
        isInDanger: isInDanger,
        isResizing: isResizing,
        isHeaderRowEnabled: isHeaderRowEnabled,
        isHeaderColumnEnabled: isHeaderColumnEnabled,
        hoveredRows: hoveredRows,
        stickyTop: tableActive ? stickyTop : undefined,
        tableActive: tableActive,
        hoverRows: _hoverRows,
        selectRow: _selectRow,
        api: api
    }))));
};
var $534ff361a414cc4b$export$2e2bcd8739ae039 = $534ff361a414cc4b$export$1e425115e5c75aac;

















const $17073aeea32b894f$export$1041cb8214100cd2 = ({ editorView: editorView, node: node, getScrollOffset: getScrollOffset, getTableWrapperWidth: getTableWrapperWidth })=>{
    const [isDragging, setIsDragging] = (0, $42omo.useState)(false);
    const currentNodeLocalId = node?.attrs.localId;
    (0, $42omo.useEffect)(()=>{
        return (0, $4T4vf.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, indexes: indexes, localId: localId } = source.data;
                return type === 'table-column' && !!indexes?.length && localId === currentNodeLocalId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        currentNodeLocalId,
        editorView
    ]);
    if (!isDragging) return null;
    const colWidths = (0, $7eacb027e2e3fea2$export$79aef9e007571c)(editorView);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            width: getTableWrapperWidth(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            top: `-${(0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8) - (0, $1zav4.tableMarginTop)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            zIndex: `${(0, $fbbb9ee8877c285e$export$b2015400488f9243)}`
        },
        "data-testid": "table-floating-column-extended-drop-targets",
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // move drop targets based on table wrapper scroll
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginLeft: `-${getScrollOffset()}px`
            },
            children: colWidths?.map((width, index)=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $d471513cc0a7aea8$export$e8a325e09c5453d5), {
                    index: index,
                    localId: currentNodeLocalId,
                    width: width,
                    height: (0, $fbbb9ee8877c285e$export$6bec1f8a2aa82be8),
                    marginTop: 0
                }, index);
            })
        })
    });
};






























































var $6MTPr = parcelRequire("6MTPr");











var $hWRJP = parcelRequire("hWRJP");


var $8b5jG = parcelRequire("8b5jG");


var $b3YrF = parcelRequire("b3YrF");




























const $605f685ca1d87a0d$export$192a1a4af16beb38 = (lengths, hasFullWidthGuide = false)=>{
    return Array.from(new Set(lengths)).reduce((acc, length, index)=>{
        const h = length * 0.5;
        if (length === 0) return [
            ...acc,
            {
                left: 0,
                right: 0,
                length: length
            }
        ];
        if (!h || !Number.isFinite(length)) // Filter out nonsensical values, null, undefined, NaN, empty string
        return acc;
        return [
            ...acc,
            {
                left: -h,
                right: h,
                length: length,
                // Assumes the full width guide is always the last length in the array
                ...hasFullWidthGuide && index === lengths.length - 1 ? {
                    isFullWidth: true
                } : {}
            }
        ];
    }, []);
};
const $605f685ca1d87a0d$export$24448ad8894709b4 = (lengths, key = 'guide', hasFullWidthGuide = false)=>{
    return $605f685ca1d87a0d$export$192a1a4af16beb38(lengths, hasFullWidthGuide).reduce((acc, { left: left, right: right, length: length, isFullWidth: isFullWidth })=>{
        if (length === 0) return [
            ...acc,
            {
                key: `${key}-${length}-centre`,
                position: {
                    x: left
                }
            }
        ];
        else return [
            ...acc,
            {
                key: `${key}-${length}-left`,
                position: {
                    x: left
                }
            },
            {
                key: `${key}-${length}-right`,
                position: {
                    x: right
                },
                ...isFullWidth ? {
                    isFullWidth: true
                } : {}
            }
        ];
    }, []);
};



var $4HPW1 = parcelRequire("4HPW1");










const $94176587bf937630$var$numberOfLanesInDefaultLayoutWidth = 12;
const $94176587bf937630$var$calculateSubSnappingWidths = (totalLanes, totalWidth)=>new Array(Math.round(totalLanes / 2) - 1).fill(totalWidth / totalLanes).map((v, i)=>v * (i + 1) * 2);
const $94176587bf937630$export$c4ddb11be0806484 = (lengthOffset = 0)=>[
        ...$94176587bf937630$var$calculateSubSnappingWidths($94176587bf937630$var$numberOfLanesInDefaultLayoutWidth, (0, $aFUXX.akEditorDefaultLayoutWidth) + lengthOffset),
        (0, $aFUXX.akEditorDefaultLayoutWidth) + lengthOffset,
        (0, $aFUXX.akEditorCalculatedWideLayoutWidth) + lengthOffset,
        (0, $aFUXX.akEditorFullWidthLayoutWidth) + lengthOffset
    ];
const $94176587bf937630$var$getPadding = (editorContainerWidth)=>{
    return editorContainerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
};
const $94176587bf937630$export$7542cd96381664c2 = (lengthOffset = 0, editorContainerWidth = (0, $aFUXX.akEditorFullWidthLayoutWidth), exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const padding = $94176587bf937630$var$getPadding(editorContainerWidth);
    const dynamicFullWidthLine = editorContainerWidth - padding * 2 >= (0, $aFUXX.akEditorFullWidthLayoutWidth) ? (0, $aFUXX.akEditorFullWidthLayoutWidth) : editorContainerWidth - padding * 2;
    const dynamicMaxWidthLine = editorContainerWidth - padding * 2 >= (0, $aFUXX.akEditorMaxWidthLayoutWidth) ? (0, $aFUXX.akEditorMaxWidthLayoutWidth) : editorContainerWidth - padding * 2;
    const guides = [
        dynamicFullWidthLine - lengthOffset
    ];
    if ((0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) guides.push(dynamicMaxWidthLine - lengthOffset);
    if (!exclude.breakoutPoints) guides.unshift((0, $aFUXX.akEditorDefaultLayoutWidth) + lengthOffset, (0, $aFUXX.akEditorCalculatedWideLayoutWidth) + lengthOffset);
    if (!exclude.innerGuidelines) guides.unshift(0, ...$94176587bf937630$var$calculateSubSnappingWidths($94176587bf937630$var$numberOfLanesInDefaultLayoutWidth, (0, $aFUXX.akEditorDefaultLayoutWidth) + lengthOffset));
    return guides;
};
const $94176587bf937630$export$c5e672719c546336 = $94176587bf937630$export$c4ddb11be0806484();
const $94176587bf937630$export$b2f61428a1609695 = 0;
const $94176587bf937630$export$461c50a158de0369 = (lengthOffset, editorContainerWidth, exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const padding = $94176587bf937630$var$getPadding(editorContainerWidth);
    return editorContainerWidth - padding * 2 > (0, $aFUXX.akEditorFullWidthLayoutWidth) ? $94176587bf937630$export$c4ddb11be0806484() : $94176587bf937630$export$7542cd96381664c2(lengthOffset, editorContainerWidth, exclude); // lengthOffset was hardcoded 0 here, created PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET instead.
};
const $94176587bf937630$export$5ea7b9558ea477a = (currentWidth, snapWidths, guidelines, snapGap = 0, tolerance = 0)=>{
    const closestGapIndex = snapWidths.reduce((prev, curr, index)=>Math.abs(curr - currentWidth) < Math.abs(snapWidths[prev] - currentWidth) ? index : prev, 0);
    const gap = Math.abs(snapWidths[closestGapIndex] - currentWidth);
    if (gap < snapGap) {
        const snappingWidth = Math.round(snapWidths[closestGapIndex]);
        const guidelineKeys = guidelines.reduce((acc, guideline)=>{
            // NOTE: The snap points are based on the guidelines, however their formatted as a length value whereas the guidelines
            // are point based. The point base x coords are calculated by halving the lengths. This means we can convert the
            // point base position to length by simply multiplying by 2.
            const length = Math.round(Math.abs((0, $4HPW1.isVerticalPosition)(guideline.position) ? guideline.position.x : guideline.position.y) * 2);
            if (snappingWidth >= length - tolerance && snappingWidth <= length + tolerance) acc.push(guideline.key);
            return acc;
        }, []);
        return {
            gap: gap,
            keys: guidelineKeys
        };
    }
    return {
        gap: gap,
        keys: []
    };
};


const $386bd6c12e70d174$export$71ea7e0a71c6d202 = (0, $605f685ca1d87a0d$export$24448ad8894709b4)([
    0,
    ...(0, $94176587bf937630$export$c4ddb11be0806484)(-1)
]);
const $386bd6c12e70d174$export$d25f7f8989bf9598 = -1;
const $386bd6c12e70d174$export$be2db36e9da53e09 = (lengthOffset, editorContainerWidth, exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const lengths = (0, $94176587bf937630$export$7542cd96381664c2)(lengthOffset, editorContainerWidth, exclude);
    return (0, $605f685ca1d87a0d$export$24448ad8894709b4)(lengths, undefined, true);
};




const $cfef72949acb5fed$var$RESIZE_STEP_VALUE = 10;
const $cfef72949acb5fed$var$handles = {
    right: true
};
const $cfef72949acb5fed$var$handleStyles = {
    right: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        right: '-14px',
        marginTop: "var(--ds-space-150, 12px)"
    }
};
const $cfef72949acb5fed$var$getResizerHandleHeight = (tableRef)=>{
    const tableHeight = tableRef?.clientHeight ?? 0;
    /*
  - One row table height (minimum possible table height) ~ 45px
  - Two row table height ~ 90px
  - Three row table height ~ 134px
  	In the if below we need to use:
  - > 46 because the height of the table can be a float number like 45.44.
  - < 96 is the height of large resize handle.
   */ if (tableHeight >= 96) return 'large';
    if (tableHeight > 46) return 'medium';
    return 'small';
};
const $cfef72949acb5fed$var$getResizerMinWidth = (node)=>{
    const currentColumnCount = (0, $d7e0ca7a06057b05$export$dc24345db4290451)(node);
    const minColumnWidth = Math.min(3, currentColumnCount) * (0, $8588522c22c049a0$export$dd66abdcfb4bb2cf);
    // add an extra pixel as the scale table logic will scale columns to be tableContainerWidth - 1
    // the table can't scale past its min-width, so instead restrict table container min width to avoid that situation
    return minColumnWidth + 1;
};
const $cfef72949acb5fed$var$getPadding = (containerWidth)=>{
    return containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
};
const $cfef72949acb5fed$var$getTableMaxWidth = (containerWidth, lineLength, isCommentEditor, isChromelessEditor)=>{
    if (isCommentEditor) return Math.floor(containerWidth - (0, $8588522c22c049a0$export$c332ba2dd5aa2199));
    else if (isChromelessEditor) return Number.isFinite(lineLength) && lineLength !== undefined ? lineLength : Math.floor(containerWidth - (0, $8588522c22c049a0$export$a823f6a7493b3d06));
    else return (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916);
};
/**
 * When guidelines are outside the viewport, filter them out, do not show
 * So the guideline container won't make the fabric-editor-popup-scroll-parent overflow
 * @param guidelines
 * @param containerWidth editorWidth
 * @param lineLength
 * @param isTableScalingEnabled
 * @param isFullWidthModeEnabled
 */ const $cfef72949acb5fed$var$getVisibleGuidelines = (guidelines, containerWidth, lineLength, isTableScalingEnabled, isFullWidthModeEnabled)=>{
    let guidelineVisibleAdjustment = (0, $fbbb9ee8877c285e$export$858d012f03ae70a5);
    if (isTableScalingEnabled) {
        // Notes:
        // Example: containerWidth = 1244, lineLength = 1180 (used for when editor full width mode is enabled)
        // Full width/dynamic x coordinate can be float number.
        // Ex: guideline.position.x can be 590.5. So 590.5 * 2 = 1181 (not 1180).
        // For PTW we need to ensure that dynamic guideline never gets excluded: 1181 should be > width + guidelineVisibleAdjustment
        // guidelineVisibleAdjustment is set as a negative value, so we making it positive and adding + 1
        const preserve_table_widths_adjustment = -1 * (0, $386bd6c12e70d174$export$d25f7f8989bf9598) + 1;
        const padding = $cfef72949acb5fed$var$getPadding(containerWidth);
        guidelineVisibleAdjustment = isFullWidthModeEnabled ? preserve_table_widths_adjustment // guidelineVisibleAdjustment = -2, if lineLength = 1180, 1181 < 1180 + 2 is true.
         : -2 * padding + preserve_table_widths_adjustment; // guidelineVisibleAdjustment = -62, if containerWidth is 1244, 1181 < 1244 - 62 = 1182 is true.
    }
    const width = isTableScalingEnabled && isFullWidthModeEnabled ? lineLength : containerWidth;
    return guidelines.filter((guideline)=>{
        return guideline.position && guideline.position.x !== undefined && typeof guideline.position.x === 'number' && Math.abs(guideline.position.x * 2) < width + guidelineVisibleAdjustment;
    });
};
const $cfef72949acb5fed$var$selector = (states)=>({
        widthToWidest: states.tableState?.widthToWidest
    });
const $cfef72949acb5fed$export$65233f8d64070eeb = ({ children: children, width: width, maxWidth: maxWidth, containerWidth: containerWidth, lineLength: lineLength, updateWidth: updateWidth, onResizeStop: onResizeStop, onResizeStart: onResizeStart, editorView: editorView, getPos: getPos, node: node, tableRef: tableRef, displayGuideline: displayGuideline, attachAnalyticsEvent: attachAnalyticsEvent, displayGapCursor: displayGapCursor, isTableScalingEnabled: isTableScalingEnabled, allowFixedColumnWidthOption: allowFixedColumnWidthOption, isTableAlignmentEnabled: isTableAlignmentEnabled, isWholeTableInDanger: isWholeTableInDanger, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, pluginInjectionApi: pluginInjectionApi, isFullWidthModeEnabled: isFullWidthModeEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor, disabled: disabled })=>{
    const currentGap = (0, $42omo.useRef)(0);
    // track resizing state - use ref over state to avoid re-render
    const isResizing = (0, $42omo.useRef)(false);
    const areResizeMetaKeysPressed = (0, $42omo.useRef)(false);
    const resizerRef = (0, $42omo.useRef)(null);
    const interactionState = (0, $b3YrF.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    const { widthToWidest: widthToWidest } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'table'
    ], $cfef72949acb5fed$var$selector);
    // used to reposition tooltip when table is resizing via keyboard
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const [snappingEnabled, setSnappingEnabled] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
    const currentSelection = editorView.state?.selection;
    const tableFromSelection = (0, $42omo.useMemo)(()=>{
        return (0, $id9O1.findTable)(currentSelection);
    }, [
        currentSelection
    ]);
    const tableFromSelectionPosition = tableFromSelection?.pos;
    const isTableSelected = (0, $42omo.useMemo)(()=>{
        // Avoid call getPos if there is no table in the current selection,
        if (typeof tableFromSelectionPosition !== 'number') return false;
        if (interactionState === 'hasNotHadInteraction') return false;
        let currentNodePosition;
        try {
            // The React Table and the ProseMirror can endup out-of-sync
            // ProseMirror always assume the DOM is not managed by other framework
            currentNodePosition = getPos();
        } catch (e) {
            (0, $hWRJP.logException)(e, {
                location: 'editor-plugin-table/table-resizer'
            });
            return false;
        }
        return tableFromSelectionPosition === currentNodePosition;
    }, [
        tableFromSelectionPosition,
        interactionState,
        getPos
    ]);
    const resizerMinWidth = $cfef72949acb5fed$var$getResizerMinWidth(node);
    const handleSize = $cfef72949acb5fed$var$getResizerHandleHeight(tableRef);
    const { startMeasure: startMeasure, endMeasure: endMeasure, countFrames: countFrames } = (0, $d406f1b0c5d56902$export$9642a56c1e8805cc)();
    const excludeGuidelineConfig = (0, $42omo.useMemo)(()=>({
            innerGuidelines: !!isTableAlignmentEnabled,
            breakoutPoints: !!(isTableAlignmentEnabled && isFullWidthModeEnabled)
        }), [
        isFullWidthModeEnabled,
        isTableAlignmentEnabled
    ]);
    const updateActiveGuidelines = (0, $42omo.useCallback)(({ gap: gap, keys: keys })=>{
        if (gap !== currentGap.current) {
            currentGap.current = gap;
            const visibleGuidelines = $cfef72949acb5fed$var$getVisibleGuidelines(isTableScalingEnabled ? (0, $386bd6c12e70d174$export$be2db36e9da53e09)((0, $386bd6c12e70d174$export$d25f7f8989bf9598), isFullWidthModeEnabled ? lineLength + 2 * $cfef72949acb5fed$var$getPadding(containerWidth) : containerWidth, excludeGuidelineConfig) : (0, $386bd6c12e70d174$export$71ea7e0a71c6d202), containerWidth, lineLength, Boolean(isTableScalingEnabled), Boolean(isFullWidthModeEnabled));
            displayGuideline((0, $6MTPr.getGuidelinesWithHighlights)(gap, (0, $fbbb9ee8877c285e$export$8f6133b6e2b4291), keys, visibleGuidelines));
        }
    }, [
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        displayGuideline,
        lineLength,
        isFullWidthModeEnabled
    ]);
    const guidelineSnaps = (0, $42omo.useMemo)(()=>snappingEnabled ? {
            x: isTableScalingEnabled ? (0, $94176587bf937630$export$461c50a158de0369)((0, $94176587bf937630$export$b2f61428a1609695), // was hardcoded to 0, using PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET instead.
            isFullWidthModeEnabled ? lineLength + 2 * $cfef72949acb5fed$var$getPadding(containerWidth) : containerWidth, excludeGuidelineConfig) : (0, $94176587bf937630$export$c5e672719c546336)
        } : undefined, [
        snappingEnabled,
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        lineLength,
        isFullWidthModeEnabled
    ]);
    const switchToCenterAlignment = (0, $42omo.useCallback)((pos, node, newWidth, state, dispatch)=>{
        if ((0, $8b84c930bc26bcf8$export$8dcb9bda5f25db3a)(isTableAlignmentEnabled, node, lineLength, newWidth) && isResizing.current) {
            const tableNodeWithPos = {
                pos: pos,
                node: node
            };
            (0, $d9aad08b0e0e65bb$export$58691b745e97f79d)(pluginInjectionApi?.analytics?.actions)((0, $8b84c930bc26bcf8$export$3ea9e188ab01c845), (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2), tableNodeWithPos, (0, $d925B.INPUT_METHOD).AUTO, (0, $3824I.CHANGE_ALIGNMENT_REASON).EDITOR_APPEARANCE_CHANGED)(state, dispatch);
            return true;
        }
        return false;
    }, [
        isTableAlignmentEnabled,
        lineLength,
        pluginInjectionApi?.analytics?.actions
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            // only bring back the cursor if this table was deleted - i.e. if a user was resizing, then another
            // deleted this table
            if (isResizing.current) {
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                displayGapCursor(true);
                displayGuideline([]);
                tr.setMeta((0, $e9b9e23609860f66$export$18d4026d1ea86bb1), {
                    resizing: false,
                    tableLocalId: '',
                    tableRef: null
                });
                dispatch(tr);
            }
        };
    }, [
        editorView,
        displayGuideline,
        displayGapCursor
    ]);
    const handleResizeStart = (0, $42omo.useCallback)(()=>{
        if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.startFeature('tableResize');
        startMeasure();
        isResizing.current = true;
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        displayGapCursor(false);
        tr.setMeta((0, $e9b9e23609860f66$export$18d4026d1ea86bb1), {
            resizing: true,
            tableLocalId: node.attrs.localId,
            tableRef: tableRef
        });
        tr.setMeta('is-resizer-resizing', true);
        tr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
            name: (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED
        });
        pluginInjectionApi?.userIntent?.commands.setCurrentUserIntent('resizing')({
            tr: tr
        });
        dispatch(tr);
        const visibleGuidelines = $cfef72949acb5fed$var$getVisibleGuidelines(isTableScalingEnabled ? (0, $386bd6c12e70d174$export$be2db36e9da53e09)((0, $386bd6c12e70d174$export$d25f7f8989bf9598), isFullWidthModeEnabled ? lineLength + 2 * $cfef72949acb5fed$var$getPadding(containerWidth) : containerWidth, excludeGuidelineConfig) : (0, $386bd6c12e70d174$export$71ea7e0a71c6d202), containerWidth, lineLength, Boolean(isTableScalingEnabled), Boolean(isFullWidthModeEnabled));
        setSnappingEnabled(displayGuideline(visibleGuidelines));
        if (onResizeStart) onResizeStart();
    }, [
        startMeasure,
        editorView,
        displayGapCursor,
        node.attrs.localId,
        tableRef,
        isTableScalingEnabled,
        isFullWidthModeEnabled,
        lineLength,
        containerWidth,
        excludeGuidelineConfig,
        displayGuideline,
        onResizeStart,
        pluginInjectionApi?.userIntent?.commands
    ]);
    const handleResize = (0, $42omo.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (originalState, delta)=>{
        countFrames();
        const newWidth = originalState.width + delta.width;
        let pos;
        try {
            pos = getPos();
        } catch  {
            return;
        }
        if (typeof pos !== 'number') return;
        const editorContainerWidth = isFullWidthModeEnabled ? lineLength + 2 * $cfef72949acb5fed$var$getPadding(containerWidth) : containerWidth;
        const closestSnap = // remove isCommentEditor check if platform_editor_table_resize_chromeless is cleaned up
        (((0, $1oCLl.expValEquals)('platform_editor_table_resize_chromeless', 'isEnabled', true) || (0, $1oCLl.expValEquals)('create_work_item_modernization_exp', 'isEnabled', true)) && isFullPageAppearance || !isCommentEditor) && (0, $94176587bf937630$export$5ea7b9558ea477a)(newWidth, isTableScalingEnabled ? (0, $94176587bf937630$export$461c50a158de0369)((0, $94176587bf937630$export$b2f61428a1609695), editorContainerWidth, excludeGuidelineConfig) : (0, $94176587bf937630$export$c5e672719c546336), isTableScalingEnabled ? (0, $386bd6c12e70d174$export$be2db36e9da53e09)((0, $386bd6c12e70d174$export$d25f7f8989bf9598), editorContainerWidth, excludeGuidelineConfig) : (0, $386bd6c12e70d174$export$71ea7e0a71c6d202), (0, $fbbb9ee8877c285e$export$edb1b9caf8ff5b32), (0, $fbbb9ee8877c285e$export$7af5c65e392a647));
        closestSnap && updateActiveGuidelines(closestSnap);
        // When snapping to the full width guideline, resize the table to be 1800px
        const { state: state, dispatch: dispatch } = editorView;
        const currentTableNodeLocalId = node?.attrs?.localId ?? '';
        const fullWidthGuideline = (0, $386bd6c12e70d174$export$be2db36e9da53e09)((0, $386bd6c12e70d174$export$d25f7f8989bf9598), editorContainerWidth, excludeGuidelineConfig).filter((guideline)=>guideline.isFullWidth)[0];
        const isFullWidthGuidelineActive = (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? closestSnap && fullWidthGuideline && closestSnap.keys.includes(fullWidthGuideline.key) : closestSnap && closestSnap.keys.includes(fullWidthGuideline.key);
        const tableMaxWidth = (0, $1oCLl.expValEquals)('platform_editor_table_resize_chromeless', 'isEnabled', true) || (0, $1oCLl.expValEquals)('create_work_item_modernization_exp', 'isEnabled', true) ? $cfef72949acb5fed$var$getTableMaxWidth(containerWidth, lineLength, isCommentEditor, isChromelessEditor) : isCommentEditor ? Math.floor(containerWidth - (0, $8588522c22c049a0$export$c332ba2dd5aa2199)) : (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916);
        const shouldUpdateWidthToWidest = ((0, $1oCLl.expValEquals)('platform_editor_table_resize_chromeless', 'isEnabled', true) || (0, $1oCLl.expValEquals)('create_work_item_modernization_exp', 'isEnabled', true)) && !isFullPageAppearance || isCommentEditor ? tableMaxWidth <= newWidth : !!isTableScalingEnabled && isFullWidthGuidelineActive;
        const previewParentWidth = (((0, $1oCLl.expValEquals)('platform_editor_table_resize_chromeless', 'isEnabled', true) || (0, $1oCLl.expValEquals)('create_work_item_modernization_exp', 'isEnabled', true)) && !isFullPageAppearance || isCommentEditor) && shouldUpdateWidthToWidest ? tableMaxWidth : newWidth;
        (0, $0e5c6cf05dff4e80$export$2d57109fc9066ba2)(tableRef, {
            node: node,
            prevNode: node,
            start: pos + 1,
            parentWidth: previewParentWidth
        }, editorView.domAtPos.bind(editorView), isTableScalingEnabled, allowFixedColumnWidthOption, (0, $1oCLl.expValEquals)('platform_editor_table_resize_chromeless', 'isEnabled', true) || (0, $1oCLl.expValEquals)('create_work_item_modernization_exp', 'isEnabled', true) ? !isFullPageAppearance : isCommentEditor);
        (0, $astHL.chainCommands)((state, dispatch)=>{
            return switchToCenterAlignment(pos, node, newWidth, state, dispatch);
        }, (0, $4ca83755c936c9c8$export$833849b68219cbcc)({
            [currentTableNodeLocalId]: shouldUpdateWidthToWidest
        }))(state, dispatch);
        updateWidth(shouldUpdateWidthToWidest ? tableMaxWidth : newWidth);
        return newWidth;
    }, [
        countFrames,
        isCommentEditor,
        isChromelessEditor,
        isFullPageAppearance,
        isTableScalingEnabled,
        allowFixedColumnWidthOption,
        isFullWidthModeEnabled,
        excludeGuidelineConfig,
        tableRef,
        node,
        editorView,
        updateActiveGuidelines,
        containerWidth,
        lineLength,
        updateWidth,
        getPos,
        switchToCenterAlignment
    ]);
    const scheduleResize = (0, $42omo.useMemo)(()=>(0, $2P8Ax.default)(handleResize), [
        handleResize
    ]);
    const handleResizeStop = (0, $42omo.useCallback)((originalState, delta)=>{
        isResizing.current = false;
        let newWidth = originalState.width + delta.width;
        const originalNewWidth = newWidth;
        const { state: state, dispatch: dispatch } = editorView;
        const pos = getPos();
        const currentTableNodeLocalId = node?.attrs?.localId ?? '';
        const tableMaxWidth = ((0, $1oCLl.expValEquals)('platform_editor_table_resize_chromeless', 'isEnabled', true) || (0, $1oCLl.expValEquals)('create_work_item_modernization_exp', 'isEnabled', true)) && !isFullPageAppearance || isCommentEditor ? undefined // Table's full-width in comment appearance inherit the width of the Editor/Renderer
         : (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916);
        newWidth = widthToWidest && currentTableNodeLocalId && widthToWidest[currentTableNodeLocalId] ? tableMaxWidth : newWidth;
        let tr = state.tr.setMeta((0, $e9b9e23609860f66$export$18d4026d1ea86bb1), {
            resizing: false,
            tableLocalId: '',
            tableRef: null
        });
        tr.setMeta('is-resizer-resizing', false);
        pluginInjectionApi?.userIntent?.commands.setCurrentUserIntent('default')({
            tr: tr
        });
        const frameRateSamples = endMeasure();
        if (frameRateSamples.length > 0) {
            const resizeFrameRatePayloads = (0, $d406f1b0c5d56902$export$29574a7e6ffc8eb4)({
                docSize: state.doc.nodeSize,
                frameRateSamples: frameRateSamples,
                originalNode: node
            });
            resizeFrameRatePayloads.forEach((payload)=>{
                attachAnalyticsEvent(payload)?.(tr);
            });
        }
        if (typeof pos === 'number') {
            tr = tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                width: newWidth,
                layout: node.attrs.layout !== (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2) && node.attrs.layout !== (0, $8b84c930bc26bcf8$export$3ea9e188ab01c845) ? (0, $8b84c930bc26bcf8$export$3ea9e188ab01c845) : node.attrs.layout
            });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const newNode = tr.doc.nodeAt(pos);
            tr = (0, $0e5c6cf05dff4e80$export$edcf1a404e75ce35)(tableRef, {
                node: newNode,
                prevNode: node,
                start: pos + 1,
                // We use originalNewWidth in comment editor, because in comment editor
                // newWidth can be underined when table is resized to 'full-width'
                // scaleTable function needs number value to work correctly.
                // remove isCommentEditor check when platform_editor_table_resize_chromeless is removed
                parentWidth: ((0, $1oCLl.expValEquals)('platform_editor_table_resize_chromeless', 'isEnabled', true) || (0, $1oCLl.expValEquals)('create_work_item_modernization_exp', 'isEnabled', true)) && !isFullPageAppearance || isCommentEditor ? originalNewWidth : newWidth
            }, editorView.domAtPos.bind(editorView), pluginInjectionApi, isTableScalingEnabled, shouldUseIncreasedScalingPercent || false, (0, $1oCLl.expValEquals)('platform_editor_table_resize_chromeless', 'isEnabled', true) || (0, $1oCLl.expValEquals)('create_work_item_modernization_exp', 'isEnabled', true) ? !isFullPageAppearance : isCommentEditor)(tr);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const scaledNode = tr.doc.nodeAt(pos);
            attachAnalyticsEvent((0, $d406f1b0c5d56902$export$a12b1eaff522a2d1)({
                originalNode: node,
                resizedNode: scaledNode
            }))?.(tr);
        }
        displayGapCursor(true);
        dispatch(tr);
        if (delta.width < 0 && newWidth !== undefined) pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify(formatMessage((0, $2CQVV.messages).tableSizeDecreaseScreenReaderInformation, {
            newWidth: newWidth
        }));
        else if (delta.width > 0 && newWidth !== undefined) pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify(formatMessage((0, $2CQVV.messages).tableSizeIncreaseScreenReaderInformation, {
            newWidth: newWidth
        }));
        // Hide guidelines when resizing stops
        displayGuideline([]);
        newWidth !== undefined && updateWidth(newWidth);
        scheduleResize.cancel();
        if (onResizeStop) onResizeStop();
        if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableResize');
        return newWidth;
    }, [
        editorView,
        getPos,
        node,
        isCommentEditor,
        widthToWidest,
        endMeasure,
        displayGapCursor,
        displayGuideline,
        updateWidth,
        scheduleResize,
        onResizeStop,
        pluginInjectionApi,
        attachAnalyticsEvent,
        tableRef,
        isTableScalingEnabled,
        shouldUseIncreasedScalingPercent,
        formatMessage,
        isFullPageAppearance
    ]);
    const handleTableSizeChangeOnKeypress = (0, $42omo.useCallback)((step)=>{
        const newWidth = width + step;
        if (newWidth < resizerMinWidth) return;
        handleResizeStop({
            width: width,
            x: 0,
            y: 0,
            height: 0
        }, {
            width: step,
            height: 0
        });
    }, [
        width,
        handleResizeStop,
        resizerMinWidth
    ]);
    const handleEscape = (0, $42omo.useCallback)(()=>{
        editorView?.focus();
    }, [
        editorView
    ]);
    const handleKeyDown = (0, $42omo.useCallback)((event)=>{
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        const browser = (0, $d7ZU3.getBrowserInfo)();
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        if (event.altKey || metaKey || event.shiftKey) areResizeMetaKeysPressed.current = true;
        if (event.altKey && metaKey) {
            if (isBracketKey) {
                event.preventDefault();
                handleTableSizeChangeOnKeypress(event.code === 'BracketRight' ? $cfef72949acb5fed$var$RESIZE_STEP_VALUE : -$cfef72949acb5fed$var$RESIZE_STEP_VALUE);
            }
        } else if (!areResizeMetaKeysPressed.current) handleEscape();
    }, [
        handleEscape,
        handleTableSizeChangeOnKeypress
    ]);
    const handleKeyUp = (0, $42omo.useCallback)((event)=>{
        if (event.altKey || event.metaKey) areResizeMetaKeysPressed.current = false;
        return;
    }, [
        areResizeMetaKeysPressed
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!resizerRef.current) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        const globalKeyDownHandler = (event)=>{
            const browser = (0, $d7ZU3.getBrowserInfo)();
            const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
            if (!isTableSelected) return;
            if (event.altKey && event.shiftKey && metaKey && event.code === 'KeyR') {
                event.preventDefault();
                if (!resizeHandleThumbEl) return;
                resizeHandleThumbEl.focus();
                resizeHandleThumbEl.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        const editorViewDom = editorView?.dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom?.addEventListener('keydown', globalKeyDownHandler);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        resizeHandleThumbEl?.addEventListener('keydown', handleKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        resizeHandleThumbEl?.addEventListener('keyup', handleKeyUp);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom?.removeEventListener('keydown', globalKeyDownHandler);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            resizeHandleThumbEl?.removeEventListener('keydown', handleKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            resizeHandleThumbEl?.removeEventListener('keyup', handleKeyUp);
        };
    }, [
        resizerRef,
        editorView,
        handleResizeStop,
        isTableSelected,
        handleKeyDown,
        handleKeyUp
    ]);
    (0, $42omo.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        width
    ]);
    const resizeRatio = !isTableAlignmentEnabled || isTableAlignmentEnabled && (0, $8b84c930bc26bcf8$export$2e10df95acfe6933)(node.attrs.layout) === (0, $8b84c930bc26bcf8$export$3ea9e188ab01c845) ? 2 : 1;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8b5jG.default), {
            ref: resizerRef,
            enable: disabled ? {} : $cfef72949acb5fed$var$handles,
            width: width,
            handleAlignmentMethod: "sticky",
            handleSize: handleSize,
            handleStyles: $cfef72949acb5fed$var$handleStyles,
            handleResizeStart: handleResizeStart,
            handleResize: scheduleResize,
            handleResizeStop: handleResizeStop,
            resizeRatio: resizeRatio,
            minWidth: resizerMinWidth,
            maxWidth: maxWidth,
            snapGap: (0, $fbbb9ee8877c285e$export$8f6133b6e2b4291),
            snap: guidelineSnaps,
            handlePositioning: "adjacent",
            isHandleVisible: isTableSelected,
            needExtendedResizeZone: true,
            appearance: isTableSelected && isWholeTableInDanger ? 'danger' : undefined,
            handleHighlight: "shadow",
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleTooltipContent: ({ update: update })=>{
                updateTooltip.current = update;
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
                    description: formatMessage((0, $2CQVV.messages).resizeTable),
                    keymap: (0, $hgeg8.focusTableResizer)
                });
            },
            "data-vc-nvs": "true",
            children: children
        })
    });
};


const $18d33f212dd25a88$var$InnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ className: className, style: style, node: node, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-number-column": node.attrs.isNumberColumnEnabled,
        "data-layout": node.attrs.layout,
        "data-testid": "table-container",
        children: children
    });
});
const $18d33f212dd25a88$var$AlignmentTableContainer = ({ node: node, children: children, pluginInjectionApi: pluginInjectionApi, getPos: getPos, editorView: editorView })=>{
    const alignment = node.attrs.layout !== (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2) ? (0, $8b84c930bc26bcf8$export$3ea9e188ab01c845) : (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2);
    const { isFullWidthModeEnabled: isFullWidthModeEnabled, wasFullWidthModeEnabled: wasFullWidthModeEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'table'
    ], (states)=>({
            isFullWidthModeEnabled: states.tableState?.isFullWidthModeEnabled,
            wasFullWidthModeEnabled: states.tableState?.wasFullWidthModeEnabled
        }));
    (0, $42omo.useEffect)(()=>{
        if (editorView && getPos) {
            const { state: state, dispatch: dispatch } = editorView;
            if (wasFullWidthModeEnabled && isFullWidthModeEnabled !== undefined && !isFullWidthModeEnabled && alignment !== (0, $8b84c930bc26bcf8$export$3ea9e188ab01c845) && node.attrs.width > (0, $aFUXX.akEditorDefaultLayoutWidth)) {
                const pos = getPos && getPos();
                if (typeof pos !== 'number') return;
                (0, $d9aad08b0e0e65bb$export$58691b745e97f79d)(pluginInjectionApi?.analytics?.actions)((0, $8b84c930bc26bcf8$export$3ea9e188ab01c845), alignment, {
                    pos: pos,
                    node: node
                }, (0, $d925B.INPUT_METHOD).AUTO, (0, $3824I.CHANGE_ALIGNMENT_REASON).EDITOR_APPEARANCE_CHANGED)(state, dispatch);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorView,
        isFullWidthModeEnabled,
        wasFullWidthModeEnabled,
        node
    ]);
    const style = (0, $42omo.useMemo)(()=>{
        return (0, $b5ee4b1040c29bb8$export$b4e2cb644a5e9e7e)(alignment);
    }, [
        alignment
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "table-alignment-container",
        "data-ssr-placeholder": `table-${node.attrs.localId}`,
        "data-ssr-placeholder-replace": `table-${node.attrs.localId}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: children
    });
};
const $18d33f212dd25a88$var$AlignmentTableContainerWrapper = ({ isTableAlignmentEnabled: isTableAlignmentEnabled, node: node, children: children, pluginInjectionApi: pluginInjectionApi, getPos: getPos, editorView: editorView })=>{
    if (!isTableAlignmentEnabled) return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "table-alignment-container",
        "data-ssr-placeholder": `table-${node.attrs.localId}`,
        "data-ssr-placeholder-replace": `table-${node.attrs.localId}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center'
        },
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($18d33f212dd25a88$var$AlignmentTableContainer, {
        node: node,
        pluginInjectionApi: pluginInjectionApi,
        getPos: getPos,
        editorView: editorView,
        children: children
    });
};
const $18d33f212dd25a88$var$selector = (states)=>({
        tableState: states.tableState,
        editorViewModeState: states.editorViewModeState
    });
const $18d33f212dd25a88$var$getPadding = (containerWidth)=>{
    return containerWidth <= (0, $aFUXX.akEditorFullPageNarrowBreakout) && (0, $iu6m9.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $aFUXX.akEditorGutterPaddingReduced) : (0, $aFUXX.akEditorGutterPaddingDynamic)();
};
const $18d33f212dd25a88$export$7063e69b8a954175 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ children: children, className: className, node: node, containerWidth: containerWidth, lineLength: lineLength, editorView: editorView, getPos: getPos, tableRef: tableRef, isResizing: isResizing, pluginInjectionApi: pluginInjectionApi, tableWrapperHeight: tableWrapperHeight, isWholeTableInDanger: isWholeTableInDanger, isTableScalingEnabled: isTableScalingEnabled, allowFixedColumnWidthOption: allowFixedColumnWidthOption, isTableAlignmentEnabled: isTableAlignmentEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor })=>{
    const containerRef = (0, $42omo.useRef)(null);
    const tableWidthRef = (0, $42omo.useRef)((0, $aFUXX.akEditorDefaultLayoutWidth));
    const [resizing, setIsResizing] = (0, $42omo.useState)(false);
    const { tableState: tableState, editorViewModeState: editorViewModeState } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'table',
        'editorViewMode'
    ], $18d33f212dd25a88$var$selector);
    const isFullWidthModeEnabled = tableState?.isFullWidthModeEnabled;
    const isMaxWidthModeEnabled = tableState?.isMaxWidthModeEnabled;
    const mode = editorViewModeState?.mode;
    // If the editor is in max width mode and the table has no width, use the max width value rather than the default table value
    const tableWidth = isMaxWidthModeEnabled && !node.attrs.width && (0, $dh538.fg)('platform_editor_max_width_default_width') ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $6fQl1.getTableContainerWidth)(node);
    const updateContainerHeight = (0, $42omo.useCallback)((height)=>{
        // current StickyHeader State is not stable to be fetch.
        // we need to update stickyHeader plugin to make sure state can be
        //    consistently fetch and refactor below
        const stickyHeaders = containerRef.current?.getElementsByClassName('pm-table-sticky');
        if (!stickyHeaders || stickyHeaders.length < 1) // when starting to drag, we need to keep the original space,
        // -- When sticky header not appear, margin top(24px) and margin bottom(16px), should be 40px,
        //    1px is border width but collapse make it 0.5.
        // -- When sticky header appear, we should add first row height but reduce
        //    collapsed border
        return typeof height === 'number' ? `${height + 40.5}px` : 'auto';
        else {
            const stickyHeaderHeight = containerRef.current?.getElementsByTagName('th')[0].getBoundingClientRect().height || 0;
            return typeof height === 'number' ? `${height + stickyHeaderHeight + 39.5}px` : 'auto';
        }
    }, []);
    const onResizeStart = (0, $42omo.useCallback)(()=>{
        setIsResizing(true);
    }, []);
    const onResizeStop = (0, $42omo.useCallback)(()=>{
        setIsResizing(false);
    }, []);
    const updateWidth = (0, $42omo.useCallback)((width)=>{
        if (!containerRef.current) return;
        // make sure during resizing
        // the pm-table-resizer-container width is the same as its child div resizer-item
        // otherwise when resize table from wider to narrower , pm-table-resizer-container stays wider
        // and cause the fabric-editor-popup-scroll-parent to overflow
        if (containerRef.current.style.width !== `${width}px`) containerRef.current.style.width = `${width}px`;
    }, []);
    const displayGuideline = (0, $42omo.useCallback)((guidelines)=>{
        return pluginInjectionApi?.guideline?.actions?.displayGuideline(editorView)({
            guidelines: guidelines
        }) ?? false;
    }, [
        pluginInjectionApi,
        editorView
    ]);
    const attachAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        return pluginInjectionApi?.analytics?.actions.attachAnalyticsEvent(payload);
    }, [
        pluginInjectionApi
    ]);
    const displayGapCursor = (0, $42omo.useCallback)((toggle)=>{
        return pluginInjectionApi?.core?.actions.execute(pluginInjectionApi?.selection?.commands.displayGapCursor(toggle)) ?? false;
    }, [
        pluginInjectionApi
    ]);
    const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
    const { width: width, maxResizerWidth: maxResizerWidth } = (0, $42omo.useMemo)(()=>{
        let responsiveContainerWidth = 0;
        const padding = $18d33f212dd25a88$var$getPadding(containerWidth);
        // When Full width or Max width editor enabled, a Mac OS user can change "ak-editor-content-area" width by
        // updating Settings -> Appearance -> Show scroll bars from "When scrolling" to "Always". It causes
        // issues when viwport width is less than full/max width Editor's width. To detect avoid them
        // we need to use lineLength to defined responsiveWidth instead of containerWidth
        // (which does not get updated when Mac setting changes) in Full-width/Max-width editor.
        if (isFullWidthModeEnabled || isMaxWidthModeEnabled && (0, $dh538.fg)('platform_editor_max_width_default_width')) {
            // When: Show scroll bars -> containerWidth = akEditorGutterPadding * 2 + lineLength;
            // When: Always -> containerWidth = akEditorGutterPadding * 2 + lineLength + scrollbarWidth;
            // scrollbarWidth can vary. Values can be 14, 15, 16 and up to 20px;
            // lineLength is undefined on first paint → width: NaN → wrapper expands to page
            // width. rAF col-sizing then runs before the number-column padding and
            // the final shrink, so column widths are locked in wrong.
            // If the value isn't finite we fall back to gutterWidth for that first frame.
            if (isTableScalingEnabled && Number.isFinite(lineLength) && lineLength !== undefined) responsiveContainerWidth = lineLength;
            else responsiveContainerWidth = containerWidth - padding * 2 - (0, $8588522c22c049a0$export$a823f6a7493b3d06);
        } else if (isCommentEditor) responsiveContainerWidth = containerWidth - (0, $8588522c22c049a0$export$c332ba2dd5aa2199);
        else if (isChromelessEditor && ((0, $1oCLl.expValEquals)('platform_editor_table_resize_chromeless', 'isEnabled', true) || (0, $1oCLl.expValEquals)('create_work_item_modernization_exp', 'isEnabled', true))) // there's no padding included in chromeless appearance, so we need to reduce table
        // width to ensure all controls are visible.
        // use lineLength as the value is updated by scrollbar visibility changes
        responsiveContainerWidth = Number.isFinite(lineLength) && lineLength !== undefined ? lineLength : containerWidth - (0, $8588522c22c049a0$export$a823f6a7493b3d06);
        else // 76 is currently an accepted padding value considering the spacing for resizer handle
        // containerWidth = width of a DIV with test id="ak-editor-fp-content-area". It is a parent of
        // a DIV with className="ak-editor-content-area". This DIV has padding left and padding right.
        // padding left = padding right = akEditorGutterPadding = 32
        responsiveContainerWidth = isTableScalingEnabled ? containerWidth - padding * 2 : containerWidth - padding * 2 - (0, $8588522c22c049a0$export$a823f6a7493b3d06);
        // Fix for HOT-119925: Ensure table width is properly constrained and responsive
        // For wide tables, ensure they don't exceed container width and can be scrolled
        const calculatedWidth = // remove isCommentEditor check if platform_editor_table_resize_chromeless is cleaned up
        !node.attrs.width && (((0, $1oCLl.expValEquals)('platform_editor_table_resize_chromeless', 'isEnabled', true) || (0, $1oCLl.expValEquals)('create_work_item_modernization_exp', 'isEnabled', true)) && !isFullPageAppearance || isCommentEditor) ? responsiveContainerWidth : Math.min(tableWidth, responsiveContainerWidth);
        // Ensure minimum width for usability while respecting container constraints
        const width = Math.max(calculatedWidth, Math.min(responsiveContainerWidth * 0.5, 300));
        // remove isCommentEditor check if platform_editor_table_resize_chromeless is cleaned up
        const maxResizerWidth = ((0, $1oCLl.expValEquals)('platform_editor_table_resize_chromeless', 'isEnabled', true) || (0, $1oCLl.expValEquals)('create_work_item_modernization_exp', 'isEnabled', true)) && !isFullPageAppearance || isCommentEditor ? responsiveContainerWidth : Math.min(responsiveContainerWidth, (0, $1oCLl.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $1oCLl.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true) ? (0, $8588522c22c049a0$export$8a91b25da594a758) : (0, $8588522c22c049a0$export$bffd6819c009a916));
        return {
            width: width,
            maxResizerWidth: maxResizerWidth
        };
    }, [
        containerWidth,
        isCommentEditor,
        isChromelessEditor,
        isFullWidthModeEnabled,
        isMaxWidthModeEnabled,
        isFullPageAppearance,
        isTableScalingEnabled,
        lineLength,
        node.attrs.width,
        tableWidth
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isResizing) tableWidthRef.current = width;
    }, [
        width,
        isResizing
    ]);
    // CSS Solution for table resizer container width
    const tableResizerContainerWidth = (0, $42omo.useMemo)(()=>{
        return (0, $b61fc0745b235461$export$30421da09613cb3d)(node, isTableScalingEnabled);
    }, [
        node,
        isTableScalingEnabled
    ]);
    // CSS Solution for table resizer max width
    const tableResizerMaxWidth = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
        const nonResizingMaxWidth = isFullPageAppearance ? (0, $b61fc0745b235461$export$817f7cd897b65634)(isCommentEditor, isChromelessEditor, isTableScalingEnabled) : maxResizerWidth;
        // isResizing is needed, otherwise we can't resize table.
        // when not resizing, maxWidth is calculated based on the container width via CSS
        return !isResizing ? nonResizingMaxWidth : maxResizerWidth;
    }, [
        isCommentEditor,
        isChromelessEditor,
        isTableScalingEnabled,
        isResizing,
        maxResizerWidth
    ]);
    // TODO: EDITOR-1679 - Add support for lineLength being undefined at runtime.
    const tableResizerProps = {
        width: // The `width` is used for .resizer-item in <TableResizer>, and it has to be a number
        // So we can't use min(var(--ak-editor-table-width), ${tableWidth}px) here
        // We still have to use JS to calculate width
        width,
        maxWidth: tableResizerMaxWidth,
        containerWidth: containerWidth,
        // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion -- To be fixed in EDITOR-1679
        lineLength: lineLength,
        updateWidth: updateWidth,
        editorView: editorView,
        getPos: getPos,
        node: node,
        tableRef: tableRef,
        displayGuideline: displayGuideline,
        attachAnalyticsEvent: attachAnalyticsEvent,
        displayGapCursor: displayGapCursor,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        isFullWidthModeEnabled: isFullWidthModeEnabled,
        isTableScalingEnabled: isTableScalingEnabled,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        isWholeTableInDanger: isWholeTableInDanger,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        pluginInjectionApi: pluginInjectionApi,
        onResizeStart: onResizeStart,
        onResizeStop: onResizeStop,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor
    };
    const isLivePageViewMode = mode === 'view';
    return /*#__PURE__*/ (0, $l998X.jsx)($18d33f212dd25a88$var$AlignmentTableContainerWrapper, {
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        node: node,
        pluginInjectionApi: pluginInjectionApi,
        getPos: getPos,
        editorView: editorView,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                '--ak-editor-table-gutter-padding': 'calc(var(--ak-editor--large-gutter-padding) * 2)',
                '--ak-editor-table-width': isFullPageAppearance ? tableResizerContainerWidth : `${tableWidthRef.current}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                width: 'var(--ak-editor-table-width)',
                height: resizing ? updateContainerHeight(tableWrapperHeight ?? 'auto') : 'auto',
                position: isLivePageViewMode ? 'relative' : 'unset'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RESIZER_CONTAINER,
            ref: containerRef,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cfef72949acb5fed$export$65233f8d64070eeb), {
                ...tableResizerProps,
                disabled: isLivePageViewMode,
                children: /*#__PURE__*/ (0, $l998X.jsx)($18d33f212dd25a88$var$InnerContainer, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: className,
                    node: node,
                    children: children
                })
            })
        })
    });
});
const $18d33f212dd25a88$export$f2c3aea42b2a048f = ({ children: children, node: node, className: className, containerWidth: { width: editorWidth, lineLength: lineLength }, editorView: editorView, getPos: getPos, tableRef: tableRef, isNested: isNested, tableWrapperHeight: tableWrapperHeight, isResizing: isResizing, pluginInjectionApi: pluginInjectionApi, isWholeTableInDanger: isWholeTableInDanger, isTableResizingEnabled: isTableResizingEnabled, isTableScalingEnabled: isTableScalingEnabled, allowFixedColumnWidthOption: allowFixedColumnWidthOption, isTableAlignmentEnabled: isTableAlignmentEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor })=>{
    if (isTableResizingEnabled && !isNested) return /*#__PURE__*/ (0, $l998X.jsx)($18d33f212dd25a88$export$7063e69b8a954175, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        node: node,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        containerWidth: editorWidth,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        lineLength: lineLength,
        editorView: editorView,
        getPos: getPos,
        tableRef: tableRef,
        tableWrapperHeight: tableWrapperHeight,
        isResizing: isResizing,
        pluginInjectionApi: pluginInjectionApi,
        isTableScalingEnabled: isTableScalingEnabled,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        isWholeTableInDanger: isWholeTableInDanger,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor,
        children: children
    });
    const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
    const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
    const resizableTableWidth = isFullPageAppearance ? (0, $b61fc0745b235461$export$30421da09613cb3d)(node, isTableScalingEnabled) : `calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2))`;
    return /*#__PURE__*/ (0, $l998X.jsx)($18d33f212dd25a88$var$InnerContainer, {
        node: node,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))(className, {
            'less-padding': editorWidth < (0, $aFUXX.akEditorMobileBreakoutPoint) && !isNested && !(isChromelessEditor && isDragAndDropEnabled)
        }),
        style: // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: 'inherit',
            marginLeft: isChromelessEditor ? 18 : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--ak-editor-table-width': resizableTableWidth
        },
        children: children
    });
};



var $7YjFd = parcelRequire("7YjFd");





class $561368c6992f96d2$export$8c072780619cfc83 {
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) this.stickyScrollbarContainerElement.scrollLeft = left;
    }
    init() {
        if (!this.wrapper) return;
        this.stickyScrollbarContainerElement = this.wrapper.parentElement?.querySelector(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        this.editorScrollableElement = // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        (0, $7YjFd.findOverflowScrollParent)(this.view.dom) || window.document;
        if (!this.editorScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                // if the rootBounds has 0 height, e.g. confluence preview mode, we do nothing.
                if (entry.rootBounds?.height === 0) return;
                if (target.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.editorScrollableElement
        });
        // Multiple bottom sentinels may be found if there are nested tables. We need to make sure we get the last one which will belong to the parent table.
        const bottomSentinels = this.wrapper?.parentElement?.getElementsByClassName((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.bottom = bottomSentinels?.item(bottomSentinels.length - 1);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = this.wrapper?.parentElement?.getElementsByClassName((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)?.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>{
            if (el !== null && this.intersectionObserver) this.intersectionObserver.observe(el);
        });
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (entry.rootBounds?.top || 0) || // When editorScrollableElement is the root document or inside modal,
        // so the boundingClientRect.top will never be less than the rootBounds.top,
        // so we need to check if the boundingClientRect.top is less than 20% of the rootBounds.height
        // to determine if the bottom sentinel is above the scroll area
        entry.boundingClientRect.top < (entry.rootBounds?.height || 0) * 0.2;
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        const sentinelIsBelowScrollArea = (entry.rootBounds?.bottom || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.display !== 'none') this.stickyScrollbarContainerElement.style.display = 'none';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.display !== 'block') this.stickyScrollbarContainerElement.style.display = 'block';
    }
    constructor(wrapper, view){
        this.wrapper = void 0;
        this.view = void 0;
        this.editorScrollableElement = void 0;
        this.intersectionObserver = void 0;
        this.stickyScrollbarContainerElement = void 0;
        this.sentinels = {};
        this.topSentinelState = void 0;
        this.bottomSentinelState = void 0;
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            this.wrapper.scrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        };
        this.wrapper = wrapper;
        this.view = view;
        if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', true)) requestAnimationFrame(()=>{
            this.init();
        });
        else this.init();
    }
}


// Prevent unnecessary parentWidth updates when table is nested inside of a node that is nested itself.
const $e98a20a38af9057c$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLD = 2;
const $e98a20a38af9057c$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MAX_THRESHOLD = 20;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e98a20a38af9057c$var$TableComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidMount() {
        const { observe: observe } = (0, $92LVN.nodeVisibilityManager)(this.props.view.dom);
        if (this.table) {
            this.nodeVisibilityObserverCleanupFn = observe({
                element: this.table,
                onFirstVisible: ()=>{
                    this.initialiseEventListenersAfterMount();
                    // force width calculation - missed resize event under firefox when
                    // table is nested within bodied extension
                    if (this.wrapper) this.wrapperWidth = this.wrapper?.clientWidth;
                }
            });
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', this.handleWindowResizeNewDebounced);
        }
        this.dispatchTableRefUpdate();
    }
    initialiseEventListenersAfterMount() {
        const { allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, eventDispatcher: eventDispatcher, isDragAndDropEnabled: isDragAndDropEnabled, getNode: getNode } = this.props;
        const browser = (0, $d7ZU3.getBrowserInfo)();
        const isIE11 = browser.ie_version === 11;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.addEventListener('mouseenter', this.handleMouseEnter);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.addEventListener('mouseout', this.handleMouseOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.addEventListener('mouseover', this.handleMouseOver);
        if (this.wrapper) {
            this.wrapperReisizeObserver = new ResizeObserver((entries)=>{
                for (const entry of entries)this.wrapperWidth = entry.contentRect?.width;
            });
            this.wrapperReisizeObserver.observe(this.wrapper);
        }
        if (allowColumnResizing && this.wrapper && !isIE11) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.wrapper.addEventListener('scroll', this.handleScrollDebounced, {
                passive: true
            });
            if (this.table && !this.isNestedInTable) this.stickyScrollbar = new (0, $561368c6992f96d2$export$8c072780619cfc83)(this.wrapper, this.props.view);
            if (isDragAndDropEnabled) this.dragAndDropCleanupFn = (0, $bSjaC.combine)(...(0, $f69a5020d7054d5c$export$aed4bc7b473fc217)({
                tableWrapper: this.wrapper,
                getNode: getNode
            }));
        }
        if (allowColumnResizing) {
            /**
       * We no longer use `containerWidth` as a variable to determine an update for table resizing (avoids unnecessary updates).
       * Instead we use the resize event to only trigger updates when necessary.
       */ if (!allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', this.handleWindowResizeDebounced);
            this.handleTableResizingDebounced();
        }
        const currentStickyState = (0, $1562ea854f0ae047$export$18d4026d1ea86bb1).getState(this.props.view.state);
        if (currentStickyState) this.onStickyState(currentStickyState);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventDispatcher.on((0, $1562ea854f0ae047$export$18d4026d1ea86bb1).key, this.onStickyState);
    }
    componentWillUnmount() {
        const { allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, eventDispatcher: eventDispatcher, isDragAndDropEnabled: isDragAndDropEnabled, view: view, isInDanger: isInDanger } = this.props;
        const browser = (0, $d7ZU3.getBrowserInfo)();
        const isIE11 = browser.ie_version === 11;
        if (this.wrapper && !isIE11) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.wrapper.removeEventListener('scroll', this.handleScrollDebounced);
        if (isDragAndDropEnabled && this.dragAndDropCleanupFn) this.dragAndDropCleanupFn();
        if (this.nodeVisibilityObserverCleanupFn) this.nodeVisibilityObserverCleanupFn();
        this.resizeObserver?.disconnect();
        this.wrapperReisizeObserver?.disconnect();
        if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        this.handleScrollDebounced.cancel();
        this.scaleTableDebounced.cancel();
        this.handleTableResizingDebounced.cancel();
        this.handleAutoSizeDebounced.cancel();
        if (!allowTableResizing) this.handleWindowResizeDebounced.cancel();
        this.handleWindowResizeNewDebounced.cancel();
        if (isInDanger) (0, $7132c436572167eb$export$d4bebf197f3770e4)()(view.state, view.dispatch);
        if (!allowTableResizing && allowColumnResizing) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.handleWindowResizeDebounced);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.handleWindowResizeNewDebounced);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.removeEventListener('mouseenter', this.handleMouseEnter);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.removeEventListener('mouseout', this.handleMouseOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this?.table?.removeEventListener('mouseover', this.handleMouseOver);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventDispatcher.off((0, $1562ea854f0ae047$export$18d4026d1ea86bb1).key, this.onStickyState);
        if (this.initialOverflowCaptureTimerId) clearTimeout(this.initialOverflowCaptureTimerId);
    }
    // Should be called only when table node width is reset to undefined in Comment Editor
    // Maybe replaced by handleColgroupUpdates as we implement new table's support in Comment Editor.
    removeInlineTableWidth() {
        const { isResizing: isResizing, getNode: getNode, view: view, getPos: getPos } = this.props;
        if (!this.table) return;
        const tableNode = getNode();
        const newTableWidth = tableNode.attrs.width;
        const start = getPos() || 0;
        const depth = view.state.doc.resolve(start).depth;
        if (depth !== 0) return;
        if (!isResizing && newTableWidth === null) this.table.style.width = '';
    }
    handleColgroupUpdates(force = false) {
        const { getNode: getNode, containerWidth: containerWidth, isResizing: isResizing, view: view, getPos: getPos, getEditorFeatureFlags: getEditorFeatureFlags, options: options } = this.props;
        if (!this.table) return;
        // Remove any widths styles after resizing preview is completed
        this.table.style.width = '';
        const tableNode = getNode();
        const start = getPos() || 0;
        const depth = view.state.doc.resolve(start).depth;
        if (depth !== 0) return;
        let tableNodeWidth = (0, $6fQl1.getTableContainerWidth)(tableNode);
        const isTableResizedFullWidth = tableNodeWidth === 1800 && this.wasResizing && !isResizing;
        // Needed for undo / redo
        const isTableWidthChanged = tableNodeWidth !== this.tableNodeWidth;
        const tableRenderWidth = options?.isCommentEditor ? containerWidth.width - ((0, $8588522c22c049a0$export$c332ba2dd5aa2199) + 1 // should be the same as this.table.parentElement?.clientWidth - 1, subtract 1 to avoid overflow
        ) : containerWidth.width - (0, $8588522c22c049a0$export$7c8bcfa1d3f9af23);
        tableNodeWidth = options?.isCommentEditor && !tableNode.attrs.width ? tableRenderWidth : tableNodeWidth;
        const isTableSquashed = tableRenderWidth < tableNodeWidth;
        const isNumberColumnChanged = tableNode.attrs.isNumberColumnEnabled !== this.node.attrs.isNumberColumnEnabled;
        const isNumberOfColumnsChanged = (0, $bdb0299b531c40df$export$bc84d95d2dfa63bf)(tableNode, this.node);
        const { width: containerWidthValue, lineLength: containerLineLength } = containerWidth;
        const isLineLengthChanged = this.containerWidth?.lineLength !== containerLineLength;
        const isFullWidthModeAndLineLengthChanged = this.updateColGroupFromFullWidthChange && isLineLengthChanged;
        const maybeScale = isTableSquashed || isTableWidthChanged || isTableResizedFullWidth && !options?.isCommentEditor || isNumberColumnChanged || isNumberOfColumnsChanged || this.state.windowResized;
        if (force || maybeScale || isFullWidthModeAndLineLengthChanged) {
            const isWidthChanged = this.containerWidth?.width !== containerWidthValue;
            const wasTableResized = (0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(this.node);
            const isTableResized = (0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(tableNode);
            const isColumnsDistributed = wasTableResized && !isTableResized;
            const isTableDisplayModeChanged = this.node.attrs.displayMode !== tableNode.attrs.displayMode;
            const shouldUpdateColgroup = this.shouldUpdateColgroup({
                isWindowResized: this.state.windowResized,
                isWidthChanged: isWidthChanged,
                isTableWidthChanged: isTableWidthChanged,
                isColumnsDistributed: isColumnsDistributed,
                isTableResizedFullWidth: isTableResizedFullWidth,
                isTableDisplayModeChanged: isTableDisplayModeChanged,
                isNumberColumnChanged: isNumberColumnChanged,
                isNumberOfColumnsChanged: isNumberOfColumnsChanged,
                isFullWidthModeAndLineLengthChanged: isFullWidthModeAndLineLengthChanged,
                isTableResized: isTableResized
            });
            const tableWithFixedColumnWidthsOption = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? this.props?.allowFixedColumnWidthOption : getEditorFeatureFlags()?.tableWithFixedColumnWidthsOption) || false;
            const isTableScalingWithFixedColumnWidthsOptionEnabled = !!this.props.options?.isTableScalingEnabled && tableWithFixedColumnWidthsOption;
            const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || !!this.props.options?.isTableScalingEnabled && !!this.props.options?.isCommentEditor;
            if (force || !isResizing && shouldUpdateColgroup) {
                const resizeState = (0, $77650a1f6e0f1ab2$export$38f73cf370cfaafc)({
                    minWidth: (0, $8588522c22c049a0$export$dd66abdcfb4bb2cf),
                    // When numbered column enabled, we need to subtract the width of the numbered column
                    maxSize: tableNode.attrs.isNumberColumnEnabled ? tableRenderWidth - (0, $aFUXX.akEditorTableNumberColumnWidth) : tableRenderWidth,
                    table: tableNode,
                    tableRef: this.table,
                    start: start,
                    domAtPos: view.domAtPos.bind(view),
                    isTableScalingEnabled: true,
                    shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                    isCommentEditor: !!this.props.options?.isCommentEditor
                });
                let shouldScaleOnColgroupUpdate = false;
                if (this.props.options?.isTableScalingEnabled && !tableWithFixedColumnWidthsOption) shouldScaleOnColgroupUpdate = true;
                if (isTableScalingWithFixedColumnWidthsOptionEnabled && tableNode.attrs.displayMode !== 'fixed') shouldScaleOnColgroupUpdate = true;
                if (this.props.options?.isTableScalingEnabled && this.props.options?.isCommentEditor) shouldScaleOnColgroupUpdate = true;
                let scalePercent = 1;
                requestAnimationFrame(()=>{
                    // Scaling percent has to be calculated inside requestAnimationFrame, otherwise
                    // renderWidth calculated as `tableRef?.parentElement?.clientWidth`
                    // inside of getTableScalingPercent returns 0.
                    if (!this.props.options?.isCommentEditor || this.props.options?.isCommentEditor && tableNode.attrs.width) scalePercent = (0, $b61fc0745b235461$export$b2c142721a99201b)(tableNode, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.table, shouldUseIncreasedScalingPercent);
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    scalePercent = (0, $b61fc0745b235461$export$4e884677f8e54bba)(tableNode, this.table);
                    // Request animation frame required for Firefox
                    (0, $77650a1f6e0f1ab2$export$23e0010f5fd8981)(resizeState, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.table, tableNode, shouldScaleOnColgroupUpdate, scalePercent);
                });
            }
        }
        if (isFullWidthModeAndLineLengthChanged) this.updateColGroupFromFullWidthChange = false;
        this.tableNodeWidth = tableNodeWidth;
        this.wasResizing = isResizing;
        this.containerWidth = containerWidth;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    componentDidUpdate(_, prevState) {
        const { getNode: getNode, isMediaFullscreen: isMediaFullscreen, allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, isResizing: isResizing, options: options, isTableScalingEnabled: isTableScalingEnabled, getPos: // we could use options.isTableScalingEnabled here
        getPos, getEditorFeatureFlags: getEditorFeatureFlags, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        let shouldScale = false;
        let shouldHandleColgroupUpdates = false;
        const tableWithFixedColumnWidthsOption = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? allowFixedColumnWidthOption : getEditorFeatureFlags()?.tableWithFixedColumnWidthsOption) || false;
        if (isTableScalingEnabled && !tableWithFixedColumnWidthsOption) {
            shouldScale = true;
            shouldHandleColgroupUpdates = true;
        }
        const isTableScalingWithFixedColumnWidthsOptionEnabled = !!isTableScalingEnabled && tableWithFixedColumnWidthsOption;
        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || !!isTableScalingEnabled && !!this.props.options?.isCommentEditor;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled && getNode().attrs.displayMode !== 'fixed') {
            shouldScale = true;
            shouldHandleColgroupUpdates = true;
        }
        if (shouldHandleColgroupUpdates) this.handleColgroupUpdates();
        if (this.props.options?.isCommentEditor && allowTableResizing && !options?.isTableScalingEnabled) this.removeInlineTableWidth();
        const currentTable = getNode();
        const previousTable = this.node;
        const isNoOfColumnsChanged = (0, $bdb0299b531c40df$export$bc84d95d2dfa63bf)(currentTable, previousTable);
        const isNoOfRowsChanged = (0, $bdb0299b531c40df$export$8fe872ff9fc9b477)(currentTable, previousTable);
        if (isNoOfColumnsChanged || isNoOfRowsChanged) this.props.pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify((0, $1731f25dceb7d4d1$export$cea95ea93d5f9224)(previousTable, currentTable, this.props.intl), {
            priority: 'important'
        });
        if (currentTable.attrs.__autoSize) // Wait for next tick to handle auto sizing, gives the browser time to do layout calc etc.
        this.handleAutoSizeDebounced();
        else if (allowColumnResizing && this.table && !isMediaFullscreen) {
            // If col widths (e.g. via collab) or number of columns (e.g. delete a column) have changed,
            // re-draw colgroup.
            if ((0, $bdb0299b531c40df$export$8f2a10e9b102ac33)(currentTable, previousTable) || isNoOfColumnsChanged) {
                const { view: view } = this.props;
                const shouldRecreateResizeCols = !allowTableResizing || !isResizing || isNoOfColumnsChanged && isResizing;
                if (shouldRecreateResizeCols) {
                    const start = getPos() || 0;
                    const depth = view.state.doc.resolve(start).depth;
                    shouldScale = depth === 0 && shouldScale;
                    (0, $d7e0ca7a06057b05$export$ae5d9647f2a0891c)(this.table, currentTable, shouldScale, undefined, shouldUseIncreasedScalingPercent, options?.isCommentEditor);
                    // Deferred from setDomAttrs — remove only once colgroup is updated and table has left content mode.
                    if (this.table?.hasAttribute('data-initial-width-mode') && !(0, $ixUmr.isTableInContentMode)({
                        tableNode: currentTable,
                        isSupported: (0, $3a3941a6aa273892$export$e217d2a535d6ae45)({
                            allowColumnResizing: !!allowColumnResizing,
                            allowTableResizing: !!allowTableResizing,
                            isFullPageEditor: !this.props.options?.isCommentEditor && !this.props.options?.isChromelessEditor
                        }),
                        isTableNested: (0, $bdb0299b531c40df$export$d4302a800316ebd6)(view.state, getPos())
                    })) this.table.removeAttribute('data-initial-width-mode');
                }
                (0, $b432f0a26e9b5b59$export$13c259c17cfd51f5)()(view.state);
            }
            this.handleTableResizingDebounced();
        }
        this.dispatchTableRefUpdate();
    }
    dispatchTableRefUpdate() {
        if (this.table && this.table !== this.lastSetTableRef && (!(0, $1oCLl.expValEquals)('platform_editor_table_ref_optimisation', 'isEnabled', true) || this.props.tableActive) && this.props.view && (0, $1oCLl.expValEquals)('platform_editor_fix_editor_unhandled_type_errors', 'isEnabled', true) && ((0, $1oCLl.expValEquals)('platform_editor_table_update_table_ref', 'isEnabled', true) || (0, $dh538.fg)('platform_editor_enable_table_update_ref_atlas'))) {
            this.lastSetTableRef = this.table;
            (0, $4ca83755c936c9c8$export$79b661cbf50c3490)(this.table)(this.props.view.state, this.props.view.dispatch);
        }
    }
    observeTable(table) {
        if (table) this.resizeObserver?.observe(table);
    }
    render() {
        const { view: view, getNode: getNode, isResizing: isResizing, allowControls: allowControls = true, isHeaderRowEnabled: isHeaderRowEnabled, ordering: ordering, isHeaderColumnEnabled: isHeaderColumnEnabled, tableActive: tableActive, containerWidth: containerWidth, options: options, getPos: getPos, pluginInjectionApi: pluginInjectionApi, isDragAndDropEnabled: isDragAndDropEnabled, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, allowTableResizing: // here we can use options.isTableScalingEnabled
        allowTableResizing, allowTableAlignment: allowTableAlignment, selection: selection, isInDanger: isInDanger, hoveredRows: hoveredRows, hoveredCell: hoveredCell, isTableHovered: isTableHovered, isWholeTableInDanger: isWholeTableInDanger } = this.props;
        const node = getNode();
        const tableRef = this.table || undefined;
        const headerRow = tableRef ? tableRef.querySelector('tr[data-header-row]') : undefined;
        const hasHeaderRow = (0, $bdb0299b531c40df$export$86a810659e2d575)(node);
        const rowControls = /*#__PURE__*/ (0, $l998X.jsx)((0, $534ff361a414cc4b$export$2e2bcd8739ae039), {
            editorView: view,
            tableRef: tableRef,
            tableNode: node,
            tableActive: tableActive,
            hoveredRows: hoveredRows,
            hoveredCell: hoveredCell,
            isTableHovered: isTableHovered,
            isInDanger: isInDanger,
            isResizing: isResizing,
            isNumberColumnEnabled: node.attrs.isNumberColumnEnabled,
            isHeaderRowEnabled: isHeaderRowEnabled,
            isDragAndDropEnabled: isDragAndDropEnabled,
            ordering: ordering,
            isHeaderColumnEnabled: isHeaderColumnEnabled,
            hasHeaderRow: hasHeaderRow,
            // pass `selection` and `tableHeight` to control re-render
            selection: view.state.selection,
            headerRowHeight: headerRow ? headerRow.offsetHeight : undefined,
            stickyHeader: !this.props.limitedMode ? this.state.stickyHeader : undefined,
            tableWrapperWidth: this.state.tableWrapperWidth,
            api: pluginInjectionApi,
            isChromelessEditor: options?.isChromelessEditor
        });
        const tableContainerWidth = (0, $6fQl1.getTableContainerWidth)(node);
        const colControls = isDragAndDropEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fc03cc481fa1e1aa$export$2e2bcd8739ae039), {
            editorView: view,
            tableRef: tableRef,
            getNode: getNode,
            tableActive: tableActive,
            isInDanger: isInDanger,
            hoveredRows: hoveredRows,
            hoveredCell: hoveredCell,
            isTableHovered: isTableHovered,
            isResizing: isResizing,
            ordering: ordering,
            hasHeaderRow: hasHeaderRow,
            // pass `selection` to control re-render
            selection: view.state.selection,
            headerRowHeight: headerRow ? headerRow.offsetHeight : undefined,
            stickyHeader: !this.props.limitedMode ? this.state.stickyHeader : undefined,
            getEditorFeatureFlags: getEditorFeatureFlags,
            tableContainerWidth: tableContainerWidth,
            isNumberColumnEnabled: node.attrs.isNumberColumnEnabled,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            getScrollOffset: ()=>this.wrapper?.scrollLeft || 0,
            tableWrapperHeight: this.state.tableWrapperHeight,
            api: pluginInjectionApi,
            isChromelessEditor: options?.isChromelessEditor,
            isDragAndDropEnabled: isDragAndDropEnabled
        }) : null;
        /**
     *  ED-19838
     *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
     *  before CR6 lands in production
     */ let tablePos;
        try {
            tablePos = getPos ? getPos() : undefined;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
            tablePos = undefined;
        }
        const isNested = (0, $bdb0299b531c40df$export$d4302a800316ebd6)(view.state, tablePos);
        const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
        const shouldUseIncreasedScalingPercent = !!isTableScalingEnabled && (tableWithFixedColumnWidthsOption || !!this.props.options?.isCommentEditor);
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $18d33f212dd25a88$export$f2c3aea42b2a048f), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, {
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS]: allowControls && tableActive,
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY]: !this.props.limitedMode && this.state.stickyHeader && hasHeaderRow,
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON]: isInDanger,
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SELECTED]: (0, $iYC9s.isTableSelected)(selection ?? view.state.selection),
                [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NESTED_TABLE_WITH_CONTROLS]: tableActive && allowControls && this.isNestedInTable
            }),
            editorView: view,
            getPos: getPos,
            node: node,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tableRef: tableRef,
            containerWidth: containerWidth,
            isNested: isNested,
            pluginInjectionApi: pluginInjectionApi,
            tableWrapperHeight: this.state.tableWrapperHeight,
            isTableResizingEnabled: allowTableResizing,
            isResizing: isResizing,
            isTableScalingEnabled: isTableScalingEnabled,
            allowFixedColumnWidthOption: tableWithFixedColumnWidthsOption,
            isWholeTableInDanger: isWholeTableInDanger,
            isTableAlignmentEnabled: allowTableAlignment,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isCommentEditor: options?.isCommentEditor,
            isChromelessEditor: options?.isChromelessEditor,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP,
                    "data-testid": "sticky-sentinel-top"
                }),
                !this.isNestedInTable && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                    "data-testid": "sticky-scrollbar-sentinel-top"
                }),
                allowControls && rowControls,
                isDragAndDropEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $17073aeea32b894f$export$1041cb8214100cd2), {
                    editorView: view,
                    node: node,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    getScrollOffset: ()=>{
                        return this.wrapper?.scrollLeft || 0;
                    },
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    getTableWrapperWidth: ()=>{
                        return this.wrapper?.clientWidth || 760;
                    }
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER),
                    ref: (elem)=>{
                        this.wrapper = elem;
                        if (elem) {
                            this.props.contentDOM(elem);
                            const tableElement = elem.querySelector('table');
                            if (tableElement !== this.table) {
                                this.table = tableElement;
                                this.observeTable(this.table);
                                // // Update tableRef in plugin state when table is properly mounted
                                // // At this point, both table and wrapper are in DOM with correct parent-child relationship
                                if (this.table && (!(0, $1oCLl.expValEquals)('platform_editor_table_ref_optimisation', 'isEnabled', true) || this.props.tableActive) && this.props.view && !(0, $1oCLl.expValEquals)('platform_editor_fix_editor_unhandled_type_errors', 'isEnabled', true) && ((0, $1oCLl.expValEquals)('platform_editor_table_update_table_ref', 'isEnabled', true) || (0, $dh538.fg)('platform_editor_enable_table_update_ref_atlas'))) (0, $4ca83755c936c9c8$export$79b661cbf50c3490)(this.table)(this.props.view.state, this.props.view.dispatch);
                            }
                        }
                    },
                    children: allowControls && colControls
                }),
                !this.isNestedInTable ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_CONTAINER,
                    "data-vc-nvs": "true",
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        height: "var(--ds-space-250, 20px)",
                        // MAX_BROWSER_SCROLLBAR_HEIGHT
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        display: 'none',
                        // prevent unwanted scroll during table resize without removing scrollbar container from the dom
                        width: isResizing ? "var(--ds-space-0, 0px)" : '100%'
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            width: tableRef?.clientWidth,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: '100%'
                        },
                        "data-vc-nvs": "true"
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    style: {
                        width: tableRef?.clientWidth,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        height: '100%'
                    },
                    "data-vc-nvs": "true"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM,
                    "data-testid": "sticky-sentinel-bottom"
                }),
                !this.isNestedInTable && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                    "data-testid": "sticky-scrollbar-sentinel-bottom"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    contentEditable: false,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_BORDER,
                    "data-with-numbered-table": node.attrs.isNumberColumnEnabled,
                    "data-testid": "table-left-border"
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    contentEditable: false,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_BORDER,
                    "data-testid": "table-right-border"
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            parentWidth: undefined,
            tableWrapperWidth: undefined,
            tableWrapperHeight: undefined,
            windowResized: false
        };
        this.wrapper = void 0;
        this.table = void 0;
        this.node = void 0;
        this.containerWidth = void 0;
        this.wasResizing = void 0;
        this.tableNodeWidth = void 0;
        this.layoutSize = void 0;
        this.stickyScrollbar = void 0;
        this.isNestedInTable = void 0;
        this.initialOverflowCaptureTimerId = void 0;
        this.resizeObserver = void 0;
        this.wrapperWidth = void 0;
        this.wrapperReisizeObserver = void 0;
        this.updateColGroupFromFullWidthChange = void 0;
        this.dragAndDropCleanupFn = void 0;
        this.nodeVisibilityObserverCleanupFn = void 0;
        this.handleMouseOut = (event)=>{
            if (!(0, $f10f08824d624bfc$export$42d5d9cc7457d81e)(this.props.view)) return false;
            return (0, $f10f08824d624bfc$export$72517da01e0ce829)(this.props.view, event);
        };
        this.handleMouseOver = (event)=>{
            if (!(0, $f10f08824d624bfc$export$42d5d9cc7457d81e)(this.props.view)) return false;
            return (0, $f10f08824d624bfc$export$87e6a6bf8341824f)((0, $f10f08824d624bfc$export$321c2da35903b013))(this.props.view, event);
        };
        this.handleMouseEnter = ()=>{
            const node = this.props.getNode();
            const pos = this.props.getPos();
            const tr = this.props.view.state.tr;
            const tableId = node.attrs.localId;
            tr.setMeta('mouseEnterTable', [
                tableId,
                node,
                pos
            ]);
            this.props.view.dispatch(tr);
        };
        this.lastSetTableRef = null;
        this.onStickyState = (state)=>{
            const pos = this.props.getPos();
            if (!(0, $kTbzR.isValidPosition)(pos, this.props.view.state)) return;
            const stickyHeader = (0, $894c3bb16e3b70ec$export$91d61a242b14c7fb)(state, pos);
            if (stickyHeader !== this.state.stickyHeader) this.setState({
                stickyHeader: stickyHeader
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.prevTableState = null;
        this.handleScroll = (event)=>{
            if (!this.wrapper || event.target !== this.wrapper) return;
            if (this.stickyScrollbar) this.stickyScrollbar.scrollLeft(this.wrapper.scrollLeft);
            if (this.table) {
                // sync sticky header row to table scroll
                const headers = this.table.querySelectorAll('tr[data-header-row]');
                for(let i = 0; i < headers.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const header = headers[i];
                    header.scrollLeft = this.wrapper.scrollLeft;
                    header.style.marginRight = '2px';
                }
            }
            // force update to for table controls to re-align
            this.forceUpdate();
        };
        this.handleTableResizing = ()=>{
            const { getNode: getNode, containerWidth: containerWidth, options: options, allowTableResizing: allowTableResizing } = this.props;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const prevNode = this.node;
            const node = getNode();
            const prevAttrs = prevNode.attrs;
            const tablePos = this.props.getPos();
            const isNested = (0, $bdb0299b531c40df$export$d4302a800316ebd6)(this.props.view.state, tablePos);
            let parentWidth = this.getParentNodeWidth();
            const useMeasuredWidthForBodiedSyncBlock = isNested && typeof tablePos === 'number' && (0, $bdb0299b531c40df$export$ffa7c963c6f2f204)(this.props.view.state, tablePos) && (0, $dh538.fg)('platform_synced_block_patch_9');
            if (useMeasuredWidthForBodiedSyncBlock) {
                // Prefer the live DOM measurement (`clientWidth`) over the ResizeObserver-cached
                // value (`wrapperWidth`) because clientWidth is synchronous and more up-to-date
                // at the time this handler runs. Fall back to `wrapperWidth` if the wrapper ref
                // is not yet available.
                // The clientWidth > 0 since DOM clientWidth is 0 before layout
                // The > 1 guard for wrapperWidth was intentional to filter out the degenerate value of 1 that ResizeObserver reports during element unmounting.
                let measuredWrapperWidth;
                if (this.wrapper && this.wrapper.clientWidth > 0) measuredWrapperWidth = this.wrapper.clientWidth;
                else if (this.wrapperWidth && this.wrapperWidth > 1) measuredWrapperWidth = this.wrapperWidth;
                if (measuredWrapperWidth !== undefined) // Override the default parentWidth so that scaleTable uses the real
                // available width inside the sync-block rather than the full editor width.
                parentWidth = measuredWrapperWidth;
            }
            if (!useMeasuredWidthForBodiedSyncBlock && isNested && (0, $bdb0299b531c40df$export$e31912a493829c23)(this.props.view.state, tablePos)) {
                const resizeObsWrapperWidth = this.wrapperWidth || 0;
                const wrapperWidthDiffBetweenRerenders = Math.abs(resizeObsWrapperWidth - (this.state.parentWidth || 0));
                const isOusideOfThreshold = wrapperWidthDiffBetweenRerenders <= $e98a20a38af9057c$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLD || wrapperWidthDiffBetweenRerenders > $e98a20a38af9057c$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MAX_THRESHOLD;
                // 1. Check isOusideOfThreshold is added to prevent undersired state update.
                // When table is nested in the extenstion and the table column is being resized,
                // space available within extension can change and cause undesirable state update.
                // MIN_THRESNESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLDHOLD value is required
                // as the resizeObsWrapperWidth can differ between page reloads by 2px.
                // 2. Check resizeObsWrapperWidth > 1 is added to prevent parentWidth update when table unmounts.
                // When a is nested table in a nested expand and the expand collabses, the table unmounts and
                // resizeObsWrapperWidth becomes 1.
                parentWidth = isOusideOfThreshold && resizeObsWrapperWidth > 1 ? resizeObsWrapperWidth : this.state.parentWidth;
            }
            const parentWidthChanged = parentWidth && parentWidth !== this.state.parentWidth;
            const layoutSize = this.tableNodeLayoutSize(node, containerWidth.width, options);
            const hasNumberedColumnChanged = prevAttrs.isNumberColumnEnabled !== node.attrs.isNumberColumnEnabled;
            const noOfColumnsChanged = (0, $bdb0299b531c40df$export$bc84d95d2dfa63bf)(node, prevNode);
            if (// We need to react if our parent changes
            // Scales the cols widths relative to the new parent width.
            parentWidthChanged || // Enabling / disabling this feature reduces or adds size to the table.
            hasNumberedColumnChanged || // This last check is also to cater for dynamic text sizing changing the 'default' layout width
            // Usually happens on window resize.
            layoutSize !== this.layoutSize || noOfColumnsChanged) {
                const shouldScaleTable = (!allowTableResizing || allowTableResizing && isNested) && !hasNumberedColumnChanged && !noOfColumnsChanged;
                // If column has been inserted/deleted avoid multi dispatch
                if (shouldScaleTable) this.scaleTable({
                    parentWidth: parentWidth
                }, hasNumberedColumnChanged);
                // only when table resizing is enabled and toggle numbered column to run scaleTable
                if (allowTableResizing && hasNumberedColumnChanged) {
                    if (!(0, $d7e0ca7a06057b05$export$8c07f44cea64e3c7)(prevNode)) this.scaleTable({
                        parentWidth: node.attrs.width
                    }, true);
                }
                this.updateParentWidth(parentWidth);
            }
            this.node = node;
            this.containerWidth = containerWidth;
            this.layoutSize = layoutSize;
        };
        // Function gets called when table is nested.
        this.scaleTable = (scaleOptions, isUserTriggered = false)=>{
            const { view: view, getNode: getNode, getPos: getPos, containerWidth: containerWidth, options: options } = this.props;
            const node = getNode();
            const { state: state, dispatch: dispatch } = view;
            const pos = getPos();
            if (typeof pos !== 'number' || !(0, $kTbzR.isValidPosition)(pos, state)) return;
            const domAtPos = view.domAtPos.bind(view);
            const { width: width } = containerWidth;
            this.scaleTableDebounced.cancel();
            const tr = (0, $0e5c6cf05dff4e80$export$edcf1a404e75ce35)(this.table, {
                ...scaleOptions,
                node: node,
                prevNode: this.node || node,
                start: pos + 1,
                containerWidth: width,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                previousContainerWidth: this.containerWidth.width || width,
                ...options
            }, domAtPos, this.props.pluginInjectionApi, false, // isTableScalingEnabled doesn't change the behavior of nested tables
            false // shouldUseIncreasedScalingPercent set to false for nested tables
            )(state.tr);
            if (!isUserTriggered) {
                (0, $h3X17.tintDirtyTransaction)(tr);
                // Avoid adding this transaction separately to the history as these are automatic updates
                // as a consequence of another action
                tr.setMeta('addToHistory', false);
            }
            dispatch(tr);
        };
        this.handleAutoSize = ()=>{
            if (this.table) {
                const { view: view, getNode: getNode, getPos: getPos, containerWidth: containerWidth } = this.props;
                const node = getNode();
                const pos = getPos();
                if (!(0, $kTbzR.isValidPosition)(pos, view.state)) return;
                (0, $4ca83755c936c9c8$export$d6e5d8afaa172954)(view, node, this.table, pos, {
                    containerWidth: containerWidth.width
                });
            }
        };
        this.handleWindowResize = ()=>{
            const { getNode: getNode, containerWidth: containerWidth } = this.props;
            const node = getNode();
            const layoutSize = this.tableNodeLayoutSize(node);
            if (containerWidth.width > layoutSize) return;
            const parentWidth = this.getParentNodeWidth();
            this.scaleTableDebounced({
                parentWidth: parentWidth
            });
        };
        // This is a new handler for window resize events that sets the windowResized state immediately
        // This is needed to update colgroup on window resize, to enforce the table scaling
        this.handleWindowResizeNew = ()=>{
            // Set resizing to true immediately
            if (!this.state.windowResized) this.setState({
                windowResized: true
            });
        };
        this.getParentNodeWidth = ()=>{
            const { getPos: getPos, containerWidth: containerWidth, options: options, view: { state: state } } = this.props;
            const pos = getPos();
            if (!(0, $kTbzR.isValidPosition)(pos, state)) return;
            const parentNodeWith = (0, $6fQl1.getParentNodeWidth)(pos, state, containerWidth, options && options.isFullWidthModeEnabled);
            return parentNodeWith;
        };
        this.updateParentWidth = (width)=>{
            this.setState({
                parentWidth: width
            });
        };
        this.tableNodeLayoutSize = (node, containerWidth, options)=>(0, $b61fc0745b235461$export$7bde9ac1d5d663fc)(node.attrs.layout, containerWidth || this.props.containerWidth.width, options || this.props.options || {});
        this.shouldUpdateColgroup = (params)=>{
            const { isWindowResized: isWindowResized, isWidthChanged: isWidthChanged, isTableWidthChanged: isTableWidthChanged, isColumnsDistributed: isColumnsDistributed, isTableResizedFullWidth: isTableResizedFullWidth, isTableDisplayModeChanged: isTableDisplayModeChanged, isNumberColumnChanged: isNumberColumnChanged, isNumberOfColumnsChanged: isNumberOfColumnsChanged, isFullWidthModeAndLineLengthChanged: isFullWidthModeAndLineLengthChanged } = params;
            const isFullPageEditor = !this.props.options?.isCommentEditor && !this.props.options?.isChromelessEditor;
            if (isFullPageEditor) return !!isWindowResized || isColumnsDistributed || !!isTableResizedFullWidth || isTableDisplayModeChanged || isNumberColumnChanged || isNumberOfColumnsChanged || !!isFullWidthModeAndLineLengthChanged;
            return isWidthChanged || isTableWidthChanged || isColumnsDistributed || !!isTableResizedFullWidth || isTableDisplayModeChanged || isNumberColumnChanged || isNumberOfColumnsChanged || !!isFullWidthModeAndLineLengthChanged;
        };
        this.scaleTableDebounced = (0, $2P8Ax.default)(this.scaleTable);
        this.handleTableResizingDebounced = (0, $2P8Ax.default)(this.handleTableResizing);
        this.handleScrollDebounced = (0, $2P8Ax.default)(this.handleScroll);
        this.handleAutoSizeDebounced = (0, $2P8Ax.default)(this.handleAutoSize);
        this.handleWindowResizeDebounced = (0, $2P8Ax.default)(this.handleWindowResize);
        this.handleWindowResizeNewDebounced = (0, $2P8Ax.default)(this.handleWindowResizeNew);
        const { options: _options, containerWidth: _containerWidth, getNode: _getNode } = props;
        this.node = _getNode();
        this.containerWidth = _containerWidth;
        const _tablePos = props.getPos();
        this.isNestedInTable = _tablePos ? (0, $sxTNo.getParentOfTypeCount)(props.view.state.schema.nodes.table)(props.view.state.doc.resolve(_tablePos)) > 0 : false;
        if (!this.updateColGroupFromFullWidthChange) this.updateColGroupFromFullWidthChange = _options?.isFullWidthModeEnabled && !_options?.wasFullWidthModeEnabled;
        // store table size using previous full-width mode so can detect if it has changed.
        const isFullWidthModeEnabled = _options ? _options.wasFullWidthModeEnabled : false;
        this.layoutSize = this.tableNodeLayoutSize(this.node, _containerWidth.width, {
            isFullWidthModeEnabled: isFullWidthModeEnabled
        });
        this.resizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries)this.setState((prev)=>{
                return prev?.tableWrapperWidth === entry.contentRect?.width && prev?.tableWrapperHeight === entry.contentRect?.height ? prev : {
                    ...prev,
                    tableWrapperWidth: entry.contentRect.width,
                    tableWrapperHeight: entry.contentRect.height
                };
            });
        });
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
$e98a20a38af9057c$var$TableComponent.displayName = 'TableComponent';
const $e98a20a38af9057c$var$_default_1 = (0, $aXWIB.injectIntl)($e98a20a38af9057c$var$TableComponent);
var $e98a20a38af9057c$export$2e2bcd8739ae039 = $e98a20a38af9057c$var$_default_1;


const $fd705b3bea000047$export$b6d58ec6836e4dcf = ({ view: view, options: options, getNode: getNode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, api: api, getEditorFeatureFlags: getEditorFeatureFlags, eventDispatcher: eventDispatcher, allowColumnResizing: allowColumnResizing, allowControls: allowControls, getPos: getPos, forwardRef: forwardRef, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, allowFixedColumnWidthOption: allowFixedColumnWidthOption })=>{
    const { isTableResizing: isTableResizing, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, ordering: ordering, isResizing: isResizing, isInDanger: isInDanger, hoveredCell: hoveredCell, hoveredRows: hoveredRows, isTableHovered: isTableHovered, isWholeTableInDanger: isWholeTableInDanger, interaction: interaction, isFullscreen: isFullscreen, lineLength: lineLength, mode: mode, selection: selection, width: width } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'table',
        'width',
        'media',
        'selection',
        'editorViewMode',
        'interaction'
    ], (states)=>({
            // tableState
            isTableResizing: states.tableState?.isTableResizing,
            isHeaderColumnEnabled: states.tableState?.isHeaderColumnEnabled,
            isHeaderRowEnabled: states.tableState?.isHeaderRowEnabled,
            ordering: states.tableState?.ordering,
            isResizing: states.tableState?.isResizing,
            isInDanger: states.tableState?.isInDanger,
            hoveredCell: states.tableState?.hoveredCell,
            hoveredRows: states.tableState?.hoveredRows,
            isTableHovered: states.tableState?.isTableHovered,
            isWholeTableInDanger: states.tableState?.isWholeTableInDanger,
            // Required so that table control re-renders
            targetCellPosition: states.tableState?.targetCellPosition,
            // mediaState
            isFullscreen: states.mediaState?.isFullscreen,
            // selectionState
            selection: states.selectionState?.selection,
            // editorViewModeState
            mode: states.editorViewModeState?.mode,
            // widthState
            width: states.widthState?.width,
            lineLength: states.widthState?.lineLength,
            // interactionState
            interaction: states.interactionState?.interactionState
        }));
    const isLivePageViewMode = mode === 'view';
    /**
   *  ED-19810
   *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
   *  directly to confluence since this bug is now in production.
   */ let currentTablePos;
    try {
        currentTablePos = getPos ? getPos() : undefined;
    } catch (e) {
        // eslint-disable-line no-unused-vars
        currentTablePos = undefined;
    }
    const selectedTable = (0, $id9O1.findTable)(view.state.selection);
    const tablePos = selectedTable && selectedTable.start - 1;
    const tableActive = typeof currentTablePos === 'number' && typeof tablePos === 'number' && currentTablePos === tablePos && !isTableResizing;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $e98a20a38af9057c$export$2e2bcd8739ae039), {
        view: view,
        allowColumnResizing: allowColumnResizing,
        eventDispatcher: eventDispatcher,
        getPos: getPos,
        isMediaFullscreen: isFullscreen,
        options: options,
        allowControls: allowControls,
        isHeaderRowEnabled: isHeaderRowEnabled ?? false,
        isHeaderColumnEnabled: isHeaderColumnEnabled ?? false,
        isDragAndDropEnabled: options?.isDragAndDropEnabled && !isLivePageViewMode,
        isTableScalingEnabled: options?.isTableScalingEnabled,
        allowTableAlignment: allowTableAlignment,
        allowTableResizing: allowTableResizing,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        tableActive: tableActive && !isLivePageViewMode && interaction !== 'hasNotHadInteraction',
        ordering: ordering,
        isResizing: isResizing,
        getNode: getNode,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        containerWidth: {
            width: width ?? 0,
            lineLength: lineLength
        },
        contentDOM: forwardRef,
        getEditorFeatureFlags: getEditorFeatureFlags,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: api,
        isInDanger: !!isInDanger,
        hoveredRows: hoveredRows,
        hoveredCell: hoveredCell,
        isTableHovered: isTableHovered,
        isWholeTableInDanger: isWholeTableInDanger,
        selection: selection
    });
};



const $1a05aa95aa438aa8$var$tableAttributes = (node)=>{
    return {
        'data-number-column': node.attrs.isNumberColumnEnabled,
        'data-layout': node.attrs.layout,
        'data-autosize': node.attrs.__autoSize,
        'data-table-local-id': node.attrs.localId || '',
        'data-table-width': node.attrs.width || 'inherit',
        'data-table-display-mode': node.attrs.displayMode
    };
};
const $1a05aa95aa438aa8$var$getInlineWidth = (node, options, state, pos, allowTableResizing)=>{
    if (!node.attrs.width && options?.isChromelessEditor || !node.attrs.width && options?.isCommentEditor && allowTableResizing) return;
    // provide a width for tables when custom table width is supported
    // this is to ensure 'responsive' tables (colgroup widths are undefined) become fixed to
    // support screen size adjustments
    const shouldHaveInlineWidth = allowTableResizing && !(0, $bdb0299b531c40df$export$d4302a800316ebd6)(state, pos);
    let widthValue = (0, $6fQl1.getTableContainerWidth)(node);
    if (node.attrs.isNumberColumnEnabled) widthValue -= (0, $aFUXX.akEditorTableNumberColumnWidth);
    return shouldHaveInlineWidth ? widthValue : undefined;
};
const $1a05aa95aa438aa8$var$handleInlineTableWidth = (table, width)=>{
    if (!table || !width) return;
    table.style.setProperty('width', `${width}px`);
};
class $1a05aa95aa438aa8$export$2e2bcd8739ae039 extends (0, $2gkmX.default) {
    getContentDOM() {
        const isNested = (0, $bdb0299b531c40df$export$d4302a800316ebd6)(this.view.state, this.getPos());
        const tableDOMStructure = (0, $da7b34fe5d676606$export$477bb32cbededd65)({
            allowColumnResizing: !!this.reactComponentProps.allowColumnResizing,
            tableResizingEnabled: !!this.reactComponentProps.allowTableResizing,
            getEditorContainerWidth: this.reactComponentProps.getEditorContainerWidth,
            isTableScalingEnabled: this.reactComponentProps.options?.isTableScalingEnabled,
            shouldUseIncreasedScalingPercent: this.reactComponentProps.options?.shouldUseIncreasedScalingPercent,
            isCommentEditor: this.reactComponentProps.options?.isCommentEditor,
            isChromelessEditor: this.reactComponentProps.options?.isChromelessEditor,
            isNested: isNested
        }).toDOM(this.node);
        const rendered = (0, $5SAOw.DOMSerializer).renderSpec(document, tableDOMStructure);
        if (rendered.dom) {
            const tableElement = rendered.dom.querySelector('table');
            this.table = tableElement ? tableElement : rendered.dom;
            this.renderedDOM = rendered.dom;
            const allowFixedColumnWidthOption = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? this.reactComponentProps?.allowFixedColumnWidthOption : this.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption) || false;
            if (!this.options?.isTableScalingEnabled || this.options?.isTableScalingEnabled && allowFixedColumnWidthOption && this.node.attrs.displayMode === 'fixed') {
                const tableInlineWidth = $1a05aa95aa438aa8$var$getInlineWidth(this.node, this.reactComponentProps.options, this.reactComponentProps.view.state, this.reactComponentProps.getPos(), this.reactComponentProps.allowTableResizing);
                if (tableInlineWidth) $1a05aa95aa438aa8$var$handleInlineTableWidth(this.table, tableInlineWidth);
            }
        }
        return rendered;
    }
    /**
   * Handles moving the table from ProseMirror's DOM structure into a React-rendered table node.
   * Temporarily disables mutation observers (except for selection changes) during the move,
   * preserves selection state, and restores it afterwards if mutations occurred and cursor
   * wasn't at start of node. This prevents duplicate tables and maintains editor state during
   * the DOM manipulation.
   */ _handleTableRef(node) {
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // Only proceed if we have both a node and table, and the table isn't already inside the node
        if (node && this.table && !node.contains(this.table)) {
            // Store the current ignoreMutation handler so we can restore it later
            oldIgnoreMutation = this.ignoreMutation;
            // Set up a temporary mutation handler that:
            // - Ignores all DOM mutations except selection changes
            // - Tracks when mutations have been ignored via mutationsIgnored flag
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // Store the current selection state if there is a visible selection
            // This lets us restore it after DOM changes
            const { selection: selection } = this.view.state;
            const tablePos = this.getPos();
            if (selection.empty && tablePos && (0, $ks2lK.TextSelection).near(this.view.state.doc.resolve(tablePos)).from === selection.from) selectionBookmark = this.view.state.selection.getBookmark();
            if (this.dom) {
                this.dom.setAttribute('data-ssr-placeholder', `table-nodeview-${this.node.attrs.localId}`);
                this.dom.setAttribute('data-ssr-placeholder-replace', `table-nodeview-${this.node.attrs.localId}`);
            }
            // Remove the ProseMirror table DOM structure to avoid duplication, as it's replaced with the React table node.
            if (this.dom && this.renderedDOM) this.dom.removeChild(this.renderedDOM);
            // Move the table from the ProseMirror table structure into the React rendered table node.
            node.appendChild(this.table);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    /**
           * This handles a very specific case only -> insertion by the user of a new
           * table
           * Since it's behind a RAF it's possible the user has clicked elsewhere or
           * it affects collaborative users (which selection changes shouldn't ever)
           *
           * This ensures that the selectionBookmark *before* is inside the first
           * position in the table and that after it is the text position directly
           * before the table
           * Ideally we want to remove this RAF entirely but that would require removing
           * the DOM manipulation and is a more complex effort
           */ if (!resolvedSelection.eq(this.view.state.selection) && resolvedSelection.empty && // Ensure that the *next* valid text position matches the first position
                    // in the table
                    (0, $ks2lK.TextSelection).findFrom(this.view.state.doc.resolve(this.view.state.selection.from + 1), 1, true)?.eq(resolvedSelection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'TableNodeView:_handleTableRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    setDomAttrs(node) {
        if (!this.table) return; // width / attribute application to actual table will happen later when table is set
        const attrs = $1a05aa95aa438aa8$var$tableAttributes(node);
        // render table with content-mode attribute which removes all width constraints from the table
        // fire exposure here
        if ((0, $ixUmr.isTableInContentMode)({
            tableNode: node,
            isSupported: (0, $3a3941a6aa273892$export$e217d2a535d6ae45)({
                allowColumnResizing: !!this.reactComponentProps.allowColumnResizing,
                allowTableResizing: !!this.reactComponentProps.allowTableResizing,
                isFullPageEditor: !this.reactComponentProps.options?.isCommentEditor && !this.reactComponentProps.options?.isChromelessEditor
            }),
            isTableNested: (0, $bdb0299b531c40df$export$d4302a800316ebd6)(this.view.state, this.getPos())
        }) && (0, $1oCLl.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true)) attrs['data-initial-width-mode'] = 'content';
        Object.keys(attrs).forEach((attr)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.table.setAttribute(attr, attrs[attr]);
        });
        const isTableFixedColumnWidthsOptionEnabled = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? this.reactComponentProps?.allowFixedColumnWidthOption : this.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption) || false;
        // Preserve Table Width cannot have inline width set on the table
        if (!this.options?.isTableScalingEnabled || this.options?.isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled && node.attrs.displayMode === 'fixed') {
            // handle inline style when table been resized
            const tableInlineWidth = $1a05aa95aa438aa8$var$getInlineWidth(node, this.reactComponentProps.options, this.view.state, this.getPos(), this.reactComponentProps.allowTableResizing);
            const isTableResizing = (0, $e9b9e23609860f66$export$18d4026d1ea86bb1).getState(this.view.state)?.resizing;
            if (!isTableResizing && tableInlineWidth) $1a05aa95aa438aa8$var$handleInlineTableWidth(this.table, tableInlineWidth);
        }
    }
    render(props, forwardRef) {
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $fd705b3bea000047$export$b6d58ec6836e4dcf), {
            forwardRef: forwardRef,
            getNode: this.getNode,
            view: props.view,
            options: props.options,
            eventDispatcher: props.eventDispatcher,
            api: props.pluginInjectionApi,
            allowColumnResizing: props.allowColumnResizing,
            allowTableAlignment: props.allowTableAlignment,
            allowTableResizing: props.allowTableResizing,
            allowControls: props.allowControls,
            getPos: props.getPos,
            getEditorFeatureFlags: props.getEditorFeatureFlags,
            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
            allowFixedColumnWidthOption: props.allowFixedColumnWidthOption
        });
    }
    viewShouldUpdate(nextNode) {
        const { hoveredRows: hoveredRows } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(this.view.state);
        const hoveredRowsChanged = !!hoveredRows?.length !== this.hasHoveredRows;
        if (nextNode.attrs.isNumberColumnEnabled && hoveredRowsChanged) {
            this.hasHoveredRows = !!hoveredRows?.length;
            return true;
        }
        const node = this.getNode();
        if (typeof node.attrs !== typeof nextNode.attrs) return true;
        if ((0, $bdb0299b531c40df$export$8f2a10e9b102ac33)(node, nextNode) && (0, $1oCLl.expValEquals)('platform_editor_lovability_distribute_column_fix', 'isEnabled', true)) return true;
        const attrKeys = Object.keys(node.attrs);
        const nextAttrKeys = Object.keys(nextNode.attrs);
        if (attrKeys.length !== nextAttrKeys.length) return true;
        const tableMap = (0, $LmqWp.TableMap).get(node);
        const nextTableMap = (0, $LmqWp.TableMap).get(nextNode);
        if (tableMap.width !== nextTableMap.width) return true;
        return attrKeys.some((key)=>{
            return node.attrs[key] !== nextNode.attrs[key];
        });
    }
    ignoreMutation(mutation) {
        const { type: type, target: { nodeName: nodeName, firstChild: firstChild } } = mutation;
        if (type === 'selection' && nodeName?.toUpperCase() === 'DIV' && firstChild?.nodeName.toUpperCase() === 'TABLE') return false;
        // ED-16668
        // Do not remove this fixes an issue with windows firefox that relates to
        // the addition of the shadow sentinels
        if (type === 'selection' && nodeName?.toUpperCase() === 'TABLE' && (firstChild?.nodeName.toUpperCase() === 'COLGROUP' || firstChild?.nodeName.toUpperCase() === 'SPAN')) return false;
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    destroy() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.eventDispatcher?.emit('TABLE_DELETED', this.node);
        super.destroy();
    }
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props, undefined, undefined, // @portal-render-immediately
        true);
        this.table = void 0;
        this.renderedDOM = void 0;
        this.resizeObserver = void 0;
        this.eventDispatcher = void 0;
        this.getPos = void 0;
        this.options = void 0;
        this.getEditorFeatureFlags = void 0;
        this.getNode = ()=>{
            return this.node;
        };
        this.hasHoveredRows = false;
        this.getPos = props.getPos;
        this.eventDispatcher = props.eventDispatcher;
        this.options = props.options;
        this.getEditorFeatureFlags = props.getEditorFeatureFlags;
        this.handleRef = (node)=>this._handleTableRef(node);
    }
}
const $1a05aa95aa438aa8$export$f0e1dd383a612bf9 = (node, view, getPos, portalProviderAPI, eventDispatcher, getEditorContainerWidth, getEditorFeatureFlags, dispatchAnalyticsEvent, pluginInjectionApi, isCommentEditor, isChromelessEditor, allowFixedColumnWidthOption)=>{
    const { pluginConfig: pluginConfig, isDragAndDropEnabled: isDragAndDropEnabled, isTableScalingEnabled: isTableScalingEnabled // same as options.isTableScalingEnabled
     } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(view.state);
    // Use shared state for isFullWidthModeEnabled and wasFullWidthModeEnabled for most up-to-date values
    const tableState = pluginInjectionApi?.table?.sharedState.currentState();
    const { allowColumnResizing: allowColumnResizing, allowControls: allowControls, allowTableResizing: allowTableResizing, allowTableAlignment: allowTableAlignment } = (0, $46b4a5487442d4d4$export$c23fbabe48bd9130)(pluginConfig);
    const isTableFixedColumnWidthsOptionEnabled = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? allowFixedColumnWidthOption : getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption) || false;
    const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || isCommentEditor);
    return new $1a05aa95aa438aa8$export$2e2bcd8739ae039({
        node: node,
        view: view,
        allowColumnResizing: allowColumnResizing,
        allowTableResizing: allowTableResizing,
        allowTableAlignment: allowTableAlignment,
        allowControls: allowControls,
        portalProviderAPI: portalProviderAPI,
        eventDispatcher: eventDispatcher,
        getPos: getPos,
        options: {
            isFullWidthModeEnabled: tableState?.isFullWidthModeEnabled,
            wasFullWidthModeEnabled: tableState?.wasFullWidthModeEnabled,
            isDragAndDropEnabled: isDragAndDropEnabled,
            isTableScalingEnabled: isTableScalingEnabled,
            isCommentEditor: // same as options.isTableScalingEnabled
            isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent
        },
        getEditorContainerWidth: getEditorContainerWidth,
        getEditorFeatureFlags: getEditorFeatureFlags,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption
    }).init();
};













class $aa5e4371d8281b79$export$2e2bcd8739ae039 {
    /**
   * @constructor
   */ constructor(node, view, getPos, eventDispatcher){
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.eventDispatcher = eventDispatcher;
        /**
     * Variables
     */ this.dom = void 0;
        this.contentDOM = void 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { dom: dom, contentDOM: contentDOM } = (0, $5SAOw.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node));
        this.dom = dom;
        this.contentDOM = contentDOM;
    }
}


const $aeff2d6ebbdab783$var$DEFAULT_COL_SPAN = 1;
const $aeff2d6ebbdab783$var$DEFAULT_ROW_SPAN = 1;
/**
 * For performance reasons we do this in the background - it shouldn't block the main thread
 */ function $aeff2d6ebbdab783$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $aeff2d6ebbdab783$var$cssVariablePattern = /^VAR\(--.*\)$/;
class $aeff2d6ebbdab783$export$2e2bcd8739ae039 extends (0, $aa5e4371d8281b79$export$2e2bcd8739ae039) {
    update(node) {
        const didUpdate = this.updateNodeView(node);
        if (didUpdate) this.node = node;
        return didUpdate;
    }
    updateNodeView(node) {
        if (this.node.type !== node.type) return false;
        const attrs = (0, $63Ztt.getCellDomAttrs)(this.node);
        const nextAttrs = (0, $63Ztt.getCellDomAttrs)(node);
        const { colspan: colspan, rowspan: rowspan } = (0, $63Ztt.getCellAttrs)(this.dom);
        // need to rerender when colspan/rowspan in dom are different from the node attrs
        // this can happen when undoing merge cells
        if (colspan !== (node.attrs.colspan || $aeff2d6ebbdab783$var$DEFAULT_COL_SPAN) || rowspan !== (node.attrs.rowspan || $aeff2d6ebbdab783$var$DEFAULT_ROW_SPAN)) return false;
        // added + changed attributes
        const addedAttrs = Object.entries(nextAttrs).filter(([key, value])=>attrs[key] !== value);
        const removedAttrs = Object.keys(attrs).filter((key)=>!nextAttrs.hasOwnProperty(key));
        if (addedAttrs.length || removedAttrs.length) {
            addedAttrs.forEach(([key, value])=>this.dom.setAttribute(key, value || ''));
            removedAttrs.forEach((key)=>this.dom.removeAttribute(key));
            return true;
        }
        // Return true to not re-render this node view
        if (this.node.sameMarkup(node)) return true;
        return false;
    }
    constructor(node, view, getPos, eventDispatcher, editorAnalyticsAPI){
        super(node, view, getPos, eventDispatcher);
        // CONFCLOUD-78239: Previously we had a bug which tried to invert the heading colour of a table
        // Obviously design tokens can't be inverted and so it would result in `VAR(--DS-BACKGROUND-ACCENT-GRAY-SUBTLEST, #F4F5F7)`
        // which is not a valid CSS variable.
        //
        // We should follow-up and remove this in TODO-xx in 6 months once we're confident
        // that this has fixed most of the cases in the wild.
        //
        // This is a workaround to fix those cases on the fly. Note it is super specific on purpose
        // so that it just fixes the heading token (other tokens should be unaffected)
        // At some point in the future
        this.delayHandle = void 0;
        this.destroy = ()=>{
            if (this.delayHandle && typeof window !== 'undefined') {
                // eslint-disable-next-line compat/compat
                window?.cancelIdleCallback?.(this.delayHandle);
                window?.cancelAnimationFrame?.(this.delayHandle);
            }
        };
        if ($aeff2d6ebbdab783$var$cssVariablePattern.test(node.attrs.background)) this.delayHandle = $aeff2d6ebbdab783$var$delayUntilIdle(()=>{
            const pos = getPos();
            if (pos) {
                const tr = view.state.tr;
                tr.setNodeAttribute(pos, 'background', node.attrs.background.toLowerCase())// Ensures dispatch does not contribute to undo history (otherwise user requires multiple undo's to revert table)
                .setMeta('addToHistory', false);
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $3824I.TABLE_ACTION).TABLE_CELL_BACKGROUND_FIXED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })(tr);
                view.dispatch(tr);
            }
        });
    }
}



var $jSnXV = parcelRequire("jSnXV");


var $8Yfbq = parcelRequire("8Yfbq");















// eslint-disable-next-line import/order




const $738e0202c4e34f01$var$reducer = (pluginState, action)=>{
    if (action.name === 'UPDATE') {
        let updated = false;
        const updatedState = pluginState.map((oldTableState)=>{
            const replace = oldTableState.pos === action.state.pos;
            if (replace) updated = true;
            return replace ? action.state : oldTableState;
        });
        if (!updated) // new, add it
        updatedState.push(action.state);
        return updatedState;
    } else if (action.name === 'REMOVE') return pluginState.filter((rowState)=>rowState.pos !== action.pos);
    return pluginState;
};
const $738e0202c4e34f01$var$dest = (0, $lkJUe.pluginFactory)((0, $1562ea854f0ae047$export$18d4026d1ea86bb1), $738e0202c4e34f01$var$reducer, {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) return pluginState.map((rowInfo)=>{
            const remapped = tr.mapping.mapResult(rowInfo.pos);
            return remapped ? {
                ...rowInfo,
                pos: remapped.pos
            } : undefined;
        }).filter((f)=>f !== undefined);
        return pluginState;
    }
});
const $738e0202c4e34f01$export$656c7661095efe2e = $738e0202c4e34f01$var$dest.createPluginState;
const $738e0202c4e34f01$export$8d4021544bdece00 = $738e0202c4e34f01$var$dest.createCommand;


const $1e600b287caa90c3$export$dd348cf8bfd51272 = (rowState)=>(0, $738e0202c4e34f01$export$8d4021544bdece00)({
        name: 'UPDATE',
        state: rowState
    }, (tr)=>tr.setMeta('addToHistory', false));
const $1e600b287caa90c3$export$98af81c5504c750e = (pos)=>(0, $738e0202c4e34f01$export$8d4021544bdece00)({
        name: 'REMOVE',
        pos: pos
    }, (tr)=>tr.setMeta('addToHistory', false));








// limit scroll event calls
const $41994fbd33408f1b$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT = 200;
// timeout for resetting the scroll class - if it's too long then users won't be able to click on the header cells,
// if too short it would trigger too many dom updates.
const $41994fbd33408f1b$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT = 400;
class $41994fbd33408f1b$export$2e2bcd8739ae039 extends (0, $aa5e4371d8281b79$export$2e2bcd8739ae039) {
    subscribeWhenRowVisible() {
        if (this.listening) return;
        this.dom.setAttribute('data-header-row', 'true');
        if (this.isStickyHeaderEnabled) this.subscribe();
    }
    /**
   * Methods: Nodeview Lifecycle
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    update(node, ..._args) {
        // do nothing if nodes were identical
        if (node === this.node) return true;
        // see if we're changing into a header row or
        // changing away from one
        const newNodeIsHeaderRow = (0, $bdb0299b531c40df$export$4af45fdaadf67b18)(node);
        if (this.isHeaderRow !== newNodeIsHeaderRow) return false; // re-create nodeview
        // node is different but no need to re-create nodeview
        this.node = node;
        // don't do anything if we're just a regular tr
        if (!this.isHeaderRow) return true;
        // something changed, sync widths
        if (this.isStickyHeaderEnabled) {
            const tbody = this.dom.parentElement;
            const table = tbody && tbody.parentElement;
            (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(table);
        }
        return true;
    }
    destroy() {
        if (this.isStickyHeaderEnabled) {
            this.unsubscribe();
            this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
            const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
            if (tree) this.makeRowHeaderNotSticky(tree.table, true);
            this.emitOff(true);
        }
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('limited-mode-activated', this.cleanup);
        if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
    }
    ignoreMutation(mutationRecord) {
        /* tableRows are not directly editable by the user
     * so it should be safe to ignore mutations that we cause
     * by updating styles and classnames on this DOM element
     *
     * Update: should not ignore mutations for row selection to avoid known issue with table selection highlight in firefox
     * Related bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=1289673
     * */ const isTableSelection = mutationRecord.type === 'selection' && mutationRecord.target.nodeName === 'TR';
        /**
     * Update: should not ignore mutations when an node is added, as this interferes with
     * prosemirrors handling of some language inputs in Safari (ie. Pinyin, Hiragana).
     *
     * In paticular, when a composition occurs at the start of the first node inside a table cell, if the resulting mutation
     * from the composition end is ignored than prosemirror will end up with; invalid table markup nesting and a misplaced
     * selection and insertion.
     */ const isNodeInsertion = mutationRecord.type === 'childList' && mutationRecord.target.nodeName === 'TR' && mutationRecord.addedNodes.length;
        if (isTableSelection || isNodeInsertion) return false;
        return true;
    }
    subscribe() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorScrollableElement = (0, $7YjFd.findOverflowScrollParent)(this.view.dom) || window;
        if (this.editorScrollableElement) {
            this.initObservers();
            this.topPosEditorElement = (0, $c2cd42e9bb213cdd$export$449115d164fc37c3)(this.editorScrollableElement);
        }
        this.eventDispatcher.on('widthPlugin', this.updateStickyHeaderWidth.bind(this));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.on((0, $fedf15e5199146e8$export$18d4026d1ea86bb1).key, this.onTablePluginState.bind(this));
        this.listening = true;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('wheel', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('touchmove', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
    }
    unsubscribe() {
        if (!this.listening) return;
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            // ED-16211 Once intersection observer is disconnected, we need to remove the isObserved from the sentinels
            // Otherwise when newer intersection observer is created it will not observe because it thinks its already being observed
            [
                this.sentinels.top,
                this.sentinels.bottom
            ].forEach((el)=>{
                if (el) delete el.dataset.isObserved;
            });
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.eventDispatcher.off('widthPlugin', this.updateStickyHeaderWidth);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.off((0, $fedf15e5199146e8$export$18d4026d1ea86bb1).key, this.onTablePluginState);
        this.listening = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('wheel', this.headerRowMouseScroll);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('touchmove', this.headerRowMouseScroll);
    }
    // initialize intersection observer to track if table is within scroll area
    initObservers() {
        if (!this.dom || this.dom.dataset.isObserved) return;
        this.dom.dataset.isObserved = 'true';
        this.createIntersectionObserver();
        this.createResizeObserver();
        if (!this.intersectionObserver || !this.resizeObserver) return;
        this.resizeObserver.observe(this.dom);
        if (this.editorScrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.resizeObserver.observe(this.editorScrollableElement);
        window.requestAnimationFrame(()=>{
            const getTableContainer = ()=>(0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom)?.wrapper.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}`);
            // we expect tree to be defined after animation frame
            let tableContainer = getTableContainer();
            if (tableContainer) {
                const getSentinelTop = ()=>tableContainer && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    tableContainer.getElementsByClassName((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP).item(0);
                const getSentinelBottom = ()=>{
                    // Multiple bottom sentinels may be found if there are nested tables.
                    // We need to make sure we get the last one which will belong to the parent table.
                    const bottomSentinels = tableContainer && tableContainer.getElementsByClassName((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM);
                    return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    bottomSentinels && bottomSentinels.item(bottomSentinels.length - 1));
                };
                const sentinelsInDom = ()=>getSentinelTop() !== null && getSentinelBottom() !== null;
                const observeStickySentinels = ()=>{
                    this.sentinels.top = getSentinelTop();
                    this.sentinels.bottom = getSentinelBottom();
                    [
                        this.sentinels.top,
                        this.sentinels.bottom
                    ].forEach((el)=>{
                        // skip if already observed for another row on this table
                        if (el && !el.dataset.isObserved) {
                            el.dataset.isObserved = 'true';
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.intersectionObserver.observe(el);
                        }
                    });
                };
                const isInitialProsemirrorToDomRender = tableContainer.hasAttribute('data-prosemirror-initial-toDOM-render');
                // Sentinels may be in the DOM but they're part of the prosemirror placeholder structure which is replaced with the fully rendered React node.
                if (sentinelsInDom() && !isInitialProsemirrorToDomRender) // great - DOM ready, observe as normal
                observeStickySentinels();
                else {
                    // concurrent loading issue - here TableRow is too eager trying to
                    // observe sentinels before they are in the DOM, use MutationObserver
                    // to wait for sentinels to be added to the parent Table node DOM
                    // then attach the IntersectionObserver
                    this.tableContainerObserver = new MutationObserver(()=>{
                        // Check if the tableContainer is still connected to the DOM. It can become disconnected when the placholder
                        // prosemirror node is replaced with the fully rendered React node (see _handleTableRef).
                        if (!tableContainer || !tableContainer.isConnected) tableContainer = getTableContainer();
                        if (sentinelsInDom()) {
                            observeStickySentinels();
                            this.tableContainerObserver?.disconnect();
                        }
                    });
                    const mutatingNode = tableContainer;
                    if (mutatingNode && this.tableContainerObserver) this.tableContainerObserver.observe(mutatingNode, {
                        subtree: true,
                        childList: true
                    });
                }
            }
        });
    }
    // updating bottom sentinel position if sticky header height changes
    // to allocate for new header height
    createResizeObserver() {
        this.resizeObserver = new ResizeObserver((entries)=>{
            const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
            if (!tree) return;
            const { table: table } = tree;
            entries.forEach((entry)=>{
                // On resize of the parent scroll element we need to adjust the width
                // of the sticky header
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (entry.target.className === this.editorScrollableElement?.className) this.updateStickyHeaderWidth();
                else {
                    const newHeight = entry.contentRect ? entry.contentRect.height : // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    entry.target.offsetHeight;
                    if (this.sentinels.bottom && // When the table header is sticky, it would be taller by a 1px (border-bottom),
                    // So we adding this check to allow a 1px difference.
                    Math.abs(newHeight - (this.stickyRowHeight || 0)) > (0, $fbbb9ee8877c285e$export$13b0e72269a9a3aa)) {
                        this.stickyRowHeight = newHeight;
                        this.sentinels.bottom.style.bottom = `${(0, $fbbb9ee8877c285e$export$92421f8864c287b1) + (0, $fbbb9ee8877c285e$export$83c60dd0aac17107) + newHeight}px`;
                        (0, $b432f0a26e9b5b59$export$ec6da316e37a54bf)(table);
                    }
                }
            });
        });
    }
    createIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            // IMPORTANT: please try and avoid using entry.rootBounds it's terribly inconsistent. For example; sometimes it may return
            // 0 height. In safari it will multiply all values by the window scale factor, however chrome & firfox won't.
            // This is why i just get the scroll view bounding rect here and use it, and fallback to the entry.rootBounds if needed.
            const rootBounds = this.editorScrollableElement?.getBoundingClientRect?.();
            entries.forEach((entry)=>{
                const { target: target, isIntersecting: isIntersecting, boundingClientRect: boundingClientRect } = entry;
                // This observer only every looks at the top/bottom sentinels, we can assume if it's not one then it's the other.
                const targetKey = target.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP) ? 'top' : 'bottom';
                // Cache the latest sentinel information
                this.sentinelData[targetKey] = {
                    isIntersecting: isIntersecting,
                    boundingClientRect: boundingClientRect,
                    rootBounds: rootBounds ?? entry.rootBounds
                };
                // Keep the other sentinels rootBounds in sync with this latest one
                this.sentinelData[targetKey === 'top' ? 'bottom' : targetKey].rootBounds = rootBounds ?? entry.rootBounds;
            });
            this.refreshStickyState();
        }, {
            threshold: 0,
            root: this.editorScrollableElement
        });
    }
    refreshStickyState() {
        const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        const { table: table } = tree;
        const shouldStick = this.shouldSticky();
        if (this.isSticky !== shouldStick) {
            if (shouldStick) {
                // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
                const rootRect = this.sentinelData.top.rootBounds ?? this.sentinelData.bottom.rootBounds;
                this.makeHeaderRowSticky(tree, rootRect?.top);
            } else this.makeRowHeaderNotSticky(table);
        }
    }
    shouldSticky() {
        if (// is Safari
        navigator.userAgent.includes('AppleWebKit') && !navigator.userAgent.includes('Chrome')) {
            const pos = this.getPos();
            if (typeof pos === 'number') {
                const $tableRowPos = this.view.state.doc.resolve(pos);
                // layout -> layout column -> table -> table row
                if ($tableRowPos.depth >= 3) {
                    const isInsideLayout = (0, $8m4tT.findParentNodeClosestToPos)($tableRowPos, (node)=>{
                        return node.type.name === 'layoutColumn';
                    })?.node;
                    if (isInsideLayout) return false;
                }
            }
        }
        return this.isHeaderSticky();
    }
    isHeaderSticky() {
        /*
      # Overview
        I'm going to list all the view states associated with the sentinels and when they should trigger sticky headers.
        The format of the states are;    {top|bottom}:{in|above|below}
        ie sentinel:view-position -- both "above" and "below" are equal to out of the viewport
         For example; "top:in" means top sentinel is within the viewport. "bottom:above" means the bottom sentinel is
        above and out of the viewport
         This will hopefully simplify things and make it easier to determine when sticky should/shouldn't be triggered.
       # States
        top:in / bottom:in - NOT sticky
        top:in / bottom:above - NOT sticky - NOTE: This is an inversion clause
        top:in / bottom:below - NOT sticky
        top:above / bottom:in - STICKY
        top:above / bottom:above - NOT sticky
        top:above / bottom:below - STICKY
        top:below / bottom:in - NOT sticky - NOTE: This is an inversion clause
        top:below / bottom:above - NOT sticky - NOTE: This is an inversion clause
        top:below / bottom:below - NOT sticky
       # Summary
        The only time the header should be sticky is when the top sentinel is above the view and the bottom sentinel
        is in or below it.
      */ const { top: sentinelTop, bottom: sentinelBottom } = this.sentinelData;
        // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
        const rootBounds = sentinelTop.rootBounds ?? sentinelBottom.rootBounds;
        if (!rootBounds || !sentinelTop.boundingClientRect || !sentinelBottom.boundingClientRect) return false;
        // Normalize the sentinels to y points
        // Since the sentinels are actually rects 1px high we want make sure we normalise the inner most values closest to the table.
        const sentinelTopY = sentinelTop.boundingClientRect.bottom;
        const sentinelBottomY = sentinelBottom.boundingClientRect.top;
        // If header row height is more than 50% of viewport height don't do this
        const isRowHeaderTooLarge = this.stickyRowHeight && this.stickyRowHeight > window.innerHeight * 0.5;
        const isTopSentinelAboveScrollArea = !sentinelTop.isIntersecting && sentinelTopY <= rootBounds.top;
        const isBottomSentinelInOrBelowScrollArea = sentinelBottom.isIntersecting || sentinelBottomY > rootBounds.bottom;
        // This makes sure that the top sentinel is actually above the bottom sentinel, and that they havn't inverted.
        const isTopSentinelAboveBottomSentinel = sentinelTopY < sentinelBottomY;
        return isTopSentinelAboveScrollArea && isBottomSentinelInOrBelowScrollArea && isTopSentinelAboveBottomSentinel && !isRowHeaderTooLarge;
    }
    /* receive external events */ onTablePluginState(state) {
        const tableRef = state.tableRef;
        const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        // when header rows are toggled off - mark sentinels as unobserved
        if (!state.isHeaderRowEnabled) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el) delete el.dataset.isObserved;
        });
        const isCurrentTableSelected = tableRef === tree.table;
        // If current table selected and header row is toggled off, turn off sticky header
        if (isCurrentTableSelected && !state.isHeaderRowEnabled && tree) this.makeRowHeaderNotSticky(tree.table);
        this.focused = isCurrentTableSelected;
        const { wrapper: wrapper } = tree;
        const tableContainer = wrapper.parentElement;
        const tableContentWrapper = tableContainer?.parentElement;
        const parentContainer = tableContentWrapper && tableContentWrapper.parentElement;
        const isTableInsideLayout = parentContainer && parentContainer.getAttribute('data-layout-content');
        if (tableContentWrapper) {
            if (isCurrentTableSelected) {
                this.colControlsOffset = (0, $fbbb9ee8877c285e$export$880976487022eb5);
                // move table a little out of the way
                // to provide spacing for table controls
                if (isTableInsideLayout) tableContentWrapper.style.paddingLeft = '11px';
            } else {
                this.colControlsOffset = 0;
                if (isTableInsideLayout) tableContentWrapper.style.removeProperty('padding-left');
            }
        }
        // run after table style changes have been committed
        setTimeout(()=>{
            (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(tree.table);
        }, 0);
    }
    updateStickyHeaderWidth() {
        // table width might have changed, sync that back to sticky row
        const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(tree.table);
    }
    /**
   * Manually refire the intersection observers.
   * Useful when the header may have detached from the table.
   */ refireIntersectionObservers() {
        if (this.isSticky) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el && this.intersectionObserver) {
                this.intersectionObserver.unobserve(el);
                this.intersectionObserver.observe(el);
            }
        });
    }
    makeHeaderRowSticky(tree, scrollTop) {
        // If header row height is more than 50% of viewport height don't do this
        if (this.isSticky || this.stickyRowHeight && this.stickyRowHeight > window.innerHeight / 2 || this.isInNestedTable) return;
        const { table: table, wrapper: wrapper } = tree;
        // TODO: ED-16035 - Make sure sticky header is only applied to first row
        const tbody = this.dom.parentElement;
        const isFirstHeader = tbody?.firstChild?.isEqualNode(this.dom);
        if (!isFirstHeader) return;
        const currentTableTop = this.getCurrentTableTop(tree);
        if (!scrollTop) scrollTop = (0, $c2cd42e9bb213cdd$export$449115d164fc37c3)(this.editorScrollableElement);
        const domTop = currentTableTop > 0 ? scrollTop : scrollTop + currentTableTop;
        if (!this.isSticky) {
            (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(table);
            this.dom.classList.add('sticky');
            table.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY);
            this.isSticky = true;
            /**
       * The logic below is not desirable, but acts as a fail safe for scenarios where the sticky header
       * detaches from the table. This typically happens during a fast scroll by the user which causes
       * the intersection observer logic to not fire as expected.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.editorScrollableElement?.addEventListener('scrollend', this.refireIntersectionObservers, {
                passive: true,
                once: true
            });
            const fastScrollThresholdMs = 500;
            setTimeout(()=>{
                this.refireIntersectionObservers();
            }, fastScrollThresholdMs);
        }
        this.dom.style.top = `0px`;
        (0, $b432f0a26e9b5b59$export$ec6da316e37a54bf)(table);
        this.dom.scrollLeft = wrapper.scrollLeft;
        this.emitOn(domTop, this.colControlsOffset);
    }
    makeRowHeaderNotSticky(table, isEditorDestroyed = false) {
        if (!this.isSticky || !table || !this.dom) return;
        this.dom.style.removeProperty('width');
        this.dom.classList.remove('sticky');
        table.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY);
        this.isSticky = false;
        this.dom.style.top = '';
        table.style.removeProperty('margin-top');
        this.emitOff(isEditorDestroyed);
    }
    getWrapperoffset(inverse = false) {
        const focusValue = inverse ? !this.focused : this.focused;
        return focusValue ? 0 : (0, $fbbb9ee8877c285e$export$880976487022eb5);
    }
    getWrapperRefTop(wrapper) {
        return Math.round((0, $c2cd42e9bb213cdd$export$449115d164fc37c3)(wrapper)) + this.getWrapperoffset();
    }
    getScrolledTableTop(wrapper) {
        return this.getWrapperRefTop(wrapper) - this.topPosEditorElement;
    }
    getCurrentTableTop(tree) {
        return this.getScrolledTableTop(tree.wrapper) + tree.table.clientHeight;
    }
    /* emit external events */ emitOn(top, padding) {
        if (top === this.top && padding === this.padding) return;
        this.top = top;
        this.padding = padding;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (Number.isFinite(pos)) (0, $1e600b287caa90c3$export$dd348cf8bfd51272)({
            pos: pos,
            top: top,
            sticky: true,
            padding: padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    emitOff(isEditorDestroyed) {
        if (this.top === 0 && this.padding === 0) return;
        this.top = 0;
        this.padding = 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (!isEditorDestroyed && Number.isFinite(pos)) (0, $1e600b287caa90c3$export$dd348cf8bfd51272)({
            pos: pos,
            sticky: false,
            top: this.top,
            padding: this.padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    constructor(node, view, getPos, eventDispatcher, api){
        super(node, view, getPos, eventDispatcher);
        this.nodeVisibilityObserverCleanupFn = void 0;
        this.cleanup = ()=>{
            if (this.isStickyHeaderEnabled) {
                this.unsubscribe();
                this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
                const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
                if (tree) this.makeRowHeaderNotSticky(tree.table, true);
                this.emitOff(false);
            }
            if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
        };
        /**
     * Variables
     */ this.isHeaderRow = void 0;
        this.isInNestedTable = void 0;
        this.isStickyHeaderEnabled = void 0;
        this.editorScrollableElement = void 0;
        this.colControlsOffset = 0;
        this.focused = false;
        this.topPosEditorElement = 0;
        this.isSticky = void 0;
        this.intersectionObserver = void 0;
        this.resizeObserver = void 0;
        this.tableContainerObserver = void 0;
        this.sentinels = {};
        this.sentinelData = {
            top: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            },
            bottom: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            }
        };
        this.stickyRowHeight = void 0;
        this.listening = false;
        this.padding = 0;
        this.top = 0;
        /**
     * Methods
     */ this.headerRowMouseScrollEnd = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            this.dom.classList.remove('no-pointer-events');
        }, $41994fbd33408f1b$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT);
        // When the header is sticky, the header row is set to position: fixed
        // This prevents mouse wheel scrolling on the scroll-parent div when user's mouse is hovering the header row.
        // This fix sets pointer-events: none on the header row briefly to avoid this behaviour
        this.headerRowMouseScroll = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(()=>{
            if (this.isSticky) {
                this.dom.classList.add('no-pointer-events');
                this.headerRowMouseScrollEnd();
            }
        }, $41994fbd33408f1b$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT);
        this.isHeaderRow = (0, $bdb0299b531c40df$export$4af45fdaadf67b18)(node);
        this.isSticky = false;
        const { pluginConfig: pluginConfig } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(view.state);
        this.isStickyHeaderEnabled = !!pluginConfig.stickyHeaders;
        if (api?.limitedMode?.sharedState.currentState()?.limitedModePluginKey.getState(view.state)?.documentSizeBreachesThreshold) {
            this.isStickyHeaderEnabled = false;
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('limited-mode-activated', this.cleanup);
        }
        const pos = this.getPos();
        this.isInNestedTable = false;
        try {
            // We cannot trust that the value from getPos will be defined
            // https://discuss.prosemirror.net/t/getpos-is-undefined-in-nodeview-constructor/1246/4
            // There are also scenarios where the value it brings back does not tally with the current doc
            // E.g. when AI streaming brings in new content, this position brings back incorrect values that cannot be resolved
            if (pos) this.isInNestedTable = (0, $sxTNo.getParentOfTypeCount)(view.state.schema.nodes.table)(view.state.doc.resolve(pos)) > 1;
        } catch  {
        // Intentionally swallowed — getPos can return stale positions during AI streaming
        }
        if (this.isHeaderRow) {
            this.dom.setAttribute('data-vc-nvs', 'true');
            const { observe: observe } = (0, $92LVN.nodeVisibilityManager)(view.dom);
            this.nodeVisibilityObserverCleanupFn = observe({
                element: this.contentDOM,
                onFirstVisible: ()=>{
                    this.subscribeWhenRowVisible();
                }
            });
        }
    }
}












































// limit scroll event calls
const $9ce7b5ba4bcfa9b7$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT = 200;
// timeout for resetting the scroll class - if it's too long then users won't be able to click on the header cells,
// if too short it would trigger too many dom updates.
const $9ce7b5ba4bcfa9b7$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT = 400;
class $9ce7b5ba4bcfa9b7$export$2e2bcd8739ae039 extends (0, $aa5e4371d8281b79$export$2e2bcd8739ae039) {
    subscribeWhenRowVisible() {
        if (this.listening) return;
        this.dom.setAttribute('data-header-row', 'true');
        if (this.isStickyHeaderEnabled) this.subscribe();
    }
    /**
   * Methods: Nodeview Lifecycle
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    update(node, ..._args) {
        // do nothing if nodes were identical
        if (node === this.node) return true;
        // see if we're changing into a header row or
        // changing away from one
        const newNodeIsHeaderRow = (0, $bdb0299b531c40df$export$4af45fdaadf67b18)(node);
        if (this.isHeaderRow !== newNodeIsHeaderRow) {
            if (!newNodeIsHeaderRow && this.isHeaderRow) this.dom.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`)?.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
            return false; // re-create nodeview
        }
        // node is different but no need to re-create nodeview
        this.node = node;
        // don't do anything if we're just a regular tr
        if (!this.isHeaderRow) return true;
        // something changed, sync widths
        if (this.isStickyHeaderEnabled) {
            const tbody = this.dom.parentElement;
            const table = tbody && tbody.parentElement;
            (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(table);
        }
        return true;
    }
    destroy() {
        if (this.isStickyHeaderEnabled) {
            this.unsubscribe();
            this.overflowObserver && this.overflowObserver.disconnect();
            this.overflowObserverEntries = undefined;
            this.stickyStateObserver && this.stickyStateObserver.disconnect();
            this.nodeVisibilityObserver?.disconnect();
            this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
            const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
            if (tree) this.makeRowHeaderNotLegacySticky(tree.table, true);
            this.emitOff(true);
        }
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('limited-mode-activated', this.cleanup);
        if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
    }
    ignoreMutation(mutationRecord) {
        /* tableRows are not directly editable by the user
     * so it should be safe to ignore mutations that we cause
     * by updating styles and classnames on this DOM element
     *
     * Update: should not ignore mutations for row selection to avoid known issue with table selection highlight in firefox
     * Related bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=1289673
     * */ const isTableSelection = mutationRecord.type === 'selection' && mutationRecord.target.nodeName === 'TR';
        /**
     * Update: should not ignore mutations when an node is added, as this interferes with
     * prosemirrors handling of some language inputs in Safari (ie. Pinyin, Hiragana).
     *
     * In paticular, when a composition occurs at the start of the first node inside a table cell, if the resulting mutation
     * from the composition end is ignored than prosemirror will end up with; invalid table markup nesting and a misplaced
     * selection and insertion.
     */ const isNodeInsertion = mutationRecord.type === 'childList' && mutationRecord.target.nodeName === 'TR' && mutationRecord.addedNodes.length;
        if (isTableSelection || isNodeInsertion) return false;
        return true;
    }
    subscribe() {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorScrollableElement = (0, $7YjFd.findOverflowScrollParent)(this.view.dom) || window;
        if (this.editorScrollableElement) {
            this.initObservers();
            this.topPosEditorElement = (0, $c2cd42e9bb213cdd$export$449115d164fc37c3)(this.editorScrollableElement);
            if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_5')) {
                this.scrollListener = ()=>{
                    if (this.hasScrolledSinceLoad) return;
                    this.hasScrolledSinceLoad = true;
                    if (!this.overflowObserver) return;
                    // Re-check intersection state now that scrolling has occurred
                    const entries = this.overflowObserverEntries ?? this.overflowObserver.takeRecords();
                    this.overflowObserverEntries = undefined;
                    /** NOTE: This logic is duplicated in the overflowObserver callback
           *  to avoid conflicting with a follow up refactor where this will
           *  be cleaned up.
           */ entries.forEach((entry)=>{
                        const tableWrapper = this.dom.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`);
                        if (tableWrapper && tableWrapper instanceof HTMLElement && (!(0, $c2cd42e9bb213cdd$export$732358707dcc2511)(entry) && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_10', 'isEnabled', true) || !(0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_10', 'isEnabled', true))) {
                            if (entry.isIntersecting) {
                                tableWrapper.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                                this.dom.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                                this.isNativeSticky = true;
                            } else {
                                tableWrapper.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                                this.dom.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                                this.isNativeSticky = false;
                            }
                            this.refreshLegacyStickyState();
                        }
                    });
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.editorScrollableElement.addEventListener('scroll', this.scrollListener, {
                    passive: true,
                    once: true
                });
            }
        }
        this.eventDispatcher.on('widthPlugin', this.updateStickyHeaderWidth.bind(this));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.on((0, $fedf15e5199146e8$export$18d4026d1ea86bb1).key, this.onTablePluginState.bind(this));
        this.listening = true;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('wheel', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('touchmove', this.headerRowMouseScroll.bind(this), {
            passive: true
        });
    }
    unsubscribe() {
        if (!this.listening) return;
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            // ED-16211 Once intersection observer is disconnected, we need to remove the isObserved from the sentinels
            // Otherwise when newer intersection observer is created it will not observe because it thinks its already being observed
            [
                this.sentinels.top,
                this.sentinels.bottom
            ].forEach((el)=>{
                if (el) delete el.dataset.isObserved;
            });
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.scrollListener && this.editorScrollableElement) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.editorScrollableElement.removeEventListener('scroll', this.scrollListener);
            this.scrollListener = undefined;
        }
        this.eventDispatcher.off('widthPlugin', this.updateStickyHeaderWidth);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventDispatcher.off((0, $fedf15e5199146e8$export$18d4026d1ea86bb1).key, this.onTablePluginState);
        this.listening = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('wheel', this.headerRowMouseScroll);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('touchmove', this.headerRowMouseScroll);
    }
    initOverflowObserver() {
        const tableWrapper = this.dom.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`);
        if (!tableWrapper) return;
        const options = {
            root: tableWrapper,
            threshold: 1
        };
        this.overflowObserver = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                if (!(observer.root instanceof HTMLElement)) return;
                // Only apply classes if page has scrolled since load
                if (!this.hasScrolledSinceLoad && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_5')) {
                    this.overflowObserverEntries = entries;
                    return;
                }
                if (entry.isIntersecting) {
                    if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_4')) {
                        observer.root.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                        if (!this.disableNativeSticky) this.dom.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                    } else {
                        observer.root.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                        this.dom.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                    }
                    this.isNativeSticky = true;
                } else {
                    if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_4')) {
                        observer.root.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                        this.dom.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                    } else {
                        observer.root.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                        this.dom.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                    }
                    this.isNativeSticky = false;
                }
                this.refreshLegacyStickyState();
                if ((0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true)) this.api?.analytics?.actions?.fireAnalyticsEvent({
                    action: (0, $3824I.TABLE_ACTION).STICKY_HEADER_METHOD_TOGGLED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TABLE_STICKY_HEADER,
                    eventType: (0, $d925B.EVENT_TYPE).UI,
                    attributes: {
                        nativeStickyHeaderEnabled: entry.isIntersecting
                    }
                });
            });
        }, options);
    }
    /**
   * This observer is used to track the 'stuck' state of the header row.
   * This roughly mimics `(at)container scroll-state(stuck: top)` in CSS,
   * but with full browser support.
   */ initStickyStateObserver() {
        if (!this.editorScrollableElement || !(this.editorScrollableElement instanceof Element)) return;
        const options = {
            root: this.editorScrollableElement,
            rootMargin: `-${(0, $1zav4.tableMarginTop) + 1}px 0px 0px 0px`,
            threshold: 1
        };
        this.stickyStateObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const tableContainer = this.dom.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}`);
                if (entry.intersectionRect.top === entry.rootBounds?.top && (!this.disableNativeSticky || !(0, $dh538.fg)('platform_editor_table_sticky_header_patch_4'))) {
                    this.dom.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE);
                    if (tableContainer && tableContainer instanceof HTMLElement) tableContainer.dataset.tableHeaderIsStuck = 'true';
                } else {
                    this.dom.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE);
                    if (tableContainer && tableContainer instanceof HTMLElement) {
                        if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_3')) delete tableContainer.dataset.tableHeaderIsStuck;
                        else tableContainer.dataset.tableHeaderIsStuck = 'false';
                    }
                }
            });
        }, options);
    }
    // initialize intersection observer to track if table is within scroll area
    initObservers() {
        if (!this.dom || this.dom.dataset.isObserved) return;
        this.dom.dataset.isObserved = 'true';
        this.createIntersectionObserver();
        this.createResizeObserver();
        if (!this.intersectionObserver || !this.resizeObserver) return;
        if (this.isHeaderRow && !this.isInNestedTable) {
            if ((0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) this.dom.style.setProperty('anchor-name', this.dom.getAttribute('data-node-anchor') ?? '');
            this.initOverflowObserver();
            if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_4')) this.initNodeVisibilityObserver();
            const closestTable = this.dom.closest('table');
            if (closestTable) {
                this.overflowObserver?.observe(closestTable);
                if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_4')) this.nodeVisibilityObserver?.observe(closestTable);
            }
            this.initStickyStateObserver();
            this.stickyStateObserver?.observe(this.dom);
        }
        this.resizeObserver.observe(this.dom);
        if (this.editorScrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.resizeObserver.observe(this.editorScrollableElement);
        window.requestAnimationFrame(()=>{
            const getTableContainer = ()=>(0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom)?.wrapper.closest(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}`);
            // we expect tree to be defined after animation frame
            let tableContainer = getTableContainer();
            if (tableContainer) {
                const getSentinelTop = ()=>tableContainer && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    tableContainer.getElementsByClassName((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP).item(0);
                const getSentinelBottom = ()=>{
                    // Multiple bottom sentinels may be found if there are nested tables.
                    // We need to make sure we get the last one which will belong to the parent table.
                    const bottomSentinels = tableContainer && tableContainer.getElementsByClassName((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM);
                    return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    bottomSentinels && bottomSentinels.item(bottomSentinels.length - 1));
                };
                const sentinelsInDom = ()=>getSentinelTop() !== null && getSentinelBottom() !== null;
                const observeStickySentinels = ()=>{
                    this.sentinels.top = getSentinelTop();
                    this.sentinels.bottom = getSentinelBottom();
                    [
                        this.sentinels.top,
                        this.sentinels.bottom
                    ].forEach((el)=>{
                        // skip if already observed for another row on this table
                        if (el && !el.dataset.isObserved) {
                            el.dataset.isObserved = 'true';
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.intersectionObserver.observe(el);
                        }
                    });
                };
                const isInitialProsemirrorToDomRender = tableContainer.hasAttribute('data-prosemirror-initial-toDOM-render');
                // Sentinels may be in the DOM but they're part of the prosemirror placeholder structure which is replaced with the fully rendered React node.
                if (sentinelsInDom() && !isInitialProsemirrorToDomRender) // great - DOM ready, observe as normal
                observeStickySentinels();
                else {
                    // concurrent loading issue - here TableRow is too eager trying to
                    // observe sentinels before they are in the DOM, use MutationObserver
                    // to wait for sentinels to be added to the parent Table node DOM
                    // then attach the IntersectionObserver
                    this.tableContainerObserver = new MutationObserver(()=>{
                        // Check if the tableContainer is still connected to the DOM. It can become disconnected when the placholder
                        // prosemirror node is replaced with the fully rendered React node (see _handleTableRef).
                        if (!tableContainer || !tableContainer.isConnected) tableContainer = getTableContainer();
                        if (sentinelsInDom()) {
                            observeStickySentinels();
                            this.tableContainerObserver?.disconnect();
                        }
                    });
                    const mutatingNode = tableContainer;
                    if (mutatingNode && this.tableContainerObserver) this.tableContainerObserver.observe(mutatingNode, {
                        subtree: true,
                        childList: true
                    });
                }
            }
        });
    }
    // initialise intersection observer to track whether table is in scroll area
    initNodeVisibilityObserver() {
        this.nodeVisibilityObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!this.isNativeSticky) return;
                if (entry.intersectionRatio !== 0 && entry.intersectionRatio !== 1) return;
                if (this.disableNativeSticky === true) this.dom.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
                if (this.disableNativeSticky === false) this.dom.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
            });
        }, {
            threshold: [
                0,
                0.05,
                0.95,
                1
            ]
        });
    }
    // updating bottom sentinel position if sticky header height changes
    // to allocate for new header height
    createResizeObserver() {
        this.resizeObserver = new ResizeObserver((entries)=>{
            const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
            if (!tree) return;
            const { table: table } = tree;
            entries.forEach((entry)=>{
                // On resize of the parent scroll element we need to adjust the width
                // of the sticky header
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (entry.target.className === this.editorScrollableElement?.className) this.updateStickyHeaderWidth();
                else {
                    const newHeight = entry.contentRect ? entry.contentRect.height : // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    entry.target.offsetHeight;
                    if (this.sentinels.bottom && // When the table header is sticky, it would be taller by a 1px (border-bottom),
                    // So we adding this check to allow a 1px difference.
                    Math.abs(newHeight - (this.stickyRowHeight || 0)) > (0, $fbbb9ee8877c285e$export$13b0e72269a9a3aa)) {
                        this.stickyRowHeight = newHeight;
                        this.sentinels.bottom.style.bottom = `${(0, $fbbb9ee8877c285e$export$92421f8864c287b1) + (0, $fbbb9ee8877c285e$export$83c60dd0aac17107) + newHeight}px`;
                        (0, $b432f0a26e9b5b59$export$ec6da316e37a54bf)(table);
                    }
                    if ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_4')) {
                        const viewportHeight = this.editorContentAreaHeight ?? (0, $c80e8922e1b59353$export$4d09e1a8cc78d53);
                        this.toggleDisableNativeSticky(newHeight, viewportHeight);
                    }
                }
            });
        });
    }
    createIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            // IMPORTANT: please try and avoid using entry.rootBounds it's terribly inconsistent. For example; sometimes it may return
            // 0 height. In safari it will multiply all values by the window scale factor, however chrome & firfox won't.
            // This is why i just get the scroll view bounding rect here and use it, and fallback to the entry.rootBounds if needed.
            const rootBounds = this.editorScrollableElement?.getBoundingClientRect?.();
            entries.forEach((entry)=>{
                const { target: target, isIntersecting: isIntersecting, boundingClientRect: boundingClientRect } = entry;
                // This observer only every looks at the top/bottom sentinels, we can assume if it's not one then it's the other.
                const targetKey = target.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP) ? 'top' : 'bottom';
                // Cache the latest sentinel information
                this.sentinelData[targetKey] = {
                    isIntersecting: isIntersecting,
                    boundingClientRect: boundingClientRect,
                    rootBounds: rootBounds ?? entry.rootBounds
                };
                // Keep the other sentinels rootBounds in sync with this latest one
                this.sentinelData[targetKey === 'top' ? 'bottom' : targetKey].rootBounds = rootBounds ?? entry.rootBounds;
            });
            this.refreshLegacyStickyState();
        }, {
            threshold: 0,
            root: this.editorScrollableElement
        });
    }
    refreshLegacyStickyState() {
        const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        const { table: table } = tree;
        if (this.isNativeSticky) {
            this.makeRowHeaderNotLegacySticky(table);
            return;
        }
        const shouldStick = this.shouldSticky();
        if (this.isLegacySticky !== shouldStick) {
            if (shouldStick) {
                // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
                const rootRect = this.sentinelData.top.rootBounds ?? this.sentinelData.bottom.rootBounds;
                this.makeHeaderRowLegacySticky(tree, rootRect?.top);
            } else this.makeRowHeaderNotLegacySticky(table);
        }
    }
    shouldSticky() {
        if (// is Safari
        navigator.userAgent.includes('AppleWebKit') && !navigator.userAgent.includes('Chrome')) {
            const pos = this.getPos();
            if (typeof pos === 'number') {
                const $tableRowPos = this.view.state.doc.resolve(pos);
                // layout -> layout column -> table -> table row
                if ($tableRowPos.depth >= 3) {
                    const isInsideLayout = (0, $8m4tT.findParentNodeClosestToPos)($tableRowPos, (node)=>{
                        return node.type.name === 'layoutColumn';
                    })?.node;
                    if (isInsideLayout) return false;
                }
            }
        }
        return this.isHeaderSticky();
    }
    isHeaderSticky() {
        /*
    # Overview
     I'm going to list all the view states associated with the sentinels and when they should trigger sticky headers.
     The format of the states are;    {top|bottom}:{in|above|below}
     ie sentinel:view-position -- both "above" and "below" are equal to out of the viewport
      For example; "top:in" means top sentinel is within the viewport. "bottom:above" means the bottom sentinel is
     above and out of the viewport
      This will hopefully simplify things and make it easier to determine when sticky should/shouldn't be triggered.
    # States
     top:in / bottom:in - NOT sticky
     top:in / bottom:above - NOT sticky - NOTE: This is an inversion clause
     top:in / bottom:below - NOT sticky
     top:above / bottom:in - STICKY
     top:above / bottom:above - NOT sticky
     top:above / bottom:below - STICKY
     top:below / bottom:in - NOT sticky - NOTE: This is an inversion clause
     top:below / bottom:above - NOT sticky - NOTE: This is an inversion clause
     top:below / bottom:below - NOT sticky
    # Summary
     The only time the header should be sticky is when the top sentinel is above the view and the bottom sentinel
     is in or below it.
    */ const { top: sentinelTop, bottom: sentinelBottom } = this.sentinelData;
        // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
        const rootBounds = sentinelTop.rootBounds ?? sentinelBottom.rootBounds;
        if (!rootBounds || !sentinelTop.boundingClientRect || !sentinelBottom.boundingClientRect) return false;
        // Normalize the sentinels to y points
        // Since the sentinels are actually rects 1px high we want make sure we normalise the inner most values closest to the table.
        const sentinelTopY = sentinelTop.boundingClientRect.bottom;
        const sentinelBottomY = sentinelBottom.boundingClientRect.top;
        // If header row height is more than 50% of viewport height don't do this
        const isRowHeaderTooLarge = this.stickyRowHeight && this.stickyRowHeight > window.innerHeight * 0.5;
        const isTopSentinelAboveScrollArea = !sentinelTop.isIntersecting && sentinelTopY <= rootBounds.top;
        const isBottomSentinelInOrBelowScrollArea = sentinelBottom.isIntersecting || sentinelBottomY > rootBounds.bottom;
        // This makes sure that the top sentinel is actually above the bottom sentinel, and that they havn't inverted.
        const isTopSentinelAboveBottomSentinel = sentinelTopY < sentinelBottomY;
        return isTopSentinelAboveScrollArea && isBottomSentinelInOrBelowScrollArea && isTopSentinelAboveBottomSentinel && !isRowHeaderTooLarge;
    }
    /* receive external events */ onTablePluginState(state) {
        const tableRef = state.tableRef;
        const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        // when header rows are toggled off - mark sentinels as unobserved
        if (!state.isHeaderRowEnabled) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el) delete el.dataset.isObserved;
        });
        const isCurrentTableSelected = tableRef === tree.table;
        // If current table selected and header row is toggled off, turn off sticky header
        if (isCurrentTableSelected && !state.isHeaderRowEnabled && tree) this.makeRowHeaderNotLegacySticky(tree.table);
        this.focused = isCurrentTableSelected;
        const { wrapper: wrapper } = tree;
        const tableContainer = wrapper.parentElement;
        const tableContentWrapper = tableContainer?.parentElement;
        const parentContainer = tableContentWrapper && tableContentWrapper.parentElement;
        const isTableInsideLayout = parentContainer && parentContainer.getAttribute('data-layout-content');
        if (tableContentWrapper) {
            if (isCurrentTableSelected) {
                this.colControlsOffset = (0, $fbbb9ee8877c285e$export$880976487022eb5);
                // move table a little out of the way
                // to provide spacing for table controls
                if (isTableInsideLayout) tableContentWrapper.style.paddingLeft = '11px';
            } else {
                this.colControlsOffset = 0;
                if (isTableInsideLayout) tableContentWrapper.style.removeProperty('padding-left');
            }
        }
        // run after table style changes have been committed
        setTimeout(()=>{
            (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(tree.table);
        }, 0);
    }
    updateStickyHeaderWidth() {
        // table width might have changed, sync that back to sticky row
        const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
        if (!tree) return;
        (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(tree.table);
    }
    /**
   * Manually refire the intersection observers.
   * Useful when the header may have detached from the table.
   */ refireIntersectionObservers() {
        if (this.isLegacySticky) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el && this.intersectionObserver) {
                this.intersectionObserver.unobserve(el);
                this.intersectionObserver.observe(el);
            }
        });
    }
    makeHeaderRowLegacySticky(tree, scrollTop) {
        // If header row height is more than 50% of viewport height don't do this
        if (this.isLegacySticky || this.stickyRowHeight && this.stickyRowHeight > window.innerHeight / 2 || this.isInNestedTable) return;
        const { table: table, wrapper: wrapper } = tree;
        // TODO: ED-16035 - Make sure sticky header is only applied to first row
        const tbody = this.dom.parentElement;
        const isFirstHeader = tbody?.firstChild?.isEqualNode(this.dom);
        if (!isFirstHeader) return;
        const currentTableTop = this.getCurrentTableTop(tree);
        if (!scrollTop) scrollTop = (0, $c2cd42e9bb213cdd$export$449115d164fc37c3)(this.editorScrollableElement);
        const domTop = currentTableTop > 0 ? scrollTop : scrollTop + currentTableTop;
        if (!this.isLegacySticky) {
            (0, $b432f0a26e9b5b59$export$43080b9794565cc4)(table);
            this.dom.classList.add('sticky');
            table.classList.add((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY);
            this.isLegacySticky = true;
            /**
       * The logic below is not desirable, but acts as a fail safe for scenarios where the sticky header
       * detaches from the table. This typically happens during a fast scroll by the user which causes
       * the intersection observer logic to not fire as expected.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.editorScrollableElement?.addEventListener('scrollend', this.refireIntersectionObservers, {
                passive: true,
                once: true
            });
            const fastScrollThresholdMs = 500;
            setTimeout(()=>{
                this.refireIntersectionObservers();
            }, fastScrollThresholdMs);
        }
        this.dom.style.top = `0px`;
        (0, $b432f0a26e9b5b59$export$ec6da316e37a54bf)(table);
        this.dom.scrollLeft = wrapper.scrollLeft;
        this.emitOn(domTop, this.colControlsOffset);
    }
    makeRowHeaderNotLegacySticky(table, isEditorDestroyed = false) {
        if (!this.isLegacySticky || !table || !this.dom) return;
        this.dom.style.removeProperty('width');
        this.dom.classList.remove('sticky');
        table.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY);
        this.isLegacySticky = false;
        this.dom.style.top = '';
        table.style.removeProperty('margin-top');
        this.emitOff(isEditorDestroyed);
    }
    getWrapperoffset(inverse = false) {
        const focusValue = inverse ? !this.focused : this.focused;
        return focusValue ? 0 : (0, $fbbb9ee8877c285e$export$880976487022eb5);
    }
    getWrapperRefTop(wrapper) {
        return Math.round((0, $c2cd42e9bb213cdd$export$449115d164fc37c3)(wrapper)) + this.getWrapperoffset();
    }
    getScrolledTableTop(wrapper) {
        return this.getWrapperRefTop(wrapper) - this.topPosEditorElement;
    }
    getCurrentTableTop(tree) {
        return this.getScrolledTableTop(tree.wrapper) + tree.table.clientHeight;
    }
    /* emit external events */ emitOn(top, padding) {
        if (top === this.top && padding === this.padding) return;
        this.top = top;
        this.padding = padding;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (Number.isFinite(pos)) (0, $1e600b287caa90c3$export$dd348cf8bfd51272)({
            pos: pos,
            top: top,
            sticky: true,
            padding: padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    emitOff(isEditorDestroyed) {
        if (this.top === 0 && this.padding === 0) return;
        this.top = 0;
        this.padding = 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (!isEditorDestroyed && Number.isFinite(pos)) (0, $1e600b287caa90c3$export$dd348cf8bfd51272)({
            pos: pos,
            sticky: false,
            top: this.top,
            padding: this.padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    constructor(node, view, getPos, eventDispatcher, api){
        super(node, view, getPos, eventDispatcher);
        this.nodeVisibilityObserverCleanupFn = void 0;
        this.cleanup = ()=>{
            if (this.isStickyHeaderEnabled) {
                this.unsubscribe();
                this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
                const tree = (0, $c2cd42e9bb213cdd$export$b76263aac816aadb)(this.dom);
                if (tree) this.makeRowHeaderNotLegacySticky(tree.table, true);
                this.emitOff(false);
            }
            if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
            this.onEditorContentAreaHeightChange?.();
        };
        /**
     * Variables
     */ this.isHeaderRow = void 0;
        this.isInNestedTable = void 0;
        this.isStickyHeaderEnabled = void 0;
        this.editorScrollableElement = void 0;
        this.colControlsOffset = 0;
        this.focused = false;
        this.topPosEditorElement = 0;
        this.isLegacySticky = void 0;
        this.intersectionObserver = void 0;
        this.resizeObserver = void 0;
        this.tableContainerObserver = void 0;
        this.sentinels = {};
        this.sentinelData = {
            top: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            },
            bottom: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            }
        };
        this.stickyRowHeight = void 0;
        this.listening = false;
        this.padding = 0;
        this.top = 0;
        this.api = void 0;
        /** Native sticky header variables */ this.overflowObserver = void 0;
        this.stickyStateObserver = void 0;
        this.hasScrolledSinceLoad = false;
        this.scrollListener = void 0;
        this.overflowObserverEntries = void 0;
        this.isNativeSticky = void 0;
        this.disableNativeSticky = false;
        this.onEditorContentAreaHeightChange = void 0;
        this.editorContentAreaHeight = void 0;
        this.nodeVisibilityObserver = void 0;
        /**
     * Methods
     */ this.headerRowMouseScrollEnd = (0, (/*@__PURE__*/$parcel$interopDefault($jSnXV)))(()=>{
            this.dom.classList.remove('no-pointer-events');
        }, $9ce7b5ba4bcfa9b7$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT);
        // When the header is sticky, the header row is set to position: fixed
        // This prevents mouse wheel scrolling on the scroll-parent div when user's mouse is hovering the header row.
        // This fix sets pointer-events: none on the header row briefly to avoid this behaviour
        this.headerRowMouseScroll = (0, (/*@__PURE__*/$parcel$interopDefault($8Yfbq)))(()=>{
            if (this.isLegacySticky) {
                this.dom.classList.add('no-pointer-events');
                this.headerRowMouseScrollEnd();
            }
        }, $9ce7b5ba4bcfa9b7$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT);
        this.toggleDisableNativeSticky = (headerHeight, viewportHeight)=>{
            if (!this.disableNativeSticky && headerHeight > viewportHeight * 0.5) {
                this.disableNativeSticky = true;
                if (this.isNativeSticky === undefined) this.dom.classList.remove((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY);
            }
            if (this.disableNativeSticky && headerHeight <= viewportHeight * 0.5) this.disableNativeSticky = false;
        };
        this.isHeaderRow = (0, $bdb0299b531c40df$export$4af45fdaadf67b18)(node);
        this.isLegacySticky = false;
        const { pluginConfig: pluginConfig } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(view.state);
        this.isStickyHeaderEnabled = !!pluginConfig.stickyHeaders;
        this.api = api;
        if (api?.limitedMode?.sharedState.currentState()?.limitedModePluginKey.getState(view.state)?.documentSizeBreachesThreshold) {
            this.isStickyHeaderEnabled = false;
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('limited-mode-activated', this.cleanup);
        }
        const pos = this.getPos();
        this.isInNestedTable = false;
        if (pos) this.isInNestedTable = (0, $sxTNo.getParentOfTypeCount)(view.state.schema.nodes.table)(view.state.doc.resolve(pos)) > 1;
        if (this.isHeaderRow) {
            this.dom.setAttribute('data-vc-nvs', 'true');
            const { observe: observe } = (0, $92LVN.nodeVisibilityManager)(view.dom);
            this.nodeVisibilityObserverCleanupFn = observe({
                element: this.contentDOM,
                onFirstVisible: ()=>{
                    this.subscribeWhenRowVisible();
                }
            });
        }
        if (this.isHeaderRow && this.isStickyHeaderEnabled && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_4')) this.onEditorContentAreaHeightChange = api?.table?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState?.editorContentAreaHeight && nextSharedState?.editorContentAreaHeight !== this.editorContentAreaHeight) {
                this.editorContentAreaHeight = nextSharedState.editorContentAreaHeight;
                this.toggleDisableNativeSticky(this.stickyRowHeight ?? 0, nextSharedState.editorContentAreaHeight);
            }
        });
    }
}


const $6edebf68ab9a523e$export$58b58f8ab97e94ed = (options)=>{
    return (node, view, getPos)=>{
        return (0, $1a05aa95aa438aa8$export$f0e1dd383a612bf9)(node, view, getPos, options.portalProviderAPI, options.eventDispatcher, options.getEditorContainerWidth, options.getEditorFeatureFlags, options.dispatchAnalyticsEvent, options.pluginInjectionApi, options.isCommentEditor, options.isChromelessEditor, options?.allowFixedColumnWidthOption);
    };
};
const $6edebf68ab9a523e$export$cb505927d54cfbe6 = (options)=>{
    return (node, view, getPos)=>{
        return new (0, $aeff2d6ebbdab783$export$2e2bcd8739ae039)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi?.analytics?.actions);
    };
};
const $6edebf68ab9a523e$export$182d82ed34901998 = (options)=>{
    return (node, view, getPos)=>{
        return new (0, $aeff2d6ebbdab783$export$2e2bcd8739ae039)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi?.analytics?.actions);
    };
};
const $6edebf68ab9a523e$export$2b8a69d954e9d30 = (options)=>{
    return (node, view, getPos)=>{
        if ((0, $425e1bfad150b07f$export$2ee7329d46115d8f)() && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) return new (0, $9ce7b5ba4bcfa9b7$export$2e2bcd8739ae039)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi);
        else return new (0, $41994fbd33408f1b$export$2e2bcd8739ae039)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi);
    };
};





























const $331e9acffee27015$export$ea73b328547c6ad5 = (state, content, inputMethod, editorAnalyticsAPI)=>{
    if ((0, $iYC9s.isTableSelected)(state.selection)) {
        const table = (0, $id9O1.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(state.schema.text(content)), 0, 0) : content;
            const tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $ks2lK.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $d406f1b0c5d56902$export$d2cf64960b17e12e)(state.selection);
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $3824I.TABLE_ACTION).REPLACED,
                actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                attributes: {
                    totalColumnCount: totalColumnCount,
                    totalRowCount: totalRowCount,
                    inputMethod: inputMethod
                },
                eventType: (0, $d925B.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    }
    return state.tr;
};






















const $91aa52f15622bdd0$export$c2e425c24c996f14 = (maybeTable)=>{
    const { schema: schema } = maybeTable.type;
    if (maybeTable.type === schema.nodes.table) {
        const content = [];
        const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
        maybeTable.descendants((maybeCell)=>{
            if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
                content.push(...(0, $8m4tT.flatten)(maybeCell, false).map((child)=>child.node));
                return false;
            }
            return true;
        });
        return content;
    }
    return maybeTable;
};
// Flattens nested tables after a given nesting depth
// If this looks familiar, it's a heavily modified version of `mapFragment` which has been
// adjusted to support tracking nesting depth. This wasn't possible by using `mapFragment` directly
const $91aa52f15622bdd0$var$unwrapNestedTables = (content, schema, unwrapNestDepth, currentNestDepth = 0)=>{
    const flattenNested = (node, tableDepth)=>{
        if (node.type === schema.nodes.table) {
            if (tableDepth >= unwrapNestDepth) return $91aa52f15622bdd0$export$c2e425c24c996f14(node);
            return node;
        }
        return node;
    };
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? flattenNested(node, currentNestDepth) : flattenNested(node.copy((0, $5SAOw.Fragment).fromArray($91aa52f15622bdd0$var$unwrapNestedTables(node.content, schema, unwrapNestDepth, node.type === schema.nodes.table ? currentNestDepth + 1 : currentNestDepth))), currentNestDepth);
        if (transformed) {
            if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return children;
};
const $91aa52f15622bdd0$export$152b5a96986a7396 = (node, i)=>{
    return i === 0 ? $91aa52f15622bdd0$export$c2e425c24c996f14(node) : node;
};
const $91aa52f15622bdd0$export$791e770947b65d04 = (node, i, fragment)=>{
    return i === fragment.childCount - 1 ? $91aa52f15622bdd0$export$c2e425c24c996f14(node) : node;
};
const $91aa52f15622bdd0$export$8bc9a7cde47c4f8e = (slice, schema, selection)=>{
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    let openEnd = slice.openEnd;
    const newFragment = (0, $3Ter7.flatmap)(slice.content, (node, i, fragment)=>{
        // We allow default nesting of 2 to support
        // two levels of nesting in nodes that support table nesting already such as layoutSection and expands
        let allowedTableNesting = 2;
        const isCellSelection = selection instanceof (0, $7XFGZ.CellSelection);
        const isPasteInTable = (0, $8m4tT.hasParentNodeOfType)([
            table,
            tableCell,
            tableHeader
        ])(selection);
        const isPasteInNestedTable = (0, $sxTNo.getParentOfTypeCount)(schema.nodes.table)(selection.$from) > 1;
        const isPasteFullTableInsideEmptyCellEnabled = (0, $dh538.fg)('platform_editor_paste_full_table_inside_empty_cell');
        // Pasted content only contains a table and no other content
        const isCellPaste = isPasteInTable && slice.content.childCount === 1 && slice.content.firstChild?.type === table && (!isPasteFullTableInsideEmptyCellEnabled || slice.openStart !== 0 && slice.openEnd !== 0);
        // however if pasted content is a table, allow just one level
        if (node.type === schema.nodes.table) {
            allowedTableNesting = 1;
            // if paste is inside a table, allow no further nesting
            if (isPasteInTable) allowedTableNesting = 0;
            // unless we are pasting inside a nested table, then bounce back to 1 level
            // because editor-plugin-paste will lift the table to the parent table (just below it)
            if (isPasteInNestedTable) allowedTableNesting = 1;
            // paste of table cells into a table cell - content is spread across multiple cells
            // by editor-tables so needs to be treated a little differently
            if (isCellPaste || isCellSelection) {
                allowedTableNesting = 1;
                if (isPasteInNestedTable) allowedTableNesting = 0;
            }
        }
        // Prevent invalid openEnd after pasting tables with a selection that ends inside a nested table cell.
        // If the slice ends with a selection that ends inside a nested table, and we paste inside a table we
        // need to adjust the openEnd because it is no longer correct. If we don't, Prosemirror fires an exception
        // because it iterates to a non-existent depth and the transform will not be applied
        if (slice.openEnd >= 7 && // depth of a nested table cell
        slice.content.childCount > 1 && slice.content.lastChild?.type === table && isPasteInTable) // re-point the slice's openEnd to non-nested table cell depth
        openEnd = 4;
        if (isCellSelection && !isCellPaste) // if pasting into a cell selection, we need to flatten the parent table as well
        return $91aa52f15622bdd0$var$unwrapNestedTables((0, $5SAOw.Fragment).fromArray([
            node
        ]), schema, allowedTableNesting);
        else {
            // after we've worked out what the allowed nesting depth is, unwrap nested tables
            const newChildren = $91aa52f15622bdd0$var$unwrapNestedTables(node.content, schema, allowedTableNesting);
            return node.copy((0, $5SAOw.Fragment).fromArray(newChildren));
        }
    });
    return new (0, $5SAOw.Slice)(newFragment, slice.openStart, openEnd);
};
const $91aa52f15622bdd0$export$fc3230cbfe498044 = (slice, schema)=>{
    const { paragraph: paragraph, table: table, hardBreak: hardBreak } = schema.nodes;
    const emptyParagraphNode = paragraph.createAndFill();
    const hardBreakNode = hardBreak?.createAndFill();
    const paragraphNodeSize = emptyParagraphNode ? emptyParagraphNode.nodeSize : 0;
    const hardBreakNodeSize = hardBreakNode ? hardBreakNode.nodeSize : 0;
    const paragraphWithHardBreakSize = paragraphNodeSize + hardBreakNodeSize;
    if (slice.content.childCount === 2 && slice.content.firstChild && slice.content.lastChild && slice.content.firstChild.type === table && slice.content.lastChild.type === paragraph && slice.content.lastChild.nodeSize === paragraphWithHardBreakSize) {
        const nodes = $91aa52f15622bdd0$export$c2e425c24c996f14(slice.content.firstChild);
        if (nodes instanceof Array) return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(// keep only the content and discard the hardBreak
        nodes[0]), slice.openStart, slice.openEnd);
    }
    return slice;
};
const $91aa52f15622bdd0$var$isNodeSingleCellTable = (node, schema)=>{
    return node.childCount === 1 && node.firstChild?.type === schema.nodes.tableRow && node.firstChild.childCount === 1 && (node.firstChild.firstChild?.type === schema.nodes.tableCell || node.firstChild.firstChild?.type === schema.nodes.tableHeader);
};
const $91aa52f15622bdd0$var$isFragmentSingleCellTable = (fragment, schema)=>{
    return fragment.childCount === 1 && fragment.firstChild !== null && $91aa52f15622bdd0$var$isNodeSingleCellTable(fragment.firstChild, schema);
};
const $91aa52f15622bdd0$var$containsNonTableBlockChildren = (fragment, schema)=>{
    let containsNonTableBlock = false;
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    fragment.forEach((node)=>{
        if (node.isBlock && ![
            table,
            tableCell,
            tableHeader
        ].includes(node.type)) containsNonTableBlock = true;
    });
    return containsNonTableBlock;
};
const $91aa52f15622bdd0$export$7932630df6a9b5d9 = (slice, schema)=>{
    // Case 1: A slice of a block selection inside a nested table
    // Prosemirror wraps nested block selections in their respective tables
    // We are using `safeInsert` to paste nested tables, so we do not want to preserve this wrapping
    // slice starts and ends inside a nested table at the same depth
    if (slice.openStart >= 7 && slice.openEnd >= 7) {
        let cleaned = slice;
        let descendedDepth = 0;
        const tableDepthDecrement = 2;
        // if the slice is a single cell table and contains cells with single cell tables, descend into it until we find textblock children
        if ($91aa52f15622bdd0$var$isFragmentSingleCellTable(slice.content, schema)) slice.content.firstChild?.descendants((node)=>{
            if ($91aa52f15622bdd0$var$isNodeSingleCellTable(node, schema)) descendedDepth += tableDepthDecrement;
            else if (node.type === schema.nodes.table) return false;
            else if ($91aa52f15622bdd0$var$containsNonTableBlockChildren(node.content, schema)) {
                descendedDepth += tableDepthDecrement;
                // create a new slice with the content of non-table block children and the depth of the nested tables subtracted
                cleaned = new (0, $5SAOw.Slice)(node.content, slice.openStart - descendedDepth - tableDepthDecrement, slice.openEnd - descendedDepth - tableDepthDecrement);
                return false;
            }
        });
        if (!cleaned.eq(slice)) return cleaned;
    }
    // Case 2: A slice entirely within a single CELL
    if (// starts and ends inside of a cell
    slice.openStart >= 4 && slice.openEnd >= 4 && // slice is a table node
    slice.content.childCount === 1 && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    slice.content.firstChild.type === schema.nodes.table) {
        // we're removing the table, tableRow and tableCell reducing the open depth by 3
        const depthDecrement = 3;
        // prosemirror-view has a bug that it duplicates table entry when selecting multiple paragraphs in a table cell.
        // https://github.com/ProseMirror/prosemirror/issues/1270
        // The structure becomes
        // table(genuine) > tableRow(genuine) > table(duplicated) > tableRow(duplicated) > tableCell/tableHeader(genuine) > contents(genuine)
        // As we are removing wrapping table anyway, we keep duplicated table and tableRow for simplicity
        let cleaned = slice;
        if (slice.content.firstChild?.content?.firstChild?.content?.firstChild?.type === schema.nodes.table) cleaned = new (0, $5SAOw.Slice)(slice.content.firstChild.content.firstChild.content, slice.openStart - 2, slice.openEnd - 2);
        return new (0, $5SAOw.Slice)((0, $3Ter7.flatmap)(cleaned.content, $91aa52f15622bdd0$export$c2e425c24c996f14), cleaned.openStart - depthDecrement, cleaned.openEnd - depthDecrement);
    }
    // Case 3: A slice starting within a CELL and ending outside the table
    if (// starts inside of a cell but ends outside of the starting table
    slice.openStart >= 4 && // slice starts from a table node (and spans across more than one node)
    slice.content.childCount > 1 && slice.content.firstChild?.type === schema.nodes.table) // repoint the slice's cutting depth so that cell content where the slice starts
    // does not get lifted out of the cell on paste
    return new (0, $5SAOw.Slice)(slice.content, 1, slice.openEnd);
    return slice;
};
const $91aa52f15622bdd0$export$5354b8e5d3b01769 = (slice, schema)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $3Ter7.mapSlice)(slice, (node)=>{
        if (node && (node.type === tableCell || node.type === tableHeader) && !node.content.childCount) return node.type.createAndFill(node.attrs) || node;
        return node;
    });
};
function $91aa52f15622bdd0$export$cbabf4b236642ebb(state) {
    const tableState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    return tableState && tableState.pluginConfig.isHeaderRowRequired;
}
const $91aa52f15622bdd0$export$4e98c990eb0fdba6 = (slice, schema)=>{
    const { table: table } = schema.nodes;
    const children = [];
    (0, $3Ter7.mapChildren)(slice.content, (node)=>{
        if (node.type === table && node.attrs.layout === 'default') children.push(table.createChecked({
            ...node.attrs,
            layout: 'center'
        }, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};



const $acc346d62149cd5a$export$ae829ec7b2625219 = (dispatchAnalyticsEvent, dispatch, portalProviderAPI, nodeViewPortalProviderAPI, eventDispatcher, pluginConfig, getEditorContainerWidth, getEditorFeatureFlags, getIntl, fullWidthModeEnabled, previousFullWidthModeEnabled, editorAnalyticsAPI, pluginInjectionApi, isTableScalingEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, allowFixedColumnWidthOption)=>{
    const state = (0, $69d6e2a2c784f306$export$656c7661095efe2e)(dispatch, {
        pluginConfig: pluginConfig,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor,
        isTableHovered: false,
        insertColumnButtonIndex: undefined,
        insertRowButtonIndex: undefined,
        isFullWidthModeEnabled: fullWidthModeEnabled,
        wasFullWidthModeEnabled: previousFullWidthModeEnabled,
        isHeaderRowEnabled: !!pluginConfig.allowHeaderRow,
        isHeaderColumnEnabled: false,
        isDragAndDropEnabled: true,
        isTableScalingEnabled: isTableScalingEnabled,
        ...(0, $780923e152cc8f13$export$4c0699e9a8272521),
        ...(0, $780923e152cc8f13$export$af473ce758096273),
        getIntl: getIntl
    });
    // Used to prevent invalid table cell spans being reported more than once per editor/document
    const invalidTableIds = [];
    let editorViewRef = null;
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    const getCurrentEditorState = ()=>{
        const editorView = editorViewRef;
        if (!editorView) return null;
        return editorView.state;
    };
    const getNodeView = ()=>{
        return {
            table: (0, $6edebf68ab9a523e$export$58b58f8ab97e94ed)({
                portalProviderAPI: portalProviderAPI,
                eventDispatcher: eventDispatcher,
                getEditorContainerWidth: getEditorContainerWidth,
                getEditorFeatureFlags: getEditorFeatureFlags,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                pluginInjectionApi: pluginInjectionApi,
                isCommentEditor: isCommentEditor,
                isChromelessEditor: isChromelessEditor,
                allowFixedColumnWidthOption: allowFixedColumnWidthOption
            }),
            tableRow: (0, $6edebf68ab9a523e$export$2b8a69d954e9d30)({
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi,
                isDragAndDropEnabled: true
            }),
            tableCell: (0, $6edebf68ab9a523e$export$cb505927d54cfbe6)({
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi
            }),
            tableHeader: (0, $6edebf68ab9a523e$export$182d82ed34901998)({
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi
            })
        };
    };
    const nodeViews = getNodeView();
    return new (0, $1S4f7.SafePlugin)({
        state: state,
        key: (0, $fedf15e5199146e8$export$18d4026d1ea86bb1),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta('uiEvent') === 'cut');
            function reportInvalidTableCellSpanAttrs(invalidNodeAttr) {
                if (invalidTableIds.find((id)=>id === invalidNodeAttr.tableLocalId)) return;
                invalidTableIds.push(invalidNodeAttr.tableLocalId);
                dispatchAnalyticsEvent({
                    action: (0, $d925B.ACTION).INVALID_DOCUMENT_ENCOUNTERED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        nodeType: invalidNodeAttr.nodeType,
                        reason: `${invalidNodeAttr.attribute}: ${invalidNodeAttr.reason}`,
                        tableLocalId: invalidNodeAttr.tableLocalId,
                        spanValue: invalidNodeAttr.spanValue
                    }
                });
            }
            if (tr) {
                const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
                // "fixTables" removes empty rows as we don't allow that in schema
                const updatedTr = (0, $f10f08824d624bfc$export$1c3f791fb2a5168)(tr, oldState, newState, pluginInjectionApi, editorAnalyticsAPI, editorViewRef || undefined, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent);
                return (0, $994471c61aed7ad3$export$d6d48849d9121a1)(updatedTr) || updatedTr;
            }
            if (transactions.find((tr)=>tr.docChanged)) return (0, $994471c61aed7ad3$export$d6d48849d9121a1)(newState.tr, reportInvalidTableCellSpanAttrs);
        },
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            editorViewRef = editorView;
            let contentModeSizeTableId = null;
            let focusListenerBinding = null;
            if (pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode !== 'view' && (0, $3a3941a6aa273892$export$e217d2a535d6ae45)({
                allowColumnResizing: !!pluginConfig.allowColumnResizing,
                allowTableResizing: !!pluginConfig.allowTableResizing,
                isFullPageEditor: !isChromelessEditor && !isCommentEditor
            }) && (0, $1oCLl.expValEquals)('platform_editor_table_fit_to_content_auto_convert', 'isEnabled', true)) focusListenerBinding = (0, $fFa3V.bind)(editorView.dom, {
                type: 'focus',
                listener: ()=>{
                    if (contentModeSizeTableId) return;
                    contentModeSizeTableId = requestAnimationFrame(()=>{
                        if (!editorViewRef) return;
                        (0, $3a3941a6aa273892$export$a6fbfadef1c3fa2e)(editorViewRef, pluginInjectionApi);
                    });
                },
                options: {
                    once: true
                }
            });
            return {
                update: (view, prevState)=>{
                    const { state: state, dispatch: dispatch } = view;
                    const { selection: selection } = state;
                    const pluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
                    let tableRef;
                    if ((0, $dh538.fg)('platform_editor_enable_table_dnd')) {
                        const parent = (0, $8m4tT.findParentDomRefOfType)(state.schema.nodes.table, domAtPos)(selection);
                        let shouldSetTableRef = (0, $dh538.fg)('platform_editor_enable_table_dnd_patch_1') ? parent && pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode !== 'view' : parent;
                        if ((0, $1oCLl.expValEquals)('platform_editor_table_update_table_ref', 'isEnabled', true) && (0, $dh538.fg)('platform_editor_update_table_ref_fix')) shouldSetTableRef = parent && pluginInjectionApi?.editorViewMode?.sharedState.currentState()?.mode !== 'view' && pluginInjectionApi?.interaction?.sharedState.currentState()?.interactionState !== 'hasNotHadInteraction';
                        if (shouldSetTableRef) tableRef = // Ignored via go/ees005
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        parent.querySelector('table') || undefined;
                    }
                    if (pluginState.editorHasFocus) {
                        if (!(0, $dh538.fg)('platform_editor_enable_table_dnd')) {
                            const parent = (0, $8m4tT.findParentDomRefOfType)(state.schema.nodes.table, domAtPos)(selection);
                            if (parent) tableRef = // Ignored via go/ees005
                            // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            parent.querySelector('table') || undefined;
                        }
                        const tableNode = (0, $id9O1.findTable)(state.selection);
                        // when keyboard cursor leaves the table we need to stop column resizing
                        const pluginPrevState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(prevState);
                        const isStopKeyboardColumResizing = pluginPrevState.isResizeHandleWidgetAdded && pluginPrevState.isKeyboardResize;
                        if (isStopKeyboardColumResizing) {
                            const isTableNodesDifferent = pluginPrevState?.tableNode !== tableNode?.node;
                            if (pluginPrevState?.tableNode && tableNode && isTableNodesDifferent) {
                                const oldRowsNumber = (0, $LmqWp.TableMap).get(pluginPrevState.tableNode).height;
                                const newRowsNumber = (0, $LmqWp.TableMap).get(tableNode.node).height;
                                if (oldRowsNumber !== newRowsNumber || // Add/delete row
                                tableNode.node.attrs.localId !== pluginPrevState.tableNode.attrs.localId) // Jump to another table
                                (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({
                                    ariaNotify: ariaNotifyPlugin,
                                    getIntl: getIntl
                                })(state, dispatch);
                            } else if (!tableNode) // selection outside of table
                            (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({
                                ariaNotify: ariaNotifyPlugin,
                                getIntl: getIntl
                            })(state, dispatch);
                        }
                    }
                    if (pluginState.tableRef !== tableRef) (0, $4ca83755c936c9c8$export$79b661cbf50c3490)(tableRef)(state, dispatch);
                    if (pluginState.editorHasFocus && pluginState.tableRef) {
                        const { $cursor: $cursor } = state.selection;
                        if ($cursor) {
                            // Only update bold when it's a cursor
                            const tableCellHeader = (0, $8m4tT.findParentNodeOfType)(state.schema.nodes.tableHeader)(state.selection);
                            if (tableCellHeader) (0, $4ca83755c936c9c8$export$bf5ab08a5036bda8)(tableCellHeader)(state, dispatch);
                        }
                    } else if (pluginState.isResizeHandleWidgetAdded) (0, $4ca83755c936c9c8$export$99c5230572e6696d)()(state, dispatch);
                },
                destroy: ()=>{
                    contentModeSizeTableId && cancelAnimationFrame(contentModeSizeTableId);
                    focusListenerBinding && focusListenerBinding();
                }
            };
        },
        props: {
            transformPasted (slice) {
                const editorState = getCurrentEditorState();
                if (!editorState) return slice;
                const { schema: schema } = editorState;
                // if we're pasting to outside a table or outside a table
                // header, ensure that we apply any table headers to the first
                // row of content we see, if required
                if (!(0, $4KOFJ.insideTable)(editorState) && (0, $91aa52f15622bdd0$export$cbabf4b236642ebb)(editorState)) slice = (0, $4ca83755c936c9c8$export$bb3294affcb5059f)(slice, schema);
                // This fixes pasting a table with default layout into comment editor
                // table lose width and expand to full width
                if (!(0, $4KOFJ.insideTable)(editorState) && isCommentEditor && pluginConfig.allowTableAlignment && isTableScalingEnabled) slice = (0, $91aa52f15622bdd0$export$4e98c990eb0fdba6)(slice, schema);
                slice = (0, $91aa52f15622bdd0$export$fc3230cbfe498044)(slice, schema);
                // We do this separately, so it also applies to drag/drop events
                // This needs to go before `transformSliceToRemoveOpenExpand`
                slice = (0, $edTnG.transformSliceToRemoveOpenLayoutNodes)(slice, schema);
                // If a partial paste of expand, paste only the content
                // This needs to go before `transformSliceToRemoveOpenTable`
                slice = (0, $hcbpx.transformSliceToRemoveOpenExpand)(slice, schema);
                // transformSliceToRemoveOpenTable() transforms based on the depth of the root node, assuming that the tables will be at the root
                // Bodied extensions will contribute to the depth of the table selection so we need to remove them first
                /** If a partial paste of bodied extension, paste only text */ slice = (0, $igNsz.transformSliceToRemoveOpenBodiedExtension)(slice, schema);
                /** If a partial paste of table, paste only table's content */ slice = (0, $91aa52f15622bdd0$export$7932630df6a9b5d9)(slice, schema);
                /** If a partial paste of multi bodied extension, paste only children */ slice = (0, $igNsz.transformSliceToRemoveOpenMultiBodiedExtension)(slice, schema);
                slice = (0, $91aa52f15622bdd0$export$5354b8e5d3b01769)(slice, schema);
                if (!pluginConfig.allowColumnResizing) slice = (0, $4ca83755c936c9c8$export$8fcd87e05a98248e)(slice, schema);
                // If we don't allow background on cells, we need to remove it
                // from the paste slice
                if (!pluginConfig.allowBackgroundColor) slice = (0, $4ca83755c936c9c8$export$f4e57bcfd514085d)(slice, schema);
                else slice = (0, $4ca83755c936c9c8$export$80a571fa7de8754d)(slice, schema);
                slice = (0, $hcbpx.transformSliceToRemoveOpenNestedExpand)(slice, schema);
                if ((0, $sxTNo.isNestedTablesSupported)(schema)) slice = (0, $91aa52f15622bdd0$export$8bc9a7cde47c4f8e)(slice, schema, editorState.selection);
                return slice;
            },
            handleClick: ({ state: state, dispatch: dispatch }, _pos, event)=>{
                const decorationSet = (0, $de8398c45f744acc$export$18d4026d1ea86bb1).getState(state);
                const browser = (0, $d7ZU3.getBrowserInfo)();
                if ((0, $9283ce7d62ffd391$export$6577d2f7fe84e45c)(decorationSet).length) (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
                // ED-6069: workaround for Chrome given a regression introduced in prosemirror-view@1.6.8
                // Returning true prevents that updateSelection() is getting called in the commit below:
                // @see https://github.com/ProseMirror/prosemirror-view/commit/33fe4a8b01584f6b4103c279033dcd33e8047b95
                if (browser.chrome && event.target) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const targetClassList = event.target.classList;
                    if (targetClassList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON) || targetClassList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_BUTTON) || targetClassList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE) || targetClassList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CONTAINER)) return true;
                }
                return false;
            },
            handleScrollToSelection: (view)=>{
                // when typing into a sticky header cell, we don't want to scroll
                // back to the top of the table if the user has already scrolled down
                const { tableHeader: tableHeader } = view.state.schema.nodes;
                const domRef = (0, $8m4tT.findParentDomRefOfType)(tableHeader, view.domAtPos.bind(view))(view.state.selection);
                const maybeTr = (0, $4vlwG.closestElement)(domRef, 'tr');
                return maybeTr ? maybeTr.classList.contains('sticky') : false;
            },
            handleTextInput: (view, _from, _to, text)=>{
                const { state: state, dispatch: dispatch } = view;
                const { isKeyboardResize: isKeyboardResize } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
                if (isKeyboardResize) {
                    (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({
                        ariaNotify: ariaNotifyPlugin,
                        getIntl: getIntl
                    })(state, dispatch);
                    return false;
                }
                const tr = (0, $331e9acffee27015$export$ea73b328547c6ad5)(state, text, (0, $d925B.INPUT_METHOD).KEYBOARD, editorAnalyticsAPI);
                if (tr.selectionSet) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            nodeViews: nodeViews,
            handleDOMEvents: {
                focus: (0, $f10f08824d624bfc$export$185584c64f36588),
                blur: (0, $f10f08824d624bfc$export$27d5d91e7417534c),
                mousedown: (0, $f10f08824d624bfc$export$87e6a6bf8341824f)((0, $f10f08824d624bfc$export$b4a93e0b711d8f7)),
                mouseleave: (0, $f10f08824d624bfc$export$fcff8e67f71577c3),
                mousemove: (0, $f10f08824d624bfc$export$82a75cb550f27e28)((0, $f10f08824d624bfc$export$3248c033e90a4ba0)(nodeViewPortalProviderAPI), pluginInjectionApi),
                mouseenter: (0, $f10f08824d624bfc$export$2560ef85393729a7),
                mouseup: (0, $f10f08824d624bfc$export$82a75cb550f27e28)((0, $f10f08824d624bfc$export$88f4dbb0cd0ffc84)),
                click: (0, $f10f08824d624bfc$export$87e6a6bf8341824f)((0, $f10f08824d624bfc$export$82a75cb550f27e28)((0, $f10f08824d624bfc$export$b981489921ee18cd)))
            },
            handleTripleClick: $f10f08824d624bfc$export$f17e34274dd6fcf5
        }
    });
};



/**
 * Fix an issue that composition text replacement in Safari removes empty nodes during text composition text deletion.
 * https://github.com/ProseMirror/prosemirror/issues/934
 * We will remove this plugin when Webkit fix the problem itself.
 */ 








const $d6be50079e9249c7$var$tableSafariDeleteCompositionTextIssueWorkaroundKey = new (0, $ks2lK.PluginKey)('tableSafariDeleteCompositionTextIssueWorkaround');
const $d6be50079e9249c7$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $d6be50079e9249c7$var$tableSafariDeleteCompositionTextIssueWorkaroundKey,
        state: {
            init: ()=>({
                    renderSpan: false,
                    decorations: (0, $ftzrq.DecorationSet).empty
                }),
            apply: (tr, value)=>{
                const renderSpan = tr.getMeta($d6be50079e9249c7$var$tableSafariDeleteCompositionTextIssueWorkaroundKey);
                if (typeof renderSpan === 'undefined') return value;
                let decorations;
                if (renderSpan) {
                    // Find position of the first text node in case it has multiple text nodes created by Japanese IME
                    const { $from: $from } = tr.selection;
                    const pos = $from.before($from.depth);
                    const spanDecoration = (0, $ftzrq.Decoration).widget(pos, ()=>{
                        const spanElement = document.createElement('span');
                        return spanElement;
                    });
                    decorations = (0, $ftzrq.DecorationSet).create(tr.doc, [
                        spanDecoration
                    ]);
                } else decorations = (0, $ftzrq.DecorationSet).empty;
                return {
                    renderSpan: renderSpan,
                    decorations: decorations
                };
            }
        },
        props: {
            decorations: (state)=>$d6be50079e9249c7$var$tableSafariDeleteCompositionTextIssueWorkaroundKey.getState(state)?.decorations,
            handleDOMEvents: {
                beforeinput: (view, event)=>{
                    if (event?.inputType !== 'deleteCompositionText') return false;
                    const selection = window.getSelection();
                    if (!selection || selection.rangeCount <= 0 || selection.type !== 'Range') return false;
                    const range = selection.getRangeAt(0);
                    const { startContainer: startContainer, endContainer: endContainer, endOffset: endOffset, startOffset: startOffset } = range;
                    /**
						 * On Safari when composition text is deleted, it deletes any empty elements it finds up the dom tree. Prosemirror can sometimes be confused by this
						 * and will think that we meant to delete those elements. This fix forces the resulting node to not be empty.
						 * The condition here checks to see if the entire text node is about to be swapped inside of an element
						 */ if (startContainer.nodeType === Node.TEXT_NODE && startContainer === endContainer && startOffset === 0 && endOffset === startContainer.length) {
                        const { tr: tr } = view.state;
                        tr.setMeta($d6be50079e9249c7$var$tableSafariDeleteCompositionTextIssueWorkaroundKey, true);
                        view.dispatch(tr);
                    }
                    return false;
                },
                input: (view, event)=>{
                    if (event?.inputType !== 'deleteCompositionText') return false;
                    const selection = window.getSelection();
                    if (!selection) return false;
                    const { tr: tr } = view.state;
                    tr.setMeta($d6be50079e9249c7$var$tableSafariDeleteCompositionTextIssueWorkaroundKey, false);
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });
};







const $def0041f08b1347a$export$ae829ec7b2625219 = (dispatch, initialState = ()=>[])=>{
    return new (0, $1S4f7.SafePlugin)({
        state: (0, $738e0202c4e34f01$export$656c7661095efe2e)(dispatch, initialState),
        key: (0, $1562ea854f0ae047$export$18d4026d1ea86bb1)
    });
};





// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid

var $dQl1W = parcelRequire("dQl1W");





var $04H9b = parcelRequire("04H9b");













class $8a4fbf3fe4f0ae86$var$ObjHash {
    static getForNode(node) {
        if (this.cache.has(node)) return this.cache.get(node) || '';
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid
        const uniqueId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        this.cache.set(node, uniqueId);
        return uniqueId;
    }
}
$8a4fbf3fe4f0ae86$var$ObjHash.cache = new WeakMap();
const $8a4fbf3fe4f0ae86$var$getNodeAnchor = (node)=>{
    const handleId = $8a4fbf3fe4f0ae86$var$ObjHash.getForNode(node);
    return `--table-${node.type.name}-${handleId}`;
};
const $8a4fbf3fe4f0ae86$var$createTableAnchorDecorations = (state)=>{
    const decs = [];
    let headerRowId;
    state.doc.nodesBetween(0, state.doc.content.size, (node, pos, parent, index)=>{
        const isTableHeader = node.type.name === 'tableHeader';
        const isTableRow = node.type.name === 'tableRow';
        const isParentTableRow = parent?.type.name === 'tableRow';
        const isParentTableHeaderRow = parent?.type.name === 'tableRow' && headerRowId && parent?.attrs?.localId === headerRowId;
        const shouldAddDecorationToHeader = (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? isParentTableHeaderRow && isTableHeader : isTableHeader;
        const isFirstRow = isTableRow && index === 0;
        if (isFirstRow) headerRowId = node.attrs.localId;
        // only apply to header cells and the first row of a table, for performance reasons
        if (isFirstRow || shouldAddDecorationToHeader) {
            const anchorName = $8a4fbf3fe4f0ae86$var$getNodeAnchor(node);
            const shouldAddAnchorNameInDecoration = !(0, $04H9b.isCSSAttrAnchorSupported)() && (0, $04H9b.isCSSAnchorSupported)() && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_8');
            const attributes = {
                'data-node-anchor': anchorName,
                style: `anchor-name: ${anchorName};`
            };
            decs.push((0, $ftzrq.Decoration).node(pos, pos + node.nodeSize, shouldAddAnchorNameInDecoration ? attributes : {
                'data-node-anchor': anchorName
            }));
        }
        // only decend if there is a possible table row or table header node after the current node, for performance reasons
        return (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? !(isTableHeader || isParentTableHeaderRow) : !(isTableHeader || isParentTableRow);
    });
    return (0, $ftzrq.DecorationSet).create(state.doc, decs);
};
const $8a4fbf3fe4f0ae86$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableAnchorNamesPlugin');
const $8a4fbf3fe4f0ae86$export$ae829ec7b2625219 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init: (_config, state)=>{
                return $8a4fbf3fe4f0ae86$var$createTableAnchorDecorations(state);
            },
            apply: (tr, decorationSet, _, newState)=>{
                if (tr.docChanged) return $8a4fbf3fe4f0ae86$var$createTableAnchorDecorations(newState);
                return decorationSet;
            }
        },
        key: $8a4fbf3fe4f0ae86$export$18d4026d1ea86bb1,
        props: {
            decorations: (state)=>$8a4fbf3fe4f0ae86$export$18d4026d1ea86bb1.getState(state) || (0, $ftzrq.DecorationSet).empty
        }
    });
};


/**
 * A plugin for ensuring tables always have unique local IDs, and to
 * preserve/not regenerate them when they are being cut and paste around the
 * document.
 *
 * More broadly, this plugin should be generalised so it can solve this ‘unique
 * id’ problem across the codebase for any node, but for now this will live on
 * its own solving only for tables.
 *
 * TODO: https://product-fabric.atlassian.net/browse/ED-12714
 *
 */ 



var $fO7hX = parcelRequire("fO7hX");










const $d5b05171647091ac$var$pluginKey = new (0, $ks2lK.PluginKey)('tableLocalIdPlugin');
const $d5b05171647091ac$var$getPluginState = (state)=>state && $d5b05171647091ac$var$pluginKey.getState(state);
/**
 * Ensures uniqueness of `localId`s on tables being created or edited
 */ const $d5b05171647091ac$export$ae829ec7b2625219 = (dispatch)=>new (0, $1S4f7.SafePlugin)({
        key: $d5b05171647091ac$var$pluginKey,
        state: {
            init () {
                return {
                    parsedForLocalIds: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($d5b05171647091ac$var$pluginKey);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($d5b05171647091ac$var$pluginKey, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view: ()=>{
            return {
                /**
				 * Utilise the update cycle for _one_ scan through an initial doc
				 * to ensure existing tables without IDs get them when this plugin is
				 * enabled.
				 *
				 * This entire block can be skipped if we simply remove the `checkIsAddingTable`
				 * check in appendTransaction, but that comes with 2 cons:
				 *
				 * 1. require a transaction before we actually add the local IDs
				 * 2. ever slightly more unncessary checks
				 *
				 * Finally, this never happens in practice when utilising this in
				 * confluence, as the collab/synchrony initialisation process will
				 * trigger a transaction which adds tables, and thus this plugin will
				 * add/dedupe the necessary IDs. But general usage of the editor
				 * without collab should still solve for IDs.
				 */ update (editorView) {
                    const { state: state } = editorView;
                    const pluginState = $d5b05171647091ac$var$getPluginState(state);
                    if (!pluginState) return;
                    const parsed = pluginState.parsedForLocalIds;
                    if (parsed) return;
                    const { table: table } = state.schema.nodes;
                    (0, $2P8Ax.default)(()=>{
                        const tr = editorView.state.tr;
                        let tableIdWasAdded = false;
                        editorView.state.doc.descendants((node, pos)=>{
                            const isTable = node.type === table;
                            const localId = node.attrs.localId;
                            if (isTable && !localId) {
                                tableIdWasAdded = true;
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    localId: (0, $fO7hX.uuid).generate()
                                });
                                return false;
                            }
                            /**
							 * Otherwise continue traversing, we can encounter tables nested in
							 * expands/bodiedExtensions
							 */ return true;
                        });
                        if (tableIdWasAdded) {
                            tr.setMeta('addToHistory', false);
                            editorView.dispatch(tr);
                        }
                    })();
                    editorView.dispatch(state.tr.setMeta($d5b05171647091ac$var$pluginKey, {
                        parsedForLocalIds: true
                    }));
                }
            };
        },
        appendTransaction: (transactions, _oldState, newState)=>{
            let modified = false;
            const tr = newState.tr;
            const { table: table } = newState.schema.nodes;
            const addedTableNodes = new Set();
            const addedTableNodePos = new Map();
            const localIds = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Don't interfere with cut as it clashes with fixTables & we don't need
                // to handle any extra cut cases in this plugin
                const uiEvent = transaction.getMeta('uiEvent');
                if (uiEvent === 'cut') return;
                /** Get the tables we are adding and their position */ for (const step of transaction.steps){
                    if (!(0, $kTbzR.stepHasSlice)(step)) continue;
                    step.slice.content.descendants((node)=>{
                        if (node.type === table) addedTableNodes.add(node);
                        return true;
                    });
                }
            });
            if (!addedTableNodes.size) return;
            // Get the existing localIds on the page
            newState.doc.descendants((node, pos)=>{
                // Skip if this is position of added table
                if (addedTableNodes.has(node)) {
                    addedTableNodePos.set(node, pos);
                    return false;
                }
                if (node.type !== table) return true;
                localIds.add(node.attrs.localId);
                // can't have table within a table
                return false;
            });
            // If the added nodes have duplicate id, generate a new one
            for (const node of addedTableNodes)if (!node.attrs.localId || localIds.has(node.attrs.localId)) {
                const pos = addedTableNodePos.get(node);
                if (pos === undefined) continue;
                tr.setNodeMarkup(pos, undefined, {
                    ...node.attrs,
                    localId: (0, $fO7hX.uuid).generate()
                });
                modified = true;
            }
            if (modified) return tr;
            return;
        }
    });













































const $85a33fc35d6cf43a$export$b4a93e0b711d8f7 = (view, event, localResizeHandlePos, getEditorContainerWidth, getEditorFeatureFlags, isTableScalingEnabled, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isCommentEditor)=>{
    const { state: state, dispatch: dispatch } = view;
    const editorDisabled = !view.editable;
    const domAtPos = view.domAtPos.bind(view);
    const { width: editorWidth } = getEditorContainerWidth();
    if (editorDisabled || localResizeHandlePos === null || !(0, $b61fc0745b235461$export$3c89e45c7dff9619)(state.doc.resolve(localResizeHandlePos))) return false;
    const { isKeyboardResize: isKeyboardResize } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
    event.preventDefault();
    if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.startFeature('tableColumnResize');
    const tr = view.state.tr;
    tr.setMeta((0, $92e1eed7d2f10a77$export$210bf30466b5bcc8).OVERFLOW_TRIGGER, {
        name: (0, $3824I.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED_COLUMN
    });
    dispatch(tr);
    const mouseDownTime = event.timeStamp;
    const cell = state.doc.nodeAt(localResizeHandlePos);
    const $cell = state.doc.resolve(localResizeHandlePos);
    const originalTable = $cell.node(-1);
    const start = $cell.start(-1);
    const tablePos = state.doc.resolve(start).start(-1);
    const tableDepth = state.doc.resolve(tablePos).depth;
    let dom = domAtPos(start).node;
    if (dom && dom.nodeName !== 'TABLE') dom = dom.closest('table');
    let maxSize = 0;
    if (isTableScalingEnabled && isCommentEditor && !originalTable.attrs?.width) maxSize = editorWidth - (0, $8588522c22c049a0$export$c332ba2dd5aa2199);
    else maxSize = (0, $b61fc0745b235461$export$8bfbafe1083a527d)({
        table: originalTable,
        tableStart: start,
        state: state,
        layout: originalTable.attrs.layout,
        getEditorContainerWidth: getEditorContainerWidth
    });
    let shouldScale = tableDepth === 0 && isTableScalingEnabled;
    const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && tableWithFixedColumnWidthsOption;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
    let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingEnabled && isCommentEditor) {
        shouldScale = tableDepth === 0;
        shouldUseIncreasedScalingPercent = true;
    }
    const resizeState = (0, $77650a1f6e0f1ab2$export$38f73cf370cfaafc)({
        minWidth: (0, $1zav4.tableCellMinWidth),
        maxSize: maxSize,
        table: originalTable,
        tableRef: dom,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: shouldScale,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor || false
    });
    if ((0, $fab8fdccc1cad2fc$export$c955b9a736441250)({
        resizeState: resizeState,
        table: originalTable,
        start: start,
        event: event,
        api: api
    })(state, dispatch)) {
        finish(event);
        return true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const width = (0, $b61fc0745b235461$export$8f862fd911e06936)(view, localResizeHandlePos, cell.attrs);
    (0, $fab8fdccc1cad2fc$export$e747fb9908ce65b7)({
        startX: event.clientX,
        startWidth: width
    })(state, dispatch);
    // When we start resizing a column we need to ensure the underlying tooltip is removed from the decoration to avoid
    // unnecessary tooltips being displayed during drag.
    (0, $4ca83755c936c9c8$export$31eed8673ceee613)(nodeViewPortalProviderAPI, undefined, undefined, false)(state, dispatch);
    function finish(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('mouseup', finish);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('mousemove', move);
        const { clientX: clientX } = event;
        const { state: state, dispatch: dispatch } = view;
        const { dragging: dragging, resizeHandlePos: resizeHandlePos } = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state);
        const { isTableHovered: isTableHovered } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        if (resizeHandlePos === null) {
            if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableColumnResize');
            return (0, $fab8fdccc1cad2fc$export$d1301521f1f26547)()(state, dispatch);
        }
        if (!(0, $b61fc0745b235461$export$3c89e45c7dff9619)(state.doc.resolve(resizeHandlePos))) {
            if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableColumnResize');
            return;
        }
        // resizeHandlePos could be remapped via a collab change.
        // Fetch a fresh reference of the table.
        const $cell = state.doc.resolve(resizeHandlePos);
        const start = $cell.start(-1);
        const table = $cell.node(-1);
        const tablePos = state.doc.resolve(start).start(-1);
        const tableDepth = state.doc.resolve(tablePos).depth;
        // If we let go in the same place we started, don't need to do anything.
        if (dragging && clientX === dragging.startX) {
            if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableColumnResize');
            if (isKeyboardResize || !isTableHovered) /** if column resize had started via keyboard but continued by mouse
				 *  or mouse pointer leaves the table but mouse button still pressed
				 */ return (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({})(state, dispatch, view);
            else return (0, $fab8fdccc1cad2fc$export$d1301521f1f26547)()(state, dispatch);
        }
        let { tr: tr } = state;
        if (dragging) {
            const { startX: startX } = dragging;
            // If the dimensions of the table have changed through a remote modification by another
            // person for example don't persist the new column widths as we couldn't reliably remap them
            // For example, if a table col is deleted
            // There may be a more elegant solution to this, to avoid a jarring experience. This used to
            // be an equality check but that caused issues when a nested table would change (eg. when it
            // dynamically updates its width on resize)
            if (!(0, $bdb0299b531c40df$export$bc84d95d2dfa63bf)(originalTable, table)) {
                const map = (0, $LmqWp.TableMap).get(table);
                const colIndex = map.colCount($cell.pos - start) + ($cell.nodeAfter ? $cell.nodeAfter.attrs.colspan : 1) - 1;
                const selectionRect = (0, $iP1et.getSelectionRect)(state.selection);
                const selectedColumns = selectionRect ? (0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect) : [];
                // only selected (or selected - 1) columns should be distributed
                const resizingSelectedColumns = selectedColumns.indexOf(colIndex) > -1 || selectedColumns.indexOf(colIndex + 1) > -1;
                let shouldScale = tableDepth === 0 && isTableScalingEnabled;
                if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
                const resizedDelta = clientX - startX;
                const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && !!isCommentEditor;
                const scalePercent = isTableScalingEnabled && isCommentEditor && !table.attrs?.width ? (0, $b61fc0745b235461$export$4e884677f8e54bba)(originalTable, dom) : (0, $b61fc0745b235461$export$b2c142721a99201b)(originalTable, dom, shouldUseIncreasedScalingPercent);
                const newResizeState = (0, $b475a539e4faa154$export$7f7e69ee7fe25ed6)(resizeState, colIndex, resizedDelta, dom, originalTable, resizingSelectedColumns ? selectedColumns : undefined, shouldScale, scalePercent);
                tr = (0, $b2a65d666c2c28a8$export$6688b13ec132acdf)(newResizeState, table, start, api)(tr);
                if (colIndex === map.width - 1) {
                    const mouseUpTime = event.timeStamp;
                    editorAnalyticsAPI?.attachAnalyticsEvent({
                        action: (0, $3824I.TABLE_ACTION).ATTEMPTED_TABLE_WIDTH_CHANGE,
                        actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        attributes: {
                            type: 'table-border',
                            position: 'right',
                            duration: mouseUpTime - mouseDownTime,
                            delta: Math.abs(resizedDelta)
                        },
                        eventType: (0, $d925B.EVENT_TYPE).UI
                    })(tr);
                }
                editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $3824I.TABLE_ACTION).COLUMN_RESIZED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                    eventType: (0, $d925B.EVENT_TYPE).TRACK,
                    attributes: {
                        colIndex: colIndex,
                        resizedDelta: resizedDelta,
                        isLastColumn: colIndex === map.width - 1,
                        tableWidth: table.attrs.width,
                        inputMethod: (0, $d925B.INPUT_METHOD).MOUSE,
                        totalRowCount: map.height,
                        totalColumnCount: map.width
                    }
                })(tr);
            }
            if ((0, $1oCLl.expValEquals)('cc_editor_interactivity_monitoring', 'isEnabled', true)) (0, $2v1PW.insm).session?.endFeature('tableColumnResize');
            if (isKeyboardResize || !isTableHovered) /** if column resize had started via keyboard but continued by mouse
				 *  or mouse pointer leaves the table but mouse button still pressed
				 */ return (0, $9f1d04378e27f5e1$export$b77825ff607efdbb)({
                originalTr: tr
            })(state, dispatch, view);
            else return (0, $fab8fdccc1cad2fc$export$d1301521f1f26547)(tr)(state, dispatch);
        }
    }
    function move(event) {
        const { clientX: clientX, which: which } = event;
        const { state: state } = view;
        const { dragging: dragging, resizeHandlePos: resizeHandlePos } = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state);
        const { isTableHovered: isTableHovered } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
        const tablePos = state.doc.resolve(start).start(-1);
        if (!which || !dragging || resizeHandlePos === null || !(0, $b61fc0745b235461$export$3c89e45c7dff9619)(state.doc.resolve(resizeHandlePos)) || !isTableHovered) return finish(event);
        const $cell = state.doc.resolve(resizeHandlePos);
        const table = $cell.node(-1);
        const tableDepth = state.doc.resolve(tablePos).depth;
        const map = (0, $LmqWp.TableMap).get(table);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const colIndex = map.colCount($cell.pos - $cell.start(-1)) + $cell.nodeAfter.attrs.colspan - 1;
        let shouldScale = tableDepth === 0 && isTableScalingEnabled;
        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
        const resizedDelta = clientX - dragging.startX;
        const scalePercent = isTableScalingEnabled && isCommentEditor && !table.attrs?.width ? (0, $b61fc0745b235461$export$4e884677f8e54bba)(table, dom) : (0, $b61fc0745b235461$export$b2c142721a99201b)(originalTable, dom, shouldUseIncreasedScalingPercent);
        (0, $b475a539e4faa154$export$7f7e69ee7fe25ed6)(resizeState, colIndex, resizedDelta, dom, table, undefined, shouldScale, scalePercent);
        (0, $b432f0a26e9b5b59$export$13c259c17cfd51f5)()(state);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('mouseup', finish);
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('mousemove', move);
    return true;
};





function $b3a746dda27eb371$export$ae829ec7b2625219(dispatch, { lastColumnResizable: lastColumnResizable = true }, getEditorContainerWidth, getEditorFeatureFlags, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled, isCommentEditor) {
    return new (0, $1S4f7.SafePlugin)({
        key: (0, $452bdd9463f93418$export$18d4026d1ea86bb1),
        state: (0, $bd73f3b7ba9edc98$export$656c7661095efe2e)(dispatch, {
            lastColumnResizable: lastColumnResizable,
            resizeHandlePos: null,
            dragging: null,
            lastClick: null
        }),
        props: {
            attributes (state) {
                const pluginState = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state);
                return {
                    class: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))({
                        [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_CURSOR]: pluginState.resizeHandlePos !== null,
                        [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING]: !!pluginState.dragging
                    })
                };
            },
            handleDOMEvents: {
                mousedown (view, event) {
                    const { state: state } = view;
                    const resizeHandlePos = // we're setting `resizeHandlePos` via command in unit tests
                    (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state).resizeHandlePos || (0, $b432f0a26e9b5b59$export$3658aa65e79e3104)(view, event);
                    const { dragging: dragging } = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(state);
                    let isColumnKeyboardResizeStarted = false;
                    /*
          	We need to start listening mouse events if column resize started from keyboard.
          	This will allow continue resizing via mouse
          */ const { isKeyboardResize: isKeyboardResize } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
                    if (isKeyboardResize) isColumnKeyboardResizeStarted = isKeyboardResize;
                    if (resizeHandlePos !== null && (!dragging || isColumnKeyboardResizeStarted)) {
                        if ((0, $85a33fc35d6cf43a$export$b4a93e0b711d8f7)(view, event, resizeHandlePos, getEditorContainerWidth, getEditorFeatureFlags, isTableScalingEnabled || false, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isCommentEditor)) {
                            const { state: state, dispatch: dispatch } = view;
                            return (0, $fab8fdccc1cad2fc$export$4d14ce8b526952e5)(resizeHandlePos)(state, dispatch);
                        }
                    }
                    return false;
                }
            }
        }
    });
}













var $adhil = parcelRequire("adhil");

var $l6okE = parcelRequire("l6okE");

var $cQ4aK = parcelRequire("cQ4aK");

























var $5a97dbfcccfa8f8d$var$TableSelectionDirection = /*#__PURE__*/ function(TableSelectionDirection) {
    TableSelectionDirection["TopToBottom"] = "TopToBottom";
    TableSelectionDirection["BottomToTop"] = "BottomToTop";
    return TableSelectionDirection;
}($5a97dbfcccfa8f8d$var$TableSelectionDirection || {});
const $5a97dbfcccfa8f8d$export$2c7e1bbc14ebf0ec = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection instanceof (0, $7XFGZ.CellSelection)) return $5a97dbfcccfa8f8d$var$arrowLeftFromCellSelection(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $adhil.GapCursorSelection)) return $5a97dbfcccfa8f8d$var$arrowLeftFromGapCursor(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $ks2lK.TextSelection)) return $5a97dbfcccfa8f8d$var$arrowLeftFromText(editorSelectionAPI)(selection)(state, dispatch);
            return false;
        };
const $5a97dbfcccfa8f8d$export$2e5835b1a25e33b = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection instanceof (0, $7XFGZ.CellSelection)) return $5a97dbfcccfa8f8d$var$arrowRightFromCellSelection(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $adhil.GapCursorSelection)) return $5a97dbfcccfa8f8d$var$arrowRightFromGapCursor(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $ks2lK.TextSelection)) return $5a97dbfcccfa8f8d$var$arrowRightFromText(editorSelectionAPI)(selection)(state, dispatch);
            return false;
        };
const $5a97dbfcccfa8f8d$var$arrowLeftFromCellSelection = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            if ((0, $iYC9s.isTableSelected)(state.selection) && editorSelectionAPI) {
                const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                if (selectionState?.selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Start) // we have full table cell selection and want to set gap cursor selection before table
                return $5a97dbfcccfa8f8d$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                else if (selectionState?.selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).End) // we have full table cell selection and want to set selection at end of last cell
                return $5a97dbfcccfa8f8d$var$setSelectionAtEndOfLastCell(editorSelectionAPI)(selection)(state, dispatch);
                else if (selectionState?.selectionRelativeToNode === undefined) // we have full table cell selection and want to set selection at start of first cell
                return $5a97dbfcccfa8f8d$var$setSelectionAtStartOfFirstCell(editorSelectionAPI)(selection, (0, $cQ4aK.RelativeSelectionPos).Before)(state, dispatch);
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$arrowRightFromCellSelection = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            if ((0, $iYC9s.isTableSelected)(state.selection) && editorSelectionAPI) {
                const { selectionRelativeToNode: selectionRelativeToNode } = editorSelectionAPI.sharedState.currentState() || {};
                if (selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Start) // we have full table cell selection and want to set selection at start of first cell
                return $5a97dbfcccfa8f8d$var$setSelectionAtStartOfFirstCell(editorSelectionAPI)(selection)(state, dispatch);
                else if (selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).End || selectionRelativeToNode === undefined) // we have full table cell selection and want to set gap cursor selection after table
                return $5a97dbfcccfa8f8d$var$setGapCursorAfterTable(editorSelectionAPI)()(state, dispatch);
            }
            return false;
        };
const $5a97dbfcccfa8f8d$export$41a42e79fbe56d35 = (editorSelectionAPI, ariaNotify, getIntl)=>(triggeredByKeyboard = false)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $id9O1.findTable)(selection);
            const rect = (0, $2QyFu.selectedRect)(state);
            if (table && (0, $iYC9s.isRowSelected)(rect.top)(selection)) return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            if (table && rect) {
                const selectColumnCommand = (0, $4ca83755c936c9c8$export$c2e8772deb1607ea)(rect.left, undefined, triggeredByKeyboard)(state, dispatch);
                const map = (0, $LmqWp.TableMap).get(table.node);
                if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).columnSelected, {
                    index: rect.left + 1,
                    total: map.width
                }), {
                    priority: 'important'
                });
                return selectColumnCommand;
            }
            return false;
        };
const $5a97dbfcccfa8f8d$export$b5ba3b60192c7a8d = (editorSelectionAPI, ariaNotify, getIntl)=>(triggeredByKeyboard = false)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $id9O1.findTable)(selection);
            const rect = (0, $2QyFu.selectedRect)(state);
            if (table && (0, $iYC9s.isColumnSelected)(rect.left)(selection)) return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            if (table && rect) {
                const selectRowCommand = (0, $4ca83755c936c9c8$export$e247ed8cec4832f4)(rect.top, undefined, triggeredByKeyboard)(state, dispatch);
                const map = (0, $LmqWp.TableMap).get(table.node);
                if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $2CQVV.messages).rowSelected, {
                    index: rect.top + 1,
                    total: map.height
                }), {
                    priority: 'important'
                });
                return selectRowCommand;
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$arrowLeftFromGapCursor = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const { doc: doc } = state;
            const { $from: $from, from: from, side: side } = selection;
            if (side === (0, $adhil.Side).RIGHT) {
                if ($from.nodeBefore && $from.nodeBefore.type.name === 'table') // we have a gap cursor after a table node and want to set a full table cell selection
                return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                    node: $from.nodeBefore,
                    startPos: doc.resolve(from - 1).start($from.depth + 1),
                    dir: "TopToBottom"
                })(state, dispatch);
            } else if (side === (0, $adhil.Side).LEFT) {
                const table = (0, $id9O1.findTable)(selection);
                if (table && $5a97dbfcccfa8f8d$var$isSelectionAtStartOfTable($from, selection) && editorSelectionAPI) {
                    const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                    if (selectionState?.selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Before) // we have a gap cursor at start of first table cell and want to set a gap cursor selection before table
                    return $5a97dbfcccfa8f8d$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                    else // we have a gap cursor at start of first table cell and want to set a full table cell selection
                    return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                        node: table.node,
                        startPos: table.start,
                        dir: "BottomToTop"
                    })(state, dispatch);
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$arrowRightFromGapCursor = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const { $from: $from, from: from, $to: $to, side: side } = selection;
            if (side === (0, $adhil.Side).LEFT) {
                if ($from.nodeAfter && $from.nodeAfter.type.name === 'table') // we have a gap cursor before a table node and want to set a full table cell selection
                return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                    node: $from.nodeAfter,
                    startPos: from + 1,
                    dir: "BottomToTop"
                })(state, dispatch);
            } else if (side === (0, $adhil.Side).RIGHT) {
                const table = (0, $id9O1.findTable)(selection);
                if (table && $5a97dbfcccfa8f8d$var$isSelectionAtEndOfTable($to, selection)) // we have a gap cursor at end of last table cell and want to set a full table cell selection
                return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                    node: table.node,
                    startPos: table.start,
                    dir: "TopToBottom"
                })(state, dispatch);
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$arrowLeftFromText = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const table = (0, $id9O1.findTable)(selection);
            if (table) {
                const { $from: $from } = selection;
                const columResizePluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state) || {};
                const isColumnResizing = Boolean(columResizePluginState?.isKeyboardResize);
                if ($5a97dbfcccfa8f8d$var$isSelectionAtStartOfTable($from, selection) && $from.parent.type.name === 'paragraph' && $from.depth === table.depth + 3 && // + 3 for: row, cell & paragraph nodes
                editorSelectionAPI && !isColumnResizing) {
                    const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                    if (selectionState?.selectionRelativeToNode === (0, $cQ4aK.RelativeSelectionPos).Before) // we have a text selection at start of first table cell, directly inside a top level paragraph,
                    // and want to set gap cursor selection before table
                    return $5a97dbfcccfa8f8d$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                    else // we have a text selection at start of first table cell, directly inside a top level paragraph,
                    // and want to set a full table cell selection
                    return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                        node: table.node,
                        startPos: table.start,
                        dir: "BottomToTop"
                    })(state, dispatch);
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$arrowRightFromText = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const table = (0, $id9O1.findTable)(selection);
            if (table) {
                const { $to: $to } = selection;
                const columResizePluginState = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state) || {};
                const isColumnResizing = Boolean(columResizePluginState?.isKeyboardResize);
                if ($5a97dbfcccfa8f8d$var$isSelectionAtEndOfTable($to, selection) && $to.parent.type.name === 'paragraph' && $to.depth === table.depth + 3 && // + 3 for: row, cell & paragraph nodes
                !isColumnResizing) // we have a text selection at end of last table cell, directly inside a top level paragraph,
                // and want to set a full table cell selection
                return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                    node: table.node,
                    startPos: table.start,
                    dir: "TopToBottom"
                })(state, dispatch);
            }
            return false;
        };
/**
 * sets a cell selection over the table cell in which the selection is inside of
 */ const $5a97dbfcccfa8f8d$var$selectTableCell = (state, dispatch)=>{
    const $cell = (0, $3gZJH.cellAround)(state.selection.$from);
    if (!$cell) return false;
    if (dispatch) {
        dispatch(state.tr.setSelection(new (0, $7XFGZ.CellSelection)($cell)));
        return true;
    }
    return false;
};
/**
 * Sets a cell selection over all the cells in the table node
 * We use this instead of selectTable from prosemirror-utils so we can control which
 * cell is the anchor and which is the head, and also so we can set the relative selection
 * pos in the selection plugin
 */ const $5a97dbfcccfa8f8d$var$selectFullTable = (editorSelectionAPI)=>({ node: node, startPos: startPos, dir: dir })=>(state, dispatch)=>{
            const { doc: doc } = state;
            const { map: map } = (0, $LmqWp.TableMap).get(node);
            const $firstCell = doc.resolve(startPos + map[0]);
            const $lastCell = doc.resolve(startPos + map[map.length - 1]);
            let fullTableSelection;
            let selectionRelativeToNode;
            if (dir === "TopToBottom") {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fullTableSelection = new (0, $7XFGZ.CellSelection)($firstCell, $lastCell);
                selectionRelativeToNode = (0, $cQ4aK.RelativeSelectionPos).End;
            } else {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fullTableSelection = new (0, $7XFGZ.CellSelection)($lastCell, $firstCell);
                selectionRelativeToNode = (0, $cQ4aK.RelativeSelectionPos).Start;
            }
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: fullTableSelection
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$setSelectionAtStartOfFirstCell = (editorSelectionAPI)=>(selection, selectionRelativeToNode)=>(state, dispatch)=>{
            const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
            const $firstCell = $anchorCell.pos < $headCell.pos ? $anchorCell : $headCell;
            const $firstPosInsideCell = state.doc.resolve($firstCell.pos + 1);
            // check if first pos should have a gap cursor, otherwise find closest text selection
            const selectionAtStartOfCell = (0, $adhil.GapCursorSelection).valid($firstPosInsideCell) ? new (0, $adhil.GapCursorSelection)($firstPosInsideCell, (0, $adhil.Side).LEFT) : (0, $ks2lK.Selection).findFrom($firstPosInsideCell, 1);
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: selectionAtStartOfCell
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$setSelectionAtEndOfLastCell = (editorSelectionAPI)=>(selection, selectionRelativeToNode)=>(state, dispatch)=>{
            const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
            const $lastCell = $anchorCell.pos > $headCell.pos ? $anchorCell : $headCell;
            const lastPosInsideCell = $lastCell.pos + ($lastCell.nodeAfter ? $lastCell.nodeAfter.content.size : 0) + 1;
            const $lastPosInsideCell = state.doc.resolve(lastPosInsideCell);
            // check if last pos should have a gap cursor, otherwise find closest text selection
            const selectionAtEndOfCell = (0, $adhil.GapCursorSelection).valid($lastPosInsideCell) ? new (0, $adhil.GapCursorSelection)($lastPosInsideCell, (0, $adhil.Side).RIGHT) : (0, $ks2lK.Selection).findFrom($lastPosInsideCell, -1);
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: selectionAtEndOfCell
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$setGapCursorBeforeTable = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const table = (0, $id9O1.findTable)(state.selection);
            if (table) {
                const $beforeTablePos = state.doc.resolve(table.pos);
                if ((0, $adhil.GapCursorSelection).valid($beforeTablePos)) {
                    const selectionBeforeTable = new (0, $adhil.GapCursorSelection)($beforeTablePos, (0, $adhil.Side).LEFT);
                    if (editorSelectionAPI) {
                        const tr = editorSelectionAPI.actions.selectNearNode({
                            selectionRelativeToNode: undefined,
                            selection: selectionBeforeTable
                        })(state);
                        if (dispatch) {
                            dispatch(tr);
                            return true;
                        }
                    }
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$setGapCursorAfterTable = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const table = (0, $id9O1.findTable)(state.selection);
            if (table) {
                const $afterTablePos = state.doc.resolve(table.pos + table.node.nodeSize);
                if ((0, $adhil.GapCursorSelection).valid($afterTablePos)) {
                    const selectionAfterTable = new (0, $adhil.GapCursorSelection)($afterTablePos, (0, $adhil.Side).RIGHT);
                    if (editorSelectionAPI) {
                        const tr = editorSelectionAPI.actions.selectNearNode({
                            selectionRelativeToNode: undefined,
                            selection: selectionAfterTable
                        })(state);
                        if (dispatch) {
                            dispatch(tr);
                            return true;
                        }
                    }
                    return false;
                }
            }
            return false;
        };
const $5a97dbfcccfa8f8d$var$isSelectionAtStartOfTable = ($pos, selection)=>(0, $l6okE.isSelectionAtStartOfNode)($pos, (0, $id9O1.findTable)(selection)?.node);
const $5a97dbfcccfa8f8d$var$isSelectionAtEndOfTable = ($pos, selection)=>(0, $l6okE.isSelectionAtEndOfNode)($pos, (0, $id9O1.findTable)(selection)?.node);
const $5a97dbfcccfa8f8d$export$ef446fa0355915f = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $id9O1.findTable)(selection);
            const selectionRect = (0, $b9cb78eca8ad2cf1$export$e3ff63a8559e7571)(state);
            const index = selectionRect?.top;
            if (table && index === 0) return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            return false;
        };
const $5a97dbfcccfa8f8d$export$1de5b4cd2a72d822 = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $id9O1.findTable)(selection);
            if (!table) return false;
            const { $from: $from, $to: $to } = selection;
            const tableSelected = (0, $iYC9s.isTableSelected)(selection);
            const isCellSelection = selection instanceof (0, $7XFGZ.CellSelection);
            // if no cells are selected
            if (!isCellSelection && (0, $1oCLl.expValEquals)('platform_editor_lovability_select_all_shortcut', 'isEnabled', true)) return $5a97dbfcccfa8f8d$var$selectTableCell(state, dispatch);
            else if (!tableSelected && $from.pos > table.start + 1 && $to.pos < table.start + table.node.nodeSize) return $5a97dbfcccfa8f8d$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            return false;
        };


function $493109f8baa484ba$export$21439b5bf6b9c77f(pluginInjectionApi, getIntl) {
    const list = {};
    const editorSelectionAPI = pluginInjectionApi?.selection;
    const ariaNotifyPlugin = pluginInjectionApi?.accessibilityUtils?.actions.ariaNotify;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveRight).common, (0, $5a97dbfcccfa8f8d$export$2e5835b1a25e33b)(editorSelectionAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.moveLeft).common, (0, $5a97dbfcccfa8f8d$export$2c7e1bbc14ebf0ec)(editorSelectionAPI)(), list);
    (0, $hgeg8.bindKeymapArrayWithCommand)((0, $hgeg8.selectColumn), (0, $5a97dbfcccfa8f8d$export$41a42e79fbe56d35)(editorSelectionAPI, ariaNotifyPlugin, getIntl)(true), list);
    (0, $hgeg8.bindKeymapArrayWithCommand)((0, $hgeg8.selectRow), (0, $5a97dbfcccfa8f8d$export$b5ba3b60192c7a8d)(editorSelectionAPI, ariaNotifyPlugin, getIntl)(true), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.shiftArrowUp).common, (0, $5a97dbfcccfa8f8d$export$ef446fa0355915f)(editorSelectionAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.bindKeymapWithCommand)((0, $hgeg8.selectTable).common, (0, $5a97dbfcccfa8f8d$export$1de5b4cd2a72d822)(editorSelectionAPI)(), list);
    return (0, $dus6D.keymap)(list);
}








const $030f86662bf3c0ad$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableSizeSelectorPlugin');
const $030f86662bf3c0ad$export$ae829ec7b2625219 = (dispatch)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $030f86662bf3c0ad$export$18d4026d1ea86bb1,
        state: {
            init: ()=>({
                    isSelectorOpen: false
                }),
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($030f86662bf3c0ad$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return currentPluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...currentPluginState,
                            ...meta
                        };
                        dispatch($030f86662bf3c0ad$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return currentPluginState;
            }
        }
    });
};



/*
	Existing legacy tables in Comment editor have set attributes:
	- width = 760
	- layout = 'default'.

	When "Support Table in Comment" FF is enabled, table resizing (and table alignment in Confluence comments) is turned.
	It results in (ED-24795) all exising tables being set 760px width. Instead they all should inherit width from
	the editor container until a user decided to edit their old comment and set a custom table width themselves.

	This plugin exists to fix the described issue. It ensures that once "Support Table in Comment" FF turned on,
	existing tables continue to inherit the width of editor container and are 'left-aligned' by default.
*/ 












const $0a5bcf7050b8ed19$export$18d4026d1ea86bb1 = new (0, $ks2lK.PluginKey)('tableWidthInCommentFixPlugin');
const $0a5bcf7050b8ed19$var$getPluginState = (state)=>state && $0a5bcf7050b8ed19$export$18d4026d1ea86bb1.getState(state);
const $0a5bcf7050b8ed19$export$ae829ec7b2625219 = (dispatch, isTableAlignmentEnabled)=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $0a5bcf7050b8ed19$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    documentHasLoadedOnce: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($0a5bcf7050b8ed19$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($0a5bcf7050b8ed19$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view: ()=>{
            return {
                update (editorView) {
                    const { state: state } = editorView;
                    const pluginState = $0a5bcf7050b8ed19$var$getPluginState(state);
                    if (!pluginState) return;
                    const { documentHasLoadedOnce: documentHasLoadedOnce } = pluginState;
                    if (documentHasLoadedOnce) return;
                    const { table: table } = state.schema.nodes;
                    (0, $2P8Ax.default)(()=>{
                        const tr = editorView.state.tr;
                        let tableWidthAndLayoutUpdated = false;
                        editorView.state.doc.descendants((node, pos)=>{
                            const isTable = node.type === table;
                            const width = node.attrs.width;
                            const layout = node.attrs.layout;
                            if (isTable && width === (0, $aFUXX.akEditorDefaultLayoutWidth) && layout === 'default') {
                                tableWidthAndLayoutUpdated = true;
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    width: null,
                                    layout: isTableAlignmentEnabled ? (0, $8b84c930bc26bcf8$export$2cbc54593c64b1f2) : 'default'
                                });
                                return false;
                            }
                            // Returning false here because don't need to change nested tables
                            return false;
                        });
                        if (tableWidthAndLayoutUpdated) {
                            tr.setMeta('addToHistory', false);
                            editorView.dispatch(tr);
                        }
                    })();
                    editorView.dispatch(state.tr.setMeta($0a5bcf7050b8ed19$export$18d4026d1ea86bb1, {
                        documentHasLoadedOnce: true
                    }));
                }
            };
        }
    });
};




/**
 * This plugin allows sorting of table nodes in the Editor without modifying the underlying ProseMirror document.
 * Instead of making changes to the ProseMirror document, the plugin sorts the table rows in the DOM. This allows the sorting to be
 * visible to the user without affecting the document's content.
 */ 












var $2QYOD = parcelRequire("2QYOD");










parcelRequire("42omo");





var $7f6CO = parcelRequire("7f6CO");

const $a438db2af398b98d$export$25fb1502cf13990c = (props)=>{
    const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(props.api, [
        'editorViewMode'
    ], (states)=>({
            mode: states.editorViewModeState?.mode
        }));
    if (mode === 'edit') return null;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7f6CO.default), {
        ...props
    });
};



const $ef6a076f3671a2c9$export$b61cb5d3425147f = 'view-mode-sorting-icon';
const $ef6a076f3671a2c9$export$fb5c0ba8f0806db1 = 'is-disabled';
const $ef6a076f3671a2c9$export$665a01df2c44393a = 'data-sort-index';





const $1e532babbc96e86a$export$994e077cfffa9ab4 = new (0, $ks2lK.PluginKey)('tableViewModeSortPlugin');











const $b64e469133d270dc$export$f81e43e57018b033 = (oldOrder, tableElement)=>{
    const tbody = tableElement.querySelector(`:scope > tbody`);
    const rows = tableElement.querySelectorAll(`:scope > tbody > tr`);
    const sortedOrder = [
        ...oldOrder
    ].sort((a, b)=>a.value - b.value);
    sortedOrder.forEach((item)=>{
        tbody?.appendChild(rows[item.index + 1]);
    });
};
const $b64e469133d270dc$var$getSortOrderFromTable = (tableNode, sortIndex, direction)=>{
    const tableArray = (0, $caYZ2.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    tableArray.shift(); // remove header row
    // Keep track of the origin row index
    const tableArrayWithIndex = tableArray.map((node, index)=>({
            node: node,
            originalIndex: index
        }));
    const compareNodesInOrder = (0, $d4WtM.createCompareNodes)({
        // TODO: ED-26961 - add inline card support
        getInlineCardTextFromStore () {
            return null;
        }
    }, direction);
    const order = tableArrayWithIndex.sort((a, b)=>{
        return compareNodesInOrder(a.node[sortIndex], b.node[sortIndex]);
    }).map((tableRow, index)=>({
            value: tableRow.originalIndex,
            index: index
        }));
    return [
        // Ensures the first tr is always first in the order
        {
            value: -1,
            index: -1
        },
        ...order
    ];
};
const $b64e469133d270dc$export$e9466f5bf01e21a7 = (view, event, pluginState)=>{
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const widget = target.closest(`.${(0, $ef6a076f3671a2c9$export$b61cb5d3425147f)}`);
    if (widget?.classList.contains((0, $ef6a076f3671a2c9$export$fb5c0ba8f0806db1)) || !widget) return;
    const dataSortIndex = target?.closest('.ProseMirror-widget')?.getAttribute((0, $ef6a076f3671a2c9$export$665a01df2c44393a));
    const tr = view.state.tr;
    const tableElement = target.closest('table');
    if (!tableElement || !dataSortIndex) return;
    const tablePos = view.posAtDOM(tableElement, 0);
    const tableNode = view.state.doc.nodeAt(tablePos - 1);
    const tableId = tableNode?.attrs.localId;
    if (!tableId || !tableNode || tableNode?.type?.name !== 'table') return;
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { index: index, direction: direction, order: oldOrder } = pluginState?.[tableId] || {};
    // Unsort if there was already a sort
    if (direction !== (0, $2QYOD.SortOrder).NO_ORDER && oldOrder !== undefined) $b64e469133d270dc$export$f81e43e57018b033(oldOrder, tableElement);
    const sortIndex = parseInt(dataSortIndex);
    if (sortIndex === index) switch(direction){
        case (0, $2QYOD.SortOrder).NO_ORDER:
            direction = (0, $2QYOD.SortOrder).ASC;
            break;
        case (0, $2QYOD.SortOrder).ASC:
            direction = (0, $2QYOD.SortOrder).DESC;
            break;
        case (0, $2QYOD.SortOrder).DESC:
            direction = (0, $2QYOD.SortOrder).NO_ORDER;
            break;
    }
    else direction = (0, $2QYOD.SortOrder).ASC; // default direction when a new index is clicked
    const order = $b64e469133d270dc$var$getSortOrderFromTable(tableNode, sortIndex, direction);
    if (direction === (0, $2QYOD.SortOrder).NO_ORDER) tr.setMeta('tableSortMeta', {
        [tableId]: {}
    });
    else tr.setMeta('tableSortMeta', {
        [tableId]: {
            index: sortIndex,
            direction: direction,
            order: order,
            tableElement: tableElement
        }
    });
    view.dispatch(tr);
};
const $b64e469133d270dc$export$8bb6f5de29aeee1e = (tableId)=>{
    const tableElement = document.querySelector(`table[data-table-local-id="${tableId}"]`);
    const tbody = tableElement?.querySelector(':scope > tbody');
    const rows = tableElement?.querySelectorAll(':scope > tbody > tr');
    return {
        tbody: tbody,
        rows: rows
    };
};


const $236c7224c8ab51a2$export$ae829ec7b2625219 = (api, nodeViewPortalProviderAPI)=>{
    return new (0, $1S4f7.SafePlugin)({
        state: {
            init: ()=>({
                    decorations: (0, $ftzrq.DecorationSet).empty,
                    sort: {},
                    allTables: []
                }),
            apply (tr, pluginState, oldState) {
                // TODO: ED-26961 - move this mode check to plugin creation if possible. Right now it's here because the initial state
                // does not appear correct when the plugin is created.
                const { mode: mode } = api.editorViewMode?.sharedState.currentState() || {};
                if (mode !== 'view') {
                    const sortingDecorations = pluginState?.decorations?.find(undefined, undefined, (s)=>s?.type === 'sorting-decoration');
                    return {
                        ...pluginState,
                        decorations: pluginState?.decorations?.remove(sortingDecorations)
                    };
                }
                let { decorations: decorations, sort: sort, allTables: allTables } = pluginState;
                const sortMeta = tr.getMeta('tableSortMeta');
                const hoverTableMeta = tr.getMeta('mouseEnterTable');
                const removeTableMeta = tr.getMeta('removeTable');
                let tableId = '';
                // Remove the table from the state
                if (removeTableMeta) allTables = allTables.filter(([id])=>id !== removeTableMeta);
                else tableId = hoverTableMeta?.[0];
                sort = {
                    ...sort,
                    ...sortMeta
                };
                const isTableInState = allTables.some(([id])=>id === tableId);
                // Update the table in the state
                if (hoverTableMeta) {
                    allTables = allTables.filter(([id])=>id !== hoverTableMeta[0]);
                    allTables.push(hoverTableMeta);
                }
                /**
         * Create decorations for the sorting icons
         */ const decs = [];
                const sortingDecorations = pluginState.decorations.find(undefined, undefined, (spec)=>spec.tableId === tableId && spec.type === 'sorting-decoration');
                // TODO: ED-26961 - add support for keyboard only users
                if (hoverTableMeta && !isTableInState || sortMeta || isTableInState && !sortingDecorations.length) {
                    allTables.forEach((table)=>{
                        const [tableId, _node, pos] = table;
                        const tableNode = tr.doc.nodeAt(tr.mapping.map(pos));
                        if (!tableNode || tableNode.type.name !== 'table') return pluginState;
                        const map = (0, $LmqWp.TableMap).get(tableNode);
                        const hasMergedCells = new Set(map.map).size !== map.map.length;
                        map.mapByRow[0].forEach((cell, index)=>{
                            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                            const decorationRenderKey = (0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))();
                            decs.push((0, $ftzrq.Decoration).widget(cell + pos + 2, ()=>{
                                const element = document.createElement('div');
                                element.setAttribute((0, $ef6a076f3671a2c9$export$665a01df2c44393a), `${index}`);
                                element.classList.add((0, $ef6a076f3671a2c9$export$b61cb5d3425147f));
                                if (hasMergedCells) element.classList.add((0, $ef6a076f3671a2c9$export$fb5c0ba8f0806db1));
                                let sortOrdered;
                                if (index === sort[tableId]?.index) sortOrdered = sort[tableId]?.direction;
                                else sortOrdered = (0, $2QYOD.SortOrder).NO_ORDER;
                                const { getIntl: getIntl } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(oldState);
                                nodeViewPortalProviderAPI.render(()=>(0, $42omo.createElement)((0, $aXWIB.RawIntlProvider), {
                                        value: getIntl()
                                    }, (0, $42omo.createElement)((0, $a438db2af398b98d$export$25fb1502cf13990c), {
                                        isSortingAllowed: !hasMergedCells,
                                        sortOrdered: sortOrdered,
                                        onClick: ()=>{},
                                        onKeyDown: ()=>{},
                                        api: api
                                    })), element, decorationRenderKey);
                                return element;
                            }, {
                                destroy: (node)=>{
                                    nodeViewPortalProviderAPI.remove(decorationRenderKey);
                                },
                                type: 'sorting-decoration',
                                tableId: tableId
                            }));
                        });
                    });
                    decorations = (0, $ftzrq.DecorationSet).create(tr.doc, decs);
                }
                /**
         * Map the decorations to the new document if there are changes
         */ if (tr.docChanged) {
                    decorations = decorations.map(tr.mapping, tr.doc);
                    allTables = allTables.map((table)=>{
                        return [
                            table[0],
                            table[1],
                            tr.mapping.map(table[2])
                        ];
                    });
                }
                return {
                    decorations: decorations,
                    sort: sort,
                    allTables: allTables
                };
            }
        },
        key: $1e532babbc96e86a$export$994e077cfffa9ab4,
        appendTransaction: (trs, oldState, newState)=>{
            // return newState.tr;
            const { mode: mode } = api?.editorViewMode?.sharedState.currentState() || {};
            if (mode !== 'view') return newState.tr;
            let allTables = (0, $1e532babbc96e86a$export$994e077cfffa9ab4).getState(newState)?.allTables || [];
            /**
       * If incoming changes have affected a table node, remove the sorting. This prevents the
       * table from breaking if changes like merged cells are incoming.
       */ for (const tr of trs){
                const hoverTableMeta = tr.getMeta('mouseEnterTable');
                if (hoverTableMeta) {
                    allTables = allTables.filter(([id])=>id !== hoverTableMeta[0]);
                    allTables.push(hoverTableMeta);
                }
                const isRemote = tr.getMeta('isRemote');
                const isDocChanged = tr.docChanged;
                const isChangesIncoming = isRemote && isDocChanged;
                const oldPluginState = (0, $1e532babbc96e86a$export$994e077cfffa9ab4).getState(oldState);
                const newPluginState = (0, $1e532babbc96e86a$export$994e077cfffa9ab4).getState(newState);
                for (const table of allTables){
                    const [tableId, node, pos] = table;
                    const { order: oldOrder, direction: oldDirection, index: oldIndex } = oldPluginState?.sort?.[tableId] || {};
                    if (isChangesIncoming) {
                        const maybeTableNode = tr.doc.nodeAt(pos);
                        const isTableNodeChanged = maybeTableNode?.attrs?.localId !== tableId || !node.eq(maybeTableNode);
                        if (isTableNodeChanged) {
                            const newtr = newState.tr;
                            newtr.setMeta('tableSortMeta', {
                                [tableId]: {}
                            });
                            newtr.setMeta('removeTable', tableId);
                            // Unsort the table here
                            if (oldOrder !== undefined) {
                                const { rows: rows, tbody: tbody } = (0, $b64e469133d270dc$export$8bb6f5de29aeee1e)(tableId);
                                if (!rows || !tbody) return newtr;
                                const sortedOrder = [
                                    ...oldOrder
                                ].sort((a, b)=>a.value - b.value);
                                sortedOrder.forEach((index, i)=>{
                                    tbody.appendChild(rows[index.index + 1]);
                                });
                                return newtr;
                            }
                        }
                    }
                    /**
           * Sort the table if the sort order has changed
           */ const { order: newOrder, direction: newDirection, index: newIndex } = newPluginState?.sort?.[tableId] || {};
                    const orderChanged = oldDirection !== newDirection || oldIndex !== newIndex;
                    if (orderChanged) {
                        if (!isRemote && newDirection !== (0, $2QYOD.SortOrder).NO_ORDER) {
                            const { rows: rows, tbody: tbody } = (0, $b64e469133d270dc$export$8bb6f5de29aeee1e)(tableId);
                            if (rows && newOrder) newOrder.forEach((index, i)=>{
                                tbody?.appendChild(rows[index.value + 1]);
                            });
                        }
                    }
                }
            }
            return newState.tr;
        },
        props: {
            handleDOMEvents: {
                keydown: (view, event)=>{
                    // TODO: ED-26961 - fix the focus issue here, where toggling sort with a keypress loses focus
                    if (event.key === 'Enter' || event.key === ' ') {
                        const pluginState = (0, $1e532babbc96e86a$export$994e077cfffa9ab4).getState(view.state)?.sort || {};
                        (0, $b64e469133d270dc$export$e9466f5bf01e21a7)(view, event, pluginState);
                    }
                },
                click: (view, event)=>{
                    const pluginState = (0, $1e532babbc96e86a$export$994e077cfffa9ab4).getState(view.state)?.sort || {};
                    (0, $b64e469133d270dc$export$e9466f5bf01e21a7)(view, event, pluginState);
                }
            },
            decorations (state) {
                const decs = (0, $1e532babbc96e86a$export$994e077cfffa9ab4).getState(state)?.decorations || (0, $ftzrq.DecorationSet).empty;
                return decs;
            }
        }
    });
};





parcelRequire("42omo");





var $7fmpI = parcelRequire("7fmpI");


var $kuh1P = parcelRequire("kuh1P");





var $7x0qS = parcelRequire("7x0qS");







/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





















var $jwWgu = parcelRequire("jwWgu");


var $a4eZN = parcelRequire("a4eZN");








var $ghftu = parcelRequire("ghftu");


























/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766












var $1j8OE = parcelRequire("1j8OE");




var $ieXGd = parcelRequire("ieXGd");

var $b38UX = parcelRequire("b38UX");

/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $3e9f2b46b7207c53$export$b2380b18b089518f = `
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    overflow: hidden,
  }

  &::-webkit-scrollbar-corner {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-subtle, #00000000)"};
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-bold, #292A2E)"};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${"var(--ds-background-neutral-bold-hovered, #3B3D42)"};
  }
`;

















/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs mahual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766











function $a1b9a7d0f0cb60f0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a1b9a7d0f0cb60f0$var$InsertLine = (cssString)=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE, "{background:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";display:none;position:absolute;z-index:", (0, $aFUXX.akEditorUnitZIndex), ";", cssString, ";}");
const $a1b9a7d0f0cb60f0$var$Marker = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794),
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $fbbb9ee8877c285e$export$a3e71c692f2c2213)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $fbbb9ee8877c285e$export$a3e71c692f2c2213)}px`,
        borderRadius: "var(--ds-radius-full, 9999px)",
        pointerEvents: 'none'
    });
const $a1b9a7d0f0cb60f0$export$22ce45ffbca2b768 = (cssString)=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_MARKER, "{", $a1b9a7d0f0cb60f0$var$Marker(), ";", cssString, ";}");
const $a1b9a7d0f0cb60f0$var$Button = (cssString)=>/*#__PURE__*/ (0, $9K4OG.css)("border-radius:var(--ds-radius-small, 3px);border-width:0px;display:inline-flex;max-width:100%;text-align:center;margin:0px;padding:0px;text-decoration:none;transition:background 0.1s ease-out 0s,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;outline:none!important;cursor:none;>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_ICON, "{display:inline-flex;max-height:100%;max-width:100%;}", cssString, ";");
const $a1b9a7d0f0cb60f0$export$c7c73467b57835d = (cssString)=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, "{background:", (0, $fbbb9ee8877c285e$export$95883e661e73a1d1), ";border:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";display:block;box-sizing:border-box;padding:0;", cssString, ";:focus{outline:none;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON, "::after{content:' ';background-color:transparent;left:-15px;top:0;position:absolute;width:15px;height:100%;z-index:1;}.active .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, "{color:var(--ds-icon-inverse, #FFFFFF);background-color:", (0, $fbbb9ee8877c285e$export$8c5dd0fc35774ae1), ";border-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";}");
const $a1b9a7d0f0cb60f0$export$eb5435fbd56e8d4 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, ":hover{color:var(--ds-icon-inverse, #FFFFFF);background-color:", (0, $fbbb9ee8877c285e$export$8c5dd0fc35774ae1), ";border-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";cursor:pointer;}");
const $a1b9a7d0f0cb60f0$export$7f243984d41e6570 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, "{background-color:", (0, $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50), ";border-color:", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";position:relative;z-index:", (0, $aFUXX.akEditorUnitZIndex), ";}");
const $a1b9a7d0f0cb60f0$var$InsertButton = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $aFUXX.akEditorUnitZIndex) + 10, ";bottom:0;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON_INNER, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON, "{height:", (0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c), "px;width:", (0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON, "{", $a1b9a7d0f0cb60f0$var$Button(`
      background: ${"var(--ds-surface-overlay, #FFFFFF)"};
      box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"};
      color: ${"var(--ds-icon, #292A2E)"};
    `), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE, "{display:none;}&:hover .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE, "{display:flex;}");
const $a1b9a7d0f0cb60f0$var$InsertButtonHover = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON, ":hover{background:var(--ds-background-brand-bold, #1868DB);color:var(--ds-icon-inverse, #FFFFFF);cursor:pointer;}");
const $a1b9a7d0f0cb60f0$export$cfa9a9cdd25b9d6e = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $aFUXX.akEditorUnitZIndex) + 10, ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN, "{bottom:-3px;left:2px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW, "{left:-3px;bottom:-2px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS, "{left:6px;bottom:-2px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON, "{", $a1b9a7d0f0cb60f0$var$Button(`
    background: ${"var(--ds-surface-overlay, #FFFFFF)"};
    color: ${"var(--ds-icon, #292A2E)"};
    border: 1px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
    border-radius: 50%;
    height: ${(0, $fbbb9ee8877c285e$export$d18320cc8ee69115)}px;
    width: ${(0, $fbbb9ee8877c285e$export$d18320cc8ee69115)}px;
  `), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON, ":hover{background:var(--ds-background-brand-bold, #1868DB);border:1px solid var(--ds-background-brand-bold, #1868DB);color:var(--ds-icon-inverse, #FFFFFF);cursor:pointer;}");
const $a1b9a7d0f0cb60f0$export$6134f9ac8c9f161f = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON, "{width:15px;height:15px;display:flex;justify-content:center;align-items:center;position:absolute;top:-17px;left:-5px;background-color:transparent;border:none;padding:0;outline:none;z-index:", (0, $aFUXX.akEditorUnitZIndex) * 99, ";&.active .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER, "{background-color:var(--ds-border-selected, #1868DB);width:10px;height:10px;border-width:2px;border-radius:4px;top:3px;left:2px;}&:hover{cursor:pointer;.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER, "{width:10px;height:10px;border-radius:4px;top:3px;left:2px;}}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CORNER_BUTTON_INNER, "{border:1px solid var(--ds-border-inverse, #FFFFFF);background-color:var(--ds-background-accent-gray-subtler, #DDDEE1);border-radius:2px;width:5px;height:5px;position:relative;}");
const $a1b9a7d0f0cb60f0$export$d9daf73b486785b9 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertLine(`
    width: 2px;
    left: 9px;
  `));
const $a1b9a7d0f0cb60f0$export$595c9c01d7c39885 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $a1b9a7d0f0cb60f0$var$InsertLine(`
    height: 2px;
    top: -11px;
	${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
    left: ${(0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c) - 1}px;
  `));
const $a1b9a7d0f0cb60f0$export$6114ba9f95ca48dc = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, " table tr:first-of-type td,.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, " table tr:first-of-type th{position:relative;}");
const $a1b9a7d0f0cb60f0$export$d6f68d0fe29f8050 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON_WRAP, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON, "{height:", (0, $fbbb9ee8877c285e$export$cb376ed67c7ae37e), "px;width:", (0, $fbbb9ee8877c285e$export$cb376ed67c7ae37e), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON_WRAP, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON, "{", $a1b9a7d0f0cb60f0$var$Button(`
        background: ${(0, $fbbb9ee8877c285e$export$cd5e5900c9fa42dc)};
        color: ${(0, $fbbb9ee8877c285e$export$a699493d7d7580c3)};
      `), ";}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON, ":hover{background:", (0, $fbbb9ee8877c285e$export$9907ca2ad437ddcc), ";color:", (0, $fbbb9ee8877c285e$export$6cc2aa96833a5989), ";cursor:pointer;}");
const $a1b9a7d0f0cb60f0$export$f802e22253ad2b2c = (isDragAndDropEnabled)=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{display:block;height:calc(100% - ", (0, $1zav4.tableMarginTop), "px);position:absolute;pointer-events:none;top:", (0, $1zav4.tableMarginTop), "px;z-index:", (0, $aFUXX.akEditorShadowZIndex), ";width:", (0, $fbbb9ee8877c285e$export$1680d391e1ce7b96), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{background:linear-gradient(to left, transparent 0, var(--ds-shadow-overflow-spread, #1E1F2129) 140%),linear-gradient(\n\t\t\t\tto right,\n\t\t\t\tvar(--ds-shadow-overflow-perimeter, #1E1F211f) 0px,\n\t\t\t\ttransparent 1px\n\t\t\t);left:0px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true']>:not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SHADOW, ").", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{left:", (0, $aFUXX.akEditorTableNumberColumnWidth) - 1, "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{background:linear-gradient(to right, transparent 0, var(--ds-shadow-overflow-spread, #1E1F2129) 140%),linear-gradient(to left, var(--ds-shadow-overflow-perimeter, #1E1F211f) 0px, transparent 1px);left:calc(100% - ", (0, $fbbb9ee8877c285e$export$1680d391e1ce7b96), "px);}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, "{", $a1b9a7d0f0cb60f0$var$overflowShadowWidhoutDnD(isDragAndDropEnabled), " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{border-left:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";}}");
const $a1b9a7d0f0cb60f0$var$overflowShadowWidhoutDnD = (isDragAndDropEnabled)=>{
    if (!isDragAndDropEnabled) return /*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{height:calc(100% - ", (0, $1zav4.tableMarginTopWithControl), "px);top:", (0, $1zav4.tableMarginTopWithControl), "px;}");
};
const $a1b9a7d0f0cb60f0$export$b9641ea8858d4b62 = (tableOverflowShadowWidth)=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{width:", tableOverflowShadowWidth, "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{left:6px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:8px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{left:calc(100% - 6px);}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:calc(100% - 16px);}");
const $a1b9a7d0f0cb60f0$var$columnHeaderButton = (cssString)=>{
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: (0, $fbbb9ee8877c285e$export$95883e661e73a1d1),
        display: 'block',
        boxSizing: 'border-box',
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: 'none'
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    cssString);
};
const $a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        color: "var(--ds-text-inverse, #FFFFFF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $fbbb9ee8877c285e$export$8c5dd0fc35774ae1),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderColor: (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $fbbb9ee8877c285e$export$83da30a15600a83e)
    });
const $a1b9a7d0f0cb60f0$var$getFloatingDotOverrides = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)("tr th:last-child .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::before,tr td:last-child .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::before{content:'';background-color:", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";position:absolute;height:", (0, $fbbb9ee8877c285e$export$a3e71c692f2c2213), "px;width:", (0, $fbbb9ee8877c285e$export$a3e71c692f2c2213), "px;border-radius:50%;pointer-events:none;top:var(--ds-space-025, 2px);right:0px;}");
};
const $a1b9a7d0f0cb60f0$export$125caa90718a4ea9 = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_DROP_TARGET_CONTROLS, "{box-sizing:border-box;position:absolute;top:0;.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER, "{display:flex;flex-direction:row;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS, "{box-sizing:border-box;.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER, "{display:grid;justify-items:center;}}");
};
const $a1b9a7d0f0cb60f0$export$a2258906ae78ec82 = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)("div.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, ">.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, "::after{display:none;}div.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, ">.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, "::after{content:' ';background-color:", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";position:absolute;height:", (0, $fbbb9ee8877c285e$export$a3e71c692f2c2213), "px;width:", (0, $fbbb9ee8877c285e$export$a3e71c692f2c2213), "px;border-radius:50%;pointer-events:none;top:-", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px;right:-1px;}");
};
const $a1b9a7d0f0cb60f0$export$8c8180e74f25db6a = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "{display:none;cursor:pointer;position:absolute;width:100%;left:0;top:-", (0, $fbbb9ee8877c285e$export$62374dd2f63076b0) + (0, $1zav4.tableCellBorderWidth), "px;height:", (0, $fbbb9ee8877c285e$export$62374dd2f63076b0), "px;&::before{content:' ';background-color:", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";position:absolute;height:", (0, $fbbb9ee8877c285e$export$a3e71c692f2c2213), "px;width:", (0, $fbbb9ee8877c285e$export$a3e71c692f2c2213), "px;border-radius:50%;pointer-events:none;top:2px;right:var(--ds-space-negative-025, -2px);}&::after{content:' ';", $a1b9a7d0f0cb60f0$var$columnHeaderButton(`
        border-right: ${(0, $1zav4.tableCellBorderWidth)}px solid ${(0, $fbbb9ee8877c285e$export$60473ec4f7c2b794)};
        border-top: ${(0, $1zav4.tableCellBorderWidth)}px solid ${(0, $fbbb9ee8877c285e$export$60473ec4f7c2b794)};
        border-bottom: ${(0, $1zav4.tableCellBorderWidth)}px solid ${(0, $fbbb9ee8877c285e$export$60473ec4f7c2b794)};
        box-sizing: content-box;
        height: ${(0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) - 1}px;
        width: 100%;
        position: absolute;
        top: ${(0, $fbbb9ee8877c285e$export$62374dd2f63076b0) - (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b)}px;
        left: 0px;
        z-index: ${(0, $fbbb9ee8877c285e$export$da0ccd381b1a80f)};
      `), ";}}", $a1b9a7d0f0cb60f0$var$getFloatingDotOverrides(), " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "{display:block;}table tr:first-of-type td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, ",table tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED, ",&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_TABLE, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{", $a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected(), ";}&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50), ";border-color:", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";z-index:", (0, $aFUXX.akEditorUnitZIndex) * 100, ";}}}table tr:first-of-type td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, ",table tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED, ",&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_COLUMN, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{", $a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected(), ";border-left:", (0, $1zav4.tableCellBorderWidth), "px solid ", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";left:-", (0, $1zav4.tableCellBorderWidth), "px;}}}table tr:first-of-type td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, ",table tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_COLUMN, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{", $a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected(), ";}&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50), ";border-color:", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";border-left:", (0, $1zav4.tableCellBorderWidth), "px solid ", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";left:-", (0, $1zav4.tableCellBorderWidth), "px;z-index:", (0, $aFUXX.akEditorUnitZIndex) * 100, ";}}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SELECTED, " table tr:first-of-type td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SELECTED, " table tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{", $a1b9a7d0f0cb60f0$var$columnHeaderButtonSelected(), ";}}");
};
const $a1b9a7d0f0cb60f0$export$4d63bf225990ad34 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL, "{border:1px solid ", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, "::after{background:", (0, $fbbb9ee8877c285e$export$3c2a828febe9d506), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $fbbb9ee8877c285e$export$3c2a828febe9d506), ";border:1px solid ", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, "{background-color:unset;}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $fbbb9ee8877c285e$export$3c2a828febe9d506), ";border:1px solid ", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";}}}");
const $a1b9a7d0f0cb60f0$export$1c46f5412a5a3ae0 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON, "){.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL, "{position:relative;border:1px solid ", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, "{position:relative;border:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";}}");
const $a1b9a7d0f0cb60f0$export$40edb32b62e4fb85 = /*#__PURE__*/ (0, $9K4OG.css)(":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON, "){td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_WARNING, "{background-color:var(--ds-background-warning, #FFF5DB)!important;border:1px solid var(--ds-border-warning, #E06C00);}}");
// Explicit pixel values required here to ensure correct positioning and sizes of column resize handle
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $a1b9a7d0f0cb60f0$var$resizeLineStyles = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)("th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE, "::before,td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $fbbb9ee8877c285e$export$45d9825f76985b4e), "px;height:calc(100% + 2px);background-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";z-index:", (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before,td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $fbbb9ee8877c285e$export$45d9825f76985b4e), "px;height:calc(100% + 2px);background-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";z-index:", (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $fbbb9ee8877c285e$export$45d9825f76985b4e), "px;height:calc(100% + 2px);background-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";z-index:", (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, "::before{content:' ';left:var(--ds-space-negative-025, -2px);position:absolute;width:", (0, $fbbb9ee8877c285e$export$45d9825f76985b4e), "px;height:calc(100% + ", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px);background-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";z-index:", (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2, ";top:-", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px;}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $fbbb9ee8877c285e$export$45d9825f76985b4e), "px;height:calc(100% + 2px);background-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";z-index:", (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';right:-1px;position:absolute;width:", (0, $fbbb9ee8877c285e$export$45d9825f76985b4e), "px;height:calc(100% + ", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px);background-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";z-index:", (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2, ";top:-", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px;}");
};
const $a1b9a7d0f0cb60f0$export$8e36b812ea421d73 = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $fbbb9ee8877c285e$export$72409f838e9c33c7), "px;height:100%;top:0;right:-", (0, $fbbb9ee8877c285e$export$72409f838e9c33c7) / 2, "px;cursor:col-resize;z-index:", (0, $fbbb9ee8877c285e$export$887c1388be90c08e), ";}tr th:last-child .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, ",tr td:last-child .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $fbbb9ee8877c285e$export$72409f838e9c33c7) / 2, "px;height:100%;top:0;right:0;cursor:col-resize;z-index:", (0, $fbbb9ee8877c285e$export$887c1388be90c08e), ";}", $a1b9a7d0f0cb60f0$var$resizeLineStyles(), " table tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_DRAG_RESIZE_LINE, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after{top:-", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px;height:calc(100% + ", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $1zav4.tableCellBorderWidth), "px);}}");
// Drag and Drop: drop target insert line
const $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    content: "' '",
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100% + ${(0, $1zav4.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $fbbb9ee8877c285e$export$cc7ed656b7dcf729)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2
});
const $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    content: "' '",
    position: 'absolute',
    left: "var(--ds-space-negative-025, -2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $fbbb9ee8877c285e$export$cc7ed656b7dcf729)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(100% + ${(0, $1zav4.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $fbbb9ee8877c285e$export$da0ccd381b1a80f) * 2
});
const $a1b9a7d0f0cb60f0$var$insertLineActiveColor = /*#__PURE__*/ (0, $9K4OG.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb)
});
const $a1b9a7d0f0cb60f0$var$insertLineInactiveColor = {
    name: "5t20g5",
    styles: "background-color:var(--ds-background-accent-gray-subtler, #DDDEE1)"
};
const $a1b9a7d0f0cb60f0$export$b9932a52fb1c7aad = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $1zav4.tableCellBorderWidth), "px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $1zav4.tableCellBorderWidth), "px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $1zav4.tableCellBorderWidth), "px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $1zav4.tableCellBorderWidth), "px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $1zav4.tableCellBorderWidth), "px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $1zav4.tableCellBorderWidth), "px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " top:-1px;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " bottom:0;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " bottom:0;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " bottom:0;", $a1b9a7d0f0cb60f0$var$insertLineActiveColor, ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $a1b9a7d0f0cb60f0$var$tableCellRowInsertLineStyles, " bottom:0;", $a1b9a7d0f0cb60f0$var$insertLineInactiveColor, ";}}");


const $93fa7bbbefe5a956$var$cornerControlHeight = (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + 1;
const $93fa7bbbefe5a956$export$af45328890cf2a82 = (0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c) / 2;
const $93fa7bbbefe5a956$export$cc4d06b9af7cea87 = 44;
// Shared styling for numbered column buttons in selected state
const $93fa7bbbefe5a956$var$numberedColumnButtonSelectedStyles = `
	border-bottom: 1px solid ${(0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb)};
	border-color: ${(0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb)};
	background-color: ${(0, $fbbb9ee8877c285e$export$8c5dd0fc35774ae1)};
	position: relative;
	z-index: ${(0, $aFUXX.akEditorUnitZIndex)};
	color: ${"var(--ds-text-selected, #1868DB)"};
`;
const $93fa7bbbefe5a956$var$rangeSelectionStyles = `
.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}.${(0, $aFUXX.akEditorSelectedNodeClassName)} table tbody tr {
  th,td {
    ${(0, $ieXGd.getSelectionStyles)([
    (0, $b38UX.SelectionStyle).Blanket,
    (0, $b38UX.SelectionStyle).Border
])}

    // The non-break space /00a0 in :after selector caused a table scroll issue when pressing Cmd+A to select table
    // This line is to override the content of :after selector from the shared getSelectionStyles
    &::after {
      content: '';
    }
  }
}
`;
const $93fa7bbbefe5a956$var$rangeSelectionStylesForFakeBorders = `
.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}.${(0, $aFUXX.akEditorSelectedNodeClassName)} .${(0, $1zav4.TableSharedCssClassName).TABLE_LEFT_BORDER},
.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER}.${(0, $aFUXX.akEditorSelectedNodeClassName)} .${(0, $1zav4.TableSharedCssClassName).TABLE_RIGHT_BORDER} {
	  background: ${(0, $aFUXX.akEditorSelectedBorderColor)};
}
`;
const $93fa7bbbefe5a956$var$sentinelStyles = `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
  > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP}, > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP} {
    top: ${(0, $fbbb9ee8877c285e$export$62374dd2f63076b0)}px;
  }
  > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM} {
      bottom: ${(0, $fbbb9ee8877c285e$export$92421f8864c287b1) + (0, $fbbb9ee8877c285e$export$83c60dd0aac17107) + (0, $fbbb9ee8877c285e$export$e5ff276883773ffd) * 2 + 23}px;
  }
  &.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS} {
    > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_TOP} {
      top: 0px;
    }
    > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SENTINEL_BOTTOM} {
      margin-bottom: ${(0, $fbbb9ee8877c285e$export$62374dd2f63076b0)}px;
    }
  }
}`;
const $93fa7bbbefe5a956$var$stickyScrollbarSentinelStyles = `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
 > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
 > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    top: ${(0, $fbbb9ee8877c285e$export$62374dd2f63076b0) + $93fa7bbbefe5a956$export$cc4d06b9af7cea87 * 3}px;
  }
  > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
    bottom: ${(0, $aFUXX.MAX_BROWSER_SCROLLBAR_HEIGHT)}px;
  }
}`;
const $93fa7bbbefe5a956$var$stickyScrollbarContainerStyles = `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER} {
  > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SCROLLBAR_CONTAINER} {
    width: 100%;
    display: none;
    overflow-x: auto;
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}`;
const $93fa7bbbefe5a956$var$stickyScrollbarStyles = `${$93fa7bbbefe5a956$var$stickyScrollbarContainerStyles} ${$93fa7bbbefe5a956$var$stickyScrollbarSentinelStyles}`;
const $93fa7bbbefe5a956$var$shadowSentinelStyles = `
  .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SHADOW_SENTINEL_LEFT},
  .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SHADOW_SENTINEL_RIGHT} {
    position: absolute;
    top: 0;
    height: 100%;
    width: 1px;
    visibility: hidden;
  }
  .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SHADOW_SENTINEL_LEFT} {
    left: 0;
  }
  .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SHADOW_SENTINEL_RIGHT} {
    right: 0;
  }
`;
const $93fa7bbbefe5a956$var$breakoutWidthStyling = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)(">*:not([data-mark-type='fragment']) .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}>[data-mark-type='fragment'] * .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}");
};
const $93fa7bbbefe5a956$var$viewModeSortStyles = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)("th{.", (0, $ef6a076f3671a2c9$export$b61cb5d3425147f), "{+p{margin-top:0!important;}}>.", (0, $ef6a076f3671a2c9$export$b61cb5d3425147f), "{&:has(.is-active){.", (0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME), "{opacity:1;}}}>.", (0, $ef6a076f3671a2c9$export$b61cb5d3425147f), "{.", (0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME), "{opacity:0;&:focus{opacity:1;}}}&:hover:not(:has(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":hover)){>.", (0, $ef6a076f3671a2c9$export$b61cb5d3425147f), "{.", (0, $1j8OE.SORTABLE_COLUMN_ICON_CLASSNAME), "{opacity:1;}}}}");
};
const $93fa7bbbefe5a956$var$tableBorderStyles = ()=>{
    return `border-color: ${0, $fbbb9ee8877c285e$export$870d72a5700e711d}`;
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $93fa7bbbefe5a956$var$tableStickyHeaderColumnControlsDecorationsStyle = ()=>{
    return /*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "{z-index:0;left:-1px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{border-left:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED, ",&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_COLUMN, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "::after{left:0;}}}");
};
const $93fa7bbbefe5a956$var$tableStickyHeaderFirefoxFixStyle = ()=>{
    const browser = (0, $d7ZU3.getBrowserInfo)();
    /*
  This is MAGIC!
  This fixes a bug which occurs in firefox when the first row becomes sticky.
  see https://product-fabric.atlassian.net/browse/ED-19177
   */ if (browser.gecko) return /*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, ">tbody::before{content:'';}");
};
const $93fa7bbbefe5a956$var$baseTableStylesWithoutSharedStyle = (props)=>/*#__PURE__*/ (0, $9K4OG.css)((0, $a1b9a7d0f0cb60f0$export$6114ba9f95ca48dc)(), ";", (0, $a1b9a7d0f0cb60f0$export$4d63bf225990ad34)(), ";", (0, $a1b9a7d0f0cb60f0$export$1c46f5412a5a3ae0)(), ";", (0, $a1b9a7d0f0cb60f0$export$40edb32b62e4fb85), ";", (0, $a1b9a7d0f0cb60f0$export$b9932a52fb1c7aad)(), ";", (0, $a1b9a7d0f0cb60f0$export$8e36b812ea421d73)(), ";", $93fa7bbbefe5a956$var$rangeSelectionStyles, ";", $93fa7bbbefe5a956$var$rangeSelectionStylesForFakeBorders, ";", $93fa7bbbefe5a956$var$viewModeSortStyles(), ";", (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && $93fa7bbbefe5a956$var$tableAnchorStyles, ";.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, "{td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, ",th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, "{position:relative;overflow:visible;}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, "{background-color:", (0, $fbbb9ee8877c285e$export$3efa753685336605), ";&::after{height:100%;content:'';border-left:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";border-bottom:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";position:absolute;right:0px;top:0px;bottom:0;width:100%;display:inline-block;pointer-events:none;}}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_COLUMN, "{", (0, $a1b9a7d0f0cb60f0$export$d9daf73b486785b9)(), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_ROW, "{", (0, $a1b9a7d0f0cb60f0$export$595c9c01d7c39885)(), ";}", (0, $a1b9a7d0f0cb60f0$export$cfa9a9cdd25b9d6e)(), " ", (0, $a1b9a7d0f0cb60f0$export$6134f9ac8c9f161f)(), (0, $a1b9a7d0f0cb60f0$export$d6f68d0fe29f8050)(), ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, ">.", props.isDragAndDropEnabled ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ":first-of-type{margin-top:", (0, $fbbb9ee8877c285e$export$83c60dd0aac17107), "px;width:", (0, $aFUXX.akEditorTableNumberColumnWidth), "px;position:fixed!important;z-index:", (0, $aFUXX.akEditorStickyHeaderZIndex), "!important;box-shadow:0px -", (0, $fbbb9ee8877c285e$export$83c60dd0aac17107), "px var(--ds-surface, #FFFFFF);border-right:0 none;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ".sticky{position:fixed!important;z-index:", (0, $aFUXX.akEditorSmallZIndex), "!important;background:var(--ds-surface, #FFFFFF);width:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;height:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ".sticky .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, "{border-bottom:0px none;border-right:0px none;height:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;width:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;}", $93fa7bbbefe5a956$var$tableStickyHeaderColumnControlsDecorationsStyle(), " ", $93fa7bbbefe5a956$var$tableStickyHeaderFirefoxFixStyle(), " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, ".sticky{position:fixed!important;z-index:", (0, $aFUXX.akEditorStickyHeaderZIndex), "!important;display:flex;border-left:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px solid var(--ds-surface, #FFFFFF);margin-left:-", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " col:first-of-type{border-right:1px solid var(--ds-surface, #FFFFFF);}tr.sticky{padding-top:", (0, $fbbb9ee8877c285e$export$83c60dd0aac17107), "px;position:fixed;display:grid;z-index:", (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex) - 5, ";overflow-y:visible;overflow-x:hidden;grid-auto-flow:column;background:var(--ds-surface, #FFFFFF);box-sizing:content-box;box-shadow:0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f);margin-left:-1px;&.no-pointer-events{pointer-events:none;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SHADOW, "{left:unset;position:fixed;z-index:", (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SHADOW, "{padding-bottom:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;}.tableView-content-wrap:has(.tableView-content-wrap):has(\n\t\t\t.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NESTED_TABLE_WITH_CONTROLS, "\n\t\t){padding-left:unset;}.tableView-content-wrap:has(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NESTED_TABLE_WITH_CONTROLS, "){padding-left:15px;}tr.sticky th{border-bottom:", (0, $fbbb9ee8877c285e$export$13b0e72269a9a3aa), "px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";margin-right:-1px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " tr.sticky>th:last-child{border-right-width:1px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " tr.sticky>th:first-of-type{margin-left:0px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " tr.sticky::after{content:' ';width:", $93fa7bbbefe5a956$export$af45328890cf2a82 + 1, "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .sticky+tr{min-height:0px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, "{tr.sticky td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, ",tr.sticky th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $fbbb9ee8877c285e$export$72409f838e9c33c7) - (0, $fbbb9ee8877c285e$export$45d9825f76985b4e)) / 2 + 1, "px;}}tr.sticky td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ",tr.sticky th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_RESIZE_LINE, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $fbbb9ee8877c285e$export$72409f838e9c33c7) - (0, $fbbb9ee8877c285e$export$45d9825f76985b4e)) / 2, "px;}}}tr.sticky .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL, ",tr.sticky .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, "{z-index:1;}tr.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY, "{position:sticky;top:", (0, $1zav4.tableMarginTop), "px;z-index:calc(", (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex), " - 5);box-shadow:inset -1px 1px ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ",inset 1px -1px ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? `th.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL}::after {
				height: 100%;
				content: '';
				border-left: 1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794};
				border-bottom: 1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794};
				position: absolute;
				right: 0px;
				top: 0px;
				bottom: 0;
				width: 100%;
				display: inline-block;
				pointer-events: none;
			}` : ``, ";&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, "{box-shadow:inset -1px 1px ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ",inset 1px -1px ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ",0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f);}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ":has(tr.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY, ")::before{content:' ';display:block;top:0;box-sizing:border-box;width:100%;height:0;margin-bottom:-", (0, $1zav4.tableMarginTop), "px;position:sticky;border-top:", (0, $1zav4.tableMarginTop), "px solid var(--ds-surface, #FFFFFF);z-index:", (0, $fbbb9ee8877c285e$export$1279af870a198fea), ";}", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_2') ? `
		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}:has(tr.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY})::before {
			border-top: ${0, $1zav4.tableMarginTop}px solid transparent;
		}

		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}:has(tr.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE})::before {
			border-top: ${0, $1zav4.tableMarginTop}px solid ${"var(--ds-surface, #FFFFFF)"};
		}` : (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? `
			.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}:has(tr.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY})::before {
				margin-top: 1px;
			}` : ``, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":has(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, ")>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ">div>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS, "{top:", (0, $fbbb9ee8877c285e$export$9c3151841258b6f0), "px;z-index:", (0, $fbbb9ee8877c285e$export$471fb2a0b2f2f936), ";}", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_7') ? `
		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER}:has(~ .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW}) {
			margin-top: 0;
		}
	` : ``, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-table-header-is-stuck='true']:has(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, ")>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ">div>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS, "{z-index:", (0, $fbbb9ee8877c285e$export$7b64f35449327c05), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ":has(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " ", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_4') ? `tr.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY}` : '', ")>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ">div>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, "{top:", (0, $fbbb9ee8877c285e$export$9c3151841258b6f0), "px;}.pm-table-wrapper:has([data-number-column='true'] tr.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY, ")::before{margin-left:-", (0, $aFUXX.akEditorTableNumberColumnWidth), "px;width:calc(100% + ", (0, $aFUXX.akEditorTableNumberColumnWidth), "px);}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, "[data-table-header-is-stuck='true'] .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_DRAG_HANDLE, ":is([data-row-index='0'], [data-selected-row-index='0']:not([data-handle-appearance='default'])){visibility:hidden;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, " tr.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY, "{top:", (0, $1zav4.tableMarginTop), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, " tr.sticky{padding-top:", (0, $fbbb9ee8877c285e$export$880976487022eb5), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, ">.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ":first-of-type{margin-top:", (0, $fbbb9ee8877c285e$export$880976487022eb5), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ".sticky{border-top:", (0, $fbbb9ee8877c285e$export$880976487022eb5) - (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px solid var(--ds-surface, #FFFFFF);}", $93fa7bbbefe5a956$var$sentinelStyles, " ", (0, $a1b9a7d0f0cb60f0$export$f802e22253ad2b2c)(props.featureFlags?.tableDragAndDrop), " ", $93fa7bbbefe5a956$var$stickyScrollbarStyles, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY_SHADOW, "{height:0;}.less-padding{padding:0 ", (0, $fbbb9ee8877c285e$export$e5ff276883773ffd), "px;.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, "{padding:0 ", (0, $fbbb9ee8877c285e$export$e5ff276883773ffd), "px;&::after{right:6px!important;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:-4px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "{padding:0 ", (0, $fbbb9ee8877c285e$export$e5ff276883773ffd), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:-8px;}&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $aFUXX.akEditorTableNumberColumnWidth) + (0, $fbbb9ee8877c285e$export$e5ff276883773ffd) - 1, "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{width:", (0, $fbbb9ee8877c285e$export$40311377f05dbfc4), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{left:6px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:8px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, "{left:calc(100% - 6px);}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_RIGHT_SHADOW, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CHROMELESS, "{left:calc(100% - 16px);}.", (0, $1zav4.TableSharedCssClassName).TABLE_LEFT_BORDER, "{left:8px;}.", (0, $1zav4.TableSharedCssClassName).TABLE_RIGHT_BORDER, "{right:8px;}}>.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NODEVIEW_WRAPPER, "{/**\n       * Prevent margins collapsing, aids with placing the gap-cursor correctly\n       * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing\n       *\n       * TODO: Enable this, many tests will fail!\n       * border-top: 1px solid transparent;\n       */}", $93fa7bbbefe5a956$var$breakoutWidthStyling(), " ", (0, $a1b9a7d0f0cb60f0$export$8c8180e74f25db6a)(), ";", (0, $a1b9a7d0f0cb60f0$export$a2258906ae78ec82)(), ";.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, "{width:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + 1, "px;height:", $93fa7bbbefe5a956$var$cornerControlHeight, "px;display:none;.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS_INSERT_ROW_MARKER, "{position:relative;", (0, $a1b9a7d0f0cb60f0$export$22ce45ffbca2b768)(`
          left: -11px;
          top: 9px;
        `), ";}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ".sticky{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS_INSERT_ROW_MARKER, "{display:none!important;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, "{position:absolute;top:0;width:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + 1, "px;height:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + 1, "px;border:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";border-radius:0;border-top-left-radius:", (0, $fbbb9ee8877c285e$export$371da7842ff35a5b), "px;background:", (0, $fbbb9ee8877c285e$export$95883e661e73a1d1), ";box-sizing:border-box;padding:0;:focus{outline:none;}}.active .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, "{border-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";background:", (0, $fbbb9ee8877c285e$export$8c5dd0fc35774ae1), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column='true']{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, "{width:", (0, $aFUXX.akEditorTableToolbarSize) + (0, $aFUXX.akEditorTableNumberColumnWidth) + 1, "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, "{border-right-width:0;}}:not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, ":hover{border-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";background:", (0, $fbbb9ee8877c285e$export$8c5dd0fc35774ae1), ";cursor:pointer;}:not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_CORNER_BUTTON, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "{border-color:", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";background:", (0, $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS, "{width:", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b), "px;box-sizing:border-box;display:none;position:relative;", (0, $a1b9a7d0f0cb60f0$export$22ce45ffbca2b768)(`
        bottom: -1px;
        left: -11px;
      `), ";", (0, $a1b9a7d0f0cb60f0$export$c7c73467b57835d)(`
        border-bottom: 1px solid ${(0, $fbbb9ee8877c285e$export$60473ec4f7c2b794)};
        border-right: 0px;
        border-radius: 0;
        height: 100%;
        width: ${(0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b)}px;

        .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_OVERLAY} {
          position: absolute;
          width: 30px;
          height: 50%;
          right: 0;
          bottom: 0;
        }
        .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_OVERLAY}:first-of-type {
          top: 0;
        }
      `), ";.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_INNER, "{display:flex;flex-direction:column;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, ":last-child>button{border-bottom-left-radius:", (0, $fbbb9ee8877c285e$export$371da7842ff35a5b), "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, "{position:relative;margin-top:-1px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, ":hover,.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_BUTTON_WRAP, ".active,.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON, ":hover{z-index:", (0, $aFUXX.akEditorUnitZIndex), ";}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS, "{display:grid;align-items:center;position:absolute;z-index:", (0, $fbbb9ee8877c285e$export$45aeeddcedd441ab) + 4, ";.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;align-self:end;height:100%;width:18px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_FLOATING_INSERT_DOT, "{position:absolute;bottom:-3px;left:2px;background-color:var(--ds-background-accent-gray-subtler, #DDDEE1);height:4px;width:4px;border-radius:50%;pointer-events:none;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER, "{height:", (0, $fbbb9ee8877c285e$export$9c3151841258b6f0), "px;position:absolute;top:var(--ds-space-negative-150, -12px);z-index:", (0, $fbbb9ee8877c285e$export$887c1388be90c08e), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;height:", (0, $fbbb9ee8877c285e$export$9c3151841258b6f0), "px;width:100%;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_FLOATING_INSERT_DOT, "{background-color:var(--ds-background-accent-gray-subtler, #DDDEE1);height:4px;width:4px;border-radius:50%;position:absolute;right:-2px;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE, "{background:none;border:none;outline:none;position:absolute;margin:0;padding:0;display:flex;align-items:center;cursor:pointer;:focus{outline:none;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_BUTTON_CONTAINER, "{cursor:grab;pointer-events:auto;line-height:0;padding:0;border-radius:6px;width:max-content;border:2px solid var(--ds-surface, #FFFFFF);display:flex;justify-content:center;align-items:center;background:transparent;outline:none;&.placeholder{background-color:transparent;border:2px solid transparent;}&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_DISABLED, "{cursor:pointer;& svg{&>rect.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_MINIMISED, "{fill:var(--ds-background-accent-gray-subtler, #DDDEE1);}&>rect{fill:var(--ds-background-accent-gray-subtlest, #F0F1F2);}&>g>rect{fill:var(--ds-icon-disabled, #080F214A);}}}&:not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_HANDLE_DISABLED, "){& svg{rect{fill:var(--ds-background-accent-gray-subtler, #DDDEE1);}g{fill:var(--ds-icon-subtle, #505258);}}&:hover{svg{rect{fill:var(--ds-background-accent-blue-subtle, #669DF1);}g{fill:var(--ds-icon-inverse, #FFFFFF);}}}&:active{cursor:grabbing;}&.selected{:focus{outline:2px solid var(--ds-border-focused, #4688EC);outline-offset:1px;}&:active{outline:none;}svg{rect{fill:var(--ds-background-accent-blue-subtle, #669DF1);}g{fill:var(--ds-icon-inverse, #FFFFFF);}}}&.danger{svg{rect{fill:var(--ds-background-accent-red-subtler-pressed, #FD9891);}g{fill:var(--ds-border-inverse, #FFFFFF);}}}}}", (0, $a1b9a7d0f0cb60f0$export$125caa90718a4ea9)(), " :not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS, "{", (0, $a1b9a7d0f0cb60f0$export$eb5435fbd56e8d4)(), " ", (0, $a1b9a7d0f0cb60f0$export$7f243984d41e6570)(), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, "{position:relative;float:right;margin-left:", (0, $aFUXX.akEditorTableToolbarSize), "px;top:", props.isDragAndDropEnabled ? 0 : (0, $aFUXX.akEditorTableToolbarSize), "px;width:", (0, $aFUXX.akEditorTableNumberColumnWidth) + 1, "px;box-sizing:border-box;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, "{border:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";box-sizing:border-box;margin-top:-1px;padding-bottom:2px;padding:", (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? (0, $aFUXX.relativeSizeToBaseFontSize)(10) : `10px`, " 2px;text-align:center;font-size:", (0, $1oCLl.expValEquals)('confluence_compact_text_format', 'isEnabled', true) || (0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? (0, $aFUXX.relativeSizeToBaseFontSize)(14) : (0, $aFUXX.relativeFontSizeToBase16)(14), ";background-color:", (0, $fbbb9ee8877c285e$export$95883e661e73a1d1), ";color:", (0, $fbbb9ee8877c285e$export$14da8da34a807702), ";border-color:", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";:first-child:not(style),style:first-child+*{margin-top:0;}:last-child{border-bottom:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, ">.", props.isDragAndDropEnabled ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON_DISABLED, ":first-of-type::after{content:'';display:block;height:33px;width:100%;background-color:var(--ds-surface, #FFFFFF);position:absolute;top:-34px;left:-1px;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CORNER_CONTROLS, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS, "{display:block;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN, "{padding-left:0px;.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, "{border-left:0 none;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".active{", $93fa7bbbefe5a956$var$numberedColumnButtonSelectedStyles, ";}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, "{border-left:1px solid ", (0, $fbbb9ee8877c285e$export$60473ec4f7c2b794), ";}}}", (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) ? `/* Apply numbered column styling when table is selected via text selection (e.g., block menu) */
	.${0, $aFUXX.akEditorSelectedNodeClassName} {
		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN} {
			.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON} {
				${$93fa7bbbefe5a956$var$numberedColumnButtonSelectedStyles}
				${0, $ieXGd.hideNativeBrowserTextSelectionStyles}
			}
		}
	}` : '', " :not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, ") .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON_DISABLED, "){cursor:pointer;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON_DISABLED, "):hover{", $93fa7bbbefe5a956$var$numberedColumnButtonSelectedStyles, ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "{background-color:", (0, $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50), ";border:1px solid ", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";border-left:0;color:var(--ds-text-danger, #AE2E24);position:relative;z-index:", (0, $aFUXX.akEditorUnitZIndex), ";}}", (0, $iu6m9.editorExperiment)('platform_editor_block_menu', true) ? `.tableView-content-wrap.danger {
		:not(.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING}) .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS} {
			.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON} {
				background-color: ${0, $fbbb9ee8877c285e$export$e7bba7ffd7bf3c50};
				border: 1px solid ${0, $fbbb9ee8877c285e$export$870d72a5700e711d};
				border-left: 0;
				color: ${"var(--ds-text-danger, #AE2E24)"};
				position: relative;
				z-index: ${0, $aFUXX.akEditorUnitZIndex};
			}
		}
	}` : '', ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{table-layout:fixed;white-space:normal;border-top:none;margin-right:-1px;position:relative;>tbody>tr{white-space:pre-wrap;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_CONTROLS_DECORATIONS, "+*{margin-top:0;}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ">.fabric-editor-block-mark{>h1:first-of-type,>h2:first-of-type,>h3:first-of-type,>h4:first-of-type,>h5:first-of-type,>h6:first-of-type{margin-top:0;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "{position:relative;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, "::after,.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{z-index:", (0, $aFUXX.akEditorSmallZIndex), ";position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, "{border:1px solid ", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, "::after{background:", (0, $fbbb9ee8877c285e$export$f26d047169b4195d), ";z-index:", (0, $aFUXX.akEditorSmallZIndex), ";}th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, ",td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CELL, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "{border-left-color:", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";border-top-color:", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";&::after{height:100%;width:100%;border:1px solid ", (0, $fbbb9ee8877c285e$export$870d72a5700e711d), ";content:'';position:absolute;left:-1px;top:-1px;bottom:0;z-index:", (0, $aFUXX.akEditorUnitZIndex) * 100, ";display:inline-block;pointer-events:none;background:", (0, $fbbb9ee8877c285e$export$3c2a828febe9d506), ";}}td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL, ",td.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ",th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ",th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_HEADER_CELL, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL, "{&::after{height:100%;width:100%;border:1px solid ", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";content:'';position:absolute;left:-1px;top:-1px;bottom:0;z-index:", (0, $aFUXX.akEditorSmallZIndex), ";display:inline-block;pointer-events:none;}&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{", $93fa7bbbefe5a956$var$tableBorderStyles(), ";z-index:", (0, $aFUXX.akEditorUnitZIndex) * 100, ";background:", (0, $fbbb9ee8877c285e$export$3c2a828febe9d506), ";}&.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_NO_HIGHLIGHT, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "::after{", $93fa7bbbefe5a956$var$tableBorderStyles(), ";z-index:", (0, $aFUXX.akEditorUnitZIndex) * 100, ";background:", (0, $fbbb9ee8877c285e$export$3c2a828febe9d506), ";}}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, "{position:absolute;margin-top:", (0, $1zav4.tableMarginTop), "px;left:-", (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + 1, "px;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, "{position:absolute;", props.isDragAndDropEnabled ? `
			margin-top: ${0, $1zav4.tableMarginTop}px;
			top: 0;
			left: -${(0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + 1}px;
		` : `
			/* top of corner control is table margin top - corner control height + 1 pixel of table border. */
			top: ${(0, $1zav4.tableMarginTop) - $93fa7bbbefe5a956$var$cornerControlHeight + 1}px;
			margin-top: 0;
			left: -${0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b}px;
		`, ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, ",.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).ROW_CONTROLS_WRAPPER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_LEFT_SHADOW, "{z-index:", (0, $aFUXX.akEditorUnitZIndex), ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:absolute;top:", (0, $1zav4.tableMarginTop), "px;}", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? `
	.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER} {
		/* +2px is to overlap the table border on the sides */
		width: calc(anchor-size(width) + 2px);
		height: ${0, $1zav4.tableMarginTop}px;
		background: ${"var(--ds-surface, #FFFFFF)"};
		top: unset;
		position: fixed;
		position-area: top center;
		position-visibility: anchors-visible;
		z-index: ${(0, $fbbb9ee8877c285e$export$a13fb25a398e2fab) + 1};
	}` : `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} > .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER} {
		/* +2px is to overlap the table border on the sides */
		width: calc(anchor-size(width) + 2px);
		height: ${0, $1zav4.tableMarginTop}px;
		background: ${"var(--ds-surface, #FFFFFF)"};
		position: fixed;
		position-area: top center;
		position-visibility: anchors-visible;
		z-index: ${(0, $fbbb9ee8877c285e$export$a13fb25a398e2fab) + 1};
	}`, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, ">.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "::before{content:'';position:relative;display:inline-block;margin-left:-", (0, $aFUXX.akEditorTableNumberColumnWidth) + (0, $fbbb9ee8877c285e$export$c2ef52861254b274), "px;width:", (0, $aFUXX.akEditorTableNumberColumnWidth) + (0, $fbbb9ee8877c285e$export$c2ef52861254b274), "px;height:", (0, $1zav4.tableMarginTop), "px;background:var(--ds-surface, #FFFFFF);z-index:", (0, $fbbb9ee8877c285e$export$a13fb25a398e2fab) - 1, ";}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th:first-of-type::before{content:'';position:absolute;display:inline-block;box-sizing:border-box;left:0;width:", (0, $aFUXX.akEditorTableNumberColumnWidth) - 1, "px;height:100%;margin-left:-", (0, $aFUXX.akEditorTableNumberColumnWidth), "px;margin-top:-", (0, $fbbb9ee8877c285e$export$83c60dd0aac17107), "px;outline:", (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? `0.5px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794}` : `1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794}`, ";border-left:", (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? 'none' : `1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794}`, ";background:var(--ds-background-accent-gray-subtlest, #F0F1F2);", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? `border-top: 1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794};` : ``, " ", (0, $d7ZU3.getBrowserInfo)().gecko && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true) ? `border-top: 1px solid ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794};` : `border-top: none;`, ";}", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_7') ? `.ak-editor-selected-node .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"]:not(.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SELECTED}) .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th:first-of-type {
			&::before {
				margin-top: 0;
			}
			&::after {
				width: 100%;
				border-left: 1px solid ${0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb};
				background: ${0, $fbbb9ee8877c285e$export$f26d047169b4195d};
			}
	}` : '', " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"].", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SELECTED, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, "):first-of-type::before,.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER, ", .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED, "):first-of-type::before{outline:none;border-left-color:", (0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb), ";", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? `border-top-color: ${0, $fbbb9ee8877c285e$export$9bf0891aaaf2fecb};` : ``, " background:", (0, $fbbb9ee8877c285e$export$7c0a2e8110d12a28), ";}", (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"] .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER}:first-of-type::before, .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"] .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER}:not(.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED}):first-of-type::before {
			outline: none;
			border-left: unset;
			border-top: unset;
			background: ${0, $fbbb9ee8877c285e$export$3c2a828febe9d506};
		}
		.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"].${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_SELECTED}.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON} .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th:first-of-type::before, .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"].${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON} .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL}:not(.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED}):first-of-type::before {
		outline: none;
		border-left-color: ${0, $fbbb9ee8877c285e$export$870d72a5700e711d};
		border-top-color: ${0, $fbbb9ee8877c285e$export$870d72a5700e711d};
		background: ${0, $fbbb9ee8877c285e$export$3c2a828febe9d506};
		}` : `	.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"] .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_CELL_IN_DANGER}:not(.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED}):first-of-type::before {
				outline: none;
				background: ${0, $fbbb9ee8877c285e$export$3c2a828febe9d506};
			}
			.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}[data-number-column="true"].${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).HOVERED_DELETE_BUTTON} .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW} tr:first-of-type th.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).SELECTED_CELL}:not(.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).COLUMN_SELECTED}):first-of-type::before {
				outline: none;
				border-left-color: ${0, $fbbb9ee8877c285e$export$870d72a5700e711d};
				background: ${0, $fbbb9ee8877c285e$export$3c2a828febe9d506};
		}`, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY_ACTIVE, " th:first-of-type::before{box-shadow:0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f);}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_INNER, ":not(.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NESTED_TABLE_WITH_CONTROLS, " *){margin-top:", (0, $1zav4.tableMarginTop), "px!important;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:fixed;z-index:", (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex) - 4, ";}", (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_6') ? `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).WITH_CONTROLS}:has(tr.sticky) .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN} .${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN_BUTTON}:first-of-type {
			box-shadow: 0 -5px 0 1px ${0, $fbbb9ee8877c285e$export$60473ec4f7c2b794};
		}` : ``, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_STICKY, " .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:absolute;z-index:", (0, $aFUXX.akEditorUnitZIndex), ";}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, "{padding-bottom:0px;overflow:auto;overflow-y:hidden;position:relative;}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW, "{overflow:visible;}");
const $93fa7bbbefe5a956$export$9989b31b7900261c = (props)=>/*#__PURE__*/ (0, $9K4OG.css)((0, $1zav4.tableSharedStyle)(), ";", $93fa7bbbefe5a956$var$baseTableStylesWithoutSharedStyle(props), ";");
const $93fa7bbbefe5a956$export$e938d6f191645a3e = (props)=>/*#__PURE__*/ (0, $9K4OG.css)(".ProseMirror{", $93fa7bbbefe5a956$var$baseTableStylesWithoutSharedStyle(props), ";}.ProseMirror.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).IS_RESIZING, "{.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, "{overflow-x:auto;", (0, $3e9f2b46b7207c53$export$b2380b18b089518f), ";}}.ProseMirror.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).RESIZE_CURSOR, "{cursor:col-resize;}", $93fa7bbbefe5a956$var$shadowSentinelStyles, ";");
const $93fa7bbbefe5a956$export$b0d19c9126eaec7a = /*#__PURE__*/ (0, $9K4OG.css)(".ProseMirror .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:-1px;width:100%;}");
const $93fa7bbbefe5a956$export$61a2da566f69d1df = /*#__PURE__*/ (0, $9K4OG.css)(".ProseMirror .", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:0;", (0, $3e9f2b46b7207c53$export$b2380b18b089518f), ";}");
const $93fa7bbbefe5a956$var$tableAnchorStyles = /*#__PURE__*/ (0, $9K4OG.css)(".pm-table-with-controls .pm-table-wrapper-no-overflow [data-prosemirror-node-name='tableHeader']{anchor-name:var(", (0, $04H9b.ANCHOR_VARIABLE_NAME), ", attr(data-node-anchor type(<custom-ident>)));}.pm-table-with-controls .pm-table-wrapper-no-overflow [data-prosemirror-node-name='tableRow']{anchor-name:var(", (0, $04H9b.ANCHOR_VARIABLE_NAME), ", attr(data-node-anchor type(<custom-ident>)));}");


const $a9f4aaa0a150f4bb$var$BUTTON_WIDTH = 20;
const $a9f4aaa0a150f4bb$export$ed0fda2c59cbba0f = ({ buttonWidth: buttonWidth, cellRectLeft: cellRectLeft, cellRefWidth: cellRefWidth, offset: offset })=>{
    return cellRectLeft + cellRefWidth - buttonWidth - offset;
};
const $a9f4aaa0a150f4bb$export$b2a1e556154bddb = (tableWrapper, fixedButtonRefCurrent)=>{
    const tableWrapperRect = tableWrapper.getBoundingClientRect();
    const fixedButtonRect = fixedButtonRefCurrent.getBoundingClientRect();
    const scrollLeft = tableWrapper.scrollLeft;
    return fixedButtonRect.left - tableWrapperRect.left + scrollLeft;
};
const $a9f4aaa0a150f4bb$export$c947181980f67d40 = ({ children: children, isContextualMenuOpen: isContextualMenuOpen, mountTo: mountTo, offset: offset, stickyHeader: stickyHeader, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition, targetCellRef: targetCellRef })=>{
    const fixedButtonRef = (0, $42omo.useRef)(null);
    const observerTargetRef = (0, $42omo.useRef)(null);
    // Using refs here rather than state to prevent heaps of renders on scroll
    const scrollDataRef = (0, $42omo.useRef)(0);
    const leftPosDataRef = (0, $42omo.useRef)(0);
    (0, $42omo.useEffect)(()=>{
        const observerTargetRefCurrent = observerTargetRef.current;
        const fixedButtonRefCurrent = fixedButtonRef.current;
        if (fixedButtonRefCurrent && observerTargetRefCurrent) {
            scrollDataRef.current = tableWrapper.scrollLeft;
            leftPosDataRef.current = 0;
            // Hide the button initially in case there's a flash of the button being
            // outside the table before the Intersection Observer fires
            fixedButtonRefCurrent.style.visibility = 'hidden';
            const margin = $a9f4aaa0a150f4bb$export$b2a1e556154bddb(tableWrapper, fixedButtonRefCurrent);
            // Much more simple and predictable to add this margin to the observer target
            // rather than using it to calculate the rootMargin values
            observerTargetRefCurrent.style.marginLeft = `${margin}px`;
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    if (entry.isIntersecting) fixedButtonRefCurrent.style.visibility = 'visible';
                    else fixedButtonRefCurrent.style.visibility = 'hidden';
                });
            }, {
                root: tableWrapper,
                rootMargin: `0px ${(0, $93fa7bbbefe5a956$export$af45328890cf2a82)}px 0px 0px`,
                threshold: 1
            });
            const handleScroll = (0, $2P8Ax.default)((event)=>{
                if (fixedButtonRef.current) {
                    const delta = event.target.scrollLeft - scrollDataRef.current;
                    const style = `translateX(${leftPosDataRef.current - delta}px)`;
                    fixedButtonRef.current.style.transform = style;
                    scrollDataRef.current = event.target.scrollLeft;
                    leftPosDataRef.current = leftPosDataRef.current - delta;
                }
            });
            observer.observe(observerTargetRefCurrent);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            tableWrapper.addEventListener('scroll', handleScroll);
            return ()=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                tableWrapper.removeEventListener('scroll', handleScroll);
                fixedButtonRefCurrent.style.transform = '';
                observer.unobserve(observerTargetRefCurrent);
            };
        }
    }, [
        fixedButtonRef,
        observerTargetRef,
        tableWrapper,
        targetCellPosition,
        targetCellRef,
        isContextualMenuOpen
    ]);
    const fixedButtonTop = 0;
    const containerLeft = (0, $42omo.useMemo)(()=>{
        const container = targetCellRef.closest('[data-editor-container="true"]');
        return container?.getBoundingClientRect().left || 0;
    }, [
        targetCellRef
    ]);
    const left = (0, $42omo.useMemo)(()=>{
        const targetCellRect = targetCellRef.getBoundingClientRect();
        const baseLeft = $a9f4aaa0a150f4bb$export$ed0fda2c59cbba0f({
            buttonWidth: $a9f4aaa0a150f4bb$var$BUTTON_WIDTH,
            cellRectLeft: targetCellRect.left,
            cellRefWidth: targetCellRef.clientWidth,
            offset: offset
        });
        return baseLeft - containerLeft;
    }, [
        containerLeft,
        targetCellRef,
        offset
    ]);
    // Using a portal here to ensure wrapperRef has the tableWrapper as an
    // ancestor. This is required to make the Intersection Observer work.
    return /*#__PURE__*/ (0, $jTxSS.createPortal)(// Using observerTargetRef here for our Intersection Observer. There is issues
    // getting the observer to work just using the fixedButtonRef, possible due
    // to using position fixed on this Element, or possibly due to its position
    // being changed on scroll.
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: observerTargetRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: "var(--ds-space-0, 0px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            left: "var(--ds-space-0, 0px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: "var(--ds-space-250, 20px)",
            // BUTTON_WIDTH
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: "var(--ds-space-250, 20px)" // BUTTON_WIDTH
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ref: fixedButtonRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'fixed',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                top: fixedButtonTop + stickyHeader.padding + offset * 2,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                zIndex: (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex),
                left: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                left,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: "var(--ds-space-250, 20px)",
                // BUTTON_WIDTH
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: "var(--ds-space-250, 20px)" // BUTTON_WIDTH
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_BUTTON_FIXED,
            children: children
        })
    }), mountTo);
};
var $a9f4aaa0a150f4bb$export$2e2bcd8739ae039 = $a9f4aaa0a150f4bb$export$c947181980f67d40;


// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766




function $dd69dcd623361863$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dd69dcd623361863$export$554a9cb1559eb2d5 = ()=>/*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            // Sits behind button to provide surface-color background
            background: "var(--ds-surface, #FFFFFF)",
            borderRadius: "var(--ds-radius-small, 3px)",
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${(0, $fbbb9ee8877c285e$export$3969371f057ce1e5) + 2}px`,
            width: "var(--ds-space-250, 20px)",
            flexDirection: 'column'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            background: "var(--ds-background-neutral, #0515240F)",
            flexDirection: 'column',
            margin: "var(--ds-space-025, 2px)",
            outline: `2px solid ${"var(--ds-surface, #FFFFFF)"}`,
            borderRadius: '1px',
            padding: 0,
            height: 'calc(100% - 4px)',
            display: 'flex'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:hover': {
            background: "var(--ds-background-neutral-hovered, #0B120E24)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:active': {
            background: "var(--ds-background-neutral-pressed, #080F214A)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button > span': {
            margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& span': {
            pointerEvents: 'none'
        }
    });
var $dd69dcd623361863$var$_ref = {
    name: "lb8dok",
    styles: "&& button{background:var(--ds-background-selected, #E9F2FE);}&& button:hover{background:var(--ds-background-selected-hovered, #CFE1FD);}&& button:active{background:var(--ds-background-selected-pressed, #8FB8F6);}"
};
const $dd69dcd623361863$export$cd6af2ca27c1a823 = ()=>$dd69dcd623361863$var$_ref;


const $35f649121590a9ea$var$BUTTON_OFFSET = 3;
const $35f649121590a9ea$var$CONTEXTUAL_MENU_BUTTON_Z_INDEX = 2;
const $35f649121590a9ea$var$anchorStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    position: 'absolute',
    positionVisibility: 'anchors-visible',
    zIndex: $35f649121590a9ea$var$CONTEXTUAL_MENU_BUTTON_Z_INDEX
});
const $35f649121590a9ea$var$FloatingContextualButtonInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { editorView: editorView, isContextualMenuOpen: isContextualMenuOpen, mountPoint: mountPoint, scrollableElement: scrollableElement, stickyHeader: stickyHeader, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, intl: { formatMessage: formatMessage } } = props; //  : Props & WrappedComponentProps
    const handleClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        // Clicking outside the dropdown handles toggling the menu closed
        // (otherwise these two toggles combat each other).
        // In the event a user clicks the chevron button again
        // That will count as clicking outside the dropdown and
        // will be toggled appropriately
        if (!isContextualMenuOpen) (0, $4d39a5caa29eeec8$export$458dbe7d48b81d0a)()(state, dispatch);
    };
    const domAtPos = editorView.domAtPos.bind(editorView);
    const targetCellRef = (0, $8m4tT.findDomRefAtPos)(targetCellPosition, domAtPos);
    (0, $42omo.useEffect)(()=>{
        if (isCellMenuOpenByKeyboard && !isContextualMenuOpen) {
            const { state: state, dispatch: dispatch } = editorView;
            // open the menu when the keyboard shortcut is pressed
            (0, $4d39a5caa29eeec8$export$458dbe7d48b81d0a)()(state, dispatch);
        }
    }, [
        isCellMenuOpenByKeyboard,
        isContextualMenuOpen,
        editorView
    ]);
    if (!targetCellRef || !(targetCellRef instanceof HTMLElement)) return null;
    const labelCellOptions = formatMessage((0, $2CQVV.messages).cellOptions);
    const button = /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $dd69dcd623361863$export$554a9cb1559eb2d5)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isContextualMenuOpen && (0, $dd69dcd623361863$export$cd6af2ca27c1a823)()
        ]
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_BUTTON,
        selected: isContextualMenuOpen,
        title: labelCellOptions,
        keymap: (0, $hgeg8.focusToContextMenuTrigger),
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            color: "currentColor",
            size: "small"
        }),
        "aria-label": labelCellOptions,
        "aria-expanded": isContextualMenuOpen
    }));
    const parentSticky = targetCellRef.parentElement && targetCellRef.parentElement.className.indexOf('sticky') > -1;
    const parentStickyNative = targetCellRef.parentElement && ((0, $dh538.fg)('platform_editor_table_sticky_header_patch_4') ? tableWrapper?.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW) : targetCellRef.parentElement.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NATIVE_STICKY));
    if (parentStickyNative && targetCellRef.nodeName === 'TH' && (0, $425e1bfad150b07f$export$2ee7329d46115d8f)() && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) {
        /* We need to default to checking the anchor style because there may be a conflict with the block controls
     plugin not using the data attribute value and setting the `anchor-name` style property independently of the data attribute.
     */ let rowAnchorName = targetCellRef.parentElement?.style.getPropertyValue('anchor-name');
        let colAnchorName = targetCellRef.style.getPropertyValue('anchor-name');
        if (rowAnchorName === '') rowAnchorName = targetCellRef.parentElement?.dataset.nodeAnchor;
        if (colAnchorName === '') colAnchorName = targetCellRef?.dataset.nodeAnchor;
        if (!(0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_patch_9', 'isEnabled', true)) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $35f649121590a9ea$var$anchorStyles,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                top: `calc(${$35f649121590a9ea$var$BUTTON_OFFSET}px + anchor(${rowAnchorName} top))`,
                right: `calc(${$35f649121590a9ea$var$BUTTON_OFFSET}px + anchor(${colAnchorName} right))`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                positionAnchor: colAnchorName
            },
            "data-testid": "table-cell-options-anchor-wrapper"
        }, button);
        if (rowAnchorName && colAnchorName) return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: $35f649121590a9ea$var$anchorStyles,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                top: `calc(${$35f649121590a9ea$var$BUTTON_OFFSET}px + anchor(${rowAnchorName} top))`,
                right: `calc(${$35f649121590a9ea$var$BUTTON_OFFSET}px + anchor(${colAnchorName} right))`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                positionAnchor: colAnchorName
            },
            "data-testid": "table-cell-options-anchor-wrapper"
        }, button);
    }
    if (stickyHeader && parentSticky && tableWrapper) return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a9f4aaa0a150f4bb$export$2e2bcd8739ae039), {
        offset: $35f649121590a9ea$var$BUTTON_OFFSET,
        stickyHeader: stickyHeader,
        tableWrapper: tableWrapper,
        targetCellPosition: targetCellPosition,
        targetCellRef: targetCellRef,
        mountTo: tableWrapper,
        isContextualMenuOpen: isContextualMenuOpen
    }, button);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
        alignX: "right",
        alignY: "start",
        target: targetCellRef,
        mountTo: tableWrapper || mountPoint,
        boundariesElement: targetCellRef,
        scrollableElement: scrollableElement,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            $35f649121590a9ea$var$BUTTON_OFFSET,
            -$35f649121590a9ea$var$BUTTON_OFFSET
        ],
        forcePlacement: true,
        allowOutOfBounds: true,
        zIndex: (0, $aFUXX.akEditorSmallZIndex)
    }, button);
});
const $35f649121590a9ea$var$FloatingContextualButton = (0, $aXWIB.injectIntl)($35f649121590a9ea$var$FloatingContextualButtonInner);
function $35f649121590a9ea$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $7fmpI.ErrorBoundary), {
        component: (0, $d925B.ACTION_SUBJECT).FLOATING_CONTEXTUAL_BUTTON,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $9K4OG.jsx)($35f649121590a9ea$var$FloatingContextualButton, props));
}


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766





















/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 





















var $lwMQJ = parcelRequire("lwMQJ");


var $8LFdJ = parcelRequire("8LFdJ");

var $hxEux = parcelRequire("hxEux");

var $ahQKW = parcelRequire("ahQKW");


var $9Z3I5 = parcelRequire("9Z3I5");

var $5v8Ta = parcelRequire("5v8Ta");

var $h4TOP = parcelRequire("h4TOP");


var $1eLzC = parcelRequire("1eLzC");





var $6icEc = parcelRequire("6icEc");






var $7TXtV = parcelRequire("7TXtV");





var $lZgFC = parcelRequire("lZgFC");


var $4nv4H = parcelRequire("4nv4H");





































// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766








const $992337a348060053$export$bc7b8b99ac8e8073 = (selectedColor)=>/*#__PURE__*/ (0, $9K4OG.css)({
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: selectedColor
        }
    });
const $992337a348060053$export$62225ca66ffe289c = (isDragAndDropEnabled)=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_SUBMENU, "{border-radius:var(--ds-radius-small, 3px);background:var(--ds-surface-overlay, #FFFFFF);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);display:block;position:absolute;top:0;left:", isDragAndDropEnabled ? (0, $fbbb9ee8877c285e$export$42d9040c5091b076) : (0, $fbbb9ee8877c285e$export$a6ed027d1a83416d), "px;padding:var(--ds-space-100, 8px);>div{padding:0;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_ICON, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $63Ztt.tableBackgroundBorderColor), ";border-radius:var(--ds-radius-small, 3px);width:20px;height:20px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:20px;color:var(--ds-icon, #292A2E);}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_ICON_SMALL, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $63Ztt.tableBackgroundBorderColor), ";border-radius:var(--ds-radius-small, 3px);width:14px;height:14px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:14px;color:var(--ds-icon, #292A2E);}}");


const $cea27b5fb5fc6748$var$arrowsList = new Set(!(0, $1oCLl.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true) ? [
    'ArrowRight',
    'ArrowLeft'
] : [
    'ArrowRight'
]);
const $cea27b5fb5fc6748$var$elementBeforeIconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.negative.075',
    display: 'flex'
});
class $cea27b5fb5fc6748$export$f55c8e309b1cad66 extends (0, $42omo.Component) {
    componentDidMount() {
        // ArrowKeyNavigationProvider in DropdownMenu expects that menu handle will stay focused
        // until user pressed ArrowDown.
        // Behavior above fails the A11Y requirement about first item in menu should be focused immediately.
        // so here is triggering componentDidUpdate inside dropdown to set focus on first element
        const { isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
        if (isCellMenuOpenByKeyboard) this.setState({
            ...this.state,
            isOpenAllowed: isCellMenuOpenByKeyboard
        });
    }
    componentDidUpdate() {
        const { isDragAndDropEnabled: isDragAndDropEnabled, isContextualMenuOpen: isContextualMenuOpen } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(this.props.editorView.state);
        if (isDragAndDropEnabled && this.props.isDragMenuOpen && isContextualMenuOpen) (0, $4d39a5caa29eeec8$export$458dbe7d48b81d0a)()(this.props.editorView.state, this.props.editorView.dispatch);
    }
    render() {
        const { isOpen: isOpen, offset: offset, boundariesElement: boundariesElement, editorView: editorView, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, api: api } = this.props;
        const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
        const items = isDragAndDropEnabled ? this.createNewContextMenuItems() : this.createOriginalContextMenuItems();
        let isOpenAllowed = false;
        isOpenAllowed = isCellMenuOpenByKeyboard ? this.state.isOpenAllowed : isOpen;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1eLzC.UserIntentPopupWrapper), {
            userIntent: "tableContextualMenuPopupOpen",
            api: api
        }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            "data-testid": "table-cell-contextual-menu",
            onMouseLeave: (0, $1oCLl.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true) ? undefined : this.closeSubmenu,
            ref: this.dropdownMenuRef
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $h4TOP.default), {
            //This needs be removed when the a11y is completely handled
            //Disabling key navigation now as it works only partially
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            arrowKeyNavigationProviderOptions: {
                type: (0, $5v8Ta.ArrowKeyNavigationType).MENU,
                disableArrowKeyNavigation: !isCellMenuOpenByKeyboard || this.state.isSubmenuOpen
            },
            items: items,
            isOpen: isOpenAllowed,
            onOpenChange: this.handleOpenChange,
            onItemActivated: this.onMenuItemActivated,
            onMouseEnter: this.handleItemMouseEnter,
            onMouseLeave: this.handleItemMouseLeave,
            fitHeight: 188,
            fitWidth: isDragAndDropEnabled ? (0, $fbbb9ee8877c285e$export$42d9040c5091b076) : (0, $fbbb9ee8877c285e$export$a6ed027d1a83416d),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            shouldFocusFirstItem: ()=>{
                return Boolean(isCellMenuOpenByKeyboard);
            },
            boundariesElement: boundariesElement,
            offset: offset,
            section: isDragAndDropEnabled ? {
                hasSeparator: true
            } : undefined,
            allowEnterDefaultBehavior: this.state.isSubmenuOpen
        })));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isSubmenuOpen: false,
            isOpenAllowed: false
        };
        this.dropdownMenuRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.handleSubMenuRef = (ref)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const dom = this.props.editorView.dom;
            const parent = (0, $4vlwG.closestElement)(dom, '.fabric-editor-popup-scroll-parent') || (0, $4vlwG.closestElement)(dom, '.ak-editor-content-area');
            if (!(parent && ref)) return;
            const boundariesRect = parent.getBoundingClientRect();
            const rect = ref.getBoundingClientRect();
            if (!!this.props.mountPoint) return;
            const offsetParent = ref?.offsetParent;
            if (!offsetParent) return;
            const offsetParentRect = offsetParent.getBoundingClientRect();
            const rightOverflow = offsetParentRect.right + rect.width - boundariesRect.right;
            const leftOverflow = boundariesRect.left - (offsetParentRect.left - rect.width);
            if (rightOverflow > leftOverflow) ref.style.left = `-${rect.width}px`;
            // if it overflows regardless of side, let it overlap with the parent menu
            if (leftOverflow > 0 && rightOverflow > 0) {
                if (rightOverflow < leftOverflow) ref.style.left = `${offsetParentRect.width - rightOverflow}px`;
                else ref.style.left = `-${rect.width - leftOverflow}px`;
            }
        };
        this.createBackgroundColorItem = ()=>{
            const { allowBackgroundColor: allowBackgroundColor, editorView: { state: state }, isOpen: isOpen, intl: { formatMessage: formatMessage }, editorView: editorView, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            const { isSubmenuOpen: isSubmenuOpen } = this.state;
            const { targetCellPosition: targetCellPosition, isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            if (allowBackgroundColor) {
                const node = isOpen && targetCellPosition ? state.doc.nodeAt(targetCellPosition) : null;
                const background = (0, $6icEc.hexToEditorBackgroundPaletteColor)(node?.attrs?.background || '#ffffff');
                const selectedRowAndColumnFromPalette = (0, $ahQKW.getSelectedRowAndColumnFromPalette)((0, $81b7b6f3cf3366fc$export$2e2bcd8739ae039), // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                background, (0, $fbbb9ee8877c285e$export$2c18704a8d793cdb));
                const selectedRowIndex = selectedRowAndColumnFromPalette.selectedRowIndex;
                const selectedColumnIndex = selectedRowAndColumnFromPalette.selectedColumnIndex;
                return {
                    content: isDragAndDropEnabled ? formatMessage((0, $2CQVV.messages).backgroundColor) : formatMessage((0, $2CQVV.messages).cellBackground),
                    value: {
                        name: 'background'
                    },
                    elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                        xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7TXtV))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $2CQVV.messages).backgroundColor)
                    })) : undefined,
                    elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                        className: (0, $lwMQJ.DropdownMenuSharedCssClassName).SUBMENU
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                        css: (0, $992337a348060053$export$bc7b8b99ac8e8073)(background),
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: isDragAndDropEnabled ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_ICON_SMALL : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_MENU_ICON
                    }), isSubmenuOpen && /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTEXTUAL_SUBMENU,
                        ref: this.handleSubMenuRef
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9Z3I5.ArrowKeyNavigationProvider), {
                        type: (0, $5v8Ta.ArrowKeyNavigationType).COLOR,
                        selectedRowIndex: selectedRowIndex || 0,
                        selectedColumnIndex: selectedColumnIndex || 0,
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        handleClose: ()=>{
                            this.setState({
                                isSubmenuOpen: false
                            });
                            if (this.dropdownMenuRef && this.dropdownMenuRef.current) {
                                const focusableItems = this.dropdownMenuRef.current.querySelectorAll('div[tabindex="-1"]:not([disabled])');
                                if (focusableItems && focusableItems.length) focusableItems[0].focus();
                            }
                        },
                        isPopupPositioned: true,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        isOpenedByKeyboard: isCellMenuOpenByKeyboard
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hxEux.default), {
                        cols: 7,
                        onClick: this.setColor,
                        selectedColor: node?.attrs?.background || '#ffffff',
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        paletteOptions: {
                            palette: (0, $81b7b6f3cf3366fc$export$2e2bcd8739ae039),
                            paletteColorTooltipMessages: (0, $8LFdJ.backgroundPaletteTooltipMessages),
                            hexToPaletteColor: (0, $6icEc.hexToEditorBackgroundPaletteColor)
                        }
                    })))),
                    'aria-expanded': isSubmenuOpen
                };
            }
        };
        // Used in the NewContextMenuItems object
        this.newDistributeColumnsItem = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            return this.createDistributeColumnsItemInternal({
                elemBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iBNSQ))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2CQVV.messages).distributeColumns)
                }))
            });
        };
        this.createMergeSplitCellItems = ()=>{
            const { allowMergeCells: allowMergeCells, editorView: { state: state }, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            if (allowMergeCells) return [
                {
                    content: formatMessage((0, $2CQVV.messages).mergeCells),
                    value: {
                        name: 'merge'
                    },
                    isDisabled: !(0, $c13226e4e2217284$export$9df87bad3fce982f)(state.tr),
                    elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                        xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lZgFC))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $2CQVV.messages).mergeCells)
                    })) : undefined
                },
                {
                    content: formatMessage((0, $2CQVV.messages).splitCell),
                    value: {
                        name: 'split'
                    },
                    isDisabled: !(0, $2d87994eabccd17d$export$74933b5979945879)(state),
                    elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                        xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4nv4H))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $2CQVV.messages).splitCell)
                    })) : undefined
                }
            ];
            return [];
        };
        this.createInsertColumnItem = ()=>{
            const { intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const content = formatMessage(isDragAndDropEnabled ? (0, $2CQVV.messages).addColumnRight : (0, $2CQVV.messages).insertColumn);
            return {
                content: content,
                value: {
                    name: 'insert_column'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                    css: (0, $6f5RK.shortcutStyle)
                }, (0, $hgeg8.tooltip)((0, $hgeg8.addColumnAfter))),
                elemBefore: isDragAndDropEnabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6p8nb))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2CQVV.messages).addColumnRight)
                })) : undefined,
                'aria-label': (0, $hgeg8.tooltip)((0, $hgeg8.addColumnAfter), String(content))
            };
        };
        this.createInsertRowItem = ()=>{
            const { intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const content = formatMessage(isDragAndDropEnabled ? (0, $2CQVV.messages).addRowBelow : (0, $2CQVV.messages).insertRow);
            return {
                content: content,
                value: {
                    name: 'insert_row'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                    css: (0, $6f5RK.shortcutStyle)
                }, (0, $hgeg8.tooltip)((0, $hgeg8.addRowAfter))),
                elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4s9K9))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2CQVV.messages).addRowBelow)
                })) : undefined,
                'aria-label': (0, $hgeg8.tooltip)((0, $hgeg8.addRowAfter), String(content))
            };
        };
        this.createClearCellsItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const { top: top, bottom: bottom, right: right, left: left } = selectionRect;
            const noOfColumns = right - left;
            const noOfRows = bottom - top;
            const content = formatMessage((0, $2CQVV.messages).clearCells, {
                0: Math.max(noOfColumns, noOfRows)
            });
            return {
                content: content,
                value: {
                    name: 'clear'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                    css: (0, $6f5RK.shortcutStyle)
                }, (0, $hgeg8.tooltip)((0, $hgeg8.backspace))),
                elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iV7dk))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2CQVV.messages).clearCells, {
                        0: Math.max(noOfColumns, noOfRows)
                    })
                })) : undefined,
                'aria-label': (0, $hgeg8.tooltip)((0, $hgeg8.backspace), String(content))
            };
        };
        this.createDeleteColumnItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const { right: right, left: left } = selectionRect;
            const noOfColumns = right - left;
            return {
                content: formatMessage((0, $2CQVV.messages).removeColumns, {
                    0: noOfColumns
                }),
                value: {
                    name: 'delete_column'
                },
                elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4Ilrk))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2CQVV.messages).removeColumns, {
                        0: noOfColumns
                    })
                })) : undefined
            };
        };
        this.createDeleteRowItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage }, editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const { bottom: bottom, top: top } = selectionRect;
            const noOfRows = bottom - top;
            return {
                content: formatMessage((0, $2CQVV.messages).removeRows, {
                    0: noOfRows
                }),
                value: {
                    name: 'delete_row'
                },
                elemBefore: isDragAndDropEnabled ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                    xcss: $cea27b5fb5fc6748$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($HbwpQ))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $2CQVV.messages).removeRows, {
                        0: noOfRows
                    })
                })) : undefined
            };
        };
        this.createDistributeColumnsItemInternal = (partialMenuItem)=>{
            const { selectionRect: selectionRect, editorView: editorView, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, intl: { formatMessage: formatMessage } } = this.props;
            const { isTableScalingEnabled: isTableScalingEnabled = false } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            const newResizeState = (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(selectionRect, editorView.state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, tableWithFixedColumnWidthsOption);
            const wouldChange = newResizeState?.changed ?? false;
            return {
                content: formatMessage((0, $2CQVV.messages).distributeColumns),
                value: {
                    name: 'distribute_columns'
                },
                isDisabled: !wouldChange,
                ...partialMenuItem
            };
        };
        this.createDistributeColumnsItem = ()=>{
            const { editorView: editorView } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled, pluginConfig: { allowDistributeColumns: allowDistributeColumns } } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            if (allowDistributeColumns && !isDragAndDropEnabled) return this.createDistributeColumnsItemInternal();
            return null;
        };
        this.createSortColumnItems = ()=>{
            const { intl: { formatMessage: formatMessage }, editorView: editorView, allowColumnSorting: allowColumnSorting } = this.props;
            const { isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
            if (allowColumnSorting && !isDragAndDropEnabled) {
                const hasMergedCellsInTable = (0, $1731f25dceb7d4d1$export$ffded79ba5549697)(editorView.state.tr).length > 0;
                const warning = hasMergedCellsInTable ? {
                    tooltipDescription: formatMessage((0, $2CQVV.messages).canNotSortTable),
                    isDisabled: true
                } : {};
                return [
                    {
                        content: formatMessage((0, $2CQVV.messages).sortColumnASC),
                        value: {
                            name: 'sort_column_asc'
                        },
                        ...warning
                    },
                    {
                        content: formatMessage((0, $2CQVV.messages).sortColumnDESC),
                        value: {
                            name: 'sort_column_desc'
                        },
                        ...warning
                    }
                ];
            }
            return null;
        };
        this.createOriginalContextMenuItems = ()=>{
            const items = [];
            const sortColumnItems = this.createSortColumnItems();
            const backgroundColorItem = this.createBackgroundColorItem();
            const distributeColumnsItem = this.createDistributeColumnsItem();
            sortColumnItems && items.push(...sortColumnItems);
            backgroundColorItem && items.push(backgroundColorItem);
            items.push(this.createInsertColumnItem());
            items.push(this.createInsertRowItem());
            items.push(this.createDeleteColumnItem());
            items.push(this.createDeleteRowItem());
            items.push(...this.createMergeSplitCellItems());
            distributeColumnsItem && items.push(distributeColumnsItem);
            items.push(this.createClearCellsItem());
            return [
                {
                    items: items
                }
            ];
        };
        this.createNewContextMenuItems = ()=>{
            const backgroundColorItem = this.createBackgroundColorItem();
            const mergeSplitCellItems = this.createMergeSplitCellItems();
            const insertColumnItem = this.createInsertColumnItem();
            const insertRowItem = this.createInsertRowItem();
            const clearCellsItem = this.createClearCellsItem();
            const deleteColumnItem = this.createDeleteColumnItem();
            const deleteRowItem = this.createDeleteRowItem();
            // Group items so when table.menu.group-items FF is enabled, a divider shows under split cell, above add column
            const items = [
                {
                    items: []
                },
                {
                    items: []
                }
            ];
            backgroundColorItem && items[0].items.push(backgroundColorItem);
            items[0].items.push(...mergeSplitCellItems);
            items[1].items.push(insertColumnItem);
            items[1].items.push(insertRowItem);
            if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1')) items[1].items.push(this.newDistributeColumnsItem());
            items[1].items.push(clearCellsItem);
            items[1].items.push(deleteColumnItem);
            items[1].items.push(deleteRowItem);
            return items;
        };
        this.onMenuItemActivated = ({ item: item })=>{
            const { editorView: editorView, selectionRect: selectionRect, editorAnalyticsAPI: editorAnalyticsAPI, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, isCommentEditor: isCommentEditor } = this.props;
            // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
            const { state: state, dispatch: dispatch } = editorView;
            const { targetCellPosition: targetCellPosition, isTableScalingEnabled: isTableScalingEnabled = false } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            // context menu opened by keyboard and any item except 'background' activated
            // or color has been chosen from color palette
            if (isCellMenuOpenByKeyboard && (item.value.name !== 'background' || item.value.name === 'background' && this.state.isSubmenuOpen)) {
                const { tr: tr } = state;
                tr.setMeta((0, $fedf15e5199146e8$export$18d4026d1ea86bb1), {
                    type: 'SET_CELL_MENU_OPEN',
                    data: {
                        isCellMenuOpenByKeyboard: false
                    }
                });
                dispatch(tr);
                editorView.dom.focus(); // otherwise cursor disappears from cell
            }
            const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
            isCommentEditor);
            switch(item.value.name){
                case 'sort_column_desc':
                    (0, $d9aad08b0e0e65bb$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, selectionRect.left, (0, $5rHEx.SortOrder).DESC)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'sort_column_asc':
                    (0, $d9aad08b0e0e65bb$export$1be9cb7a554871e3)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, selectionRect.left, (0, $5rHEx.SortOrder).ASC)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'merge':
                    (0, $d9aad08b0e0e65bb$export$96680f9d22153cab)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'split':
                    (0, $d9aad08b0e0e65bb$export$e30671f873d3125c)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'distribute_columns':
                    const newResizeStateWithAnalytics = (0, $77650a1f6e0f1ab2$export$8490eb29eba3007d)(selectionRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, tableWithFixedColumnWidthsOption, isCommentEditor);
                    if (newResizeStateWithAnalytics) {
                        (0, $d9aad08b0e0e65bb$export$9bca7816a0c95373)(editorAnalyticsAPI, this.props.api)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, newResizeStateWithAnalytics)(state, dispatch);
                        this.toggleOpen();
                    }
                    break;
                case 'clear':
                    (0, $d9aad08b0e0e65bb$export$67e5a2aa802b5be1)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, targetCellPosition)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'insert_column':
                    (0, $d9aad08b0e0e65bb$export$fc693eab55df8b35)(this.props.api, editorAnalyticsAPI, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, selectionRect.right)(state, dispatch, editorView);
                    this.toggleOpen();
                    break;
                case 'insert_row':
                    (0, $d9aad08b0e0e65bb$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, {
                        index: selectionRect.bottom,
                        moveCursorToInsertedRow: true
                    })(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'delete_column':
                    (0, $d9aad08b0e0e65bb$export$4c11b948fab97510)(editorAnalyticsAPI, this.props.api, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, selectionRect)(state, dispatch, editorView);
                    this.toggleOpen();
                    break;
                case 'delete_row':
                    const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
                    (0, $d9aad08b0e0e65bb$export$ad9854279980efbe)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, selectionRect, !!isHeaderRowRequired)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'background':
                    if (!(0, $1oCLl.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) // This is called twice.
                    // 1st time when user chooses the background color item.
                    // 2nd when color has been chosen from color palette.
                    // here we are handling the 1st call relying on the isSubmenuOpen state value
                    {
                        if (isCellMenuOpenByKeyboard && !this.state.isSubmenuOpen) this.setState({
                            isSubmenuOpen: true
                        });
                    } else this.setState((prevState)=>({
                            isSubmenuOpen: !prevState.isSubmenuOpen
                        }));
                    break;
            }
        };
        this.toggleOpen = ()=>{
            const { isOpen: isOpen, editorView: { state: state, dispatch: dispatch } } = this.props;
            (0, $4d39a5caa29eeec8$export$458dbe7d48b81d0a)()(state, dispatch);
            if (!isOpen) this.setState({
                isSubmenuOpen: false
            });
        };
        this.handleOpenChange = (payload)=>{
            const { editorView: { state: state, dispatch: dispatch, dom: dom }, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            if (payload) {
                const { event: event } = payload;
                if (event && event instanceof KeyboardEvent) {
                    if (!this.state.isSubmenuOpen) {
                        if ($cea27b5fb5fc6748$var$arrowsList.has(event.key)) {
                            // preventing default behavior for avoiding cursor jump to next/previous table column
                            // when left/right arrow pressed.
                            event.preventDefault();
                            if ((0, $1oCLl.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) {
                                this.setState({
                                    isSubmenuOpen: true
                                });
                                return;
                            }
                        }
                        (0, $4d39a5caa29eeec8$export$458dbe7d48b81d0a)()(state, dispatch);
                        this.setState({
                            isSubmenuOpen: false
                        });
                        (0, $4ca83755c936c9c8$export$a6e5155a1ac72366)(false)(state, dispatch);
                        dom.focus();
                    }
                } else {
                    // mouse click outside
                    (0, $4d39a5caa29eeec8$export$458dbe7d48b81d0a)()(state, dispatch);
                    this.setState({
                        isSubmenuOpen: false
                    });
                    if (isCellMenuOpenByKeyboard) (0, $4ca83755c936c9c8$export$a6e5155a1ac72366)(false)(state, dispatch);
                }
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleItemMouseEnter = ({ item: item })=>{
            const { editorView: { state: state, dispatch: dispatch }, selectionRect: selectionRect } = this.props;
            if (!(0, $1oCLl.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) {
                if (item.value.name === 'background') {
                    if (!this.state.isSubmenuOpen) this.setState({
                        isSubmenuOpen: true
                    });
                }
            }
            if (item.value.name === 'delete_column') (0, $7132c436572167eb$export$4cf548f2efac0afe)((0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect), true)(state, dispatch);
            if (item.value.name === 'delete_row') (0, $7132c436572167eb$export$ab63d99b591b89)((0, $cee807f94f070ba4$export$d023456f91fdf995)(selectionRect), true)(state, dispatch);
            if ([
                'sort_column_asc',
                'sort_column_desc'
            ].indexOf(item.value.name) > -1 && (0, $1731f25dceb7d4d1$export$ffded79ba5549697)(state.tr).length !== 0) (0, $7132c436572167eb$export$59dcdc44819c7e7c)()(state, dispatch);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleItemMouseLeave = ({ item: item })=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            if (!(0, $1oCLl.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) {
                if (item.value.name === 'background') this.closeSubmenu();
            }
            if ([
                'sort_column_asc',
                'sort_column_desc',
                'delete_column',
                'delete_row'
            ].indexOf(item.value.name) > -1) (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        };
        this.closeSubmenu = ()=>{
            if (this.state.isSubmenuOpen) this.setState({
                isSubmenuOpen: false
            });
        };
        this.setColor = (color)=>{
            const { editorView: editorView, editorAnalyticsAPI: editorAnalyticsAPI, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            const { state: state, dispatch: dispatch, dom: dom } = editorView;
            (0, $d9aad08b0e0e65bb$export$d0cc02883d6bbba)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, color)(state, dispatch);
            if (!(0, $1oCLl.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) this.toggleOpen();
            else {
                (0, $4d39a5caa29eeec8$export$458dbe7d48b81d0a)()(state, dispatch);
                this.setState({
                    isSubmenuOpen: false
                });
                if (isCellMenuOpenByKeyboard) {
                    (0, $4ca83755c936c9c8$export$a6e5155a1ac72366)(false)(state, dispatch);
                    dom.focus();
                }
            }
        };
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
$cea27b5fb5fc6748$export$f55c8e309b1cad66.defaultProps = {
    boundariesElement: typeof document !== 'undefined' ? document.body : undefined
};
const $cea27b5fb5fc6748$var$_default_1 = (0, $aXWIB.injectIntl)($cea27b5fb5fc6748$export$f55c8e309b1cad66);
var $cea27b5fb5fc6748$export$2e2bcd8739ae039 = $cea27b5fb5fc6748$var$_default_1;



const $b47da77c2d9945b4$var$FloatingContextualMenu = ({ mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isOpen: isOpen, pluginConfig: pluginConfig, editorAnalyticsAPI: editorAnalyticsAPI, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, isCommentEditor: isCommentEditor, api: api, isDragMenuOpen: isDragMenuOpen })=>{
    if (!editorView) return null;
    // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
    const { targetCellPosition: targetCellPosition, isDragAndDropEnabled: isDragAndDropEnabled } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
    if (!isOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition) return null;
    const { selection: selection } = editorView.state;
    const selectionRect = (0, $BW42l.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $iP1et.getSelectionRect)(selection) : (0, $id9O1.findCellRectClosestToPos)(selection.$from);
    if (!selectionRect) return null;
    const domAtPos = editorView.domAtPos.bind(editorView);
    const targetCellRef = (0, $8m4tT.findDomRefAtPos)(targetCellPosition, domAtPos);
    if (!targetCellRef) return null;
    const parentSticky = targetCellRef.parentElement && targetCellRef.parentElement.className.indexOf('sticky') > -1;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $jwWgu.default), {
        alignX: "right",
        alignY: "top",
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        target: targetCellRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitHeight: (0, $fbbb9ee8877c285e$export$3cdde837cf189e96),
        fitWidth: isDragAndDropEnabled ? (0, $fbbb9ee8877c285e$export$42d9040c5091b076) : (0, $fbbb9ee8877c285e$export$a6ed027d1a83416d),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        zIndex: parentSticky ? (0, $aFUXX.akEditorFloatingDialogZIndex) : (0, $aFUXX.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            -7,
            0
        ],
        stick: true
    }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: (0, $992337a348060053$export$62225ca66ffe289c)(isDragAndDropEnabled)
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cea27b5fb5fc6748$export$2e2bcd8739ae039), {
        editorView: editorView,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            (0, $fbbb9ee8877c285e$export$3969371f057ce1e5) / 2,
            -(0, $fbbb9ee8877c285e$export$3969371f057ce1e5)
        ],
        isOpen: isOpen,
        targetCellPosition: targetCellPosition,
        allowColumnSorting: pluginConfig && pluginConfig.allowColumnSorting,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        allowMergeCells: pluginConfig.allowMergeCells,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        allowBackgroundColor: pluginConfig.allowBackgroundColor,
        selectionRect: selectionRect,
        mountPoint: mountPoint,
        boundariesElement: boundariesElement,
        editorAnalyticsAPI: editorAnalyticsAPI,
        getEditorContainerWidth: getEditorContainerWidth,
        getEditorFeatureFlags: getEditorFeatureFlags,
        isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
        isCommentEditor: isCommentEditor,
        api: api,
        isDragMenuOpen: isDragMenuOpen
    })));
};
$b47da77c2d9945b4$var$FloatingContextualMenu.displayName = 'FloatingContextualMenu';
var $b47da77c2d9945b4$export$2e2bcd8739ae039 = $b47da77c2d9945b4$var$FloatingContextualMenu;












































parcelRequire("42omo");








const $91703e3fafeca120$var$DeleteButton = ({ style: style, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, removeLabel: removeLabel, intl: { formatMessage: formatMessage } })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON_WRAP,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? onMouseEnter : undefined,
        onBlur: (0, $1oCLl.expValEquals)('platform_editor_table_a11y_eslint_fix', 'isEnabled', true) ? onMouseLeave : undefined,
        children: /*#__PURE__*/ (0, $l998X.jsx)("button", {
            type: "button",
            "aria-label": formatMessage(removeLabel, {
                0: 1
            }),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_DELETE_BUTTON,
            onMouseDown: onClick,
            onMouseMove: (e)=>e.preventDefault(),
            children: /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_ICON,
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M12.242 10.828L9.414 8l2.828-2.829a.999.999 0 1 0-1.414-1.414L8 6.587l-2.829-2.83a1 1 0 0 0-1.414 1.414l2.83 2.83-2.83 2.827a1 1 0 0 0 1.414 1.414l2.83-2.828 2.827 2.828a.999.999 0 1 0 1.414-1.414",
                    fill: "currentColor",
                    fillRule: "evenodd"
                })
            })
        })
    });
// eslint-disable-next-line @typescript-eslint/ban-types
const $91703e3fafeca120$var$_default_1 = (0, $aXWIB.injectIntl)($91703e3fafeca120$var$DeleteButton);
var $91703e3fafeca120$export$2e2bcd8739ae039 = $91703e3fafeca120$var$_default_1;



const $193fc70e9c765515$var$DELETE_BUTTON_CONTROLS_OFFSET = (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $fbbb9ee8877c285e$export$cb376ed67c7ae37e) + (0, $fbbb9ee8877c285e$export$52b432855099b8bd);
function $193fc70e9c765515$var$getColumnOptions(left, tableWrapper) {
    return {
        alignX: 'left',
        alignY: 'start',
        offset: [
            left,
            $193fc70e9c765515$var$DELETE_BUTTON_CONTROLS_OFFSET
        ],
        shouldRenderPopup () {
            if (tableWrapper) {
                const rect = tableWrapper.getBoundingClientRect();
                const maxVisibleLeftPosition = rect.width + tableWrapper.scrollLeft - (0, $fbbb9ee8877c285e$export$cb376ed67c7ae37e);
                const minVisibleLeftPosition = tableWrapper.scrollLeft;
                return maxVisibleLeftPosition - left > 0 && left > minVisibleLeftPosition;
            }
            return true;
        }
    };
}
function $193fc70e9c765515$var$getRowOptions(top) {
    return {
        alignX: 'left',
        alignY: 'start',
        forcePlacement: true,
        offset: [
            0,
            -top
        ],
        onPositionCalculated (position) {
            return {
                ...position,
                // We need to force left to always be the offset to not be affected by overflow
                left: -$193fc70e9c765515$var$DELETE_BUTTON_CONTROLS_OFFSET
            };
        }
    };
}
function $193fc70e9c765515$export$2e2bcd8739ae039({ left: left, top: top, selectionType: selectionType, tableWrapper: tableWrapper }) {
    switch(selectionType){
        case 'column':
            return $193fc70e9c765515$var$getColumnOptions(left, tableWrapper);
        case 'row':
            return $193fc70e9c765515$var$getRowOptions(top);
        default:
            return {};
    }
}


function $deb8cdf2192525db$var$getSelectionType(selection) {
    if (!(0, $iYC9s.isTableSelected)(selection) && selection instanceof (0, $7XFGZ.CellSelection)) {
        if (selection.isRowSelection()) return 'row';
        if (selection.isColSelection()) return 'column';
    }
    return;
}
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $deb8cdf2192525db$var$FloatingDeleteButton extends (0, $42omo.Component) {
    shouldComponentUpdate(_, nextState) {
        return this.state.selectionType !== nextState.selectionType || this.state.left !== nextState.left || this.state.top !== nextState.top || this.state.scrollLeft !== nextState.scrollLeft;
    }
    componentDidMount() {
        this.updateWrapper();
    }
    componentDidUpdate() {
        this.updateWrapper();
    }
    componentWillUnmount() {
        if (this.wrapper) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.wrapper.removeEventListener('scroll', this.onWrapperScrolled);
    }
    /**
   * We derivate the button state from the properties passed.
   * We do this in here because we need this information in different places
   * and this prevent to do multiple width calculations in the same component.
   */ static getDerivedStateFromProps(nextProps, prevState) {
        const selectionType = $deb8cdf2192525db$var$getSelectionType(nextProps.selection);
        const inStickyMode = nextProps.stickyHeaders && nextProps.stickyHeaders.sticky;
        const rect = (0, $iP1et.getSelectionRect)(nextProps.selection);
        // only tie row delete to sticky header if it's the only thing
        // in the selection, otherwise the row delete will hover around
        // the rest of the selection
        const firstRowInSelection = rect && rect.top === 0 && rect.bottom === 1;
        const shouldStickyButton = inStickyMode && firstRowInSelection;
        const stickyTop = nextProps.stickyHeaders ? nextProps.stickyHeaders.top + nextProps.stickyHeaders.padding : 0;
        if (selectionType) switch(selectionType){
            case 'column':
                {
                    // Calculate the button position and indexes for columns
                    const columnsWidths = (0, $7eacb027e2e3fea2$export$79aef9e007571c)(nextProps.editorView);
                    const deleteBtnParams = (0, $7eacb027e2e3fea2$export$bedfed4734d37a07)(columnsWidths, nextProps.editorView.state.selection);
                    if (deleteBtnParams) return {
                        ...deleteBtnParams,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        top: inStickyMode ? nextProps.stickyHeaders.top : 0,
                        position: inStickyMode ? 'sticky' : undefined,
                        selectionType: selectionType
                    };
                    return null;
                }
            case 'row':
                // Calculate the button position and indexes for rows
                if (nextProps.tableRef) {
                    const rowHeights = (0, $885c1a71dd6e181b$export$3e5149a60ac7416b)(nextProps.tableRef);
                    const offsetTop = inStickyMode ? -rowHeights[0] : 0;
                    const deleteBtnParams = (0, $885c1a71dd6e181b$export$b0ece9f607a8bda1)(rowHeights, nextProps.editorView.state.selection, shouldStickyButton ? stickyTop : offsetTop);
                    if (deleteBtnParams) return {
                        ...deleteBtnParams,
                        position: shouldStickyButton ? 'sticky' : undefined,
                        left: 0,
                        selectionType: selectionType
                    };
                }
                return null;
        }
        // Clean state if no type
        if (prevState.selectionType !== selectionType) return {
            selectionType: undefined,
            top: 0,
            left: 0,
            indexes: []
        };
        // Do nothing if doesn't change anything
        return null;
    }
    render() {
        const { mountPoint: mountPoint, boundariesElement: boundariesElement, tableRef: tableRef } = this.props;
        const { selectionType: selectionType } = this.state;
        if (!selectionType || !tableRef) return null;
        const tableContainerWrapper = (0, $4vlwG.closestElement)(tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}`);
        const button = /*#__PURE__*/ (0, $l998X.jsx)((0, $91703e3fafeca120$export$2e2bcd8739ae039), {
            removeLabel: selectionType === 'column' ? (0, $2CQVV.messages).removeColumns : (0, $2CQVV.messages).removeRows,
            onClick: this.handleClick,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
        });
        const popupOpts = (0, $193fc70e9c765515$export$2e2bcd8739ae039)({
            left: this.state.left,
            top: this.state.top,
            selectionType: this.state.selectionType,
            tableWrapper: this.wrapper
        });
        const mountTo = tableContainerWrapper || mountPoint;
        if (this.state.position === 'sticky' && mountTo) {
            const headerRow = tableRef.querySelector('tr.sticky');
            if (headerRow) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const rect = headerRow.getBoundingClientRect();
                const calculatePosition = popupOpts.onPositionCalculated || ((pos)=>pos);
                const pos = calculatePosition({
                    left: this.state.left,
                    top: this.state.top
                });
                return /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, $l998X.jsx)("div", {
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        position: 'fixed',
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        top: pos.top,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        zIndex: (0, $fbbb9ee8877c285e$export$1279af870a198fea),
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        left: rect.left + (pos.left || 0) - (this.state.selectionType === 'column' ? this.state.scrollLeft : 0) - // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        (this.props.isNumberColumnEnabled ? (0, $aFUXX.akEditorTableNumberColumnWidth) : 0)
                    },
                    children: button
                }), mountTo);
            }
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
            target: tableRef,
            mountTo: mountTo,
            boundariesElement: tableContainerWrapper || boundariesElement,
            scrollableElement: this.wrapper || undefined,
            forcePlacement: true,
            allowOutOfBounds: true,
            ...popupOpts,
            children: button
        });
    }
    constructor(props){
        super(props);
        this.wrapper = null;
        this.updateWrapper = ()=>{
            const tableWrapper = (0, $4vlwG.closestElement)(this.props.tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`);
            if (tableWrapper) {
                this.wrapper = tableWrapper;
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                this.wrapper.addEventListener('scroll', this.onWrapperScrolled);
                this.setState({
                    scrollLeft: tableWrapper.scrollLeft
                });
            } else {
                if (this.wrapper) {
                    // unsubscribe if we previously had one and it just went away
                    // Ignored via go/ees005
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    this.wrapper.removeEventListener('scroll', this.onWrapperScrolled);
                    // and reset scroll position
                    this.setState({
                        scrollLeft: 0
                    });
                }
                this.wrapper = null;
            }
        };
        this.onWrapperScrolled = (e)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const wrapper = e.target;
            this.setState({
                scrollLeft: wrapper.scrollLeft
            });
        };
        this.handleMouseEnter = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            switch(this.state.selectionType){
                case 'row':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return (0, $7132c436572167eb$export$ab63d99b591b89)(this.state.indexes, true)(state, dispatch, this.props.editorView);
                case 'column':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return (0, $7132c436572167eb$export$4cf548f2efac0afe)(this.state.indexes, true)(state, dispatch, this.props.editorView);
            }
            return false;
        };
        this.handleMouseLeave = ()=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            return (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        };
        /**
     *
     *
     * @private
     * @memberof FloatingDeleteButton
     */ this.handleClick = (event)=>{
            event.preventDefault();
            const { editorAnalyticsAPI: editorAnalyticsAPI } = this.props;
            let { state: state, dispatch: dispatch } = this.props.editorView;
            const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(state);
            const rect = (0, $iP1et.getSelectionRect)(state.selection);
            if (rect) switch(this.state.selectionType){
                case 'column':
                    (0, $d9aad08b0e0e65bb$export$4c11b948fab97510)(editorAnalyticsAPI, this.props.api)((0, $d925B.INPUT_METHOD).BUTTON, rect)(state, dispatch, this.props.editorView);
                    return;
                case 'row':
                    (0, $d9aad08b0e0e65bb$export$ad9854279980efbe)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).BUTTON, rect, !!isHeaderRowRequired)(state, dispatch);
                    return;
            }
            ({ state: state, dispatch: dispatch } = this.props.editorView);
            (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
        };
        this.state = {
            selectionType: undefined,
            top: 0,
            left: 0,
            indexes: [],
            scrollLeft: 0
        };
    }
}
$deb8cdf2192525db$var$FloatingDeleteButton.displayName = 'FloatingDeleteButton';
var $deb8cdf2192525db$export$2e2bcd8739ae039 = $deb8cdf2192525db$var$FloatingDeleteButton;





parcelRequire("42omo");















/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 































































var $82gXq = parcelRequire("82gXq");











/* eslint-disable @atlaskit/design-system/prefer-primitives */ 






var $9CaSN = parcelRequire("9CaSN");











var $efG2U = parcelRequire("efG2U");





var $2SlZp = parcelRequire("2SlZp");

var $7rvPL = parcelRequire("7rvPL");


const $1ff18a7a5a57b9d2$var$DropListWithOutsideClickTargetRef = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $efG2U.OutsideClickTargetRefContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9CaSN.default), {
        onDroplistRef: setOutsideClickTargetRef,
        ...props
    });
};
const $1ff18a7a5a57b9d2$var$DropListWithOutsideListeners = (0, $efG2U.default)($1ff18a7a5a57b9d2$var$DropListWithOutsideClickTargetRef);
const $1ff18a7a5a57b9d2$export$e44a253a59704894 = ({ items: items, section: section, disableKeyboardHandling: disableKeyboardHandling, onItemActivated: onItemActivated, handleClose: handleClose, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, fitWidth: fitWidth, fitHeight: fitHeight, direction: direction, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const [popupPlacement, setPopupPlacement] = (0, $42omo.useState)([
        'bottom',
        'left'
    ]);
    const [targetRefDiv, setTargetRefDiv] = (0, $42omo.useState)(null);
    const handleRef = (ref)=>{
        setTargetRefDiv(ref);
    };
    // more offsets calculation as offsets depend on the direction and updated placement here
    const offsetY = direction === 'row' ? popupPlacement[0] === 'bottom' ? -8 : -34 : 0;
    const offsetX = direction === 'column' ? popupPlacement[1] === 'left' ? 0 : -7 : 0;
    const innerMenu = ()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)($1ff18a7a5a57b9d2$var$DropListWithOutsideListeners, {
            isOpen: true,
            shouldFitContainer: true,
            position: popupPlacement.join(' '),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleClickOutside: ()=>handleClose('editor'),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleEscapeKeydown: ()=>{
                if (!disableKeyboardHandling) handleClose('handle');
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleEnterKeydown: (e)=>{
                if (!disableKeyboardHandling) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            targetRef: targetRefDiv,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    style: {
                        height: 0,
                        minWidth: (0, $fbbb9ee8877c285e$export$963fb187132ee7cf)
                    }
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
                    role: "menu",
                    children: items.map((group, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7rvPL.default), {
                            hasSeparator: section?.hasSeparator && index > 0,
                            title: section?.title,
                            children: group.items.map((item)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $h4TOP.DropdownMenuItem), {
                                    shouldUseDefaultRole: false,
                                    item: item,
                                    onItemActivated: onItemActivated,
                                    onMouseEnter: onMouseEnter,
                                    onMouseLeave: onMouseLeave
                                }, item.key ?? String(item.content)))
                        }, index))
                })
            ]
        });
    };
    const onClose = (0, $42omo.useCallback)(()=>handleClose('handle'), [
        handleClose
    ]);
    const onSelection = (0, $42omo.useCallback)((index)=>{
        const results = items.flatMap((item)=>'items' in item ? item.items : item);
        // onSelection is called when any focusable element is 'activated'
        // this is an issue as some menu items have toggles, which cause the index value
        // in the callback to be outside of array length.
        // The logic below normalises the index value based on the number
        // of menu items with 2 focusable elements, and adjusts the index to ensure
        // the correct menu item is sent in onItemActivated callback
        const keys = [
            'row_numbers',
            'header_row',
            'header_column'
        ];
        let doubleItemCount = 0;
        const firstIndex = results.findIndex((value)=>{
            const key = value.key;
            return key !== undefined && keys.includes(key);
        });
        if (firstIndex === -1 || index <= firstIndex) {
            onItemActivated && onItemActivated({
                item: results[index]
            });
            return;
        }
        for(let i = firstIndex; i < results.length; i += 1){
            const key = results[i].key;
            if (key !== undefined && keys.includes(key)) doubleItemCount += 1;
            if (firstIndex % 2 === 0 && index - doubleItemCount === i) {
                onItemActivated && onItemActivated({
                    item: results[i]
                });
                return;
            }
            if (firstIndex % 2 === 1 && index - doubleItemCount === i) {
                onItemActivated && onItemActivated({
                    item: results[i]
                });
                return;
            }
        }
    }, [
        items,
        onItemActivated
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: "drag-dropdown-menu-wrapper",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: "drag-dropdown-menu-popup-ref",
                ref: handleRef
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                target: targetRefDiv,
                mountTo: mountPoint,
                boundariesElement: boundariesElement,
                scrollableElement: scrollableElement,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onPlacementChanged: (placement)=>{
                    setPopupPlacement(placement);
                },
                fitHeight: fitHeight,
                fitWidth: fitWidth,
                zIndex: (0, $aFUXX.akEditorFloatingPanelZIndex),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                offset: [
                    offsetX,
                    offsetY
                ],
                allowOutOfBounds: true,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9Z3I5.ArrowKeyNavigationProvider), {
                    closeOnTab: !disableKeyboardHandling,
                    type: (0, $5v8Ta.ArrowKeyNavigationType).MENU,
                    handleClose: onClose,
                    onSelection: onSelection,
                    // disableKeyboardHandling is linked with isSubmenuOpen in DragMenu
                    // When isSubmenuOpen is true, the background color picker palette is open, and the picker is a ColorPaletteArrowKeyNavigationProvider
                    // At the same time the MenuArrowKeyNavigationProvider are renderer too, as it is the wrapper for all other DragMenu items
                    // In this case we want the ColorPaletteArrowKeyNavigationProvider to handle the keyboard event, not the MenuArrowKeyNavigationProvider
                    // Hence set disableArrowKeyNavigation to true when disableKeyboardHandling is true
                    disableArrowKeyNavigation: disableKeyboardHandling,
                    children: innerMenu()
                })
            })
        ]
    }));
};


/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766 */ 







function $f06d467cdb1ed078$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f06d467cdb1ed078$export$bc7b8b99ac8e8073 = (selectedColor)=>/*#__PURE__*/ (0, $9K4OG.css)({
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: selectedColor
        }
    });
const $f06d467cdb1ed078$export$2a71c1910478944e = ()=>/*#__PURE__*/ (0, $9K4OG.css)(".", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_SUBMENU, "{border-radius:var(--ds-radius-small, 3px);background:var(--ds-surface-overlay, #FFFFFF);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);display:block;position:absolute;top:", (0, $fbbb9ee8877c285e$export$e0140c2b978caac5) + (0, $fbbb9ee8877c285e$export$a13bd817a2eda041) + (0, $fbbb9ee8877c285e$export$c6a9e7014cf7aedc), "px;left:", (0, $fbbb9ee8877c285e$export$963fb187132ee7cf), "px;padding:var(--ds-space-100, 8px);>div{padding:0;}}.", (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_SUBMENU_ICON, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $63Ztt.tableBackgroundBorderColor), ";border-radius:var(--ds-radius-small, 3px);width:14px;height:14px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:14px;color:var(--ds-icon, #292A2E);}}");
const $f06d467cdb1ed078$export$4e493e7fd1e47c4d = {
    name: "16vi1vz",
    styles: "display:flex;input[type='checkbox']{width:30px;height:14px;pointer-events:initial;cursor:pointer;}> label{margin:0px;pointer-events:none;> span{pointer-events:none;}}"
};


const $eda89f8ab7004d19$var$MapDragMenuOptionIdToMessage = {
    add_row_above: {
        message: (0, $2CQVV.messages).addRowAbove,
        plural: null
    },
    add_row_below: {
        message: (0, $2CQVV.messages).addRowBelow,
        plural: null
    },
    add_column_left: {
        message: (0, $2CQVV.messages).addColumnLeft,
        plural: null
    },
    add_column_right: {
        message: (0, $2CQVV.messages).addColumnRight,
        plural: null
    },
    distribute_columns: {
        message: (0, $2CQVV.messages).distributeColumns,
        plural: 'noOfCols'
    },
    clear_cells: {
        message: (0, $2CQVV.messages).clearCells,
        plural: 'noOfCells'
    },
    delete_row: {
        message: (0, $2CQVV.messages).removeRows,
        plural: 'noOfRows'
    },
    delete_column: {
        message: (0, $2CQVV.messages).removeColumns,
        plural: 'noOfCols'
    },
    move_column_left: {
        message: (0, $2CQVV.messages).moveColumnLeft,
        plural: 'noOfCols'
    },
    move_column_right: {
        message: (0, $2CQVV.messages).moveColumnRight,
        plural: 'noOfCols'
    },
    move_row_up: {
        message: (0, $2CQVV.messages).moveRowUp,
        plural: 'noOfRows'
    },
    move_row_down: {
        message: (0, $2CQVV.messages).moveRowDown,
        plural: 'noOfRows'
    },
    sort_column_asc: {
        message: (0, $2CQVV.messages).sortColumnIncreasing,
        plural: null
    },
    sort_column_desc: {
        message: (0, $2CQVV.messages).sortColumnDecreasing,
        plural: null
    }
};
const $eda89f8ab7004d19$var$getGroupedDragMenuConfig = ()=>{
    const groupedDragMenuConfig = [
        [
            'add_row_above',
            'add_row_below',
            'add_column_left',
            'add_column_right',
            'distribute_columns',
            'clear_cells',
            'delete_row',
            'delete_column'
        ],
        [
            'move_column_left',
            'move_column_right',
            'move_row_up',
            'move_row_down'
        ]
    ];
    const sortColumnItems = [
        'sort_column_asc',
        'sort_column_desc'
    ];
    groupedDragMenuConfig.unshift(sortColumnItems);
    return groupedDragMenuConfig;
};
const $eda89f8ab7004d19$var$elementBeforeIconStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.negative.075',
    display: 'flex'
});
const $eda89f8ab7004d19$var$convertToDropdownItems = (dragMenuConfig, formatMessage, selectionRect)=>{
    const groupedDragMenuConfig = $eda89f8ab7004d19$var$getGroupedDragMenuConfig();
    const menuItemsArr = [
        ...Array(groupedDragMenuConfig.length)
    ].map(()=>[]);
    const menuCallback = {};
    dragMenuConfig.forEach((item)=>{
        const menuGroupIndex = groupedDragMenuConfig.findIndex((group)=>group.includes(item.id));
        if (menuGroupIndex === -1) return;
        const isPlural = Boolean($eda89f8ab7004d19$var$MapDragMenuOptionIdToMessage[item.id]?.plural);
        let plural = 0;
        if (isPlural && selectionRect) {
            const { top: top, bottom: bottom, right: right, left: left } = selectionRect;
            switch($eda89f8ab7004d19$var$MapDragMenuOptionIdToMessage[item.id].plural){
                case 'noOfCols':
                    plural = right - left;
                    break;
                case 'noOfRows':
                    plural = bottom - top;
                    break;
                case 'noOfCells':
                    plural = Math.max(right - left, bottom - top);
                    break;
            }
        }
        const options = isPlural ? {
            0: plural
        } : undefined;
        menuItemsArr[menuGroupIndex].push({
            key: item.id,
            content: formatMessage($eda89f8ab7004d19$var$MapDragMenuOptionIdToMessage[item.id].message, options),
            value: {
                name: item.id
            },
            isDisabled: item.disabled,
            elemBefore: item.icon ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                xcss: $eda89f8ab7004d19$var$elementBeforeIconStyles
            }, /*#__PURE__*/ (0, $9K4OG.jsx)(item.icon, {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage($eda89f8ab7004d19$var$MapDragMenuOptionIdToMessage[item.id].message, options)
            })) : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: item.keymap ? /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $6f5RK.shortcutStyle)
            }, item.keymap) : undefined
        });
        item.onClick && (menuCallback[item.id] = item.onClick);
    });
    const menuItems = menuItemsArr.reduce((acc, curr)=>{
        curr?.length > 0 && acc.push({
            items: curr
        });
        return acc;
    }, []);
    return {
        menuItems: menuItems,
        menuCallback: menuCallback
    };
};
const $eda89f8ab7004d19$var$DragMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ direction: direction = 'row', index: index, target: target, isOpen: isOpen, editorView: editorView, tableNode: tableNode, targetCellPosition: targetCellPosition, getEditorContainerWidth: getEditorContainerWidth, api: api, editorAnalyticsAPI: editorAnalyticsAPI, pluginConfig: pluginConfig, intl: { formatMessage: formatMessage }, fitHeight: fitHeight, fitWidth: fitWidth, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, isTableScalingEnabled: isTableScalingEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, ariaNotifyPlugin: ariaNotifyPlugin, isCommentEditor: isCommentEditor })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const { selection: selection } = state;
    const tableMap = tableNode ? (0, $LmqWp.TableMap).get(tableNode) : undefined;
    const [isSubmenuOpen, setIsSubmenuOpen] = (0, $42omo.useState)(false);
    const { isKeyboardModeActive: isKeyboardModeActive } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
    const selectionRect = (0, $BW42l.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $iP1et.getSelectionRect)(selection) : (0, $id9O1.findCellRectClosestToPos)(selection.$from);
    const hasMergedCellsInTable = tableMap?.hasMergedCells() ?? false;
    const allowBackgroundColor = pluginConfig?.allowBackgroundColor ?? false;
    const dragMenuConfig = (0, $95cc14ff7c35ef77$export$25f919d23e41e94d)(direction, getEditorContainerWidth, hasMergedCellsInTable, editorView, api, tableMap, index, targetCellPosition, selectionRect, editorAnalyticsAPI, pluginConfig?.isHeaderRowRequired, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, ariaNotifyPlugin, isCommentEditor, pluginConfig?.allowColumnSorting ?? true);
    const { menuItems: menuItems, menuCallback: menuCallback } = $eda89f8ab7004d19$var$convertToDropdownItems(dragMenuConfig, formatMessage, selectionRect);
    const handleSubMenuRef = (ref)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const dom = editorView.dom;
        const parent = (0, $4vlwG.closestElement)(dom, '.fabric-editor-popup-scroll-parent') || (0, $4vlwG.closestElement)(dom, '.ak-editor-content-area');
        if (!(parent && ref)) return;
        const boundariesRect = parent.getBoundingClientRect();
        const rect = ref.getBoundingClientRect();
        if (!!mountPoint) return;
        const offsetParent = ref?.offsetParent;
        if (!offsetParent) return;
        const offsetParentRect = offsetParent.getBoundingClientRect();
        const rightOverflow = offsetParentRect.right + rect.width - boundariesRect.right;
        const leftOverflow = boundariesRect.left - (offsetParentRect.left - rect.width);
        if (rightOverflow > leftOverflow) ref.style.left = `-${rect.width}px`;
        // if it overflows regardless of side, let it overlap with the parent menu
        if (leftOverflow > 0 && rightOverflow > 0) {
            if (rightOverflow < leftOverflow) ref.style.left = `${offsetParentRect.width - rightOverflow}px`;
            else ref.style.left = `-${rect.width - leftOverflow}px`;
        }
    };
    const setColor = (color)=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $d9aad08b0e0e65bb$export$d0cc02883d6bbba)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).CONTEXT_MENU, color)(state, dispatch);
        closeMenu();
        setIsSubmenuOpen(false);
    };
    const createBackgroundColorMenuItem = ()=>{
        const { targetCellPosition: targetCellPosition } = (0, $69d6e2a2c784f306$export$f05434c51e3762e)(editorView.state);
        const node = targetCellPosition ? state.doc.nodeAt(targetCellPosition) : null;
        const background = (0, $6icEc.hexToEditorBackgroundPaletteColor)(node?.attrs?.background || '#ffffff');
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $ahQKW.getSelectedRowAndColumnFromPalette)((0, $81b7b6f3cf3366fc$export$2e2bcd8739ae039), background, (0, $fbbb9ee8877c285e$export$2c18704a8d793cdb));
        return {
            key: 'background',
            content: formatMessage((0, $2CQVV.messages).backgroundColor),
            value: {
                name: 'background'
            },
            elemBefore: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6f0Oj.default), {
                xcss: $eda89f8ab7004d19$var$elementBeforeIconStyles
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7TXtV))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $2CQVV.messages).backgroundColor)
            })),
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $lwMQJ.DropdownMenuSharedCssClassName).SUBMENU,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: (0, $f06d467cdb1ed078$export$2a71c1910478944e)()
            }, /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: (0, $f06d467cdb1ed078$export$bc7b8b99ac8e8073)(background),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_SUBMENU_ICON
            }), isSubmenuOpen && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_SUBMENU,
                ref: handleSubMenuRef
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9Z3I5.ArrowKeyNavigationProvider), {
                type: (0, $5v8Ta.ArrowKeyNavigationType).COLOR,
                selectedRowIndex: selectedRowIndex,
                selectedColumnIndex: selectedColumnIndex,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                handleClose: ()=>{
                    const keyboardEvent = new KeyboardEvent('keydown', {
                        key: 'ArrowDown',
                        bubbles: true
                    });
                    setIsSubmenuOpen(false);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    target?.focus();
                    target?.dispatchEvent(keyboardEvent);
                },
                isPopupPositioned: true,
                isOpenedByKeyboard: isKeyboardModeActive
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hxEux.default), {
                cols: (0, $fbbb9ee8877c285e$export$2c18704a8d793cdb),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClick: (color)=>{
                    setColor(color);
                },
                selectedColor: background,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                paletteOptions: {
                    palette: (0, $81b7b6f3cf3366fc$export$2e2bcd8739ae039),
                    paletteColorTooltipMessages: (0, $8LFdJ.backgroundPaletteTooltipMessages),
                    hexToPaletteColor: (0, $6icEc.hexToEditorBackgroundPaletteColor)
                }
            }))))
        };
    };
    const toggleHeaderColumn = ()=>{
        (0, $d9aad08b0e0e65bb$export$9fd5a66fcada8ad2)(editorAnalyticsAPI)(state, dispatch);
    };
    const toggleHeaderRow = ()=>{
        (0, $d9aad08b0e0e65bb$export$2e66edaa488e7a1d)(editorAnalyticsAPI)(state, dispatch);
    };
    const toggleRowNumbers = ()=>{
        (0, $d9aad08b0e0e65bb$export$9e4b8d27ecc9c55)(editorAnalyticsAPI)(state, dispatch);
    };
    const HeaderColumnToggle = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $f06d467cdb1ed078$export$4e493e7fd1e47c4d)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $82gXq.default), {
            id: "toggle-header-column",
            label: formatMessage((0, $2CQVV.messages).headerColumn),
            onChange: toggleHeaderColumn,
            isChecked: (0, $bdb0299b531c40df$export$653b4f383b39a1d0)(selection)
        }));
    const HeaderRowToggle = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
            css: (0, $f06d467cdb1ed078$export$4e493e7fd1e47c4d)
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $82gXq.default), {
            id: "toggle-header-row",
            label: formatMessage((0, $2CQVV.messages).headerRow),
            onChange: toggleHeaderRow,
            isChecked: (0, $bdb0299b531c40df$export$b8efdc0183f04d59)(selection)
        }));
    const createHeaderRowColumnMenuItemOld = (direction)=>{
        return direction === 'column' ? {
            key: 'header_column',
            content: formatMessage((0, $2CQVV.messages).headerColumn),
            value: {
                name: 'header_column'
            },
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)(HeaderColumnToggle, null)
        } : {
            key: 'header_row',
            content: formatMessage((0, $2CQVV.messages).headerRow),
            value: {
                name: 'header_row'
            },
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)(HeaderRowToggle, null)
        };
    };
    const createHeaderRowColumnMenuItem = (direction)=>{
        if (direction === 'column' && (pluginConfig?.advanced || pluginConfig?.allowHeaderColumn)) return {
            key: 'header_column',
            content: formatMessage((0, $2CQVV.messages).headerColumn),
            value: {
                name: 'header_column'
            },
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)(HeaderColumnToggle, null)
        };
        if (direction === 'row' && (pluginConfig?.advanced || pluginConfig?.allowHeaderRow)) return {
            key: 'header_row',
            content: formatMessage((0, $2CQVV.messages).headerRow),
            value: {
                name: 'header_row'
            },
            elemAfter: /*#__PURE__*/ (0, $9K4OG.jsx)(HeaderRowToggle, null)
        };
    };
    const createRowNumbersMenuItem = ()=>{
        return {
            key: 'row_numbers',
            content: formatMessage((0, $2CQVV.messages).numberedRows),
            value: {
                name: 'row_numbers'
            },
            elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $f06d467cdb1ed078$export$4e493e7fd1e47c4d)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $82gXq.default), {
                id: "toggle-row-numbers",
                label: formatMessage((0, $2CQVV.messages).numberedRows),
                onChange: toggleRowNumbers,
                isChecked: (0, $bdb0299b531c40df$export$101f2696d8127fe0)(selection)
            }))
        };
    };
    /**
   * This function is to check if the menu should be closed or not.
   * As when continously clicking on tyle handle on different rows/columns,
   * should open the menu corresponding to the position of the drag handle.
   * @returns true when the menu should be closed, false otherwise
   */ const shouldCloseMenu = (state)=>{
        const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $abc6204662f4f035$export$f05434c51e3762e)(state);
        // menu open but menu direction changed, means user clicked on drag handle of different row/column
        // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
        // 2 scenarios above , menu should not be closed.
        if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) return false;
        else return true;
    };
    const closeMenu = (focusTarget = 'handle')=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (shouldCloseMenu(state)) {
            if (target && focusTarget === 'handle') target?.focus();
            else editorView.focus();
            (0, $68bb38467b052d2c$export$8a902a12acc69924)(false, direction, index)(state, dispatch);
        }
    };
    const handleMenuItemActivated = ({ item: item })=>{
        menuCallback[item.value.name]?.(state, dispatch);
        switch(item.value.name){
            case 'background':
                setIsSubmenuOpen(!isSubmenuOpen);
                break;
            case 'header_column':
                toggleHeaderColumn();
                break;
            case 'header_row':
                toggleHeaderRow();
                break;
            case 'row_numbers':
                toggleRowNumbers();
                break;
            default:
                break;
        }
        if ([
            'header_column',
            'header_row',
            'row_numbers',
            'background'
        ].indexOf(item.value.name) <= -1) closeMenu('editor');
    };
    const handleItemMouseEnter = ({ item: item })=>{
        if (!selectionRect) return;
        if (item.value.name === 'background' && !isSubmenuOpen) setIsSubmenuOpen(true);
        if (!item.value.name?.startsWith('delete')) return;
        (item.value.name === 'delete_column' ? (0, $7132c436572167eb$export$4cf548f2efac0afe)((0, $cee807f94f070ba4$export$915a77877be361e9)(selectionRect), true) : (0, $7132c436572167eb$export$ab63d99b591b89)((0, $cee807f94f070ba4$export$d023456f91fdf995)(selectionRect), true))(state, dispatch);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleItemMouseLeave = ({ item: item })=>{
        if (item.value.name === 'background' && isSubmenuOpen) setIsSubmenuOpen(false);
        if ([
            'sort_column_asc',
            'sort_column_desc',
            'delete_column',
            'delete_row'
        ].indexOf(item.value.name) > -1) (0, $7132c436572167eb$export$d4bebf197f3770e4)()(state, dispatch);
    };
    (0, $42omo.useEffect)(()=>{
        // focus on first menu item automatically when menu renders
        // and user is using keyboard
        if (isOpen && target && isKeyboardModeActive) {
            const keyboardEvent = new KeyboardEvent('keydown', {
                key: 'ArrowDown',
                bubbles: true
            });
            target.dispatchEvent(keyboardEvent);
        }
    }, [
        isOpen,
        target,
        isKeyboardModeActive
    ]);
    if (!menuItems) return null;
    if (allowBackgroundColor) menuItems[1].items.unshift(createBackgroundColorMenuItem());
    // If first row, add toggle for Header row, default is true
    // If first column, add toggle for Header column, default is false
    if (index === 0) {
        if (!(0, $dh538.fg)('platform_editor_enable_table_dnd')) menuItems.push({
            items: [
                createHeaderRowColumnMenuItemOld(direction)
            ]
        });
        else if ((pluginConfig?.advanced || pluginConfig?.allowHeaderColumn || pluginConfig?.allowHeaderRow) && (0, $dh538.fg)('platform_editor_enable_table_dnd')) {
            const headerRowColumnMenuItem = createHeaderRowColumnMenuItem(direction);
            headerRowColumnMenuItem && menuItems.push({
                items: [
                    headerRowColumnMenuItem
                ]
            });
        }
    }
    // All rows, add toggle for numbered rows, default is false
    if (direction === 'row' && ((0, $dh538.fg)('platform_editor_enable_table_dnd') ? pluginConfig?.advanced || pluginConfig?.allowNumberColumn : true)) index === 0 ? menuItems[menuItems.length - 1].items.push(createRowNumbersMenuItem()) : menuItems.push({
        items: [
            createRowNumbersMenuItem()
        ]
    });
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1eLzC.UserIntentPopupWrapper), {
        api: api,
        userIntent: "tableDragMenuPopupOpen"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1ff18a7a5a57b9d2$export$e44a253a59704894), {
        disableKeyboardHandling: isSubmenuOpen,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        section: {
            hasSeparator: true
        },
        items: menuItems,
        onItemActivated: handleMenuItemActivated,
        onMouseEnter: handleItemMouseEnter,
        onMouseLeave: handleItemMouseLeave,
        handleClose: closeMenu,
        fitHeight: fitHeight,
        fitWidth: fitWidth,
        direction: direction,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement
    }));
});
// eslint-disable-next-line @typescript-eslint/ban-types
const $eda89f8ab7004d19$var$_default_1 = (0, $aXWIB.injectIntl)($eda89f8ab7004d19$var$DragMenu);
var $eda89f8ab7004d19$export$2e2bcd8739ae039 = $eda89f8ab7004d19$var$_default_1;


const $efc91945e1888679$var$FloatingDragMenu = ({ mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isOpen: isOpen, tableNode: tableNode, direction: direction, index: index, targetCellPosition: targetCellPosition, getEditorContainerWidth: getEditorContainerWidth, editorAnalyticsAPI: editorAnalyticsAPI, stickyHeaders: stickyHeaders, pluginConfig: pluginConfig, isTableScalingEnabled: isTableScalingEnabled, getEditorFeatureFlags: getEditorFeatureFlags, ariaNotifyPlugin: ariaNotifyPlugin, api: api, isCommentEditor: isCommentEditor, tableWrapper: tableWrapper })=>{
    if (!isOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition) return null;
    const inStickyMode = stickyHeaders?.sticky || tableWrapper?.classList.contains((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER_NO_OVERFLOW) && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_7');
    const targetHandleRef = direction === 'row' ? document.querySelector('#drag-handle-button-row') : document.querySelector('#drag-handle-button-column');
    const offset = direction === 'row' ? [
        -9,
        0
    ] : [
        0,
        -7
    ];
    if (!targetHandleRef || !(editorView.state.selection instanceof (0, $7XFGZ.CellSelection))) return null;
    const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags?.() ?? {};
    const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || isCommentEditor);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
        alignX: direction === 'row' ? 'right' : undefined,
        alignY: direction === 'row' ? 'start' : undefined,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        target: targetHandleRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitWidth: (0, $fbbb9ee8877c285e$export$963fb187132ee7cf),
        fitHeight: (0, $fbbb9ee8877c285e$export$3cdde837cf189e96),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        // In sticky mode, we want to show the menu above the sticky header
        zIndex: inStickyMode ? (0, $aFUXX.akEditorFloatingDialogZIndex) : (0, $aFUXX.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        offset: offset,
        stick: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eda89f8ab7004d19$export$2e2bcd8739ae039), {
            editorView: editorView,
            isOpen: isOpen,
            tableNode: tableNode,
            direction: direction,
            index: index,
            target: targetHandleRef || undefined,
            targetCellPosition: targetCellPosition,
            getEditorContainerWidth: getEditorContainerWidth,
            editorAnalyticsAPI: editorAnalyticsAPI,
            pluginConfig: pluginConfig,
            fitWidth: (0, $fbbb9ee8877c285e$export$963fb187132ee7cf),
            fitHeight: (0, $fbbb9ee8877c285e$export$3cdde837cf189e96),
            mountPoint: mountPoint,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            isTableScalingEnabled: isTableScalingEnabled,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isTableFixedColumnWidthsOptionEnabled: tableWithFixedColumnWidthsOption,
            ariaNotifyPlugin: ariaNotifyPlugin,
            api: api,
            isCommentEditor: isCommentEditor || false
        })
    });
};
$efc91945e1888679$var$FloatingDragMenu.displayName = 'FloatingDragMenu';
var $efc91945e1888679$export$2e2bcd8739ae039 = $efc91945e1888679$var$FloatingDragMenu;













































const $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_COLUMN_BUTTON = -((0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c) / 2);
const $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_NUMBERED_COLUMN_BUTTON = $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_COLUMN_BUTTON + (0, $aFUXX.akEditorTableNumberColumnWidth);
const $1f4cdf22bfe2994c$var$VERTICAL_ALIGN_COLUMN_BUTTON = (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $fbbb9ee8877c285e$export$73b1242ebdcc73be);
const $1f4cdf22bfe2994c$var$VERTICAL_ALIGN_COLUMN_BUTTON_DRAG = (0, $fbbb9ee8877c285e$export$73b1242ebdcc73be);
const $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_ROW_BUTTON = -((0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $fbbb9ee8877c285e$export$73b1242ebdcc73be) + (0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c));
const $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_ROW_BUTTON_DRAG = -18;
const $1f4cdf22bfe2994c$var$VERTICAL_ALIGN_ROW_BUTTON = (0, $fbbb9ee8877c285e$export$6d23b13c5fcb846c) / 2;
function $1f4cdf22bfe2994c$var$getRowOptions(index, isDragAndDropEnabled) {
    let defaultOptions = {
        alignX: 'left',
        alignY: 'bottom',
        offset: [
            0,
            $1f4cdf22bfe2994c$var$VERTICAL_ALIGN_ROW_BUTTON
        ]
    };
    if (index === 0) defaultOptions = {
        ...defaultOptions,
        alignY: 'top',
        // The offset is the inverse the original, because is align top nop bottom.
        offset: [
            0,
            -$1f4cdf22bfe2994c$var$VERTICAL_ALIGN_ROW_BUTTON
        ]
    };
    return {
        ...defaultOptions,
        onPositionCalculated (position) {
            return {
                ...position,
                // Left position should be always the offset (To place in the correct position even if the table has overflow).
                left: isDragAndDropEnabled ? $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_ROW_BUTTON_DRAG : $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_ROW_BUTTON
            };
        }
    };
}
function $1f4cdf22bfe2994c$var$getColumnOptions(index, tableContainer, hasNumberedColumns, isDragAndDropEnabled) {
    const options = {
        alignX: 'end',
        alignY: 'top',
        offset: [
            $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_COLUMN_BUTTON,
            isDragAndDropEnabled ? $1f4cdf22bfe2994c$var$VERTICAL_ALIGN_COLUMN_BUTTON_DRAG : $1f4cdf22bfe2994c$var$VERTICAL_ALIGN_COLUMN_BUTTON
        ],
        // :: (position: PopupPosition) -> PopupPosition
        // Limit the InsertButton position to the table container
        // if the left position starts before it
        // we should always set the InsertButton on the start,
        // considering the offset from the first column
        onPositionCalculated (position) {
            const { left: left } = position;
            if (!left) // If not left, lest skip expensive next calculations.
            return position;
            if (index === 0) return {
                ...position,
                left: hasNumberedColumns ? $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_NUMBERED_COLUMN_BUTTON : $1f4cdf22bfe2994c$var$HORIZONTAL_ALIGN_COLUMN_BUTTON
            };
            // Check if current position is greater than the available container width
            const rect = tableContainer ? tableContainer.getBoundingClientRect() : null;
            return {
                ...position,
                left: rect && left > rect.width ? rect.width : left
            };
        }
    };
    // We need to change the popup position when
    // the column index is zero
    if (index === 0) return {
        ...options,
        alignX: 'left',
        alignY: 'top'
    };
    return options;
}
function $1f4cdf22bfe2994c$var$getPopupOptions(direction, index, hasNumberedColumns, isDragAndDropEnabled, tableContainer) {
    switch(direction){
        case 'column':
            return $1f4cdf22bfe2994c$var$getColumnOptions(index, tableContainer, hasNumberedColumns, isDragAndDropEnabled);
        case 'row':
            return $1f4cdf22bfe2994c$var$getRowOptions(index, isDragAndDropEnabled);
        default:
            return {};
    }
}
var $1f4cdf22bfe2994c$export$2e2bcd8739ae039 = $1f4cdf22bfe2994c$var$getPopupOptions;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


parcelRequire("42omo");



























const $3717dbb6fe2829eb$var$getInsertLineHeight = (tableRef, hasStickyHeaders, isDragAndDropEnabled)=>{
    // The line gets height 100% from the table,
    // but since we have an overflow on the left,
    // we should add an offset to make up for it.
    const LINE_OFFSET = 3;
    const ADDITIONAL_HEIGHT = hasStickyHeaders ? tableRef.getBoundingClientRect().top - (0, $1zav4.tableMarginTop) * (isDragAndDropEnabled ? 3 : 4) - LINE_OFFSET : (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + LINE_OFFSET;
    return tableRef.offsetHeight + ADDITIONAL_HEIGHT;
};
const $3717dbb6fe2829eb$var$getToolbarSize = (tableRef)=>{
    const parent = (0, $4vlwG.closestElement)(tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}`);
    if (parent) return parent.querySelector(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN}`) ? (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b) + (0, $aFUXX.akEditorTableNumberColumnWidth) - 1 : (0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b);
    return 0, $fbbb9ee8877c285e$export$a4d60e31f4f6188b;
};
const $3717dbb6fe2829eb$var$getNumberColumnWidth = (tableRef, isDragAndDropEnabled)=>{
    const parent = (0, $4vlwG.closestElement)(tableRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}`);
    if (parent && isDragAndDropEnabled) return parent.querySelector(`.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).NUMBERED_COLUMN}`) ? (0, $aFUXX.akEditorTableNumberColumnWidth) - 1 : 0;
    return 0;
};
const $3717dbb6fe2829eb$var$getInsertLineWidth = (tableRef, isDragAndDropEnabled, isChromelessEditor)=>{
    // The line gets width 100% from the table,
    // but since we have an overflow on the left,
    // we should add an offset to make up for it.
    const LINE_OFFSET = 4;
    const DRAG_LINE_OFFSET = isChromelessEditor ? 14 : 6;
    const { parentElement: parentElement, offsetWidth: offsetWidth } = tableRef;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const parentOffsetWidth = parentElement.offsetWidth;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { scrollLeft: scrollLeft } = parentElement;
    const diff = offsetWidth - parentOffsetWidth;
    const toolbarSize = isDragAndDropEnabled ? 0 : $3717dbb6fe2829eb$var$getToolbarSize(tableRef);
    const lineOffset = isDragAndDropEnabled ? DRAG_LINE_OFFSET : LINE_OFFSET;
    return Math.min(offsetWidth + toolbarSize, parentOffsetWidth + toolbarSize - Math.max(scrollLeft - diff, 0)) + lineOffset + $3717dbb6fe2829eb$var$getNumberColumnWidth(tableRef, isDragAndDropEnabled);
};
const $3717dbb6fe2829eb$var$tooltipMessageByType = (type)=>{
    return type === 'row' ? (0, $2CQVV.messages).insertRow : (0, $2CQVV.messages).insertColumn;
};
const $3717dbb6fe2829eb$var$InsertButtonForDragAndDrop = ({ onMouseDown: onMouseDown, tableRef: tableRef, type: type, intl: { formatMessage: formatMessage }, hasStickyHeaders: hasStickyHeaders, isChromelessEditor: isChromelessEditor })=>{
    const isRow = type === 'row';
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
            description: formatMessage(isRow ? (0, $2CQVV.messages).insertRowDrag : (0, $2CQVV.messages).insertColumnDrag),
            keymap: isRow ? (0, $hgeg8.addRowAfter) : (0, $hgeg8.addColumnAfter)
        }),
        position: "top",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($2daQU)))((0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER, {
                        [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW]: isRow && !isChromelessEditor,
                        [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN]: !isRow,
                        [(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS]: isRow && isChromelessEditor
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)("button", {
                        type: "button",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON,
                        onMouseDown: onMouseDown,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_ICON,
                            width: "16",
                            height: "16",
                            viewBox: "0 0 16 16",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M8 4C7.44771 4 7 4.44771 7 5V7H5C4.44771 7 4 7.44771 4 8C4 8.55229 4.44771 9 5 9H7V11C7 11.5523 7.44771 12 8 12C8.55229 12 9 11.5523 9 11V9H11C11.5523 9 12 8.55229 12 8C12 7.44771 11.5523 7 11 7H9V5C9 4.44771 8.55229 4 8 4Z",
                                fill: "currentColor"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: type === 'row' ? {
                        width: $3717dbb6fe2829eb$var$getInsertLineWidth(tableRef, true, isChromelessEditor),
                        left: "var(--ds-space-150, 12px)"
                    } : {
                        height: $3717dbb6fe2829eb$var$getInsertLineHeight(tableRef, hasStickyHeaders, true) - 8,
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        top: '-3px'
                    }
                })
            ]
        })
    });
    const floatingButtonClassName = isRow ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_ROW : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_COLUMN;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: floatingButtonClassName,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).DRAG_CONTROLS_INSERT_BUTTON_WRAP} ${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_ROW}`,
            children: content
        })
    }));
};
const $3717dbb6fe2829eb$export$5e513603d391e3de = (0, $aXWIB.injectIntl)($3717dbb6fe2829eb$var$InsertButtonForDragAndDrop);
const $3717dbb6fe2829eb$var$InsertButton = ({ onMouseDown: onMouseDown, tableRef: tableRef, type: type, intl: { formatMessage: formatMessage }, hasStickyHeaders: hasStickyHeaders })=>{
    const content = /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $hgeg8.ToolTipContent), {
            description: formatMessage($3717dbb6fe2829eb$var$tooltipMessageByType(type)),
            keymap: type === 'row' ? (0, $hgeg8.addRowAfter) : (0, $hgeg8.addColumnAfter)
        }),
        position: "top",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON_INNER,
                    children: /*#__PURE__*/ (0, $l998X.jsx)("button", {
                        type: "button",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON,
                        onMouseDown: onMouseDown,
                        "aria-label": formatMessage($3717dbb6fe2829eb$var$tooltipMessageByType(type)),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                            className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_BUTTON_ICON,
                            children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                                d: "M10 4a1 1 0 0 1 1 1v4h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4H5a1 1 0 1 1 0-2h4V5a1 1 0 0 1 1-1z",
                                fill: "currentColor",
                                fillRule: "evenodd"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_LINE,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: type === 'row' ? {
                        width: $3717dbb6fe2829eb$var$getInsertLineWidth(tableRef)
                    } : {
                        height: $3717dbb6fe2829eb$var$getInsertLineHeight(tableRef, hasStickyHeaders)
                    }
                })
            ]
        })
    });
    const floatingButtonClassName = type === 'column' ? (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_COLUMN : (0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_FLOATING_BUTTON_ROW;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: floatingButtonClassName,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_BUTTON_WRAP} ${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).CONTROLS_INSERT_ROW}`,
            children: content
        })
    }));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $3717dbb6fe2829eb$var$_default_1 = (0, $aXWIB.injectIntl)($3717dbb6fe2829eb$var$InsertButton);
var $3717dbb6fe2829eb$export$2e2bcd8739ae039 = $3717dbb6fe2829eb$var$_default_1;


class $008d5f85143ad358$export$e2c2386b8045af89 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { tableNode: tableNode, editorView: editorView, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, tableRef: tableRef, mountPoint: mountPoint, boundariesElement: boundariesElement, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, isDragAndDropEnabled: isDragAndDropEnabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isChromelessEditor: isChromelessEditor } = this.props;
        // TODO: ED-26961 - temporarily disable insert button for first column and row https://atlassian.slack.com/archives/C05U8HRQM50/p1698363744682219?thread_ts=1698209039.104909&cid=C05U8HRQM50
        if (isDragAndDropEnabled && (insertColumnButtonIndex === 0 || insertRowButtonIndex === 0)) return null;
        const type = typeof insertColumnButtonIndex !== 'undefined' ? 'column' : typeof insertRowButtonIndex !== 'undefined' ? 'row' : null;
        if (!tableNode || !tableRef || !type) return null;
        // We can’t display the insert button for row|colum index 0
        // when the header row|colum is enabled, this feature will be change on the future
        if (type === 'column' && isHeaderColumnEnabled && insertColumnButtonIndex === 0 || type === 'row' && isHeaderRowEnabled && insertRowButtonIndex === 0) return null;
        const { state: { tr: tr } } = editorView;
        if (tr.selection instanceof (0, $7XFGZ.CellSelection) && (tr.selection.isColSelection() || tr.selection.isRowSelection())) return null;
        const tablePos = (0, $id9O1.findTable)(tr.selection);
        if (!tablePos) return null;
        // the tableNode props is not always latest (when you type some text in a cell, it's not updated yet)
        // we need to get the latest one by calling findTable(tr.selection)
        const cellPosition = this.getCellPosition(type, tablePos?.node);
        if (!cellPosition) return null;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const pos = cellPosition + tablePos.start + 1;
        let target;
        try {
            target = (0, $8m4tT.findDomRefAtPos)(pos, domAtPos);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $d925B.ACTION).ERRORED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).CONTENT_COMPONENT,
                    eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        component: (0, $d925B.CONTENT_COMPONENT).FLOATING_INSERT_BUTTON,
                        selection: editorView.state.selection.toJSON(),
                        position: pos,
                        docSize: editorView.state.doc.nodeSize,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        error: error?.toString()
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
        }
        if (!target || !(target instanceof HTMLElement)) return null;
        const targetCellRef = type === 'row' ? (0, $4vlwG.closestElement)(target, 'tr') : (0, $4vlwG.closestElement)(target, 'td, th');
        if (!targetCellRef) return null;
        const tableContainerWrapper = (0, $4vlwG.closestElement)(targetCellRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_CONTAINER}`);
        const tableWrapper = (0, $4vlwG.closestElement)(targetCellRef, `.${(0, $8b6ac7577f3a66b8$export$19a8a7a6488b1b9f).TABLE_NODE_WRAPPER}`);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const index = type === 'column' ? insertColumnButtonIndex : insertRowButtonIndex;
        const hasNumberedColumns = (0, $bdb0299b531c40df$export$101f2696d8127fe0)(editorView.state.selection);
        // Fixed the 'add column button' not visible issue when sticky header is enabled
        // By setting the Popup z-index higher than the sticky header z-index ( common-styles.ts tr.sticky)
        // Only when inserting a column, otherwise set to undefined
        // Need to set z-index in the Popup, set z-index in the <InsertButton /> will not work
        const zIndex = (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') || type === 'column' ? (0, $aFUXX.akEditorTableCellOnStickyHeaderZIndex) : undefined;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
            target: targetCellRef,
            mountTo: tableContainerWrapper || mountPoint,
            boundariesElement: tableContainerWrapper || boundariesElement,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            scrollableElement: tableWrapper,
            forcePlacement: true,
            allowOutOfBounds: true,
            ...(0, $1f4cdf22bfe2994c$export$2e2bcd8739ae039)(type, index, hasNumberedColumns, !!isDragAndDropEnabled, tableContainerWrapper),
            zIndex: zIndex,
            children: isDragAndDropEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $3717dbb6fe2829eb$export$5e513603d391e3de), {
                type: type,
                tableRef: tableRef,
                onMouseDown: type === 'column' ? this.insertColumn : this.insertRow,
                hasStickyHeaders: this.props.hasStickyHeaders || false,
                isChromelessEditor: isChromelessEditor
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $3717dbb6fe2829eb$export$2e2bcd8739ae039), {
                type: type,
                tableRef: tableRef,
                onMouseDown: type === 'column' ? this.insertColumn : this.insertRow,
                hasStickyHeaders: this.props.hasStickyHeaders || false
            })
        });
    }
    getCellPosition(type, tableNode) {
        const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex } = this.props;
        const tableMap = (0, $LmqWp.TableMap).get(tableNode);
        if (type === 'column') {
            // This condition is to make typescript happy.
            // Previously insertColumnButtonIndex - 1 would produce NaN and return null anyway.
            if (insertColumnButtonIndex === undefined) return null;
            const columnIndex = insertColumnButtonIndex === 0 ? 0 : insertColumnButtonIndex - 1;
            if (columnIndex > tableMap.width - 1) return null;
            return tableMap.positionAt(0, columnIndex, tableNode);
        } else {
            // This condition is to make typescript happy.
            // Previously insertRowButtonIndex - 1 would produce NaN and return null anyway.
            if (insertRowButtonIndex === undefined) return null;
            const rowIndex = insertRowButtonIndex === 0 ? 0 : insertRowButtonIndex - 1;
            if (rowIndex > tableMap.height - 1) return null;
            return tableMap.positionAt(rowIndex, 0, tableNode);
        }
    }
    insertRow(event) {
        const { editorView: editorView, insertRowButtonIndex: insertRowButtonIndex, editorAnalyticsAPI: editorAnalyticsAPI } = this.props;
        if (typeof insertRowButtonIndex !== 'undefined') {
            event.preventDefault();
            const { state: state, dispatch: dispatch } = editorView;
            (0, $d9aad08b0e0e65bb$export$e45f3a1f9c021052)(editorAnalyticsAPI)((0, $d925B.INPUT_METHOD).BUTTON, {
                index: insertRowButtonIndex,
                moveCursorToInsertedRow: true
            })(state, dispatch);
        }
    }
    insertColumn(event) {
        const { editorView: editorView, insertColumnButtonIndex: insertColumnButtonIndex, editorAnalyticsAPI: editorAnalyticsAPI, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, isCommentEditor: isCommentEditor } = this.props;
        if (typeof insertColumnButtonIndex !== 'undefined') {
            event.preventDefault();
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || isCommentEditor);
            const { state: state, dispatch: dispatch } = editorView;
            (0, $d9aad08b0e0e65bb$export$fc693eab55df8b35)(this.props.api, editorAnalyticsAPI, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $d925B.INPUT_METHOD).BUTTON, insertColumnButtonIndex)(state, dispatch, editorView);
        }
    }
    constructor(props){
        super(props);
        this.insertColumn = this.insertColumn.bind(this);
        this.insertRow = this.insertRow.bind(this);
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
$008d5f85143ad358$export$e2c2386b8045af89.displayName = 'FloatingInsertButton';
const $008d5f85143ad358$var$_default_1 = (0, $aXWIB.injectIntl)($008d5f85143ad358$export$e2c2386b8045af89);
var $008d5f85143ad358$export$2e2bcd8739ae039 = $008d5f85143ad358$var$_default_1;











const $3d5a4c7c037fbee4$export$a60e1be3b6001ff3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((props)=>{
    const { target: target, content: content, alignX: alignX, alignY: alignY, zIndex: zIndex, forcePlacement: forcePlacement, stick: stick, offset: offset } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jwWgu.default), {
        target: target,
        alignX: alignX,
        alignY: alignY,
        zIndex: zIndex,
        stick: stick,
        forcePlacement: forcePlacement,
        offset: offset,
        children: content
    });
});


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 






const $4c3548cc318b5972$export$cc5403d58ddfa812 = ({ featureFlags: featureFlags, api: api })=>{
    const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'editorViewMode'
    ], (states)=>({
            mode: states.editorViewModeState?.mode
        }));
    const isLivePageViewMode = mode === 'view';
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $9K4OG.Global), {
        styles: (0, $93fa7bbbefe5a956$export$e938d6f191645a3e)({
            featureFlags: featureFlags,
            isDragAndDropEnabled: !isLivePageViewMode
        })
    });
};


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $hMaMb = parcelRequire("hMaMb");


const $99b6a28c1e195b05$var$DEFAULT_TABLE_SELECTOR_COLS = 3;
const $99b6a28c1e195b05$var$DEFAULT_TABLE_SELECTOR_ROWS = 3;
const $99b6a28c1e195b05$export$800b7d81026538f2 = ({ api: api, target: target, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
    const closeSelectorPopup = (0, $42omo.useCallback)(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $030f86662bf3c0ad$export$18d4026d1ea86bb1), {
                isSelectorOpen: false
            });
            return tr;
        });
    }, [
        api
    ]);
    const onSelection = (0, $42omo.useCallback)((rowsCount, colsCount)=>{
        api?.core.actions.execute(({ tr: tr })=>{
            api?.table.commands.insertTableWithSize(rowsCount, colsCount)({
                tr: tr
            });
            tr.setMeta((0, $030f86662bf3c0ad$export$18d4026d1ea86bb1), {
                isSelectorOpen: false
            });
            return tr;
        });
    }, [
        api
    ]);
    const onUnmount = ()=>{
        api?.core.actions.focus();
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $hMaMb.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        defaultSize: {
            row: $99b6a28c1e195b05$var$DEFAULT_TABLE_SELECTOR_ROWS,
            col: $99b6a28c1e195b05$var$DEFAULT_TABLE_SELECTOR_COLS
        },
        target: target,
        onUnmount: onUnmount,
        onSelection: onSelection,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        popupsBoundariesElement: popupsBoundariesElement,
        isOpenedByKeyboard: true,
        handleClickOutside: closeSelectorPopup,
        handleEscapeKeydown: closeSelectorPopup
    });
};





parcelRequire("42omo");










var $dcJ7R = parcelRequire("dcJ7R");



const $c8d2ef0836054c91$var$tableFullWidthLabelWrapperStyles = (0, $ecnYn.xcss)({
    height: "var(--ds-space-400, 32px)",
    display: 'flex',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    boxSizing: 'border-box',
    alignItems: 'center'
});
const $c8d2ef0836054c91$var$tableFullWidthLabelStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $c8d2ef0836054c91$export$8bde7db5b2aba7d = ()=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        xcss: $c8d2ef0836054c91$var$tableFullWidthLabelWrapperStyles,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
            xcss: $c8d2ef0836054c91$var$tableFullWidthLabelStyles,
            children: formatMessage((0, $2CQVV.messages).fullWidthLabel)
        })
    });
};


const $9a7d1b7fff538a30$var$selector = (states)=>({
        resizingTableLocalId: states.tableState?.resizingTableLocalId,
        resizingTableRef: states.tableState?.resizingTableRef,
        isTableResizing: states.tableState?.isTableResizing,
        isResizing: states.tableState?.isResizing,
        widthToWidest: states.tableState?.widthToWidest,
        tableNode: states.tableState?.tableNode,
        targetCellPosition: states.tableState?.targetCellPosition,
        isContextualMenuOpen: states.tableState?.isContextualMenuOpen,
        tableRef: states.tableState?.tableRef,
        pluginConfig: states.tableState?.pluginConfig,
        insertColumnButtonIndex: states.tableState?.insertColumnButtonIndex,
        insertRowButtonIndex: states.tableState?.insertRowButtonIndex,
        isHeaderColumnEnabled: states.tableState?.isHeaderColumnEnabled,
        isHeaderRowEnabled: states.tableState?.isHeaderRowEnabled,
        isDragAndDropEnabled: states.tableState?.isDragAndDropEnabled,
        tableWrapperTarget: states.tableState?.tableWrapperTarget,
        isCellMenuOpenByKeyboard: states.tableState?.isCellMenuOpenByKeyboard,
        stickyHeader: states.tableState?.stickyHeader,
        dragMenuDirection: states.tableState?.dragMenuDirection,
        dragMenuIndex: states.tableState?.dragMenuIndex,
        isDragMenuOpen: states.tableState?.isDragMenuOpen,
        isSizeSelectorOpen: states.tableState?.isSizeSelectorOpen,
        sizeSelectorTargetRef: states.tableState?.sizeSelectorTargetRef,
        // IMPORTANT: hovered states are used by FloatingDragMenu component to render popup in the correct location
        hoveredRows: states.tableState?.hoveredRows,
        hoveredColumns: states.tableState?.hoveredColumns,
        hoveredCell: states.tableState?.hoveredCell
    });
const $9a7d1b7fff538a30$var$ContentComponentInternal = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, options: options, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isTableSelectorEnabled: isTableSelectorEnabled, defaultGetEditorContainerWidth: defaultGetEditorContainerWidth, defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const ariaNotifyPlugin = api?.accessibilityUtils?.actions.ariaNotify;
    const { resizingTableLocalId: resizingTableLocalId, resizingTableRef: resizingTableRef, isTableResizing: isTableResizing, isResizing: isResizing, widthToWidest: widthToWidest, tableNode: tableNode, targetCellPosition: targetCellPosition, isContextualMenuOpen: isContextualMenuOpen, tableRef: tableRef, pluginConfig: pluginConfig, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, isDragAndDropEnabled: isDragAndDropEnabled, tableWrapperTarget: tableWrapperTarget, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, stickyHeader: stickyHeader, dragMenuDirection: dragMenuDirection, dragMenuIndex: dragMenuIndex, isDragMenuOpen: isDragMenuOpen, isSizeSelectorOpen: isSizeSelectorOpen, sizeSelectorTargetRef: sizeSelectorTargetRef } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'table'
    ], $9a7d1b7fff538a30$var$selector);
    const { allowControls: allowControls } = pluginConfig ?? {};
    if (!editorView) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            targetCellPosition && (tableRef || isCellMenuOpenByKeyboard) && !isResizing && options && options.allowContextualMenu && /*#__PURE__*/ (0, $l998X.jsx)((0, $35f649121590a9ea$export$2e2bcd8739ae039), {
                isNumberColumnEnabled: tableNode && tableNode.attrs.isNumberColumnEnabled,
                editorView: editorView,
                tableNode: tableNode,
                mountPoint: popupsMountPoint,
                targetCellPosition: targetCellPosition,
                scrollableElement: popupsScrollableElement,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                isContextualMenuOpen: isContextualMenuOpen,
                stickyHeader: stickyHeader,
                tableWrapper: tableWrapperTarget,
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
                isDragAndDropEnabled: isDragAndDropEnabled
            }),
            allowControls && /*#__PURE__*/ (0, $l998X.jsx)((0, $008d5f85143ad358$export$2e2bcd8739ae039), {
                tableNode: tableNode,
                tableRef: tableRef,
                insertColumnButtonIndex: insertColumnButtonIndex,
                insertRowButtonIndex: insertRowButtonIndex,
                isHeaderColumnEnabled: isHeaderColumnEnabled,
                isHeaderRowEnabled: isHeaderRowEnabled,
                isDragAndDropEnabled: isDragAndDropEnabled,
                isTableScalingEnabled: options?.isTableScalingEnabled,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                hasStickyHeaders: stickyHeader && stickyHeader.sticky,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                editorAnalyticsAPI: editorAnalyticsAPI,
                getEditorContainerWidth: defaultGetEditorContainerWidth,
                getEditorFeatureFlags: options?.getEditorFeatureFlags || defaultGetEditorFeatureFlags,
                isChromelessEditor: options?.isChromelessEditor,
                api: api,
                isCommentEditor: options?.isCommentEditor
            }),
            options?.allowContextualMenu && /*#__PURE__*/ (0, $l998X.jsx)((0, $b47da77c2d9945b4$export$2e2bcd8739ae039), {
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                targetCellPosition: targetCellPosition,
                isOpen: Boolean(isContextualMenuOpen) && !isResizing,
                pluginConfig: pluginConfig,
                editorAnalyticsAPI: editorAnalyticsAPI,
                getEditorContainerWidth: defaultGetEditorContainerWidth,
                getEditorFeatureFlags: options?.getEditorFeatureFlags || defaultGetEditorFeatureFlags,
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
                isCommentEditor: options?.isCommentEditor,
                api: api,
                isDragMenuOpen: isDragMenuOpen
            }),
            isDragAndDropEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $efc91945e1888679$export$2e2bcd8739ae039), {
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                tableRef: tableRef,
                tableNode: tableNode,
                targetCellPosition: targetCellPosition,
                direction: dragMenuDirection,
                index: dragMenuIndex,
                isOpen: !!isDragMenuOpen && !isResizing,
                getEditorContainerWidth: defaultGetEditorContainerWidth,
                editorAnalyticsAPI: editorAnalyticsAPI,
                stickyHeaders: stickyHeader,
                pluginConfig: pluginConfig,
                isTableScalingEnabled: options?.isTableScalingEnabled,
                getEditorFeatureFlags: options?.getEditorFeatureFlags || defaultGetEditorFeatureFlags,
                ariaNotifyPlugin: ariaNotifyPlugin,
                api: api,
                isCommentEditor: options?.isCommentEditor,
                tableWrapper: tableWrapperTarget
            }),
            allowControls && !isDragAndDropEnabled && !isResizing && /*#__PURE__*/ (0, $l998X.jsx)((0, $deb8cdf2192525db$export$2e2bcd8739ae039), {
                editorView: editorView,
                selection: editorView.state.selection,
                tableRef: tableRef,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                stickyHeaders: stickyHeader,
                isNumberColumnEnabled: tableNode && tableNode.attrs.isNumberColumnEnabled,
                editorAnalyticsAPI: editorAnalyticsAPI,
                api: api
            }),
            (options?.isTableScalingEnabled || options?.tableOptions.allowTableResizing && options.isCommentEditor) && isTableResizing && widthToWidest && resizingTableLocalId && resizingTableRef && widthToWidest[resizingTableLocalId] && /*#__PURE__*/ (0, $l998X.jsx)((0, $3d5a4c7c037fbee4$export$a60e1be3b6001ff3), {
                target: resizingTableRef,
                content: (0, $iu6m9.editorExperiment)('single_column_layouts', true) ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7x0qS.ResizerBreakoutModeLabel), {
                    layout: "full-width"
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $c8d2ef0836054c91$export$8bde7db5b2aba7d), {}),
                alignX: 'center',
                alignY: 'bottom',
                stick: true,
                forcePlacement: true,
                zIndex: (0, $aFUXX.akEditorFloatingPanelZIndex),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                offset: [
                    0,
                    10
                ]
            }),
            isTableSelectorEnabled && isSizeSelectorOpen && /*#__PURE__*/ (0, $l998X.jsx)((0, $99b6a28c1e195b05$export$800b7d81026538f2), {
                api: api,
                isOpenedByKeyboard: false,
                popupsMountPoint: popupsMountPoint,
                target: sizeSelectorTargetRef ?? (0, $kuh1P.getDomRefFromSelection)(editorView, (0, $d925B.ACTION_SUBJECT_ID).PICKER_TABLE_SIZE, api?.analytics?.actions),
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            })
        ]
    });
};
const $9a7d1b7fff538a30$export$2dda1e4a1d1f6a81 = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, options: options, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isTableSelectorEnabled: isTableSelectorEnabled, defaultGetEditorContainerWidth: defaultGetEditorContainerWidth, defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7fmpI.ErrorBoundary), {
        component: (0, $d925B.ACTION_SUBJECT).TABLES_PLUGIN,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        fallbackComponent: null,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $4c3548cc318b5972$export$cc5403d58ddfa812), {
                featureFlags: api?.featureFlags?.sharedState.currentState(),
                api: api
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($9a7d1b7fff538a30$var$ContentComponentInternal, {
                api: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                options: options,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                isTableSelectorEnabled: isTableSelectorEnabled,
                defaultGetEditorContainerWidth: defaultGetEditorContainerWidth,
                defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags
            })
        ]
    });
};



const $b21157aa04a7535c$var$defaultGetEditorFeatureFlags = ()=>({});
// we want to calculate all the table widths (which causes reflows) after the editor has finished loading to mitigate performance impact
const $b21157aa04a7535c$var$TABLE_WIDTH_INFO_TIMEOUT = 10000;
/**
 * Table plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $b21157aa04a7535c$var$tablePlugin = ({ config: config, api: api })=>{
    const editorViewRef = {
        current: null
    };
    const options = {
        ...config,
        tableOptions: config?.tableOptions ?? {},
        isTableScalingEnabled: config?.isTableScalingEnabled || (0, $dh538.fg)('platform_editor_enable_table_scaling')
    };
    const defaultGetEditorContainerWidth = ()=>{
        return api?.width?.sharedState.currentState() ?? {
            width: document?.body?.offsetWidth ?? 500
        };
    };
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isTableFixedColumnWidthsOptionEnabled = (0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? options?.allowFixedColumnWidthOption : options?.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption || false;
    const shouldUseIncreasedScalingPercent = options?.isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
    options?.isCommentEditor);
    const isTableSelectorEnabled = // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    !options?.isChromelessEditor && !options?.isCommentEditor && options?.getEditorFeatureFlags?.().tableSelector && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1');
    return {
        name: 'table',
        // Use getSharedState to store fullWidthEnabled and wasFullWidthModeEnabled to guarantee access
        // to most up to date values - passing to createPluginState will not re-initialise the state
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const tablePluginState = (0, $fedf15e5199146e8$export$18d4026d1ea86bb1).getState(editorState);
            const tableResizingPluginState = (0, $bd73f3b7ba9edc98$export$f05434c51e3762e)(editorState);
            const tableWidthResizingPluginState = (0, $e9b9e23609860f66$export$18d4026d1ea86bb1).getState(editorState);
            const stickyHeadersState = (0, $1562ea854f0ae047$export$18d4026d1ea86bb1).getState(editorState);
            const stickyHeader = stickyHeadersState ? (0, $894c3bb16e3b70ec$export$91d61a242b14c7fb)(stickyHeadersState, tablePluginState?.tablePos) : undefined;
            const dragAndDropState = (0, $c8432cced568eda6$export$18d4026d1ea86bb1).getState(editorState);
            const sizeSelectorPluginState = (0, $030f86662bf3c0ad$export$18d4026d1ea86bb1).getState(editorState);
            const editorContentAreaHeightPluginState = (0, $c80e8922e1b59353$export$18d4026d1ea86bb1).getState(editorState);
            const sharedStateInternal = {
                isFullWidthModeEnabled: !!options?.fullWidthEnabled,
                wasFullWidthModeEnabled: !!options?.wasFullWidthEnabled,
                isMaxWidthModeEnabled: !!options?.maxWidthEnabled,
                wasMaxWidthModeEnabled: !!options?.wasMaxWidthEnabled,
                isHeaderRowEnabled: tablePluginState.isHeaderRowEnabled,
                isHeaderColumnEnabled: tablePluginState.isHeaderColumnEnabled,
                ordering: tablePluginState.ordering,
                isResizing: !!(tableResizingPluginState?.dragging || tableWidthResizingPluginState?.resizing),
                isTableResizing: tableWidthResizingPluginState?.resizing,
                isInDanger: tablePluginState.isInDanger,
                hoveredRows: tablePluginState.hoveredRows,
                hoveredColumns: tablePluginState.hoveredColumns,
                hoveredCell: tablePluginState.hoveredCell,
                isTableHovered: tablePluginState.isTableHovered,
                isWholeTableInDanger: tablePluginState.isWholeTableInDanger,
                // IMPORTANT: Need to continue to pass tableNode to control re-renders
                // TableComponent listens for node attribute changes to update colgroups
                tableNode: tablePluginState.tableNode,
                widthToWidest: tablePluginState.widthToWidest,
                resizingTableLocalId: tableWidthResizingPluginState?.tableLocalId,
                tableRef: tablePluginState?.tableRef ?? undefined,
                resizingTableRef: tableWidthResizingPluginState?.tableRef ?? undefined,
                tablePos: tablePluginState.tablePos,
                targetCellPosition: tablePluginState.targetCellPosition,
                isContextualMenuOpen: tablePluginState.isContextualMenuOpen,
                pluginConfig: tablePluginState.pluginConfig,
                insertColumnButtonIndex: tablePluginState.insertColumnButtonIndex,
                insertRowButtonIndex: tablePluginState.insertRowButtonIndex,
                isDragAndDropEnabled: tablePluginState.isDragAndDropEnabled,
                tableWrapperTarget: tablePluginState.tableWrapperTarget,
                isCellMenuOpenByKeyboard: tablePluginState.isCellMenuOpenByKeyboard,
                stickyHeader: stickyHeader,
                dragMenuDirection: dragAndDropState?.dragMenuDirection,
                dragMenuIndex: dragAndDropState?.dragMenuIndex,
                isDragMenuOpen: dragAndDropState?.isDragMenuOpen,
                isSizeSelectorOpen: sizeSelectorPluginState?.isSelectorOpen,
                sizeSelectorTargetRef: sizeSelectorPluginState?.targetRef,
                editorContentAreaHeight: (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_4') ? editorContentAreaHeightPluginState?.height : undefined
            };
            return sharedStateInternal;
        },
        actions: {
            insertTable: (analyticsPayload)=>(state, dispatch)=>{
                    if (options?.tableOptions?.allowNestedTables) return (0, $gmyMu.editorCommandToPMCommand)((0, $6921de1f1a31eb9c$export$b57b177fe1ab7f1f)({
                        isTableScalingEnabled: options?.isTableScalingEnabled,
                        isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                        isFullWidthModeEnabled: options?.fullWidthEnabled,
                        isMaxWidthModeEnabled: options?.maxWidthEnabled,
                        isCommentEditor: options?.isCommentEditor,
                        isChromelessEditor: options?.isChromelessEditor,
                        isTableResizingEnabled: options?.tableOptions.allowTableResizing
                    }, api, analyticsPayload))(state, dispatch);
                    else {
                        const node = (0, $93be038868ed0558$export$5003ecb973fc11c2)({
                            isTableScalingEnabled: options?.isTableScalingEnabled,
                            isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                            isFullWidthModeEnabled: options?.fullWidthEnabled,
                            isMaxWidthModeEnabled: options?.maxWidthEnabled,
                            isCommentEditor: options?.isCommentEditor,
                            isChromelessEditor: options?.isChromelessEditor,
                            isTableResizingEnabled: options?.tableOptions.allowTableResizing
                        })(state.schema);
                        return api?.contentInsertion?.actions?.insert({
                            state: state,
                            dispatch: dispatch,
                            node: node,
                            options: {
                                selectNodeInserted: false,
                                analyticsPayload: {
                                    ...analyticsPayload,
                                    attributes: {
                                        ...analyticsPayload.attributes,
                                        localId: node.attrs.localId
                                    }
                                }
                            }
                        }) ?? false;
                    }
                }
        },
        commands: {
            insertTableWithSize: (rowsCount, colsCount, inputMethod)=>(0, $6921de1f1a31eb9c$export$b57b177fe1ab7f1f)({
                    isTableScalingEnabled: options?.isTableScalingEnabled,
                    isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                    isFullWidthModeEnabled: options?.fullWidthEnabled,
                    isMaxWidthModeEnabled: options?.maxWidthEnabled,
                    isCommentEditor: options?.isCommentEditor,
                    isChromelessEditor: options?.isChromelessEditor,
                    isTableResizingEnabled: options?.tableOptions.allowTableResizing,
                    createTableProps: {
                        rowsCount: rowsCount,
                        colsCount: colsCount
                    }
                }, api, {
                    action: (0, $d925B.ACTION).INSERTED,
                    actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: inputMethod ?? (0, $d925B.INPUT_METHOD).PICKER,
                        totalRowCount: rowsCount,
                        totalColumnCount: colsCount
                    },
                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                })
        },
        nodes () {
            const { allowColumnResizing: allowColumnResizing } = (0, $46b4a5487442d4d4$export$c23fbabe48bd9130)(options?.tableOptions);
            // TODO: ED-25901 - We need to move this into a plugin config option so we don't accidentally enable nested nodes in Jira
            const isNestingSupported = Boolean(options?.tableOptions?.allowNestedTables);
            const isTableFixedColumnWidthsOptionEnabled = ((0, $dh538.fg)('platform_editor_table_fixed_column_width_prop') ? options?.allowFixedColumnWidthOption : options?.getEditorFeatureFlags?.().tableWithFixedColumnWidthsOption) || false;
            const shouldUseIncreasedScalingPercent = options?.isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
            options?.isCommentEditor);
            const isTableScalingEnabled = options?.isTableScalingEnabled;
            const isCommentEditor = options?.isCommentEditor;
            const isChromelessEditor = options?.isChromelessEditor;
            return isNestingSupported ? [
                {
                    name: 'table',
                    node: (0, $da7b34fe5d676606$export$477bb32cbededd65)({
                        allowColumnResizing: Boolean(allowColumnResizing),
                        tableResizingEnabled: Boolean(options?.tableOptions.allowTableResizing),
                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                        isNestingSupported: isNestingSupported,
                        isTableScalingEnabled: isTableScalingEnabled,
                        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                        isCommentEditor: isCommentEditor,
                        isChromelessEditor: isChromelessEditor
                    })
                },
                {
                    name: 'tableHeader',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $63Ztt.tableHeaderWithNestedTableWithLocalId) : (0, $63Ztt.tableHeaderWithNestedTable)
                },
                {
                    name: 'tableRow',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $63Ztt.tableRowWithNestedTableWithLocalId) : (0, $63Ztt.tableRowWithNestedTable)
                },
                {
                    name: 'tableCell',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $63Ztt.tableCellWithNestedTableWithLocalId) : (0, $63Ztt.tableCellWithNestedTable)
                }
            ] : [
                {
                    name: 'table',
                    node: (0, $da7b34fe5d676606$export$477bb32cbededd65)({
                        allowColumnResizing: Boolean(allowColumnResizing),
                        tableResizingEnabled: Boolean(options?.tableOptions.allowTableResizing),
                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                        isNestingSupported: isNestingSupported,
                        isTableScalingEnabled: isTableScalingEnabled,
                        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                        isCommentEditor: isCommentEditor,
                        isChromelessEditor: isChromelessEditor
                    })
                },
                {
                    name: 'tableHeader',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $63Ztt.tableHeaderWithLocalId) : (0, $63Ztt.tableHeader)
                },
                {
                    name: 'tableRow',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $63Ztt.tableRowWithLocalId) : (0, $63Ztt.tableRow)
                },
                {
                    name: 'tableCell',
                    node: (0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $63Ztt.tableCellWithLocalId) : (0, $63Ztt.tableCell)
                }
            ];
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'table',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch, portalProviderAPI: portalProviderAPI, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>{
                        const { fullWidthEnabled: fullWidthEnabled, wasFullWidthEnabled: wasFullWidthEnabled, tableOptions: tableOptions, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor } = options || {};
                        return (0, $acc346d62149cd5a$export$ae829ec7b2625219)(dispatchAnalyticsEvent, dispatch, portalProviderAPI, nodeViewPortalProviderAPI, eventDispatcher, (0, $46b4a5487442d4d4$export$c23fbabe48bd9130)(tableOptions), defaultGetEditorContainerWidth, getEditorFeatureFlags || $b21157aa04a7535c$var$defaultGetEditorFeatureFlags, getIntl, fullWidthEnabled, wasFullWidthEnabled, editorAnalyticsAPI, api, isTableScalingEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, options?.allowFixedColumnWidthOption);
                    }
                },
                {
                    name: 'tablePMColResizing',
                    plugin: ({ dispatch: dispatch, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const { fullWidthEnabled: fullWidthEnabled, tableOptions: tableOptions, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled } = options || {};
                        const { allowColumnResizing: allowColumnResizing } = (0, $46b4a5487442d4d4$export$c23fbabe48bd9130)(tableOptions);
                        return allowColumnResizing ? (0, $b3a746dda27eb371$export$ae829ec7b2625219)(dispatch, {
                            lastColumnResizable: !fullWidthEnabled
                        }, defaultGetEditorContainerWidth, getEditorFeatureFlags || $b21157aa04a7535c$var$defaultGetEditorFeatureFlags, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled || false, !!options?.isCommentEditor) : undefined;
                    }
                },
                {
                    name: 'tableEditing',
                    plugin: ()=>(0, $de8398c45f744acc$export$ae829ec7b2625219)()
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing backspace events inside tables
                {
                    name: 'tableKeymap',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const { isTableScalingEnabled: isTableScalingEnabled = false, fullWidthEnabled: fullWidthEnabled = false, isCommentEditor: isCommentEditor = false, isChromelessEditor: isChromelessEditor = false, tableOptions: tableOptions } = options || {};
                        return (0, $7b84646b01762248$export$e832373cff8dec22)(defaultGetEditorContainerWidth, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled, tableOptions?.allowTableAlignment, fullWidthEnabled, api, getIntl, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, tableOptions?.allowTableResizing);
                    }
                },
                {
                    name: 'tableSelectionKeymap',
                    plugin: ({ getIntl: getIntl })=>(0, $493109f8baa484ba$export$21439b5bf6b9c77f)(api, getIntl)
                },
                {
                    name: 'tableEditing',
                    plugin: ()=>{
                        return (0, $4bda0cf32d3d9590$export$e382fe3f780a6548)({
                            reportFixedTable: ({ tr: tr, reason: reason })=>{
                                editorAnalyticsAPI?.attachAnalyticsEvent({
                                    action: (0, $3824I.TABLE_ACTION).FIXED,
                                    actionSubject: (0, $d925B.ACTION_SUBJECT).TABLE,
                                    actionSubjectId: null,
                                    attributes: {
                                        reason: reason
                                    },
                                    eventType: (0, $d925B.EVENT_TYPE).TRACK
                                })(tr);
                            }
                        });
                    }
                },
                {
                    name: 'tableStickyHeaders',
                    plugin: ({ dispatch: dispatch })=>options && options.tableOptions.stickyHeaders ? (0, $def0041f08b1347a$export$ae829ec7b2625219)(dispatch, ()=>[]) : undefined
                },
                {
                    name: 'tableDragAndDrop',
                    plugin: ({ dispatch: dispatch })=>{
                        return (0, $58c44b411bfbf733$export$ae829ec7b2625219)(dispatch, editorAnalyticsAPI, options?.isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, options.isCommentEditor, api);
                    }
                },
                {
                    name: 'tableViewModeSort',
                    plugin: ({ nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return api?.editorViewMode ? (0, $236c7224c8ab51a2$export$ae829ec7b2625219)(api, nodeViewPortalProviderAPI) : undefined;
                    }
                },
                {
                    name: 'tableLocalId',
                    plugin: ({ dispatch: dispatch })=>!(0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $d5b05171647091ac$export$ae829ec7b2625219)(dispatch) : undefined
                },
                {
                    name: 'tableWidth',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch })=>options?.tableOptions.allowTableResizing ? (0, $e9b9e23609860f66$export$ae829ec7b2625219)(dispatch, dispatchAnalyticsEvent, options.fullWidthEnabled ?? false, options.maxWidthEnabled ?? false, options.isTableScalingEnabled ?? false, options.tableOptions.allowTableResizing ?? false, options.isCommentEditor ?? false) : undefined
                },
                {
                    name: 'tableWidthInCommentFix',
                    plugin: ({ dispatch: dispatch })=>options?.tableOptions.allowTableResizing && options?.isCommentEditor ? (0, $0a5bcf7050b8ed19$export$ae829ec7b2625219)(dispatch, options.tableOptions.allowTableAlignment ?? false) : undefined
                },
                // TODO: ED-26961 - should be deprecated and eventually replaced with 'tableAnalyticsPlugin'
                {
                    name: 'tableOverflowAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $92e1eed7d2f10a77$export$ae829ec7b2625219)(dispatch, dispatchAnalyticsEvent, options?.tableOptions.allowTableResizing ?? false)
                },
                {
                    name: 'tableAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $5ee9558e2724a8ab$export$ae829ec7b2625219)(dispatch, dispatchAnalyticsEvent)
                },
                {
                    name: 'tableGetEditorViewReferencePlugin',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                        return new (0, $1S4f7.SafePlugin)({
                            view: (editorView)=>{
                                editorViewRef.current = editorView;
                                let rafID;
                                let ricID;
                                // send statistics about the widths of the tables on the page for alerting
                                // only send this event once, after the editorView is first initialised
                                const setTimeoutID = setTimeout(()=>{
                                    const requestIdleCallbackFn = ()=>{
                                        const editorWidth = api?.width.sharedState.currentState()?.width;
                                        if (editorViewRef.current) {
                                            if (editorWidth) {
                                                const payload = (0, $d406f1b0c5d56902$export$208d2421b73f3f86)(editorViewRef.current, editorWidth);
                                                if (payload) dispatchAnalyticsEvent(payload);
                                            }
                                            if ((0, $dh538.fg)('platform_editor_table_height_analytics_event')) {
                                                const payloadHeight = (0, $d406f1b0c5d56902$export$34e5b28c67455a81)(editorViewRef.current);
                                                if (payloadHeight) dispatchAnalyticsEvent(payloadHeight);
                                            }
                                        }
                                    };
                                    if (window && typeof window.requestIdleCallback === 'function') ricID = window.requestIdleCallback(requestIdleCallbackFn);
                                    else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                                    rafID = window.requestAnimationFrame(requestIdleCallbackFn);
                                }, $b21157aa04a7535c$var$TABLE_WIDTH_INFO_TIMEOUT);
                                return {
                                    destroy: ()=>{
                                        editorViewRef.current = null;
                                        if (setTimeoutID) clearTimeout(setTimeoutID);
                                        if (rafID) window.cancelAnimationFrame(rafID);
                                        if (ricID) window.cancelIdleCallback(ricID);
                                    }
                                };
                            }
                        });
                    }
                },
                {
                    name: 'tableSizeSelectorPlugin',
                    plugin: ({ dispatch: dispatch })=>isTableSelectorEnabled ? (0, $030f86662bf3c0ad$export$ae829ec7b2625219)(dispatch) : undefined
                },
                {
                    name: 'editorContentAreaHeightPlugin',
                    plugin: ()=>(0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_1') ? (0, $c80e8922e1b59353$export$ae829ec7b2625219)() : undefined
                }
            ];
            if (!(0, $1oCLl.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) && (0, $1oCLl.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $dh538.fg)('platform_editor_table_sticky_header_patch_2')) plugins.push({
                name: 'tableAnchorNames',
                plugin: ()=>(0, $8a4fbf3fe4f0ae86$export$ae829ec7b2625219)()
            });
            const browser = (0, $d7ZU3.getBrowserInfo)();
            // Workaround for table element breaking issue caused by composition event with an inputType of deleteCompositionText.
            // https://github.com/ProseMirror/prosemirror/issues/934
            if (browser.safari) plugins.push({
                name: 'tableSafariDeleteCompositionTextIssueWorkaround',
                plugin: ()=>{
                    return (0, $d6be50079e9249c7$export$ae829ec7b2625219)();
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $9a7d1b7fff538a30$export$2dda1e4a1d1f6a81), {
                api: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                options: options,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                defaultGetEditorContainerWidth: defaultGetEditorContainerWidth,
                defaultGetEditorFeatureFlags: $b21157aa04a7535c$var$defaultGetEditorFeatureFlags,
                isTableSelectorEnabled: isTableSelectorEnabled
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'table',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).table),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).tableDescription),
                        keywords: [
                            'cell',
                            'table'
                        ],
                        priority: 600,
                        keyshortcut: (0, $hgeg8.tooltip)((0, $hgeg8.toggleTable)),
                        icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $cQMhV.IconTable), {}),
                        action (insert, state) {
                            if (isTableSelectorEnabled) {
                                const tr = insert('');
                                tr.setMeta((0, $030f86662bf3c0ad$export$18d4026d1ea86bb1), {
                                    isSelectorOpen: true
                                });
                                return tr;
                            }
                            // see comment on tablesPlugin.getSharedState on usage
                            const tableState = api?.table?.sharedState.currentState();
                            const tableNodeProps = {
                                isTableScalingEnabled: options?.isTableScalingEnabled,
                                isTableAlignmentEnabled: options?.tableOptions.allowTableAlignment,
                                isFullWidthModeEnabled: tableState?.isFullWidthModeEnabled,
                                isMaxWidthModeEnabled: tableState?.isMaxWidthModeEnabled,
                                isCommentEditor: options?.isCommentEditor,
                                isChromelessEditor: options?.isChromelessEditor,
                                isTableResizingEnabled: options?.tableOptions.allowTableResizing
                            };
                            let tableNode = (0, $93be038868ed0558$export$5003ecb973fc11c2)(tableNodeProps)(state.schema);
                            let { tr: tr } = state;
                            // If the cursor is inside a table
                            if ((0, $8m4tT.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) && options?.tableOptions?.allowNestedTables) {
                                // If trying to nest deeper than one level, we insert the table after the top table
                                if ((0, $sxTNo.getParentOfTypeCount)(state.schema.nodes.table)(state.selection.$from) > 1) {
                                    // Nesting is too deep insert table after the top parent table
                                    const positionAfterTopTable = (0, $sxTNo.getPositionAfterTopParentNodeOfType)(state.schema.nodes.table)(state.selection.$from);
                                    tr = (0, $8m4tT.safeInsert)(tableNode, positionAfterTopTable)(tr);
                                    tr.scrollIntoView();
                                } else {
                                    // Table can be nested in parent table
                                    tableNode = (0, $93be038868ed0558$export$5003ecb973fc11c2)({
                                        ...tableNodeProps,
                                        isNestedTable: true
                                    })(state.schema);
                                    tr = insert(tableNode);
                                }
                            } else tr = insert(tableNode);
                            editorAnalyticsAPI?.attachAnalyticsEvent({
                                action: (0, $d925B.ACTION).INSERTED,
                                actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).TABLE,
                                attributes: {
                                    inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                                    localId: tableNode.attrs.localId
                                },
                                eventType: (0, $d925B.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ],
            floatingToolbar: (0, $b9cb78eca8ad2cf1$export$86ce8f8241c20a3)(defaultGetEditorContainerWidth, api, editorAnalyticsAPI, ()=>editorViewRef.current, options, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $46b4a5487442d4d4$export$c23fbabe48bd9130)(options?.tableOptions))
        },
        usePluginHook ({ editorView: editorView }) {
            const { mode: mode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
                'editorViewMode'
            ], (states)=>({
                    mode: states.editorViewModeState?.mode
                }));
            (0, $42omo.useEffect)(()=>{
                const { state: state, dispatch: dispatch } = editorView;
                const tr = state.tr;
                tr.setMeta('viewModeState', mode);
                if (dispatch) dispatch(tr);
            }, [
                editorView,
                mode
            ]);
        }
    };
};
var $b21157aa04a7535c$export$2e2bcd8739ae039 = $b21157aa04a7535c$var$tablePlugin;
module.exports["default"] = $b21157aa04a7535c$export$2e2bcd8739ae039;

});

parcelRegister("kEbNW", function(module, exports) {

var $iu6m9 = parcelRequire("iu6m9");


var $7XFGZ = parcelRequire("7XFGZ");


var $LmqWp = parcelRequire("LmqWp");


var $8usfh = parcelRequire("8usfh");


var $id9O1 = parcelRequire("id9O1");

const $4f55633bb70b189e$var$select = (type)=>(index, expand)=>(tr)=>{
            const table = (0, $id9O1.findTable)(tr.selection);
            const isRowSelection = type === 'row';
            const prevSelection = tr.selection;
            const isPrevRowSelection = !!prevSelection.$anchorCell && !!prevSelection.$headCell;
            if (table) {
                const map = (0, $LmqWp.TableMap).get(table.node);
                // Check if the index is valid
                if (index >= 0 && index < (isRowSelection ? map.height : map.width)) {
                    let left = isRowSelection ? 0 : index;
                    let top = isRowSelection ? index : 0;
                    let right = isRowSelection ? map.width : index + 1;
                    let bottom = isRowSelection ? index + 1 : map.height;
                    let cellsInFirstRow = [];
                    if (expand) {
                        const cell = (0, $id9O1.findCellClosestToPos)(tr.selection.$from);
                        if (!cell) return tr;
                        const selRect = map.findCell(cell.pos - table.start);
                        if (isRowSelection) {
                            top = Math.min(top, selRect.top);
                            bottom = Math.max(bottom, selRect.bottom);
                            cellsInFirstRow = map.cellsInRect({
                                left: left,
                                top: top,
                                right: right,
                                bottom: top + 1
                            });
                            const targetRowCells = map.cellsInRect({
                                left: left,
                                top: index,
                                right: right,
                                bottom: index + 1
                            });
                            const isBackwardSelection = targetRowCells[0] < prevSelection.$head.pos - table.start;
                            if (isBackwardSelection && isPrevRowSelection) {
                                const head = table.start + cellsInFirstRow[0];
                                const anchor = prevSelection.$anchorCell.pos;
                                const $head = tr.doc.resolve(head);
                                const $anchor = tr.doc.resolve(anchor);
                                return (0, $8usfh.cloneTr)(tr.setSelection(new (0, $7XFGZ.CellSelection)($anchor, $head)));
                            }
                        } else {
                            left = Math.min(left, selRect.left);
                            right = Math.max(right, selRect.right);
                            cellsInFirstRow = map.cellsInRect({
                                left: left,
                                top: top,
                                right: left + 1,
                                bottom: bottom
                            });
                            const targetRowCells = map.cellsInRect({
                                left: index,
                                top: top,
                                right: index + 1,
                                bottom: bottom
                            });
                            const isBackwardSelection = targetRowCells[0] < prevSelection.$head.pos - table.start;
                            if (isBackwardSelection && isPrevRowSelection) {
                                const head = table.start + cellsInFirstRow[0];
                                const anchor = prevSelection.$anchorCell.pos;
                                const $head = tr.doc.resolve(head);
                                const $anchor = tr.doc.resolve(anchor);
                                return (0, $8usfh.cloneTr)(tr.setSelection(new (0, $7XFGZ.CellSelection)($anchor, $head)));
                            }
                        }
                    }
                    cellsInFirstRow = map.cellsInRect({
                        left: left,
                        top: top,
                        right: isRowSelection ? right : left + 1,
                        bottom: isRowSelection ? top + 1 : bottom
                    });
                    const cellsInLastRow = bottom - top === 1 ? cellsInFirstRow : map.cellsInRect({
                        left: isRowSelection ? left : right - 1,
                        top: isRowSelection ? bottom - 1 : top,
                        right: right,
                        bottom: bottom
                    });
                    const head = table.start + cellsInFirstRow[0];
                    const anchor = table.start + cellsInLastRow[cellsInLastRow.length - 1];
                    const $head = tr.doc.resolve(head);
                    const $anchor = tr.doc.resolve(anchor);
                    return (0, $8usfh.cloneTr)(tr.setSelection(new (0, $7XFGZ.CellSelection)($anchor, $head)));
                }
            }
            return tr;
        };
const $4f55633bb70b189e$export$c2e8772deb1607ea = $4f55633bb70b189e$var$select('column');
const $4f55633bb70b189e$export$e247ed8cec4832f4 = $4f55633bb70b189e$var$select('row');
const $4f55633bb70b189e$var$selectRowsOrColumns = (type)=>(indexes)=>(tr)=>{
            const table = (0, $id9O1.findTable)(tr.selection);
            if (!table) return tr;
            const map = (0, $LmqWp.TableMap).get(table.node);
            if (!indexes || indexes.length <= 0 || type === 'rows' && Math.max(...indexes) > map.height || type === 'columns' && Math.max(...indexes) > map.width || Math.min(...indexes) < 0) return tr;
            const startCellRect = map.cellsInRect({
                left: type === 'rows' ? 0 : Math.min(...indexes),
                top: type === 'rows' ? Math.min(...indexes) : 0,
                right: type === 'rows' ? map.width : Math.min(...indexes) + 1,
                bottom: type === 'rows' ? Math.min(...indexes) + 1 : 1
            });
            const endCellRect = map.cellsInRect({
                left: type === 'rows' ? map.width - 1 : Math.max(...indexes),
                top: type === 'rows' ? Math.max(...indexes) : map.height - 1,
                right: type === 'rows' ? map.width : Math.max(...indexes) + 1,
                bottom: type === 'rows' ? Math.max(...indexes) + 1 : map.height
            });
            const head = table.start + startCellRect[0];
            const anchor = table.start + endCellRect[endCellRect.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $8usfh.cloneTr)(tr.setSelection(new (0, $7XFGZ.CellSelection)($anchor, $head)));
        };
const $4f55633bb70b189e$export$b5ba3b60192c7a8d = $4f55633bb70b189e$var$selectRowsOrColumns('rows');
const $4f55633bb70b189e$export$41a42e79fbe56d35 = $4f55633bb70b189e$var$selectRowsOrColumns('columns');
const $4f55633bb70b189e$export$625c5b9bf13f01a8 = (tr)=>{
    const table = (0, $id9O1.findTable)(tr.selection);
    if (table) {
        const { map: map } = (0, $LmqWp.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $8usfh.cloneTr)(tr.setSelection(new (0, $7XFGZ.CellSelection)($anchor, $head)));
        }
    }
    return tr;
};
const $4f55633bb70b189e$export$cec96519863940d = ($pos)=>{
    const table = (0, $id9O1.findTableClosestToPos)($pos);
    if (table) {
        const { map: map } = (0, $LmqWp.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = $pos.doc.resolve(head);
            const $anchor = $pos.doc.resolve(anchor);
            return new (0, $7XFGZ.CellSelection)($anchor, $head);
        }
    }
};
const $4f55633bb70b189e$export$3e7c4d16b1cc1be3 = (tr, $pos)=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_block_menu', true, {
        exposure: true
    })) {
        const tableSelection = $4f55633bb70b189e$export$cec96519863940d($pos);
        if (tableSelection) return (0, $8usfh.cloneTr)(tr.setSelection(tableSelection));
        return tr;
    }
    const table = (0, $id9O1.findTableClosestToPos)($pos);
    if (table) {
        const { map: map } = (0, $LmqWp.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $8usfh.cloneTr)(tr.setSelection(new (0, $7XFGZ.CellSelection)($anchor, $head)));
        }
    }
    return tr;
};
module.exports["selectColumn"] = $4f55633bb70b189e$export$c2e8772deb1607ea;
module.exports["selectRow"] = $4f55633bb70b189e$export$e247ed8cec4832f4;
module.exports["selectRows"] = $4f55633bb70b189e$export$b5ba3b60192c7a8d;
module.exports["selectColumns"] = $4f55633bb70b189e$export$41a42e79fbe56d35;
module.exports["selectTable"] = $4f55633bb70b189e$export$625c5b9bf13f01a8;
module.exports["getTableSelectionClosesToPos"] = $4f55633bb70b189e$export$cec96519863940d;
module.exports["selectTableClosestToPos"] = $4f55633bb70b189e$export$3e7c4d16b1cc1be3;

});

parcelRegister("1rJN9", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $cO9ey = parcelRequire("cO9ey");

var $aXG5V = parcelRequire("aXG5V");


var $jl382 = parcelRequire("jl382");

const $d82c222672448203$var$EmptyCellNodeSize = 4;
function $d82c222672448203$var$calculateRowsToSkip(attrs) {
    if (attrs && attrs.rowspan) return attrs.rowspan - 1;
    return 0;
}
function $d82c222672448203$export$1e67a55385d21834(tr, tableRect, cell, cellStep, isDelete, column) {
    // Apply the merge actions,
    if (cellStep.mergeWith !== undefined) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const cellNode = tr.doc.nodeAt(tr.mapping.map(cellStep.mergeWith));
        const columns = column - tableRect.map.colCount(cellStep.mergeWith - tableRect.tableStart);
        const cellAttrs = isDelete ? (0, $jl382.removeColSpan)(cellNode.attrs, columns) : (0, $jl382.addColSpan)(cellNode.attrs, columns);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (cellAttrs.colspan > 0) {
            // When colspan is 0 should remove the cell
            tr.setNodeMarkup(tr.mapping.map(cellStep.mergeWith), undefined, cellAttrs);
            return {
                tr: tr,
                skipRows: $d82c222672448203$var$calculateRowsToSkip(cellAttrs),
                cellStep: cellStep
            };
        }
        // When the new colspan is 0, I need to change the operation to a delete operation
        // Update cellStep with the proper data
        cellStep.from = cellStep.mergeWith;
        cellStep.to = cellStep.from + cellNode.nodeSize;
        cellStep.mergeWith = undefined;
    }
    let skipRows = 0;
    // Modify temporary document
    if (isDelete) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const cellNode = tr.doc.nodeAt(tr.mapping.map(cellStep.from));
        skipRows = $d82c222672448203$var$calculateRowsToSkip(cellNode.attrs);
        tr.delete(tr.mapping.map(cellStep.from), tr.mapping.map(cellStep.to));
    } else if (cellStep.newCell) {
        tr.insert(tr.mapping.map(cellStep.from), cellStep.newCell);
        skipRows = $d82c222672448203$var$calculateRowsToSkip(cellStep.newCell.attrs);
    } else // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    tr.insert(tr.mapping.map(cellStep.from), cell.type.createAndFill());
    return {
        tr: tr,
        skipRows: skipRows,
        cellStep: cellStep
    };
}
function $d82c222672448203$export$13a5db78deedf2bc(cellStep, isDelete) {
    if (cellStep.mergeWith !== undefined) return [
        cellStep.mergeWith,
        1,
        1
    ];
    if (isDelete) return [
        cellStep.from,
        cellStep.to - cellStep.from,
        0
    ];
    else {
        if (cellStep.newCell) return [
            cellStep.from,
            0,
            cellStep.newCell.nodeSize
        ];
        return [
            cellStep.from,
            0,
            $d82c222672448203$var$EmptyCellNodeSize
        ];
    }
}
/**
 * Helper to calculate the offset of the inverted cells.
 * When you delete consecutive rows in a single step, the position in the generated document
 *  are skipped by the all the changes except your own. (StepMap.map is not valid)
 * @param map
 * @param cellStep
 * @param isDelete
 */ function $d82c222672448203$var$getOffset(map, cellStep, isDelete) {
    if (isDelete) return map.map(cellStep.from) - cellStep.from;
    const [, oldSize, newSize] = $d82c222672448203$export$13a5db78deedf2bc(cellStep, isDelete);
    return map.map(cellStep.from) - cellStep.from - (newSize - oldSize);
}
function $d82c222672448203$export$1238fc51d97634a(doc, getTableRectAndColumn, cellStep, isDelete, stepMap) {
    /**
	 * We need a correct map when a cell is added
	 * We need the normal map position minus the size of the cell you added it. Why?
	 * Having a table 3x3 and we add a new column at 2 creates this ranges
	 * [
	 *  10, 0, 4,
	 *  20, 0, 4,
	 *  30, 0, 4,
	 *  ]
	 *  Where:
	 *    * [10, 20, 30] are the original cell positions where we add the cells
	 *    * [0, 0, 0] are the old size. We are adding new cells, so it's always zero
	 *    * [4, 4, 4] are the new size. In this case, we are adding empty cell and has size 4, this will be different for prefill cells.
	 *  In the document generated the cells that I want to delete (if I invert this step) are [10, 24, 38]
	 *  this is calculated in the given way
	 *    * Map the position using this step mapping function, this will return the cell in the next column
	 *    * Remove the diff (4 - 0 in this case) of the current position.
	 *  For a delete action this not happen, it will always return the right value
	 */ const offset = $d82c222672448203$var$getOffset(stepMap, cellStep, isDelete);
    const newCellStepInfo = {
        ...cellStep,
        // Map the position to position of the generated document
        from: cellStep.from + offset,
        to: cellStep.to + offset
    };
    if (cellStep.mergeWith !== undefined) newCellStepInfo.mergeWith = cellStep.mergeWith + offset;
    if (isDelete) {
        // Add the removed cell as the new cell of the inverted step
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const removedCell = doc.nodeAt(cellStep.from);
        newCellStepInfo.newCell = removedCell.copy(removedCell.content);
        // When we delete a column we can end in a position that doesnt represent the right column.
        // This only happens on merged cell that ends in the deleted column.
        // We need to remap this position to the "next" cell (AKA cellStep.to)
        const { column: column, rect: rect } = getTableRectAndColumn();
        if (column < rect.map.width) {
            const isAtTheEnd = rect.map.colCount(cellStep.from - rect.tableStart) + removedCell.attrs.colspan - 1 === column;
            if (cellStep.mergeWith !== undefined && isAtTheEnd) {
                newCellStepInfo.mergeWith = newCellStepInfo.from;
                newCellStepInfo.from = newCellStepInfo.to;
            }
        }
    }
    return newCellStepInfo;
}
function $d82c222672448203$export$e2625d4b6ce2d04b(cell, column, isDelete, previousCellStep) {
    const newCellStepInfo = {
        from: cell.from,
        to: cell.to
    };
    if (cell.hasMergedCells) // Check what column has to merge
    {
        if (column !== cell.col || isDelete) newCellStepInfo.mergeWith = cell.from;
    }
    if (previousCellStep) {
        if (previousCellStep.mergeWith !== undefined) newCellStepInfo.mergeWith = previousCellStep.mergeWith;
        if (previousCellStep.newCell) newCellStepInfo.newCell = previousCellStep.newCell;
    }
    return newCellStepInfo;
}



var $9b9Mr = parcelRequire("9b9Mr");

var $d1kIV = parcelRequire("d1kIV");

const $bbff9d1592bf1369$export$858eb3bd69719bea = (map, row, col)=>{
    return row * map.width + col;
};
function $bbff9d1592bf1369$export$9854dd07bd861449(map, row, col) {
    const index = $bbff9d1592bf1369$export$858eb3bd69719bea(map, row, col);
    return col > 0 && map.map[index - 1] === map.map[index] || col < map.width - 1 && map.map[index + 1] === map.map[index];
}
function $bbff9d1592bf1369$export$b17f150b6103459c(map, row, col) {
    const index = $bbff9d1592bf1369$export$858eb3bd69719bea(map, row, col);
    return row > 0 && map.map[index - map.width] !== map.map[index] || row < map.height - 1 && map.map[index + map.width] === map.map[index];
}
function $bbff9d1592bf1369$export$8575677d782d45d2(map, row, col) {
    const index = $bbff9d1592bf1369$export$858eb3bd69719bea(map, row, col);
    return row > 0 ? map.map[index - map.width] !== map.map[index] : true;
}
function $bbff9d1592bf1369$export$d119febc0282b034(map, row, col) {
    const index = $bbff9d1592bf1369$export$858eb3bd69719bea(map, row, col);
    return row > 0 ? map.map[index - 1] !== map.map[index] : true;
}


function* $195310467a879139$export$7ca27240fa9450d9(rect, col) {
    const { map: map, tableStart: tableStart, table: table } = rect;
    let refColumn = col > 0 ? -1 : 0;
    if ((0, $9b9Mr.columnIsHeader)(map, table, col + refColumn)) refColumn = col === 0 || col === map.width ? null : 0;
    for(let row = 0; row < map.height; row++){
        const index = (0, $bbff9d1592bf1369$export$858eb3bd69719bea)(rect.map, row, col);
        let pos = map.map[index];
        // We only consider to has merged cell to the first cell in a rowspan.
        const hasMergedCells = (0, $bbff9d1592bf1369$export$9854dd07bd861449)(rect.map, row, col) && (0, $bbff9d1592bf1369$export$8575677d782d45d2)(rect.map, row, col);
        // If this position falls inside a col-spanning cell
        const type = refColumn == null ? (0, $d1kIV.tableNodeTypes)(table.type.schema).cell : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        table.nodeAt(map.map[index + refColumn]).type;
        if (!hasMergedCells) pos = map.positionAt(row, col, table);
        const cell = table.nodeAt(pos);
        const cellInfo = {
            from: tableStart + pos,
            to: tableStart + pos,
            row: row,
            col: hasMergedCells ? map.colCount(pos) : col,
            type: type,
            hasMergedCells: hasMergedCells
        };
        if (cell) {
            cellInfo.attrs = cell.attrs;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            cellInfo.to = tableStart + pos + cell.nodeSize;
        }
        // We let the consumer to pass the rows that we want to skip
        const skippedRows = yield cellInfo;
        if (skippedRows && skippedRows > 0) row += skippedRows;
    }
}


function $3db3f34a32e2ec72$export$718b3d71c384ca05(columnInfo, rect) {
    /**
	 * Algorithm explained
	 * Given a table like this:
	 *    | 5  | 10      |
	 *    | 15      | 20 |
	 *    | 25 | 30 | 35 |
	 * Represented by a table map like this:
	 *   rect.map = [5, 10, 10,
	 *              15, 15, 20,
	 *              25, 30, 35]
	 * And a have this inputs:
	 *   columnInfo[].from = [10, 15, 30]
	 *
	 * Algorithm:
	 *    * Initial state
	 *      start = 0;
	 *      end = 2 (rect.width - 1 === 3 - 1)
	 *    * Iterate until find first cell position
	 *      start = 1
	 *      end = 2 (min(start column + colspan - 1, start column + end column))
	 *    * Iterate until find second cell position
	 *      start = 1
	 *      end = 1
	 *    * Start === end return 1
	 */ // Initial range (start and end column) to search for each row
    let [start, end] = [
        0,
        rect.map.width - 1
    ];
    const iter = columnInfo.values();
    let next = iter.next();
    // Iterate for each row
    for(let row = 0; row < rect.map.height; row++){
        if (next.done) break;
        // Iterate for the column. Starting with the current start range
        for(let col = start; col <= end; col++){
            const i = row * rect.map.width + col;
            const cell = rect.map.map[i];
            const cellInfo = next.value.from - rect.tableStart;
            // When cell is found update range with the new values
            if (cell === cellInfo) {
                start = col; // Start column will be the current column
                // Try to find the end column. End column will be different that start when has merged cells.
                const endIndex = end - start + i;
                for(let j = i; j <= endIndex; j++){
                    if (rect.map.map[j] !== cell) break;
                    // merged columns
                    end = start + j - i; // Update the end column with the new position
                }
                if (start === end) // We found the right column only when start and end columns are the same.
                return start;
                next = iter.next();
                break;
            }
            // Sometimes I want to find a column at the end of the table (It doesn't exist, but we can add a new cell there).
            // This is represented by the end position of the last cell in the column.
            // In this case return, table width
            if (col === rect.map.width - 1) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const cellNode = rect.table.nodeAt(cell);
                if (cell + cellNode.nodeSize === cellInfo) return rect.map.width;
            }
        }
    }
    return null;
}



var $LmqWp = parcelRequire("LmqWp");

function $3dbecde1498474fb$export$7a7f743a3e044584(doc, tablePos) {
    const table = doc.nodeAt(tablePos);
    // Check for table existence
    if (!table || table.type.name !== 'table') throw new Error(`No table at position "${tablePos}".`);
    // Create transform base on the doc
    const map = (0, $LmqWp.TableMap).get(table);
    const $table = doc.resolve(tablePos);
    // Nested tables start position might differ from the original position
    const start = $table.start($table.depth + 1);
    return {
        map: map,
        table: table,
        tableStart: start,
        // Default to zero
        bottom: 0,
        left: 0,
        right: 0,
        top: 0
    };
}



function $cc7957949c13c5ad$var$mergedRanges(first, second) {
    const newRanges = [];
    const firstLength = first.length;
    const secondLength = second.length;
    let i = 0;
    let j = 0;
    while(i < firstLength && j < secondLength)if (first[i] < second[j]) {
        newRanges.push(first[i], first[i + 1], first[i + 2]);
        i += 3;
    } else {
        newRanges.push(second[j], second[j + 1], second[j + 2]);
        j += 3;
    }
    if (i < firstLength) newRanges.push(...first.slice(i));
    if (j < secondLength) newRanges.push(...second.slice(i));
    return newRanges;
}
function $cc7957949c13c5ad$var$increaseRowSpan(tr, rect, row) {
    const { map: map, tableStart: tableStart } = rect;
    for(let col = 0; col < map.width; col++){
        const index = row * map.width + col;
        const pos = map.map[index];
        const mappedPos = tr.mapping.map(pos + tableStart);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const attrs = tr.doc.nodeAt(mappedPos).attrs;
        tr.setNodeMarkup(mappedPos, undefined, {
            ...attrs,
            rowspan: attrs.rowspan + 1
        });
        col += attrs.colspan - 1;
    }
}
function $cc7957949c13c5ad$var$decreaseRowspan(tr, rect, row, colToRemove) {
    let skipRows = 0;
    const { map: map, table: table, tableStart: tableStart } = rect;
    for(let col = 0; col < map.width; col++){
        const index = row * map.width + col;
        const pos = map.map[index];
        if (row > 0 && pos === map.map[index - map.width]) {
            // If this cell starts in the row above, simply reduce its rowspan
            const mappedPos = tr.mapping.map(pos + tableStart);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const attrs = tr.doc.nodeAt(mappedPos).attrs;
            tr.setNodeMarkup(mappedPos, undefined, {
                ...attrs,
                rowspan: attrs.rowspan - 1
            });
            col += attrs.colspan - 1;
        } else if (col === colToRemove) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        skipRows = table.nodeAt(pos).attrs.rowspan - 1;
    }
    return skipRows;
}
function $cc7957949c13c5ad$var$isLastCellInRow(rect, row, col) {
    const rowNode = rect.table.child(row);
    if (!rowNode) return false;
    return rowNode.childCount === 1 && !(0, $bbff9d1592bf1369$export$9854dd07bd861449)(rect.map, row, col);
}
function $cc7957949c13c5ad$var$removeRowWithLastCell(tr, rect, row, _col) {
    // Get row pos
    let from = rect.tableStart;
    for(let i = 0; i < row; i++)from += rect.table.child(i).nodeSize;
    const rowNode = rect.table.child(row);
    const to = from + rowNode.nodeSize;
    // Create sideEffect and delete the row
    // We store original row position before modifications
    tr.delete(tr.mapping.map(from), tr.mapping.map(to));
    // Change rowspan of all cells except current col and get the rows to skip
    const skipRows = $cc7957949c13c5ad$var$decreaseRowspan(tr, rect, row, _col);
    return {
        skipRows: skipRows,
        row: {
            from: from,
            to: to,
            rowNode: rowNode.copy(rowNode.content)
        }
    };
}
function $cc7957949c13c5ad$var$addRow(tr, rect, prevRow, rowSideEffect) {
    const cellNode = rowSideEffect.rowNode.child(0);
    tr.insert(tr.mapping.map(rowSideEffect.from), rowSideEffect.rowNode);
    $cc7957949c13c5ad$var$increaseRowSpan(tr, rect, prevRow);
    return cellNode.attrs.rowspan - 1;
}
class $cc7957949c13c5ad$export$6a87112aa04a9486 {
    start(isDelete) {
        if (isDelete) return this.deleteHandler();
        return this.addHandler();
    }
    addRowRanges(ranges, isDelete) {
        if (!this.rows) return ranges;
        const rowRanges = [];
        for (const row of this.rows){
            const { from: from, to: to } = row;
            if (isDelete) rowRanges.push(from, to - from, 0);
            else rowRanges.push(from, 0, to - from);
        }
        // Merged ranges
        return $cc7957949c13c5ad$var$mergedRanges(ranges, rowRanges);
    }
    map(_mapping) {
        return [];
    }
    invert(_originalDoc, isDelete, map) {
        if (!this.rows) return;
        const invertedRows = [];
        for (const row of this.rows)if (isDelete) {
            // Moving from delete to add keep the inverted rows + offset
            const offset = map.map(row.from) - row.from;
            invertedRows.push({
                ...row,
                from: row.from + offset,
                to: row.from + offset
            });
        }
        return invertedRows;
    }
    toJSON() {
        if (!this.rows) return;
        const rowsInJson = [];
        for (const row of this.rows)rowsInJson.push({
            from: row.from,
            to: row.to,
            rowNode: row.rowNode.toJSON()
        });
        return rowsInJson;
    }
    static fromJSON(schema, json) {
        const rowSideEffects = [];
        for (const row of json)rowSideEffects.push({
            from: row.from,
            to: row.to,
            rowNode: schema.nodeFromJSON(row.rowNode)
        });
        return rowSideEffects;
    }
    constructor(rowsSideEffect){
        this.rows = void 0;
        this.deleteHandler = ()=>{
            const newRows = [];
            return {
                handle: (tr, rect, row, col, _cell)=>{
                    if (!$cc7957949c13c5ad$var$isLastCellInRow(rect, row, col)) return {
                        handled: false
                    };
                    const { row: rowSideEffect, skipRows: skipRows } = $cc7957949c13c5ad$var$removeRowWithLastCell(tr, rect, row, col);
                    newRows.push(rowSideEffect);
                    return {
                        handled: true,
                        skipRows: skipRows
                    };
                },
                end: ()=>{
                    if (newRows.length > 0) this.rows = newRows;
                    else this.rows = undefined;
                }
            };
        };
        this.addHandler = ()=>{
            let lastCellFrom = 0;
            let i = 0;
            return {
                handle: (tr, rect, row, _col, cell)=>{
                    // // If not sideEffects stored return;
                    if (!this.rows || i >= this.rows.length) return {
                        handled: false
                    };
                    // Next row to add;
                    let skipRows;
                    let nextRow;
                    while(// Ignored via go/ees005
                    // eslint-disable-next-line no-cond-assign
                    (nextRow = this.rows[i]) && nextRow.from > lastCellFrom && nextRow.from < cell.from){
                        // I am in between of the previous and next row in the table;
                        skipRows = $cc7957949c13c5ad$var$addRow(tr, rect, row - 1, nextRow);
                        i++;
                    }
                    lastCellFrom = cell.from;
                    if (!skipRows || skipRows === 0) return {
                        handled: false
                    };
                    return {
                        handled: true,
                        skipRows: skipRows - 1
                    };
                },
                end: (tr, rect, _col)=>{
                    if (!this.rows || i >= this.rows.length) return;
                    // Add rows at the end of the table
                    let nextRow;
                    // Ignored via go/ees005
                    // eslint-disable-next-line no-cond-assign
                    while(nextRow = this.rows[i]){
                        $cc7957949c13c5ad$var$addRow(tr, rect, rect.map.height - 1, nextRow);
                        i++;
                    }
                }
            };
        };
        this.rows = rowsSideEffect;
    }
}





class $9ba2978c7534d8fc$export$9d510b823609a5ac {
    addTableSideEffect(from, to, node) {
        this.table = {
            from: from,
            to: to,
            node: node
        };
    }
    handleAddTable(tr, isDelete) {
        if (isDelete || !this.table) return false;
        tr.insert(this.table.from, this.table.node);
        return true;
    }
    handleRemoveTable(tr, tablePos, tableRect, column, isDelete) {
        if (isDelete && tableRect.map.width === 1 && column === 0) {
            // Add side effect
            this.addTableSideEffect(tablePos, tablePos + tableRect.table.nodeSize, tableRect.table.copy(tableRect.table.content));
            tr.delete(tablePos, tablePos + tableRect.table.nodeSize);
            return true;
        }
        return false;
    }
    getTableMap(isDelete) {
        if (!this.table) return;
        const { from: from, to: to } = this.table;
        if (isDelete) return new (0, $aXG5V.StepMap)([
            from,
            to - from,
            0
        ]);
        return new (0, $aXG5V.StepMap)([
            from,
            0,
            to - from
        ]);
    }
    map(mapping) {
        if (!this.table) return;
        return {
            from: mapping.map(this.table.from),
            to: mapping.map(this.table.to),
            node: this.table.node
        };
    }
    invert(doc) {
        if (!this.table) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const tableNode = doc.nodeAt(this.table.from);
        return {
            from: this.table.from,
            to: this.table.from + tableNode.nodeSize,
            node: tableNode.copy(tableNode.content)
        };
    }
    toJSON() {
        if (!this.table) return;
        return {
            from: this.table.from,
            to: this.table.to,
            node: this.table.node.toJSON()
        };
    }
    static fromJSON(schema, json) {
        return {
            from: json.from,
            to: json.to,
            node: schema.nodeFromJSON(json.node)
        };
    }
    constructor(tableSideEffect){
        this.table = void 0;
        if (tableSideEffect) this.table = tableSideEffect;
    }
}


class $faf5e1e5acefbc28$export$2e0f8a284a2635ac {
    getTableMap(isDelete) {
        return this.table.getTableMap(isDelete);
    }
    map(mapping) {
        const sideEffects = {};
        const tableSideEffect = this.table.map(mapping);
        const rowsSideEffect = this.rows.map(mapping);
        if (tableSideEffect) sideEffects.table = tableSideEffect;
        if (rowsSideEffect) sideEffects.rows = rowsSideEffect;
        return sideEffects;
    }
    invert(originalDoc, isDelete, map) {
        const sideEffects = {};
        const tableSideEffect = this.table.invert(originalDoc);
        if (tableSideEffect) sideEffects.table = tableSideEffect;
        const rowsSideEffect = this.rows.invert(originalDoc, isDelete, map);
        if (rowsSideEffect) sideEffects.rows = rowsSideEffect;
        return sideEffects;
    }
    toJSON() {
        const tableSideEffectJson = this.table.toJSON();
        const rowsSideEffectJson = this.rows.toJSON();
        if (!tableSideEffectJson && !rowsSideEffectJson) return;
        const sideEffectsJSON = {};
        if (tableSideEffectJson) sideEffectsJSON.table = tableSideEffectJson;
        if (rowsSideEffectJson) sideEffectsJSON.rows = rowsSideEffectJson;
        return sideEffectsJSON;
    }
    static fromJSON(schema, json) {
        const sideEffects = {};
        if (json.table) sideEffects.table = (0, $9ba2978c7534d8fc$export$9d510b823609a5ac).fromJSON(schema, json.table);
        if (json.rows) sideEffects.rows = (0, $cc7957949c13c5ad$export$6a87112aa04a9486).fromJSON(schema, json.rows);
        return sideEffects;
    }
    constructor(sideEffects){
        this.table = void 0;
        this.rows = void 0;
        this.table = new (0, $9ba2978c7534d8fc$export$9d510b823609a5ac)(sideEffects && sideEffects.table);
        this.rows = new (0, $cc7957949c13c5ad$export$6a87112aa04a9486)(sideEffects && sideEffects.rows);
    }
}


const $37749854fe7ee835$var$ADD_COLUMN_STEP = 'ak-add-column';
function $37749854fe7ee835$var$printColumnInfo(columnInfo) {
    const cellsFrom = [];
    for (const cellInfo of columnInfo.values())cellsFrom.push(cellInfo.from);
    return `[${cellsFrom.join(',')}]`;
}
function $37749854fe7ee835$var$createColumnInfo(cellsInfo) {
    return new Map(cellsInfo.map((cellInfo)=>[
            cellInfo.from,
            cellInfo
        ]));
}
const $37749854fe7ee835$var$getTableRectAndColumnFactory = (doc, pos, columnInfo)=>{
    return (0, $2XqLN.default)(()=>{
        const rect = (0, $3dbecde1498474fb$export$7a7f743a3e044584)(doc, pos);
        const column = (0, $3db3f34a32e2ec72$export$718b3d71c384ca05)(columnInfo, rect);
        if (column === null) throw new Error('no column');
        return {
            rect: rect,
            column: column
        };
    });
};
class $37749854fe7ee835$export$7f589f68a74fcd15 extends (0, $cO9ey.Step) {
    /**
   * Detect the column based on all the cells step in column info.
   * Recreate columnInfo based on the current document. We might need to add new cells added by insert row or unmerge cells.
   * If isDelete
   *    Decrease colspan if one row has merged cell
   *    Remove all the cells using columnInfo.cellStep[].from
   * else
   *    Increase colspan if one row had merged cell
   *    Add all new cells at columnInfo.cellStep[].from,
   *      if there is columnInfo.cellStep[].newCell use it
   *      else create an empty cell
   *
   * @param doc Current document
   */ apply(doc) {
        const { tablePos: tablePos } = this;
        // Create transform base on the doc
        const tr = new (0, $aXG5V.Transform)(doc);
        if (this.sideEffectsHandler.table.handleAddTable(tr, this.isDelete)) return (0, $aXG5V.StepResult).ok(tr.doc);
        let tableRect;
        try {
            tableRect = (0, $3dbecde1498474fb$export$7a7f743a3e044584)(doc, tablePos);
        } catch (e) {
            return (0, $aXG5V.StepResult).fail(e.message);
        }
        const column = (0, $3db3f34a32e2ec72$export$718b3d71c384ca05)(this.columnInfo, tableRect);
        if (column === null) return (0, $aXG5V.StepResult).fail(`No column for this cells "${$37749854fe7ee835$var$printColumnInfo(this.columnInfo)}" in table at position "${tablePos}".`);
        if (this.sideEffectsHandler.table.handleRemoveTable(tr, this.tablePos, tableRect, column, this.isDelete)) return (0, $aXG5V.StepResult).ok(tr.doc);
        this.columnInfo = this.applyCellSteps(tr, tableRect, column, this.isDelete);
        // Return the document modified.
        return (0, $aXG5V.StepResult).ok(tr.doc);
    }
    /**
   * Update tablePos with the new position. If tablePos doesnt exist any more remove the step
   * Update all the cellStep inside columnInfo. If cellStep.from position gets deleted removed it from column info
   * if cellStep.length === 0 remove the step
   * Create a new step with all the position updated
   * @param mapping
   */ map(mapping) {
        const tablePosResult = mapping.mapResult(this.tablePos);
        if (tablePosResult.deleted) // If table was deleted remove the step
        return null;
        const cellSteps = [];
        for (const oldCellStep of this.columnInfo.values()){
            const fromResult = mapping.mapResult(oldCellStep.from);
            const toResult = mapping.mapResult(oldCellStep.to);
            if (fromResult.deleted && toResult.deleted) continue;
            const cellStep = {
                ...oldCellStep,
                from: fromResult.pos,
                to: toResult.pos
            };
            if (oldCellStep.mergeWith !== undefined) cellStep.mergeWith = mapping.map(oldCellStep.mergeWith);
            cellSteps.push(cellStep);
        }
        if (cellSteps.length === 0) return null;
        const sideEffects = this.sideEffectsHandler.map(mapping);
        return new $37749854fe7ee835$export$7f589f68a74fcd15(tablePosResult.pos, {
            cells: cellSteps,
            sideEffects: sideEffects
        }, this.isDelete);
    }
    /**
   * if isDelete
   *    Get the original cell node at columnInfo.cellStep[].from to columnInfo.cellStep[].to
   *    Create a copy of the node
   *    Create a new cellStep with the same positions but with the clone node as a content
   *    return new step inverted
   * else
   *    Remove the content from each columnInfo.cellStep[].content
   *    return new step inverted
   * @param originalDoc
   */ invert(originalDoc) {
        const stepMap = this.getMap();
        // Memoize function to be called only on delete scenarios
        const getTableRectAndColumn = $37749854fe7ee835$var$getTableRectAndColumnFactory(originalDoc, this.tablePos, this.columnInfo);
        // This is needed because the real pos of the cell in the generated document is affected by the previous operations.
        const newCellSteps = Array.from(this.columnInfo.values(), (oldCellStep)=>{
            const newCellStep = (0, $d82c222672448203$export$1238fc51d97634a)(originalDoc, getTableRectAndColumn, oldCellStep, this.isDelete, stepMap);
            return newCellStep;
        });
        const sideEffects = this.sideEffectsHandler.invert(originalDoc, this.isDelete, stepMap);
        return new $37749854fe7ee835$export$7f589f68a74fcd15(this.tablePos, {
            cells: newCellSteps,
            sideEffects: sideEffects
        }, !this.isDelete);
    }
    /**
   * StepMap is created based on columnInfo.
   * ColumnInfo is created on constructor and once is applied (the document could have new cells that weren't part of the original set)
   * if isDelete
   *    Create range array based on cell info where each range is [cellStep.from, cellStep.from - cellStep.to, 0]
   * else
   *    Create range array base on cell info where each range is [cellStep.from, 0, cellStep.content ? cellStep.content.nodeSize : defaultEmptyCellNodeSize]
   *
   * Ranges in ProseMirror are represented by each 3 elements in an array.
   * As [pos, currentSize, newSize, pos2, currentSize2, newSize2] where:
   * pos: Position in the document
   * currentSize: Represent the affected range, this will be pos + currentSize
   * newSize: Represent the new values, pos + newSize
   */ getMap() {
        const tableMap = this.sideEffectsHandler.getTableMap(this.isDelete);
        if (tableMap) return tableMap;
        let ranges = [];
        for (const cellStep of this.columnInfo.values())ranges.push(...(0, $d82c222672448203$export$13a5db78deedf2bc)(cellStep, this.isDelete));
        ranges = this.sideEffectsHandler.rows.addRowRanges(ranges, this.isDelete);
        // If no steps, I create am empty stepMap
        return new (0, $aXG5V.StepMap)(ranges);
    }
    /**
   * Try to merge this step with another one, to be applied directly
   * after it. Returns the merged step when possible, null if the
   * steps can't be merged.
   */ merge(_other) {
        // We cannot merge add column step at the moment
        return null;
    }
    /**
   * Create a JSON-serializeable representation of this step. When
   * defining this for a custom subclass, make sure the result object
   * includes the step type's [JSON id](#transform.Step^jsonID) under
   * the `stepType` property.
   */ toJSON() {
        const addColumnStepJson = {
            stepType: $37749854fe7ee835$var$ADD_COLUMN_STEP,
            tablePos: this.tablePos,
            cells: Array.from(this.columnInfo.values(), (cellStep)=>{
                const cellStepJson = {
                    from: cellStep.from,
                    to: cellStep.to
                };
                if (cellStep.mergeWith !== undefined) cellStepJson.mergeWith = cellStep.mergeWith;
                if (cellStep.newCell !== undefined) cellStepJson.newCell = cellStep.newCell.toJSON();
                return cellStepJson;
            }),
            isDelete: this.isDelete
        };
        const sideEffectsJSON = this.sideEffectsHandler.toJSON();
        if (sideEffectsJSON) addColumnStepJson.sideEffects = sideEffectsJSON;
        return addColumnStepJson;
    }
    /**
   * Deserialize a step from its JSON representation. Will call
   * through to the step class' own implementation of this method.
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static fromJSON(schema, json) {
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: Add validation. Return null if it is invalid. Check in review if this is necessary
        const cells = json.cells.map((cellsJson)=>{
            const cell = {
                ...cellsJson,
                newCell: cellsJson.newCell ? schema.nodeFromJSON(cellsJson.newCell) : undefined
            };
            return cell;
        });
        let sideEffects;
        if (json.sideEffects) sideEffects = (0, $faf5e1e5acefbc28$export$2e0f8a284a2635ac).fromJSON(schema, json.sideEffects);
        return new $37749854fe7ee835$export$7f589f68a74fcd15(json.tablePos, {
            cells: cells,
            sideEffects: sideEffects
        }, json.isDelete);
    }
    static create(doc, tablePos, column, isDelete = false) {
        const tableRect = (0, $3dbecde1498474fb$export$7a7f743a3e044584)(doc, tablePos);
        // By default add column will rely on default behaviour (add empty cell).
        // There is no need to add content
        const cells = [];
        const iter = (0, $195310467a879139$export$7ca27240fa9450d9)(tableRect, column);
        let next = iter.next();
        while(!next.done){
            const cell = next.value;
            cells.push((0, $d82c222672448203$export$e2625d4b6ce2d04b)(cell, column, isDelete));
            let skipRows = 0;
            if (cell.attrs && cell.attrs.rowspan) skipRows = cell.attrs.rowspan - 1;
            next = iter.next(skipRows);
        }
        return new $37749854fe7ee835$export$7f589f68a74fcd15(tablePos, {
            cells: cells
        }, isDelete);
    }
    applyCellSteps(tr, tableRect, column, isDelete) {
        const newColumnInfo = new Map();
        const rowsHandler = this.sideEffectsHandler.rows.start(this.isDelete);
        const iter = (0, $195310467a879139$export$7ca27240fa9450d9)(tableRect, column);
        let next = iter.next();
        // Iterate for all the cells in the current document
        while(!next.done){
            const cell = next.value;
            const previousCellStep = this.columnInfo.get(cell.from);
            const newCellStep = (0, $d82c222672448203$export$e2625d4b6ce2d04b)(cell, column, isDelete, previousCellStep);
            // If is the last cell in the row and doesnt have colspan I need to remove the whole row.
            const removeRowResult = rowsHandler.handle(tr, tableRect, cell.row, column, cell);
            if (removeRowResult.handled) {
                next = iter.next(removeRowResult.skipRows);
                continue;
            }
            // Apply the step, to the pseudo document, get rows to skip, and the cellstep (might be modified, for example, a merge cell that remove the cell instead)
            const { skipRows: skipRows, cellStep: cellStep } = (0, $d82c222672448203$export$1e67a55385d21834)(tr, tableRect, cell, newCellStep, isDelete, column);
            // Store the new cell step. This could be an existing one or a new cell.
            newColumnInfo.set(newCellStep.from, cellStep);
            next = iter.next(skipRows);
        }
        rowsHandler.end(tr, tableRect, column);
        return newColumnInfo;
    }
    constructor(tablePos, addColumnStepInfo, isDelete = false){
        super();
        this.tablePos = void 0;
        this.isDelete = void 0;
        this.columnInfo = void 0;
        this.sideEffectsHandler = void 0;
        this.tablePos = tablePos;
        this.isDelete = isDelete;
        this.sideEffectsHandler = new (0, $faf5e1e5acefbc28$export$2e0f8a284a2635ac)(addColumnStepInfo.sideEffects);
        this.columnInfo = $37749854fe7ee835$var$createColumnInfo(addColumnStepInfo.cells);
    }
}
(0, $cO9ey.Step).jsonID($37749854fe7ee835$var$ADD_COLUMN_STEP, $37749854fe7ee835$export$7f589f68a74fcd15);
module.exports["AddColumnStep"] = $37749854fe7ee835$export$7f589f68a74fcd15;

});

parcelRegister("9MzzS", function(module, exports) {

var $d1kIV = parcelRequire("d1kIV");

function $04a932cfc33b57bb$var$rowIsHeader(map, table, row) {
    const headerCell = (0, $d1kIV.tableNodeTypes)(table.type.schema).header_cell;
    for(let col = 0; col < map.width; col++){
        const cell = table.nodeAt(map.map[col + row * map.width]);
        if (cell && cell.type !== headerCell) return false;
    }
    return true;
}
function $04a932cfc33b57bb$export$40ed00dbc18f8b2f(tr, { map: map, tableStart: tableStart, table: table }, row) {
    let rowPos = tableStart;
    for(let i = 0; i < row; i++)rowPos += table.child(i).nodeSize;
    const cells = [];
    let refRow = row > 0 ? -1 : 0;
    if ($04a932cfc33b57bb$var$rowIsHeader(map, table, row + refRow)) refRow = row === 0 || row === map.height ? null : 0;
    for(let col = 0, index = map.width * row; col < map.width; col++, index++)// Covered by a rowspan cell
    if (row > 0 && row < map.height && map.map[index] === map.map[index - map.width]) {
        const pos = map.map[index];
        const node = table.nodeAt(pos);
        if (!node) throw new Error(`addRow: node not found at pos ${pos}`);
        const { attrs: attrs } = node;
        tr.setNodeMarkup(tableStart + pos, undefined, {
            ...attrs,
            rowspan: attrs.rowspan + 1
        });
        col += attrs.colspan - 1;
    } else {
        let type;
        let attrs = {};
        if (refRow == null) type = (0, $d1kIV.tableNodeTypes)(table.type.schema).cell;
        else {
            const mappedPos = map.map[index + refRow * map.width];
            const cell = table.nodeAt(mappedPos);
            if (!cell) throw new Error(`addRow: invalid node at mapped pos ${mappedPos}`);
            type = cell.type;
            if (cell.attrs.background) attrs = {
                background: cell.attrs.background
            };
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cells.push(type.createAndFill(attrs));
    }
    const rowType = (0, $d1kIV.tableNodeTypes)(table.type.schema).row;
    const rowCells = rowType.create(null, cells);
    tr.insert(rowPos, rowCells);
    return tr;
}
module.exports["addRow"] = $04a932cfc33b57bb$export$40ed00dbc18f8b2f;

});

parcelRegister("5rHEx", function(module, exports) {
var $f46f6146aadd3e55$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    return SortOrder;
}({});
module.exports["SortOrder"] = $f46f6146aadd3e55$export$7ae723045d45777a;

});

parcelRegister("8usfh", function(module, exports) {
const $476e04ad97820508$export$5add988076756575 = (tr)=>Object.assign(Object.create(tr), tr).setTime(Date.now());
module.exports["cloneTr"] = $476e04ad97820508$export$5add988076756575;

});

parcelRegister("9b9Mr", function(module, exports) {

var $jl382 = parcelRequire("jl382");


var $d1kIV = parcelRequire("d1kIV");

function $578be7a47ad1e1db$export$c71ebdbebc3fa79b(map, table, col) {
    const headerCell = (0, $d1kIV.tableNodeTypes)(table.type.schema).header_cell;
    for(let row = 0; row < map.height; row++){
        const cell = table.nodeAt(map.map[col + row * map.width]);
        if (cell && cell.type !== headerCell) return false;
    }
    return true;
}
function $578be7a47ad1e1db$export$9e26b0bcc810b84c(tr, { map: map, tableStart: tableStart, table: table }, col) {
    let refColumn = col > 0 ? -1 : 0;
    if ($578be7a47ad1e1db$export$c71ebdbebc3fa79b(map, table, col + refColumn)) refColumn = col === 0 || col === map.width ? null : 0;
    for(let row = 0; row < map.height; row++){
        const index = row * map.width + col;
        // If this position falls inside a col-spanning cell
        if (col > 0 && col < map.width && map.map[index - 1] === map.map[index]) {
            const pos = map.map[index];
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`addColumn: invalid cell for pos ${pos}`);
            const attributes = cell.attrs;
            (0, $jl382.assertColspan)(attributes);
            tr.setNodeMarkup(tr.mapping.map(tableStart + pos), undefined, (0, $jl382.addColSpan)(attributes, col - map.colCount(pos)));
            // Skip ahead if rowspan > 1
            row += attributes.rowspan - 1;
        } else {
            let type;
            let attrs = {};
            if (refColumn === null) type = (0, $d1kIV.tableNodeTypes)(table.type.schema).cell;
            else {
                const mappedPos = map.map[index + refColumn];
                const cell = table.nodeAt(mappedPos);
                if (!cell) throw new Error(`addColumn: invalid node at mapped pos ${mappedPos}`);
                type = cell.type;
                if (cell.attrs.background) attrs = {
                    background: cell.attrs.background
                };
            }
            const pos = map.positionAt(row, col, table);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tr.insert(tr.mapping.map(tableStart + pos), type.createAndFill(attrs));
        }
    }
    return tr;
}
module.exports["columnIsHeader"] = $578be7a47ad1e1db$export$c71ebdbebc3fa79b;
module.exports["addColumn"] = $578be7a47ad1e1db$export$9e26b0bcc810b84c;

});


$parcel$global.rlb("kBJEF")
//# sourceMappingURL=FullPageEditorComponent.91c9c9eb.js.map
